export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Base64 encoded data */
  Binary: { input: any; output: any };
  /**
   * A valid ISO 3166-1 alpha-2 country code
   * https://the-guild.dev/graphql/scalars/docs/scalars/country-code
   */
  CountryCode: { input: any; output: any };
  DateTime: { input: any; output: any };
  /** A string that is a valid hex color code, e.g. #0099CC, #09C, #0099cc */
  HexColorCode: { input: any; output: any };
  JSON: { input: any; output: any };
};

export type AcceptInviteInput = {
  inviteCode: Scalars['String']['input'];
};

export type AcceptUserInviteResult = {
  __typename?: 'AcceptUserInviteResult';
  household?: Maybe<Household>;
  householdRole?: Maybe<UserHouseholdRole>;
  /** The updated current user. */
  user: User;
};

/** Result of a user account deletion request. */
export type AccountDeletionRequestResult = {
  __typename?: 'AccountDeletionRequestResult';
  message: Scalars['String']['output'];
  requestId?: Maybe<Scalars['String']['output']>;
  scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AccountInvoiceSummary = {
  __typename?: 'AccountInvoiceSummary';
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  origin?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

/** Recurly account note created by CX agents or support staff */
export type AccountNote = {
  __typename?: 'AccountNote';
  /** When the note was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Recurly user who created the note */
  createdBy?: Maybe<AccountNoteUser>;
  /** Unique identifier for the note */
  id?: Maybe<Scalars['ID']['output']>;
  /** The note message content */
  message?: Maybe<Scalars['String']['output']>;
};

/** User information from Recurly who created the account note */
export type AccountNoteUser = {
  __typename?: 'AccountNoteUser';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type AcknowledgeSearchPartyResult = {
  __typename?: 'AcknowledgeSearchPartyResult';
  /** Error message if the operation failed, null otherwise. */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the acknowledgment was successful. */
  success: Scalars['Boolean']['output'];
};

/**
 * The live shop coupon that discounts hardware-first units, if one is running in the account's
 * country. Null when no promotion is active, the promotion has no coupon code, or the coupon
 * prices no hardware discount.
 */
export type ActiveHardwarePromo = {
  __typename?: 'ActiveHardwarePromo';
  couponCode: Scalars['String']['output'];
  /** When the promotion (plus any extension) stops running. Null when the promotion has no end. */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  hardwarePercentOff: Scalars['Int']['output'];
  promotionName: Scalars['String']['output'];
};

export type ActivitiesForRangeResult = {
  __typename?: 'ActivitiesForRangeResult';
  activities: Array<Activity>;
};

export type Activity = {
  address?: Maybe<Scalars['String']['output']>;
  areaName?: Maybe<Scalars['String']['output']>;
  cityState?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use likeCount */
  clapCount: Scalars['Int']['output'];
  dbId: Scalars['Int']['output'];
  debugMetadata: Scalars['JSON']['output'];
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use isLikable */
  isClappable: Scalars['Boolean']['output'];
  isLikable: Scalars['Boolean']['output'];
  likeCount: Scalars['Int']['output'];
  neighborhood?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  obfuscated: Scalars['Boolean']['output'];
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']['output']>;
  start: Scalars['DateTime']['output'];
  totalSteps: Scalars['Int']['output'];
};

export type ActivityFeed = {
  __typename?: 'ActivityFeed';
  activities: Array<Activity>;
  pageInfo: PageInfo;
};

export type ActivityGoal = {
  __typename?: 'ActivityGoal';
  targetScore: Scalars['Int']['output'];
};

export type ActivityIntensity = {
  __typename?: 'ActivityIntensity';
  date: Scalars['DateTime']['output'];
  intensity: Scalars['Int']['output'];
  type: ActivityType;
};

/**
 * A single activity report from a device
 * !! IMPORTANT: This should never be exposed to or used by non-admin clients,
 * since it has a monotonically increasing ID (not a UUID).
 */
export type ActivityReport = {
  __typename?: 'ActivityReport';
  attributes?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  duration: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  ignoreReason?: Maybe<Scalars['String']['output']>;
  steps: Scalars['Int']['output'];
};

export type ActivityReportInput = {
  date: Scalars['DateTime']['input'];
  duration: Scalars['Float']['input'];
  params?: InputMaybe<Scalars['JSON']['input']>;
  steps: Scalars['Int']['input'];
};

/** Period of time over which Rest, Activity, and Strain feeds return data. */
export enum ActivityRestStrainPeriod {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR',
}

/** Indicates if data is available for given period, or reason why not. */
export enum ActivityRestStrainPeriodDataAvailability {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE_DATE_IS_IN_FUTURE = 'UNAVAILABLE_DATE_IS_IN_FUTURE',
  UNAVAILABLE_NO_DATA = 'UNAVAILABLE_NO_DATA',
}

export type ActivitySummary = {
  __typename?: 'ActivitySummary';
  dailySteps: Array<DailyStepSummary>;
  end: Scalars['DateTime']['output'];
  hourlySteps: Array<TimeBoundStepCount>;
  period: ActivitySummaryPeriod;
  start: Scalars['DateTime']['output'];
  stepGoal: Scalars['Int']['output'];
  totalActiveTimeSeconds: Scalars['Float']['output'];
  totalDistance: Scalars['Float']['output'];
  totalSteps: Scalars['Int']['output'];
};

export type ActivitySummaryFeed = {
  __typename?: 'ActivitySummaryFeed';
  activitySummaries: Array<ActivitySummary>;
  hasNext: Scalars['Boolean']['output'];
  nextCursor: Scalars['String']['output'];
};

export enum ActivitySummaryPeriod {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
}

export enum ActivityType {
  MISSING_REPORTS = 'MISSING_REPORTS',
  PLAY = 'PLAY',
  REST = 'REST',
  TRAVEL = 'TRAVEL',
  WALK = 'WALK',
}

export type AddCouponToAccountInput = {
  /** The account code (user external ID) */
  accountCode: Scalars['ID']['input'];
  /** The coupon code to add */
  couponCode: Scalars['String']['input'];
  /**
   * Optional subscription ID (uuid) to apply the coupon to a specific subscription.
   * If not provided, the coupon is applied at the account level.
   */
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type AddMultipleSupplementSubscriptionsInput = {
  forceApplyDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  skusToAdd: Array<Scalars['String']['input']>;
};

export type AddMultipleSupplementSubscriptionsResult = {
  __typename?: 'AddMultipleSupplementSubscriptionsResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddOrderLineItemsInput = {
  cart: AdminCartInput;
  id: Scalars['ID']['input'];
};

export type AddPetDocumentInput = {
  fileName: Scalars['String']['input'];
  fileSizeBytes: Scalars['Int']['input'];
  fileType: Scalars['String']['input'];
  householdId: Scalars['ID']['input'];
  recordKey: Scalars['String']['input'];
};

export type AddPetPhotoInput = {
  petId: Scalars['ID']['input'];
  photoId: Scalars['ID']['input'];
  updates?: InputMaybe<PhotoUpdatesInput>;
};

export type AddPhotoCommentResult = {
  __typename?: 'AddPhotoCommentResult';
  photo: Photo;
};

export type AddResellerModulesInput = {
  moduleIds: Array<Scalars['String']['input']>;
  orderSource: OrderSource;
  renewalMonths: Scalars['Int']['input'];
  shipDate: Scalars['DateTime']['input'];
  shipmentId?: InputMaybe<Scalars['String']['input']>;
};

export type AddSupplementSubscriptionInput = {
  skuToAdd: Scalars['String']['input'];
};

export type AddSupplementSubscriptionResult = {
  __typename?: 'AddSupplementSubscriptionResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddTextPostCommentResult = {
  __typename?: 'AddTextPostCommentResult';
  post: TextPost;
};

export type AddThirdPartySubscriptionInput = {
  thirdParty: ThirdPartyId;
};

export type AddThirdPartySubscriptionResult = {
  __typename?: 'AddThirdPartySubscriptionResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddUserEmailInput = {
  email: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type AddUserToHouseholdInput = {
  householdId: Scalars['ID']['input'];
  role: UserHouseholdRole;
  userId: Scalars['ID']['input'];
};

export type AddUserToHouseholdResult = {
  __typename?: 'AddUserToHouseholdResult';
  household: Household;
};

export type AddVideoPostCommentResult = {
  __typename?: 'AddVideoPostCommentResult';
  post: VideoPost;
};

export type AddWifiCredentialInput = {
  credentials: WifiCredentialInput;
  householdId: Scalars['ID']['input'];
  position: PositionInput;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type Admin = {
  __typename?: 'Admin';
  /** Fetch comments made by a specific pet across posts. For admin moderation. */
  adminCommentsByPet: AdminCommentsByPetResult;
  /** Postcard orders for one GWA program, most recent first. Admin-only. */
  adminGwaPostcardOrders: Array<RescueGwaPostcardOrder>;
  /**
   * This is the same as the normal packMemberFeed but it doesn't filter pets
   * socially or require an acting pet.
   */
  adminPackMemberFeed: PackMemberFeed;
  allChargingBases: Array<ChargingBase>;
  allDeviceTags: Array<DeviceTag>;
  /** Get all devices */
  allDevices: Array<Device>;
  allFeatureFlags: Array<FeatureFlag>;
  allPromotions: Array<Promotion>;
  allRescueGwaPrograms: Array<RescueGwaProgram>;
  allUserGroups: Array<UserGroup>;
  baseEventHistory: Array<AuditLogEvent>;
  batteryHistory: Array<BatteryHistoryAggregationBucket>;
  batteryHistoryConnectionStateChanges: ConnectionStateChangesResult;
  batteryHistoryDeviceActivity: Array<DeviceActivity>;
  batteryHistoryDeviceErrors: Array<DeviceError>;
  batteryHistoryOverviewDeviceEvents: Array<BatteryHistoryOverviewDeviceEvent>;
  batteryHistoryStatDeltaEvents: Array<StatDeltaDeviceEvent>;
  chargingBaseBatches: Array<DeviceBatchInfo>;
  chipEventHistory: Array<AuditLogEvent>;
  chipResellerEventHistory: Array<AuditLogEvent>;
  commentEventHistory: Array<AuditLogEvent>;
  communityFeedModifiers: CommunityFeedModifiers;
  communityFeedPostBoosts: Array<CommunityFeedPostBoost>;
  communityFeedScorePreview: CommunityFeedScorePreview;
  communityFeedTrendingMeta: CommunityFeedTrendingMeta;
  consignmentAccountEventHistory: Array<AuditLogEvent>;
  couponById?: Maybe<Coupon>;
  couponRedirect: Scalars['String']['output'];
  coupons: Array<Coupon>;
  /**
   * Query CX billing audit events for a specific entity.
   * Must provide at least one of: accountCode, invoiceNumber, or subscriptionId.
   */
  cxBillingAuditEvents: CxBillingAuditResult;
  /** Get a specific deletion request by UUID. */
  deletionRequest?: Maybe<AdminUserDeletionRequest>;
  /** List deletion requests with optional filtering. */
  deletionRequests: Array<AdminUserDeletionRequest>;
  deviceModelPlatformMappings: Array<DeviceModelPlatformMapping>;
  deviceStats: Array<DeviceStat>;
  /** Get multiple devices by module IDs */
  devices: Array<Device>;
  esIndices?: Maybe<Scalars['JSON']['output']>;
  feedDecayCurveConfig: FeedDecayCurveConfig;
  findUsersInGroup: Array<AdminBaseUserProfile>;
  firmwareStatistics: FirmwareStatistics;
  /** All the currently defined firmware tags. */
  firmwareTags: Array<FirmwareTag>;
  firmwareVersions: Array<FirmwareVersion>;
  /** Get GDPR dashboard statistics for admin overview. */
  gdprDashboardStats: GdprDashboardStats;
  /** Returns a signed URL that can be used to force a user into a GrowthBook experiment variant */
  growthBookExperimentForcedVariantUrl: Scalars['String']['output'];
  gwaRedemptionSourceCounts: Array<GwaRedemptionSourceCount>;
  gwpPartnerPrograms: Array<GwpPartnerProgram>;
  householdEventHistory: Array<AuditLogEvent>;
  inPersonEvent: InPersonEvent;
  inPersonEvents: Array<InPersonEvent>;
  moduleBatches: Array<DeviceBatchInfo>;
  moduleEventHistory: Array<AuditLogEvent>;
  /** Get all AuditLogEvent by object type */
  petEventHistory: Array<AuditLogEvent>;
  petSnoozeEventHistory: Array<AuditLogEvent>;
  placeEventHistory: Array<AuditLogEvent>;
  platforms: Array<Platform>;
  previewCreateCoupon: Array<Scalars['JSON']['output']>;
  productInventoryLevels: ProductInventoryLevels;
  promotion: Promotion;
  /**
   * Fetch recent HealthGPT messages across all users for admin review.
   * Defaults to last 24 hours if no date range specified.
   */
  recentHealthGptMessages: AdminHealthGptMessagesConnection;
  recentlyPurchasedItems: RecentlyPurchasedItemsResponse;
  referralRewardHistory: Array<AuditLogEvent>;
  /**
   * Fetch a single rescue document by ID. The returned `downloadUrl` is a fresh,
   * short-TTL signed URL — refetch this when a stored URL may have expired.
   */
  rescueDocument: RescueDocument;
  /**
   * The admin review queue: every uploaded rescue document, newest upload first,
   * with the rescue that submitted it attached. `status` narrows to one review
   * state (null = every state, including SUPERSEDED); `search` matches the rescue
   * household name, the submitting user's email/name, or the uploaded file name.
   * Defaults to `tenancy: 'prod'` to match the rest of admin rescue search, so a
   * test-tenancy rescue's documents never appear in the real review queue; pass
   * `'test'` to review those instead.
   */
  rescueDocuments: AdminRescueDocumentsResult;
  /**
   * Approved exemption documents that have expired or will within `withinDays`, soonest first.
   *
   * Exists because expiry is derived rather than stored: nothing surfaces on its own — no status
   * changes and no job runs — so an expired certificate is indistinguishable from a valid one in the
   * review queue until somebody asks this question. Capped at 200.
   */
  rescueExpiringExemptionDocuments: Array<AdminRescueExpiringDocument>;
  /**
   * Admin GWA enrollments with server-side pagination and filtering. `search` matches the rescue
   * slug, promo code, or owner (email / name); `active` filters by enrollment status (null = all);
   * `enrollmentType` filters by how the rescue was enrolled, e.g. `self_service`,
   * `shelterluv_auto_enroll`, or `fi_nano_auto_enroll` (null = all). Legacy enrollments have a null type and aren't matched by a value filter.
   */
  rescueGwaPrograms: AdminRescueGwaProgramsResult;
  /**
   * Find users matching the given email who are a rescue organization user, a
   * rescue-typed chip reseller, or both. Non-rescue chip resellers (other types)
   * are intentionally excluded — this search is scoped to the rescue admin tooling.
   * Email matches partially (ILIKE) against the user's primary email only. Empty
   * input returns an empty list. Defaults to `tenancy: 'prod'` to match the rest
   * of admin search; pass `'test'` to inspect test-tenancy users.
   */
  rescueOrResellerSearch: Array<RescueResellerSearchResult>;
  /**
   * Every jurisdiction's sales-tax exemption rule, for the Finance-facing editor. Ordered by
   * jurisdiction. Admin only — these rows carry the internal reason a jurisdiction grants no exemption,
   * which is never shown to a rescue.
   */
  rescueStateExemptionRules: Array<RescueStateExemptionRule>;
  /** List users whose data processing is currently restricted (GDPR Art. 18). */
  restrictedUsers: Array<User>;
  /** Assignments for one email, or every assignment when email is omitted. */
  roleAssignments: Array<AdminRoleAssignment>;
  roles: Array<AdminRoleDefinition>;
  searchChipResellers: Array<ChipReseller>;
  searchChips: Array<ResellerChip>;
  searchDevices: Array<Device>;
  searchPets: Array<Pet>;
  searchUsers: Array<AdminBaseUserProfile>;
  signUrl: Scalars['String']['output'];
  statistics: Statistics;
  subscriptionEventHistory: Array<AuditLogEvent>;
  /** This endpoint is a noop. It is used to test GraphQL DateTime validation. */
  testDateTimeParsing?: Maybe<Scalars['DateTime']['output']>;
  /** Get consent history for a specific user. */
  userConsentHistory: Array<ConsentRecord>;
  /** Get current consent statuses for a specific user. */
  userConsentStatuses: Array<ConsentStatus>;
  userEventHistory: Array<AuditLogEvent>;
};

export type AdminadminCommentsByPetArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  petId: Scalars['ID']['input'];
};

export type AdminadminGwaPostcardOrdersArgs = {
  programId: Scalars['ID']['input'];
};

export type AdminadminPackMemberFeedArgs = {
  adjacentPetId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  packAgeFilter?: InputMaybe<PackAgeFilter>;
  packId: Scalars['ID']['input'];
  pagingInstruction?: InputMaybe<PagingInstruction>;
  validityToken?: InputMaybe<Scalars['String']['input']>;
};

export type AdminallChargingBasesArgs = {
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<AdminAllChargingBasesInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  updateChannel?: InputMaybe<Scalars['String']['input']>;
};

export type AdminallDevicesArgs = {
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminallUserGroupsArgs = {
  excludePseudo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminbaseEventHistoryArgs = {
  baseId: Scalars['ID']['input'];
};

export type AdminbatteryHistoryArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  interval: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
};

export type AdminbatteryHistoryConnectionStateChangesArgs = {
  dateRange: DateRangeInput;
  moduleId: Scalars['String']['input'];
};

export type AdminbatteryHistoryDeviceActivityArgs = {
  dateRange: DateRangeInput;
  moduleId: Scalars['String']['input'];
};

export type AdminbatteryHistoryDeviceErrorsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  moduleId: Scalars['String']['input'];
};

export type AdminbatteryHistoryOverviewDeviceEventsArgs = {
  moduleId: Scalars['String']['input'];
};

export type AdminbatteryHistoryStatDeltaEventsArgs = {
  dateRange: DateRangeInput;
  moduleId: Scalars['String']['input'];
  statNames: Array<Scalars['String']['input']>;
};

export type AdminchipEventHistoryArgs = {
  chipId: Scalars['ID']['input'];
};

export type AdminchipResellerEventHistoryArgs = {
  chipResellerId: Scalars['ID']['input'];
};

export type AdmincommentEventHistoryArgs = {
  commentId: Scalars['ID']['input'];
};

export type AdmincommunityFeedScorePreviewArgs = {
  input: CommunityFeedScorePreviewInput;
};

export type AdminconsignmentAccountEventHistoryArgs = {
  consignmentAccountId: Scalars['ID']['input'];
};

export type AdmincouponByIdArgs = {
  id: Scalars['Int']['input'];
};

export type AdmincouponRedirectArgs = {
  input: CouponRedirectInput;
};

export type AdmincxBillingAuditEventsArgs = {
  input: CxBillingAuditInput;
};

export type AdmindeletionRequestArgs = {
  uuid: Scalars['String']['input'];
};

export type AdmindeletionRequestsArgs = {
  input?: InputMaybe<DeletionRequestFilterInput>;
};

export type AdmindevicesArgs = {
  moduleIds: Array<Scalars['String']['input']>;
};

export type AdminfeedDecayCurveConfigArgs = {
  feedType: FeedDecayCurveType;
};

export type AdminfindUsersInGroupArgs = {
  groupName: Scalars['String']['input'];
};

export type AdminfirmwareStatisticsArgs = {
  platformId: Scalars['String']['input'];
};

export type AdmingrowthBookExperimentForcedVariantUrlArgs = {
  experimentId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
};

export type AdminhouseholdEventHistoryArgs = {
  householdId: Scalars['ID']['input'];
};

export type AdmininPersonEventArgs = {
  id: Scalars['ID']['input'];
};

export type AdmininPersonEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<InPersonEventQuery>;
};

export type AdminmoduleEventHistoryArgs = {
  moduleId: Scalars['String']['input'];
};

export type AdminpetEventHistoryArgs = {
  petId: Scalars['ID']['input'];
};

export type AdminpetSnoozeEventHistoryArgs = {
  petId: Scalars['ID']['input'];
};

export type AdminplaceEventHistoryArgs = {
  userId: Scalars['ID']['input'];
};

export type AdminplatformsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminpreviewCreateCouponArgs = {
  input: CreateCouponInput;
};

export type AdminpromotionArgs = {
  id: Scalars['Int']['input'];
};

export type AdminrecentHealthGptMessagesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminrecentlyPurchasedItemsArgs = {
  householdId: Scalars['ID']['input'];
};

export type AdminreferralRewardHistoryArgs = {
  userId: Scalars['ID']['input'];
};

export type AdminrescueDocumentArgs = {
  id: Scalars['ID']['input'];
};

export type AdminrescueDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RescueDocumentStatus>;
  tenancy?: InputMaybe<Scalars['String']['input']>;
};

export type AdminrescueExpiringExemptionDocumentsArgs = {
  tenancy?: InputMaybe<Scalars['String']['input']>;
  withinDays?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminrescueGwaProgramsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  enrollmentType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AdminrescueOrResellerSearchArgs = {
  email: Scalars['String']['input'];
  tenancy?: InputMaybe<Scalars['String']['input']>;
};

export type AdminroleAssignmentsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type AdminsearchChipResellersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<ChipResellerQueryInput>;
};

export type AdminsearchChipsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<ChipQueryInput>;
};

export type AdminsearchDevicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<DeviceQueryInput>;
};

export type AdminsearchPetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  tenancies?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdminsearchUsersArgs = {
  filter?: InputMaybe<AdminSearchUsersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  tenancies?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdminsignUrlArgs = {
  url: Scalars['String']['input'];
};

export type AdminsubscriptionEventHistoryArgs = {
  subscriptionId: Scalars['String']['input'];
};

export type AdmintestDateTimeParsingArgs = {
  dt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminuserConsentHistoryArgs = {
  userId: Scalars['ID']['input'];
};

export type AdminuserConsentStatusesArgs = {
  userId: Scalars['ID']['input'];
};

export type AdminuserEventHistoryArgs = {
  userId: Scalars['ID']['input'];
};

export type AdminAddDogParkFromOSMInput = {
  isDiscoverableOverride?: InputMaybe<Scalars['Boolean']['input']>;
  osmWayId: Scalars['String']['input'];
  preventUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminAddNanoIcarIdRangeInput = {
  endIcarId: Scalars['String']['input'];
  startIcarId: Scalars['String']['input'];
};

export type AdminAllChargingBasesInput = {
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated No longer supported */
  modulusRange?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlineSince?: InputMaybe<Scalars['DateTime']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  updateChannel?: InputMaybe<Scalars['String']['input']>;
};

export type AdminBaseUserProfile = {
  billingAccount?: Maybe<BillingAccount>;
  chipReseller?: Maybe<ChipReseller>;
  dbId: Scalars['Int']['output'];
  deactivated: Scalars['Boolean']['output'];
  ecommerceOrders: Array<Order>;
  email: Scalars['String']['output'];
  emails: Array<UserEmail>;
  firstName: Scalars['String']['output'];
  groups: Array<UserGroup>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  /** Admin tags on devices in households this user owns, deduplicated. */
  ownedDeviceTags: Array<DeviceTag>;
  /**
   * Paginated view over every pet in this user's households, ordered collar-first.
   * Mirrors User.petsFeed.
   */
  petsFeed: PetFeed;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  referrals: Referrals;
  region?: Maybe<FiCountry>;
  rmas: Array<RMA>;
  /** Returns all feature flag values by default, but can optionally provide an array of feature flag names to return */
  targetedFeatureFlags: Array<TargetedFeatureFlag>;
  tenancy?: Maybe<Scalars['String']['output']>;
  thirdPartyAccess?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
  userHouseholds: Array<UserHousehold>;
};

export type AdminBaseUserProfilegroupsArgs = {
  excludePseudo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminBaseUserProfilepetsFeedArgs = {
  filters?: InputMaybe<Array<PetFilter>>;
  householdType?: InputMaybe<HouseholdType>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type AdminBaseUserProfiletargetedFeatureFlagsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdminBulkAssignUsersToGroupInput = {
  groupName: Scalars['String']['input'];
  uploadedFileKey: Scalars['String']['input'];
};

export type AdminBulkRequestGwaPostcardMailingsInput = {
  orders: Array<AdminRequestGwaPostcardMailingInput>;
};

export type AdminCartInput = {
  cartItems: Array<AdminCartItemInput>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
};

export type AdminCartItemInput = {
  cartItemId: Scalars['String']['input'];
  lineItem: CartLineItemInput;
  quantity: Scalars['Int']['input'];
  subscriptionLineItem?: InputMaybe<CartLineItemInput>;
};

export type AdminClaimNanoWebIdsInput = {
  /**
   * When true, claim ICAR IDs only — skip claiming web IDs. Defaults to false (combined claim).
   * @deprecated Use adminStartNanoIcarIdOnlyClaim for ICAR-only batches.
   */
  icarOnly?: InputMaybe<Scalars['Boolean']['input']>;
  number: Scalars['Int']['input'];
};

export type AdminCommentsByPetResult = {
  __typename?: 'AdminCommentsByPetResult';
  comments: Array<Comment>;
  hasMore: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type AdminCreateBreedInput = {
  localizedNames?: InputMaybe<Array<BreedTranslationInput>>;
  name: Scalars['String']['input'];
  species: Species;
};

export type AdminCreateConsignmentOrderInput = {
  cart: AdminCartInput;
  /** The order channel. Defaults to CONSIGNMENT_RETAIL if not provided. */
  channel?: InputMaybe<OrderChannel>;
  consignmentLocationId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type AdminCreateDogParkCheckinExclusionInput = {
  dogParkEncodedUuid: Scalars['ID']['input'];
  /** Prefer to use petId instead of petDbId */
  petDbId: Scalars['Int']['input'];
  petId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminCreateEmployeeGiftOrderInput = {
  /** Required for SERIES_3_PLUS_KIT; ignored for MINI_KIT (single finished kit, no variants). */
  color?: InputMaybe<EmployeeGiftColor>;
  product: EmployeeGiftProduct;
  /** Recipient email — the recipient's free-year activation coupon is emailed here when the order ships. */
  recipientEmail: Scalars['String']['input'];
  recipientName: Scalars['String']['input'];
  shippingAddress: AddressInput;
  /** Required for SERIES_3_PLUS_KIT; ignored for MINI_KIT. */
  size?: InputMaybe<SizeOption>;
};

export type AdminCreateEmployeeGiftSubscriptionCouponInput = {
  /** Recipient email — the single-use activation coupon is emailed here on submission. */
  recipientEmail: Scalars['String']['input'];
};

export type AdminCreateEmployeeGiftSubscriptionCouponResult = {
  __typename?: 'AdminCreateEmployeeGiftSubscriptionCouponResult';
  couponCode: Scalars['String']['output'];
};

export type AdminCreateEvalGuidelineInput = {
  appliesWhen?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  exampleBadResponse?: InputMaybe<Scalars['String']['input']>;
  exampleGoodResponse?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  scope: EvalGuidelineScope;
  severity: EvalGuidelineSeverity;
  title: Scalars['String']['input'];
};

export type AdminCreateGoldenQuestionInput = {
  classification: EvalClassification;
  mockBreedSummaryData?: InputMaybe<Scalars['JSON']['input']>;
  mockCurrentDate?: InputMaybe<Scalars['DateTime']['input']>;
  mockGraphqlData?: InputMaybe<Scalars['JSON']['input']>;
  mockKnowledgeBaseDocs?: InputMaybe<Scalars['JSON']['input']>;
  mockPetDetails?: InputMaybe<Scalars['JSON']['input']>;
  mockPetDocuments?: InputMaybe<Scalars['JSON']['input']>;
  questionText: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AdminCreateHealthGptPlaybookInput = {
  appliesWhen: Scalars['String']['input'];
  audience?: InputMaybe<HealthGptPlaybookAudienceInput>;
  confidenceThreshold?: InputMaybe<Scalars['Float']['input']>;
  evalCategories?: InputMaybe<Array<EvalClassification>>;
  key: Scalars['String']['input'];
  promptSection?: InputMaybe<Scalars['String']['input']>;
  responseMode: HealthGptPlaybookResponseMode;
  retrievalConfig: HealthGptPlaybookRetrievalConfigInput;
  terminalResponseTemplate?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type AdminCreateInternalOrderInput = {
  cart: AdminCartInput;
  channel: OrderChannel;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** Optional notes about the order. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Partner name for the order. */
  partnerName: Scalars['String']['input'];
  shippingAddress: AddressInput;
  shippingOption: ShippingOption;
  /** Number of subscription override months to apply to modules after shipment. */
  subscriptionOverrideMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminCreateMediaAssetUploadUrlInput = {
  /**
   * Must be true to get an upload URL for a path that already has an object; otherwise the mutation
   * fails with a conflict so callers can't overwrite by accident.
   */
  allowOverwrite?: InputMaybe<Scalars['Boolean']['input']>;
  contentType: Scalars['String']['input'];
  /**
   * Destination object path, e.g. "app-assets/dogpark/empty.jpg". Must include a folder and a file
   * extension. The "resized/" prefix is reserved for the image resizer.
   */
  path: Scalars['String']['input'];
};

export type AdminCreateOrderInput = {
  billingAddress?: InputMaybe<AddressInput>;
  billingFirstName: Scalars['String']['input'];
  billingLastName: Scalars['String']['input'];
  billingToken: Scalars['String']['input'];
  cart: AdminCartInput;
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  shippingAddress: AddressInput;
  shippingOption?: InputMaybe<ShippingOption>;
};

export type AdminCreatePurchaseInput = {
  lineItems: Array<AdminLineItemInput>;
  userId: Scalars['ID']['input'];
};

export type AdminCreateTargetedFeatureFlagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  forcedValue?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  percentOfUsers?: InputMaybe<Scalars['Float']['input']>;
  targetingRules?: InputMaybe<Scalars['JSON']['input']>;
  userOverrides?: InputMaybe<Array<AdminTargetedFeatureFlagUserOverrideInput>>;
};

export type AdminCreateVipUserLookupCriteriaInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<AdminCreateVipUserLookupCriteriaNameInput>;
};

export type AdminCreateVipUserLookupCriteriaNameInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

/** Result of an admin GDPR deletion request operation (retry, cancel, or force process). */
export type AdminDeletionRequestResult = {
  __typename?: 'AdminDeletionRequestResult';
  message: Scalars['String']['output'];
  request?: Maybe<AdminUserDeletionRequest>;
  success: Scalars['Boolean']['output'];
};

export type AdminDeviceActuationsInput = {
  dateRange: DateRangeInput;
  moduleId: Scalars['String']['input'];
};

export type AdminDeviceActuationsResult = {
  __typename?: 'AdminDeviceActuationsResult';
  actuations: Array<DeviceActuation>;
  totalCount: Scalars['Int']['output'];
};

export type AdminDeviceHealthStatisticsInput = {
  customRange?: InputMaybe<DateRangeInput>;
  moduleId: Scalars['String']['input'];
};

export type AdminDeviceHealthStatisticsResult = {
  __typename?: 'AdminDeviceHealthStatisticsResult';
  statistics: DeviceHealthStatistics;
};

export type AdminDogParkCheckinExclusion = {
  __typename?: 'AdminDogParkCheckinExclusion';
  createdAt: Scalars['DateTime']['output'];
  dogPark: DogPark;
  id: Scalars['ID']['output'];
  pet: StrangerPet;
};

/** An ecommerce image list for PDP carousels, managed via admin. */
export type AdminEcommerceImageList = {
  __typename?: 'AdminEcommerceImageList';
  contentTargeting: AdminMobileAppContentTargeting;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  images: Array<EcommerceImage>;
  internalName: Scalars['String']['output'];
  /**
   * The product ID this image list applies to.
   * Valid values: 'smart-collar-mini', 'smart-collar-v3b', 'smart-collar-ultra'
   */
  productId: Scalars['String']['output'];
};

export type AdminExtendEmployeeGiftSubscriptionInput = {
  subscriptionId: Scalars['String']['input'];
};

export type AdminExtendEmployeeGiftSubscriptionResult = {
  __typename?: 'AdminExtendEmployeeGiftSubscriptionResult';
  newTermEndsAt?: Maybe<Scalars['DateTime']['output']>;
  petName: Scalars['String']['output'];
  previousTermEndsAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Every owner of the pet, who the confirmation email is queued to. A queue failure is logged
   * rather than surfaced, so this is who we meant to notify, not proof that we did.
   */
  recipientEmails: Array<Scalars['String']['output']>;
  subscriptionId: Scalars['String']['output'];
};

export type AdminFinalizeMediaAssetUploadResult = {
  __typename?: 'AdminFinalizeMediaAssetUploadResult';
  asset: AdminMediaAsset;
  /**
   * CloudFront invalidation ID for the uploaded path. Null outside production, where no CDN fronts
   * the bucket.
   */
  invalidationId?: Maybe<Scalars['String']['output']>;
};

export type AdminFireMobileAppContentTriggersInput = {
  /** Id of the MobileAppContent to fire, as returned by `getAllMobileAppContent`. */
  contentId: Scalars['ID']['input'];
  /** Days until the created triggers expire. Omit for triggers that never expire. */
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  triggers: Array<AdminMobileAppContentTriggerInput>;
};

export type AdminFiredMobileAppContentTrigger = {
  __typename?: 'AdminFiredMobileAppContentTrigger';
  triggerId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type AdminGPSTestConclusiveResult = {
  __typename?: 'AdminGPSTestConclusiveResult';
  result: GPSTestResult;
};

/** Indicates there was an internal error determining the result of the test */
export type AdminGPSTestErrorResult = {
  __typename?: 'AdminGPSTestErrorResult';
  errorDescription: Scalars['String']['output'];
};

export type AdminGPSTestResult = AdminGPSTestConclusiveResult | AdminGPSTestErrorResult | AdminGPSTestTimeoutResult;

export type AdminGPSTestTimeoutResult = {
  __typename?: 'AdminGPSTestTimeoutResult';
  timedOut?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminHealthGptAddMessageInput = {
  llmOverride?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  petId: Scalars['ID']['input'];
  promptTemplatesOverride?: InputMaybe<AdminHealthGptPromptTemplatesInput>;
  /**
   * Controls randomness of a model's output.
   * - 0.0: Fully deterministic — the model always chooses the highest-probability next token. (Same input → same output every time.)
   * - 0.7: Default for many OpenAI endpoints — balances randomness and coherence.
   * - 1.0: Higher randomness and creativity, more diverse outputs.
   * - >1.0 up to 2.0: Very exploratory — often leads to incoherent or nonsensical responses, but can be useful in rare creative tasks.
   */
  temperatureOverride?: InputMaybe<Scalars['Float']['input']>;
};

export type AdminHealthGptConfig = {
  __typename?: 'AdminHealthGptConfig';
  availableLlms: Array<Scalars['String']['output']>;
  currentLlm: Scalars['String']['output'];
  /**
   * Controls randomness of a model's output.
   * - 0.0: Fully deterministic — the model always chooses the highest-probability next token. (Same input → same output every time.)
   * - 0.7: Default for many OpenAI endpoints — balances randomness and coherence.
   * - 1.0: Higher randomness and creativity, more diverse outputs.
   * - >1.0 up to 2.0: Very exploratory — often leads to incoherent or nonsensical responses, but can be useful in rare creative tasks.
   */
  currentTemperature?: Maybe<Scalars['Float']['output']>;
  promptTemplates: AdminHealthGptPromptTemplates;
};

export type AdminHealthGptCreateDocumentInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  uploadedFileKey: Scalars['String']['input'];
};

export type AdminHealthGptDocument = {
  __typename?: 'AdminHealthGptDocument';
  createdAt: Scalars['DateTime']['output'];
  fetchFileUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: HealthGptDocumentStatus;
  updateFileUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * A single durable fact remembered across a member's Fi Intelligence chats about a pet, exposed for
 * admin/CX inspection only (memory is not member-facing). See plans/FI_INTELLIGENCE_MEMORY.md.
 */
export type AdminHealthGptMemory = {
  __typename?: 'AdminHealthGptMemory';
  category: HealthGptMemoryCategory;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  extractionModel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 1 (trivial) to 5 (critical). */
  importance: Scalars['Int']['output'];
  petId: Scalars['ID']['output'];
  /** The chat message this fact was extracted from. */
  sourceMessageId?: Maybe<Scalars['ID']['output']>;
  sourcePetDocumentId?: Maybe<Scalars['ID']['output']>;
  status: HealthGptMemoryStatus;
  /** The ACTIVE row that replaced this one; set when status is SUPERSEDED. */
  supersededById?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
};

export type AdminHealthGptMessage = {
  __typename?: 'AdminHealthGptMessage';
  breedSummaryData?: Maybe<Scalars['JSON']['output']>;
  /** Portion of inputTokens served from the model's prompt cache (a subset of inputTokens). */
  cachedInputTokens?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  documents?: Maybe<Scalars['JSON']['output']>;
  estimatedCostCents?: Maybe<Scalars['Float']['output']>;
  evaluation?: Maybe<EvalResult>;
  expandedMessage?: Maybe<Scalars['String']['output']>;
  graphqlData?: Maybe<Scalars['JSON']['output']>;
  graphqlQuery?: Maybe<Scalars['String']['output']>;
  graphqlQueryError?: Maybe<AdminHealthGptQueryError>;
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  petDetails?: Maybe<Scalars['JSON']['output']>;
  petDocuments?: Maybe<Scalars['JSON']['output']>;
  playbookRoute?: Maybe<AdminHealthGptPlaybookRoute>;
  prompt?: Maybe<Scalars['String']['output']>;
  queryExpansionReason?: Maybe<Scalars['String']['output']>;
  queryWasExpanded?: Maybe<Scalars['Boolean']['output']>;
  request: Scalars['String']['output'];
  response: Scalars['String']['output'];
  threadId: Scalars['ID']['output'];
  timing?: Maybe<AdminHealthGptTiming>;
  userFeedback?: Maybe<HealthGptChatMessageUserFeedback>;
};

export type AdminHealthGptMessagesConnection = {
  __typename?: 'AdminHealthGptMessagesConnection';
  items: Array<AdminHealthGptMessage>;
  pageInfo: PageInfo;
};

export type AdminHealthGptPlaybookRoute = {
  __typename?: 'AdminHealthGptPlaybookRoute';
  decision: AdminHealthGptPlaybookRouteDecision;
  /** Set when the router LLM call failed (route degraded to fallback) */
  error?: Maybe<Scalars['String']['output']>;
  matches: Array<AdminHealthGptPlaybookRouteMatch>;
  reasoning?: Maybe<Scalars['String']['output']>;
  /** Key of the single winning playbook, or null when the decision is fallback */
  resolvedKey?: Maybe<Scalars['String']['output']>;
  resolvedVersionUuid?: Maybe<Scalars['String']['output']>;
  routerModel: Scalars['String']['output'];
};

export enum AdminHealthGptPlaybookRouteDecision {
  fallback = 'fallback',
  playbook = 'playbook',
  terminal = 'terminal',
}

export type AdminHealthGptPlaybookRouteMatch = {
  __typename?: 'AdminHealthGptPlaybookRouteMatch';
  confidence: Scalars['Float']['output'];
  key: Scalars['String']['output'];
};

export type AdminHealthGptPromptTemplates = {
  __typename?: 'AdminHealthGptPromptTemplates';
  brandTone: Scalars['String']['output'];
  dataFetching: Scalars['String']['output'];
  dataInclusion: Scalars['String']['output'];
  responseFormat: Scalars['String']['output'];
  userQuestion: Scalars['String']['output'];
};

/** Can be specified to override default prompt template in the context of this request */
export type AdminHealthGptPromptTemplatesInput = {
  brandTone?: InputMaybe<Scalars['String']['input']>;
  dataFetching?: InputMaybe<Scalars['String']['input']>;
  dataInclusion?: InputMaybe<Scalars['String']['input']>;
  responseFormat?: InputMaybe<Scalars['String']['input']>;
  userQuestion?: InputMaybe<Scalars['String']['input']>;
};

export type AdminHealthGptQueryError = {
  __typename?: 'AdminHealthGptQueryError';
  errors: Array<Scalars['String']['output']>;
  query: Scalars['String']['output'];
};

export type AdminHealthGptStepTiming = {
  __typename?: 'AdminHealthGptStepTiming';
  children?: Maybe<Array<AdminHealthGptStepTiming>>;
  durationMs: Scalars['Int']['output'];
  mode?: Maybe<AdminHealthGptTimingMode>;
  step: Scalars['String']['output'];
};

export type AdminHealthGptThread = {
  __typename?: 'AdminHealthGptThread';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastMessage?: Maybe<Scalars['DateTime']['output']>;
  pet: Pet;
  totalMessages: Scalars['Int']['output'];
};

export type AdminHealthGptTiming = {
  __typename?: 'AdminHealthGptTiming';
  breakdown: Array<AdminHealthGptStepTiming>;
  totalMs: Scalars['Int']['output'];
};

export enum AdminHealthGptTimingMode {
  parallel = 'parallel',
  sequential = 'sequential',
}

export type AdminHealthGptUpdateDocumentInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type AdminIssueGiftCardInput = {
  accountId: Scalars['ID']['input'];
  /** ISO-8601 timestamp to schedule delivery. Delivers immediately when omitted. */
  deliverAt?: InputMaybe<Scalars['String']['input']>;
  ecomConfigType?: InputMaybe<Scalars['String']['input']>;
  gifterName?: InputMaybe<Scalars['String']['input']>;
  personalMessage?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  recipientEmail: Scalars['String']['input'];
  recipientFirstName?: InputMaybe<Scalars['String']['input']>;
  recipientLastName?: InputMaybe<Scalars['String']['input']>;
  /** A gift-card sku (e.g. gift-card-sub-1y). Determines the amount, which is fixed in Recurly. */
  sku: Scalars['String']['input'];
};

export enum AdminLevel {
  CITY = 'CITY',
  STATE = 'STATE',
}

export type AdminLineItemInput = {
  id: Scalars['ID']['input'];
  priceOverrideInCents?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
};

/**
 * An object in the public media bucket (barkinglabs-media), served at `publicUrl` via
 * media.tryfi.com in prod.
 */
export type AdminMediaAsset = {
  __typename?: 'AdminMediaAsset';
  /**
   * Null when the asset came from `adminListMediaAssets` — S3's list API doesn't return content
   * types. `adminGetMediaAsset` populates it.
   */
  contentType?: Maybe<Scalars['String']['output']>;
  lastModified: Scalars['DateTime']['output'];
  path: Scalars['String']['output'];
  publicUrl: Scalars['String']['output'];
  sizeBytes: Scalars['Float']['output'];
};

export type AdminMediaAssetList = {
  __typename?: 'AdminMediaAssetList';
  assets: Array<AdminMediaAsset>;
  /** Immediate sub-folder prefixes (each ends in "/"). */
  folders: Array<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
};

export type AdminMediaAssetUploadUrl = {
  __typename?: 'AdminMediaAssetUploadUrl';
  /** The object currently at `path` (null if new). Returned so UIs can show what an overwrite replaces. */
  existingAsset?: Maybe<AdminMediaAsset>;
  expiration: Scalars['DateTime']['output'];
  path: Scalars['String']['output'];
  publicUrl: Scalars['String']['output'];
  /**
   * Presigned S3 PUT URL. Upload with the same Content-Type passed to the mutation, then call
   * `adminFinalizeMediaAssetUpload`.
   */
  url: Scalars['String']['output'];
};

export type AdminMobileAppBanner = MobileAppBannerInterface & {
  __typename?: 'AdminMobileAppBanner';
  backgroundColorHex: Scalars['HexColorCode']['output'];
  borderGradient?: Maybe<MobileAppBannerBorderGradient>;
  contentTargeting: AdminMobileAppContentTargeting;
  createdAt: Scalars['DateTime']['output'];
  darkModeBackgroundColorHex?: Maybe<Scalars['HexColorCode']['output']>;
  darkModeForegroundColorHex?: Maybe<Scalars['HexColorCode']['output']>;
  description: Scalars['String']['output'];
  destinationUrl: Scalars['String']['output'];
  dismissOnTap: Scalars['Boolean']['output'];
  dismissible: Scalars['Boolean']['output'];
  dismissibleAfterSeconds?: Maybe<Scalars['Int']['output']>;
  foregroundColorHex: Scalars['HexColorCode']['output'];
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  leadingImage?: Maybe<MobileAppBannerImage>;
  title: Scalars['String']['output'];
};

export type AdminMobileAppBlockerScreen = MobileAppBlockerScreenInterface & {
  __typename?: 'AdminMobileAppBlockerScreen';
  bottomSheet: MobileAppBlockerScreenBottomSheet;
  contentTargeting: AdminMobileAppContentTargeting;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  pages: Array<MobileAppBlockerScreenPage>;
};

export type AdminMobileAppBottomSheet = MobileAppBottomSheetInterface & {
  __typename?: 'AdminMobileAppBottomSheet';
  /** @deprecated Read cards instead; this is the first card */
  buttons: Array<MobileAppBottomSheetButton>;
  cards: Array<MobileAppBottomSheetCard>;
  contentTargeting: AdminMobileAppContentTargeting;
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated Read cards instead; this is the first card */
  description: Scalars['String']['output'];
  /** @deprecated Read cards instead; this is the first card */
  formattedDescription: FormatString;
  /** @deprecated Read cards instead; this is the first card */
  formattedTitle: FormatString;
  id: Scalars['ID']['output'];
  /** @deprecated Read cards instead; this is the first card */
  image?: Maybe<MobileAppBottomSheetImage>;
  internalName: Scalars['String']['output'];
  /** @deprecated Read cards instead; this is the first card */
  title: Scalars['String']['output'];
};

export type AdminMobileAppClientSplash = {
  __typename?: 'AdminMobileAppClientSplash';
  clientSplashKey: ClientSplashKey;
  contentTargeting: AdminMobileAppContentTargeting;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
};

export type AdminMobileAppContent =
  | AdminEcommerceImageList
  | AdminMobileAppBanner
  | AdminMobileAppBlockerScreen
  | AdminMobileAppBottomSheet
  | AdminMobileAppClientSplash
  | AdminMobileAppDiscoverItem
  | AdminMobileAppPermissionBlockerScreen
  | AdminMobileAppSplashScreen;

export type AdminMobileAppContentAuditEntry = {
  __typename?: 'AdminMobileAppContentAuditEntry';
  clientView: MobileAppContentSourceView;
  config: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Null for rows backfilled by the audit-trail migration (pre-audit-trail content). */
  createdByUserEmail?: Maybe<Scalars['String']['output']>;
  dismissalDurationSeconds?: Maybe<Scalars['Int']['output']>;
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  requiresTrigger: Scalars['Boolean']['output'];
  start?: Maybe<Scalars['DateTime']['output']>;
  targetSpecies: Array<Species>;
  targetingRules?: Maybe<Scalars['JSON']['output']>;
  type: Scalars['String']['output'];
};

export type AdminMobileAppContentTargeting = {
  __typename?: 'AdminMobileAppContentTargeting';
  clientView?: Maybe<MobileAppContentSourceView>;
  dismissalDurationSeconds?: Maybe<Scalars['Int']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  isActive: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  requiresTrigger: Scalars['Boolean']['output'];
  startAt?: Maybe<Scalars['DateTime']['output']>;
  targetSpecies: Array<Species>;
  /**
   * JSON converted `json-rules-engine` rules.
   * No targeting rules will result in content being visible to any user/pet
   * See https://github.com/CacheControl/json-rules-engine/blob/master/docs/rules.md#persisting
   */
  targetingRules?: Maybe<Scalars['JSON']['output']>;
};

export type AdminMobileAppContentTriggerInput = {
  /**
   * Visibility-trigger targeting facts stored on the trigger, e.g.
   * `{ lifetimeTierReachedPetEncodedUuid: "...", lifetimeTierReachedTierName: "GOLD" }`. Unrecognized
   * fact names are rejected rather than silently dropped. Any of the user's live triggers for this
   * content carrying these same facts are expired first, so re-firing replaces rather than stacks.
   */
  targetingFacts?: InputMaybe<Scalars['JSON']['input']>;
  userId: Scalars['ID']['input'];
};

export type AdminMobileAppDiscoverItem = MobileAppDiscoverItemInterface & {
  __typename?: 'AdminMobileAppDiscoverItem';
  contentTargeting: AdminMobileAppContentTargeting;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  destinationUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Image;
  internalName: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AdminMobileAppPermissionBlockerScreen = MobileAppPermissionBlockerScreenInterface & {
  __typename?: 'AdminMobileAppPermissionBlockerScreen';
  bottomSheet: MobileAppBlockerScreenBottomSheet;
  contentTargeting: AdminMobileAppContentTargeting;
  createdAt: Scalars['DateTime']['output'];
  dismissable: Scalars['Boolean']['output'];
  dismissalDurationSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  pages: Array<MobileAppBlockerScreenPage>;
  permissionType: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
};

export type AdminMobileAppSplashScreen = MobileAppSplashScreenInterface & {
  __typename?: 'AdminMobileAppSplashScreen';
  contentTargeting: AdminMobileAppContentTargeting;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  pages: Array<MobileAppSplashScreenPage>;
};

export type AdminPauseMembershipInput = {
  moduleId: Scalars['String']['input'];
  /** Pause length in months, 1-3. */
  pauseMonths: Scalars['Int']['input'];
  /** Recurly subscription UUID. Must match the device's current subscription. */
  subscriptionId: Scalars['String']['input'];
};

export type AdminPermission = {
  __typename?: 'AdminPermission';
  scope: PermissionScope;
  suite: AdminSuite;
};

export type AdminPermissionInput = {
  scope: PermissionScope;
  suite: AdminSuite;
};

export type AdminPetDocument = BasePetDocument & {
  __typename?: 'AdminPetDocument';
  date: Scalars['DateTime']['output'];
  dbId: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  fileSizeBytes: Scalars['Int']['output'];
  fileType: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isUnseen: Scalars['Boolean']['output'];
  labels?: Maybe<Array<Scalars['String']['output']>>;
  markdownFileUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pets: Array<Pet>;
  status: PetDocumentStatus;
  summary?: Maybe<Scalars['String']['output']>;
  totalCostCents?: Maybe<Scalars['Int']['output']>;
  type: PetDocumentType;
};

export enum AdminPreSignedUploadPurpose {
  BULK_GROUP_ASSIGNMENT = 'BULK_GROUP_ASSIGNMENT',
  CONSIGNMENT_RESALE_CERTIFICATE = 'CONSIGNMENT_RESALE_CERTIFICATE',
  HEALTH_GPT = 'HEALTH_GPT',
  IAC_SHIPMENTS = 'IAC_SHIPMENTS',
  RESCUE_501C3 = 'RESCUE_501C3',
}

export type AdminPreSignedUploadUrlInput = {
  contentType: Scalars['String']['input'];
  filename?: InputMaybe<Scalars['String']['input']>;
  purpose: AdminPreSignedUploadPurpose;
};

export type AdminPreviewOrderInput = {
  cart: AdminCartInput;
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  shippingAddress: AddressInput;
  shippingOption?: InputMaybe<ShippingOption>;
};

/** Database-backed product SKU synced from Recurly or DCL */
export type AdminProductSku = {
  __typename?: 'AdminProductSku';
  category?: Maybe<Scalars['String']['output']>;
  compatibleDeviceProductIds?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  fulfillmentFlags?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isAdminOnly: Scalars['Boolean']['output'];
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  pricingInCents: Scalars['JSON']['output'];
  sku: Scalars['String']['output'];
  source: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminQueryNanoBatchInput = {
  batchId: Scalars['String']['input'];
};

export type AdminRecentGPSTest = {
  __typename?: 'AdminRecentGPSTest';
  date: Scalars['DateTime']['output'];
  duration: Scalars['Int']['output'];
  /** A location report associated with the test result, if there is one. */
  locationReport?: Maybe<LocationReport>;
  result: AdminGPSTestResult;
  user: User;
};

export type AdminRecentGPSTests = {
  __typename?: 'AdminRecentGPSTests';
  tests: Array<AdminRecentGPSTest>;
};

export type AdminRemoveBillingInfoInput = {
  accountCode: Scalars['String']['input'];
  billingInfoId: Scalars['String']['input'];
  /** Optional CX note recorded on the audit event and the Recurly account note. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AdminRequestGwaPostcardMailingInput = {
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
  /**
   * Fulfillment vendor registry name (`click2mail`, `gelato`). Omit to use the configured default.
   * Binds this order only — in-flight orders are unaffected by later config changes.
   */
  provider?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  shippingAddress: AddressInput;
};

/**
 * One row of the admin rescue-document review queue. The rescue context is
 * batch-resolved by `Admin.rescueDocuments`, so a page of rows costs a fixed
 * number of queries no matter how many documents it holds.
 */
export type AdminRescueDocumentListItem = {
  __typename?: 'AdminRescueDocumentListItem';
  /**
   * The signature on file, or null if the rescue has never certified. A document without one is only
   * half of what the jurisdiction asks for, which is the thing a reviewer most needs to see.
   */
  attestation?: Maybe<RescueExemptionAttestationRecord>;
  /**
   * Time-limited URL for the filed PDF of that signature. Null when no signature exists. Generated
   * fresh on each read (~5m TTL).
   */
  attestationPdfUrl?: Maybe<Scalars['String']['output']>;
  document: RescueDocument;
  /**
   * The owner's RESCUE-typed household, when they have one. Null for owners who
   * haven't been assigned a household yet.
   */
  rescueHousehold?: Maybe<Household>;
  /**
   * The rescue user who owns the document — the same user the document was
   * uploaded against, not the admin who uploaded it.
   */
  user: User;
};

/**
 * How many documents sit in each review state. Counts span the whole table
 * (pagination and the `status` filter are ignored) but honor `search`, so the
 * filter tabs can show totals for the states the operator isn't looking at.
 */
export type AdminRescueDocumentStatusCount = {
  __typename?: 'AdminRescueDocumentStatusCount';
  count: Scalars['Int']['output'];
  status: RescueDocumentStatus;
};

export type AdminRescueDocumentsResult = {
  __typename?: 'AdminRescueDocumentsResult';
  documents: Array<AdminRescueDocumentListItem>;
  hasMore: Scalars['Boolean']['output'];
  statusCounts: Array<AdminRescueDocumentStatusCount>;
  totalCount: Scalars['Int']['output'];
};

export type AdminRescueExpiringDocument = {
  __typename?: 'AdminRescueExpiringDocument';
  document: RescueDocument;
  /** True where the expiry date has already passed, as opposed to approaching. */
  expired: Scalars['Boolean']['output'];
  /** The rescue user the document is filed under. */
  user: User;
};

export type AdminRescueGwaProgramsResult = {
  __typename?: 'AdminRescueGwaProgramsResult';
  hasMore: Scalars['Boolean']['output'];
  programs: Array<RescueGwaProgram>;
  totalCount: Scalars['Int']['output'];
};

export type AdminResetConsignmentBurnerPartnerInput = {
  consignmentAccountId: Scalars['ID']['input'];
};

export type AdminResumeMembershipInput = {
  moduleId: Scalars['String']['input'];
  /** Recurly subscription UUID. Must match the device's current subscription. */
  subscriptionId: Scalars['String']['input'];
};

export type AdminRoleAssignment = {
  __typename?: 'AdminRoleAssignment';
  createdAt: Scalars['DateTime']['output'];
  createdByEmail: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role: AdminRoleDefinition;
};

export type AdminRoleDefinition = {
  __typename?: 'AdminRoleDefinition';
  assignmentCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<AdminPermission>;
  unmaskedPiiCategories: Array<PiiCategory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissions: Array<AdminPermissionInput>;
  unmaskedPiiCategories: Array<PiiCategory>;
};

export type AdminSearchDogParksInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<PositionInput>;
  radiusInMeters?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<POIType>;
};

export type AdminSearchUsersInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  petName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<FiCountry>;
};

export type AdminSendFreeNanoBoxesInput = {
  quantity: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type AdminSendSearchPartyTestNotificationResult = {
  __typename?: 'AdminSendSearchPartyTestNotificationResult';
  error?: Maybe<Scalars['String']['output']>;
  notificationsSent: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type AdminSetThirdPartyAccessInput = {
  /** Calling this with an undefined thirdPartyAccess will remove any existing third party access */
  thirdPartyAccess?: InputMaybe<Scalars['String']['input']>;
  /**
   * Finds matching user, and sets third party access for the user, for their household,
   * and for any pet they are an OWNER of.
   */
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type AdminSkuSyncResult = {
  __typename?: 'AdminSkuSyncResult';
  created: Scalars['Int']['output'];
  deactivated: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type AdminStartGoldenQuestionRunInput = {
  label: Scalars['String']['input'];
  llmModel?: InputMaybe<Scalars['String']['input']>;
  promptTemplates?: InputMaybe<AdminHealthGptPromptTemplatesInput>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type AdminStartNanoClaimInput = {
  number: Scalars['Int']['input'];
};

export enum AdminSuite {
  billing = 'billing',
  boarding = 'boarding',
  chargebacks = 'chargebacks',
  chips_nano = 'chips_nano',
  consignment = 'consignment',
  customer_lookup = 'customer_lookup',
  customerio = 'customerio',
  device_management = 'device_management',
  dog_parks = 'dog_parks',
  fi_intelligence = 'fi_intelligence',
  firmware = 'firmware',
  inventory = 'inventory',
  localization = 'localization',
  mobile_app_content = 'mobile_app_content',
  nano_ids = 'nano_ids',
  notifications = 'notifications',
  orders = 'orders',
  places = 'places',
  platform_config = 'platform_config',
  promotions = 'promotions',
  rescue = 'rescue',
  returns = 'returns',
  role_administration = 'role_administration',
  search_party = 'search_party',
  social_moderation = 'social_moderation',
  supplements = 'supplements',
}

export type AdminTargetedFeatureFlag = {
  __typename?: 'AdminTargetedFeatureFlag';
  createdAt: Scalars['DateTime']['output'];
  createdByUserEmail: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** A value here will override any value determined by the targetingRules. Can be helpful to disable a feature flag without needing to clear out the targetingRules. `userOverrides` still take precedence over this. */
  forcedValue?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * If provided, this flag is only active for a percentage of users. This is in combination with the `targetingRules`.
   * If targetingRules are also specified, this percentage is applied to the users that match the `targetingRules`.
   */
  percentOfUsers?: Maybe<Scalars['Float']['output']>;
  /**
   * JSON converted `json-rules-engine` rules.
   * See https://github.com/CacheControl/json-rules-engine/blob/master/docs/rules.md#persisting
   */
  targetingRules?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Per-user forced values, applied ahead of `forcedValue`, `targetingRules` and `percentOfUsers` alike. An "on" override is never filtered back out by a partial rollout, and an "off" override exempts a user from a flag they would otherwise get — including one that has been fully launched with `forcedValue: true`. At most one entry per user. */
  userOverrides: Array<AdminTargetedFeatureFlagUserOverride>;
};

export type AdminTargetedFeatureFlagUserOverride = {
  __typename?: 'AdminTargetedFeatureFlagUserOverride';
  userId: Scalars['Int']['output'];
  value: Scalars['Boolean']['output'];
};

export type AdminTargetedFeatureFlagUserOverrideInput = {
  userId: Scalars['Int']['input'];
  value: Scalars['Boolean']['input'];
};

export type AdminTimeline = {
  __typename?: 'AdminTimeline';
  /** @deprecated Use Query.adminMergedTimeline instead — pass a single moduleId for one device. It returns the same events plus explicit pageInfo, and windows multi-device pages consistently. */
  query: TimelineQueryResult;
};

export type AdminTimelinequeryArgs = {
  input: TimelineQueryInput;
};

export type AdminTriggerCustomerIoEventResult = {
  __typename?: 'AdminTriggerCustomerIoEventResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminUpdateAccountAddressInput = {
  accountCode: Scalars['ID']['input'];
  address: AddressInput;
};

export type AdminUpdateAccountDetailsInput = {
  accountCode: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateBreedInput = {
  localizedNames?: InputMaybe<Array<BreedTranslationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateChipPetInput = {
  chipId: Scalars['ID']['input'];
  petId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminUpdateChipResellerByBoxIdsInput = {
  boxIds: Array<Scalars['String']['input']>;
  resellerId: Scalars['ID']['input'];
};

export type AdminUpdateChipResellerByBoxInput = {
  boxId: Scalars['String']['input'];
  resellerId: Scalars['ID']['input'];
};

export type AdminUpdateChipResellerBySerialNumberInput = {
  resellerId: Scalars['ID']['input'];
  serialNumbers: Array<Scalars['String']['input']>;
};

export type AdminUpdateChipResellerInput = {
  chipId: Scalars['ID']['input'];
  resellerId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminUpdateEvalGuidelineInput = {
  appliesWhen?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  exampleBadResponse?: InputMaybe<Scalars['String']['input']>;
  exampleGoodResponse?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  scope?: InputMaybe<EvalGuidelineScope>;
  severity?: InputMaybe<EvalGuidelineSeverity>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateGoldenQuestionInput = {
  classification?: InputMaybe<EvalClassification>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  mockBreedSummaryData?: InputMaybe<Scalars['JSON']['input']>;
  mockCurrentDate?: InputMaybe<Scalars['DateTime']['input']>;
  mockGraphqlData?: InputMaybe<Scalars['JSON']['input']>;
  mockKnowledgeBaseDocs?: InputMaybe<Scalars['JSON']['input']>;
  mockPetDetails?: InputMaybe<Scalars['JSON']['input']>;
  mockPetDocuments?: InputMaybe<Scalars['JSON']['input']>;
  questionText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateHealthGptPlaybookInput = {
  appliesWhen?: InputMaybe<Scalars['String']['input']>;
  audience?: InputMaybe<HealthGptPlaybookAudienceInput>;
  confidenceThreshold?: InputMaybe<Scalars['Float']['input']>;
  evalCategories?: InputMaybe<Array<EvalClassification>>;
  key: Scalars['String']['input'];
  promptSection?: InputMaybe<Scalars['String']['input']>;
  responseMode?: InputMaybe<HealthGptPlaybookResponseMode>;
  retrievalConfig?: InputMaybe<HealthGptPlaybookRetrievalConfigInput>;
  terminalResponseTemplate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateInventoryConfigurationInput = {
  allowAutoMarkOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  allowFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  backInStockDateOverride?: InputMaybe<Scalars['DateTime']['input']>;
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
  justInTimeKittingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  manualInventoryAdjustment?: InputMaybe<Scalars['Int']['input']>;
  outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminUpdateProductSkuInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  compatibleDeviceProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  fulfillmentFlags?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  isAdminOnly?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type AdminUpdateRescueStateExemptionRuleInput = {
  bucket?: InputMaybe<RescueStateExemptionBucket>;
  purchaserForm?: InputMaybe<Scalars['String']['input']>;
  /** Two-letter jurisdiction code. Case and surrounding whitespace are normalised. */
  state: Scalars['String']['input'];
  stateIssuedForm?: InputMaybe<Scalars['String']['input']>;
  verifyOnlyReason?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateTargetedFeatureFlagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  forcedValue?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  percentOfUsers?: InputMaybe<Scalars['Float']['input']>;
  targetingRules?: InputMaybe<Scalars['JSON']['input']>;
  /** Omit to leave the existing overrides untouched; pass an empty list or null to clear them. */
  userOverrides?: InputMaybe<Array<AdminTargetedFeatureFlagUserOverrideInput>>;
};

export type AdminUploadImageResult = {
  __typename?: 'AdminUploadImageResult';
  image: Image;
};

export type AdminUploadRescueDocumentInput = {
  documentType: RescueDocumentType;
  /** Original file name from the operator's filesystem (for display only). */
  fileName: Scalars['String']['input'];
  /** S3 key returned by `adminGetPreSignedUploadUrl` with purpose RESCUE_501C3. */
  uploadedFileKey: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type AdminUpsertFulfillmentWarehouseInput = {
  /** is the warehouse active and can be used for fulfillment */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** the code the 3PL uses to identify the warehouse */
  externalCode: Scalars['String']['input'];
  /** code for the fulfillment provider (3PL) */
  fulfillmentProviderCode: FulfillmentProviderCode;
  /** metadata for the warehouse */
  metadata?: InputMaybe<FulfillmentWarehouseMetadataInput>;
  /** our internal name for this warehouse */
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A user deletion request for admin view.
 * Note: userId is nullable when accessed by non-admin users viewing their own request
 * via User.pendingDeletionRequest to avoid exposing DB identifiers.
 */
export type AdminUserDeletionRequest = {
  __typename?: 'AdminUserDeletionRequest';
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  deletionResults?: Maybe<Array<DeletionServiceResult>>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  requestSource: DeletionRequestSource;
  requestedAt: Scalars['DateTime']['output'];
  requestedByUser?: Maybe<User>;
  scheduledFor: Scalars['DateTime']['output'];
  status: DeletionRequestStatus;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
};

export type AdministrativeArea = {
  __typename?: 'AdministrativeArea';
  id: Scalars['ID']['output'];
  level: AdminLevel;
  name: Scalars['String']['output'];
};

export type AdopterAdoptionTransfersFilter = {
  status?: InputMaybe<PetAdoptionTransferStatus>;
};

export enum AdoptionTransferResolution {
  ACCEPT = 'ACCEPT',
  RESCUE_RESOLVE = 'RESCUE_RESOLVE',
}

export enum AgeRange {
  ADULT = 'ADULT',
  PUPPY = 'PUPPY',
  SENIOR = 'SENIOR',
}

export type AggregateHealthMetric = {
  __typename?: 'AggregateHealthMetric';
  binnedValues?: Maybe<HealthMetricBinnedValues>;
  count?: Maybe<HealthRollupValues>;
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  max?: Maybe<HealthRollupValues>;
  mean?: Maybe<HealthRollupValues>;
  median?: Maybe<HealthRollupValues>;
  min?: Maybe<HealthRollupValues>;
  p95?: Maybe<HealthRollupValues>;
  p99?: Maybe<HealthRollupValues>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type AirvetDataItem = {
  __typename?: 'AirvetDataItem';
  cancellationWebviewUrl: Scalars['String']['output'];
  deeplinkUrl: Scalars['String']['output'];
  hasActiveSubscription: Scalars['Boolean']['output'];
  hasValidBillingInfo: Scalars['Boolean']['output'];
  nextBillDate?: Maybe<Scalars['DateTime']['output']>;
  shouldShowMenuItem: Scalars['Boolean']['output'];
  subscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionWillExpire: Scalars['Boolean']['output'];
  unitAmountInCents: Scalars['Int']['output'];
  updatePaymentWebviewUrl: Scalars['String']['output'];
};

export type AnimatedShareableUrls = {
  __typename?: 'AnimatedShareableUrls';
  squareUrl?: Maybe<Scalars['String']['output']>;
  storyUrl?: Maybe<Scalars['String']['output']>;
};

export enum AnimationFormat {
  GIF = 'GIF',
  H264 = 'H264',
  H265 = 'H265',
  MP4 = 'MP4',
  WEBM = 'WEBM',
}

export type AnnotatedPointInTimeEvent = PointInTimeEvent & {
  __typename?: 'AnnotatedPointInTimeEvent';
  annotation: Scalars['String']['output'];
  time: Scalars['DateTime']['output'];
};

export type AnnotatedTimeRangeEvent = TimeRangeEvent & {
  __typename?: 'AnnotatedTimeRangeEvent';
  annotation: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type AppIntegration = {
  __typename?: 'AppIntegration';
  appId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  exampleCaption?: Maybe<Scalars['String']['output']>;
  exampleImage?: Maybe<Image>;
  icon?: Maybe<Image>;
  title: Scalars['String']['output'];
  userConnected: Scalars['Boolean']['output'];
};

export enum AppIntegrationId {
  alltrails = 'alltrails',
  amazon_alexa = 'amazon_alexa',
  bark = 'bark',
  bringfido = 'bringfido',
  citizen = 'citizen',
  dyrt = 'dyrt',
  fitbit = 'fitbit',
  gaia = 'gaia',
  google_home = 'google_home',
  hiking_project = 'hiking_project',
  irobot_home = 'irobot_home',
  life360 = 'life360',
  mapmyfitness = 'mapmyfitness',
  nextdoor = 'nextdoor',
  nike_run_club = 'nike_run_club',
  nike_training_club = 'nike_training_club',
  oura = 'oura',
  pawshake = 'pawshake',
  peakfinder = 'peakfinder',
  peloton = 'peloton',
  puppr = 'puppr',
  ramblr = 'ramblr',
  ring = 'ring',
  rover = 'rover',
  strava = 'strava',
  wag = 'wag',
  whoop = 'whoop',
}

export type AppUpdatePrompt = {
  __typename?: 'AppUpdatePrompt';
  forced: Scalars['Boolean']['output'];
};

export enum ApplicationState {
  BACKGROUND = 'BACKGROUND',
  INACTIVE = 'INACTIVE',
}

/** A retention free-month offer that is currently applied to, or scheduled for, a subscription. */
export type AppliedFreeMonth = {
  __typename?: 'AppliedFreeMonth';
  /**
   * PENDING only: the date the free month will begin (the current commitment term end).
   * Always null when APPLIED — the frontend uses the subscription's currentTermEndsAt as the
   * "not charged until" date for the APPLIED case.
   */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * APPLIED: the free month is active now (the next bill has already been deferred).
   * PENDING: the free month is scheduled to begin once the current commitment term ends.
   */
  status: AppliedFreeMonthStatus;
};

export enum AppliedFreeMonthStatus {
  APPLIED = 'APPLIED',
  PENDING = 'PENDING',
}

export type ApplyMultidogDiscountResult = {
  __typename?: 'ApplyMultidogDiscountResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Represents a distance that has been obfuscated so as not to reveal
 * too precise of a distance/location. The `miles` field is truncated,
 * and below a certain distance it is capped and the `isLessThanThisDistance`
 * boolean is flagged true.
 */
export type ApproximateDistance = {
  __typename?: 'ApproximateDistance';
  isLessThanThisDistance: Scalars['Boolean']['output'];
  miles: Scalars['Float']['output'];
};

export type ArchiveFirmwareInput = {
  versions: Array<Scalars['String']['input']>;
};

export type Article = {
  __typename?: 'Article';
  excerpt?: Maybe<Scalars['String']['output']>;
  featureImageUrl?: Maybe<Scalars['String']['output']>;
  html: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  likeCount: Scalars['Int']['output'];
  /** Whether the current user has liked this article. */
  liked: Scalars['Boolean']['output'];
  primaryAuthor: ArticleAuthor;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ArticleAuthor = {
  __typename?: 'ArticleAuthor';
  name: Scalars['String']['output'];
};

export type AspectRatio = {
  __typename?: 'AspectRatio';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type AspectRatioInput = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type AssignExistingPetToChipInput = {
  chipId: Scalars['ID']['input'];
  petId: Scalars['ID']['input'];
};

export type AssignNewOwnerToChipInput = {
  chipId: Scalars['ID']['input'];
  contactInfo: ChipContactInfoInput;
};

export type AssignNewPetToChipInput = {
  chipId: Scalars['ID']['input'];
  petInfo: ChipNewPetInput;
};

/**
 * A chip that the current user owns. It could either be that a pet in their household is assigned to their chip
 * or their email is listed as primary email in the chip contact info.
 */
export type AssignedChip = BaseChip & {
  __typename?: 'AssignedChip';
  /**
   * Present when this chip was sold by a GWA-enrolled rescue reseller: the adopter's free Fi Mini
   * offer plus a signed shop link that auto-applies the rescue's coupon. Null otherwise.
   */
  gwaOffer?: Maybe<GwaOffer>;
  id: Scalars['ID']['output'];
  isFiChip: Scalars['Boolean']['output'];
  latestContactHistoryEntry?: Maybe<ChipContactHistoryEntry>;
  /** @deprecated Use `latestContactHistoryEntry.contactInfo` instead */
  latestContactInfo?: Maybe<ChipContactInfo>;
  pet?: Maybe<StrangerPet>;
  serialNumber: Scalars['String']['output'];
  shortId: Scalars['String']['output'];
  /** An outstanding transfer request that the current owner of the chip can resolve/reject */
  transfer?: Maybe<ChipTransfer>;
};

export type AuditLogEvent = {
  __typename?: 'AuditLogEvent';
  action: Scalars['String']['output'];
  body: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  initiatedBy?: Maybe<AuditLogEventUser>;
  initiatedByEmail?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

/** Narrower user interface for only what audit log events need */
export type AuditLogEventUser = {
  __typename?: 'AuditLogEventUser';
  dbId?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type AutoTranslateResult = {
  __typename?: 'AutoTranslateResult';
  errors: Array<Scalars['String']['output']>;
  translations: Array<TranslatedEntry>;
};

export type AvailableS3DowngradeSubscriptionOptionsInput = {
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  currency?: InputMaybe<Currency>;
  moduleId: Scalars['ID']['input'];
};

export type AvailableS3DowngradeSubscriptionOptionsResult = {
  __typename?: 'AvailableS3DowngradeSubscriptionOptionsResult';
  subscriptionOptions: Array<SubscriptionOption>;
};

/** Subscription plan available for a product transfer. */
export type AvailableTransferPlan = {
  __typename?: 'AvailableTransferPlan';
  /** currency code for the price */
  currency?: Maybe<Currency>;
  /** True if this plan matches the source subscription's term */
  isRecommended: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priceInCents: Scalars['Int']['output'];
  renewalMonths: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
};

/** Summary of a single exemption certificate filed in Avalara against a customer. */
export type AvalaraCertSummary = {
  __typename?: 'AvalaraCertSummary';
  certificateId: Scalars['Int']['output'];
  exemptionReasonName?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  /** Full state name (e.g. "Florida", not "FL") — Avalara's format. */
  exposureZone: Scalars['String']['output'];
  signedDate?: Maybe<Scalars['String']['output']>;
  /** Avalara cert status string ("active", "revoked", etc). */
  status: Scalars['String']['output'];
};

export type AvatarAbbreviation = {
  __typename?: 'AvatarAbbreviation';
  abbreviation: Scalars['String']['output'];
};

export type AvatarImage = {
  __typename?: 'AvatarImage';
  image: Image;
};

export type BBoxInput = {
  northEasternPosition: PositionInput;
  southWesternPosition: PositionInput;
};

/**
 * How the pet's collar is currently reaching the network (its "backhaul"). Surfaced as the
 * connection indicator in live-state UIs. Mirrors the `OnlineConnectionState` union the backend
 * resolves internally; pet-level field picks the best state across the pet's devices.
 */
export enum BackhaulType {
  /** Collar is on or near its charging base. */
  BASE = 'BASE',
  /** Collar is reporting over its own cellular modem via a terrestrial cell tower. */
  CELLULAR = 'CELLULAR',
  /**
   * Collar is paired to a user device (phone or wearable) via BLE and relaying through that
   * device's network. UI-facing terminology across iOS and Android is "Phone"; wearable relays
   * (e.g. Apple Watch) are collapsed into this value since no consumer currently distinguishes.
   */
  PHONE = 'PHONE',
  /**
   * Collar is reporting over its own cellular modem via satellite (e.g. Starlink Direct-to-Cell).
   * Distinct from CELLULAR so Ultra UI can show a satellite indicator.
   */
  SATELLITE = 'SATELLITE',
  /** No recent connection state available. */
  UNKNOWN = 'UNKNOWN',
  /** Collar is on a known Wi-Fi network. */
  WIFI = 'WIFI',
}

export type BankAccountInfo = {
  __typename?: 'BankAccountInfo';
  accountType: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

export type BaseChip = {
  id: Scalars['ID']['output'];
  isFiChip: Scalars['Boolean']['output'];
  serialNumber: Scalars['String']['output'];
  shortId: Scalars['String']['output'];
};

export type BasePack = {
  actingPetCanJoin: Scalars['Boolean']['output'];
  actingPetCanLeave: Scalars['Boolean']['output'];
  actingPetCannotJoinReason?: Maybe<Scalars['String']['output']>;
  actingPetDidManuallyJoin: Scalars['Boolean']['output'];
  actingPetIsMember: Scalars['Boolean']['output'];
  actingPetMembershipReason: Scalars['String']['output'];
  ageFiltersWithEnoughRankedPets: Array<PackAgeFilter>;
  avatar: PackAvatar;
  category: PackCategory;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * A 6-digit hex color code, including # sign, and letters lowercase (eg.
   * `#ff00b1`) used to highlight this pack in the app.
   */
  highlightColorHex?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  joinPackUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  petRanking: PackRanking;
  totalRankedPets: Scalars['Int']['output'];
  /**
   * A 64-bit integer representing the total steps for all pets in this pack for
   * the latest ranking period returned as a String.
   */
  totalRankedSteps: Scalars['String']['output'];
};

export type BasePackpetRankingArgs = {
  packAgeFilter?: InputMaybe<PackAgeFilter>;
  petId: Scalars['ID']['input'];
};

export type BasePet = {
  additionalInfo?: Maybe<Scalars['String']['output']>;
  breed?: Maybe<Breed>;
  color?: Maybe<Scalars['String']['output']>;
  communityAudience: Scalars['String']['output'];
  dayOfBirth?: Maybe<Scalars['Int']['output']>;
  discoverPostFeed: PetDiscoverFeed;
  fiHandle?: Maybe<Scalars['String']['output']>;
  followers: StrangerPetFeed;
  following: StrangerPetFeed;
  gender: Gender;
  /** @deprecated Always null. Use homeLocation instead */
  homeCityState?: Maybe<Scalars['String']['output']>;
  homeLocation?: Maybe<PetHomeLocation>;
  id: Scalars['ID']['output'];
  instagramHandle?: Maybe<Scalars['String']['output']>;
  isAmbassador: Scalars['Boolean']['output'];
  isPurebred: Scalars['Boolean']['output'];
  monthOfBirth?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  photos: PhotoFeed;
  species?: Maybe<Species>;
  /** Information about step streaks */
  stepActivityInfo: StepActivityInfo;
  /** Total number of likes for this pet, across walks, photos, etc. */
  totalLikes: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weight: Scalars['Float']['output'];
  yearOfBirth: Scalars['Int']['output'];
};

export type BasePetdiscoverPostFeedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type BasePetfollowersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type BasePetfollowingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type BasePetBehaviorDetail = {
  behaviorId: Scalars['String']['output'];
  behaviorLabel: Scalars['String']['output'];
  color: Scalars['HexColorCode']['output'];
  comparison: PetBehaviorDetailComparison;
  cursor: Scalars['String']['output'];
  durationLabel: Scalars['String']['output'];
  durationText: Scalars['String']['output'];
  durationTextColor?: Maybe<Scalars['HexColorCode']['output']>;
  eventCountLabel: Scalars['String']['output'];
  eventCountText: Scalars['String']['output'];
  eventCountTextColor: Scalars['HexColorCode']['output'];
  help: PetBehaviorDetailHelp;
  icon: Image;
  nextCursor?: Maybe<Scalars['String']['output']>;
  period: PetBehaviorPeriod;
  previousCursor?: Maybe<Scalars['String']['output']>;
  /** A human readable label for this period of time */
  rangeLabel: Scalars['String']['output'];
};

export type BasePetDocument = {
  date: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  fileSizeBytes: Scalars['Int']['output'];
  fileType: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isUnseen: Scalars['Boolean']['output'];
  labels?: Maybe<Array<Scalars['String']['output']>>;
  markdownFileUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: PetDocumentStatus;
  summary?: Maybe<Scalars['String']['output']>;
  totalCostCents?: Maybe<Scalars['Int']['output']>;
  type: PetDocumentType;
};

export type BasicPointInTimeEvent = PointInTimeEvent & {
  __typename?: 'BasicPointInTimeEvent';
  time: Scalars['DateTime']['output'];
};

export type BasicTimeRangeEvent = TimeRangeEvent & {
  __typename?: 'BasicTimeRangeEvent';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type BatteryHistoryAggregationBucket = {
  __typename?: 'BatteryHistoryAggregationBucket';
  date: Scalars['DateTime']['output'];
  minBattery?: Maybe<Scalars['Float']['output']>;
  minBq27421Temperature?: Maybe<Scalars['Float']['output']>;
  minBq27421Voltage?: Maybe<Scalars['Float']['output']>;
  minMax77658BatteryTemperatureC?: Maybe<Scalars['Float']['output']>;
  minMax77658VoltageUv?: Maybe<Scalars['Float']['output']>;
  minUserFacingBatteryPercent?: Maybe<Scalars['Float']['output']>;
};

export type BatteryHistoryOverviewDeviceEvent =
  | ConnectionStateChangeDeviceEvent
  | FirmwareVersionChangeDeviceEvent
  | PowerStateChangeDeviceEvent
  | RebootDeviceEvent;

export type BillingAccount = {
  __typename?: 'BillingAccount';
  accountBalanceInCents: Scalars['Int']['output'];
  accountURL?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Address>;
  billingInfo?: Maybe<BillingInfo>;
  billingInfoEditUrl?: Maybe<Scalars['String']['output']>;
  /** All stored payment methods (up to a primary + backup). Use isPrimary to identify the default. */
  billingInfos: Array<BillingInfo>;
  /**
   * False when this account holds no membership but another member of the user's household does, so
   * the membership covering their pets is billed elsewhere. Recurly billing is per-account and the
   * payment-update path keys off the requesting user's own account, so updating a payment method here
   * would store a card that is never charged while the real membership keeps failing. Clients should
   * not offer an update-payment action when this is false, and should say who is billed rather than
   * letting the attempt fail at the end of a payment sheet.
   */
  canUpdatePaymentInfo: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  /** Active coupon redemptions on this account (account-level coupons, not subscription-specific) */
  couponRedemptions: Array<CouponRedemption>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this account's payment method can be removed, evaluated against the primary (or only)
   * stored method. Removal is allowed only when the member has no outstanding financial
   * responsibility - no subscription that will charge again and no balance owed.
   */
  paymentMethodRemovability: PaymentMethodRemovability;
  /**
   * Billing address to prefill an update-payment form with, resolved server side from the account
   * address, then the stored payment method's address, then the most recent invoice - so clients read
   * one field and implement no precedence of their own. Distinct from `address`, which is only ever
   * Recurly's account-level address and is empty on roughly 44% of accounts. Null when Recurly holds
   * no address at all: the form must stay editable and submittable in that case, since those users are
   * exactly the ones who cannot complete an update today. Pair with `firstName`/`lastName` for the
   * cardholder name.
   */
  prefillAddress?: Maybe<Address>;
  recurlyHostedBillingInfoUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Aggregated membership renewal terms for an Apple Pay recurring-payment request (merchant token).
   * Null when the account's live membership subscriptions span multiple cadences or currencies, or any
   * renewal can't be previewed (comped/overridden) - clients then use a standard (device token) request.
   */
  renewalTerms?: Maybe<RenewalTerms>;
  subscriptions: Array<BillingSubscription>;
};

export type BillingAccountsubscriptionsArgs = {
  filter?: InputMaybe<BillingSubscriptionFilter>;
};

export type BillingAccountInput = {
  address?: InputMaybe<AddressInput>;
  billingInfo?: InputMaybe<BillingInfoInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type BillingAccountMini = {
  __typename?: 'BillingAccountMini';
  code?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export enum BillingCadence {
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR',
}

export type BillingInfo = {
  __typename?: 'BillingInfo';
  address: Address;
  /** @deprecated Multiple payment types are now availble so use paymentInfo instead */
  cardInfo: ObfuscatedCardInfo;
  firstName: Scalars['String']['output'];
  /** Recurly billing info id. Use with setDefaultBillingInfo to choose the primary payment method. */
  id?: Maybe<Scalars['String']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  paymentInfo: PaymentInfo;
};

export type BillingInfoInput = {
  threeDSecureActionResultToken?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  tokenType?: InputMaybe<BillingTokenType>;
};

export type BillingSubscription = {
  __typename?: 'BillingSubscription';
  /**
   * Account-level notes from Recurly (CX agent notes, support history, etc.)
   * Returns empty array if notes cannot be fetched.
   */
  accountNotes?: Maybe<Array<AccountNote>>;
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  address?: Maybe<ShippingAddress>;
  /**
   * Present when a retention free-month offer is currently applied or scheduled for this
   * subscription; null otherwise.
   */
  appliedFreeMonth?: Maybe<AppliedFreeMonth>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  currentTermEndsAt: Scalars['DateTime']['output'];
  /** The device associated with this subscription (if any). */
  device?: Maybe<Device>;
  /**
   * Detailed dunning info when a payment has failed. Null when no failed payment.
   * Includes decline reason, payment method details, and the past-due invoice.
   */
  dunningInfo?: Maybe<DunningInfo>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether a plan change on this subscription is charged immediately rather than at the end of the
   * current cycle, which is the case inside the hardware-first activation window.
   */
  hardwareFirstChangeBillsNow?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this subscription's plan code is a free trial plan */
  hasFreeTrialPlan?: Maybe<Scalars['Boolean']['output']>;
  /** Maps to Recurly Subscription UUID */
  id: Scalars['ID']['output'];
  isCanceled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this subscription is currently within its trial period */
  isInTrialPeriod?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True while any pause is scheduled or in effect — a native monthly Recurly pause or a
   * multi-month deferral-pause window.
   */
  isPaused?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the most recent payment attempt failed */
  lastPaymentFailed?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  nextRenewalPreview?: Maybe<SubscriptionRenewalPreview>;
  nextSupplementShipmentDetails?: Maybe<NextSupplementShipmentDetails>;
  /**
   * End of the deferral-pause window — when billing resumes. Null unless a pause window is pending
   * or active.
   */
  pauseResumesAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Recurly's native pause timestamp, set for monthly plans paused via Recurly's pause mechanism.
   * Always null for multi-month deferral pauses — use pausesAt/pauseResumesAt for those.
   */
  pausedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Start of the scheduled deferral-pause window (multi-month plans) — when the app lock begins.
   * Null unless a pause window is pending or active.
   */
  pausesAt?: Maybe<Scalars['DateTime']['output']>;
  pendingChanges?: Maybe<SubscriptionPendingChange>;
  /** The pet associated with this subscription (via the device). */
  pet?: Maybe<Pet>;
  quantity: Scalars['Int']['output'];
  /**
   * Recurly's remaining native pause cycles. Greater than zero while a native monthly pause is
   * scheduled or in effect; always zero for multi-month deferral pauses.
   */
  remainingPauseCycles?: Maybe<Scalars['Int']['output']>;
  state: BillingSubscriptionState;
  /** Details about the plan itself. Null if the plan code is unknown/invalid. */
  subscriptionOption?: Maybe<SubscriptionOption>;
  supplementShipmentDates?: Maybe<SupplementShipmentDates>;
  thirdPartyId?: Maybe<ThirdPartyId>;
  /** When the trial period ends (null if subscription never had a trial) */
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
  unitAmountInCents: Scalars['Int']['output'];
  /** Warning message if there's an issue with this subscription (e.g., unknown plan code). */
  warning?: Maybe<Scalars['String']['output']>;
};

export type BillingSubscriptionFilter = {
  category?: InputMaybe<BillingSubscriptionFilterCategory>;
  state?: InputMaybe<BillingSubscriptionFilterState>;
};

/** The filter categories include all ProductCategory values */
export enum BillingSubscriptionFilterCategory {
  BAND = 'BAND',
  CHARGING_BASE = 'CHARGING_BASE',
  COLLAR_KIT = 'COLLAR_KIT',
  ENDLINK = 'ENDLINK',
  GIFT_CARD = 'GIFT_CARD',
  MICROCHIP = 'MICROCHIP',
  MODULE = 'MODULE',
  S2_UPGRADE = 'S2_UPGRADE',
  SUBSCRIPTION = 'SUBSCRIPTION',
  SUPPLEMENT = 'SUPPLEMENT',
  THIRD_PARTY_MEMBERSHIP = 'THIRD_PARTY_MEMBERSHIP',
}

/** The filter states include all the BillingSubscriptionState plus additional meta states */
export enum BillingSubscriptionFilterState {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  FUTURE = 'FUTURE',
  IN_TRIAL = 'IN_TRIAL',
  LIVE = 'LIVE',
  PAST_DUE = 'PAST_DUE',
  PAUSED = 'PAUSED',
}

export enum BillingSubscriptionState {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  FUTURE = 'FUTURE',
  PAUSED = 'PAUSED',
}

export enum BillingTokenType {
  RECURLY_JS_TOKEN = 'RECURLY_JS_TOKEN',
  STRIPE_CONFIRMATION_TOKEN = 'STRIPE_CONFIRMATION_TOKEN',
}

/** Content related to the display of a pet's birthday card */
export type BirthdayCard = {
  __typename?: 'BirthdayCard';
  petPicture?: Maybe<Image>;
  poem?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type BoardingFacility = {
  __typename?: 'BoardingFacility';
  createdAt: Scalars['DateTime']['output'];
  dbId: Scalars['Int']['output'];
  household: Household;
  /**
   * The configuration required to integrate with the boarding facility's management software.
   * Admin-only field.
   */
  managementPlatformConfig?: Maybe<BoardingFacilityPlatformConfig>;
  managementPlatformType: Scalars['String']['output'];
  /**
   * The timezone for the boarding facility (e.g., "America/New_York").
   * Used to determine when to send daily email updates.
   */
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BoardingFacilityCheckInPetInput = {
  externalPetId: Scalars['ID']['input'];
  householdId: Scalars['ID']['input'];
  moduleId: Scalars['String']['input'];
  reportSubmission?: InputMaybe<ReportSubmissionInput>;
};

export type BoardingFacilityContact = {
  __typename?: 'BoardingFacilityContact';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type BoardingFacilityOwnerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** If null, the user will have to reset their password via email */
  password?: InputMaybe<Scalars['String']['input']>;
  tenancy?: InputMaybe<Scalars['String']['input']>;
};

export type BoardingFacilityPetFeed = {
  __typename?: 'BoardingFacilityPetFeed';
  pageInfo: PageInfo;
  pets: Array<BoardingPet>;
};

export type BoardingFacilityPlatformConfig = GingrConfig;

export type BoardingFacilityProspectivePetFeed = {
  __typename?: 'BoardingFacilityProspectivePetFeed';
  pageInfo: PageInfo;
  pets: Array<ProspectiveBoardingPet>;
};

export type BoardingFacilityProspectivePetsInput = {
  householdId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
  query: Scalars['String']['input'];
};

export type BoardingFacilityStaffUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** If null, the user will have to reset their password via email */
  password?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Pet that exists in the boarding facility's third-party platform and is tied to a Fi pet because they have previously
 * checked a the boarding facility on the Fi app.
 */
export type BoardingPet = {
  __typename?: 'BoardingPet';
  /** Populated if the pet is currently checked in at the facility. */
  currentSession?: Maybe<BoardingSession>;
  fiPet: Pet;
  owner: BoardingFacilityContact;
  /**
   * This breed comes from the third-party platform and may not map to our own Breed type that we store on Pet so we
   * make this available separately as a String.
   */
  thirdPartyBreedName: Scalars['String']['output'];
  /** The ID of the pet in the boarding facility's third-party platform. */
  thirdPartyPetId: Scalars['ID']['output'];
  /** The next upcoming reservation time for the pet. */
  upcomingReservationTime?: Maybe<Scalars['DateTime']['output']>;
};

export type BoardingSession = {
  __typename?: 'BoardingSession';
  checkedInAt: Scalars['DateTime']['output'];
  checkedInByUser: User;
  checkedOutAt?: Maybe<Scalars['DateTime']['output']>;
  checkedOutByUser?: Maybe<User>;
  household: Household;
  id: Scalars['ID']['output'];
  pet: Pet;
};

export type BooleanFeatureFlag = FeatureFlag & {
  __typename?: 'BooleanFeatureFlag';
  accessedAt?: Maybe<Scalars['DateTime']['output']>;
  booleanValue: BooleanSetting;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dynamicSettingName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BooleanSetting = {
  platformOverrides: Array<BooleanSettingPlatformOverride>;
};

export type BooleanSettingForceOffPlatformOverride = BooleanSettingPlatformOverride & {
  __typename?: 'BooleanSettingForceOffPlatformOverride';
  forceOff: Scalars['Boolean']['output'];
  platform: HandsetPlatform;
};

export type BooleanSettingForceOnPlatformOverride = BooleanSettingPlatformOverride & {
  __typename?: 'BooleanSettingForceOnPlatformOverride';
  forceOn: Scalars['Boolean']['output'];
  platform: HandsetPlatform;
};

export type BooleanSettingMinVersionPlatformOverride = BooleanSettingPlatformOverride & {
  __typename?: 'BooleanSettingMinVersionPlatformOverride';
  minVersion: Scalars['String']['output'];
  platform: HandsetPlatform;
};

export type BooleanSettingPlatformOverride = {
  platform: HandsetPlatform;
};

export type BooleanSettingPlatformOverrideInput = {
  /** Note: only one of `forceOn`, `forceOff`, or `minVersion` should be set. */
  forceOff?: InputMaybe<Scalars['Boolean']['input']>;
  /** Note: only one of `forceOn`, `forceOff`, or `minVersion` should be set. */
  forceOn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Note: only one of `forceOn`, `forceOff`, or `minVersion` should be set. */
  minVersion?: InputMaybe<Scalars['String']['input']>;
  platform: HandsetPlatform;
};

export enum BooleanSettingType {
  FALSE = 'FALSE',
  GROUPS = 'GROUPS',
  PERCENTAGE_OF_USERS = 'PERCENTAGE_OF_USERS',
  RANDOM_PERCENTAGE = 'RANDOM_PERCENTAGE',
  TRUE = 'TRUE',
  USER_IDS = 'USER_IDS',
}

export type Breed = {
  __typename?: 'Breed';
  dbId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  localizedNames: Array<BreedTranslation>;
  name: Scalars['String']['output'];
  /** @deprecated Sorting should be done server side */
  popularityScore: Scalars['Int']['output'];
  species: Species;
};

export type BreedTranslation = {
  __typename?: 'BreedTranslation';
  language: FiLanguage;
  name: Scalars['String']['output'];
};

export type BreedTranslationInput = {
  language: FiLanguage;
  name: Scalars['String']['input'];
};

export type BrowsePacksResponse = {
  __typename?: 'BrowsePacksResponse';
  packFeed: PackFeed;
};

export type BulkPackInsertResponse = {
  __typename?: 'BulkPackInsertResponse';
  error?: Maybe<Scalars['String']['output']>;
  petWarnings?: Maybe<Array<Maybe<BulkPackInsertWarning>>>;
  success: Scalars['Boolean']['output'];
  successPetIds: Array<Scalars['ID']['output']>;
};

export type BulkPackInsertWarning = {
  __typename?: 'BulkPackInsertWarning';
  petId: Scalars['ID']['output'];
  reason: ReasonForPackInsertFailure;
};

/** Live BullMQ queue counts plus the most recent failed-job reasons (up to 5). */
export type BullMqQueueStats = {
  __typename?: 'BullMqQueueStats';
  active: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  delayed: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  queueName: Scalars['String']['output'];
  recentFailedReasons: Array<Scalars['String']['output']>;
};

/** Result of cancel and refund operation */
export type CancelAndRefundResult = {
  __typename?: 'CancelAndRefundResult';
  /** Refund invoice (if refund was processed) */
  refundInvoice?: Maybe<RecurlyInvoice>;
  /** Amount refunded in cents */
  refundedAmountInCents: Scalars['Int']['output'];
  /** Updated subscription */
  subscription: BillingSubscription;
};

/** Options for canceling and refunding a subscription */
export type CancelAndRefundSubscriptionInput = {
  /** CX agent notes (optional) */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Refund type */
  refundType: SubscriptionRefundType;
  /** Subscription UUID to cancel */
  subscriptionId: Scalars['String']['input'];
};

export type CancelDeletionRequestInput = {
  /** Reason for cancellation */
  reason: Scalars['String']['input'];
  /** The UUID of the deletion request to cancel */
  requestId: Scalars['ID']['input'];
};

export type CancelMembershipInput = {
  /** Reason the member selected when canceling. Mirrored onto the Customer.io profile. */
  cancellationReason?: InputMaybe<zendeskCancellationReason>;
  recurlySubscriptionId: Scalars['String']['input'];
};

export type CancelMembershipResult = {
  __typename?: 'CancelMembershipResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CancelOrderLineItemsInput = {
  cancelYearlySubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  lineItemIds: Array<Scalars['ID']['input']>;
  placeOrderOnHold?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancelSupplementSubscriptionInput = {
  recurlySubscriptionId: Scalars['ID']['input'];
};

export type CancelSupplementSubscriptionResult = {
  __typename?: 'CancelSupplementSubscriptionResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CancelThirdPartySubscriptionInput = {
  recurlySubscriptionId: Scalars['String']['input'];
};

export type CancelThirdPartySubscriptionResult = {
  __typename?: 'CancelThirdPartySubscriptionResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/**
 * A candidate location source that was available to the location engine when it chose a report's
 * position. `selected` marks the one used as the dog's location.
 */
export type CandidateLocationSource = {
  __typename?: 'CandidateLocationSource';
  accuracyRadius?: Maybe<Scalars['Float']['output']>;
  /** Distinguishes multiple candidates that share a source: the wifi-lookup provider, a base id, or an SSID. */
  detail?: Maybe<Scalars['String']['output']>;
  position: Position;
  selected: Scalars['Boolean']['output'];
  source: LocationSource;
};

export type CartLineItemInput = {
  lineItemId: Scalars['ID']['input'];
  sku: Scalars['String']['input'];
};

export type CartPurchaseResult = {
  __typename?: 'CartPurchaseResult';
  chargeInvoice?: Maybe<PurchaseResultInvoice>;
  giftCardInvoices: Array<PurchaseResultInvoice>;
  isGWP: Scalars['Boolean']['output'];
  isReturningCustomer: Scalars['Boolean']['output'];
};

export type ChangeLog = {
  __typename?: 'ChangeLog';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: ChangeLogType;
  uuid: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum ChangeLogType {
  ANDROID_APP = 'ANDROID_APP',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  BASE = 'BASE',
  COLLAR = 'COLLAR',
  IOS_APP = 'IOS_APP',
}

export type ChangeLogs = {
  __typename?: 'ChangeLogs';
  changeLogs: Array<ChangeLog>;
  hasNext: Scalars['Boolean']['output'];
};

export type ChangeMembershipPlanEndOfTermInput = {
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  currency?: InputMaybe<Currency>;
  moduleId: Scalars['String']['input'];
  newSku: Scalars['String']['input'];
};

export type ChangeMembershipPlanEndOfTermResult = {
  __typename?: 'ChangeMembershipPlanEndOfTermResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ChargeAccountBySkuInput = {
  accountId: Scalars['ID']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  ecomConfigType?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
  /** Optional price override in cents. When provided, uses this price instead of catalog price. */
  unitAmountInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type ChargeConsignmentAccountInput = {
  /**
   * Unit amount in cents. The line-item subtotal is `quantity * amountInCents`
   * (+ tax). The name is kept (no `unit` prefix) for backwards compatibility with
   * callers that predate `quantity` — at the implicit quantity of 1 the unit
   * amount and the line total are the same value.
   */
  amountInCents: Scalars['Int']['input'];
  consignmentAccountId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  ecomConfigType?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to 1 when omitted, preserving pre-quantity caller behavior. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Recurly item code to charge against; must be one of `adminConsignmentChargeSkus`. */
  sku: Scalars['String']['input'];
  taxExempt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChargeConsignmentAccountResult = {
  __typename?: 'ChargeConsignmentAccountResult';
  error?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<RecurlyInvoice>;
  success: Scalars['Boolean']['output'];
};

export type ChargePreview = {
  __typename?: 'ChargePreview';
  /** Currency code (e.g., USD) */
  currency: Scalars['String']['output'];
  /** Line items from Recurly invoice preview */
  lineItems: Array<PreviewLineItem>;
  /** Product name/description */
  productName: Scalars['String']['output'];
  /** Quantity being charged */
  quantity: Scalars['Int']['output'];
  /** SKU being previewed */
  sku: Scalars['String']['output'];
  /** Tax amount in cents */
  taxInCents: Scalars['Int']['output'];
  /** Total amount to charge in cents (including tax) */
  totalInCents: Scalars['Int']['output'];
  /** Base price per unit in cents (before tax) */
  unitPriceInCents: Scalars['Int']['output'];
};

/** Product available for charging to accounts */
export type ChargeableProduct = {
  __typename?: 'ChargeableProduct';
  /** Product category (e.g., BAND, CHARGING_BASE, MODULE) */
  category: Scalars['String']['output'];
  /** Product display name */
  name: Scalars['String']['output'];
  /** Price in cents (USD) */
  priceInCents: Scalars['Int']['output'];
  /** Product SKU code */
  sku: Scalars['String']['output'];
};

export type ChargingBase = {
  __typename?: 'ChargingBase';
  baseId: Scalars['String']['output'];
  batch?: Maybe<Scalars['String']['output']>;
  /**
   * BLE transmit power level for Bluetooth communication between the base and modules.
   * Integer value maps to BtPowerLevel protobuf enum (0-15).
   * See: @barkinglabs/protos-common base_submission.proto
   * When null, defaults to 15 (ESP_PWR_LVL_P21, +21dBm).
   */
  bleTxPowerLevel?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credentialUpdate?: Maybe<CredentialUpdate>;
  dbId: Scalars['Int']['output'];
  fccId?: Maybe<Scalars['String']['output']>;
  hardwareRevision?: Maybe<Scalars['String']['output']>;
  /** May be false if the system has reason to believe the base's position is no longer accurate */
  hasAccuratePosition: Scalars['Boolean']['output'];
  household?: Maybe<Household>;
  icId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  info: Scalars['JSON']['output'];
  infoLastUpdated: Scalars['DateTime']['output'];
  isInSafeZone: Scalars['Boolean']['output'];
  lastReportedFirmwareVersion?: Maybe<Scalars['String']['output']>;
  macAddress?: Maybe<Scalars['String']['output']>;
  modelId?: Maybe<Scalars['String']['output']>;
  modelImageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  networkName?: Maybe<Scalars['String']['output']>;
  online: Scalars['Boolean']['output'];
  /** Indicative of how often the base is online (doesn't relate to connection to modules etc) */
  onlineQuality: DiagnosticStatus;
  percentOnlineLastNDays: Scalars['Int']['output'];
  places: Array<Place>;
  platform: Platform;
  position?: Maybe<Position>;
  /**
   * Admin only
   *
   * Human readable string like "Series 3 Base"
   */
  readableModelName?: Maybe<Scalars['String']['output']>;
  returnEligibility?: Maybe<RMAPolicyResult>;
  tenancy?: Maybe<Scalars['String']['output']>;
  updateChannel?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  warrantyStatus?: Maybe<RMAPolicyResult>;
  wifiNetwork?: Maybe<WifiNetwork>;
};

export type ChargingBasecredentialUpdateArgs = {
  currentHash?: InputMaybe<Scalars['String']['input']>;
};

export type ChargingBasepercentOnlineLastNDaysArgs = {
  nDays: Scalars['Int']['input'];
};

export type ChargingBasereturnEligibilityArgs = {
  drilldownCode: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
};

export type ChargingBasewarrantyStatusArgs = {
  drilldownCode: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
};

export type ChargingBaseAssignable = {
  __typename?: 'ChargingBaseAssignable';
  assignable: Scalars['Boolean']['output'];
};

export enum CheckFiHandleValidAndAvailableResponse {
  INVALID = 'INVALID',
  IS_TAKEN = 'IS_TAKEN',
  SUCCESS = 'SUCCESS',
}

export type CheckInNewRMAItemInput = {
  condition: RMAItemCondition;
  itemInput: RMAItemInput;
};

export type CheckInRMAInput = {
  id: Scalars['ID']['input'];
  itemUpdates: Array<CheckInRMAItemInput>;
  newItems: Array<CheckInNewRMAItemInput>;
  reasonUpdate?: InputMaybe<CheckInReasonUpdate>;
};

export type CheckInRMAItemInput = {
  condition: RMAItemCondition;
  hardwareDefectCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CheckInReasonUpdate = {
  drilldownCode: Scalars['String']['input'];
  processType: RMAProcessType;
  reasonCode: Scalars['String']['input'];
};

export type CheckInUnknownReturnInput = {
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  drilldownCode: Scalars['String']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceSource?: InputMaybe<InvoiceSource>;
  items: Array<CheckInNewRMAItemInput>;
  purchaseProvenanceCode?: InputMaybe<Scalars['String']['input']>;
  reasonCode: Scalars['String']['input'];
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum ChipCondition {
  DAMAGED = 'DAMAGED',
  DECEASED_PET = 'DECEASED_PET',
  MISSING = 'MISSING',
  WORKING = 'WORKING',
}

export type ChipContactHistoryEntry = ChipContactInfoResponse & {
  __typename?: 'ChipContactHistoryEntry';
  contactInfo: ChipContactInfo;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  dbId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  latest: Scalars['Boolean']['output'];
  rejected: Scalars['Boolean']['output'];
  source: ChipContactHistoryEntrySource;
};

export enum ChipContactHistoryEntrySource {
  FI_NANO = 'FI_NANO',
  RESELLER_API = 'RESELLER_API',
  SHELTERLUV_BACKFILL = 'SHELTERLUV_BACKFILL',
  SHELTERLUV_INCREMENTAL = 'SHELTERLUV_INCREMENTAL',
}

export type ChipContactInfo = {
  __typename?: 'ChipContactInfo';
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  primaryEmail: Scalars['String']['output'];
  primaryPhone?: Maybe<Scalars['String']['output']>;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  secondaryFirstName?: Maybe<Scalars['String']['output']>;
  secondaryLastName?: Maybe<Scalars['String']['output']>;
  secondaryPhone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

/** A chip with information relevant to a ChipReseller. */
export type ChipContactInfoForVerifiedRescue = {
  __typename?: 'ChipContactInfoForVerifiedRescue';
  dbId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  latestContactHistoryEntry?: Maybe<ChipContactHistoryEntry>;
  serialNumber: Scalars['String']['output'];
};

export type ChipContactInfoInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  estimatedAnnualAdoptions?: InputMaybe<Scalars['String']['input']>;
  estimatedMonthlyChipRegistrations?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  primaryEmail: Scalars['String']['input'];
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  secondaryEmail?: InputMaybe<Scalars['String']['input']>;
  secondaryFirstName?: InputMaybe<Scalars['String']['input']>;
  secondaryLastName?: InputMaybe<Scalars['String']['input']>;
  secondaryPhone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type ChipContactInfoResponse = {
  contactInfo: ChipContactInfo;
  dbId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type ChipImportInput = {
  chips: Array<ChipInput>;
  updateOnDuplicate?: InputMaybe<ChipImportUpdateOnDuplicate>;
};

export enum ChipImportUpdateOnDuplicate {
  SERIAL_NUMBER = 'SERIAL_NUMBER',
  SHORT_ID = 'SHORT_ID',
}

export type ChipInput = {
  boxId?: InputMaybe<Scalars['String']['input']>;
  cartonId: Scalars['String']['input'];
  expiresAt: Scalars['DateTime']['input'];
  manufacturedAt: Scalars['DateTime']['input'];
  serialNumber: Scalars['String']['input'];
  shippedAt: Scalars['DateTime']['input'];
  shortId: Scalars['String']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type ChipNewPetInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  breedId?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  dayOfBirth?: InputMaybe<Scalars['Int']['input']>;
  gender: Gender;
  isPurebred?: InputMaybe<Scalars['Boolean']['input']>;
  monthOfBirth?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  species?: InputMaybe<Species>;
  weight: Scalars['Float']['input'];
  yearOfBirth: Scalars['Int']['input'];
};

export type ChipQueryInput = {
  assignedToPet?: InputMaybe<Scalars['Boolean']['input']>;
  assignedToReseller?: InputMaybe<Scalars['Boolean']['input']>;
  boxId?: InputMaybe<Scalars['String']['input']>;
  cartonId?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  statusType?: InputMaybe<ChipStatusType>;
};

/** This step currently does not allow using an email email different from the current logged in user's email address */
export type ChipRegistrationAddEmailInput = {
  chipId: Scalars['ID']['input'];
};

export type ChipRegistrationAddExistingPetInput = {
  chipId: Scalars['ID']['input'];
  petId: Scalars['ID']['input'];
};

export type ChipRegistrationAddNewPetInput = {
  chipId: Scalars['ID']['input'];
  petInfo: ChipNewPetInput;
};

export type ChipRegistrationUpdateContactInput = {
  chipId: Scalars['ID']['input'];
  contactInfo: ChipContactInfoInput;
};

export type ChipReseller = {
  __typename?: 'ChipReseller';
  chips: ResellerChipFeed;
  contactInfo: ChipContactInfo;
  dbId: Scalars['Int']['output'];
  household: Household;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  petInterestTypes?: Maybe<Array<Maybe<ResellerPetInterest>>>;
  preferences: ChipResellerPreferences;
  programInterest?: Maybe<Array<ResellerProgramInterest>>;
  rawShippingAddress?: Maybe<Address>;
  searchChips: ResellerChipFeed;
  shippingAddress?: Maybe<Address>;
  stats: ChipResellerStats;
  status: ResellerStatus;
  taxExemptType?: Maybe<ResellerTaxExemptType>;
  types?: Maybe<Array<Maybe<ResellerType>>>;
  verified: Scalars['Boolean']['output'];
};

export type ChipResellerchipsArgs = {
  chipCondition?: InputMaybe<ChipCondition>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  statusType?: InputMaybe<ChipStatusType>;
};

export type ChipResellersearchChipsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<ChipQueryInput>;
};

export type ChipResellerContactInfoInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type ChipResellerPreferences = {
  __typename?: 'ChipResellerPreferences';
  shelterluv?: Maybe<ShelterluvConfiguration>;
};

export type ChipResellerQueryInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResellerStatus>;
  type?: InputMaybe<ResellerType>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChipResellerShippingAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type ChipResellerStats = {
  __typename?: 'ChipResellerStats';
  chipsRegisteredOnShelterluv: Scalars['Int']['output'];
  chipsRegisteredThisMonth: Scalars['Int']['output'];
  chipsRegisteredThroughFi: Scalars['Int']['output'];
  nonWorkingChips: Scalars['Int']['output'];
  pendingTransfers: Scalars['Int']['output'];
  totalChips: Scalars['Int']['output'];
  totalRegistered: Scalars['Int']['output'];
  totalStock: Scalars['Int']['output'];
};

export enum ChipStatusType {
  /** Chip that is registered to the reseller. TODO: rename this? */
  ACTIVE = 'ACTIVE',
  /** Chip that is pending transfer to a new owner. */
  REVIEW = 'REVIEW',
  /** Chip that is not registered. */
  SHIPPED = 'SHIPPED',
}

export type ChipTransfer = ChipContactInfoResponse & {
  __typename?: 'ChipTransfer';
  /**
   * Whether the current user can resolve this transfer (i.e. it is to them,
   * or they are a reseller and the current owner of the chip.)
   */
  canResolve: Scalars['Boolean']['output'];
  chip: StrangerChip;
  contactInfo: ChipContactInfo;
  createdAt: Scalars['DateTime']['output'];
  dbId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  origin: ChipTransferOrigin;
  pet?: Maybe<StrangerPet>;
  status: ChipTransferStatus;
};

export enum ChipTransferOrigin {
  CURRENT_OWNER = 'CURRENT_OWNER',
  NEW_OWNER = 'NEW_OWNER',
}

export type ChipTransferQueryInput = {
  hasPet?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ChipTransferStatus>;
};

export enum ChipTransferStatus {
  ACCEPTED = 'ACCEPTED',
  CANCELED = 'CANCELED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

export type Circle = {
  __typename?: 'Circle';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  radius: Scalars['Float']['output'];
};

export type ClaimClickToCancelDiscountInput = {
  moduleId: Scalars['String']['input'];
  recurlySubscriptionId: Scalars['String']['input'];
};

export type ClaimClickToCancelDiscountResult = {
  __typename?: 'ClaimClickToCancelDiscountResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ClaimFreeMonthInput = {
  moduleId?: InputMaybe<Scalars['String']['input']>;
};

export type ClaimFreeMonthResult = {
  __typename?: 'ClaimFreeMonthResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ClaimFreeTrialCancelDeterrentInput = {
  moduleId: Scalars['String']['input'];
  recurlySubscriptionId: Scalars['String']['input'];
};

export type ClaimFreeTrialCancelDeterrentResult = {
  __typename?: 'ClaimFreeTrialCancelDeterrentResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ClaimSupplementDiscountInput = {
  recurlySubscriptionId: Scalars['ID']['input'];
};

export type ClaimSupplementDiscountResult = {
  __typename?: 'ClaimSupplementDiscountResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ClaimTwoMonthsHalfOffInput = {
  moduleId?: InputMaybe<Scalars['String']['input']>;
  recurlySubscriptionId: Scalars['String']['input'];
};

export type ClaimTwoMonthsHalfOffResult = {
  __typename?: 'ClaimTwoMonthsHalfOffResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum ClientLocationAccuracy {
  DEFAULT = 'DEFAULT',
  HIGH = 'HIGH',
}

/**
 * Identifies which bespoke, natively-rendered splash experience the client should present.
 * The client owns all visuals/copy for each key; the comm names the experience and supplies the
 * data it renders (e.g. the reached tier and cumulative steps on MobileAppLifetimeTierClientSplash).
 */
export enum ClientSplashKey {
  LIFETIME_TIER = 'LIFETIME_TIER',
  LIFETIME_TIER_INTRO = 'LIFETIME_TIER_INTRO',
}

export type ClientUrls = {
  __typename?: 'ClientUrls';
  helpCenterBaseConnectivityImprovement: Scalars['String']['output'];
  helpCenterBaseTroubleshooting: Scalars['String']['output'];
  helpCenterBatteryImprovement: Scalars['String']['output'];
  helpCenterLteGpsConnectivityInfo: Scalars['String']['output'];
};

export enum CollarLostDogModeState {
  /** LDM is not enabled on the backend. */
  LDM_DISABLED = 'LDM_DISABLED',
  /** LDM is on from the backend perspective, and the collar has sent a report in LDM. */
  LDM_ENABLED = 'LDM_ENABLED',
  /** Collar has been informed of LDM state change, but has not yet sent a report in LDM. */
  LDM_REPORT_PENDING = 'LDM_REPORT_PENDING',
  /** LDM has been toggled on in App or Admin. */
  LDM_REQUESTED = 'LDM_REQUESTED',
  /**
   * LDM has been toggled on in App or Admin, but the collar hasn't acknowledged
   * the request for some time.
   */
  LDM_REQUESTED_LONG_DELAY = 'LDM_REQUESTED_LONG_DELAY',
}

/**
 * Collar online/offline state, finer-grained than the `isOnline` boolean. Staleness while online
 * is reported separately via `isStale`.
 */
export enum CollarOnlineState {
  /** Offline for 30 minutes or less. */
  OFFLINE = 'OFFLINE',
  /** Offline for more than 30 minutes. */
  OFFLINE_EXTENDED = 'OFFLINE_EXTENDED',
  /** Online and reporting within its expected interval. */
  ONLINE = 'ONLINE',
}

export type CollarStatus = OfflineCollarStatus | OnlineCollarStatus;

export enum ColorScheme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}

export type Comment = {
  __typename?: 'Comment';
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Admin-only */
  dbId: Scalars['Int']['output'];
  deleted: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  likeCount: Scalars['Int']['output'];
  /** If the current user has liked this comment. */
  liked: Scalars['Boolean']['output'];
  /** The parent post this comment belongs to. */
  parentPost?: Maybe<CommentParentPost>;
  strangerPet: StrangerPet;
};

export type CommentFeed = {
  __typename?: 'CommentFeed';
  items: Array<Comment>;
  totalCount: Scalars['Int']['output'];
};

export type CommentFeeditemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CommentParentPost = Photo | TextPost | VideoPost;

export type CommunityFeedModifiers = {
  __typename?: 'CommunityFeedModifiers';
  differentLanguageMultiplier: Scalars['Float']['output'];
  engagementCountOffset: Scalars['Float']['output'];
  followerCountOffset: Scalars['Float']['output'];
  sameRegionMultiplier: Scalars['Float']['output'];
  videoPostScoreMultiplier: Scalars['Float']['output'];
};

export type CommunityFeedPostBoost = {
  __typename?: 'CommunityFeedPostBoost';
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  multiplier: Scalars['Float']['output'];
  note?: Maybe<Scalars['String']['output']>;
  setBy: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CommunityFeedScorePreview = {
  __typename?: 'CommunityFeedScorePreview';
  decayValue: Scalars['Float']['output'];
  engagementRatio: Scalars['Float']['output'];
  localeMultiplier: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  videoMultiplier: Scalars['Float']['output'];
};

export type CommunityFeedScorePreviewInput = {
  applyVideoMultiplier: Scalars['Boolean']['input'];
  commentCount: Scalars['Int']['input'];
  decayCurve: Array<DecayCurvePointInput>;
  followerCount: Scalars['Int']['input'];
  isVideoPost: Scalars['Boolean']['input'];
  likeCount: Scalars['Int']['input'];
  posterSameBaseLanguage: Scalars['Boolean']['input'];
  posterSameRegion: Scalars['Boolean']['input'];
  secondsSincePost: Scalars['Float']['input'];
};

export type CommunityFeedTrendingMeta = {
  __typename?: 'CommunityFeedTrendingMeta';
  applyVideoMultiplier: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
};

export type ConcreteDailyRestSummary = DailyRestSummary & {
  __typename?: 'ConcreteDailyRestSummary';
  date: Scalars['DateTime']['output'];
  sleepAmounts: Array<SleepAmount>;
};

/** A detailed breakdown of a pet's sleep period including interruptions. */
export type ConcreteOvernightRestSummary = OvernightRestSummary & {
  __typename?: 'ConcreteOvernightRestSummary';
  /**
   * The date on which sleep commenced (e.g. the pet slept on this night.)
   * This is a DateTime at midnight in the client's timezone that should be used for its date components only.
   */
  date: Scalars['DateTime']['output'];
  interruptions: Array<SleepInterruptionSpan>;
  sleepEnd: Scalars['DateTime']['output'];
  sleepSeconds: Scalars['Int']['output'];
  sleepStart: Scalars['DateTime']['output'];
};

export type ConcreteRestSummaryData = {
  __typename?: 'ConcreteRestSummaryData';
  hourlySleepBars: Array<HourlySleepBar>;
  /** E.g. duration pet was napping, duration pet was sleeping, for this day/week/month. */
  sleepAmounts: Array<SleepAmount>;
};

export type ConfirmSetupIntentResult = {
  __typename?: 'ConfirmSetupIntentResult';
  clientSecret: Scalars['String']['output'];
  setupIntentId: Scalars['String']['output'];
};

export type ConnectedToBase = ConnectionState & {
  __typename?: 'ConnectedToBase';
  chargingBase: ChargingBase;
  date: Scalars['DateTime']['output'];
  isStale: Scalars['Boolean']['output'];
};

export type ConnectedToCellular = ConnectionState & {
  __typename?: 'ConnectedToCellular';
  date: Scalars['DateTime']['output'];
  /**
   * Whether the collar is connected via satellite (e.g. Starlink) rather than
   * a terrestrial cell tower.
   */
  isSatellite?: Maybe<Scalars['Boolean']['output']>;
  isStale: Scalars['Boolean']['output'];
  /**
   * DEPRECATED! This only represents cell strength at an instant in time
   * and is practically useless.
   */
  signalStrengthPercent?: Maybe<Scalars['Int']['output']>;
};

export type ConnectedToUser = ConnectionState & {
  __typename?: 'ConnectedToUser';
  date: Scalars['DateTime']['output'];
  isStale: Scalars['Boolean']['output'];
  user: User;
  userDevice: UserDevice;
};

export type ConnectedToWifi = ConnectionState & {
  __typename?: 'ConnectedToWifi';
  date: Scalars['DateTime']['output'];
  isStale: Scalars['Boolean']['output'];
  ssid: Scalars['String']['output'];
};

export type ConnectedWifiInput = {
  bssid?: InputMaybe<Scalars['String']['input']>;
  ssid?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectionState = {
  date: Scalars['DateTime']['output'];
  /**
   * True when `date` is older than the staleness threshold, indicating the
   * connection state may no longer reflect the device's current connectivity.
   */
  isStale: Scalars['Boolean']['output'];
};

export type ConnectionStateChangeDeviceEvent = DeviceEventBase & {
  __typename?: 'ConnectionStateChangeDeviceEvent';
  date: Scalars['DateTime']['output'];
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  moduleId: Scalars['String']['output'];
  newBackhaulType?: Maybe<ConnectionStateType>;
  newConnectionStateType: ConnectionStateType;
  oldBackhaulType?: Maybe<ConnectionStateType>;
  oldConnectionStateType: ConnectionStateType;
  platform: Scalars['String']['output'];
  prevDate: Scalars['DateTime']['output'];
  prevDuration: Scalars['Float']['output'];
};

export type ConnectionStateChangesResult = {
  __typename?: 'ConnectionStateChangesResult';
  maxResultsReached: Scalars['Boolean']['output'];
  results: Array<ConnectionStateChangeDeviceEvent>;
};

export enum ConnectionStateType {
  BASE = 'BASE',
  CELLULAR = 'CELLULAR',
  MOBILE = 'MOBILE',
  SIDEWALK = 'SIDEWALK',
  UNKNOWN = 'UNKNOWN',
  WEARABLE = 'WEARABLE',
  WIFI = 'WIFI',
}

export enum ConsentAction {
  GRANTED = 'GRANTED',
  WITHDRAWN = 'WITHDRAWN',
}

/** A record of a user's consent action for GDPR compliance. */
export type ConsentRecord = {
  __typename?: 'ConsentRecord';
  action: ConsentAction;
  consentType: ConsentType;
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

/** Current consent status for a specific consent type. */
export type ConsentStatus = {
  __typename?: 'ConsentStatus';
  consentType: ConsentType;
  currentStatus?: Maybe<ConsentAction>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
};

export enum ConsentType {
  COOKIE_ANALYTICS = 'COOKIE_ANALYTICS',
  COOKIE_FUNCTIONAL = 'COOKIE_FUNCTIONAL',
  COOKIE_MARKETING = 'COOKIE_MARKETING',
  COOKIE_SOCIAL = 'COOKIE_SOCIAL',
  DIRECT_MAIL = 'DIRECT_MAIL',
  MARKETING_EMAIL = 'MARKETING_EMAIL',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  PUSH_NOTIFICATIONS = 'PUSH_NOTIFICATIONS',
  SOCIAL_FEATURES = 'SOCIAL_FEATURES',
  STRAVA_SYNC = 'STRAVA_SYNC',
  TERMS_OF_SERVICE = 'TERMS_OF_SERVICE',
}

/**
 * A consignment account represents a business (e.g., boarding facility, small retail store, private dog park)
 * that sells Fi units on consignment. When a consignor sells a unit, they receive a portion of the sale price
 * when the unit is activated.
 */
export type ConsignmentAccount = {
  __typename?: 'ConsignmentAccount';
  /**
   * Last failure message captured by the Avalara submit worker. Non-null with `taxExemptStatus`
   * still NOT_EXEMPT means the worker tried to file the cert but failed — surfaced here so admin
   * can diagnose without grepping logs. Cleared on the next successful submit.
   */
  avalaraLastSubmissionError?: Maybe<Scalars['String']['output']>;
  /** S3 key for the consignment agreement file (if uploaded). Used to generate presigned download URL. */
  consignmentAgreementFileKey?: Maybe<Scalars['String']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dbId: Scalars['Int']['output'];
  fiSalesRepEmail: Scalars['String']['output'];
  /**
   * Whether the account has a payment method stored in Recurly.
   *
   * **Important:** This field queries the Recurly API directly and counts against Recurly's rate limits
   * (5,000 requests per 5 minutes). Each account queried makes one API call.
   *
   * **Usage Guidelines:**
   * - ✅ Safe for individual account queries
   * - ✅ Safe for small lists (< 20 accounts)
   * - ❌ Should NOT be used for list or bulk actions without caching
   * - ⚠️ Future: if needed for bulk operations, implement Redis caching similar to `hasValidBillingInfo`
   */
  hasPaymentMethod: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Live 3-source comparison of this account's tax-exempt state — Fi (stored), Recurly
   * (read at request time), Avalara (read at request time) — plus per-source-disagreement
   * remediation hints. Same rate-limit caveat as `hasPaymentMethod`/`recurlyShippingAddress`:
   * hits Recurly + Avalara directly, so use for individual account inspection only.
   */
  liveTaxExemptCheck: TaxExemptLiveCheck;
  locations: Array<ConsignmentLocation>;
  locationsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  recurlyAccountCode?: Maybe<Scalars['String']['output']>;
  /**
   * Account code to use when creating a Recurly account manually (Customers → New account).
   * Use this exact value as the Recurly account code so we can link the account. After creating
   * the account in Recurly, use "Create Recurly account" in this UI to link it (or create via UI).
   */
  recurlyAccountCodeForLinking: Scalars['String']['output'];
  /**
   * Recurly dashboard URL to open this account. Use this to go to Hosted Pages and copy the Edit Billing Information URL.
   * Null if no Recurly account.
   */
  recurlyAccountDashboardUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Recurly hosted page URL for the partner to add or edit their payment method.
   * Shown in Recurly dashboard as Hosted Pages → Edit Billing Information URL.
   * Null if no Recurly account or account has no hosted login token.
   */
  recurlyEditBillingInfoUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Address currently stored on the linked Recurly account (the field the Avalara submit worker
   * reads as the customer's shipping address). Null if no Recurly account or account has no address.
   *
   * **Important:** Queries Recurly directly — same rate-limit caveat as `hasPaymentMethod`.
   * Use for individual account inspection only.
   */
  recurlyShippingAddress?: Maybe<Address>;
  resaleCertBusinessType?: Maybe<Scalars['String']['output']>;
  resaleCertExemptionReason?: Maybe<ConsignmentExemptionReason>;
  resaleCertExpirationDate?: Maybe<Scalars['String']['output']>;
  resaleCertNumber?: Maybe<Scalars['String']['output']>;
  resaleCertStateOfIssue?: Maybe<Scalars['String']['output']>;
  /** S3 key for the resale certificate file (if registered). Used to generate presigned download URL. */
  resaleCertificateFileKey?: Maybe<Scalars['String']['output']>;
  taxExemptAvalaraConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  taxExemptRecurlySyncedAt?: Maybe<Scalars['DateTime']['output']>;
  taxExemptRevokedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Current tax-exempt status for this consignment partner.
   *
   * Computed from stored milestone timestamps:
   * - NOT_EXEMPT: no Avalara submission or revoked.
   * - PENDING: Avalara submission recorded, Recurly sync not yet done.
   * - EXEMPT: both Avalara confirmed and Recurly updated.
   */
  taxExemptStatus: TaxExemptStatus;
  updatedAt: Scalars['DateTime']['output'];
  vatNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * A SKU that may appear on a consignment order, with the human-readable label
 * from product_sku and whether it should generate a Recurly invoice line. Non-billable
 * SKUs (display materials, shelf strips) ship alongside device orders but aren't charged.
 */
export type ConsignmentAvailableSku = {
  __typename?: 'ConsignmentAvailableSku';
  billable: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  sku: Scalars['String']['output'];
};

/** Preview of account charge pricing for any product type */
export type ConsignmentChargeSku = {
  __typename?: 'ConsignmentChargeSku';
  code: Scalars['String']['output'];
  /**
   * Standard price in cents used to seed the Recurly item and pre-fill the charge form. Null when
   * there is no standard price; the final charge amount is always set via per-purchase override.
   */
  defaultPriceInCents?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
};

export enum ConsignmentExemptionReason {
  AGRICULTURAL = 'AGRICULTURAL',
  CHARITABLE = 'CHARITABLE',
  DIRECT_PAY = 'DIRECT_PAY',
  FEDERAL_GOVERNMENT = 'FEDERAL_GOVERNMENT',
  INDUSTRIAL_PROCESSING = 'INDUSTRIAL_PROCESSING',
  OTHER = 'OTHER',
  RELIGIOUS = 'RELIGIOUS',
  RESALE = 'RESALE',
  STATE_GOVERNMENT = 'STATE_GOVERNMENT',
}

/** A Recurly invoice associated with a consignment account. */
export type ConsignmentInvoiceEntry = {
  __typename?: 'ConsignmentInvoiceEntry';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  dueOn?: Maybe<Scalars['String']['output']>;
  invoiceNumber: Scalars['String']['output'];
  pdfUrl?: Maybe<Scalars['String']['output']>;
  recurlyUrl?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  subtotalInCents: Scalars['Int']['output'];
  taxInCents: Scalars['Int']['output'];
  totalInCents: Scalars['Int']['output'];
};

/**
 * A physical location belonging to a consignment account where Fi units are shipped and sold.
 * One account can have multiple locations (e.g., a chain of pet stores).
 */
export type ConsignmentLocation = {
  __typename?: 'ConsignmentLocation';
  account: ConsignmentAccount;
  accountId: Scalars['ID']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dbId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street1: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  zipcode: Scalars['String']['output'];
};

export enum ConsignmentPartnerDocumentType {
  CONSIGNMENT_AGREEMENT = 'CONSIGNMENT_AGREEMENT',
  RESALE_CERTIFICATE = 'RESALE_CERTIFICATE',
}

/** One row for the consignment account shipment history table. One entry per shipment package (or one per order when no packages yet). */
export type ConsignmentShipmentHistoryEntry = {
  __typename?: 'ConsignmentShipmentHistoryEntry';
  /** Human-readable line items e.g. \"2× Fi Mini (6mo)\". */
  lineItemsSummary: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['ID']['output'];
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type ConsumerStoreCartInput = {
  cartItems: Array<StoreCartItemInput>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  giftShippingAddress?: InputMaybe<GiftShippingAddressInput>;
  /**
   * Originating rescue's GWA program id, set by the store from the resolved offer token. Used to
   * attribute the redemption, since promo codes are shareable across rescues and can't identify one.
   */
  gwaProgramId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Entrypoint attribution for a GWA redemption (e.g. `fi_nano_registration`), set by the store
   * after exchanging a signed nano offer token. Validated server-side; ignored if not a known source.
   */
  gwaSource?: InputMaybe<Scalars['String']['input']>;
  /**
   * Signed GWA entitlement proving the shopper reached a rescue's GWA context via a legitimate entry
   * point. Required for a GWA promo alias to resolve to its rescue-adoption discount.
   */
  gwaToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * Signed GWP entitlement proving the shopper reached a partner's landing page. Required for a GWP
   * partner single-code alias to resolve to its internal coupon.
   */
  gwpToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * The shopper marked the order as a gift at checkout. Only recorded on hardware-first collar
   * line items; ignored for control carts.
   */
  isGift?: InputMaybe<Scalars['Boolean']['input']>;
  marketingEmailsOptedIn?: InputMaybe<Scalars['Boolean']['input']>;
  redeemedGiftCardCode?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  referralSource?: InputMaybe<ReferralSource>;
  shippingCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * Stripe confirmation token for klarna bnpl orders, charged inline at purchase instead of stored
   * first (klarna installments are one-time and can't be saved as reusable billing info). Verified
   * server-side; a klarna token also makes the subscription non-renewing.
   */
  stripeConfirmationToken?: InputMaybe<Scalars['String']['input']>;
  threeDSecureActionResultToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * PDP token from a Verizon product-page visit; resolved server-side to Verizon's hashed user ID
   * and attached to the Recurly subscription.
   */
  verizonPdpToken?: InputMaybe<Scalars['String']['input']>;
};

export type ContactInfo = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ContactInfoWithMeta = {
  __typename?: 'ContactInfoWithMeta';
  associatedUser?: Maybe<StrangerUser>;
  contactInfo: UserContactInfo;
  /** Copy for sending an invitation to this user via SMS. */
  inviteText?: Maybe<Scalars['String']['output']>;
  /** How many Fi users have this contact. */
  knownFiUsers?: Maybe<Scalars['Int']['output']>;
};

export type ContactsForUserInput = {
  /** By default, we exclude contacts that have an account. Setting this option to true would return all contacts. */
  includeContactsWithAccount?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * By default, contacts with no phone number (just email) are included.
   * Setting this to true will only return contacts with phone numbers.
   * Default is true.
   */
  onlyContactsWithPhoneNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
  /** Query for the contacts first/last name */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true, results are sorted first by number of Fi users that know the contact.
   * Defaults is false.
   */
  sortByKnownFiUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Returned by the `contactsForUser` query. Used for referral/invitations. */
export type ContactsForUserResponse = {
  __typename?: 'ContactsForUserResponse';
  contacts: Array<ContactInfoWithMeta>;
  pageInfo: PageInfo;
};

export enum ContainmentFeedbackType {
  SOUND = 'SOUND',
  VIBRATION = 'VIBRATION',
}

/**
 * A ContainmentZone defines a "donut" shaped geographic boundary associated with a Place (Safe Zone)
 * that triggers feedback (sound/vibration) on the collar when a pet enters it.
 */
export type ContainmentZone = {
  __typename?: 'ContainmentZone';
  dbId: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  feedbackTypes: Array<ContainmentFeedbackType>;
  id: Scalars['ID']['output'];
  place: Place;
  /** The shape defining the zone boundary (circle or polygon). */
  shape: ContainmentZoneShape;
};

/**
 * Circle-shaped containment zone boundary defined by center position and radii.
 * Creates a donut shape with inner and outer boundaries.
 */
export type ContainmentZoneCircle = {
  __typename?: 'ContainmentZoneCircle';
  /** Inner radius in meters. Defines the inner boundary of the donut. */
  innerRadius: Scalars['Float']['output'];
  /** Outer radius in meters. Defines the outer boundary of the donut. */
  outerRadius: Scalars['Float']['output'];
  /** Center position of the circle. */
  position: Position;
};

/**
 * Polygon-shaped containment zone boundary defined by GeoJSON.
 * The polygon contains an outer boundary ring and an inner hole ring to create the donut shape.
 */
export type ContainmentZonePolygon = {
  __typename?: 'ContainmentZonePolygon';
  /** GeoJSON Polygon with outer boundary and inner hole rings. */
  boundary: Scalars['JSON']['output'];
};

/** The shape of a containment zone - either a circle or polygon. */
export type ContainmentZoneShape = ContainmentZoneCircle | ContainmentZonePolygon;

export type ConvertFreeTrialInput = {
  /** The Recurly subscription UUID to convert from trial to paid */
  subscriptionId: Scalars['String']['input'];
};

export type ConvertFreeTrialResult = {
  __typename?: 'ConvertFreeTrialResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CopyAllPlacesInput = {
  /** Target test household inputId */
  householdInputId: Scalars['String']['input'];
};

export type CopyFromExistingDataInput = {
  copyAllPlaces?: InputMaybe<CopyAllPlacesInput>;
  /** Provide exactly one of placesByIds or copyAllPlaces (omit both = no places copied). */
  placesByIds?: InputMaybe<CopyPlacesByIdsInput>;
  segmentsByFilter?: InputMaybe<CopySegmentsByFilterInput>;
  /** Provide exactly one of segmentsByIds or segmentsByFilter. */
  segmentsByIds?: InputMaybe<CopySegmentsByIdsInput>;
  /**
   * Source pet to copy data from. Null = random candidate pet.
   * Omit when using segmentsByIds (inferred from segment IDs).
   */
  sourcePetId?: InputMaybe<Scalars['Int']['input']>;
};

export type CopyPlacesByIdsInput = {
  /** Target test household inputId */
  householdInputId: Scalars['String']['input'];
  /** Specific place database IDs (must all be from source household) */
  placeIds: Array<Scalars['Int']['input']>;
};

export type CopySegmentsByFilterInput = {
  /** Whether to also copy pet behavior data (barking, eating, etc.) for the same date range. Defaults to true. */
  copyBehaviorData?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to also copy pet insight data for the same date range. Defaults to true. */
  copyInsightData?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only segments starting before this */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Max segments to copy */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Target test pet inputId */
  petInputId: Scalars['String']['input'];
  /** Shift timestamps so the latest segment starts at this time. Supports nunjucks: {{ now() }} */
  relativeTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only segments starting after this */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CopySegmentsByIdsInput = {
  /** Whether to also copy pet behavior data (barking, eating, etc.) for the same date range. Defaults to true. */
  copyBehaviorData?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to also copy pet insight data for the same date range. Defaults to true. */
  copyInsightData?: InputMaybe<Scalars['Boolean']['input']>;
  /** Target test pet inputId */
  petInputId: Scalars['String']['input'];
  /** Shift timestamps so the latest segment starts at this time. Supports nunjucks: {{ now() }} */
  relativeTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Specific segment database IDs (must all be from same pet) */
  segmentIds: Array<Scalars['Int']['input']>;
};

export type Coupon = {
  __typename?: 'Coupon';
  expiresAt: Scalars['DateTime']['output'];
  /**
   * Whether hardwarePercentOff only applies to members who own a tracker on Series 3 or older
   * hardware. Everyone else gets no hardware discount from this code.
   */
  hardwareMemberUpgradeOnly: Scalars['Boolean']['output'];
  /**
   * Percent off the first tracker in a hardware-first cart that carries this code; null when the code
   * is not a hardware promo.
   */
  hardwarePercentOff?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CouponInput = {
  code: Scalars['ID']['input'];
};

/** Represents a coupon that has been redeemed on an account */
export type CouponRedemption = {
  __typename?: 'CouponRedemption';
  /** The coupon code that was redeemed */
  couponCode: Scalars['String']['output'];
  /** When the coupon was redeemed */
  createdAt: Scalars['DateTime']['output'];
  /** Currency of the discount */
  currency?: Maybe<Scalars['String']['output']>;
  /** For fixed discounts, the amount in the account currency */
  discountAmountInCents?: Maybe<Scalars['Int']['output']>;
  /** For percent discounts, the percentage off */
  discountPercent?: Maybe<Scalars['Float']['output']>;
  /** Discount type: percent, fixed, or free_trial */
  discountType?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this redemption */
  id: Scalars['ID']['output'];
  /** Current state of the redemption (active, inactive) */
  state: Scalars['String']['output'];
  /** The subscription UUID this coupon is applied to (null if account-level) */
  subscriptionUuid?: Maybe<Scalars['String']['output']>;
  /** When the coupon redemption was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CouponRedirectInput = {
  bannerText?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  isPartner?: InputMaybe<Scalars['Boolean']['input']>;
  redirectUri: Scalars['String']['input'];
};

export type CreateBillingAccountInput = {
  address?: InputMaybe<AddressInput>;
};

export type CreateCertGenJobResult = {
  __typename?: 'CreateCertGenJobResult';
  jobId?: Maybe<Scalars['String']['output']>;
  jobName?: Maybe<Scalars['String']['output']>;
};

export type CreateChangeLogInput = {
  description: Scalars['String']['input'];
  type: ChangeLogType;
  version: Scalars['String']['input'];
};

export type CreateConsignmentAccountInput = {
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  fiSalesRepEmail: Scalars['String']['input'];
  name: Scalars['String']['input'];
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConsignmentLocationInput = {
  accountId: Scalars['ID']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  recipientName: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zipcode: Scalars['String']['input'];
};

export type CreateConsignmentRecurlyAccountInput = {
  billingAccountInput: BillingAccountInput;
  consignmentAccountId: Scalars['ID']['input'];
  ecomConfigType?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for creating a containment zone with donut shape.
 * Either circle fields (position + radii) or polygon field (boundary) must be provided, not both.
 */
export type CreateContainmentZoneInput = {
  /**
   * GeoJSON Polygon for POLYGON zones. Must contain outer boundary and inner hole rings.
   * Required for POLYGON, must be null for CIRCLE.
   */
  boundary?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Inner radius (meters) for CIRCLE zones. Defines the inner boundary of the donut.
   * Required for CIRCLE, must be null for POLYGON.
   */
  innerRadius?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Outer radius (meters) for CIRCLE zones. Defines the outer boundary of the donut.
   * Required for CIRCLE, must be null for POLYGON.
   */
  outerRadius?: InputMaybe<Scalars['Float']['input']>;
  /** Center position for CIRCLE zones. Required for CIRCLE, must be null for POLYGON. */
  position?: InputMaybe<PositionInput>;
  /** Circle or polygon containment zone. */
  type: PlaceType;
};

export type CreateCouponInput = {
  expiresAt: Scalars['DateTime']['input'];
  /**
   * Restricts hardwarePercentOff to members who own a tracker on Series 3 or older hardware. Defaults
   * to false. On a recreate, omitting this keeps the expiring row's setting.
   */
  hardwareMemberUpgradeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Percent off the first tracker in a hardware-first cart (1-100). Omit for the default weekly promo
   * percent; pass null for a code that must not discount hardware (email and one-off codes).
   */
  hardwarePercentOff?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CreateDeviceActuationInput = {
  actuationId: Scalars['Int']['input'];
  expiration: Scalars['DateTime']['input'];
  moduleId: Scalars['String']['input'];
  type: DeviceActuationType;
};

export type CreateDeviceInput = {
  imei?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  moduleId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['String']['input'];
};

export type CreateDynamicEnumMemberInput = {
  code: Scalars['String']['input'];
  kind: DynamicEnumKind;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateEcommerceImageListInput = {
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  images: Array<EcommerceImageInput>;
  internalName: Scalars['String']['input'];
  /**
   * The product ID this image list applies to.
   * Valid values: 'smart-collar-mini', 'smart-collar-v3b', 'smart-collar-ultra'
   */
  productId: Scalars['String']['input'];
};

export type CreateFiNewsNotificationInput = {
  featureImageUrl: Scalars['String']['input'];
  message: Scalars['String']['input'];
  publishedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateFirmwareChannelInput = {
  channelName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['String']['input'];
  releaseClass: FirmwareReleaseClass;
};

export type CreateGingrBoardingFacilityInput = {
  apiKey: Scalars['String']['input'];
  apiSubdomain: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  owner: BoardingFacilityOwnerInput;
  /**
   * The timezone for the boarding facility (e.g., "America/New_York").
   * Defaults to "America/New_York" if not provided.
   */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGwpPartnerProgramInput = {
  /** Whether the partner landing page applies the code automatically on arrival. */
  autoApply: Scalars['Boolean']['input'];
  /**
   * Currency-keyed fixed discounts in cents, mirroring product pricingInCents — e.g.
   * {"USD": 9900, "CAD": 14900}. Must include USD; the code only applies to purchases in the
   * listed currencies. Keys are validated server-side against the supported currency set.
   */
  discountsInCents: Scalars['JSON']['input'];
  /** Single shopper-facing code (e.g. METLIFE99). Stored uppercase; matched case-insensitively. */
  promoCode: Scalars['String']['input'];
  /** URL slug of the partner landing page on the storefront (/partners/:slug). */
  slug: Scalars['String']['input'];
};

export type CreateHouseholdInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  socialOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateImageFromUrlInput = {
  url: Scalars['String']['input'];
};

export type CreateImageFromUrlResult = {
  __typename?: 'CreateImageFromUrlResult';
  image: Image;
  photoId: Scalars['ID']['output'];
};

export type CreateInPersonEventInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  location: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  startingInventory: Scalars['JSON']['input'];
};

/** Input for creating a manual subscription via CX admin */
export type CreateManualSubscriptionInput = {
  /** User account code (Recurly account ID) */
  accountCode: Scalars['String']['input'];
  /** Optional coupon code to apply to the subscription purchase */
  couponCode?: InputMaybe<Scalars['String']['input']>;
  /** Currency for the subscription (defaults to USD if not provided) */
  currency?: InputMaybe<Currency>;
  /** Device module ID to assign subscription to (required) */
  moduleId: Scalars['String']['input'];
  /** CX agent notes (optional, added to customer record) */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Override price in cents (optional, uses plan default if not provided) */
  overridePriceInCents?: InputMaybe<Scalars['Int']['input']>;
  /** Subscription plan SKU */
  sku: Scalars['String']['input'];
  /**
   * Optional future start date for the subscription. If set, the subscription will begin
   * on this date and the customer will be charged on this date. If omitted, the subscription
   * starts and charges immediately (default behavior).
   */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Waive the activation/setup fee (default: false) */
  waiveActivationFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Waive the free trial period and charge immediately (default: false) */
  waiveTrial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateMobileAppBannerInput = {
  backgroundColorHex: Scalars['HexColorCode']['input'];
  borderGradient?: InputMaybe<MobileAppBannerBorderGradientInput>;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  darkModeBackgroundColorHex?: InputMaybe<Scalars['HexColorCode']['input']>;
  darkModeForegroundColorHex?: InputMaybe<Scalars['HexColorCode']['input']>;
  description: Scalars['String']['input'];
  destinationUrl: Scalars['String']['input'];
  dismissOnTap?: Scalars['Boolean']['input'];
  dismissible?: Scalars['Boolean']['input'];
  dismissibleAfterSeconds?: InputMaybe<Scalars['Int']['input']>;
  foregroundColorHex?: InputMaybe<Scalars['HexColorCode']['input']>;
  internalName: Scalars['String']['input'];
  leadingImage?: InputMaybe<MobileAppBannerImageInput>;
  title: Scalars['String']['input'];
};

export type CreateMobileAppBlockerScreenBottomSheetInput = {
  buttons: Array<CreateMobileAppBottomSheetButtonInput>;
  description: Scalars['String']['input'];
  image?: InputMaybe<CreateMobileAppBottomSheetImageInput>;
  title: Scalars['String']['input'];
};

export type CreateMobileAppBlockerScreenButtonInput = {
  destinationUrl?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type CreateMobileAppBlockerScreenInput = {
  bottomSheet: CreateMobileAppBlockerScreenBottomSheetInput;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  internalName: Scalars['String']['input'];
  pages: Array<CreateMobileAppBlockerScreenPageInput>;
};

export type CreateMobileAppBlockerScreenPageInput = {
  button: CreateMobileAppBlockerScreenButtonInput;
  description: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  secondaryButton?: InputMaybe<CreateMobileAppBlockerScreenButtonInput>;
  title: Scalars['String']['input'];
};

export type CreateMobileAppBottomSheetButtonInput = {
  backgroundColorHex?: InputMaybe<Scalars['HexColorCode']['input']>;
  destinationUrl: Scalars['String']['input'];
  text: Scalars['String']['input'];
  type: MobileAppBottomSheetButtonType;
};

/**
 * One page of a bottom sheet. Every part is optional on its own — an image-only or copy-only card
 * is fine — but a card has to show something, so one of image, title, description or buttons must
 * be present.
 */
export type CreateMobileAppBottomSheetCardInput = {
  buttons: Array<CreateMobileAppBottomSheetButtonInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<CreateMobileAppBottomSheetImageInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMobileAppBottomSheetImageInput = {
  imageUrl: Scalars['String']['input'];
  type: MobileAppBottomSheetImageType;
};

export type CreateMobileAppBottomSheetInput = {
  /**
   * The sheet's content, in the order a reader pages through it. One card is a plain sheet; two or
   * more make a carousel, which needs an app version that can render it, so target it accordingly.
   */
  cards: Array<CreateMobileAppBottomSheetCardInput>;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  internalName: Scalars['String']['input'];
};

export type CreateMobileAppClientSplashInput = {
  clientSplashKey: ClientSplashKey;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  internalName: Scalars['String']['input'];
};

export type CreateMobileAppDiscoverItemInput = {
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  description: Scalars['String']['input'];
  destinationUrl: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  internalName: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateMobileAppPermissionBlockerScreenInput = {
  bottomSheet: CreateMobileAppBlockerScreenBottomSheetInput;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  dismissable: Scalars['Boolean']['input'];
  internalName: Scalars['String']['input'];
  pages: Array<CreateMobileAppBlockerScreenPageInput>;
  permissionType: Scalars['String']['input'];
};

export type CreateMobileAppSplashScreenButtonInput = {
  destinationUrl?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type CreateMobileAppSplashScreenInput = {
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  internalName: Scalars['String']['input'];
  pages: Array<CreateMobileAppSplashScreenPageInput>;
};

export type CreateMobileAppSplashScreenPageInput = {
  button: CreateMobileAppSplashScreenButtonInput;
  description: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateNewHealthGptChatThreadInput = {
  petId: Scalars['ID']['input'];
};

export type CreatePackInput = {
  fiHandle: Scalars['String']['input'];
  isPrivate: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  petId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatePetInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  breedId?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  dayOfBirth?: InputMaybe<Scalars['Int']['input']>;
  gender: Gender;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  isPurebred: Scalars['Boolean']['input'];
  monthOfBirth?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  newHousehold?: InputMaybe<CreateHouseholdInput>;
  species?: InputMaybe<Species>;
  weight: Scalars['Float']['input'];
  yearOfBirth: Scalars['Int']['input'];
};

export type CreatePlaceInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  /** Should only be set for polygon safe zones. */
  boundary?: InputMaybe<Scalars['JSON']['input']>;
  coordinates?: InputMaybe<Array<PositionInput>>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  ignoreIfAlreadyExists?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<PositionInput>;
  /** If provided, creates this place as a Quick Zone with the specified TTL. */
  quickZone?: InputMaybe<CreateQuickZoneInput>;
  /** Should only be set for circle safe zones. */
  radius?: InputMaybe<Scalars['Float']['input']>;
  /** Optional containment zone for sound feedback to create with this place. */
  soundZone?: InputMaybe<CreateContainmentZoneInput>;
  /** Circle or polygon safe zone. */
  type?: InputMaybe<PlaceType>;
  /** Optional containment zone for vibration feedback to create with this place. */
  vibrationZone?: InputMaybe<CreateContainmentZoneInput>;
};

export type CreatePromotionInput = {
  internalName: Scalars['String']['input'];
};

export type CreatePurchaseInput = {
  coupons: Array<CouponInput>;
  inPersonEventUuid?: InputMaybe<Scalars['String']['input']>;
  isRescueOrganizationPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  lineItems: Array<LineItemInput>;
  redeemGiftCard?: InputMaybe<RedeemGiftCardInput>;
  referral?: InputMaybe<ReferralInput>;
  shippingOption?: InputMaybe<ShippingOptionInput>;
};

/** Quick Zone options for createPlace. When provided, the place is created as a temporary Quick Zone. */
export type CreateQuickZoneInput = {
  /** Time-to-live in seconds for this Quick Zone. */
  ttlSeconds: Scalars['Int']['input'];
};

export type CreateRMAInput = {
  creationNotes?: InputMaybe<Scalars['String']['input']>;
  customerEmail: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  drilldownCode: Scalars['String']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceSource?: InputMaybe<InvoiceSource>;
  items: Array<RMAItemInput>;
  /** Agent made a policy exception to create the RMA. We trust the frontend in this case. */
  madePolicyException?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Originating order id. Required for RMAs that cannot be linked via a Recurly invoice
   * (e.g. rescue-obtained devices) — in that case it is used to resolve the customer.
   * When a Recurly invoice is supplied, the order is also derived from the invoice and
   * any orderId passed here must match (otherwise the request is rejected).
   */
  orderId?: InputMaybe<Scalars['ID']['input']>;
  policyExceptionReason?: InputMaybe<Scalars['String']['input']>;
  processType: RMAProcessType;
  purchaseProvenanceCode: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
  replacementProductAudits: Array<ReplacementProductAudit>;
  replacementProducts: Array<ReplacementProductInput>;
  shippingAddress?: InputMaybe<AddressInput>;
  tags?: InputMaybe<Array<RMATag>>;
  /**
   * Optional override for the user the RMA is assigned to. When set, replaces the user that
   * would otherwise be derived from the order (or Recurly invoice). Used by admin Returns app
   * for stale-household rescue cases — when a rescue-channel order matches but the device's
   * pet has been adopted out, the RMA should be assigned to the new pet owner instead of the
   * rescue org user that placed the original order.
   */
  userId?: InputMaybe<Scalars['ID']['input']>;
  zendeskNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateResellerOrganizationApiKeyInput = {
  name: Scalars['String']['input'];
  rateLimitReqPerMin: Scalars['Int']['input'];
  resellerId: Scalars['ID']['input'];
};

export type CreateResellerOrganizationApiKeyResult = {
  __typename?: 'CreateResellerOrganizationApiKeyResult';
  apiKey: ResellerOrganizationApiKey;
  plaintextKey: Scalars['String']['output'];
};

export type CreateTestChargingBaseInput = {
  householdInputId?: InputMaybe<Scalars['String']['input']>;
  inputId: Scalars['String']['input'];
  platformId: Scalars['String']['input'];
};

export type CreateTestDataDailyActivitySummaryInput = {
  date: Scalars['DateTime']['input'];
  stepCount?: InputMaybe<Scalars['Int']['input']>;
  stepGoal?: InputMaybe<Scalars['Int']['input']>;
  strainScoreEndOfDay?: InputMaybe<Scalars['Float']['input']>;
  strainStoreDailyAverage?: InputMaybe<Scalars['Float']['input']>;
  totalDistanceMeters?: InputMaybe<Scalars['Float']['input']>;
  tz?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTestDataInput = {
  bases?: InputMaybe<Array<CreateTestChargingBaseInput>>;
  copyFrom?: InputMaybe<CopyFromExistingDataInput>;
  devices?: InputMaybe<Array<CreateTestDeviceInput>>;
  generateActivity?: InputMaybe<GenerateActivityDataInput>;
  households?: InputMaybe<Array<CreateTestHouseholdInput>>;
  pets?: InputMaybe<Array<CreateTestPetInput>>;
  userHouseholds?: InputMaybe<Array<CreateTestUserHouseholdInput>>;
  users?: InputMaybe<Array<CreateTestUserInput>>;
};

export type CreateTestDataResult = {
  __typename?: 'CreateTestDataResult';
  bases: Array<ChargingBase>;
  devices: Array<Device>;
  households: Array<Household>;
  pets: Array<Pet>;
  users: Array<User>;
};

export type CreateTestDeviceInput = {
  hasSubscriptionOverride?: InputMaybe<Scalars['Boolean']['input']>;
  inputId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  platformId: Scalars['String']['input'];
  updateChannel: Scalars['String']['input'];
};

export type CreateTestHouseholdInput = {
  inputId: Scalars['String']['input'];
  socialOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional WiFi network to add to the household's credential pack.
   * Creates a CredentialPack with the given network so the app shows a WiFi endpoint.
   */
  wifiNetwork?: InputMaybe<CreateTestWifiNetworkInput>;
};

export type CreateTestPetInput = {
  breedId?: InputMaybe<Scalars['ID']['input']>;
  dailyActivitySummaries?: InputMaybe<Array<CreateTestDataDailyActivitySummaryInput>>;
  dayOfBirth?: InputMaybe<Scalars['Int']['input']>;
  deviceInputId?: InputMaybe<Scalars['String']['input']>;
  gender: Gender;
  householdInputId: Scalars['String']['input'];
  inputId: Scalars['String']['input'];
  monthOfBirth?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  species?: InputMaybe<Species>;
  weight: Scalars['Float']['input'];
  yearOfBirth: Scalars['Int']['input'];
};

export type CreateTestUserBillingAccountInput = {
  address: AddressInput;
  purchase?: InputMaybe<ConsumerStoreCartInput>;
};

export type CreateTestUserEmailInput = {
  email: Scalars['String']['input'];
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateTestUserHouseholdInput = {
  householdInputId: Scalars['String']['input'];
  role: UserHouseholdRole;
  userInputId: Scalars['String']['input'];
};

export type CreateTestUserInput = {
  billingAccount?: InputMaybe<CreateTestUserBillingAccountInput>;
  firstName: Scalars['String']['input'];
  inputId: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  primaryEmail: CreateTestUserEmailInput;
};

export type CreateTestWifiNetworkInput = {
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  position: PositionInput;
  psk?: InputMaybe<Scalars['String']['input']>;
  ssid: Scalars['String']['input'];
};

export type CreateTextPostInput = {
  /** Users can only specific pre-defined styles (ie. text/background). */
  styleId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type CreateUserForBoardingFacilityInput = {
  boardingFacilityId: Scalars['ID']['input'];
  householdRole: UserHouseholdRole;
  user: BoardingFacilityStaffUserInput;
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  nanoChipRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  /** If null, the user will have to reset their password via email */
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  tenancy?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVideoPostInput = {
  aspectRatio: AspectRatioInput;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** When true, the post is shadowbanned: hidden from other users but still visible to the poster. */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  includesAudio?: InputMaybe<Scalars['Boolean']['input']>;
  /** The same key returned when pre-signed upload URL was fetched */
  key: Scalars['String']['input'];
  /** @deprecated Use aspectRatio */
  orientation?: InputMaybe<VideoOrientation>;
};

export type CreateZendeskCancellationTicketInput = {
  /** Optional additional text to include in the ticket description. */
  additionalText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason: zendeskCancellationReason;
  recurlySubscriptionId: Scalars['String']['input'];
};

export type CreateZendeskReplacementTicketInput = {
  recurlySubscriptionId: Scalars['String']['input'];
  /** Free form text explaining reason for requesting replacement. Included in the ticket description. */
  replacementReason: Scalars['String']['input'];
};

export type CreateZendeskTicketResult = {
  __typename?: 'CreateZendeskTicketResult';
  ticketCreated?: Maybe<Scalars['Boolean']['output']>;
  ticketUrl?: Maybe<Scalars['String']['output']>;
};

export type CreateZendeskTroubleshootingTicketInput = {
  /** Optional free form text explaining reason for troubleshooting. Included in the ticket description. */
  additionalText?: InputMaybe<Scalars['String']['input']>;
  recurlySubscriptionId: Scalars['String']['input'];
  troubleshootingReason: zendeskCancellationReason;
};

export type CredentialUpdate = {
  __typename?: 'CredentialUpdate';
  encryptedCredentials: Scalars['Binary']['output'];
  hash: Scalars['String']['output'];
};

export enum Currency {
  CAD = 'CAD',
  CHF = 'CHF',
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  ISK = 'ISK',
  NOK = 'NOK',
  RON = 'RON',
  SEK = 'SEK',
  TRY = 'TRY',
  USD = 'USD',
}

export type CustomerSessionResult = {
  __typename?: 'CustomerSessionResult';
  clientSecret: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
};

/**
 * Input for querying CX billing audit events.
 * At least one entity identifier (accountCode, invoiceNumber, or subscriptionId) is required.
 */
export type CxBillingAuditInput = {
  /** At least one entity identifier is required */
  accountCode?: InputMaybe<Scalars['String']['input']>;
  actionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  initiatedByEmail?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Optional filters */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type CxBillingAuditResult = {
  __typename?: 'CxBillingAuditResult';
  events: Array<AuditLogEvent>;
  hasMore: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type CxPendingAction = {
  __typename?: 'CxPendingAction';
  category: Scalars['String']['output'];
  details?: Maybe<Scalars['String']['output']>;
};

export type DailyRestSummary = {
  date: Scalars['DateTime']['output'];
};

export type DailyStepSummary = {
  __typename?: 'DailyStepSummary';
  date: Scalars['DateTime']['output'];
  stepGoal: Scalars['Int']['output'];
  totalSteps: Scalars['Int']['output'];
};

/** DEPRECATED: Use activity summaries instead. */
export type DailySummary = {
  __typename?: 'DailySummary';
  activityGoal: ActivityGoal;
  activityIntensities: Array<ActivityIntensity>;
  end: Scalars['DateTime']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  start: Scalars['DateTime']['output'];
  totalSteps: Scalars['Int']['output'];
};

/** DEPRECATED: Use activity summaries instead. */
export type DailySummaryactivityIntensitiesArgs = {
  stride?: InputMaybe<Scalars['Int']['input']>;
};

/** DEPRECATED: Use activity summaries instead. */
export type DailySummaryFeed = {
  __typename?: 'DailySummaryFeed';
  dailySummaries: Array<DailySummary>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/** Result of a GDPR data export request. */
export type DataExportRequestResult = {
  __typename?: 'DataExportRequestResult';
  message: Scalars['String']['output'];
  requestId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DateRange = {
  __typename?: 'DateRange';
  endDate: Scalars['DateTime']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type DateRangeInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type DecagonChatConfiguration = {
  __typename?: 'DecagonChatConfiguration';
  epoch?: Maybe<Scalars['Int']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type DecagonWidgetAuth = {
  __typename?: 'DecagonWidgetAuth';
  epoch: Scalars['Int']['output'];
  signature: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type DecayCurvePoint = {
  __typename?: 'DecayCurvePoint';
  breakpoint: Scalars['Float']['output'];
  intercept: Scalars['Float']['output'];
  slope: Scalars['Float']['output'];
};

export type DecayCurvePointInput = {
  breakpoint: Scalars['Float']['input'];
  intercept: Scalars['Float']['input'];
  slope: Scalars['Float']['input'];
};

export type DeleteFirmwareChannelInput = {
  channelName: Scalars['String']['input'];
  platform: Scalars['String']['input'];
};

/** Input for filtering deletion requests. */
export type DeletionRequestFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<DeletionRequestStatus>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export enum DeletionRequestSource {
  ADMIN_REQUEST = 'ADMIN_REQUEST',
  DSAR_REQUEST = 'DSAR_REQUEST',
  META_CALLBACK = 'META_CALLBACK',
  USER_REQUEST = 'USER_REQUEST',
}

export enum DeletionRequestStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
}

/** Result from attempting to delete user data from a third-party service. */
export type DeletionServiceResult = {
  __typename?: 'DeletionServiceResult';
  error?: Maybe<Scalars['String']['output']>;
  service: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  timestamp: Scalars['DateTime']['output'];
};

/**
 * Represents an activity type that has been detected from a phone.
 * (Android and iOS both expose APIs to get this.)
 */
export enum DetectedActivityType {
  AUTOMOTIVE = 'AUTOMOTIVE',
  UNKNOWN = 'UNKNOWN',
  WALKING = 'WALKING',
}

export type Device = {
  __typename?: 'Device';
  actuationConfiguration: DeviceActuationConfiguration;
  adminRecentGPSTests: AdminRecentGPSTests;
  /** @deprecated Use Query.adminMergedTimeline instead */
  adminTimeline: AdminTimeline;
  /** Admin only */
  autoAddUserToHousehold?: Maybe<User>;
  availableLedColors: Array<LedColor>;
  /**
   * Report cadences the user can pick from for `operationParams.normalModeReportIntervalSeconds`.
   * Empty when the cadence isn't user-controllable for this device — clients should hide the picker.
   * "Smart" isn't in the list: it's the absence of a pick (a null `normalModeReportIntervalSeconds`).
   */
  availableNormalModeReportIntervals: Array<NormalModeReportIntervalOption>;
  /** Admin only. Whether the device reported valid AWS Sidewalk manufacturing data. */
  awsSidewalkMfgDataValid?: Maybe<Scalars['Boolean']['output']>;
  batch?: Maybe<Scalars['String']['output']>;
  bluetoothAddress: Scalars['String']['output'];
  canCancel: Scalars['Boolean']['output'];
  /** Date when a restricted subscription can be cancelled, otherwise null */
  canCancelDate?: Maybe<Scalars['DateTime']['output']>;
  capabilities: Array<ModuleCapability>;
  carrier?: Maybe<Scalars['String']['output']>;
  /** Admin only (Note: this query makes a request to a 3rd-party service and can be slow) */
  carrierDetails?: Maybe<Scalars['JSON']['output']>;
  /** Admin only (Note: this query makes a request to a 3rd-party service and can be slow) */
  carrierSessionInfo?: Maybe<Scalars['JSON']['output']>;
  /** Admin only (Note: this query makes a request to a 3rd-party service and can be slow) */
  carrierUsage?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credentialUpdate?: Maybe<CredentialUpdate>;
  currentCollarModel?: Maybe<Scalars['String']['output']>;
  currentCollarModelLongName?: Maybe<Scalars['String']['output']>;
  /**
   * The current rest segment type for this device's pet (e.g. ACTIVE, RESTING, OFF_DOG, OFFLINE).
   * Returns null if the device has no pet.
   */
  currentRestSegmentType?: Maybe<RestSegmentType>;
  /** Whether the device has a pending action with CX, e.g. a cancellation request */
  cxPendingAction?: Maybe<CxPendingAction>;
  /** Whether the device can receive CXD5610 (Sony GNSS) OTA updates */
  cxdUpdateEligible: Scalars['Boolean']['output'];
  dbId: Scalars['Int']['output'];
  /** Admin only */
  deviceResponseOverride?: Maybe<DeviceResponseOverride>;
  diagnostics?: Maybe<DeviceDiagnostics>;
  /**
   * Whether this device has been explicitly disabled by the owner for the pet it is currently
   * assigned to. While disabled, this device's reports are dropped from user-facing queries,
   * and — if it is the pet's secondary — the primary device's reports are not suppressed in
   * favor of it. Null when this device is not assigned to a pet. The flag is per-(pet, device)
   * and auto-expires; see the `setDeviceDisabled` mutation.
   */
  disabledForPet?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Admin only. Manual override forcing this device onto a specific eUICC SIM profile on activation,
   * taking precedence over the automatic (model, point-of-sale country) mapping. Null when unset.
   */
  euiccServiceProviderOverride?: Maybe<EuiccServiceProvider>;
  fccId?: Maybe<Scalars['String']['output']>;
  /**
   * Admin / customer-support only. The GN build manifest published with this collar's firmware release, listing the
   * peripheral firmware versions (da16200, nrf91, cxd5610, ...) that build pins. Null when no
   * manifest was published for the reported version.
   */
  firmwareBuildManifest?: Maybe<Scalars['JSON']['output']>;
  firmwareUpdate?: Maybe<FirmwareUpdate>;
  /** Whether the device can receive firmware updates */
  firmwareUpdateEligible: Scalars['Boolean']['output'];
  /** Admin only. Null when the device did not ship on a hardware-first order. */
  hardwareFirst?: Maybe<DeviceHardwareFirstInfo>;
  hardwareRevision?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use subscriptionAccessType */
  hasActiveSubscription: Scalars['Boolean']['output'];
  /** Month-to-Month upgrade promotion */
  hasClaimedFreeMonthsDuringMonthlyUpgrade?: Maybe<Scalars['Boolean']['output']>;
  hasSubscriptionOverride: Scalars['Boolean']['output'];
  /**
   * When this device's pet first had activity/health data recorded, i.e. when health tracking actually
   * began. Distinct from createdAt (device provisioning) and subscription.activatedAt (purchase date).
   * Null when the pet has no activity data yet.
   */
  healthTrackingStartedAt?: Maybe<Scalars['DateTime']['output']>;
  icId?: Maybe<Scalars['String']['output']>;
  iccid?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imei?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use specific fields (or add new ones if needed) */
  info: Scalars['JSON']['output'];
  infoLastUpdated: Scalars['DateTime']['output'];
  /** Admin only (Note: queries Databricks for this data) */
  inventoryData?: Maybe<Scalars['JSON']['output']>;
  /** Rescues: auto set to true when creating new adoption transfer */
  isAdoptionCollar?: Maybe<Scalars['Boolean']['output']>;
  /** Admin only */
  isBlocked: Scalars['Boolean']['output'];
  /** Admin only */
  isRefurbished: Scalars['Boolean']['output'];
  /** Whether the device can use the Search Party feature for publicly sharing live location */
  isSearchPartyEligible: Scalars['Boolean']['output'];
  /** The serial number for a charging base that was inside the same kit as the module */
  kitChargingBaseSerialNumber?: Maybe<Scalars['String']['output']>;
  lastConnectionState: ConnectionState;
  lastLocation?: Maybe<Location>;
  lastLocationReport?: Maybe<LocationReport>;
  lastReportTimestampsBySource: Scalars['JSON']['output'];
  lastReportedFirmwareVersion?: Maybe<Scalars['String']['output']>;
  ledColor: LedColor;
  locationReportsByDate: Array<LocationReport>;
  macAddress?: Maybe<Scalars['String']['output']>;
  modelIconUrl: Scalars['String']['output'];
  modelId?: Maybe<Scalars['String']['output']>;
  modelImageUrl: Scalars['String']['output'];
  moduleId: Scalars['String']['output'];
  /** Most recent actuation status triggered for this device */
  mostRecentActuationStatus?: Maybe<DeviceActuation>;
  /**
   * Date by which we expect a location report. If this date is in the future, it means
   * we have an accurate location for the module.
   */
  nextLocationUpdateExpectedBy?: Maybe<Scalars['DateTime']['output']>;
  /** Description of when the subscription renews, e.g., "Renews 5/17/28" or "Renews indefinitely" */
  nextRenewalDateDescription?: Maybe<Scalars['String']['output']>;
  /**
   * Date by which we next expect any report. If this date is in the future, it means
   * the module is online.
   */
  nextReportExpectedBy?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The cadence currently set on this device. Null means "smart" — no pick, server-computed cadence —
   * and is also what an unrecognized stored value resolves to. Always null when
   * `availableNormalModeReportIntervals` is empty.
   */
  normalModeReportInterval?: Maybe<NormalModeReportIntervalOption>;
  note?: Maybe<Scalars['String']['output']>;
  operationParams: OperationParams;
  /** Admin-only. Return information about the original plan that the device was activated with. */
  originalPlan?: Maybe<SubscriptionOption>;
  originalPurchaser?: Maybe<User>;
  pet?: Maybe<Pet>;
  platform: Platform;
  /** What shape of operationParams.plmnProfile this device's firmware honors. */
  plmnProfileSupport: PlmnProfileSupport;
  powerState: DevicePowerState;
  prepaidSubscription?: Maybe<DevicePrepaidSubscription>;
  preselectedPlanCodeForNewSubscription?: Maybe<Scalars['String']['output']>;
  /**
   * Return the set of SubscriptionOptions that a user is allowed to purchase for a device;
   * e.g. if they purchased with a $29/mo plan, only return $29/mo. For users who purchased
   * on a yearly plan this would return all yearly plans.
   */
  purchasableSubscriptionOptions: Array<SubscriptionOption>;
  quickReportMode: DeviceQuickReportMode;
  /**
   * Admin only
   *
   * Human readable string like "Series 3+" or "Series 2"
   */
  readableModelName?: Maybe<Scalars['String']['output']>;
  returnEligibility?: Maybe<RMAPolicyResult>;
  series2UpgradeEligible: Scalars['Boolean']['output'];
  series3UpgradeV2Eligible: Scalars['Boolean']['output'];
  /** Admin only */
  shipmentData?: Maybe<DeviceShipment>;
  shouldOfferDiscountDuringClickToCancel?: Maybe<Scalars['Boolean']['output']>;
  shouldOfferDowngradeDuringCancellation?: Maybe<Scalars['Boolean']['output']>;
  /** In-app cancellation flow offers. */
  shouldOfferFreeMonthDuringCancellation?: Maybe<Scalars['Boolean']['output']>;
  shouldOfferFreeTrialCancelDeterrent?: Maybe<Scalars['Boolean']['output']>;
  shouldOfferPauseMonthDuringCancellation?: Maybe<Scalars['Boolean']['output']>;
  /** Admin only. Whether this collar's AWS Sidewalk manufacturing data has been uploaded to S3 by the provisioning script. Null when it can't be determined — the bucket is only readable in production. */
  sidewalkMfgDataInS3?: Maybe<Scalars['Boolean']['output']>;
  /** Admin only. AWS Sidewalk WirelessDeviceId for collars that uplink over Sidewalk. */
  sidewalkWirelessDeviceId?: Maybe<Scalars['String']['output']>;
  /** Represents collar-specific state (i.e. online/offline) */
  status: CollarStatus;
  subscription?: Maybe<BillingSubscription>;
  subscriptionAccessType: SubscriptionAccessType;
  /** Returns the URL to the webview where a user can manage their device's subscription. */
  subscriptionDetailsWebviewUrl: Scalars['String']['output'];
  subscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionOverrideEndsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Used by clients in subscription management e.g., "Monthly membership", "6 month membership" */
  subscriptionPlanDescription?: Maybe<Scalars['String']['output']>;
  /** Used by clients in subscription management e.g., "$19 / month", "$99 / 6 months" */
  subscriptionPricingDescription?: Maybe<Scalars['String']['output']>;
  subscriptionRenewalStatus?: Maybe<SubscriptionRenewalStatus>;
  /**
   * Admin-managed tags (e.g. nypd, vip) attached to this device. Propagate to the Zendesk user
   * profile of every OWNER associated with the device, and to tickets opened after the tag is set.
   */
  tags: Array<DeviceTag>;
  tenancy?: Maybe<Scalars['String']['output']>;
  thirdPartyAccess?: Maybe<Scalars['String']['output']>;
  /** Returns the URL to the webview where a user can troubleshoot issues with their device */
  troubleshootWebviewUrl: Scalars['String']['output'];
  /**
   * TSAT band-25 lock state per the device's latest report: APPLIED when the reported bandlock
   * equals the band-25 mask, PENDING while an enable or clear hasn't taken effect yet. Null when
   * the lock is off and not in effect.
   */
  tsatBandLockStatus?: Maybe<TsatBandLockStatus>;
  updateChannel?: Maybe<Scalars['String']['output']>;
  upgradeRedeemed?: Maybe<DeviceUpgrade>;
  warrantyStatus?: Maybe<RMAPolicyResult>;
  /** Admin only */
  wsConnectionDetails?: Maybe<Scalars['JSON']['output']>;
};

export type DevicecredentialUpdateArgs = {
  currentHash?: InputMaybe<Scalars['String']['input']>;
};

export type DevicediagnosticsArgs = {
  period: DeviceDiagnosticsPeriod;
};

export type DevicefirmwareUpdateArgs = {
  currentVersion: Scalars['String']['input'];
};

export type DevicelastConnectionStateArgs = {
  ignoreOffline?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DevicelocationReportsByDateArgs = {
  after: Scalars['DateTime']['input'];
  before: Scalars['DateTime']['input'];
};

export type DevicemostRecentActuationStatusArgs = {
  actuationType?: InputMaybe<DeviceActuationCategory>;
};

export type DevicepurchasableSubscriptionOptionsArgs = {
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  inAppFlow?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DevicereturnEligibilityArgs = {
  drilldownCode: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
};

export type DevicewarrantyStatusArgs = {
  drilldownCode: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
};

export type DeviceActivity = DeviceEventBase & {
  __typename?: 'DeviceActivity';
  date: Scalars['DateTime']['output'];
  duration: Scalars['Float']['output'];
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  moduleId: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  steps: Scalars['Int']['output'];
};

export type DeviceActuation = {
  __typename?: 'DeviceActuation';
  actuationId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  events?: Maybe<Array<DeviceActuationEvent>>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  receivedBackhaul?: Maybe<DeviceActuationBackhaul>;
  state: DeviceActuationState;
  type?: Maybe<DeviceActuationType>;
  user?: Maybe<User>;
};

export enum DeviceActuationBackhaul {
  BLE = 'BLE',
  LTE = 'LTE',
  UNKNOWN = 'UNKNOWN',
  WIFI = 'WIFI',
}

/** High-level category of actuation, grouping the specific DeviceActuationType variants. */
export enum DeviceActuationCategory {
  COMBO = 'COMBO',
  HAPTIC = 'HAPTIC',
  LED = 'LED',
  PIEZO = 'PIEZO',
  SNOOZE = 'SNOOZE',
}

/** Configuration for actuation patterns on the device, user settable with a default fallback */
export type DeviceActuationConfiguration = {
  __typename?: 'DeviceActuationConfiguration';
  haptic: DeviceActuationType;
  piezo: DeviceActuationType;
};

export type DeviceActuationEvent = {
  __typename?: 'DeviceActuationEvent';
  eventType?: Maybe<DeviceActuationEventType>;
  timestamp: Scalars['DateTime']['output'];
};

export enum DeviceActuationEventType {
  CLIENT_REPORTED_RESULT = 'CLIENT_REPORTED_RESULT',
  EXPIRED = 'EXPIRED',
  REPORTED_RESULT = 'REPORTED_RESULT',
  REPORT_RECEIVED = 'REPORT_RECEIVED',
  REPORT_RESPONSE_SENT = 'REPORT_RESPONSE_SENT',
  RESULT_PUBLISHED = 'RESULT_PUBLISHED',
  SERVER_PUSH_NOT_AVAILABLE = 'SERVER_PUSH_NOT_AVAILABLE',
  SERVER_PUSH_SENT = 'SERVER_PUSH_SENT',
}

export type DeviceActuationFailure = DeviceActuationStateInterface & {
  __typename?: 'DeviceActuationFailure';
  failureReason: DeviceActuationFailureReason;
  status: DeviceActuationStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum DeviceActuationFailureReason {
  BUSY = 'BUSY',
  DUPLICATE = 'DUPLICATE',
  EXPIRED = 'EXPIRED',
  INVALID_PARAMS = 'INVALID_PARAMS',
  UNKNOWN = 'UNKNOWN',
}

export type DeviceActuationSending = DeviceActuationStateInterface & {
  __typename?: 'DeviceActuationSending';
  status: DeviceActuationStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type DeviceActuationState = DeviceActuationFailure | DeviceActuationSending | DeviceActuationSuccess;

export type DeviceActuationStateInterface = {
  status: DeviceActuationStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum DeviceActuationStatus {
  /** There are some cases where an actuation goes from `FAILURE` -> `SUCCESS`. For example, if device receives an actuation but informs the backend of success after the expiration time. */
  FAILURE = 'FAILURE',
  SENDING = 'SENDING',
  SUCCESS = 'SUCCESS',
}

export type DeviceActuationSuccess = DeviceActuationStateInterface & {
  __typename?: 'DeviceActuationSuccess';
  status: DeviceActuationStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum DeviceActuationType {
  COMBO_HIGH = 'COMBO_HIGH',
  COMBO_LOW = 'COMBO_LOW',
  COMBO_MEDIUM = 'COMBO_MEDIUM',
  COMBO_SIMPLE = 'COMBO_SIMPLE',
  HAPTIC_HIGH = 'HAPTIC_HIGH',
  HAPTIC_LOW = 'HAPTIC_LOW',
  HAPTIC_MEDIUM = 'HAPTIC_MEDIUM',
  HAPTIC_SIMPLE = 'HAPTIC_SIMPLE',
  LED_BLUE_SLOW = 'LED_BLUE_SLOW',
  LED_CYAN_SLOW = 'LED_CYAN_SLOW',
  LED_GREEN_SLOW = 'LED_GREEN_SLOW',
  LED_OFF = 'LED_OFF',
  LED_PURPLE_SLOW = 'LED_PURPLE_SLOW',
  LED_RED_SLOW = 'LED_RED_SLOW',
  LED_RED_SOS = 'LED_RED_SOS',
  LED_WHITE_SLOW = 'LED_WHITE_SLOW',
  LED_YELLOW_SLOW = 'LED_YELLOW_SLOW',
  PIEZO_HIGH = 'PIEZO_HIGH',
  PIEZO_LOW = 'PIEZO_LOW',
  PIEZO_MEDIUM = 'PIEZO_MEDIUM',
  PIEZO_SIMPLE = 'PIEZO_SIMPLE',
  SEND_REPORT = 'SEND_REPORT',
  SNOOZE_DISABLED = 'SNOOZE_DISABLED',
  SNOOZE_ENABLED = 'SNOOZE_ENABLED',
}

export type DeviceAssignable = {
  __typename?: 'DeviceAssignable';
  assignable: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type DeviceBatchInfo = {
  __typename?: 'DeviceBatchInfo';
  batch: Scalars['String']['output'];
  numActivated: Scalars['Int']['output'];
  numDevices: Scalars['Int']['output'];
};

export enum DeviceConnectionMode {
  BASE = 'BASE',
  GPS = 'GPS',
  MOBILE = 'MOBILE',
  OFFLINE = 'OFFLINE',
  WIFI = 'WIFI',
}

export type DeviceConnectionRatio = {
  __typename?: 'DeviceConnectionRatio';
  mode: DeviceConnectionMode;
  percent: Scalars['Int']['output'];
  seconds: Scalars['Int']['output'];
};

/** Get the `errorRadius` from the `location` field. */
export type DeviceDiagnosticLocationReport = {
  __typename?: 'DeviceDiagnosticLocationReport';
  cellStrength: DiagnosticStatus;
  date: Scalars['DateTime']['output'];
  /** If false, this is a celllookup report meaning the GPS wasn't able to aquire a fix. */
  fromGPS: Scalars['Boolean']['output'];
  /** Not the actual location report ID (we don't expose that) */
  id: Scalars['ID']['output'];
  location: Location;
};

export type DeviceDiagnostics = {
  __typename?: 'DeviceDiagnostics';
  connectionRatios: Array<DeviceConnectionRatio>;
  /** Clients should poll this to get the result of a GPS test. */
  gpsTestResultSince?: Maybe<GPSTestResult>;
  lastCellularReport?: Maybe<DeviceDiagnosticLocationReport>;
  /** Healthy if the collar is typically connected to BLE. */
  overallSystemHealth: DiagnosticStatus;
  periodDurationSeconds: Scalars['Int']['output'];
};

export type DeviceDiagnosticsgpsTestResultSinceArgs = {
  date: Scalars['DateTime']['input'];
};

export enum DeviceDiagnosticsPeriod {
  ONE_DAY = 'ONE_DAY',
  ONE_WEEK = 'ONE_WEEK',
  THREE_DAYS = 'THREE_DAYS',
}

export type DeviceError = {
  __typename?: 'DeviceError';
  crashSite?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  edata?: Maybe<Scalars['String']['output']>;
  expr?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  func?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  line?: Maybe<Scalars['Int']['output']>;
  pc?: Maybe<Scalars['Int']['output']>;
  rev?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Array<Scalars['String']['output']>>;
  stackKey?: Maybe<Scalars['String']['output']>;
  stackLines?: Maybe<Array<Scalars['String']['output']>>;
};

export type DeviceEventBase = {
  date: Scalars['DateTime']['output'];
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  moduleId: Scalars['String']['output'];
  platform: Scalars['String']['output'];
};

/** Admin visibility into a device that shipped without a membership on a hardware-first order. */
export type DeviceHardwareFirstInfo = {
  __typename?: 'DeviceHardwareFirstInfo';
  /** When the day-14 auto-start job will buy the membership, or null when it will not. */
  autoStartAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Why the day-14 job will not (or did not) start the membership: hasSubscription, activated,
   * returned, klarna, nonProdDevice, or disarmed. Null while auto-start is still on track.
   */
  autoStartSkipReason?: Maybe<Scalars['String']['output']>;
  isGift: Scalars['Boolean']['output'];
  /**
   * True while the hardware-first stamp is still armed, i.e. activation or the day-14 job will
   * still buy the membership. False once that has been disarmed, e.g. by an in-hand transfer.
   */
  membershipPending: Scalars['Boolean']['output'];
  orderId: Scalars['ID']['output'];
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * How the current membership was started (e.g. hardware_first_activation), from the audit log.
   * Null when the device has no membership.
   */
  startedVia?: Maybe<Scalars['String']['output']>;
};

export type DeviceHealthActivityStats = {
  __typename?: 'DeviceHealthActivityStats';
  dailyStepCount?: Maybe<SimpleHealthMetric>;
  timeOffDog?: Maybe<SimpleHealthMetric>;
  totalAccelerationVariance?: Maybe<SimpleHealthMetric>;
  walkCount?: Maybe<SimpleHealthMetric>;
  walkDistance?: Maybe<AggregateHealthMetric>;
  walkDuration?: Maybe<AggregateHealthMetric>;
  walkSteps?: Maybe<AggregateHealthMetric>;
};

export type DeviceHealthBLEBaseStats = DeviceHealthBLEDeviceStats & {
  __typename?: 'DeviceHealthBLEBaseStats';
  base?: Maybe<ChargingBase>;
  deviceLabel: Scalars['String']['output'];
  reportCount?: Maybe<SimpleHealthMetric>;
  rssi?: Maybe<AggregateHealthMetric>;
  sessionDuration?: Maybe<AggregateHealthMetric>;
  timeConnected?: Maybe<SimpleHealthMetric>;
  timeOffline?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthBLEDeviceStats = {
  deviceLabel: Scalars['String']['output'];
  rssi?: Maybe<AggregateHealthMetric>;
  sessionDuration?: Maybe<AggregateHealthMetric>;
  timeConnected?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthBLEHandsetStats = DeviceHealthBLEDeviceStats & {
  __typename?: 'DeviceHealthBLEHandsetStats';
  deviceLabel: Scalars['String']['output'];
  handset?: Maybe<Handset>;
  reportCount?: Maybe<SimpleHealthMetric>;
  rssi?: Maybe<AggregateHealthMetric>;
  sessionDuration?: Maybe<AggregateHealthMetric>;
  timeConnected?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthBLEStats = {
  __typename?: 'DeviceHealthBLEStats';
  bases?: Maybe<Array<DeviceHealthBLEBaseStats>>;
  handsets?: Maybe<Array<DeviceHealthBLEHandsetStats>>;
};

export type DeviceHealthBatteryStats = {
  __typename?: 'DeviceHealthBatteryStats';
  crashes?: Maybe<SimpleHealthMetric>;
  extrapolatedChargeTime?: Maybe<SimpleHealthMetric>;
  extrapolatedLifetime?: Maybe<SimpleHealthMetric>;
  percentChargedInPeriod?: Maybe<SimpleHealthMetric>;
  percentDrainedInPeriod?: Maybe<SimpleHealthMetric>;
  timesOnCharger?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthCellularStats = {
  __typename?: 'DeviceHealthCellularStats';
  connectionAttempts?: Maybe<SimpleHealthMetric>;
  connectionSuccessRate?: Maybe<SimpleHealthMetric>;
  connectionSuccesses?: Maybe<SimpleHealthMetric>;
  rsrp?: Maybe<AggregateHealthMetric>;
  rsrq?: Maybe<AggregateHealthMetric>;
};

export type DeviceHealthConnectivityStats = {
  __typename?: 'DeviceHealthConnectivityStats';
  baseToBaseChanges?: Maybe<SimpleHealthMetric>;
  baseToCellularChanges?: Maybe<SimpleHealthMetric>;
  baseToMobileChanges?: Maybe<SimpleHealthMetric>;
  baseToWifiChanges?: Maybe<SimpleHealthMetric>;
  /**
   * Deprecating use of "BLE" in favor of "Base" which is more specific.
   * @deprecated use baseToWifiChanges instead
   */
  bleToWifiChanges?: Maybe<SimpleHealthMetric>;
  cellularToBaseChanges?: Maybe<SimpleHealthMetric>;
  /** @deprecated use wifiToBaseChanges instead */
  cellularToBleChanges?: Maybe<SimpleHealthMetric>;
  cellularToMobileChanges?: Maybe<SimpleHealthMetric>;
  cellularToWifiChanges?: Maybe<SimpleHealthMetric>;
  mobileToBaseChanges?: Maybe<SimpleHealthMetric>;
  mobileToCellularChanges?: Maybe<SimpleHealthMetric>;
  mobileToMobileChanges?: Maybe<SimpleHealthMetric>;
  mobileToWifiChanges?: Maybe<SimpleHealthMetric>;
  reportCount?: Maybe<SimpleHealthMetric>;
  timeOffline?: Maybe<SimpleHealthMetric>;
  timeOnBLE?: Maybe<SimpleHealthMetric>;
  timeOnBase?: Maybe<SimpleHealthMetric>;
  timeOnCellular?: Maybe<SimpleHealthMetric>;
  timeOnMobile?: Maybe<SimpleHealthMetric>;
  timeOnWifi?: Maybe<SimpleHealthMetric>;
  totalConnectionChanges?: Maybe<SimpleHealthMetric>;
  wifiToBaseChanges?: Maybe<SimpleHealthMetric>;
  /** @deprecated use wifiToBaseChanges instead */
  wifiToBleChanges?: Maybe<SimpleHealthMetric>;
  wifiToCellularChanges?: Maybe<SimpleHealthMetric>;
  wifiToMobileChanges?: Maybe<SimpleHealthMetric>;
  wifiToWifiChanges?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthGNSSStats = {
  __typename?: 'DeviceHealthGNSSStats';
  accuracyRadius?: Maybe<AggregateHealthMetric>;
  allSatSnr?: Maybe<AggregateHealthMetric>;
  fixAttempts?: Maybe<SimpleHealthMetric>;
  fixSuccessRate?: Maybe<SimpleHealthMetric>;
  fixSuccesses?: Maybe<SimpleHealthMetric>;
  s3PlusCouldImprovePerf?: Maybe<SimpleHealthMetric>;
  satellitesTracked?: Maybe<AggregateHealthMetric>;
  timeToFirstFix?: Maybe<AggregateHealthMetric>;
  timeToFix?: Maybe<AggregateHealthMetric>;
  top4SatSnr?: Maybe<AggregateHealthMetric>;
};

export type DeviceHealthLDMStats = {
  __typename?: 'DeviceHealthLDMStats';
  activations?: Maybe<SimpleHealthMetric>;
  duration?: Maybe<AggregateHealthMetric>;
};

export type DeviceHealthMiscStats = {
  __typename?: 'DeviceHealthMiscStats';
  cxd5605?: Maybe<SimpleHealthMetric>;
  da16200?: Maybe<SimpleHealthMetric>;
  lis2dw12?: Maybe<SimpleHealthMetric>;
  lsm6dso?: Maybe<SimpleHealthMetric>;
  lte_modem?: Maybe<SimpleHealthMetric>;
  reboots?: Maybe<SimpleHealthMetric>;
  rv4162c7?: Maybe<SimpleHealthMetric>;
  /** @deprecated historically showed total self test failure count but was changed to total self test count, going to remove */
  selfTestFailures?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthNotificationStats = {
  __typename?: 'DeviceHealthNotificationStats';
  escapeNotificationLatency?: Maybe<AggregateHealthMetric>;
  escapeNotificationsInitiated?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthStatistics = {
  __typename?: 'DeviceHealthStatistics';
  activity?: Maybe<DeviceHealthActivityStats>;
  battery?: Maybe<DeviceHealthBatteryStats>;
  ble?: Maybe<DeviceHealthBLEStats>;
  cellular?: Maybe<DeviceHealthCellularStats>;
  connectivity?: Maybe<DeviceHealthConnectivityStats>;
  gnss?: Maybe<DeviceHealthGNSSStats>;
  ldm?: Maybe<DeviceHealthLDMStats>;
  misc?: Maybe<DeviceHealthMiscStats>;
  notifications?: Maybe<DeviceHealthNotificationStats>;
  wifi?: Maybe<DeviceHealthWiFiStats>;
};

export type DeviceHealthWiFiSSIDStats = {
  __typename?: 'DeviceHealthWiFiSSIDStats';
  bssid: Scalars['String']['output'];
  reportCount?: Maybe<SimpleHealthMetric>;
  rssi?: Maybe<AggregateHealthMetric>;
  sessionDuration?: Maybe<AggregateHealthMetric>;
  ssid: Scalars['String']['output'];
  timeConnected?: Maybe<SimpleHealthMetric>;
};

export type DeviceHealthWiFiStats = {
  __typename?: 'DeviceHealthWiFiStats';
  networks?: Maybe<Array<DeviceHealthWiFiSSIDStats>>;
};

export type DeviceModelPlatformEntry = {
  __typename?: 'DeviceModelPlatformEntry';
  description: Scalars['String']['output'];
  platformId: Scalars['String']['output'];
};

export type DeviceModelPlatformMapping = {
  __typename?: 'DeviceModelPlatformMapping';
  modelDescription: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  platforms: Array<DeviceModelPlatformEntry>;
};

export type DevicePowerState = {
  __typename?: 'DevicePowerState';
  batteryPercent?: Maybe<Scalars['Int']['output']>;
  hasPowerSupply?: Maybe<Scalars['Boolean']['output']>;
  isCharging?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * If the user has purchased a subscription from a third party and has not activated it yet,
 * this will return the subscription details.
 */
export type DevicePrepaidSubscription = {
  __typename?: 'DevicePrepaidSubscription';
  freeMonths?: Maybe<Scalars['Int']['output']>;
  orderSource: OrderSource;
  planCode: Scalars['String']['output'];
  renewalPlanCode?: Maybe<Scalars['String']['output']>;
  resellerPriceInCents?: Maybe<Scalars['Int']['output']>;
};

export type DeviceQueryInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  moduleId?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  updateChannel?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceQuickReportMode = {
  __typename?: 'DeviceQuickReportMode';
  enabled: Scalars['Boolean']['output'];
  ttlSeconds?: Maybe<Scalars['Int']['output']>;
};

export type DeviceResponseOverride = {
  __typename?: 'DeviceResponseOverride';
  expiresAt: Scalars['DateTime']['output'];
  responseOverride: Scalars['JSON']['output'];
};

export type DeviceShipment = {
  __typename?: 'DeviceShipment';
  createdAt: Scalars['DateTime']['output'];
  externalOrderId?: Maybe<Scalars['String']['output']>;
  externalOrderSource?: Maybe<Scalars['String']['output']>;
  fulfillmentFlow?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  shippedAt: Scalars['DateTime']['output'];
  sku: Scalars['String']['output'];
};

export type DeviceStat = {
  __typename?: 'DeviceStat';
  friendlyName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** Per-device summary included in PetLiveState. */
export type DeviceSummary = {
  __typename?: 'DeviceSummary';
  /** LED colors the user can pick from. */
  availableLedColors: Array<LedColor>;
  /**
   * How this device is reaching the network. Per-device, unlike the pet-level `PetLiveState.backhaul`.
   * Satellite is `backhaul == SATELLITE`.
   */
  backhaul: BackhaulType;
  batteryPercent?: Maybe<Scalars['Int']['output']>;
  /**
   * Hardware/feature capabilities for this device (e.g. USER_LED, SOUND, VIBRATION, LIVE_TRACKING).
   * Clients check via .contains(ModuleCapability.X) to branch UI on per-device support.
   */
  capabilities: Array<ModuleCapability>;
  /**
   * Whether the collar applies containment feedback (see `setContainmentEnabled`). Null when the
   * device doesn't support containment; false when supported but off.
   */
  containmentEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the owner has disabled this device for the pet (e.g. an Ultra placed in power-saving).
   * UIs suppress this device's stale battery/connection readouts while it's disabled.
   */
  disabledForPet: Scalars['Boolean']['output'];
  /** True when the device is on its charger. The app uses this for the charging-status indicator. */
  hasPowerSupply: Scalars['Boolean']['output'];
  isLedOn: Scalars['Boolean']['output'];
  isOffDog: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  /**
   * Whether Search Party is available for this device (false for Series 1/2). Gates the Search Party
   * entry point.
   */
  isSearchPartyEligible: Scalars['Boolean']['output'];
  /** Online but the last connection state is older than the staleness threshold. False when offline. */
  isStale: Scalars['Boolean']['output'];
  ledColor?: Maybe<LedColor>;
  /** The device's last known location. Null when the device has never reported a valid position. */
  location?: Maybe<Location>;
  /**
   * Stable device-model identifier (e.g. "FC3"). Use for device-type branching rather than parsing
   * `moduleId`. Null when the model can't be determined.
   */
  modelId?: Maybe<Scalars['String']['output']>;
  /** Long-form, human-facing model name (e.g. "Series 3", "Mini"). */
  modelName: Scalars['String']['output'];
  moduleId: Scalars['String']['output'];
  /**
   * This device's online/offline state (see CollarOnlineState), from its latest connection state.
   * Can differ from `isOnline` (the report-deadline signal): a device online by deadline but with no
   * recent connection report reads as offline.
   */
  onlineState: CollarOnlineState;
  /**
   * Offline with the last known battery at or below the out-of-battery threshold — distinguishes a
   * dead-battery collar from one that may still recover. False when online.
   */
  outOfBattery: Scalars['Boolean']['output'];
};

export type DeviceTag = {
  __typename?: 'DeviceTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DeviceTransferInput = {
  sourceModuleId: Scalars['String']['input'];
  /** May be null for prorated upgrades if new device not yet assigned */
  targetModuleId?: InputMaybe<Scalars['String']['input']>;
  /** e.g., 'sub-f3b-12m-001' */
  targetPlanCode: Scalars['String']['input'];
  /** e.g., 'FC3B' for S3+, 'M1' for Mini */
  targetPlatformType: Scalars['String']['input'];
};

export enum DeviceType {
  BASE = 'BASE',
  MODULE = 'MODULE',
}

export enum DeviceUpgrade {
  MINI = 'MINI',
  SERIES_2 = 'SERIES_2',
  SERIES_3 = 'SERIES_3',
  SERIES_3_PLUS = 'SERIES_3_PLUS',
  ULTRA = 'ULTRA',
}

export enum DiagnosticStatus {
  HEALTHY = 'HEALTHY',
  UNHEALTHY = 'UNHEALTHY',
  WARNING = 'WARNING',
}

export type DisconnectAppIntegrationResult = {
  __typename?: 'DisconnectAppIntegrationResult';
  /** Populated when success is false */
  reason?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DiscoverFeed = {
  __typename?: 'DiscoverFeed';
  feedItems: Array<DiscoverFeedItem>;
  pageInfo: PageInfo;
};

/** Deprecated: articles are no longer included in the discover feed. This type is retained for client compatibility. */
export type DiscoverFeedArticleItem = DiscoverFeedItem & {
  __typename?: 'DiscoverFeedArticleItem';
  /** @deprecated Articles are no longer included in the discover feed. */
  article: Article;
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
};

/**
 * This is just an empty placeholder, it does not include data about suggested dogs.
 * On receiving this, clients need to query the `suggestedPetsToFollow` endpoint
 * to get data to populate the carousel.
 */
export type DiscoverFeedCarouselItem = DiscoverFeedItem & {
  __typename?: 'DiscoverFeedCarouselItem';
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type DiscoverFeedItem = {
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type DiscoverFeedPhotoItem = DiscoverFeedItem & {
  __typename?: 'DiscoverFeedPhotoItem';
  id: Scalars['ID']['output'];
  photo: Photo;
  timestamp: Scalars['DateTime']['output'];
};

export type DiscoverFeedTextPostItem = DiscoverFeedItem & {
  __typename?: 'DiscoverFeedTextPostItem';
  id: Scalars['ID']['output'];
  post: TextPost;
  timestamp: Scalars['DateTime']['output'];
};

export type DiscoverFeedVideoPostItem = DiscoverFeedItem & {
  __typename?: 'DiscoverFeedVideoPostItem';
  id: Scalars['ID']['output'];
  post: VideoPost;
  timestamp: Scalars['DateTime']['output'];
};

export type DismissPromotionBannerInput = {
  bannerType: Scalars['String']['input'];
  dismissReason?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A piece of in-app content that has been dismissed by a user,
 * and a timestamp of when it was dismissed.
 */
export type DismissedMobileAppContent = {
  __typename?: 'DismissedMobileAppContent';
  /**
   * Pieces of Content can have a dismissal expiration time. This
   * field will be set if the user dismissed the content, but then
   * their dismissal expired, and the content should now be visible.
   */
  dismissalExpiredAt?: Maybe<Scalars['DateTime']['output']>;
  dismissalId: Scalars['ID']['output'];
  dismissedAt: Scalars['DateTime']['output'];
  dismissedContent: AdminMobileAppContent;
};

export enum DistanceUnit {
  KM = 'KM',
  MILES = 'MILES',
}

export type DogPark = {
  __typename?: 'DogPark';
  address?: Maybe<ReverseGeocodeResult>;
  boundary?: Maybe<Scalars['JSON']['output']>;
  /** Admin only */
  communityLeaderboardUrl?: Maybe<Scalars['String']['output']>;
  dbId: Scalars['Int']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDiscoverableOverride: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  position: Position;
  preventUpdate: Scalars['Boolean']['output'];
  sourceId?: Maybe<Scalars['String']['output']>;
  type: POIType;
};

export type DogParkCheckin = {
  __typename?: 'DogParkCheckin';
  activity?: Maybe<Activity>;
  connectedUser?: Maybe<User>;
  dogPark: DogPark;
  timestamp: Scalars['DateTime']['output'];
};

export type DogParkCheckinFeed = {
  __typename?: 'DogParkCheckinFeed';
  checkins: Array<DogParkCheckin>;
  pageInfo: PageInfo;
};

export type DogParkCheckinFilter = {
  types?: InputMaybe<Array<POIType>>;
};

export type DogParkCheckinsForPetInput = {
  filter?: InputMaybe<DogParkCheckinFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
  petId: Scalars['ID']['input'];
};

export type DogParkFeed = {
  __typename?: 'DogParkFeed';
  count: Scalars['Int']['output'];
  dogParks: Array<DogPark>;
};

export type DogParkMembershipInput = {
  dogParkId: Scalars['ID']['input'];
  petIds: Array<Scalars['ID']['input']>;
};

export type DogParkNotificationSettingOption = {
  __typename?: 'DogParkNotificationSettingOption';
  description: Scalars['String']['output'];
  shareVisitsEnabled: Scalars['Boolean']['output'];
  visitNotificationsEnabled: Scalars['Boolean']['output'];
};

export type DogParkNotificationSettings = {
  __typename?: 'DogParkNotificationSettings';
  availableNotificationSettingOptions: Array<DogParkNotificationSettingOption>;
  currentNotificationSetting?: Maybe<DogParkNotificationSettingOption>;
};

export type DogParkRequest = {
  __typename?: 'DogParkRequest';
  address: Scalars['String']['output'];
  boundary: Scalars['JSON']['output'];
  businessName: Scalars['String']['output'];
  businessType: Scalars['String']['output'];
  contactEmail: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dogPark?: Maybe<DogPark>;
  id: Scalars['ID']['output'];
  status: DogParkRequestStatus;
};

export enum DogParkRequestStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

export type DogParkShareableSubscriptionText = {
  __typename?: 'DogParkShareableSubscriptionText';
  text: Scalars['String']['output'];
};

export type DogParkVisitor = {
  __typename?: 'DogParkVisitor';
  /**
   * Optional text for the client to display.
   * For example "Last visited today" for recent visitors.
   */
  displayText?: Maybe<Scalars['String']['output']>;
  /** True when the dog is at the dog park now. */
  isAtDogPark?: Maybe<Scalars['Boolean']['output']>;
  /** Time at which this pet last visited the dog park. */
  lastVisitTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Visits this pet has made to the dog park, over a server-defined period. */
  numVisitsLastPeriod: Scalars['Int']['output'];
  pet: StrangerPet;
  /**
   * Step count for this pet, over a server-defined period.
   * @deprecated No longer displayed in UI
   */
  rankingPeriodStepCount?: Maybe<Scalars['Int']['output']>;
  /** Position of this pet in the dog park leaderboard. */
  visitorRankNumber: Scalars['Int']['output'];
};

export type DogParkVisitorFeed = {
  __typename?: 'DogParkVisitorFeed';
  /**
   * Total number of visitors: may be greater than len(visitors) if
   * the backend is truncating feeds, or pagination is implemented.
   */
  count: Scalars['Int']['output'];
  /**
   * The date of the beginning of the rolling window used to count
   * and rank visits to the dog park.
   */
  rankingPeriodStartDate: Scalars['DateTime']['output'];
  visitors: Array<DogParkVisitor>;
};

export type DowngradeSeries2Input = {
  moduleId: Scalars['String']['input'];
};

export type DowngradeSeries2Result = {
  __typename?: 'DowngradeSeries2Result';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DowngradeSeries3Input = {
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  currency?: InputMaybe<Currency>;
  moduleId: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};

export type DowngradeSeries3Result = {
  __typename?: 'DowngradeSeries3Result';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DunningInfo = {
  __typename?: 'DunningInfo';
  amountInCents?: Maybe<Scalars['Int']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  /** Customer-facing message from the payment processor */
  customerMessage?: Maybe<Scalars['String']['output']>;
  /** Recurly decline code (e.g. "insufficient_funds", "do_not_honor") */
  declineCode?: Maybe<Scalars['String']['output']>;
  failureDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  lastFour?: Maybe<Scalars['String']['output']>;
  /** Payment method type: "credit_card", "paypal_billing_agreement", "apple_pay", etc. */
  paymentMethodType?: Maybe<Scalars['String']['output']>;
};

export type DuplicatePromotionInput = {
  newInternalName: Scalars['String']['input'];
  sourceId: Scalars['Int']['input'];
};

export type DynamicEnum = {
  __typename?: 'DynamicEnum';
  id: Scalars['ID']['output'];
  kind: DynamicEnumKind;
  members: Array<DynamicEnumMember>;
};

export enum DynamicEnumKind {
  /** List of hardware defects that can be noted in an RMA. */
  RMA_HARDWARE_DEFECT = 'RMA_HARDWARE_DEFECT',
  /** Where an RMA item was purchased from: Fi Ecomm, Chewy, etc. */
  RMA_PURCHASE_PROVENANCE = 'RMA_PURCHASE_PROVENANCE',
  /** Reason codes for an RMA return. */
  RMA_RETURN_REASON = 'RMA_RETURN_REASON',
  /** Reason codes for an RMA shipping error. */
  RMA_SHIPPING_ERROR_REASON = 'RMA_SHIPPING_ERROR_REASON',
  /** Reason codes for an unknown RMA check-in. */
  RMA_UNKNOWN_RETURN_REASON = 'RMA_UNKNOWN_RETURN_REASON',
  /** Reason codes for an RMA warranty exchange. */
  RMA_WARRANTY_EXCHANGE_REASON = 'RMA_WARRANTY_EXCHANGE_REASON',
}

export type DynamicEnumMember = {
  __typename?: 'DynamicEnumMember';
  canDelete: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
};

export type EcommerceExperiment = {
  __typename?: 'EcommerceExperiment';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  variants: Array<EcommerceExperimentVariant>;
};

export type EcommerceExperimentEnrollment = {
  __typename?: 'EcommerceExperimentEnrollment';
  experiment: EcommerceExperiment;
  variant: EcommerceExperimentVariant;
};

export type EcommerceExperimentVariant = {
  __typename?: 'EcommerceExperimentVariant';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**
   * Returns a signed URL that can be used to direct users to the shop with this
   * variant enabled.
   */
  redirectUrl: Scalars['String']['output'];
};

export type EcommerceImage = {
  __typename?: 'EcommerceImage';
  /** File size in bytes (for display in admin) */
  fileSize?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  /** For videos: thumbnail image URL */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Type of media - 'image' or 'video' */
  type: Scalars['String']['output'];
  urls: Array<EcommerceImageUrl>;
};

export type EcommerceImageInput = {
  /** File size in bytes */
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  position: Scalars['Int']['input'];
  /** For videos: thumbnail image URL */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** Type of media - 'image' or 'video'. Defaults to 'image' */
  type?: InputMaybe<Scalars['String']['input']>;
  urls: Array<EcommerceImageUrlInput>;
};

export type EcommerceImageUrl = {
  __typename?: 'EcommerceImageUrl';
  /** srcset descriptor, e.g., '1500w', '3000w', '4000w', or 'fullSize' */
  descriptor: Scalars['String']['output'];
  url: Scalars['String']['output'];
  /** Optional WebP URL for browsers that support it */
  webpUrl?: Maybe<Scalars['String']['output']>;
};

export type EcommerceImageUrlInput = {
  /** srcset descriptor, e.g., '1500w', '3000w', '4000w', or 'fullSize' */
  descriptor: Scalars['String']['input'];
  url: Scalars['String']['input'];
  /** Optional WebP URL for browsers that support it */
  webpUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum EmployeeGiftColor {
  BLUE = 'BLUE',
  GRAY = 'GRAY',
  PINK = 'PINK',
  YELLOW = 'YELLOW',
}

export enum EmployeeGiftProduct {
  MINI_KIT = 'MINI_KIT',
  SERIES_3_PLUS_KIT = 'SERIES_3_PLUS_KIT',
}

export type EnableOrExtendQuickReportModeResult = {
  __typename?: 'EnableOrExtendQuickReportModeResult';
  ttlSeconds: Scalars['Int']['output'];
};

export type EndSharingSessionResult = {
  __typename?: 'EndSharingSessionResult';
  reason?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EnrollGwaInput = {
  promoCodeAlias: Scalars['String']['input'];
};

export type EnrollGwaResult = {
  __typename?: 'EnrollGwaResult';
  enrollment: RescueGwaProgram;
};

export enum EuiccServiceProvider {
  ATT = 'ATT',
  ONOMONDO = 'ONOMONDO',
  VERIZON = 'VERIZON',
}

export enum EvalClassification {
  ACTIVITY = 'ACTIVITY',
  BEHAVIORS = 'BEHAVIORS',
  DAILY_CHECK_IN = 'DAILY_CHECK_IN',
  FUN = 'FUN',
  GOALS = 'GOALS',
  HEALTH = 'HEALTH',
  OTHER = 'OTHER',
  SLEEP = 'SLEEP',
}

export type EvalGuideline = {
  __typename?: 'EvalGuideline';
  appliesWhen?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  exampleBadResponse?: Maybe<Scalars['String']['output']>;
  exampleGoodResponse?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  scope: EvalGuidelineScope;
  severity: EvalGuidelineSeverity;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export enum EvalGuidelineScope {
  CONDITIONAL = 'CONDITIONAL',
  GLOBAL = 'GLOBAL',
}

export enum EvalGuidelineSeverity {
  BLOCKER = 'BLOCKER',
  MAJOR = 'MAJOR',
  MINOR = 'MINOR',
}

export type EvalResult = {
  __typename?: 'EvalResult';
  /** True if any BLOCKER-severity guideline failed. */
  blockerFailed: Scalars['Boolean']['output'];
  classification: EvalClassification;
  classificationExplanation?: Maybe<Scalars['String']['output']>;
  /** Number of CONTRADICTED claims in the response. Null if no factual claims were extracted. */
  contradictionsCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  estimatedCostCents?: Maybe<Scalars['Float']['output']>;
  /** Deterministic hash of the evaluation config (active guidelines, prompt versions, judge model). Changes when any config input changes, so results are only compared apples-to-apples. */
  evalConfigHash: Scalars['String']['output'];
  evaluationDurationMs: Scalars['Int']['output'];
  evaluationModel: Scalars['String']['output'];
  faithfulnessClaims?: Maybe<Array<FaithfulnessClaim>>;
  /** Claim-based faithfulness score (0.0–1.0) computed from extracted atomic claims. Null if no factual claims were extracted. */
  faithfulnessScore?: Maybe<Scalars['Float']['output']>;
  guidelineDetails: Array<EvalResultGuideline>;
  /** Unweighted score: passedGuidelines / totalGuidelines (0.0–1.0). Treats all guideline severities equally. */
  guidelineScore: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  inputTokens: Scalars['Int']['output'];
  messageId: Scalars['Int']['output'];
  outputTokens: Scalars['Int']['output'];
  passedGuidelines: Scalars['Int']['output'];
  /** Count of guidelines determined to be applicable to this response. */
  totalGuidelines: Scalars['Int']['output'];
  /** Severity-weighted score (0.0–1.0). Weights: BLOCKER 3x, MAJOR 2x, MINOR 1x. */
  weightedGuidelineScore: Scalars['Float']['output'];
};

export type EvalResultGuideline = {
  __typename?: 'EvalResultGuideline';
  applicabilityReason?: Maybe<Scalars['String']['output']>;
  /** Whether the LLM judge determined this guideline applies to the response. Always true for GLOBAL guidelines; for CONDITIONAL guidelines, determined by the classification stage. */
  applicable: Scalars['Boolean']['output'];
  guideline: EvalGuideline;
  guidelineId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Whether the response passed this guideline. Null if the guideline was not applicable. */
  passed?: Maybe<Scalars['Boolean']['output']>;
  /** LLM judge's explanation for the pass/fail verdict. Null if the guideline was not applicable. */
  reasoning?: Maybe<Scalars['String']['output']>;
};

export type EventFeedbackResponse = {
  __typename?: 'EventFeedbackResponse';
  createdAt: Scalars['DateTime']['output'];
  feedback: Scalars['String']['output'];
  helpCenterLink: HelpCenterLink;
};

/** Input for executing a product transfer. */
export type ExecuteProductTransferInput = {
  /** Account code for the user */
  accountCode: Scalars['String']['input'];
  /** Collar color for fulfillment (yellow, gray, blue, pink). Required for S3+ kit orders. */
  collarColor?: InputMaybe<Scalars['String']['input']>;
  /** Collar size for fulfillment (xsmall, small, medium, large, xlarge). Required for S3+ kit orders. */
  collarSize?: InputMaybe<Scalars['String']['input']>;
  /**
   * Moves an existing membership onto hardware the customer already holds: no hardware invoice,
   * no order, and no prepay. Requires targetModuleId on every transfer.
   */
  hardwareAlreadyDelivered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom hardware fee amount in cents (overrides default) */
  hardwareFeeAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  /** SKU for hardware charge (e.g., 'F3B-M' for S3+ module) */
  hardwareSku?: InputMaybe<Scalars['String']['input']>;
  /** Optional CX agent notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Membership prepay option - charges upfront and extends subscription date */
  prepayOption?: InputMaybe<MembershipPrepayOption>;
  /** List of device transfers to execute */
  transfers: Array<DeviceTransferInput>;
  /** Whether to waive the hardware fee */
  waiveHardwareFee?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A GrowthBook experiment enrollment record from analytics events. */
export type ExperimentEnrollment = {
  __typename?: 'ExperimentEnrollment';
  /** How many times this enrollment event was recorded */
  eventCount: Scalars['Int']['output'];
  /** The GrowthBook experiment key (e.g. "free-trial-enabled") */
  experimentKey: Scalars['String']['output'];
  /** The most recent time this enrollment was seen */
  lastSeen: Scalars['DateTime']['output'];
  /** The variant the user/pet was assigned to (e.g. "0", "1") */
  variant: Scalars['String']['output'];
};

export type ExpireResellerModulesInput = {
  moduleIds: Array<Scalars['String']['input']>;
};

export type ExpireResellerModulesResult = {
  __typename?: 'ExpireResellerModulesResult';
  /** Module IDs whose rows were already expired (no-op). */
  alreadyExpiredModuleIds: Array<Scalars['String']['output']>;
  /** Module IDs that had at least one unactivated, non-expired row flipped to expired. */
  expiredModuleIds: Array<Scalars['String']['output']>;
  /** Total number of rows flipped to expired. */
  expiredRowCount: Scalars['Int']['output'];
  /** Module IDs with no reseller module row on file. */
  notFoundModuleIds: Array<Scalars['String']['output']>;
  /** Module IDs left untouched because a subscription has already been activated on them. */
  skippedActivatedModuleIds: Array<Scalars['String']['output']>;
};

export type ExtendSubscriptionInput = {
  days: Scalars['Int']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type ExternalUser = {
  __typename?: 'ExternalUser';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profilePicture?: Maybe<Image>;
};

export type FaithfulnessClaim = {
  __typename?: 'FaithfulnessClaim';
  claim: Scalars['String']['output'];
  label: FaithfulnessClaimLabel;
  source?: Maybe<Scalars['String']['output']>;
};

export enum FaithfulnessClaimLabel {
  CONTRADICTED = 'CONTRADICTED',
  NOT_IN_CONTEXT = 'NOT_IN_CONTEXT',
  PARTIALLY_SUPPORTED = 'PARTIALLY_SUPPORTED',
  SUPPORTED = 'SUPPORTED',
}

export type FalseBooleanSetting = BooleanSetting & {
  __typename?: 'FalseBooleanSetting';
  /**
   * DO NOT USE: This is required since GraphQL doesn't support empty types.
   * Use the __typename to determine the flag's boolean value.
   */
  emptyType?: Maybe<Scalars['Boolean']['output']>;
  platformOverrides: Array<BooleanSettingPlatformOverride>;
};

export type FeatureFlag = {
  accessedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dynamicSettingName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FeedDecayCurveConfig = {
  __typename?: 'FeedDecayCurveConfig';
  decayCurve: Array<DecayCurvePoint>;
};

export enum FeedDecayCurveType {
  MAIN = 'MAIN',
  TRENDING = 'TRENDING',
}

export enum FiCountry {
  AT = 'AT',
  BE = 'BE',
  CA = 'CA',
  CH = 'CH',
  DE = 'DE',
  DK = 'DK',
  ES = 'ES',
  FI = 'FI',
  FR = 'FR',
  GB = 'GB',
  IS = 'IS',
  LI = 'LI',
  LU = 'LU',
  LV = 'LV',
  MT = 'MT',
  NL = 'NL',
  NO = 'NO',
  RO = 'RO',
  SE = 'SE',
  SI = 'SI',
  SK = 'SK',
  TR = 'TR',
  US = 'US',
}

export type FiFeed = {
  __typename?: 'FiFeed';
  feedItems: Array<FiFeedItem>;
  pageInfo: PageInfo;
};

export type FiFeedActivityItem = FiFeedItem & {
  __typename?: 'FiFeedActivityItem';
  activity: Activity;
  existingFeedback?: Maybe<EventFeedbackResponse>;
  feedbackOptions?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  pet: Pet;
  timestamp: Scalars['DateTime']['output'];
};

export type FiFeedBirthdayCardItem = FiFeedItem & {
  __typename?: 'FiFeedBirthdayCardItem';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  petId: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
};

/** DEPRECATED: This type has been replaced by FiFeedLikableWalkItem */
export type FiFeedClappableWalkItem = FiFeedItem & {
  __typename?: 'FiFeedClappableWalkItem';
  followedPet: StrangerPet;
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
  walk: StrangerWalk;
};

export type FiFeedDogParkVisitItem = FiFeedItem & {
  __typename?: 'FiFeedDogParkVisitItem';
  dogPark: DogPark;
  id: Scalars['ID']['output'];
  pet: Pet;
  timestamp: Scalars['DateTime']['output'];
};

export enum FiFeedFilter {
  ALL = 'ALL',
  FOLLOWING = 'FOLLOWING',
  YOU = 'YOU',
}

export type FiFeedFollowedPetPhotoAddedItem = FiFeedItem & {
  __typename?: 'FiFeedFollowedPetPhotoAddedItem';
  followedPet: StrangerPet;
  id: Scalars['ID']['output'];
  photo: Photo;
  timestamp: Scalars['DateTime']['output'];
};

export type FiFeedGenericNotificationItem = FiFeedItem & {
  __typename?: 'FiFeedGenericNotificationItem';
  body: FormatString;
  existingFeedback?: Maybe<EventFeedbackResponse>;
  feedbackOptions?: Maybe<Array<Scalars['String']['output']>>;
  hideTimestamp: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  optionalPet?: Maybe<Pet>;
  timestamp: Scalars['DateTime']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type FiFeedItem = {
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type FiFeedLikableWalkItem = FiFeedItem & {
  __typename?: 'FiFeedLikableWalkItem';
  followedPet: StrangerPet;
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
  walk: StrangerWalk;
};

export type FiFeedPetFollowedItem = FiFeedItem & {
  __typename?: 'FiFeedPetFollowedItem';
  followedPet: Pet;
  followingPet: StrangerPet;
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type FiFeedPhotoAddedItem = FiFeedItem & {
  __typename?: 'FiFeedPhotoAddedItem';
  id: Scalars['ID']['output'];
  pet: Pet;
  photo: Photo;
  timestamp: Scalars['DateTime']['output'];
  user: User;
};

export type FiFeedPhotoLikedItem = FiFeedItem & {
  __typename?: 'FiFeedPhotoLikedItem';
  id: Scalars['ID']['output'];
  /** The pet who is liking the photo */
  likingPet: StrangerPet;
  numPhotosLiked: Scalars['Int']['output'];
  /** The pet whose photo is being liked */
  pet: Pet;
  photo: Photo;
  timestamp: Scalars['DateTime']['output'];
};

export type FiFeedRankingUpdateItem = FiFeedItem & {
  __typename?: 'FiFeedRankingUpdateItem';
  id: Scalars['ID']['output'];
  newBreedRank: Scalars['Int']['output'];
  newOverallRank: Scalars['Int']['output'];
  pet: Pet;
  timestamp: Scalars['DateTime']['output'];
};

export enum FiLanguage {
  DE_AT = 'DE_AT',
  DE_CH = 'DE_CH',
  DE_DE = 'DE_DE',
  DE_LI = 'DE_LI',
  DE_LU = 'DE_LU',
  EN_CA = 'EN_CA',
  EN_CH = 'EN_CH',
  EN_DK = 'EN_DK',
  EN_FI = 'EN_FI',
  EN_GB = 'EN_GB',
  EN_IS = 'EN_IS',
  EN_LV = 'EN_LV',
  EN_MT = 'EN_MT',
  EN_NO = 'EN_NO',
  EN_SE = 'EN_SE',
  EN_SI = 'EN_SI',
  EN_SK = 'EN_SK',
  EN_TR = 'EN_TR',
  EN_US = 'EN_US',
  ES_ES = 'ES_ES',
  FR_BE = 'FR_BE',
  FR_CA = 'FR_CA',
  FR_FR = 'FR_FR',
  FR_LU = 'FR_LU',
  LV_LV = 'LV_LV',
  NL_BE = 'NL_BE',
  NL_NL = 'NL_NL',
  RO_RO = 'RO_RO',
  SK_SK = 'SK_SK',
  TR_TR = 'TR_TR',
}

export type FiNewsNotification = {
  __typename?: 'FiNewsNotification';
  /** Admin-only */
  dbId: Scalars['Int']['output'];
  featureImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  publishedAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FiNewsNotificationFeed = {
  __typename?: 'FiNewsNotificationFeed';
  items: Array<FiNewsNotification>;
};

/** A statistic about firmware versions in the field. */
export type FirmwareDeploymentStatistics = {
  __typename?: 'FirmwareDeploymentStatistics';
  versionDistribution: Array<FirmwareVersionStatistic>;
};

export enum FirmwareReleaseClass {
  PROD = 'PROD',
  TEST = 'TEST',
}

export type FirmwareStatistics = {
  __typename?: 'FirmwareStatistics';
  /** The distribution of updateChannel values across this platform. */
  configuredDistribution: Array<FirmwareUpdateChannelStatistic>;
  /**
   * The distribution of applied CXD5610 recovery-image revisions (the OTA comparison key) per
   * update channel. Only devices that have reported an applied revision are counted; empty on
   * platforms without a CXD5610. The revision is returned in the statistic's `version` field.
   */
  cxdConfiguredDistribution: Array<FirmwareUpdateChannelStatistic>;
  /** The distribution of versions reported by recent devices. */
  deploymentStatistics: FirmwareDeploymentStatistics;
};

export type FirmwareTag = {
  __typename?: 'FirmwareTag';
  buildAttribute: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FirmwareUpdate = {
  __typename?: 'FirmwareUpdate';
  /**
   * Indicates that the client's firmware is out of date and they should download an update
   * from this URL.
   */
  downloadUrl?: Maybe<Scalars['String']['output']>;
};

export type FirmwareUpdateChannel = {
  __typename?: 'FirmwareUpdateChannel';
  currentAppVersion?: Maybe<FirmwareVersion>;
  currentBootloaderVersion?: Maybe<FirmwareVersion>;
  currentCxd5610Version?: Maybe<FirmwareVersion>;
  name: Scalars['String']['output'];
  platformId: Scalars['String']['output'];
  releaseClass: FirmwareReleaseClass;
  remoteLogEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Tags that are associated with this update channel. */
  tags: Array<FirmwareTag>;
};

/** A statistic about how many devices are on a particular firmware channel and version. */
export type FirmwareUpdateChannelStatistic = {
  __typename?: 'FirmwareUpdateChannelStatistic';
  count: Scalars['Int']['output'];
  updateChannel: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum FirmwareUpdateType {
  APPLICATION = 'APPLICATION',
  BOOTLOADER = 'BOOTLOADER',
  CXD5610 = 'CXD5610',
}

export type FirmwareVersion = {
  __typename?: 'FirmwareVersion';
  /** Generic per-type metadata, display-only. For CXD5610 images: { cxdVersion, protocolVersion }. */
  attributes?: Maybe<Scalars['JSON']['output']>;
  buildUrl?: Maybe<Scalars['String']['output']>;
  commit?: Maybe<Scalars['String']['output']>;
  compareUrl?: Maybe<Scalars['String']['output']>;
  compatiblePlatformId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  releaseClass: FirmwareReleaseClass;
  s3Suffix: Scalars['String']['output'];
  /** Tags that are associated with this firmware version. */
  tags: Array<FirmwareTag>;
  type: FirmwareUpdateType;
};

export type FirmwareVersionChangeDeviceEvent = DeviceEventBase & {
  __typename?: 'FirmwareVersionChangeDeviceEvent';
  date: Scalars['DateTime']['output'];
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  moduleId: Scalars['String']['output'];
  newVersion?: Maybe<Scalars['String']['output']>;
  oldVersion?: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
};

/** A statistic about how many devices are reporting a particular firmware version. */
export type FirmwareVersionStatistic = {
  __typename?: 'FirmwareVersionStatistic';
  count: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export enum FollowStatus {
  BLOCKED = 'BLOCKED',
  FOLLOWED = 'FOLLOWED',
  UNFOLLOWED = 'UNFOLLOWED',
}

export enum FontStyle {
  BOLD = 'BOLD',
  /**
   * This is currently used on client to indicate that text should be bold
   * @deprecated Use ITALIC or BOLD
   */
  EMPHASIZED = 'EMPHASIZED',
  ITALIC = 'ITALIC',
  REGULAR = 'REGULAR',
}

export type ForModuleBundleCartItemInput = {
  cartItemId: Scalars['String']['input'];
  forModuleId: Scalars['String']['input'];
  /** This will probably always be false but needed in schema because of the way the cart items are modeled on the frontend. */
  isGift?: InputMaybe<Scalars['Boolean']['input']>;
  lineItem: CartLineItemInput;
  quantity: Scalars['Int']['input'];
  subscriptionLineItem: CartLineItemInput;
};

export type ForModuleCartItemInput = {
  cartItemId: Scalars['String']['input'];
  forModuleId: Scalars['String']['input'];
  lineItem: CartLineItemInput;
  quantity: Scalars['Int']['input'];
};

export type FormatString = {
  __typename?: 'FormatString';
  spans: Array<Span>;
  text: Scalars['String']['output'];
};

export type ForwardGeocodeCityResult = {
  __typename?: 'ForwardGeocodeCityResult';
  city?: Maybe<Scalars['String']['output']>;
  cityState: Scalars['String']['output'];
  /** ISO 3166-1 alpha-2 country code, uppercased (e.g. "US"). */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** BCP-47 language tag the names are in; null when the provider doesn't report it. */
  language?: Maybe<Scalars['String']['output']>;
  position: Position;
  state?: Maybe<Scalars['String']['output']>;
  /** ISO 3166-2 subdivision code (e.g. "US-NY"). */
  subdivisionCode?: Maybe<Scalars['String']['output']>;
};

export type ForwardGeocodeResult = {
  __typename?: 'ForwardGeocodeResult';
  address: Scalars['String']['output'];
  cityState: Scalars['String']['output'];
  position: Position;
};

export enum FulfillmentProviderCode {
  DCL = 'DCL',
  TAGG = 'TAGG',
}

export type FulfillmentWarehouse = {
  __typename?: 'FulfillmentWarehouse';
  active: Scalars['Boolean']['output'];
  externalCode: Scalars['String']['output'];
  fulfillmentProviderCode: FulfillmentProviderCode;
  id: Scalars['ID']['output'];
  metadata?: Maybe<FulfillmentWarehouseMetadata>;
  name: Scalars['String']['output'];
};

export type FulfillmentWarehouseMetadata = {
  __typename?: 'FulfillmentWarehouseMetadata';
  b2bAccountNumber?: Maybe<Scalars['String']['output']>;
  d2cAccountNumber?: Maybe<Scalars['String']['output']>;
  includeDangerousGoodsSticker?: Maybe<Scalars['Boolean']['output']>;
  inventoryTypes: Array<Scalars['String']['output']>;
  maxGoodsValuePerShipmentInDollars?: Maybe<Scalars['Int']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type FulfillmentWarehouseMetadataInput = {
  /** b2bAccountNumber is included with orders when submitted to the warehouse. B2B === Business to Business. */
  b2bAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** d2cAccountNumber is included with orders when submitted to the warehouse. D2C === Direct to Consumer. */
  d2cAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * When true, for any orders that are shipped from this warehouse, the backend will explicitly include a dangerous
   * goods sticker as a line item in the shipment when the number of dangerous goods exceeds the appropriate threshold.
   */
  includeDangerousGoodsSticker?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The types of inventory that are stored at this warehouse. Used when fetching inventory from the 3PL
   * to match results with our fulfillment warehouse records.
   */
  inventoryTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * If defined, we must split the order into multiple shipments when the order contains items that are valued
   * over the specified amount
   */
  maxGoodsValuePerShipmentInDollars?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The timezone of the warehouse. Warehouse data is usually reported in their local time without specifying
   * a timezone so we use this to convert times to UTC.
   */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type FullAdminUserProfile = AdminBaseUserProfile & {
  __typename?: 'FullAdminUserProfile';
  automaticallyActivateDevices: Scalars['Boolean']['output'];
  billingAccount?: Maybe<BillingAccount>;
  chipReseller?: Maybe<ChipReseller>;
  dbId: Scalars['Int']['output'];
  deactivated: Scalars['Boolean']['output'];
  ecommerceOrders: Array<Order>;
  email: Scalars['String']['output'];
  emails: Array<UserEmail>;
  fiNewsNotificationsEnabled: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  groups: Array<UserGroup>;
  handsets: Array<Handset>;
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  latestLocation?: Maybe<Location>;
  note?: Maybe<Scalars['String']['output']>;
  /** Admin tags on devices in households this user owns, deduplicated. */
  ownedDeviceTags: Array<DeviceTag>;
  /**
   * Paginated view over every pet in this user's households, ordered collar-first.
   * Mirrors User.petsFeed.
   */
  petsFeed: PetFeed;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  referrals: Referrals;
  region?: Maybe<FiCountry>;
  rmas: Array<RMA>;
  settings: UserSettings;
  socialBanned: Scalars['Boolean']['output'];
  /** Returns all feature flag values by default, but can optionally provide an array of feature flag names to return */
  targetedFeatureFlags: Array<TargetedFeatureFlag>;
  tenancy?: Maybe<Scalars['String']['output']>;
  thirdPartyAccess?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
  userHouseholds: Array<UserHousehold>;
};

export type FullAdminUserProfilegroupsArgs = {
  excludePseudo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FullAdminUserProfilehandsetsArgs = {
  status?: InputMaybe<Array<HandsetStatus>>;
};

export type FullAdminUserProfilepetsFeedArgs = {
  filters?: InputMaybe<Array<PetFilter>>;
  householdType?: InputMaybe<HouseholdType>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type FullAdminUserProfiletargetedFeatureFlagsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GPSTestCompleteResult = {
  __typename?: 'GPSTestCompleteResult';
  report: DeviceDiagnosticLocationReport;
};

/** Connection was stolen by a charging base or another mobile user. */
export type GPSTestConnectionStolenResult = {
  __typename?: 'GPSTestConnectionStolenResult';
  /**
   * Connection state of the collar which can be used to determine if it was another user
   * or a base that stole the connection.
   */
  state: ConnectionState;
};

export type GPSTestResult = GPSTestCompleteResult | GPSTestConnectionStolenResult;

/** Summary statistics for the GDPR dashboard. */
export type GdprDashboardStats = {
  __typename?: 'GdprDashboardStats';
  cancelledDeletionRequests: Scalars['Int']['output'];
  completedDeletionRequests: Scalars['Int']['output'];
  failedDeletionRequests: Scalars['Int']['output'];
  pendingDeletionRequests: Scalars['Int']['output'];
  processingDeletionRequests: Scalars['Int']['output'];
  totalConsentRecords: Scalars['Int']['output'];
};

export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
}

/**
 * Generates deterministic, reproducible activity data without reading from the database.
 * All timestamps are computed relative to a base time (defaults to now). Produces a realistic
 * day of activity: walks, rest periods, and a home place with safe zone.
 */
export type GenerateActivityDataInput = {
  /**
   * Base time for the generated timeline. Segments are generated relative to this.
   * Defaults to now. Supports nunjucks: {{ now() }}
   */
  baseTime?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Number of days of activity to generate (going backwards from baseTime). Defaults to 3.
   * Max 14.
   */
  days?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to generate deterministic pet behavior data (barking, drinking, eating, etc.). Defaults to true. */
  generateBehaviors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to generate daily activity summaries. Defaults to true. */
  generateDailySummaries?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to generate a home place as a safe zone. Defaults to true. */
  generateHomePlace?: InputMaybe<Scalars['Boolean']['input']>;
  /** Target test household inputId — used for generated places. */
  householdInputId: Scalars['String']['input'];
  /** Target test pet inputId — must reference a pet being created in this request. */
  petInputId: Scalars['String']['input'];
  /** IANA timezone for the generated data. Defaults to America/New_York. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Number of walk segments per day. Defaults to 3. */
  walksPerDay?: InputMaybe<Scalars['Int']['input']>;
};

export type GetHealthGptChatThreadInput = {
  petId: Scalars['ID']['input'];
};

export type GetMultipleSupplementSubscriptionsPricingInput = {
  forceApplyDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  skusToAdd: Array<Scalars['String']['input']>;
};

export type GetMultipleSupplementSubscriptionsPricingResult = {
  __typename?: 'GetMultipleSupplementSubscriptionsPricingResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  subtotalInCents: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  taxInCents: Scalars['Int']['output'];
  totalInCents: Scalars['Int']['output'];
};

export type GetPermissionMobileAppContentInput = {
  clientTargetingFacts: MobileAppContentClientTargetingFactsInput;
  permissionTypes: Array<Scalars['String']['input']>;
  petId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetPetBehaviorDetailInput = {
  /**
   * behaviorId is purposely not an enum to allow adding new behaviors without client updates.
   * Current supported values are 'activity', 'barking', 'cleaning_self', 'drinking', 'eating', 'scratching', 'shaking'
   */
  behaviorId: Scalars['String']['input'];
  /** If null, treat as now */
  cursor?: InputMaybe<Scalars['String']['input']>;
  period: PetBehaviorPeriod;
  petId: Scalars['ID']['input'];
};

export type GetPetDocumentsInput = {
  householdId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type GiftCardDeliveryInput = {
  deliverAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailAddress: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  gifterName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  personalMessage?: InputMaybe<Scalars['String']['input']>;
};

export type GiftShippingAddressInput = {
  city: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zipcode: Scalars['String']['input'];
};

export type GingrConfig = {
  __typename?: 'GingrConfig';
  /** The API key that gives access to the Gingr API for the boarding facility. */
  apiKey: Scalars['String']['output'];
  /**
   * On the Gingr platform, each boarding facility has their own subdomain
   * e.g. for prhg-testing.gingrapp.com this value would be prhg-testing
   */
  apiSubdomain: Scalars['String']['output'];
  /**
   * Location ID in Gingr for this boarding facility. Optional because results using an API
   * key are already scoped to a location.
   */
  locationId?: Maybe<Scalars['String']['output']>;
};

export type Give1MonthGet1DollarPerMonthDetails = {
  __typename?: 'Give1MonthGet1DollarPerMonthDetails';
  numActiveReferrals: Scalars['Int']['output'];
  totalDollarsEarned: Scalars['Float']['output'];
};

export type GnssFixFailure = {
  __typename?: 'GnssFixFailure';
  gnssTimeToFixInSeconds: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
};

/**
 * A curated test question with controlled mock retrieval data for prompt regression testing.
 * Each mock data field mirrors the real pipeline output type so golden question runs use
 * the same prompt assembly path as production.
 */
export type GoldenQuestion = {
  __typename?: 'GoldenQuestion';
  classification: EvalClassification;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  mockBreedSummaryData?: Maybe<Scalars['JSON']['output']>;
  mockCurrentDate?: Maybe<Scalars['DateTime']['output']>;
  mockGraphqlData?: Maybe<Scalars['JSON']['output']>;
  mockKnowledgeBaseDocs?: Maybe<Scalars['JSON']['output']>;
  mockPetDetails?: Maybe<Scalars['JSON']['output']>;
  mockPetDocuments?: Maybe<Scalars['JSON']['output']>;
  questionText: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

/**
 * A single execution of all active golden questions against a prompt configuration.
 * Each run stores a full snapshot of the prompt templates used so results are reproducible
 * without a separate prompt versioning table.
 */
export type GoldenQuestionRun = {
  __typename?: 'GoldenQuestionRun';
  avgFaithfulnessScore?: Maybe<Scalars['Float']['output']>;
  avgGuidelineScore?: Maybe<Scalars['Float']['output']>;
  completedQuestions: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  estimatedCostCents?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  llmModel: Scalars['String']['output'];
  promptTemplates: Scalars['JSON']['output'];
  results: Array<GoldenQuestionRunResult>;
  status: GoldenQuestionRunStatus;
  temperature: Scalars['Float']['output'];
  /** Sum of contradictionsCount across all completed results in this run. */
  totalContradictionsCount?: Maybe<Scalars['Int']['output']>;
  totalInputTokens?: Maybe<Scalars['Int']['output']>;
  totalOutputTokens?: Maybe<Scalars['Int']['output']>;
  totalQuestions: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** Side-by-side comparison of two golden question runs, aligned by golden question. */
export type GoldenQuestionRunComparison = {
  __typename?: 'GoldenQuestionRunComparison';
  results: Array<GoldenQuestionRunResultComparison>;
  runA: GoldenQuestionRun;
  runB: GoldenQuestionRun;
};

/** Per-question result within a golden question run. */
export type GoldenQuestionRunResult = {
  __typename?: 'GoldenQuestionRunResult';
  blockerFailed?: Maybe<Scalars['Boolean']['output']>;
  classification?: Maybe<EvalClassification>;
  classificationExplanation?: Maybe<Scalars['String']['output']>;
  contradictionsCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  faithfulnessClaims?: Maybe<Scalars['JSON']['output']>;
  faithfulnessScore?: Maybe<Scalars['Float']['output']>;
  generatedResponse?: Maybe<Scalars['String']['output']>;
  goldenQuestion: GoldenQuestion;
  guidelineDetails?: Maybe<Scalars['JSON']['output']>;
  guidelineScore?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  passedGuidelines?: Maybe<Scalars['Int']['output']>;
  status: GoldenQuestionRunResultStatus;
  totalGuidelines?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
  weightedGuidelineScore?: Maybe<Scalars['Float']['output']>;
};

export type GoldenQuestionRunResultComparison = {
  __typename?: 'GoldenQuestionRunResultComparison';
  goldenQuestion: GoldenQuestion;
  resultA?: Maybe<GoldenQuestionRunResult>;
  resultB?: Maybe<GoldenQuestionRunResult>;
};

export enum GoldenQuestionRunResultStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
}

export enum GoldenQuestionRunStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
}

export type GroupsBooleanSetting = BooleanSetting & {
  __typename?: 'GroupsBooleanSetting';
  groups: Array<Scalars['String']['output']>;
  platformOverrides: Array<BooleanSettingPlatformOverride>;
};

/**
 * A Gift-with-Adoption offer surfaced to a chip's adopter when the chip's selling rescue is enrolled in GWA.
 * `shopUrl` is a short-lived signed link that auto-applies the rescue's coupon at the online store.
 */
export type GwaOffer = {
  __typename?: 'GwaOffer';
  /**
   * Offer terms as shown to the adopter, e.g. "6 months free, then $189/yr". Shared with the
   * `/rescue/:slug` landing payload so the two cannot quote different terms for the same gift.
   */
  offer: Scalars['String']['output'];
  rescueName: Scalars['String']['output'];
  shopUrl: Scalars['String']['output'];
};

export type GwaRedemption = {
  __typename?: 'GwaRedemption';
  adopterName: Scalars['String']['output'];
  age?: Maybe<Scalars['String']['output']>;
  breed?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  petName?: Maybe<Scalars['String']['output']>;
  redeemedAt: Scalars['DateTime']['output'];
  /** Where the redemption originated, e.g. `fi_nano_registration` or `shelterluv_registration_email`; null if unknown. */
  source?: Maybe<Scalars['String']['output']>;
};

export type GwaRedemptionSourceCount = {
  __typename?: 'GwaRedemptionSourceCount';
  count: Scalars['Int']['output'];
  source?: Maybe<Scalars['String']['output']>;
};

/**
 * A GWP partner's single-code program (e.g. metlife). The shopper-facing promo code alias resolves
 * server-side to the internal Recurly coupon only for shoppers who visited the partner's landing page.
 */
export type GwpPartnerProgram = {
  __typename?: 'GwpPartnerProgram';
  active: Scalars['Boolean']['output'];
  autoApply: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  internalCouponCode: Scalars['String']['output'];
  promoCodeAlias: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Handset = {
  __typename?: 'Handset';
  /** Admin only */
  client?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dbId: Scalars['Int']['output'];
  /** Admin only */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Admin only */
  deviceToken: Scalars['String']['output'];
  /** Admin only */
  endpointArn: Scalars['String']['output'];
  fromImpersonation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  platform: HandsetPlatform;
  updatedAt: Scalars['DateTime']['output'];
};

export type HandsetLogClient = {
  __typename?: 'HandsetLogClient';
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type HandsetLogDocument = {
  __typename?: 'HandsetLogDocument';
  assignable?: Maybe<Scalars['Boolean']['output']>;
  authCode?: Maybe<Scalars['Int']['output']>;
  baseId?: Maybe<Scalars['String']['output']>;
  client?: Maybe<HandsetLogClient>;
  deviceTypeForSetup?: Maybe<Scalars['String']['output']>;
  logLevel?: Maybe<Scalars['String']['output']>;
  logType?: Maybe<HandsetLogType>;
  logdate: Scalars['DateTime']['output'];
  moduleId?: Maybe<Scalars['String']['output']>;
  msg: Scalars['String']['output'];
  networkName?: Maybe<Scalars['String']['output']>;
  peripheralInfo?: Maybe<HandsetLogPeripheralInfo>;
  results?: Maybe<Array<WifiScanResult>>;
  rssi?: Maybe<Scalars['Int']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type HandsetLogPeripheralInfo = {
  __typename?: 'HandsetLogPeripheralInfo';
  peripheralType?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
};

export enum HandsetLogType {
  ADD_WIFI_CREDENTIALS_ERROR = 'ADD_WIFI_CREDENTIALS_ERROR',
  ADD_WIFI_CREDENTIALS_SUCCESS = 'ADD_WIFI_CREDENTIALS_SUCCESS',
  APP_EXIT = 'APP_EXIT',
  APP_LAUNCH = 'APP_LAUNCH',
  ASSIGNABILITY_RESULT = 'ASSIGNABILITY_RESULT',
  BASE_ASSIGNMENT_FAILURE = 'BASE_ASSIGNMENT_FAILURE',
  BASE_ASSIGNMENT_SUCCESS = 'BASE_ASSIGNMENT_SUCCESS',
  BASE_HANDOFF_FAILURE = 'BASE_HANDOFF_FAILURE',
  BASE_HANDOFF_REQUESTED = 'BASE_HANDOFF_REQUESTED',
  BASE_HANDOFF_SUCCESS = 'BASE_HANDOFF_SUCCESS',
  BASE_WIFI_AUTH_ERROR = 'BASE_WIFI_AUTH_ERROR',
  BASE_WIFI_CONNECT_SUCCESS = 'BASE_WIFI_CONNECT_SUCCESS',
  BASE_WIFI_SCAN_RESULTS = 'BASE_WIFI_SCAN_RESULTS',
  BLE_CONNECTED = 'BLE_CONNECTED',
  BLE_DISCONNECT = 'BLE_DISCONNECT',
  BLE_ERROR = 'BLE_ERROR',
  BLE_OPERATION = 'BLE_OPERATION',
  BLE_READ_INFO = 'BLE_READ_INFO',
  BLE_SCAN_RESULT = 'BLE_SCAN_RESULT',
  BLE_START_CONNECT = 'BLE_START_CONNECT',
  BLE_STATE_SNAPSHOT = 'BLE_STATE_SNAPSHOT',
  CREDENTIAL_PACK_QUERY_ERROR = 'CREDENTIAL_PACK_QUERY_ERROR',
  CREDENTIAL_PACK_QUERY_SUCCESS = 'CREDENTIAL_PACK_QUERY_SUCCESS',
  FEATURE_FLAG_READ = 'FEATURE_FLAG_READ',
  MODULE_ASSIGNMENT_FAILURE = 'MODULE_ASSIGNMENT_FAILURE',
  MODULE_ASSIGNMENT_SUCCESS = 'MODULE_ASSIGNMENT_SUCCESS',
  MODULE_CHARGE_STATE_READ = 'MODULE_CHARGE_STATE_READ',
  MODULE_FIRMWARE_UPDATE_FAILURE = 'MODULE_FIRMWARE_UPDATE_FAILURE',
  MODULE_FIRMWARE_UPDATE_STARTED = 'MODULE_FIRMWARE_UPDATE_STARTED',
  MODULE_FIRMWARE_UPDATE_SUCCESS = 'MODULE_FIRMWARE_UPDATE_SUCCESS',
  MODULE_PROXY_FAILURE = 'MODULE_PROXY_FAILURE',
  MODULE_PROXY_STARTED = 'MODULE_PROXY_STARTED',
  MODULE_PROXY_SUCCESS = 'MODULE_PROXY_SUCCESS',
  READ_BASE_DIAGNOSTIC = 'READ_BASE_DIAGNOSTIC',
  READ_CREDENTIAL_PACK_CHARACTERISTIC_SUCCESS = 'READ_CREDENTIAL_PACK_CHARACTERISTIC_SUCCESS',
  SELECTED_DEVICE_TYPE_FOR_SETUP = 'SELECTED_DEVICE_TYPE_FOR_SETUP',
  SELECTED_ENTER_MANUAL_WIFI_CREDENTIALS = 'SELECTED_ENTER_MANUAL_WIFI_CREDENTIALS',
  SELECTED_WIFI_NETWORK = 'SELECTED_WIFI_NETWORK',
  SELECT_DEVICE_TYPE_FOR_SETUP_PROMPT = 'SELECT_DEVICE_TYPE_FOR_SETUP_PROMPT',
  STARTING_BASE_ASSIGNMENT = 'STARTING_BASE_ASSIGNMENT',
  STARTING_BASE_CONFIGURATION = 'STARTING_BASE_CONFIGURATION',
  STARTING_BASE_WIFI_SCAN = 'STARTING_BASE_WIFI_SCAN',
  STARTING_FI_MINI_SETUP = 'STARTING_FI_MINI_SETUP',
  STARTING_MODULE_ASSIGNMENT = 'STARTING_MODULE_ASSIGNMENT',
  STARTING_MODULE_WIFI_CONFIGURATION = 'STARTING_MODULE_WIFI_CONFIGURATION',
  STARTING_WIFI_CONFIGURATION = 'STARTING_WIFI_CONFIGURATION',
  STARTING_WIFI_SCAN = 'STARTING_WIFI_SCAN',
  SYSTEM_METRIC = 'SYSTEM_METRIC',
  USER_NOTIFICATION = 'USER_NOTIFICATION',
  WEBSOCKET_CONNECTION_FAILURE = 'WEBSOCKET_CONNECTION_FAILURE',
  WEBSOCKET_CONNECTION_SUCCESS = 'WEBSOCKET_CONNECTION_SUCCESS',
  WIFI_AUTH_ERROR = 'WIFI_AUTH_ERROR',
  WIFI_CONNECT_SUCCESS = 'WIFI_CONNECT_SUCCESS',
  WIFI_SCAN_RESULTS = 'WIFI_SCAN_RESULTS',
  WRITE_CREDENTIAL_PACK_CHARACTERISTIC_SUCCESS = 'WRITE_CREDENTIAL_PACK_CHARACTERISTIC_SUCCESS',
}

export enum HandsetPlatform {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
}

export enum HandsetStatus {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  FROM_IMPERSONATION = 'FROM_IMPERSONATION',
}

export type HardwareDefect = {
  __typename?: 'HardwareDefect';
  createdBy?: Maybe<Scalars['String']['output']>;
  defect: DynamicEnumMember;
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoiceSource?: Maybe<InvoiceSource>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

/** Represents current state based on current/past collar reporting: */
export type HasReportsState = PetCollarState & {
  __typename?: 'HasReportsState';
  /** Represents collar-specific state (i.e. online/offline) */
  collarStatus: CollarStatus;
  /** Current Lost Dog Mode state. */
  ldmState: CollarLostDogModeState;
  /** Represents the latest activity at the time */
  ongoingActivity: OngoingActivity;
  timestamp: Scalars['DateTime']['output'];
};

export type HealthGptChatMessage = {
  __typename?: 'HealthGptChatMessage';
  disclaimer?: Maybe<HealthGptChatMessageDisclaimer>;
  id: Scalars['ID']['output'];
  request: HealthGptChatMessageRequest;
  response: HealthGptChatMessageResponse;
  userFeedback?: Maybe<HealthGptChatMessageUserFeedback>;
};

export type HealthGptChatMessageDisclaimer = {
  __typename?: 'HealthGptChatMessageDisclaimer';
  message: Scalars['String']['output'];
};

export type HealthGptChatMessageRequest = {
  __typename?: 'HealthGptChatMessageRequest';
  message: Scalars['String']['output'];
};

export type HealthGptChatMessageResponse = {
  __typename?: 'HealthGptChatMessageResponse';
  message: Scalars['String']['output'];
};

export type HealthGptChatMessageUserFeedback = {
  __typename?: 'HealthGptChatMessageUserFeedback';
  feedback?: Maybe<Scalars['String']['output']>;
  wasHelpful: Scalars['Boolean']['output'];
};

export type HealthGptChatThread = {
  __typename?: 'HealthGptChatThread';
  messages: Array<HealthGptChatMessage>;
};

export enum HealthGptDocumentStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  READY = 'READY',
}

export enum HealthGptMemoryCategory {
  BEHAVIOR = 'BEHAVIOR',
  DIET = 'DIET',
  GOAL = 'GOAL',
  HEALTH = 'HEALTH',
  HOME = 'HOME',
  OTHER = 'OTHER',
  ROUTINE = 'ROUTINE',
}

export enum HealthGptMemoryStatus {
  ACTIVE = 'ACTIVE',
  DELETED_BY_ADMIN = 'DELETED_BY_ADMIN',
  DELETED_BY_USER = 'DELETED_BY_USER',
  EXPIRED = 'EXPIRED',
  REJECTED = 'REJECTED',
  SUPERSEDED = 'SUPERSEDED',
}

export type HealthGptPlaybook = {
  __typename?: 'HealthGptPlaybook';
  appliesWhen: Scalars['String']['output'];
  /** Null targets everyone; otherwise routing is restricted to these users/groups */
  audience?: Maybe<HealthGptPlaybookAudience>;
  /** Minimum router confidence (0-1) required for this playbook to act */
  confidenceThreshold: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** Optional mapping to the eval taxonomy, for router-vs-eval disagreement metrics */
  evalCategories?: Maybe<Array<EvalClassification>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  promptSection?: Maybe<Scalars['String']['output']>;
  responseMode: HealthGptPlaybookResponseMode;
  retrievalConfig: HealthGptPlaybookRetrievalConfig;
  terminalResponseTemplate?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** Restricts which users a playbook routes for. Null targets everyone; otherwise the listed user ids or any listed group. */
export type HealthGptPlaybookAudience = {
  __typename?: 'HealthGptPlaybookAudience';
  userGroups: Array<Scalars['String']['output']>;
  userIds: Array<Scalars['Int']['output']>;
};

export type HealthGptPlaybookAudienceInput = {
  userGroups: Array<Scalars['String']['input']>;
  userIds: Array<Scalars['Int']['input']>;
};

/**
 * A retrieval source playbooks can toggle. The set is code-defined; dashboards should render
 * "Data sources" toggles from this list rather than hardcoding source names.
 */
export type HealthGptPlaybookDataSource = {
  __typename?: 'HealthGptPlaybookDataSource';
  /** Default prompt for the source's LLM step, for the admin to start from. Null when supportsPrompt is false. */
  defaultPrompt?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  /** Whether this source runs an LLM step whose prompt a playbook can override. */
  supportsPrompt: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type HealthGptPlaybookDataSourceConfig = {
  __typename?: 'HealthGptPlaybookDataSourceConfig';
  enabled: Scalars['Boolean']['output'];
  /** Extra instruction appended to the source's default LLM-step prompt (only sources with supportsPrompt). Null adds nothing. */
  prompt?: Maybe<Scalars['String']['output']>;
};

export type HealthGptPlaybookDataSourceConfigInput = {
  enabled: Scalars['Boolean']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
};

export enum HealthGptPlaybookResponseMode {
  /** Retrieve data and synthesize a personalized answer */
  RAG = 'RAG',
  /** Return the templated direct reply without retrieval or synthesis */
  TERMINAL = 'TERMINAL',
}

export type HealthGptPlaybookRetrievalConfig = {
  __typename?: 'HealthGptPlaybookRetrievalConfig';
  breedIllness: HealthGptPlaybookDataSourceConfig;
  breedSummary: HealthGptPlaybookDataSourceConfig;
  graphql: HealthGptPlaybookDataSourceConfig;
  knowledgeBase: HealthGptPlaybookDataSourceConfig;
  petDetails: HealthGptPlaybookDataSourceConfig;
  petDocuments: HealthGptPlaybookDataSourceConfig;
};

export type HealthGptPlaybookRetrievalConfigInput = {
  breedIllness: HealthGptPlaybookDataSourceConfigInput;
  breedSummary: HealthGptPlaybookDataSourceConfigInput;
  graphql: HealthGptPlaybookDataSourceConfigInput;
  knowledgeBase: HealthGptPlaybookDataSourceConfigInput;
  petDetails: HealthGptPlaybookDataSourceConfigInput;
  petDocuments: HealthGptPlaybookDataSourceConfigInput;
};

export type HealthGptSuggestedQuestion = {
  __typename?: 'HealthGptSuggestedQuestion';
  question: Scalars['String']['output'];
};

export type HealthMetricBin = {
  __typename?: 'HealthMetricBin';
  count: Scalars['Int']['output'];
  grade?: Maybe<HealthMetricGrade>;
  value: Scalars['Float']['output'];
};

export type HealthMetricBinnedValues = {
  __typename?: 'HealthMetricBinnedValues';
  custom?: Maybe<HealthMetricRollupBinnedValues>;
  rollup7d?: Maybe<HealthMetricRollupBinnedValues>;
  rollup24h?: Maybe<HealthMetricRollupBinnedValues>;
  rollup28d?: Maybe<HealthMetricRollupBinnedValues>;
};

export enum HealthMetricGrade {
  GOOD = 'GOOD',
  PROBLEM = 'PROBLEM',
  WARNING = 'WARNING',
}

export type HealthMetricRollupBinnedValues = {
  __typename?: 'HealthMetricRollupBinnedValues';
  values: Array<HealthMetricBin>;
};

export type HealthMetricValue = {
  __typename?: 'HealthMetricValue';
  grade?: Maybe<HealthMetricGrade>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type HealthRollupValues = {
  __typename?: 'HealthRollupValues';
  custom?: Maybe<HealthMetricValue>;
  rollup7d?: Maybe<HealthMetricValue>;
  rollup24h?: Maybe<HealthMetricValue>;
  rollup28d?: Maybe<HealthMetricValue>;
};

/**
 * This enum facilitates the heatmap functionality. Since PLAY activities
 * are a complete subset of REST activities, and are stored in the database
 * as REST activities, PLAY filtering has been excluded from heatmap generation.
 */
export enum HeatmapActivityType {
  MISSING_REPORTS = 'MISSING_REPORTS',
  REST = 'REST',
  TRAVEL = 'TRAVEL',
  WALK = 'WALK',
}

export type HeatmapData = {
  __typename?: 'HeatmapData';
  points: Array<HeatmapPoint>;
};

/**
 * A heatmap point returned by the system will include the position of the point along with
 * a logarithmically normalized intensity between 0 and 1. This will be based on the size of the point cluster. 0 points
 * should still be rendered at the bottom end of the scale as they are still significant, and represent the minimum value.
 */
export type HeatmapPoint = {
  __typename?: 'HeatmapPoint';
  intensity: Scalars['Float']['output'];
  position: Position;
};

export type HelpCenterLink = {
  __typename?: 'HelpCenterLink';
  displayText: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type HourlySleepBar = {
  __typename?: 'HourlySleepBar';
  /** The number of minutes the pet was resting within this hour. */
  minutesResting: Scalars['Int']['output'];
  /** Percent of time period pet was resting (0-1). */
  percentResting: Scalars['Float']['output'];
  /** Start of the period of sleep (note end = this + 1 hour). */
  start: Scalars['DateTime']['output'];
  type: SleepType;
};

export type Household = {
  __typename?: 'Household';
  bases: Array<ChargingBase>;
  /** Boarding facility pets that have previously checked into the facility on the Fi app. */
  boardingPets: BoardingFacilityPetFeed;
  credentialUpdateForDevice?: Maybe<CredentialUpdate>;
  dbId: Scalars['Int']['output'];
  following: StrangerPetFeed;
  id: Scalars['ID']['output'];
  invites: Array<UserInvite>;
  menuHeader: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pets: Array<Pet>;
  /**
   * Paginated/filterable view over the pets in this household.
   * Set `limit` to cap the page size and `pagingInstruction` to scroll.
   * Pass `filters` to narrow (e.g. HAS_DEVICE).
   */
  petsFeed: PetFeed;
  places: Array<Place>;
  /**
   * The household name as stored in the database, with no auto-generated default
   * fallback (admin tooling needs to know whether the operator actually set a name).
   * Use `name` for user-facing display where the "<First name>'s Pack" fallback is
   * desired.
   */
  rawName?: Maybe<Scalars['String']['output']>;
  socialOptedOut: Scalars['Boolean']['output'];
  suggestedVets: Array<Veterinary>;
  /** True iff any collar in this household supports containment; gates containment UI. */
  supportsContainment: Scalars['Boolean']['output'];
  tenancy?: Maybe<Scalars['String']['output']>;
  thirdPartyAccess?: Maybe<Scalars['String']['output']>;
  type: HouseholdType;
  users: Array<HouseholdUser>;
  vets: Array<Veterinary>;
  wifiNetworks: WifiNetworks;
};

export type HouseholdboardingPetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type HouseholdcredentialUpdateForDeviceArgs = {
  currentHash?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['ID']['input'];
};

export type HouseholdfollowingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type HouseholdinvitesArgs = {
  state?: InputMaybe<InviteState>;
};

export type HouseholdpetsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HouseholdpetsFeedArgs = {
  filters?: InputMaybe<Array<PetFilter>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type HouseholdusersArgs = {
  role?: InputMaybe<UserHouseholdRole>;
};

export type HouseholdInvite = {
  __typename?: 'HouseholdInvite';
  role: UserHouseholdRole;
};

export type HouseholdInviteInput = {
  householdId: Scalars['ID']['input'];
  role: UserHouseholdRole;
};

export enum HouseholdType {
  BOARDING = 'BOARDING',
  FOSTER = 'FOSTER',
  RESCUE = 'RESCUE',
  STANDARD = 'STANDARD',
}

export type HouseholdUser = {
  __typename?: 'HouseholdUser';
  adminUnderlyingUser: User;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** @deprecated Use id2 for a unique id or userId for the User.id */
  id: Scalars['ID']['output'];
  /** id was returning the User.id before which was not unique across HouseholdUsers, this is a unique ID */
  id2: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role: UserHouseholdRole;
  userId: Scalars['ID']['output'];
};

export type Image = {
  __typename?: 'Image';
  fullSize?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is a duplicate of `fullSize` and only adds to confusion on client-side. */
  id: Scalars['ID']['output'];
  /**
   * Returns a URL that is a best effort to resize the image to the specified dimensions.
   * The image may not be able to be resized, and the dimensions may be snapped to nearby
   * prespecified dimensions. Clients should still resize the image as they see fit when
   * they get it.
   */
  nearestResized: Scalars['String']['output'];
};

export type ImagenearestResizedArgs = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type InAppPromotionBanner = {
  id: Scalars['ID']['output'];
};

export type InPersonEvent = {
  __typename?: 'InPersonEvent';
  closed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  startingInventory: Scalars['JSON']['output'];
  status: InPersonEventStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type InPersonEventQuery = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum InPersonEventStatus {
  PAST = 'PAST',
  PLANNED = 'PLANNED',
}

export enum IncentiveType {
  BASE = 'BASE',
  EVENING_WALK = 'EVENING_WALK',
  MORNING_WALK = 'MORNING_WALK',
}

export type Insight = PetInsight | PetInsightWithoutGraph;

export type InsightLeadingImage = {
  __typename?: 'InsightLeadingImage';
  displayHeight: Scalars['Int']['output'];
  displayWidth: Scalars['Int']['output'];
  image: Image;
};

export type IntelligenceInsight = {
  __typename?: 'IntelligenceInsight';
  body: Scalars['String']['output'];
  icons: Array<Image>;
  id: Scalars['ID']['output'];
  prompt: Scalars['String']['output'];
};

export type IntelligenceTeaser = {
  __typename?: 'IntelligenceTeaser';
  prompts: Array<HealthGptSuggestedQuestion>;
};

export type InvalidToken = {
  __typename?: 'InvalidToken';
  /** GraphQL doesn't allow empty types; this is a bogus field that will always be null. */
  invalid?: Maybe<Scalars['Boolean']['output']>;
};

export type InventoryConfiguration = {
  __typename?: 'InventoryConfiguration';
  /** whether this warehouse should be allowed to fulfill this sku */
  allowFulfillment: Scalars['Boolean']['output'];
  backInStockDateOverride?: Maybe<Scalars['DateTime']['output']>;
  /** whether just-in-time kitting is eligible for this sku at this warehouse */
  eligibleForJustInTimeKitting: Scalars['Boolean']['output'];
  estimatedBackInStockDate?: Maybe<Scalars['DateTime']['output']>;
  fulfillmentWarehouse: FulfillmentWarehouse;
  id: Scalars['ID']['output'];
  /** whether just-in-time kitting is enabled for this sku at this warehouse */
  justInTimeKittingEnabled: Scalars['Boolean']['output'];
  nextOrMostRecentShipmentId?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
};

export enum InviteState {
  ACCEPTED = 'ACCEPTED',
  EXPIRED = 'EXPIRED',
  OUTSTANDING = 'OUTSTANDING',
  REVOKED = 'REVOKED',
}

export type InviteUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Can consider making this nullable if we support other types of invites. */
  householdInvite: HouseholdInviteInput;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  suppressSms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InviteUserToHouseholdResult = {
  __typename?: 'InviteUserToHouseholdResult';
  household: Household;
  inviteMessage: Scalars['String']['output'];
  inviteUrl: Scalars['String']['output'];
  /**
   * If a user account exists with that phone number, that user is immediately
   * added to the household and returned here.
   */
  user?: Maybe<HouseholdUser>;
};

export type Invoice = {
  __typename?: 'Invoice';
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  /**
   * This technically shouldn't be part of Invoice but we need to return it from createPurchase.
   * It'd be better if createPurchase returned its own specific CreatePurchaseResult, but
   * holding off on that migration for now.
   */
  isReturningCustomer: Scalars['Boolean']['output'];
};

export type InvoiceMarkFailedInput = {
  cancelAssociatedSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  ecomConfigType?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber: Scalars['String']['input'];
};

export type InvoiceRefundInput = {
  ecomConfigType?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber: Scalars['String']['input'];
  refundLineItems?: InputMaybe<Array<LineItemRefundInput>>;
};

export enum InvoiceRetryStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  SUCCEEDED = 'SUCCEEDED',
}

export enum InvoiceSource {
  CHEWY = 'CHEWY',
  RECURLY = 'RECURLY',
}

/**
 * Flat invoice summary for the email-keyed invoicesList query. Superset of
 * AccountInvoiceSummary with the amounts commerce-support verification needs
 * (tax, refundable balance, renewal flag, linked subscriptions).
 */
export type InvoiceSummary = {
  __typename?: 'InvoiceSummary';
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRenewal: Scalars['Boolean']['output'];
  number: Scalars['String']['output'];
  origin?: Maybe<Scalars['String']['output']>;
  refundableAmountInDollars: Scalars['Float']['output'];
  state: Scalars['String']['output'];
  subscriptionIds: Array<Scalars['String']['output']>;
  taxInDollars: Scalars['Float']['output'];
  totalInDollars: Scalars['Float']['output'];
};

export type JoinedDogPark = {
  __typename?: 'JoinedDogPark';
  dogPark: DogPark;
  /** When the most recent of those pets joined. Null once every pet has left. */
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The pets from the requested set that have joined this park. */
  pets: Array<Pet>;
};

/** Which pets to report joined parks for. Exactly one of userId or petIds must be set. */
export type JoinedDogParksInput = {
  /** Just these pets. */
  petIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Every dog in this user's households. Passing a user other than yourself requires admin or
   * customer support access.
   */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type Label = {
  __typename?: 'Label';
  subtext?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/**
 * ClickHouse-backed activity leaderboard (the weekly competition and rolling
 * windows). Distinct from the legacy pack-based rankings served by packMemberFeed.
 */
export type Leaderboard = {
  __typename?: 'Leaderboard';
  entries: Array<LeaderboardEntry>;
  week?: Maybe<LeaderboardWeek>;
  window: RankingWindow;
};

/** A pet's placement within a leaderboard page. */
export type LeaderboardEntry = {
  __typename?: 'LeaderboardEntry';
  /** Number of underlying events that contributed to the score. */
  events: Scalars['Int']['output'];
  pet: StrangerPet;
  /** 1-based rank in the full leaderboard. Ranks can skip values where hidden (social-off) pets were removed from the page. */
  rank: Scalars['Int']['output'];
  /** Total for the window's metric (e.g. steps). */
  score: Scalars['Float']['output'];
};

/** One board card on the leaderboards home screen. */
export type LeaderboardHomeBoard = {
  __typename?: 'LeaderboardHomeBoard';
  /** Weekly rank; null when unranked, with unrankedReason saying why. */
  rank?: Maybe<Scalars['Int']['output']>;
  /** Pass straight through to `leaderboard` / `petRanking` to open this board. */
  scope: LeaderboardScope;
  slice: LeaderboardSlice;
  /** Display title in the viewer's locale: "Puppies", "Ohio", "Cleveland, OH", "Chihuahua". */
  title: Scalars['String']['output'];
  unrankedReason?: Maybe<LeaderboardUnrankedReason>;
};

/**
 * A geographic slice for a leaderboard, from country-wide down to a single city.
 * Values come from the rankings discovery endpoint; omit for a global (all-locations) board.
 * Filters combine, so passing more than one narrows the board.
 */
export type LeaderboardLocation = {
  city?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 alpha-2 country code. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-2 subdivision code (e.g. "US-OH"); a bare abbreviation like "OH" matches nothing. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Second-level subdivision code in the country's own scheme (US: county FIPS, e.g. "48453"). */
  subdivision2?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A pet's own placement on one weekly leaderboard. Carries no display name —
 * clients derive it from the pet's breed / homeLocation / ageRange fields, the
 * same keys the board is sliced by.
 */
export type LeaderboardPlacement = {
  __typename?: 'LeaderboardPlacement';
  /** Weekly rank; null when the pet is unranked on that board this week. */
  rank?: Maybe<Scalars['Int']['output']>;
  slice: LeaderboardSlice;
};

/** The filters a board is sliced by, shaped as the arguments `leaderboard` and `petRanking` take. */
export type LeaderboardScope = {
  __typename?: 'LeaderboardScope';
  breedId?: Maybe<Scalars['ID']['output']>;
  lifeStage?: Maybe<AgeRange>;
  location?: Maybe<LeaderboardScopeLocation>;
  /** Set on a PACK board; ranks the pack's members as a cohort. Stands alone — never combined with the other filters. */
  packId?: Maybe<Scalars['ID']['output']>;
};

/** Output twin of the LeaderboardLocation input. */
export type LeaderboardScopeLocation = {
  __typename?: 'LeaderboardScopeLocation';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** ISO 3166-2 subdivision code (e.g. "US-OH"). */
  state?: Maybe<Scalars['String']['output']>;
  subdivision2?: Maybe<Scalars['String']['output']>;
};

/** The board dimension a pet's leaderboard placement is computed within. */
export enum LeaderboardSlice {
  BREED = 'BREED',
  CITY = 'CITY',
  LIFE_STAGE = 'LIFE_STAGE',
  PACK = 'PACK',
  STATE = 'STATE',
}

/** Why a pet has no rank on a board this week. */
export enum LeaderboardUnrankedReason {
  /** Some steps this week, but under the score floor (LeaderboardsHome.minRankedSteps). */
  BELOW_SCORE_FLOOR = 'BELOW_SCORE_FLOOR',
  /** No steps recorded this week. */
  NO_ACTIVITY = 'NO_ACTIVITY',
}

/** Week boundary metadata, present only when window = WEEKLY. */
export type LeaderboardWeek = {
  __typename?: 'LeaderboardWeek';
  /** ISO 8601 end of the week window; null for the current (still-open) week. */
  end?: Maybe<Scalars['String']['output']>;
  /** 0 = current week, 1 = last week, etc. */
  offset: Scalars['Int']['output'];
  /**
   * True when the week's earliest days have aged past the service's 180-day retention,
   * so totals may be undercounted. This does NOT indicate the current week — that's a null `end`.
   */
  partial: Scalars['Boolean']['output'];
  /** ISO 8601 start of the week window. */
  start?: Maybe<Scalars['String']['output']>;
};

/**
 * The leaderboards home screen for one pet, resolved server-side: the boards the pet is on, already
 * filtered to those with enough participants to render and ordered best rank first.
 */
export type LeaderboardsHome = {
  __typename?: 'LeaderboardsHome';
  boards: Array<LeaderboardHomeBoard>;
  /** Weekly steps a pet needs before any board ranks it. */
  minRankedSteps: Scalars['Int']['output'];
  /** Steps so far this week, counted even below the score floor. */
  stepsThisWeek: Scalars['Int']['output'];
  week: LeaderboardWeek;
};

export type LedColor = {
  __typename?: 'LedColor';
  hexCode: Scalars['String']['output'];
  ledColorCode: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type LimitedAdminUserProfile = AdminBaseUserProfile & {
  __typename?: 'LimitedAdminUserProfile';
  automaticallyActivateDevices: Scalars['Boolean']['output'];
  billingAccount?: Maybe<BillingAccount>;
  chipReseller?: Maybe<ChipReseller>;
  dbId: Scalars['Int']['output'];
  deactivated: Scalars['Boolean']['output'];
  ecommerceOrders: Array<Order>;
  email: Scalars['String']['output'];
  emails: Array<UserEmail>;
  fiNewsNotificationsEnabled: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  groups: Array<UserGroup>;
  handsets: Array<Handset>;
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  /** Admin tags on devices in households this user owns, deduplicated. */
  ownedDeviceTags: Array<DeviceTag>;
  /**
   * Paginated view over every pet in this user's households, ordered collar-first.
   * Mirrors User.petsFeed.
   */
  petsFeed: PetFeed;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  referrals: Referrals;
  region?: Maybe<FiCountry>;
  rmas: Array<RMA>;
  settings: UserSettings;
  socialBanned: Scalars['Boolean']['output'];
  /** Returns all feature flag values by default, but can optionally provide an array of feature flag names to return */
  targetedFeatureFlags: Array<TargetedFeatureFlag>;
  tenancy?: Maybe<Scalars['String']['output']>;
  thirdPartyAccess?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
  userHouseholds: Array<UserHousehold>;
};

export type LimitedAdminUserProfilegroupsArgs = {
  excludePseudo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LimitedAdminUserProfilehandsetsArgs = {
  status?: InputMaybe<Array<HandsetStatus>>;
};

export type LimitedAdminUserProfilepetsFeedArgs = {
  filters?: InputMaybe<Array<PetFilter>>;
  householdType?: InputMaybe<HouseholdType>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type LimitedAdminUserProfiletargetedFeatureFlagsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LineItem = {
  __typename?: 'LineItem';
  account: BillingAccountMini;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  isPhysicalProduct: Scalars['Boolean']['output'];
  orderStatus?: Maybe<OrderLineItemStatus>;
  productCode: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  returned: Scalars['Boolean']['output'];
  /** Look up serial numbers associated with this line item using Tagg shipping information. */
  serialNumbers: Array<Scalars['String']['output']>;
  /**
   * When invoice line item is for a physical product subscription (e.g. supplements), skuToShip will be the
   * sku of the physical product that needs to be shipped.
   */
  skuToShip: Scalars['String']['output'];
  subItems: Array<LineSubItem>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  subtotal: Scalars['Float']['output'];
};

export type LineItemInput = {
  /**
   * If the item being purchased is a SubscriptionBundle, the `id` will be the SKU for the
   * bundle and this field should be set to the SKU of the bundled product being purchased
   * (e.g. collar variant).
   */
  bundledProductSku?: InputMaybe<Scalars['String']['input']>;
  /** Extra data for a gift card line item, about to whom it is going to be delivered. */
  giftCardDelivery?: InputMaybe<GiftCardDeliveryInput>;
  id: Scalars['ID']['input'];
  /**
   * A module ID associated with this line item in some way. Affects different types
   * of products differently. If the product is a subscription, the `moduleId` will cause
   * the plan to be immediately associated with the specified module.
   */
  moduleId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type LineItemRefundInput = {
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<RefundType>;
};

export type LineSubItem = {
  __typename?: 'LineSubItem';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']['output']>;
  /** Altitude in meters */
  altitude?: Maybe<Scalars['Float']['output']>;
  date: Scalars['DateTime']['output'];
  /** Accuracy radius in meters */
  errorRadius?: Maybe<Scalars['Float']['output']>;
  /** Value from 0-360 where 0 represents true north */
  heading?: Maybe<Scalars['Float']['output']>;
  /** `Place` in which this `Location` is contained. */
  place?: Maybe<Place>;
  position: Position;
};

/**
 * A single location report from a device
 * !! IMPORTANT: This should never be exposed to or used by non-admin clients,
 * since it has a monotonically increasing ID (not a UUID).
 */
export type LocationReport = {
  __typename?: 'LocationReport';
  accuracyRadius: Scalars['Float']['output'];
  altitude?: Maybe<Scalars['Float']['output']>;
  attributes: Scalars['JSON']['output'];
  /** The single backhaul this report was delivered over. */
  backhaul?: Maybe<ReportBackhaul>;
  /**
   * Every location source that was available when the engine chose this report's position, each with the
   * position it resolved to and whether it was selected as the dog's location. Empty only for reports
   * ingested before this was recorded; when the chosen position was carried over from a previous report the
   * candidates are still listed but none is marked selected (see overrideReason).
   */
  candidateLocationSources: Array<CandidateLocationSource>;
  /**
   * All backhauls the device was connected to at report time (includes `backhaul`).
   * Best-effort: inferred from the connection submodules present in the report.
   */
  connectedBackhauls: Array<ReportBackhaul>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  detectedActivityType?: Maybe<DetectedActivityType>;
  device: Device;
  id: Scalars['ID']['output'];
  ignoreReason?: Maybe<Scalars['String']['output']>;
  location: Location;
  /** Places (safe-zones) this location report overlaps with. */
  overlappingPlaces: Array<Place>;
  /** Points of interest (e.g. dog parks) this location report overlaps with. */
  pois?: Maybe<Array<DogPark>>;
  position: Position;
  reporter?: Maybe<User>;
  source: LocationSource;
};

export type LocationReportInput = {
  altitude?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED: Use `connectedWifiInput` instead */
  connectedToSsid?: InputMaybe<Scalars['String']['input']>;
  connectedWifiInput?: InputMaybe<ConnectedWifiInput>;
  date: Scalars['DateTime']['input'];
  horizontalAccuracy: Scalars['Float']['input'];
  params?: InputMaybe<Scalars['JSON']['input']>;
  position: PositionInput;
  recentlySeenBases?: InputMaybe<Array<RecentlySeenBaseInput>>;
  /** @deprecated The backend determines the source of a location report */
  source?: InputMaybe<Scalars['String']['input']>;
  verticalAccuracy?: InputMaybe<Scalars['Float']['input']>;
};

export type LocationScrubberData = {
  __typename?: 'LocationScrubberData';
  points: Array<LocationScrubberPoint>;
  safeZoneExits: Array<LocationScrubberSafeZoneExit>;
  segments: Array<LocationScrubberSegment>;
};

/**
 * A point in a location scrubber timeline containing a position and the unix
 * timestamp (milliseconds since epoch) at which the position was recorded.
 */
export type LocationScrubberPoint = {
  __typename?: 'LocationScrubberPoint';
  activityType: ActivityType;
  /**
   * Behavior active at this timestamp. Null when no behavior is active or the overlay is disabled.
   * Allowed values are 'scratching', 'cleaning_self', 'drinking', 'eating', 'barking' (matches the
   * identifiers used elsewhere in the schema, e.g. SubmitObservedBehaviorInput.behavior). Modeled as
   * String rather than an enum so new detected behaviors can be added without a client schema bump.
   * Behaviors are mutually exclusive per time segment by the detection pipeline's design.
   */
  behavior?: Maybe<Scalars['String']['output']>;
  position: Position;
  /** Unix timestamp in milliseconds since epoch. */
  timestamp: Scalars['Float']['output'];
};

/**
 * An instant at which the pet left a safe zone. Unlike segments these have no duration — the
 * client renders them as markers on the scrubber. `withUser` is true when the pet was recorded
 * leaving alongside one of its people rather than escaping on its own.
 */
export type LocationScrubberSafeZoneExit = {
  __typename?: 'LocationScrubberSafeZoneExit';
  placeId?: Maybe<Scalars['ID']['output']>;
  placeName?: Maybe<Scalars['String']['output']>;
  /** Unix timestamp in milliseconds since epoch. */
  timestamp: Scalars['Float']['output'];
  withUser: Scalars['Boolean']['output'];
};

/**
 * A surfaced activity occupying a half-open time interval [start, end). Unlike points, these are
 * the authoritative segment boundaries: clients render bands directly from them and treat the time
 * between consecutive segments as unfilled. REST segments are clipped to overnight sleep windows
 * (matching the per-point filter); MISSING_REPORTS segments are included as real device-offline gaps.
 */
export type LocationScrubberSegment = {
  __typename?: 'LocationScrubberSegment';
  activityType: ActivityType;
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

/**
 * How the coordinates of a location report were determined. Mirrors the internal `LocationSourceName`
 * set; values are UPPER_SNAKE_CASE (GraphQL enum names can't contain hyphens) — e.g. `DEVICE_GNSS`
 * corresponds to the internal `device-gnss`. `UNKNOWN` covers any unrecognized stored source.
 */
export enum LocationSource {
  BASE = 'BASE',
  DEVICE_CELLLOOKUP = 'DEVICE_CELLLOOKUP',
  DEVICE_GNSS = 'DEVICE_GNSS',
  MCELL_LOOKUP = 'MCELL_LOOKUP',
  MOBILE = 'MOBILE',
  SIDEWALK_LOOKUP = 'SIDEWALK_LOOKUP',
  UNKNOWN = 'UNKNOWN',
  WEARABLE = 'WEARABLE',
  WIFI = 'WIFI',
  WIFI_LOOKUP = 'WIFI_LOOKUP',
}

export enum LogLevel {
  DEBUG = 'DEBUG',
  ERROR = 'ERROR',
  INFO = 'INFO',
  VERBOSE = 'VERBOSE',
  WARNING = 'WARNING',
}

export type LowLTESignalDeviceInfo = {
  __typename?: 'LowLTESignalDeviceInfo';
  rsrq: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
};

/** Result of manual subscription creation */
export type ManualSubscriptionResult = {
  __typename?: 'ManualSubscriptionResult';
  /** Applied discount in cents. Will be 0 for future-dated subscriptions. */
  discountInCents: Scalars['Int']['output'];
  /**
   * Generated invoice. Will be null for future-dated subscriptions since the
   * customer is not charged until the subscription starts.
   */
  invoice?: Maybe<RecurlyInvoice>;
  /** Created subscription */
  subscription: BillingSubscription;
  /** Total amount charged in cents. Will be 0 for future-dated subscriptions. */
  totalChargedInCents: Scalars['Int']['output'];
};

export type MapMatchedPath = {
  __typename?: 'MapMatchedPath';
  path: Array<Position>;
};

export type MapPath = MapMatchedPath | UnmatchedPath;

export enum MapStyle {
  ACTIVITY_CARD = 'ACTIVITY_CARD',
  LEGACY = 'LEGACY',
}

/**
 * Membership prepay option for product transfers.
 * Charges customer upfront and extends their subscription renewal date.
 */
export enum MembershipPrepayOption {
  NONE = 'NONE',
  SIX_MONTHS = 'SIX_MONTHS',
  TWENTY_FOUR_MONTHS = 'TWENTY_FOUR_MONTHS',
}

export type MigrateModulesToFirmwareChannelResult = {
  __typename?: 'MigrateModulesToFirmwareChannelResult';
  /** The number of records that were updated. */
  numUpdated: Scalars['Int']['output'];
};

export type MissedLocationReport = {
  __typename?: 'MissedLocationReport';
  numberOfSecondsBehind: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type MissingReports = Activity & {
  __typename?: 'MissingReports';
  address?: Maybe<Scalars['String']['output']>;
  areaName?: Maybe<Scalars['String']['output']>;
  cityState?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use likeCount */
  clapCount: Scalars['Int']['output'];
  dbId: Scalars['Int']['output'];
  debugMetadata: Scalars['JSON']['output'];
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use isLikable */
  isClappable: Scalars['Boolean']['output'];
  isLikable: Scalars['Boolean']['output'];
  likeCount: Scalars['Int']['output'];
  neighborhood?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  obfuscated: Scalars['Boolean']['output'];
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']['output']>;
  start: Scalars['DateTime']['output'];
  totalSteps: Scalars['Int']['output'];
};

export type MobileAppBanner = MobileAppBannerInterface & {
  __typename?: 'MobileAppBanner';
  backgroundColorHex: Scalars['HexColorCode']['output'];
  borderGradient?: Maybe<MobileAppBannerBorderGradient>;
  darkModeBackgroundColorHex?: Maybe<Scalars['HexColorCode']['output']>;
  darkModeForegroundColorHex?: Maybe<Scalars['HexColorCode']['output']>;
  /** @deprecated Use formattedDescription instead */
  description: Scalars['String']['output'];
  destinationUrl: Scalars['String']['output'];
  dismissOnTap: Scalars['Boolean']['output'];
  dismissalTriggerId?: Maybe<Scalars['ID']['output']>;
  dismissible: Scalars['Boolean']['output'];
  dismissibleAfterSeconds?: Maybe<Scalars['Int']['output']>;
  foregroundColorHex: Scalars['HexColorCode']['output'];
  formattedDescription: FormatString;
  formattedTitle: FormatString;
  id: Scalars['ID']['output'];
  leadingImage?: Maybe<MobileAppBannerImage>;
  /** @deprecated Use formattedDescription instead */
  title: Scalars['String']['output'];
};

export type MobileAppBannerBorderGradient = {
  __typename?: 'MobileAppBannerBorderGradient';
  animationDurationSeconds?: Maybe<Scalars['Float']['output']>;
  animationRepeatCount?: Maybe<Scalars['Int']['output']>;
  animationRepeatStyle: MobileAppBannerGradientAnimationRepeatStyle;
  rotationDirection: MobileAppBannerGradientRotationDirection;
  startAngleDegrees: Scalars['Float']['output'];
  stops: Array<MobileAppBannerGradientStop>;
};

export type MobileAppBannerBorderGradientInput = {
  animationDurationSeconds?: InputMaybe<Scalars['Float']['input']>;
  animationRepeatCount?: InputMaybe<Scalars['Int']['input']>;
  animationRepeatStyle?: InputMaybe<MobileAppBannerGradientAnimationRepeatStyle>;
  rotationDirection?: InputMaybe<MobileAppBannerGradientRotationDirection>;
  startAngleDegrees?: InputMaybe<Scalars['Float']['input']>;
  stops: Array<MobileAppBannerGradientStopInput>;
};

export enum MobileAppBannerGradientAnimationRepeatStyle {
  DONT_REPEAT = 'DONT_REPEAT',
  INDEFINITELY = 'INDEFINITELY',
  NUMBER_OF_TIMES = 'NUMBER_OF_TIMES',
}

export enum MobileAppBannerGradientRotationDirection {
  CLOCKWISE = 'CLOCKWISE',
  COUNTER_CLOCKWISE = 'COUNTER_CLOCKWISE',
}

export type MobileAppBannerGradientStop = {
  __typename?: 'MobileAppBannerGradientStop';
  colorHex: Scalars['HexColorCode']['output'];
  darkModeColorHex?: Maybe<Scalars['HexColorCode']['output']>;
  location: Scalars['Float']['output'];
};

export type MobileAppBannerGradientStopInput = {
  colorHex: Scalars['HexColorCode']['input'];
  darkModeColorHex?: InputMaybe<Scalars['HexColorCode']['input']>;
  location: Scalars['Float']['input'];
};

export type MobileAppBannerImage = {
  __typename?: 'MobileAppBannerImage';
  displayHeight: Scalars['Int']['output'];
  displayWidth: Scalars['Int']['output'];
  image: Image;
  renderingMode: MobileAppBannerImageRenderingMode;
};

export type MobileAppBannerImageInput = {
  displayHeight: Scalars['Int']['input'];
  displayWidth: Scalars['Int']['input'];
  renderingMode?: MobileAppBannerImageRenderingMode;
  url: Scalars['String']['input'];
};

export enum MobileAppBannerImageRenderingMode {
  ORIGINAL = 'ORIGINAL',
  TEMPLATE = 'TEMPLATE',
}

export type MobileAppBannerInterface = {
  backgroundColorHex: Scalars['HexColorCode']['output'];
  description: Scalars['String']['output'];
  destinationUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  leadingImage?: Maybe<MobileAppBannerImage>;
  title: Scalars['String']['output'];
};

export type MobileAppBlockerScreen = MobileAppBlockerScreenInterface & {
  __typename?: 'MobileAppBlockerScreen';
  bottomSheet: MobileAppBlockerScreenBottomSheet;
  dismissalTriggerId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  pages: Array<MobileAppBlockerScreenPage>;
};

export type MobileAppBlockerScreenBottomSheet = {
  __typename?: 'MobileAppBlockerScreenBottomSheet';
  buttons: Array<MobileAppBottomSheetButton>;
  description: Scalars['String']['output'];
  formattedDescription: FormatString;
  formattedTitle: FormatString;
  image?: Maybe<MobileAppBottomSheetImage>;
  title: Scalars['String']['output'];
};

export type MobileAppBlockerScreenButton = MobileAppBlockerScreenNextButton | MobileAppBlockerScreenUrlButton;

export type MobileAppBlockerScreenButtonInterface = {
  text: Scalars['String']['output'];
};

/**
 * Similar to a splash screen but when 'x' is pressed it will show a bottom sheet instead
 * of dismissing.
 */
export type MobileAppBlockerScreenInterface = {
  bottomSheet: MobileAppBlockerScreenBottomSheet;
  id: Scalars['ID']['output'];
  pages: Array<MobileAppBlockerScreenPage>;
};

export type MobileAppBlockerScreenNextButton = MobileAppBlockerScreenButtonInterface & {
  __typename?: 'MobileAppBlockerScreenNextButton';
  text: Scalars['String']['output'];
};

export type MobileAppBlockerScreenPage = {
  __typename?: 'MobileAppBlockerScreenPage';
  button: MobileAppBlockerScreenButton;
  description: Scalars['String']['output'];
  image: Image;
  secondaryButton?: Maybe<MobileAppBlockerScreenButton>;
  title: Scalars['String']['output'];
};

export type MobileAppBlockerScreenUrlButton = MobileAppBlockerScreenButtonInterface & {
  __typename?: 'MobileAppBlockerScreenUrlButton';
  destinationUrl: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type MobileAppBottomSheet = MobileAppBottomSheetInterface & {
  __typename?: 'MobileAppBottomSheet';
  /** @deprecated Read cards instead; this is the first card */
  buttons: Array<MobileAppBottomSheetButton>;
  cards: Array<MobileAppBottomSheetCard>;
  /** @deprecated Read cards instead; this is the first card */
  description: Scalars['String']['output'];
  dismissalTriggerId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Read cards instead; this is the first card */
  formattedDescription: FormatString;
  /** @deprecated Read cards instead; this is the first card */
  formattedTitle: FormatString;
  id: Scalars['ID']['output'];
  /** @deprecated Read cards instead; this is the first card */
  image?: Maybe<MobileAppBottomSheetImage>;
  /** @deprecated Read cards instead; this is the first card */
  title: Scalars['String']['output'];
};

export type MobileAppBottomSheetButton = MobileAppBottomSheetCTAButton | MobileAppBottomSheetTextLinkButton;

export type MobileAppBottomSheetButtonInterface = {
  destinationUrl: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export enum MobileAppBottomSheetButtonType {
  CTA = 'CTA',
  TEXT_LINK = 'TEXT_LINK',
}

export type MobileAppBottomSheetCTAButton = MobileAppBottomSheetButtonInterface & {
  __typename?: 'MobileAppBottomSheetCTAButton';
  backgroundColorHex: Scalars['HexColorCode']['output'];
  destinationUrl: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type MobileAppBottomSheetCard = {
  __typename?: 'MobileAppBottomSheetCard';
  buttons: Array<MobileAppBottomSheetButton>;
  description?: Maybe<Scalars['String']['output']>;
  formattedDescription?: Maybe<FormatString>;
  formattedTitle?: Maybe<FormatString>;
  image?: Maybe<MobileAppBottomSheetImage>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MobileAppBottomSheetImage = {
  __typename?: 'MobileAppBottomSheetImage';
  image: Image;
  type: MobileAppBottomSheetImageType;
};

export enum MobileAppBottomSheetImageType {
  RECTANGULAR = 'RECTANGULAR',
  ROUND = 'ROUND',
  SQUARE = 'SQUARE',
}

export type MobileAppBottomSheetInterface = {
  /** @deprecated Read cards instead; this is the first card */
  buttons: Array<MobileAppBottomSheetButton>;
  /**
   * The cards to page through, in order. Never empty: a single-card sheet has one card, which is
   * also what the image/title/description/buttons fields above describe. A card carries only the
   * parts it needs, so an image-only or copy-only card leaves the rest null.
   */
  cards: Array<MobileAppBottomSheetCard>;
  /** @deprecated Read cards instead; this is the first card */
  description: Scalars['String']['output'];
  /** @deprecated Read cards instead; this is the first card */
  formattedDescription: FormatString;
  /** @deprecated Read cards instead; this is the first card */
  formattedTitle: FormatString;
  id: Scalars['ID']['output'];
  /** @deprecated Read cards instead; this is the first card */
  image?: Maybe<MobileAppBottomSheetImage>;
  /** @deprecated Read cards instead; this is the first card */
  title: Scalars['String']['output'];
};

export type MobileAppBottomSheetTextLinkButton = MobileAppBottomSheetButtonInterface & {
  __typename?: 'MobileAppBottomSheetTextLinkButton';
  destinationUrl: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/**
 * Generic client-rendered splash surfaced to the app. Every splash shares a `clientSplashKey`;
 * each key has its own concrete implementing type carrying its own strongly-typed fields.
 */
export type MobileAppClientSplash = {
  clientSplashKey: ClientSplashKey;
  dismissalTriggerId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
};

export type MobileAppContent = {
  __typename?: 'MobileAppContent';
  banners: Array<MobileAppBanner>;
  blockerScreen?: Maybe<MobileAppBlockerScreen>;
  bottomSheet?: Maybe<MobileAppBottomSheet>;
  clientSplashes: Array<MobileAppClientSplash>;
  discover: Array<MobileAppDiscoverItem>;
  splashScreen?: Maybe<MobileAppSplashScreen>;
};

export type MobileAppContentClientTargetingFactsInput = {
  sourceView?: InputMaybe<MobileAppContentSourceView>;
};

export enum MobileAppContentSourceView {
  HOME = 'HOME',
  ONBOARDING = 'ONBOARDING',
}

export type MobileAppContentTargetingFact = {
  __typename?: 'MobileAppContentTargetingFact';
  name: Scalars['String']['output'];
  type: MobileAppContentTargetingFactType;
};

export enum MobileAppContentTargetingFactType {
  ARRAY_OF_STRINGS = 'ARRAY_OF_STRINGS',
  BOOLEAN = 'BOOLEAN',
  DATE_TIME = 'DATE_TIME',
  INTEGER = 'INTEGER',
  STRING = 'STRING',
}

export type MobileAppContentTargetingInput = {
  clientView?: InputMaybe<MobileAppContentSourceView>;
  dismissalDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  requiresTrigger?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetSpecies: Array<Species>;
  /**
   * JSON converted `json-rules-engine` rules.
   * No targeting rules will result in content being visible to any user/pet
   * See https://github.com/CacheControl/json-rules-engine/blob/master/docs/rules.md#persisting
   */
  targetingRules?: InputMaybe<Scalars['JSON']['input']>;
};

export type MobileAppDiscoverItem = MobileAppDiscoverItemInterface & {
  __typename?: 'MobileAppDiscoverItem';
  description: Scalars['String']['output'];
  destinationUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Image;
  title: Scalars['String']['output'];
};

export type MobileAppDiscoverItemInterface = {
  description: Scalars['String']['output'];
  destinationUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Image;
  title: Scalars['String']['output'];
};

export type MobileAppLaunchState = {
  step: MobileAppLaunchStep;
};

export type MobileAppLaunchStateBaseActivation = MobileAppLaunchState & {
  __typename?: 'MobileAppLaunchStateBaseActivation';
  household: Household;
  pet: Pet;
  step: MobileAppLaunchStep;
};

export type MobileAppLaunchStateCollarActivation = MobileAppLaunchState & {
  __typename?: 'MobileAppLaunchStateCollarActivation';
  household: Household;
  pet: Pet;
  step: MobileAppLaunchStep;
};

export type MobileAppLaunchStateForcedAppUpdate = MobileAppLaunchState & {
  __typename?: 'MobileAppLaunchStateForcedAppUpdate';
  step: MobileAppLaunchStep;
};

export type MobileAppLaunchStateHome = MobileAppLaunchState & {
  __typename?: 'MobileAppLaunchStateHome';
  /**
   * Server-chosen acting pet: the validated lastSelectedPetId hint when still
   * valid, else the first pet with an attached device (boarding households may
   * yield a deviceless pet). Subscription access state (including failed
   * payment) never affects this — billing problems surface via in-app comms on
   * the home screen.
   */
  actingPet: Pet;
  step: MobileAppLaunchStep;
};

export type MobileAppLaunchStateInput = {
  /** Client-local, session-scoped hint: the user skipped phone-number entry this session. */
  hasSkippedPhoneNumberEntry?: Scalars['Boolean']['input'];
  /** Client-local hint: the pet the user last selected. Validated server-side before being honored. */
  lastSelectedPetId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Every step this client build can render — send only the steps this client
   * actually renders, not all generated enum cases. Must include HOME and
   * FORCED_APP_UPDATE. The server only ever returns a step from this set,
   * skipping unsupported steps in cascade order.
   */
  supportedSteps: Array<MobileAppLaunchStep>;
};

export type MobileAppLaunchStatePetCreation = MobileAppLaunchState & {
  __typename?: 'MobileAppLaunchStatePetCreation';
  /** Household the new pet should be created in (first owned household). */
  household: Household;
  step: MobileAppLaunchStep;
};

export type MobileAppLaunchStatePetPhoto = MobileAppLaunchState & {
  __typename?: 'MobileAppLaunchStatePetPhoto';
  household: Household;
  pet: Pet;
  step: MobileAppLaunchStep;
};

export type MobileAppLaunchStatePhoneNumberEntry = MobileAppLaunchState & {
  __typename?: 'MobileAppLaunchStatePhoneNumberEntry';
  /** Whether the user may skip entry (server-evaluated newUserSkipPhoneNumberEnabled flag). */
  skippable: Scalars['Boolean']['output'];
  step: MobileAppLaunchStep;
};

export type MobileAppLaunchStateSafeZoneSetup = MobileAppLaunchState & {
  __typename?: 'MobileAppLaunchStateSafeZoneSetup';
  household: Household;
  pet: Pet;
  step: MobileAppLaunchStep;
};

export type MobileAppLaunchStateWifiSetup = MobileAppLaunchState & {
  __typename?: 'MobileAppLaunchStateWifiSetup';
  household: Household;
  pet: Pet;
  step: MobileAppLaunchStep;
};

/**
 * The landing step a mobile client should route to on launch. Vocabulary for
 * MobileAppLaunchStateInput.supportedSteps negotiation — the server never
 * returns a step the requesting client did not declare support for.
 */
export enum MobileAppLaunchStep {
  /**
   * The pet's household has no charging base; pair one. Reserved for
   * forward-compat — not returned at cold launch today, since any pet
   * having a device routes to HOME before this step is considered.
   */
  BASE_ACTIVATION = 'BASE_ACTIVATION',
  /** Pet has no device; activate a collar. */
  COLLAR_ACTIVATION = 'COLLAR_ACTIVATION',
  /** Hard block: the client must update before continuing. */
  FORCED_APP_UPDATE = 'FORCED_APP_UPDATE',
  /** Land in the main app shell. */
  HOME = 'HOME',
  /** User owns no pets; create the first one. */
  PET_CREATION = 'PET_CREATION',
  /** A pet exists but its profile photo is missing. */
  PET_PHOTO = 'PET_PHOTO',
  /** Collect the user's phone number. */
  PHONE_NUMBER_ENTRY = 'PHONE_NUMBER_ENTRY',
  /**
   * The pet's household has no safe zones configured. Reserved for
   * forward-compat; same caveat as BASE_ACTIVATION.
   */
  SAFE_ZONE_SETUP = 'SAFE_ZONE_SETUP',
  /**
   * The pet's household has no WiFi networks configured. Reserved for
   * forward-compat; same caveat as BASE_ACTIVATION.
   */
  WIFI_SETUP = 'WIFI_SETUP',
}

/** The LIFETIME_TIER splash, surfaced when a pet crosses into a new lifetime-step tier. */
export type MobileAppLifetimeTierClientSplash = MobileAppClientSplash & {
  __typename?: 'MobileAppLifetimeTierClientSplash';
  clientSplashKey: ClientSplashKey;
  dismissalTriggerId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  percentageOfPets: Scalars['Float']['output'];
  splineSceneUrl: Scalars['String']['output'];
  tier: PetLifetimeStatsTierName;
  trophyAnimationWebpUrl: Scalars['String']['output'];
  trophyImageUrl: Scalars['String']['output'];
};

/**
 * The LIFETIME_TIER_INTRO splash, introducing the lifetime-tiers feature at launch. Trigger-gated and
 * fired once per eligible dog, so a multi-dog household sees it once per dog and dismisses each
 * separately.
 */
export type MobileAppLifetimeTierIntroClientSplash = MobileAppClientSplash & {
  __typename?: 'MobileAppLifetimeTierIntroClientSplash';
  clientSplashKey: ClientSplashKey;
  dismissalTriggerId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
};

export type MobileAppPermissionBlockerScreen = MobileAppPermissionBlockerScreenInterface & {
  __typename?: 'MobileAppPermissionBlockerScreen';
  bottomSheet: MobileAppBlockerScreenBottomSheet;
  dismissable: Scalars['Boolean']['output'];
  dismissalDurationSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  pages: Array<MobileAppBlockerScreenPage>;
  priority: Scalars['Int']['output'];
};

export type MobileAppPermissionBlockerScreenInterface = {
  bottomSheet: MobileAppBlockerScreenBottomSheet;
  dismissable: Scalars['Boolean']['output'];
  dismissalDurationSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  pages: Array<MobileAppBlockerScreenPage>;
  priority: Scalars['Int']['output'];
};

export type MobileAppSplashScreen = MobileAppSplashScreenInterface & {
  __typename?: 'MobileAppSplashScreen';
  dismissalTriggerId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  pages: Array<MobileAppSplashScreenPage>;
};

export type MobileAppSplashScreenButton = MobileAppSplashScreenNextButton | MobileAppSplashScreenUrlButton;

export type MobileAppSplashScreenButtonInterface = {
  text: Scalars['String']['output'];
};

export type MobileAppSplashScreenInterface = {
  id: Scalars['ID']['output'];
  pages: Array<MobileAppSplashScreenPage>;
};

export type MobileAppSplashScreenNextButton = MobileAppSplashScreenButtonInterface & {
  __typename?: 'MobileAppSplashScreenNextButton';
  text: Scalars['String']['output'];
};

export type MobileAppSplashScreenPage = {
  __typename?: 'MobileAppSplashScreenPage';
  button: MobileAppSplashScreenButton;
  description: Scalars['String']['output'];
  image: Image;
  title: Scalars['String']['output'];
};

export type MobileAppSplashScreenUrlButton = MobileAppSplashScreenButtonInterface & {
  __typename?: 'MobileAppSplashScreenUrlButton';
  destinationUrl: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type MobileAuthorizedPeripherals = {
  __typename?: 'MobileAuthorizedPeripherals';
  /** Base IDs of all charging bases across every household the user belongs to. */
  baseIds: Array<Scalars['String']['output']>;
  /**
   * Module IDs of all collars (primary and secondary slots) on non-deleted pets
   * across every household the user belongs to.
   */
  moduleIds: Array<Scalars['String']['output']>;
  /** Count of non-deleted pets across every household the user belongs to. */
  totalPetCount: Scalars['Int']['output'];
};

export type MobilityReport = {
  __typename?: 'MobilityReport';
  attributes: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  device: Device;
  id: Scalars['ID']['output'];
  ignoreReason?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  type: MobilityType;
};

export type MobilityReportInput = {
  date: Scalars['DateTime']['input'];
  recentlySeenBases?: InputMaybe<Array<RecentlySeenBaseInput>>;
  /** Optional, defaults to "mobile */
  source?: InputMaybe<Scalars['String']['input']>;
  type: MobilityType;
};

export enum MobilityType {
  NO_SIGNIFICANT_CHANGE = 'NO_SIGNIFICANT_CHANGE',
  UNKNOWN = 'UNKNOWN',
}

export type ModifyWifiCredentialResult = {
  __typename?: 'ModifyWifiCredentialResult';
  hash: Scalars['String']['output'];
  isInSafeZone?: Maybe<Scalars['Boolean']['output']>;
};

export enum ModuleCapability {
  /** @deprecated Use Pet.productAvailability */
  APPLE_WATCH = 'APPLE_WATCH',
  AWS_SIDEWALK = 'AWS_SIDEWALK',
  /** @deprecated Use Pet.productAvailability */
  BEHAVIOR_DETECTION = 'BEHAVIOR_DETECTION',
  BQ27421_SUBMESSAGE = 'BQ27421_SUBMESSAGE',
  CAN_BE_SECONDARY = 'CAN_BE_SECONDARY',
  CAN_HAVE_SECONDARY = 'CAN_HAVE_SECONDARY',
  CXD5605 = 'CXD5605',
  CXD5610 = 'CXD5610',
  GPS_FREQUENCY_CONTROL = 'GPS_FREQUENCY_CONTROL',
  /** @deprecated Use Pet.productAvailability */
  HEALTH_AI = 'HEALTH_AI',
  LIVE_TRACKING = 'LIVE_TRACKING',
  LLE_UPDATE_IN_RESPONSE = 'LLE_UPDATE_IN_RESPONSE',
  LOST_MODE = 'LOST_MODE',
  LTE_BACKOFF_SUBMESSAGE = 'LTE_BACKOFF_SUBMESSAGE',
  PROTO_RESPONSE = 'PROTO_RESPONSE',
  REMOTE_LOG = 'REMOTE_LOG',
  REMOTE_REBOOT = 'REMOTE_REBOOT',
  SLEEP_TRACKING = 'SLEEP_TRACKING',
  SOUND = 'SOUND',
  USER_DISABLE = 'USER_DISABLE',
  USER_LED = 'USER_LED',
  VIBRATION = 'VIBRATION',
  WIFI = 'WIFI',
  ZONE_PACK = 'ZONE_PACK',
}

export type ModuleHSMTransitionDetails = {
  __typename?: 'ModuleHSMTransitionDetails';
  eventName: Scalars['String']['output'];
  fromStateName: Scalars['String']['output'];
  toStateName: Scalars['String']['output'];
};

export type MultidogHouseholdPromotionBanner = InAppPromotionBanner & {
  __typename?: 'MultidogHouseholdPromotionBanner';
  ctaUrl: Scalars['String']['output'];
  dismissFeedbackOptions?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  line1Text: FormatString;
  line2Text: FormatString;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptUserInvite: AcceptUserInviteResult;
  /**
   * Acknowledge a search party notification, indicating the user will "keep an eye out" for the lost pet.
   *
   * This mutation:
   * 1. Verifies an active search party session exists for the pet
   * 2. Creates or updates an acknowledgment record linking the user to the search party session
   * 3. Returns success status
   *
   * Users who acknowledge search parties will receive recovery notifications when the dog is found (future feature).
   * Each user can only acknowledge a search party once per session (enforced by unique constraint).
   */
  acknowledgeSearchParty: AcknowledgeSearchPartyResult;
  addCommentComplaint?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Add a coupon to an account
   * Requires: Admin or Customer Support role
   */
  addCouponToAccount: Scalars['Boolean']['output'];
  addHouseholdVet: Array<Veterinary>;
  addMultipleSupplementSubscriptions?: Maybe<AddMultipleSupplementSubscriptionsResult>;
  addOrderLineItems: Order;
  addPetDocument: PetDocument;
  /** @deprecated Use addPhotoForPet instead */
  addPetPhoto: Pet;
  addPhotoComment?: Maybe<AddPhotoCommentResult>;
  addPhotoComplaint?: Maybe<Scalars['Boolean']['output']>;
  addPhotoForPet: Photo;
  /** In-app supplements management mutations. */
  addSupplementSubscription?: Maybe<AddSupplementSubscriptionResult>;
  addTextPostComment?: Maybe<AddTextPostCommentResult>;
  addTextPostComplaint?: Maybe<Scalars['Boolean']['output']>;
  /** 3rd party membership management mutations. */
  addThirdPartySubscription: AddThirdPartySubscriptionResult;
  addUserEmail: User;
  addVideoPostComment?: Maybe<AddVideoPostCommentResult>;
  addVideoPostComplaint?: Maybe<Scalars['Boolean']['output']>;
  addWifiCredentials: ModifyWifiCredentialResult;
  adminActivateFulfillmentWarehouse: FulfillmentWarehouse;
  adminAddDogParkFromOSM: DogPark;
  adminAddFirmwareTag: FirmwareTag;
  adminAddNanoIcarIdRange: NanoIcarIdRange;
  /**
   * Promise an account free days on its hardware-first membership before it exists (admin/CS only).
   * Refused when the account already has an open pending extension.
   */
  adminAddPendingMembershipExtension: PendingMembershipExtension;
  adminAddResellerModules?: Maybe<Array<ResellerModule>>;
  adminAddTagToFirmwareUpdateChannel: Scalars['Boolean']['output'];
  adminAddTagToFirmwareVersion: Scalars['Boolean']['output'];
  adminAddUserToGroup?: Maybe<AdminBaseUserProfile>;
  adminAddUserToHousehold: AddUserToHouseholdResult;
  adminAddVetSuggestion: Array<Veterinary>;
  adminApproveDogParkRequest: DogPark;
  adminApproveGwaPostcardOrder: RescueGwaPostcardOrder;
  /**
   * Approve a pending rescue document, recording the date it stops being good.
   *
   * `expirationDate` is date-only, `YYYY-MM-DD`, read off the document by the reviewer. Null means it
   * carries no expiry, which is the common case — most jurisdictions issue blanket certificates.
   *
   * `documentType` corrects what the portal filed. A rescue may upload the purchaser form their state
   * also accepts rather than the document we asked for, and only the reviewer can see which arrived.
   * Limited to the exemption-flow types.
   */
  adminApproveRescueDocument: RescueDocument;
  adminArchiveFirmware?: Maybe<Scalars['Boolean']['output']>;
  adminAssignRole: AdminRoleAssignment;
  adminAutoTranslateKeys: AutoTranslateResult;
  adminBulkAddPetsToUnmanagedPack: BulkPackInsertResponse;
  adminBulkAssignUsersToGroup: Scalars['ID']['output'];
  adminBulkRequestGwaPostcardMailings: Array<RescueGwaPostcardOrder>;
  /** Cancel a deletion request (admin version - can cancel any user's request). */
  adminCancelDeletionRequest: AdminDeletionRequestResult;
  /** Cancel an account's open pending free-days extension before it is consumed (admin/CS only). */
  adminCancelPendingMembershipExtension: Scalars['Boolean']['output'];
  /**
   * Create a one-time charge for a consignment account.
   * Admin-only access.
   */
  adminChargeConsignmentAccount: ChargeConsignmentAccountResult;
  adminClaimNanoWebIds: Array<NanoWebId>;
  adminClearChip?: Maybe<Scalars['Boolean']['output']>;
  adminClearCommunityFeedPostBoost: Scalars['Boolean']['output'];
  adminCloseInPersonEvent: InPersonEvent;
  adminCreateBatchRecords?: Maybe<Scalars['Boolean']['output']>;
  adminCreateBreed: Breed;
  adminCreateChangeLog: ChangeLog;
  adminCreateConsignmentAccount: ConsignmentAccount;
  adminCreateConsignmentLocation: ConsignmentLocation;
  /** Creates an order for a consignment location */
  adminCreateConsignmentOrder: Order;
  adminCreateConsignmentRecurlyAccount: Scalars['String']['output'];
  adminCreateCoupon: Coupon;
  adminCreateDogParkCheckinExclusion: AdminDogParkCheckinExclusion;
  /**
   * Creates a self-serve employee gifting order (refurbished A-stock S3+/Mini kit shipped to a
   * friend/family recipient out of DCL).
   */
  adminCreateEmployeeGiftOrder: Order;
  /**
   * Gifts a free year of subscription with no hardware: mints a single-use fi-gift coupon and emails
   * it to the recipient immediately. For recipients who already own a collar but need a subscription.
   */
  adminCreateEmployeeGiftSubscriptionCoupon: AdminCreateEmployeeGiftSubscriptionCouponResult;
  adminCreateEvalGuideline: EvalGuideline;
  adminCreateFirmwareChannel?: Maybe<FirmwareUpdateChannel>;
  adminCreateGingrBoardingFacility: BoardingFacility;
  adminCreateGoldenQuestion: GoldenQuestion;
  adminCreateGwpPartnerProgram: GwpPartnerProgram;
  adminCreateHealthGptPlaybook: HealthGptPlaybook;
  /** Creates a new household with the user specified taking an OWNER role. */
  adminCreateHouseholdWithUser: Household;
  adminCreateInPersonEvent: InPersonEvent;
  /** Allows an admin to create an internal order that is not tied to an invoice */
  adminCreateInternalOrder: Order;
  /**
   * Presigned PUT URL for uploading a file to the media bucket at an admin-chosen path. The browser
   * uploads directly to S3, then calls `adminFinalizeMediaAssetUpload`.
   */
  adminCreateMediaAssetUploadUrl: AdminMediaAssetUploadUrl;
  /** Allows an admin to create an order on behalf of a customer, billed to the customer's credit card */
  adminCreateOrder: CartPurchaseResult;
  adminCreatePlace?: Maybe<Place>;
  adminCreatePlatform?: Maybe<Platform>;
  adminCreatePromotion: Promotion;
  adminCreateRescueChipReseller: ChipReseller;
  adminCreateRole: AdminRoleDefinition;
  adminCreateTargetedFeatureFlag: AdminTargetedFeatureFlag;
  adminCreateTestData: CreateTestDataResult;
  adminCreateUserForBoardingFacility: User;
  adminCreateUserGroup?: Maybe<UserGroup>;
  adminCreateVipUserLookupCriteria: VipUserLookupCriteria;
  adminDeactivateEvalGuideline: EvalGuideline;
  adminDeactivateFulfillmentWarehouse: FulfillmentWarehouse;
  adminDeactivateGwpPartnerProgram: GwpPartnerProgram;
  adminDeactivateHealthGptPlaybook: HealthGptPlaybook;
  /**
   * Deactivates user, removes them from households, anonymizes their information.
   *
   * This is an irrevocable, destructive operation.
   */
  adminDeactivateUser?: Maybe<User>;
  adminDeleteChangeLog: Scalars['Boolean']['output'];
  adminDeleteConsignmentAccount: ConsignmentAccount;
  adminDeleteConsignmentLocation: ConsignmentLocation;
  adminDeleteDogParkCheckinExclusion?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Deletes a firmware update channel.  This is a "safe" operation as only an unused
   * channel can be deleted.  If there are devices assigned to the channel, the operation
   * will fail.
   */
  adminDeleteFirmwareChannel?: Maybe<Scalars['Boolean']['output']>;
  adminDeleteGoldenQuestion: Scalars['Boolean']['output'];
  /** Soft-delete a memory (status DELETED_BY_ADMIN) — the CX remedy for a wrong/stale remembered fact. */
  adminDeleteHealthGptMemory: AdminHealthGptMemory;
  adminDeletePack: Pack;
  adminDeletePromotion?: Maybe<Scalars['Boolean']['output']>;
  adminDeleteRole: Scalars['Boolean']['output'];
  adminDeleteTranslation: Scalars['Boolean']['output'];
  adminDeleteUserGroup?: Maybe<Scalars['Boolean']['output']>;
  adminDeleteVipUserLookupCriteria?: Maybe<Scalars['Boolean']['output']>;
  adminDisableShelterluv: ChipReseller;
  /** Create a copy of a target promotion */
  adminDuplicatePromotion: Promotion;
  adminEnableShelterluv: ChipReseller;
  adminExpireAndRecreateCoupon: Coupon;
  adminExpireCoupon: Coupon;
  adminExpireResellerModules: ExpireResellerModulesResult;
  /**
   * Gifts a year onto a subscription the recipient already has, by pushing its renewal date out.
   * Employee-gifting counterpart to extendSubscription, which is a CX/finance tool.
   */
  adminExtendEmployeeGiftSubscription: AdminExtendEmployeeGiftSubscriptionResult;
  /**
   * Verifies the uploaded object exists and invalidates its path on the media.tryfi.com CloudFront
   * distribution so a replaced asset propagates.
   */
  adminFinalizeMediaAssetUpload: AdminFinalizeMediaAssetUploadResult;
  /**
   * Fires visibility triggers for trigger-gated mobile app content, the same mechanism production code
   * paths use (e.g. the lifetime-tier celebration splash, fired by the daily graduation task). Lets
   * admins surface such content to chosen users on demand, with hand-picked targeting facts.
   */
  adminFireMobileAppContentTriggers: Array<AdminFiredMobileAppContentTrigger>;
  /**
   * Force process a pending deletion request immediately (skip grace period).
   * Use with caution - bypasses the 30-day grace period.
   */
  adminForceProcessDeletionRequest: AdminDeletionRequestResult;
  /**
   * Generate a signed partner setup token for a consignment account. Admin-only.
   * The token grants time-limited unauthenticated access to the partner setup page.
   */
  adminGenerateConsignmentPartnerSetupToken: Scalars['String']['output'];
  adminHealthGptAddQuestion: AdminHealthGptMessage;
  adminHealthGptCreateDocument: AdminHealthGptDocument;
  adminHealthGptDeleteDocument: Scalars['Boolean']['output'];
  adminHealthGptUpdateDocument: AdminHealthGptDocument;
  adminImportChips?: Maybe<Array<ResellerChip>>;
  adminIncrementNumConfirmedReferrals?: Maybe<AdminBaseUserProfile>;
  /**
   * Issue a gift card charged to an account (admin/CS only). Routes through Recurly's gift card API so a
   * redemption code is generated and the recipient delivery email is sent. Returns the purchase invoice.
   */
  adminIssueGiftCard: RecurlyInvoice;
  /**
   * Record an Avalara exemption certificate submission for a consignment account.
   * Sets taxExemptAvalaraConfirmedAt, moving taxExemptStatus to PENDING.
   * Does NOT call Recurly — call adminSyncConsignmentTaxExempt to complete the sync.
   * Admin-only.
   */
  adminMarkConsignmentAvalaraConfirmed: ConsignmentAccount;
  adminMigrateModulesToFirmwareChannel?: Maybe<MigrateModulesToFirmwareChannelResult>;
  /**
   * Pause a member's collar membership on their behalf. Applies the same server-side eligibility
   * rules as the member-facing pauseMembership mutation.
   * Requires: Admin or Customer Support role
   */
  adminPauseMembership: BillingSubscription;
  adminPublishRescueStory: RescueStory;
  adminPublishTestPetUpdate?: Maybe<Scalars['Boolean']['output']>;
  adminRegisterConsignmentAgreement: ConsignmentAccount;
  adminRegisterConsignmentResaleCertificate: ConsignmentAccount;
  adminReinstateStreak?: Maybe<Scalars['Boolean']['output']>;
  adminRejectDogParkRequest: DogParkRequest;
  adminRejectGwaPostcardOrder: RescueGwaPostcardOrder;
  /** Reject a pending rescue document with an optional reason. */
  adminRejectRescueDocument: RescueDocument;
  adminRejectRescueStory: RescueStory;
  /**
   * Remove a stored payment method from a Recurly account (admin/CS only). Refused unless the member
   * has no outstanding financial responsibility - see BillingAccount.paymentMethodRemovability, which
   * the UI reads to explain a block before the agent tries.
   * Requires: Admin or Customer Support role
   */
  adminRemoveBillingInfo: Scalars['Boolean']['output'];
  adminRemoveConsignmentAgreement: ConsignmentAccount;
  adminRemoveConsignmentResaleCertificate: ConsignmentAccount;
  adminRemoveFeatureFlag?: Maybe<Scalars['Boolean']['output']>;
  adminRemoveTagFromFirmwareUpdateChannel: Scalars['Boolean']['output'];
  adminRemoveTagFromFirmwareVersion: Scalars['Boolean']['output'];
  adminRemoveUserFromGroup?: Maybe<AdminBaseUserProfile>;
  /**
   * Put an approved or rejected document back in the review queue, undoing the decision.
   *
   * Clears the reviewer's fields with it, the expiry included — that was their reading of the document,
   * not a fact about it. The document is then genuinely undecided and has to be reviewed again.
   *
   * The only exit from a terminal status: there is deliberately no approved-to-rejected transition,
   * which would let a decision flip without anyone reopening the file.
   */
  adminReopenRescueDocument: RescueDocument;
  adminRequestGwaPostcardMailing: RescueGwaPostcardOrder;
  /**
   * Reset a Playwright burner consignment partner to a clean state for a fresh test run.
   * Flips Recurly `tax_exempt` back to false and nulls the cert-file pointer + all
   * cert/sync columns in Postgres. Does NOT delete the S3 cert object or revoke
   * Avalara certs — both accumulate harmlessly and aren't load-bearing for test
   * determinism. Refuses any account whose name doesn't start with `PLAYWRIGHT_BURNER_`
   * so a misconfigured PW_BURNER_PARTNER_ID can't damage a real partner. Admin-only.
   */
  adminResetConsignmentBurnerPartner: ConsignmentAccount;
  adminResetDeviceBatteryState?: Maybe<Scalars['Boolean']['output']>;
  /** Restore a previously deleted/expired memory to ACTIVE. */
  adminRestoreHealthGptMemory: AdminHealthGptMemory;
  /**
   * Resume a paused membership, or cancel a pause that is scheduled but not yet in effect.
   * Requires: Admin or Customer Support role
   */
  adminResumeMembership: BillingSubscription;
  adminRetriggerEvaluation: Scalars['Boolean']['output'];
  /**
   * Retry failed third-party deletions for a deletion request.
   * Only available for requests in FAILED status.
   */
  adminRetryDeletionRequest: AdminDeletionRequestResult;
  /**
   * Revoke tax-exempt status for a consignment account.
   * Updates Recurly to charge sales tax again and records taxExemptRevokedAt.
   * Admin-only.
   */
  adminRevokeConsignmentTaxExempt: ConsignmentAccount;
  adminRevokeRole: Scalars['Boolean']['output'];
  adminSendBackgroundNotification?: Maybe<Scalars['Boolean']['output']>;
  adminSendFreeNanoBoxes: CartPurchaseResult;
  adminSendNotification?: Maybe<Scalars['Boolean']['output']>;
  adminSendSearchPartyTestNotification: AdminSendSearchPartyTestNotificationResult;
  adminSendServerPushToDevice?: Maybe<Scalars['Boolean']['output']>;
  adminSetAutomaticallyActivateDevicesOnUser?: Maybe<AdminBaseUserProfile>;
  adminSetChargingBaseOwner?: Maybe<ChargingBase>;
  adminSetChargingBaseUpdateChannel?: Maybe<ChargingBase>;
  adminSetChipResellerName: ChipReseller;
  adminSetChipResellerRescueVerified: ChipReseller;
  adminSetChipResellerStatus: ChipReseller;
  adminSetChipResellerTypes: ChipReseller;
  adminSetCommentHidden?: Maybe<Comment>;
  adminSetCommunityFeedModifiers: CommunityFeedModifiers;
  adminSetCommunityFeedPostBoost: CommunityFeedPostBoost;
  adminSetCommunityFeedTrendingMeta: CommunityFeedTrendingMeta;
  adminSetDeviceAutoAddUserToHousehold?: Maybe<Device>;
  /** Enable or disable a device from receiving CXD5610 (Sony GNSS) OTA updates. */
  adminSetDeviceCxdUpdateEligibility: Device;
  /**
   * Admin only. Set (or clear, when serviceProvider is null) the manual eUICC SIM profile override for
   * a device. Persists across assignment so it can be set on inventory before activation; if the device
   * is already assigned, the switch is also pushed to the collar immediately.
   */
  adminSetDeviceEuiccServiceProviderOverride?: Maybe<Device>;
  /** Enable or disable a device from receiving firmware updates. */
  adminSetDeviceFirmwareUpdateEligibility: Device;
  adminSetDeviceIsBlocked?: Maybe<Device>;
  adminSetDeviceIsRefurbished?: Maybe<Device>;
  adminSetDeviceTags: Device;
  adminSetFeatureFlag?: Maybe<FeatureFlag>;
  adminSetFeedDecayCurveConfig: FeedDecayCurveConfig;
  adminSetFirmwareRolloutQuantity?: Maybe<SetFirmwareRolloutResult>;
  adminSetPhotoDeleted?: Maybe<Photo>;
  adminSetRemoteLoggingForFirmwareChannel?: Maybe<FirmwareUpdateChannel>;
  adminSetSubscriptionIdOnDevice?: Maybe<Device>;
  adminSetThirdPartyAccess: Scalars['Boolean']['output'];
  adminSetUserGroups?: Maybe<AdminBaseUserProfile>;
  adminStartGoldenQuestionRun: GoldenQuestionRun;
  adminStartNanoIcarIdOnlyClaim: NanoWebIdClaimJobStatus;
  /** @deprecated Use adminStartNanoWebIdOnlyClaim or adminStartNanoIcarIdOnlyClaim. */
  adminStartNanoWebIdClaim: NanoWebIdClaimJobStatus;
  adminStartNanoWebIdOnlyClaim: NanoWebIdClaimJobStatus;
  adminSubmitCertGenJob?: Maybe<CreateCertGenJobResult>;
  /**
   * Mark a consignment account's Avalara exemption submission as recorded, then sync the
   * tax-exempt flag to Recurly. Moves taxExemptStatus from PENDING → EXEMPT.
   * Requires an existing Recurly account code and a prior Avalara submission recorded on the account.
   * Admin-only.
   */
  adminSyncConsignmentTaxExempt: ConsignmentAccount;
  adminTriggerCustomerIoTrackEventForTestUser: AdminTriggerCustomerIoEventResult;
  /**
   * Trigger an immediate SKU sync from DCL warehouse.
   * Requires: Admin or Customer Support role
   */
  adminTriggerDclSkuSync: AdminSkuSyncResult;
  /**
   * Trigger an immediate SKU sync from Recurly.
   * Requires: Admin or Customer Support role
   */
  adminTriggerSkuSync: AdminSkuSyncResult;
  /**
   * Undmismiss a previous mobile app content dismissal.
   * dbId is the id of the dismissal record.
   */
  adminUndismissMobileAppContent?: Maybe<Scalars['Boolean']['output']>;
  /** Update account address on a recurly account (admin/CS only). */
  adminUpdateAccountAddress: Scalars['Boolean']['output'];
  /** Update account details (email, name) on a recurly account (admin/CS only). */
  adminUpdateAccountDetails: Scalars['Boolean']['output'];
  adminUpdateBreed: Breed;
  adminUpdateChangeLog: ChangeLog;
  adminUpdateChipPet: ResellerChip;
  adminUpdateChipReseller: ResellerChip;
  adminUpdateChipResellerByBox: ResellerChipFeed;
  adminUpdateChipResellerByBoxIds: Array<ResellerChip>;
  adminUpdateChipResellerBySerialNumber: ResellerChipFeed;
  adminUpdateConsignmentAccount: ConsignmentAccount;
  adminUpdateConsignmentLocation: ConsignmentLocation;
  /**
   * Update the address stored on the consignment partner's linked Recurly account. The Avalara
   * submit worker reads this address from Recurly to file the customer + exemption certificate,
   * so an account created/linked without an address (or with a placeholder) needs this to make
   * Avalara submission succeed. Re-enqueues the Avalara submit job on success.
   *
   * Errors if no Recurly account is linked.
   */
  adminUpdateConsignmentRecurlyShippingAddress: ConsignmentAccount;
  /**
   * Update structured resale-cert fields (state, exemption reason, cert#, expiration) on a partner's
   * account WITHOUT requiring a new file upload. Re-enqueues Avalara so a field correction (typo'd
   * cert#, wrong state) re-submits using the cert file already on record. Idempotent at the Avalara
   * layer for same-state updates; state changes create a new exemption certificate.
   * Admin-only.
   */
  adminUpdateConsignmentResaleCertFields: ConsignmentAccount;
  adminUpdateDeviceCellularStatus?: Maybe<Scalars['String']['output']>;
  adminUpdateDeviceHasActiveSubscription?: Maybe<Device>;
  adminUpdateDeviceSubscriptionOverrideEndsAt?: Maybe<Device>;
  adminUpdateDeviceTenancy?: Maybe<Device>;
  adminUpdateEvalGuideline: EvalGuideline;
  adminUpdateFirmware?: Maybe<FirmwareVersion>;
  adminUpdateFirmwareChannel?: Maybe<FirmwareUpdateChannel>;
  adminUpdateGingrBoardingFacility: BoardingFacility;
  adminUpdateGoldenQuestion: GoldenQuestion;
  adminUpdateGwpPartnerProgramAutoApply: GwpPartnerProgram;
  /**
   * Rotates the program's internal Recurly coupon to new discount amounts (Recurly coupons are
   * immutable on discount). Also how currencies (e.g. CAD) are added to an existing program.
   * discountsInCents is a currency-keyed cents map like CreateGwpPartnerProgramInput's.
   */
  adminUpdateGwpPartnerProgramDiscount: GwpPartnerProgram;
  adminUpdateHealthGptPlaybook: HealthGptPlaybook;
  adminUpdateHouseholdName: Household;
  adminUpdateHouseholdTenancy: TenancyUpdateResult;
  adminUpdateHouseholdThirdPartyAccess: Household;
  adminUpdateInPersonEvent: InPersonEvent;
  adminUpdateInPersonEventInventory: InPersonEvent;
  adminUpdateInventoryConfiguration: ProductInventoryLevels;
  adminUpdatePetTenancy: TenancyUpdateResult;
  adminUpdatePlatform?: Maybe<Platform>;
  /**
   * Update metadata on a product SKU (admin override).
   * Requires: Admin or Customer Support role
   */
  adminUpdateProductSku: AdminProductSku;
  adminUpdatePromotion: Promotion;
  /**
   * Correct one jurisdiction's exemption rule. A patch: only the fields supplied are written, so two
   * people editing different columns of the same jurisdiction don't clobber each other. Passing an
   * explicit `null` clears a field; omitting it leaves the stored value alone.
   *
   * Rejected with an explanation if the result would be an incoherent row — a certificate jurisdiction
   * with no form named, or a reason recorded where an exemption is granted. Every change is audited
   * with the before and after of all four mutable fields.
   */
  adminUpdateRescueStateExemptionRule: RescueStateExemptionRule;
  adminUpdateRescueStory: RescueStory;
  adminUpdateRole: AdminRoleDefinition;
  adminUpdateShelterluvConfig: ChipReseller;
  adminUpdateTargetedFeatureFlag: AdminTargetedFeatureFlag;
  adminUpdateUserLanguage?: Maybe<AdminBaseUserProfile>;
  adminUpdateUserRegion?: Maybe<AdminBaseUserProfile>;
  /**
   * Upload an image to the barkinglabs-media bucket with a public ACL.
   * One of `prefix` or `path` must be specified.
   */
  adminUploadImage: AdminUploadImageResult;
  /** Admin uploads a document on behalf of a rescue user. Supersedes any prior current document for the same (user, type). */
  adminUploadRescueDocument: RescueDocument;
  /**
   * Upload a poster image for a Saved by Fi story. Returns the S3 key, which the caller passes to
   * `adminUpdateRescueStory(input.posterS3Key)` to attach it.
   */
  adminUploadRescueStoryPoster: RescueStoryPosterUploadResult;
  adminUpsertFulfillmentWarehouse: FulfillmentWarehouse;
  adminUpsertTranslation: TranslationRecord;
  /** Apply multidog discount to all dogs paid for by current user. */
  applyMultidogDiscount?: Maybe<ApplyMultidogDiscountResult>;
  /** Approves an internal order that is on hold and automatically ships it */
  approveInternalOrder: Order;
  /** Assign an unowned charging base to the current user. */
  assignChargingBase: ChargingBase;
  /** Assign an unowned device to a pet. */
  assignDevice: Pet;
  /** Chip resellers: assign an existing pet to a chip in their inventory */
  assignExistingPetToChip: ResellerChip;
  /** Chip resellers: transfer the a chip in their inventory to the new owner */
  assignNewOwnerToChip: ResellerChip;
  /** Chip resellers: add a pet to a chip in their inventory */
  assignNewPetToChip: ResellerChip;
  boardingFacilityCheckInPet: BoardingSession;
  boardingFacilityCheckOutPet: BoardingSession;
  /**
   * Cancel a subscription with optional refund
   * Requires: Admin or Customer Support role
   */
  cancelAndRefundSubscription: CancelAndRefundResult;
  /**
   * Cancel a pending deletion request during the grace period.
   * Users can cancel their own deletion requests within 30 days of requesting.
   */
  cancelDeletionRequest: AccountDeletionRequestResult;
  /** Disable autorenew for a collar membership */
  cancelMembership?: Maybe<CancelMembershipResult>;
  cancelOrderLineItems: Order;
  cancelOrders: Array<Order>;
  cancelRMA?: Maybe<RMA>;
  cancelSupplementSubscription?: Maybe<CancelSupplementSubscriptionResult>;
  cancelThirdPartySubscription: CancelThirdPartySubscriptionResult;
  changeMembershipPlanEndOfTerm?: Maybe<ChangeMembershipPlanEndOfTermResult>;
  changePetHousehold?: Maybe<Pet>;
  changePlaceHousehold?: Maybe<Place>;
  chargeAccountBySku: RecurlyInvoice;
  checkInRMA?: Maybe<RMA>;
  checkInUnknownReturn?: Maybe<RMA>;
  /**
   * Pet owners: Step 1 of the chip registration process for pet owners who want to register a chip that is injected
   * into their pet. Only connect their email address to the chip.
   */
  chipRegistrationAddEmail: BaseChip;
  /**
   * Pet owners: Alternate step 2 of the chip registration process for pet owners. Choose an existing pet to register to
   * the chip.
   */
  chipRegistrationAddExistingPet: BaseChip;
  /** Pet owners: Step 2 of the chip registration process for pet owners. Add their pet information. */
  chipRegistrationAddNewPet: BaseChip;
  /** Pet owners: Step 3 of the chip registration process for pet owners. Add their contact information */
  chipRegistrationUpdateContact: BaseChip;
  claimClickToCancelDiscount?: Maybe<ClaimClickToCancelDiscountResult>;
  /** In-app cancellation flow retention offers. */
  claimFreeMonth?: Maybe<ClaimFreeMonthResult>;
  claimFreeTrialCancelDeterrent?: Maybe<ClaimFreeTrialCancelDeterrentResult>;
  claimSupplementDiscount?: Maybe<ClaimSupplementDiscountResult>;
  claimTwoMonthsHalfOff?: Maybe<ClaimTwoMonthsHalfOffResult>;
  clearDeviceResponseOverride?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Create and confirm a Stripe SetupIntent for native iOS PaymentSheet.
   * Called by PaymentSheet's confirmHandler with the confirmation token it produces.
   * Returns the client secret for 3DS handling and the SetupIntent ID for the follow-up call.
   */
  confirmSetupIntent: ConfirmSetupIntentResult;
  /**
   * Convert a free trial subscription to paid early, applying a discount coupon.
   * This ends the trial period immediately and begins billing.
   */
  convertFreeTrial?: Maybe<ConvertFreeTrialResult>;
  /** Convert a Quick Zone into a permanent safe zone. Clears expiration and cancels pending expiry jobs. */
  convertQuickZoneToPermanent: Place;
  createBillingAccount: BillingAccount;
  /**
   * Create a Stripe CustomerSession for the native PaymentSheet. Returns the
   * customer id and a session client secret so the client can configure
   * PaymentSheet with a customer and retrieve the customer-scoped SetupIntent.
   */
  createCustomerSession: CustomerSessionResult;
  createDevice?: Maybe<Device>;
  createDeviceActuation: DeviceActuation;
  createDeviceTag: DeviceTag;
  createDynamicEnumMember: DynamicEnum;
  createEcommerceImageList: AdminEcommerceImageList;
  createFiNewsNotification: FiNewsNotification;
  createImageFromUrl?: Maybe<CreateImageFromUrlResult>;
  /**
   * Create a manual subscription for a customer
   * Requires: Admin or Customer Support role
   */
  createManualSubscription: ManualSubscriptionResult;
  createMobileAppBanner: AdminMobileAppBanner;
  createMobileAppBlockerScreen: AdminMobileAppBlockerScreen;
  createMobileAppBottomSheet: AdminMobileAppBottomSheet;
  createMobileAppClientSplash: AdminMobileAppClientSplash;
  createMobileAppDiscoverItem: AdminMobileAppDiscoverItem;
  createMobileAppPermissionBlockerScreen: AdminMobileAppPermissionBlockerScreen;
  createMobileAppSplashScreen: AdminMobileAppSplashScreen;
  createNewHealthGptChatThread: HealthGptChatThread;
  createPack: Pack;
  createPet: Pet;
  createPlace: Place;
  createRMA?: Maybe<RMA>;
  createRescueChipResellerForCurrentUser: ChipReseller;
  createResellerOrganizationApiKey: CreateResellerOrganizationApiKeyResult;
  /**
   * Creates a sharing session.
   * If sessionType is not specified, defaults to Search Party.
   */
  createSharingSession: SharingSession;
  createTestimonialReminder: User;
  createTextPost: TextPost;
  createUser?: Maybe<User>;
  createVideoPost: VideoPost;
  /**
   * Create a Zendesk ticket from in-app cancellation webview flow.
   * Return true if ticket was successfully created.
   */
  createZendeskCancellationTicket?: Maybe<CreateZendeskTicketResult>;
  createZendeskReplacementTicket?: Maybe<CreateZendeskTicketResult>;
  createZendeskTroubleshootingTicket?: Maybe<CreateZendeskTicketResult>;
  deleteComment?: Maybe<Scalars['Boolean']['output']>;
  deletePetDocument: Scalars['Boolean']['output'];
  deleteTextPost?: Maybe<Scalars['Boolean']['output']>;
  deleteVideoPost?: Maybe<Scalars['Boolean']['output']>;
  disconnectAppIntegration: DisconnectAppIntegrationResult;
  /**
   * Dismisses a mobile app content item for the current user. `id` is the content's id (e.g. a Splash Screen
   * or Banner). For content surfaced via a visibility trigger (e.g. a per-pet "Week in Review" banner), pass the
   * surfacing content's `dismissalTriggerId` to dismiss that exact trigger; with no `triggerId` every
   * currently-dismissible trigger for the content is dismissed.
   */
  dismissMobileAppContent?: Maybe<Scalars['Boolean']['output']>;
  dismissPetInsights?: Maybe<Scalars['Boolean']['output']>;
  dismissPromotionBanner?: Maybe<Scalars['Boolean']['output']>;
  downgradeSeries2?: Maybe<DowngradeSeries2Result>;
  downgradeSeries3?: Maybe<DowngradeSeries3Result>;
  /** @deprecated Use enableOrExtendQuickReportModeForPet */
  enableOrExtendQuickReportMode?: Maybe<EnableOrExtendQuickReportModeResult>;
  enableOrExtendQuickReportModeForPet?: Maybe<EnableOrExtendQuickReportModeResult>;
  /**
   * Ends a sharing session (Search Party or Location Sharing) for a pet.
   *
   * **Recovery Notifications for Lost Dog Mode:**
   * When a search party ends during Lost Dog Mode termination (when the user turns off Lost Dog Mode
   * via "Found my dog" in the app), recovery notifications are automatically sent to users who
   * acknowledged the search party. These notifications inform users that the pet has been found safe.
   *
   * Recovery notifications are ONLY sent when:
   * - The session type is SEARCH_PARTY
   * - The search party is ended via Lost Dog Mode termination (not via this GraphQL mutation)
   *
   * Recovery notifications are NOT sent when:
   * - The session type is LOCATION_SHARING
   * - The search party is ended via this GraphQL mutation directly
   * - No users acknowledged the search party
   *
   * To trigger recovery notifications, use the `updateDeviceOperationParams` mutation to change
   * the device mode from LOST_DOG to NORMAL, which will automatically end the search party and
   * send recovery notifications.
   */
  endSharingSession: EndSharingSessionResult;
  /**
   * Execute a prorated upgrade (S1/S2→S3+/Mini).
   * Issues prorated credit, terminates old subscription, creates new subscription.
   * The prorated credit is applied to the account balance before termination,
   * and auto-applies to reduce the charge for the new subscription.
   * Requires: Admin or Customer Support role
   */
  executeProratedUpgrade: ProductTransferResult;
  /**
   * Execute a SKU-only product transfer (S3→S3+, Mini↔S3+).
   * Changes the subscription plan code and charges a hardware fee.
   * The subscription is moved from the source device to the target device.
   * Requires: Admin or Customer Support role
   */
  executeSkuOnlyTransfer: ProductTransferResult;
  extendSubscription: BillingSubscription;
  forceRefundRMA?: Maybe<RMA>;
  /**
   * Holds the pet's step-goal streak in place for the next `days` days, starting today.
   * Frozen days neither extend nor break the streak.
   */
  freezeStreak: Pet;
  /** Places an order on hold, preventing it from being sent to DCL */
  holdOrder: Order;
  ignoreVetSuggestion: Array<Veterinary>;
  inviteUserToHousehold: InviteUserToHouseholdResult;
  /** Bookmark a dog park for the given pets. Idempotent; has no effect on checkins or leaderboards. */
  joinDogPark: JoinedDogPark;
  joinPack?: Maybe<Pack>;
  /**
   * Remove a dog park bookmark for the given pets. Idempotent. Null when the park has been deleted,
   * which a leave still accepts so the bookmark can be cleaned up.
   */
  leaveDogPark?: Maybe<JoinedDogPark>;
  leavePack?: Maybe<Pack>;
  markInvoiceFailed: RecurlyInvoice;
  moderationApproveContent?: Maybe<Scalars['Boolean']['output']>;
  moderationRejectContent?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Send push notifications to nearby users about an active search party.
   *
   * This mutation:
   * 1. Finds nearby users using proximity detection (Databricks or Redis GEO)
   * 2. Filters by mute preferences (excludes users with muteAllSearchParties: true)
   * 3. Queues a background job to send notifications asynchronously
   * 4. Returns immediately with estimated notification count
   *
   * The actual notification sending happens asynchronously in a background job.
   * The notificationsSent count is an estimate based on the number of user IDs that will be notified.
   */
  notifyNearbyUsersForSearchParty: NotifyNearbyUsersResult;
  notifyWroteReview: User;
  pauseMembership?: Maybe<PauseMembershipResult>;
  purchaseConsumerStoreCart: CartPurchaseResult;
  purchaseMembershipUpgrade: CartPurchaseResult;
  purchaseMonthlyUpgradePromotion: CartPurchaseResult;
  purchaseRenewAndSave: CartPurchaseResult;
  purchaseSeries3UpgradeCart: CartPurchaseResult;
  purchaseSubscription: CartPurchaseResult;
  purchaseUpgradeToSeriesThreePlusModule: CartPurchaseResult;
  purchaseUpgradeToUltra: CartPurchaseResult;
  reactivateSubscription: BillingSubscription;
  reassignChipToReseller: ResellerChip;
  /** Reassign a device from its current pet to a new pet. */
  reassignDevice: Pet;
  /** Chip resellers: recall the chip from the current owner and return it to the reseller's inventory with pet assigned. */
  recallChip: ResellerChip;
  recordAppInstallForUser: RecordAppInstallForUserResult;
  refundInvoice: RecurlyInvoice;
  /** @deprecated registerChipResellerV2 is the new version of this mutation. */
  registerChipReseller: ChipReseller;
  registerChipResellerV2: ChipReseller;
  /**
   * [Partner setup - token auth] Register an uploaded document key on the account.
   * Call after uploading file to the presigned URL. Unauthenticated.
   */
  registerConsignmentPartnerDocument: Scalars['Boolean']['output'];
  registerHandset: Handset;
  registerHandsetLiveActivityToken: Scalars['Boolean']['output'];
  registerThirdPartyChip: ResellerChip;
  /** Releases an order from hold, restoring the appropriate status based on its line item state */
  releaseOrderHold: Order;
  /**
   * Verified rescues: detach a pet and any owner/contact info from a chip the rescue owns, returning the chip to the
   * rescue's "In Stock" inventory. Use this when a chip was incorrectly attached to a pet — unlike `recallChip`, this
   * clears both the pet and the latest contact history entry.
   */
  removeChipFromPet: ResellerChip;
  /** Remove all containment zones for a safe zone (Place). */
  removeContainmentZonesForSafeZone: Place;
  /**
   * Remove a coupon from an account
   * Requires: Admin or Customer Support role
   */
  removeCouponFromAccount: Scalars['Boolean']['output'];
  removeDynamicEnumMember: DynamicEnum;
  removeFiNewsNotification?: Maybe<Scalars['Boolean']['output']>;
  removeHouseholdVets: Array<Veterinary>;
  removePet?: Maybe<Scalars['Boolean']['output']>;
  removePetInstagramHandle: Pet;
  removePhoto?: Maybe<Scalars['Boolean']['output']>;
  removePlace?: Maybe<Scalars['Boolean']['output']>;
  removeUserEmail: User;
  removeUserFromHousehold: RemoveUserFromHouseholdResult;
  removeWifiCredentials: ModifyWifiCredentialResult;
  renewSubscription?: Maybe<RenewSubscriptionResult>;
  /** Assign the input member IDs monotonically increasing `order` values. */
  reorderDynamicEnumMembers: DynamicEnum;
  /** Report a charging base that was in BLE connection range of the provided position */
  reportChargingBaseAtPosition: Scalars['Boolean']['output'];
  /**
   * Request a GDPR-compliant data export for the authenticated user.
   * Returns a result indicating success and an estimated time for export completion.
   */
  requestDataExport: DataExportRequestResult;
  requestEmailVerification: Scalars['Boolean']['output'];
  requestUserAccountDeletion: AccountDeletionRequestResult;
  requestVerificationCode: User;
  rerouteShipments: Array<OrderShipment>;
  /** Retire a foster home: archive the record and tear the home down. Rejected if a pet is still placed. */
  rescueArchiveFosterHome: RescueFosterHome;
  rescueCancelPetAdoptionTransfer: RescueCancelPetAdoptionTransferResult;
  rescueCancelScheduledHandoff: RescueScheduledHandoffResult;
  rescueCreateDeviceOrder: RescueCreateDeviceOrderResult;
  /**
   * Set a foster home up ahead of any placement, so the rescue can line its volunteers up before it
   * has a pet to place. Creates the foster household and the foster-home record.
   *
   * Nothing reaches the foster contact here — no invite, no SMS. They are first contacted when
   * `rescueCreatePetFosterTransfer` places a pet and device into the home, which is also what adds
   * them to it. Until then this is a rescue-side record, visible in `rescueFosterHomes`.
   *
   * Reuse-first: a contact who already has an active foster home with this rescue gets that home back
   * with a refreshed contact snapshot rather than a second one, so a retry is safe and one volunteer
   * is never split across two homes. Call `rescueFosterHomeForContact` first to show that in the UI.
   */
  rescueCreateFosterHome: RescueFosterHome;
  rescueCreateNanoOrder: RescueCreateNanoOrderResult;
  rescueCreatePetAdoptionTransfer: RescueCreatePetAdoptionTransferResult;
  rescueCreatePetFosterTransfer: RescueCreatePetFosterTransferResult;
  rescueDisableShelterluv: ChipReseller;
  rescueEnableShelterluv: ChipReseller;
  rescueEnrollDevicesProgram: RescueDevicesProgram;
  rescueEnrollGwa: EnrollGwaResult;
  /**
   * Mark a stalled pending adoption as "not recovered": the rescue steps out of the adoption
   * household but the collar stays attached to its pet so a future owner can still claim + subscribe.
   */
  rescueMarkAdoptionTransferNotRecovered: RescueMarkAdoptionTransferNotRecoveredResult;
  /**
   * Mark a stalled pending adoption as "recovered": the rescue got the collar back. Closes the
   * transfer and returns the device to the rescue's unassigned stock.
   */
  rescueMarkAdoptionTransferRecovered: RescueMarkAdoptionTransferRecoveredResult;
  /** Flag a PENDING adoption transfer as stalled. Does not resolve it; only sets stalledAt. */
  rescueMarkAdoptionTransferStalled: RescueMarkAdoptionTransferStalledResult;
  rescueRecallPet?: Maybe<RescueRecallPetResult>;
  rescueRecallPetFosterTransfer: RescueRecallPetFosterTransferResult;
  rescueRequestGwaPostcards: RescueGwaPostcardOrder;
  rescueRescheduleHandoff: RescueScheduledHandoffResult;
  rescueScheduleHandoff: RescueScheduledHandoffResult;
  rescueSendSms: RescueSendSmsResult;
  /**
   * Opt the rescue's reseller in or out of email updates for registrations imported
   * from ShelterLuv. Requires the ShelterLuv integration to be enabled.
   */
  rescueSetShelterluvEmailUpdateOptIn: ChipReseller;
  /**
   * Record that the rescue certified their tax position. Which wording they're entitled to sign is
   * derived server-side from their jurisdiction and organisation type, never taken from the client, so a
   * rescue in a jurisdiction granting no exemption can't claim one. Rejected if `version` isn't the
   * wording currently in force.
   *
   * Gated: unavailable until the wording has been signed off, since a signature records its version
   * permanently.
   */
  rescueSignExemptionAttestation: RescueExemptionAttestationRecord;
  /**
   * Hand off a CSV that was just uploaded via `rescueGetImportUploadUrl` to a worker for
   * processing. Creates a `fi_rescue_csv_import` tracking row in QUEUED state and enqueues a
   * BullMQ job; clients poll `rescueCsvImportProgress(id: ...)` to follow progress. Idempotent: the same
   * `uploadedFileKey` returns the existing row and does not enqueue a duplicate job.
   */
  rescueStartImport: RescueCsvImportProgress;
  /**
   * Restores a recently broken streak by marking the missed days as rescued, so the
   * streak reconnects and keeps growing.
   */
  rescueStreak: Pet;
  /**
   * File a 501(c)(3) determination letter the caller just uploaded via `rescueGet501c3UploadUrl`,
   * putting it in the PENDING queue for internal review (admins then approve or reject it). The
   * document is recorded against the calling user, who is also recorded as its uploader.
   *
   * Submitting again replaces the caller's current letter: the previous row is marked SUPERSEDED and
   * retained for audit, and the new one starts at PENDING. That is also how a rescue responds to a
   * REJECTED letter. Not idempotent — a repeated call supersedes and re-queues.
   */
  rescueSubmit501c3Document: RescueDocument;
  /**
   * File the document this rescue's jurisdiction asks for. Expects a key from
   * `rescueGet501c3UploadUrl`. The document type is derived, not supplied — uploading under the wrong
   * type would file the wrong kind of proof against a tax requirement. Supersedes any document already
   * on file of that type rather than replacing it, so the audit trail survives.
   */
  rescueSubmitExemptionDocument: RescueDocument;
  rescueTransferPetPermanently?: Maybe<RescueTransferPetPermanentlyResult>;
  rescueTransferPetTemporarily?: Maybe<RescueTransferPetTemporarilyResult>;
  rescueUnenrollDevicesProgram: RescueDevicesProgram;
  /** Update the contact snapshot on one of the rescue's foster homes. */
  rescueUpdateFosterHomeContact: RescueFosterHome;
  rescueUpdateGwaPromoCode: UpdateGwaPromoCodeResult;
  resolveChipTransfer: ChipTransfer;
  resolvePetAdoptionTransfer: ResolvePetAdoptionTransferResult;
  /** Restrict processing for a user (GDPR Art. 18). Allowed for admins/CS or the user themselves. */
  restrictUserProcessing: User;
  resumeMembership?: Maybe<ResumeMembershipResult>;
  /**
   * Re-queue the DCL sync job for a single RMA that failed to sync. Accepts an RMA number
   * (e.g. `RMA-6G0591`) or a numeric id.
   */
  resyncRMAToDcl?: Maybe<RMA>;
  /**
   * Retry collection of a past-due invoice for the native dunning recovery flow, after the
   * caller has stored a new payment method (e.g. via saveBillingInfoFromSetupIntent). Wraps
   * Recurly invoice collection and clears the dunning state on success. Returns the recovery
   * status so the client can render success/decline inline rather than treating a decline as
   * a hard error.
   */
  retryFailedInvoice: RetryFailedInvoiceResult;
  revokeResellerOrganizationApiKey: ResellerOrganizationApiKey;
  revokeUserInvite: RevokeUserInviteResult;
  /**
   * Store the payment method from a completed SetupIntent and then retry the given past-due invoice
   * in a single call — the combined native equivalent of saveBillingInfoFromSetupIntent followed by
   * retryFailedInvoice. Mirrors the web recover-payment flow: only the supplied invoice is collected,
   * not every outstanding invoice. Returns the collection status; a declined invoice is reported as
   * FAILED rather than failing the mutation.
   */
  saveBillingInfoAndRetryFailedInvoice: RetryFailedInvoiceResult;
  /**
   * Register the payment method from a completed SetupIntent with Recurly.
   * Called after PaymentSheet completes successfully (including any 3DS challenge).
   */
  saveBillingInfoFromSetupIntent: SaveBillingInfoResult;
  sendHealthGptChatMessage: HealthGptChatMessage;
  sendHighFives: Scalars['Boolean']['output'];
  setActivityNote?: Maybe<Activity>;
  setArticleLiked?: Maybe<Article>;
  setCommentLiked?: Maybe<Comment>;
  /**
   * Turn containment feedback on or off for an Ultra collar. `false` persists (containment is off,
   * not unset). Containment zones on the household's safe zones are left untouched.
   */
  setContainmentEnabled: Device;
  /**
   * Set or update containment zones for a safe zone (Place).
   * Each zone in the input will create or replace the corresponding zone type.
   * Omitted zones will be left unchanged.
   */
  setContainmentZonesForSafeZone: Place;
  /**
   * Set a stored payment method (by BillingInfo id) as the account's primary. The previous
   * primary is kept as a backup. Returns the updated billing account.
   */
  setDefaultBillingInfo: BillingAccount;
  setDeviceActuationPattern: DeviceActuationConfiguration;
  /**
   * Client-side report that a previously-created actuation was successfully delivered to / executed
   * by the device — typically used when the mobile app delivered the actuation over BLE and
   * observed the result locally before the device's next backhaul reaches the server. Only marks
   * success; failures are reported by the device itself via the report path.
   */
  setDeviceActuationSuccess: DeviceActuation;
  /** Toggle whether the given device is treated as disabled for its pet. */
  setDeviceDisabled: Device;
  setDeviceLed: Device;
  setDeviceNote: Device;
  /** Force assign a device to a pet, for admins only. */
  setDevicePet?: Maybe<Pet>;
  setDeviceResponseOverride: DeviceResponseOverride;
  setDeviceUpdateChannel: Device;
  setFiNewsNotificationsEnabled: User;
  setMarketingEmailsOptedIn: User;
  setMuteAllSearchParties: User;
  /** Set nearby user detection for an active search party session. */
  setNearbyUserDetection: SharingSession;
  /**
   * Set (or clear with null) the user-selected report cadence applied while the device is in
   * `normal` mode. `0` enables Live (constant tracking), `60..480` is a fixed cadence in seconds.
   */
  setNormalModeReportInterval: Device;
  /** An acting pet is required to make this call. */
  setPetBlocked: StrangerPet;
  /**
   * An acting pet is required to make this call.
   * A dismissed pet will no longer appear in suggested pets to follow.
   */
  setPetDismissed: StrangerPet;
  /** An acting pet is required to make this call. */
  setPetFollowed: StrangerPet;
  /**
   * Set the OperationParamsMode on every device currently assigned to the pet
   * (both primary and secondary positions).
   */
  setPetOperationParamsMode: Pet;
  setPetPrimaryPhoto: Pet;
  setPhotoLiked?: Maybe<Photo>;
  setPrimaryUserEmail: User;
  setSocialBanUser?: Maybe<Scalars['Boolean']['output']>;
  setSocialOptedOut: Household;
  setStepGoalForPet?: Maybe<SetStepGoalForPetResult>;
  setSupplementNextShipDate?: Maybe<SetNextShipmentDateResult>;
  setSupplementShippingAddress?: Maybe<SetShippingAddressResult>;
  setTermsOfServiceAccepted: SetTermsOfServiceAcceptedResult;
  setTextPostLiked?: Maybe<TextPost>;
  setUserLocation: User;
  setUserRoleInHousehold: SetUserRoleInHouseholdResult;
  setVideoPostLiked?: Maybe<VideoPost>;
  setWalkLiked?: Maybe<StrangerWalk>;
  shipOrderLineItems: Order;
  shipOrders: Array<Order>;
  skipSupplementShipment?: Maybe<SkipSupplementShipmentResult>;
  /**
   * Temporarily snooze a pet, suppressing escape/walk/safe zone notifications for the given duration.
   * For Ultra devices, also sends a SNOOZE_ENABLED actuation to the collar.
   */
  snoozePet: PetSnoozeStatus;
  /** @deprecated Phase this out in favor of only using [submitReports].  Arbitrarily overwriting DeviceInfo fields is problematic. */
  submitDeviceInfo?: Maybe<Scalars['Boolean']['output']>;
  submitHealthGptChatMessageFeedback: HealthGptChatMessageUserFeedback;
  /** @deprecated User `userFeedbackEscapeAlertFeedbackSubmit` */
  submitNotificationFeedback?: Maybe<Scalars['Boolean']['output']>;
  submitObservedBehavior: SubmitObservedBehaviorResponse;
  submitRealtimeBehaviorFeedback: SubmitRealtimeBehaviorFeedbackResponse;
  submitReports?: Maybe<SubmitReportsResult>;
  syncAmazonReturnToRMA?: Maybe<RMA>;
  syncOrders: SyncOrdersResults;
  syncOrdersForUser: SyncOrdersResults;
  /** Unassign an owned charging base from the current user. */
  unassignChargingBase: Scalars['Boolean']['output'];
  /** Unassign an owned device from a pet. */
  unassignDevice: Pet;
  undeletePet?: Maybe<Scalars['Boolean']['output']>;
  /** Ends an active streak freeze. Today stays frozen; the streak resumes tomorrow. */
  unfreezeStreak: Pet;
  unregisterHandset?: Maybe<Scalars['Boolean']['output']>;
  unregisterHandsetLiveActivityToken: Scalars['Boolean']['output'];
  /** Lift a user's processing restriction (GDPR Art. 18). Admin/CS only. */
  unrestrictUserProcessing: User;
  /** Cancel an active snooze for a pet. For Ultra devices, sends a SNOOZE_DISABLED actuation. */
  unsnoozePet: PetSnoozeStatus;
  updateBillingAccount: BillingAccount;
  updateChargingBase: ChargingBase;
  updateChipCondition: ResellerChip;
  /** @deprecated Use `chipRegistration*` or `assignNew*ToChip` mutations instead. */
  updateChipContactInfo: UpdateChipContactInfoResult;
  updateChipResellerInfo: ChipReseller;
  /** Update operational parameters for a module */
  updateDeviceOperationParams: Device;
  updateDynamicEnumMember: DynamicEnum;
  updateEcommerceImageList: AdminEcommerceImageList;
  updateFiNewsNotification: FiNewsNotification;
  updateMobileAppBanner: AdminMobileAppBanner;
  updateMobileAppBlockerScreen: AdminMobileAppBlockerScreen;
  updateMobileAppBottomSheet: AdminMobileAppBottomSheet;
  updateMobileAppClientSplash: AdminMobileAppClientSplash;
  updateMobileAppDiscoverItem: AdminMobileAppDiscoverItem;
  updateMobileAppPermissionBlockerScreen: AdminMobileAppPermissionBlockerScreen;
  updateMobileAppSplashScreen: AdminMobileAppSplashScreen;
  updateOrderShippingAddress: Order;
  updateOrderShippingOption: Order;
  updatePet: Pet;
  updatePetAlertPreferences: Pet;
  updatePetCityState?: Maybe<Pet>;
  updatePetDocument: PetDocument;
  updatePhoneNumber: User;
  updatePhoneNumberAndAutoAcceptInvites: UpdatePhoneNumberAndAutoAcceptInvitesResult;
  updatePlace: Place;
  updateResellerContactInfo: ChipReseller;
  updateResellerOrganizationApiKeyRateLimit: ResellerOrganizationApiKey;
  updateResellerRescueVerified: ChipReseller;
  updateShipmentShippingAddress: OrderShipment;
  updateSupplementSubscription?: Maybe<UpdateSupplementSubscriptionResult>;
  /** @deprecated Split into dedicated mutations: updateUserName, updatePhoneNumber, addUserEmail/removeUserEmail. */
  updateUser: User;
  updateUserCommunicationPreferences: User;
  updateUserLocalePreferences: User;
  updateUserName: User;
  updateWifiNetwork: WifiNetwork;
  /**
   * Unassigns the current device and assigns the new unowned device. If the two devices can pair
   * (e.g. an Ultra activated over a Mini/S3 membership), the new device is instead added as the
   * pet's secondary device and the current device keeps its assignment and subscription.
   */
  upgradeDevice: Pet;
  uploadContacts?: Maybe<Scalars['Boolean']['output']>;
  userFeedbackActivityPlayFeedbackSubmit?: Maybe<EventFeedbackResponse>;
  userFeedbackActivityRestFeedbackSubmit?: Maybe<EventFeedbackResponse>;
  userFeedbackActivityTravelFeedbackSubmit?: Maybe<EventFeedbackResponse>;
  userFeedbackActivityWalkFeedbackSubmit?: Maybe<EventFeedbackResponse>;
  userFeedbackEscapeAlertFeedbackSubmit?: Maybe<EventFeedbackResponse>;
  userFeedbackLostDogFeedbackSubmit?: Maybe<EventFeedbackResponse>;
  userFeedbackLostDogModeDidHelp?: Maybe<Scalars['Boolean']['output']>;
  /** Returns base-64 encoded zip file of walk segments in GeoJSON format */
  walkSegmentsGeoJSONZip?: Maybe<Scalars['String']['output']>;
};

export type MutationacceptUserInviteArgs = {
  input: AcceptInviteInput;
};

export type MutationacknowledgeSearchPartyArgs = {
  petId: Scalars['ID']['input'];
};

export type MutationaddCommentComplaintArgs = {
  commentId: Scalars['ID']['input'];
};

export type MutationaddCouponToAccountArgs = {
  input: AddCouponToAccountInput;
};

export type MutationaddHouseholdVetArgs = {
  householdId: Scalars['ID']['input'];
  vetId: Scalars['ID']['input'];
};

export type MutationaddMultipleSupplementSubscriptionsArgs = {
  input: AddMultipleSupplementSubscriptionsInput;
};

export type MutationaddOrderLineItemsArgs = {
  input: AddOrderLineItemsInput;
};

export type MutationaddPetDocumentArgs = {
  input: AddPetDocumentInput;
};

export type MutationaddPetPhotoArgs = {
  input: AddPetPhotoInput;
};

export type MutationaddPhotoCommentArgs = {
  comment: Scalars['String']['input'];
  photoId: Scalars['ID']['input'];
};

export type MutationaddPhotoComplaintArgs = {
  photoId: Scalars['ID']['input'];
};

export type MutationaddPhotoForPetArgs = {
  input: AddPetPhotoInput;
};

export type MutationaddSupplementSubscriptionArgs = {
  input: AddSupplementSubscriptionInput;
};

export type MutationaddTextPostCommentArgs = {
  comment: Scalars['String']['input'];
  textPostId: Scalars['ID']['input'];
};

export type MutationaddTextPostComplaintArgs = {
  textPostId: Scalars['ID']['input'];
};

export type MutationaddThirdPartySubscriptionArgs = {
  input: AddThirdPartySubscriptionInput;
};

export type MutationaddUserEmailArgs = {
  input: AddUserEmailInput;
};

export type MutationaddVideoPostCommentArgs = {
  comment: Scalars['String']['input'];
  videoPostId: Scalars['ID']['input'];
};

export type MutationaddVideoPostComplaintArgs = {
  videoPostId: Scalars['ID']['input'];
};

export type MutationaddWifiCredentialsArgs = {
  input: AddWifiCredentialInput;
};

export type MutationadminActivateFulfillmentWarehouseArgs = {
  warehouseId: Scalars['ID']['input'];
};

export type MutationadminAddDogParkFromOSMArgs = {
  input: AdminAddDogParkFromOSMInput;
};

export type MutationadminAddFirmwareTagArgs = {
  buildAttribute: Scalars['Boolean']['input'];
  tagName: Scalars['String']['input'];
};

export type MutationadminAddNanoIcarIdRangeArgs = {
  input: AdminAddNanoIcarIdRangeInput;
};

export type MutationadminAddPendingMembershipExtensionArgs = {
  accountId: Scalars['ID']['input'];
  days: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};

export type MutationadminAddResellerModulesArgs = {
  input: AddResellerModulesInput;
};

export type MutationadminAddTagToFirmwareUpdateChannelArgs = {
  channelName: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  tagName: Scalars['String']['input'];
};

export type MutationadminAddTagToFirmwareVersionArgs = {
  firmwareVersion: Scalars['String']['input'];
  tagName: Scalars['String']['input'];
};

export type MutationadminAddUserToGroupArgs = {
  groupName: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationadminAddUserToHouseholdArgs = {
  input: AddUserToHouseholdInput;
};

export type MutationadminAddVetSuggestionArgs = {
  householdId: Scalars['ID']['input'];
  vetId: Scalars['ID']['input'];
};

export type MutationadminApproveDogParkRequestArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<POIType>;
};

export type MutationadminApproveGwaPostcardOrderArgs = {
  orderId: Scalars['ID']['input'];
};

export type MutationadminApproveRescueDocumentArgs = {
  documentType?: InputMaybe<RescueDocumentType>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationadminArchiveFirmwareArgs = {
  input: ArchiveFirmwareInput;
};

export type MutationadminAssignRoleArgs = {
  email: Scalars['String']['input'];
  roleId: Scalars['ID']['input'];
};

export type MutationadminAutoTranslateKeysArgs = {
  keys: Array<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  namespace: TranslationNamespace;
};

export type MutationadminBulkAddPetsToUnmanagedPackArgs = {
  packId: Scalars['ID']['input'];
  petIds: Array<Scalars['ID']['input']>;
};

export type MutationadminBulkAssignUsersToGroupArgs = {
  input: AdminBulkAssignUsersToGroupInput;
};

export type MutationadminBulkRequestGwaPostcardMailingsArgs = {
  input: AdminBulkRequestGwaPostcardMailingsInput;
};

export type MutationadminCancelDeletionRequestArgs = {
  reason: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type MutationadminCancelPendingMembershipExtensionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminChargeConsignmentAccountArgs = {
  input: ChargeConsignmentAccountInput;
};

export type MutationadminClaimNanoWebIdsArgs = {
  input: AdminClaimNanoWebIdsInput;
};

export type MutationadminClearChipArgs = {
  chipId: Scalars['ID']['input'];
};

export type MutationadminClearCommunityFeedPostBoostArgs = {
  uuid: Scalars['String']['input'];
};

export type MutationadminCloseInPersonEventArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminCreateBatchRecordsArgs = {
  batch: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  deviceType: DeviceType;
  hwRev: Scalars['String']['input'];
  modelId?: InputMaybe<Scalars['String']['input']>;
  numDigits?: InputMaybe<Scalars['Int']['input']>;
  platform: Scalars['ID']['input'];
  prefix: Scalars['String']['input'];
  startOffset: Scalars['Int']['input'];
};

export type MutationadminCreateBreedArgs = {
  input: AdminCreateBreedInput;
};

export type MutationadminCreateChangeLogArgs = {
  input: CreateChangeLogInput;
};

export type MutationadminCreateConsignmentAccountArgs = {
  input: CreateConsignmentAccountInput;
};

export type MutationadminCreateConsignmentLocationArgs = {
  input: CreateConsignmentLocationInput;
};

export type MutationadminCreateConsignmentOrderArgs = {
  input: AdminCreateConsignmentOrderInput;
};

export type MutationadminCreateConsignmentRecurlyAccountArgs = {
  input: CreateConsignmentRecurlyAccountInput;
};

export type MutationadminCreateCouponArgs = {
  input: CreateCouponInput;
};

export type MutationadminCreateDogParkCheckinExclusionArgs = {
  input: AdminCreateDogParkCheckinExclusionInput;
};

export type MutationadminCreateEmployeeGiftOrderArgs = {
  input: AdminCreateEmployeeGiftOrderInput;
};

export type MutationadminCreateEmployeeGiftSubscriptionCouponArgs = {
  input: AdminCreateEmployeeGiftSubscriptionCouponInput;
};

export type MutationadminCreateEvalGuidelineArgs = {
  input: AdminCreateEvalGuidelineInput;
};

export type MutationadminCreateFirmwareChannelArgs = {
  input: CreateFirmwareChannelInput;
};

export type MutationadminCreateGingrBoardingFacilityArgs = {
  input: CreateGingrBoardingFacilityInput;
};

export type MutationadminCreateGoldenQuestionArgs = {
  input: AdminCreateGoldenQuestionInput;
};

export type MutationadminCreateGwpPartnerProgramArgs = {
  input: CreateGwpPartnerProgramInput;
};

export type MutationadminCreateHealthGptPlaybookArgs = {
  input: AdminCreateHealthGptPlaybookInput;
};

export type MutationadminCreateHouseholdWithUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationadminCreateInPersonEventArgs = {
  input: CreateInPersonEventInput;
};

export type MutationadminCreateInternalOrderArgs = {
  input: AdminCreateInternalOrderInput;
};

export type MutationadminCreateMediaAssetUploadUrlArgs = {
  input: AdminCreateMediaAssetUploadUrlInput;
};

export type MutationadminCreateOrderArgs = {
  input: AdminCreateOrderInput;
};

export type MutationadminCreatePlaceArgs = {
  input: CreatePlaceInput;
  userId: Scalars['ID']['input'];
};

export type MutationadminCreatePlatformArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  platformId: Scalars['ID']['input'];
};

export type MutationadminCreatePromotionArgs = {
  input: CreatePromotionInput;
};

export type MutationadminCreateRescueChipResellerArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationadminCreateRoleArgs = {
  input: AdminRoleInput;
};

export type MutationadminCreateTargetedFeatureFlagArgs = {
  input: AdminCreateTargetedFeatureFlagInput;
};

export type MutationadminCreateTestDataArgs = {
  input: CreateTestDataInput;
};

export type MutationadminCreateUserForBoardingFacilityArgs = {
  input: CreateUserForBoardingFacilityInput;
};

export type MutationadminCreateUserGroupArgs = {
  name: Scalars['String']['input'];
};

export type MutationadminCreateVipUserLookupCriteriaArgs = {
  input: AdminCreateVipUserLookupCriteriaInput;
};

export type MutationadminDeactivateEvalGuidelineArgs = {
  key: Scalars['String']['input'];
};

export type MutationadminDeactivateFulfillmentWarehouseArgs = {
  warehouseId: Scalars['ID']['input'];
};

export type MutationadminDeactivateGwpPartnerProgramArgs = {
  slug: Scalars['String']['input'];
};

export type MutationadminDeactivateHealthGptPlaybookArgs = {
  key: Scalars['String']['input'];
};

export type MutationadminDeactivateUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationadminDeleteChangeLogArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDeleteConsignmentAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDeleteConsignmentLocationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDeleteDogParkCheckinExclusionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDeleteFirmwareChannelArgs = {
  input: DeleteFirmwareChannelInput;
};

export type MutationadminDeleteGoldenQuestionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDeleteHealthGptMemoryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDeletePackArgs = {
  packId: Scalars['ID']['input'];
};

export type MutationadminDeletePromotionArgs = {
  id: Scalars['Int']['input'];
};

export type MutationadminDeleteRoleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDeleteTranslationArgs = {
  key: Scalars['String']['input'];
  namespace: TranslationNamespace;
};

export type MutationadminDeleteUserGroupArgs = {
  name: Scalars['String']['input'];
};

export type MutationadminDeleteVipUserLookupCriteriaArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDisableShelterluvArgs = {
  chipResellerId: Scalars['ID']['input'];
};

export type MutationadminDuplicatePromotionArgs = {
  input: DuplicatePromotionInput;
};

export type MutationadminEnableShelterluvArgs = {
  input: UpdateShelterluvConfigInput;
};

export type MutationadminExpireAndRecreateCouponArgs = {
  input: CreateCouponInput;
};

export type MutationadminExpireCouponArgs = {
  name: Scalars['String']['input'];
};

export type MutationadminExpireResellerModulesArgs = {
  input: ExpireResellerModulesInput;
};

export type MutationadminExtendEmployeeGiftSubscriptionArgs = {
  input: AdminExtendEmployeeGiftSubscriptionInput;
};

export type MutationadminFinalizeMediaAssetUploadArgs = {
  path: Scalars['String']['input'];
};

export type MutationadminFireMobileAppContentTriggersArgs = {
  input: AdminFireMobileAppContentTriggersInput;
};

export type MutationadminForceProcessDeletionRequestArgs = {
  uuid: Scalars['String']['input'];
};

export type MutationadminGenerateConsignmentPartnerSetupTokenArgs = {
  consignmentAccountId: Scalars['ID']['input'];
};

export type MutationadminHealthGptAddQuestionArgs = {
  input: AdminHealthGptAddMessageInput;
};

export type MutationadminHealthGptCreateDocumentArgs = {
  input: AdminHealthGptCreateDocumentInput;
};

export type MutationadminHealthGptDeleteDocumentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminHealthGptUpdateDocumentArgs = {
  input: AdminHealthGptUpdateDocumentInput;
};

export type MutationadminImportChipsArgs = {
  input: ChipImportInput;
};

export type MutationadminIncrementNumConfirmedReferralsArgs = {
  amount: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationadminIssueGiftCardArgs = {
  input: AdminIssueGiftCardInput;
};

export type MutationadminMarkConsignmentAvalaraConfirmedArgs = {
  consignmentAccountId: Scalars['ID']['input'];
};

export type MutationadminMigrateModulesToFirmwareChannelArgs = {
  channel: Scalars['String']['input'];
  deviceType: DeviceType;
  moduleIds: Array<Scalars['String']['input']>;
  platform: Scalars['String']['input'];
};

export type MutationadminPauseMembershipArgs = {
  input: AdminPauseMembershipInput;
};

export type MutationadminPublishRescueStoryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminPublishTestPetUpdateArgs = {
  changeType?: InputMaybe<PetChangeType>;
  petId: Scalars['ID']['input'];
};

export type MutationadminRegisterConsignmentAgreementArgs = {
  input: RegisterConsignmentAgreementInput;
};

export type MutationadminRegisterConsignmentResaleCertificateArgs = {
  input: RegisterConsignmentResaleCertificateInput;
};

export type MutationadminReinstateStreakArgs = {
  petId: Scalars['ID']['input'];
};

export type MutationadminRejectDogParkRequestArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminRejectGwaPostcardOrderArgs = {
  orderId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationadminRejectRescueDocumentArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationadminRejectRescueStoryArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationadminRemoveBillingInfoArgs = {
  input: AdminRemoveBillingInfoInput;
};

export type MutationadminRemoveConsignmentAgreementArgs = {
  consignmentAccountId: Scalars['ID']['input'];
};

export type MutationadminRemoveConsignmentResaleCertificateArgs = {
  consignmentAccountId: Scalars['ID']['input'];
};

export type MutationadminRemoveFeatureFlagArgs = {
  name: Scalars['String']['input'];
};

export type MutationadminRemoveTagFromFirmwareUpdateChannelArgs = {
  channelName: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  tagName: Scalars['String']['input'];
};

export type MutationadminRemoveTagFromFirmwareVersionArgs = {
  firmwareVersion: Scalars['String']['input'];
  tagName: Scalars['String']['input'];
};

export type MutationadminRemoveUserFromGroupArgs = {
  groupName: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationadminReopenRescueDocumentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminRequestGwaPostcardMailingArgs = {
  input: AdminRequestGwaPostcardMailingInput;
};

export type MutationadminResetConsignmentBurnerPartnerArgs = {
  input: AdminResetConsignmentBurnerPartnerInput;
};

export type MutationadminResetDeviceBatteryStateArgs = {
  moduleId: Scalars['String']['input'];
};

export type MutationadminRestoreHealthGptMemoryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminResumeMembershipArgs = {
  input: AdminResumeMembershipInput;
};

export type MutationadminRetriggerEvaluationArgs = {
  messageId: Scalars['Int']['input'];
};

export type MutationadminRetryDeletionRequestArgs = {
  uuid: Scalars['String']['input'];
};

export type MutationadminRevokeConsignmentTaxExemptArgs = {
  consignmentAccountId: Scalars['ID']['input'];
};

export type MutationadminRevokeRoleArgs = {
  email: Scalars['String']['input'];
  roleId: Scalars['ID']['input'];
};

export type MutationadminSendBackgroundNotificationArgs = {
  input: SendBackgroundNotificationInput;
};

export type MutationadminSendFreeNanoBoxesArgs = {
  input: AdminSendFreeNanoBoxesInput;
};

export type MutationadminSendNotificationArgs = {
  input: SendNotificationInput;
};

export type MutationadminSendSearchPartyTestNotificationArgs = {
  petId: Scalars['ID']['input'];
  userIds: Array<Scalars['Int']['input']>;
};

export type MutationadminSendServerPushToDeviceArgs = {
  moduleId: Scalars['String']['input'];
};

export type MutationadminSetAutomaticallyActivateDevicesOnUserArgs = {
  automaticallyActivateDevices: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationadminSetChargingBaseOwnerArgs = {
  baseId: Scalars['String']['input'];
  householdId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationadminSetChargingBaseUpdateChannelArgs = {
  baseId: Scalars['String']['input'];
  channelName: Scalars['String']['input'];
};

export type MutationadminSetChipResellerNameArgs = {
  name: Scalars['String']['input'];
  subjectId: Scalars['ID']['input'];
};

export type MutationadminSetChipResellerRescueVerifiedArgs = {
  subjectId: Scalars['ID']['input'];
  verified: Scalars['Boolean']['input'];
};

export type MutationadminSetChipResellerStatusArgs = {
  status: ResellerStatus;
  subjectId: Scalars['ID']['input'];
};

export type MutationadminSetChipResellerTypesArgs = {
  subjectId: Scalars['ID']['input'];
  types: Array<ResellerType>;
};

export type MutationadminSetCommentHiddenArgs = {
  commentId: Scalars['ID']['input'];
  hidden: Scalars['Boolean']['input'];
};

export type MutationadminSetCommunityFeedModifiersArgs = {
  input: SetCommunityFeedModifiersInput;
};

export type MutationadminSetCommunityFeedPostBoostArgs = {
  input: SetCommunityFeedPostBoostInput;
};

export type MutationadminSetCommunityFeedTrendingMetaArgs = {
  input: SetCommunityFeedTrendingMetaInput;
};

export type MutationadminSetDeviceAutoAddUserToHouseholdArgs = {
  moduleId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationadminSetDeviceCxdUpdateEligibilityArgs = {
  enable: Scalars['Boolean']['input'];
  moduleId: Scalars['String']['input'];
};

export type MutationadminSetDeviceEuiccServiceProviderOverrideArgs = {
  moduleId: Scalars['String']['input'];
  serviceProvider?: InputMaybe<EuiccServiceProvider>;
};

export type MutationadminSetDeviceFirmwareUpdateEligibilityArgs = {
  enable: Scalars['Boolean']['input'];
  moduleId: Scalars['String']['input'];
};

export type MutationadminSetDeviceIsBlockedArgs = {
  isBlocked: Scalars['Boolean']['input'];
  moduleId: Scalars['String']['input'];
};

export type MutationadminSetDeviceIsRefurbishedArgs = {
  isRefurbished: Scalars['Boolean']['input'];
  moduleId: Scalars['String']['input'];
};

export type MutationadminSetDeviceTagsArgs = {
  moduleId: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type MutationadminSetFeatureFlagArgs = {
  name: Scalars['String']['input'];
  type: SetFeatureFlagType;
  value: SetFeatureFlagValue;
};

export type MutationadminSetFeedDecayCurveConfigArgs = {
  input: SetFeedDecayCurveConfigInput;
};

export type MutationadminSetFirmwareRolloutQuantityArgs = {
  deviceType: DeviceType;
  platform: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  sourceChannel: Scalars['String']['input'];
  sourceVersion?: InputMaybe<Scalars['String']['input']>;
  targetChannel: Scalars['String']['input'];
};

export type MutationadminSetPhotoDeletedArgs = {
  deleted: Scalars['Boolean']['input'];
  photoId: Scalars['ID']['input'];
};

export type MutationadminSetRemoteLoggingForFirmwareChannelArgs = {
  input: SetRemoteLoggingForFirmwareChannelInput;
};

export type MutationadminSetSubscriptionIdOnDeviceArgs = {
  ecomConfigType?: InputMaybe<Scalars['String']['input']>;
  moduleId: Scalars['String']['input'];
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationadminSetThirdPartyAccessArgs = {
  input: AdminSetThirdPartyAccessInput;
};

export type MutationadminSetUserGroupsArgs = {
  groups: Array<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type MutationadminStartGoldenQuestionRunArgs = {
  input: AdminStartGoldenQuestionRunInput;
};

export type MutationadminStartNanoIcarIdOnlyClaimArgs = {
  input: AdminStartNanoClaimInput;
};

export type MutationadminStartNanoWebIdClaimArgs = {
  input: AdminClaimNanoWebIdsInput;
};

export type MutationadminStartNanoWebIdOnlyClaimArgs = {
  input: AdminStartNanoClaimInput;
};

export type MutationadminSubmitCertGenJobArgs = {
  batch: Scalars['String']['input'];
  deviceType: DeviceType;
};

export type MutationadminSyncConsignmentTaxExemptArgs = {
  consignmentAccountId: Scalars['ID']['input'];
};

export type MutationadminTriggerCustomerIoTrackEventForTestUserArgs = {
  emailAddress: Scalars['String']['input'];
  eventData?: InputMaybe<Scalars['JSON']['input']>;
  eventName: Scalars['String']['input'];
};

export type MutationadminTriggerSkuSyncArgs = {
  configType?: InputMaybe<Scalars['String']['input']>;
};

export type MutationadminUndismissMobileAppContentArgs = {
  dbId: Scalars['Int']['input'];
};

export type MutationadminUpdateAccountAddressArgs = {
  input: AdminUpdateAccountAddressInput;
};

export type MutationadminUpdateAccountDetailsArgs = {
  input: AdminUpdateAccountDetailsInput;
};

export type MutationadminUpdateBreedArgs = {
  id: Scalars['ID']['input'];
  input: AdminUpdateBreedInput;
};

export type MutationadminUpdateChangeLogArgs = {
  input: UpdateChangeLogInput;
};

export type MutationadminUpdateChipPetArgs = {
  input: AdminUpdateChipPetInput;
};

export type MutationadminUpdateChipResellerArgs = {
  input: AdminUpdateChipResellerInput;
};

export type MutationadminUpdateChipResellerByBoxArgs = {
  input: AdminUpdateChipResellerByBoxInput;
};

export type MutationadminUpdateChipResellerByBoxIdsArgs = {
  input: AdminUpdateChipResellerByBoxIdsInput;
};

export type MutationadminUpdateChipResellerBySerialNumberArgs = {
  input: AdminUpdateChipResellerBySerialNumberInput;
};

export type MutationadminUpdateConsignmentAccountArgs = {
  id: Scalars['ID']['input'];
  input: UpdateConsignmentAccountInput;
};

export type MutationadminUpdateConsignmentLocationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateConsignmentLocationInput;
};

export type MutationadminUpdateConsignmentRecurlyShippingAddressArgs = {
  input: UpdateConsignmentRecurlyShippingAddressInput;
};

export type MutationadminUpdateConsignmentResaleCertFieldsArgs = {
  input: UpdateConsignmentResaleCertFieldsInput;
};

export type MutationadminUpdateDeviceCellularStatusArgs = {
  moduleId: Scalars['String']['input'];
};

export type MutationadminUpdateDeviceHasActiveSubscriptionArgs = {
  hasSubscriptionOverride: Scalars['Boolean']['input'];
  moduleId: Scalars['String']['input'];
};

export type MutationadminUpdateDeviceSubscriptionOverrideEndsAtArgs = {
  moduleId: Scalars['String']['input'];
  subscriptionOverrideEndsAt?: InputMaybe<Scalars['String']['input']>;
};

export type MutationadminUpdateDeviceTenancyArgs = {
  moduleId: Scalars['String']['input'];
  tenancy: Scalars['String']['input'];
};

export type MutationadminUpdateEvalGuidelineArgs = {
  input: AdminUpdateEvalGuidelineInput;
};

export type MutationadminUpdateFirmwareArgs = {
  input: UpdateFirmwareInput;
};

export type MutationadminUpdateFirmwareChannelArgs = {
  input: UpdateFirmwareChannelInput;
};

export type MutationadminUpdateGingrBoardingFacilityArgs = {
  input: UpdateGingrBoardingFacilityInput;
};

export type MutationadminUpdateGoldenQuestionArgs = {
  input: AdminUpdateGoldenQuestionInput;
};

export type MutationadminUpdateGwpPartnerProgramAutoApplyArgs = {
  autoApply: Scalars['Boolean']['input'];
  slug: Scalars['String']['input'];
};

export type MutationadminUpdateGwpPartnerProgramDiscountArgs = {
  discountsInCents: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
};

export type MutationadminUpdateHealthGptPlaybookArgs = {
  input: AdminUpdateHealthGptPlaybookInput;
};

export type MutationadminUpdateHouseholdNameArgs = {
  householdId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MutationadminUpdateHouseholdTenancyArgs = {
  householdId: Scalars['ID']['input'];
  recursive?: InputMaybe<Scalars['Boolean']['input']>;
  tenancy: Scalars['String']['input'];
};

export type MutationadminUpdateHouseholdThirdPartyAccessArgs = {
  householdId: Scalars['ID']['input'];
  thirdPartyAccess?: InputMaybe<Scalars['String']['input']>;
};

export type MutationadminUpdateInPersonEventArgs = {
  input: UpdateInPersonEventInput;
};

export type MutationadminUpdateInPersonEventInventoryArgs = {
  input: UpdateInPersonEventInventoryInput;
};

export type MutationadminUpdateInventoryConfigurationArgs = {
  input: AdminUpdateInventoryConfigurationInput;
};

export type MutationadminUpdatePetTenancyArgs = {
  petId: Scalars['ID']['input'];
  recursive?: InputMaybe<Scalars['Boolean']['input']>;
  tenancy: Scalars['String']['input'];
};

export type MutationadminUpdatePlatformArgs = {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  platformId: Scalars['ID']['input'];
};

export type MutationadminUpdateProductSkuArgs = {
  input: AdminUpdateProductSkuInput;
};

export type MutationadminUpdatePromotionArgs = {
  input: UpdatePromotionInput;
};

export type MutationadminUpdateRescueStateExemptionRuleArgs = {
  input: AdminUpdateRescueStateExemptionRuleInput;
};

export type MutationadminUpdateRescueStoryArgs = {
  input: UpdateRescueStoryInput;
};

export type MutationadminUpdateRoleArgs = {
  id: Scalars['ID']['input'];
  input: AdminRoleInput;
};

export type MutationadminUpdateShelterluvConfigArgs = {
  input: UpdateShelterluvConfigInput;
};

export type MutationadminUpdateTargetedFeatureFlagArgs = {
  input: AdminUpdateTargetedFeatureFlagInput;
};

export type MutationadminUpdateUserLanguageArgs = {
  language: FiLanguage;
  userId: Scalars['ID']['input'];
};

export type MutationadminUpdateUserRegionArgs = {
  region: FiCountry;
  userId: Scalars['ID']['input'];
};

export type MutationadminUploadImageArgs = {
  data: Scalars['Binary']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
};

export type MutationadminUploadRescueDocumentArgs = {
  input: AdminUploadRescueDocumentInput;
};

export type MutationadminUploadRescueStoryPosterArgs = {
  data: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type MutationadminUpsertFulfillmentWarehouseArgs = {
  input: AdminUpsertFulfillmentWarehouseInput;
};

export type MutationadminUpsertTranslationArgs = {
  input: UpsertTranslationInput;
  namespace: TranslationNamespace;
};

export type MutationapproveInternalOrderArgs = {
  orderId: Scalars['ID']['input'];
};

export type MutationassignChargingBaseArgs = {
  baseId: Scalars['String']['input'];
  householdId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationassignDeviceArgs = {
  iccid?: InputMaybe<Scalars['String']['input']>;
  moduleId: Scalars['String']['input'];
  petId: Scalars['ID']['input'];
};

export type MutationassignExistingPetToChipArgs = {
  input: AssignExistingPetToChipInput;
};

export type MutationassignNewOwnerToChipArgs = {
  input: AssignNewOwnerToChipInput;
};

export type MutationassignNewPetToChipArgs = {
  input: AssignNewPetToChipInput;
};

export type MutationboardingFacilityCheckInPetArgs = {
  input: BoardingFacilityCheckInPetInput;
};

export type MutationboardingFacilityCheckOutPetArgs = {
  boardingSessionId: Scalars['ID']['input'];
};

export type MutationcancelAndRefundSubscriptionArgs = {
  input: CancelAndRefundSubscriptionInput;
};

export type MutationcancelDeletionRequestArgs = {
  input: CancelDeletionRequestInput;
};

export type MutationcancelMembershipArgs = {
  input: CancelMembershipInput;
};

export type MutationcancelOrderLineItemsArgs = {
  input: CancelOrderLineItemsInput;
};

export type MutationcancelOrdersArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type MutationcancelRMAArgs = {
  id: Scalars['ID']['input'];
};

export type MutationcancelSupplementSubscriptionArgs = {
  input: CancelSupplementSubscriptionInput;
};

export type MutationcancelThirdPartySubscriptionArgs = {
  input: CancelThirdPartySubscriptionInput;
};

export type MutationchangeMembershipPlanEndOfTermArgs = {
  input: ChangeMembershipPlanEndOfTermInput;
};

export type MutationchangePetHouseholdArgs = {
  householdId: Scalars['ID']['input'];
  subjectId: Scalars['ID']['input'];
};

export type MutationchangePlaceHouseholdArgs = {
  householdId: Scalars['ID']['input'];
  subjectId: Scalars['ID']['input'];
};

export type MutationchargeAccountBySkuArgs = {
  input: ChargeAccountBySkuInput;
};

export type MutationcheckInRMAArgs = {
  input: CheckInRMAInput;
};

export type MutationcheckInUnknownReturnArgs = {
  input: CheckInUnknownReturnInput;
};

export type MutationchipRegistrationAddEmailArgs = {
  input: ChipRegistrationAddEmailInput;
};

export type MutationchipRegistrationAddExistingPetArgs = {
  input: ChipRegistrationAddExistingPetInput;
};

export type MutationchipRegistrationAddNewPetArgs = {
  input: ChipRegistrationAddNewPetInput;
};

export type MutationchipRegistrationUpdateContactArgs = {
  input: ChipRegistrationUpdateContactInput;
};

export type MutationclaimClickToCancelDiscountArgs = {
  input: ClaimClickToCancelDiscountInput;
};

export type MutationclaimFreeMonthArgs = {
  input: ClaimFreeMonthInput;
};

export type MutationclaimFreeTrialCancelDeterrentArgs = {
  input: ClaimFreeTrialCancelDeterrentInput;
};

export type MutationclaimSupplementDiscountArgs = {
  input: ClaimSupplementDiscountInput;
};

export type MutationclaimTwoMonthsHalfOffArgs = {
  input: ClaimTwoMonthsHalfOffInput;
};

export type MutationclearDeviceResponseOverrideArgs = {
  moduleId: Scalars['String']['input'];
};

export type MutationconfirmSetupIntentArgs = {
  confirmationTokenId: Scalars['String']['input'];
};

export type MutationconvertFreeTrialArgs = {
  input: ConvertFreeTrialInput;
};

export type MutationconvertQuickZoneToPermanentArgs = {
  name: Scalars['String']['input'];
  subjectId: Scalars['ID']['input'];
};

export type MutationcreateBillingAccountArgs = {
  input: CreateBillingAccountInput;
};

export type MutationcreateDeviceArgs = {
  input: CreateDeviceInput;
};

export type MutationcreateDeviceActuationArgs = {
  input: CreateDeviceActuationInput;
};

export type MutationcreateDeviceTagArgs = {
  name: Scalars['String']['input'];
};

export type MutationcreateDynamicEnumMemberArgs = {
  input: CreateDynamicEnumMemberInput;
};

export type MutationcreateEcommerceImageListArgs = {
  input: CreateEcommerceImageListInput;
};

export type MutationcreateFiNewsNotificationArgs = {
  input: CreateFiNewsNotificationInput;
};

export type MutationcreateImageFromUrlArgs = {
  input: CreateImageFromUrlInput;
};

export type MutationcreateManualSubscriptionArgs = {
  input: CreateManualSubscriptionInput;
};

export type MutationcreateMobileAppBannerArgs = {
  input: CreateMobileAppBannerInput;
};

export type MutationcreateMobileAppBlockerScreenArgs = {
  input: CreateMobileAppBlockerScreenInput;
};

export type MutationcreateMobileAppBottomSheetArgs = {
  input: CreateMobileAppBottomSheetInput;
};

export type MutationcreateMobileAppClientSplashArgs = {
  input: CreateMobileAppClientSplashInput;
};

export type MutationcreateMobileAppDiscoverItemArgs = {
  input: CreateMobileAppDiscoverItemInput;
};

export type MutationcreateMobileAppPermissionBlockerScreenArgs = {
  input: CreateMobileAppPermissionBlockerScreenInput;
};

export type MutationcreateMobileAppSplashScreenArgs = {
  input: CreateMobileAppSplashScreenInput;
};

export type MutationcreateNewHealthGptChatThreadArgs = {
  input: CreateNewHealthGptChatThreadInput;
};

export type MutationcreatePackArgs = {
  input: CreatePackInput;
};

export type MutationcreatePetArgs = {
  input: CreatePetInput;
};

export type MutationcreatePlaceArgs = {
  input: CreatePlaceInput;
};

export type MutationcreateRMAArgs = {
  input: CreateRMAInput;
};

export type MutationcreateResellerOrganizationApiKeyArgs = {
  input: CreateResellerOrganizationApiKeyInput;
};

export type MutationcreateSharingSessionArgs = {
  petId: Scalars['ID']['input'];
  sessionType?: InputMaybe<SharingSessionType>;
};

export type MutationcreateTestimonialReminderArgs = {
  petId: Scalars['ID']['input'];
};

export type MutationcreateTextPostArgs = {
  input: CreateTextPostInput;
};

export type MutationcreateUserArgs = {
  input: CreateUserInput;
};

export type MutationcreateVideoPostArgs = {
  input: CreateVideoPostInput;
};

export type MutationcreateZendeskCancellationTicketArgs = {
  input: CreateZendeskCancellationTicketInput;
};

export type MutationcreateZendeskReplacementTicketArgs = {
  input: CreateZendeskReplacementTicketInput;
};

export type MutationcreateZendeskTroubleshootingTicketArgs = {
  input: CreateZendeskTroubleshootingTicketInput;
};

export type MutationdeleteCommentArgs = {
  commentId: Scalars['ID']['input'];
};

export type MutationdeletePetDocumentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteTextPostArgs = {
  textPostId: Scalars['ID']['input'];
};

export type MutationdeleteVideoPostArgs = {
  videoPostId: Scalars['ID']['input'];
};

export type MutationdisconnectAppIntegrationArgs = {
  app: AppIntegrationId;
};

export type MutationdismissMobileAppContentArgs = {
  id: Scalars['ID']['input'];
  triggerId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationdismissPetInsightsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type MutationdismissPromotionBannerArgs = {
  input: DismissPromotionBannerInput;
};

export type MutationdowngradeSeries2Args = {
  input: DowngradeSeries2Input;
};

export type MutationdowngradeSeries3Args = {
  input: DowngradeSeries3Input;
};

export type MutationenableOrExtendQuickReportModeArgs = {
  moduleId: Scalars['String']['input'];
};

export type MutationenableOrExtendQuickReportModeForPetArgs = {
  petId: Scalars['ID']['input'];
};

export type MutationendSharingSessionArgs = {
  petId: Scalars['ID']['input'];
  sessionType: SharingSessionType;
};

export type MutationexecuteProratedUpgradeArgs = {
  input: ExecuteProductTransferInput;
};

export type MutationexecuteSkuOnlyTransferArgs = {
  input: ExecuteProductTransferInput;
};

export type MutationextendSubscriptionArgs = {
  input: ExtendSubscriptionInput;
};

export type MutationforceRefundRMAArgs = {
  id: Scalars['ID']['input'];
};

export type MutationfreezeStreakArgs = {
  days: Scalars['Int']['input'];
  petId: Scalars['ID']['input'];
};

export type MutationholdOrderArgs = {
  orderId: Scalars['ID']['input'];
};

export type MutationignoreVetSuggestionArgs = {
  householdId: Scalars['ID']['input'];
  vetId: Scalars['ID']['input'];
};

export type MutationinviteUserToHouseholdArgs = {
  input: InviteUserInput;
};

export type MutationjoinDogParkArgs = {
  input: DogParkMembershipInput;
};

export type MutationjoinPackArgs = {
  packId: Scalars['ID']['input'];
  petId: Scalars['ID']['input'];
};

export type MutationleaveDogParkArgs = {
  input: DogParkMembershipInput;
};

export type MutationleavePackArgs = {
  packId: Scalars['ID']['input'];
  petId: Scalars['ID']['input'];
};

export type MutationmarkInvoiceFailedArgs = {
  input: InvoiceMarkFailedInput;
};

export type MutationmoderationApproveContentArgs = {
  input: SocialContentInput;
};

export type MutationmoderationRejectContentArgs = {
  input: SocialContentInput;
};

export type MutationnotifyNearbyUsersForSearchPartyArgs = {
  petId: Scalars['ID']['input'];
};

export type MutationpauseMembershipArgs = {
  input: PauseMembershipInput;
};

export type MutationpurchaseConsumerStoreCartArgs = {
  input: ConsumerStoreCartInput;
};

export type MutationpurchaseMembershipUpgradeArgs = {
  input: UpgradeMembershipInput;
};

export type MutationpurchaseMonthlyUpgradePromotionArgs = {
  input: UpgradeMembershipInput;
};

export type MutationpurchaseRenewAndSaveArgs = {
  input: RenewAndSaveInput;
};

export type MutationpurchaseSeries3UpgradeCartArgs = {
  input: Series3UpgradeCartInput;
};

export type MutationpurchaseSubscriptionArgs = {
  input: PurchaseSubscriptionInput;
};

export type MutationpurchaseUpgradeToSeriesThreePlusModuleArgs = {
  input: UpgradeToSeriesThreePlusModuleInput;
};

export type MutationpurchaseUpgradeToUltraArgs = {
  input: UpgradeToUltraInput;
};

export type MutationreactivateSubscriptionArgs = {
  input: ReactivateSubscriptionInput;
};

export type MutationreassignChipToResellerArgs = {
  input: ReassignChipToResellerInput;
};

export type MutationreassignDeviceArgs = {
  moduleId: Scalars['String']['input'];
  toPetId: Scalars['ID']['input'];
};

export type MutationrecallChipArgs = {
  input: RecallChipInput;
};

export type MutationrecordAppInstallForUserArgs = {
  input: RecordAppInstallForUserInput;
};

export type MutationrefundInvoiceArgs = {
  input: InvoiceRefundInput;
};

export type MutationregisterChipResellerArgs = {
  input: RegisterChipResellerInput;
};

export type MutationregisterChipResellerV2Args = {
  input: RegisterChipResellerInputV2;
};

export type MutationregisterConsignmentPartnerDocumentArgs = {
  documentType: ConsignmentPartnerDocumentType;
  resaleCertBusinessType?: InputMaybe<Scalars['String']['input']>;
  resaleCertExemptionReason?: InputMaybe<ConsignmentExemptionReason>;
  resaleCertExpirationDate?: InputMaybe<Scalars['String']['input']>;
  resaleCertNumber?: InputMaybe<Scalars['String']['input']>;
  resaleCertStateOfIssue?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  uploadedFileKey: Scalars['String']['input'];
};

export type MutationregisterHandsetArgs = {
  input: RegisterHandsetInput;
};

export type MutationregisterHandsetLiveActivityTokenArgs = {
  input: RegisterHandsetLiveActivityTokenInput;
};

export type MutationregisterThirdPartyChipArgs = {
  input: ThirdPartyChipInput;
};

export type MutationreleaseOrderHoldArgs = {
  orderId: Scalars['ID']['input'];
};

export type MutationremoveChipFromPetArgs = {
  input: RemoveChipFromPetInput;
};

export type MutationremoveContainmentZonesForSafeZoneArgs = {
  placeId: Scalars['ID']['input'];
};

export type MutationremoveCouponFromAccountArgs = {
  input: RemoveCouponFromAccountInput;
};

export type MutationremoveDynamicEnumMemberArgs = {
  id: Scalars['ID']['input'];
};

export type MutationremoveFiNewsNotificationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationremoveHouseholdVetsArgs = {
  householdId: Scalars['ID']['input'];
  vetIds: Array<Scalars['ID']['input']>;
};

export type MutationremovePetArgs = {
  subjectId: Scalars['ID']['input'];
};

export type MutationremovePetInstagramHandleArgs = {
  subjectId: Scalars['ID']['input'];
};

export type MutationremovePhotoArgs = {
  photoId: Scalars['ID']['input'];
};

export type MutationremovePlaceArgs = {
  subjectId: Scalars['ID']['input'];
};

export type MutationremoveUserEmailArgs = {
  input: RemoveUserEmailInput;
};

export type MutationremoveUserFromHouseholdArgs = {
  input: RemoveUserFromHouseholdInput;
};

export type MutationremoveWifiCredentialsArgs = {
  input: RemoveWifiCredentialInput;
};

export type MutationrenewSubscriptionArgs = {
  input: RenewSubscriptionInput;
};

export type MutationreorderDynamicEnumMembersArgs = {
  ids: Array<Scalars['ID']['input']>;
  kind: DynamicEnumKind;
};

export type MutationreportChargingBaseAtPositionArgs = {
  baseId: Scalars['String']['input'];
  horizontalAccuracy: Scalars['Float']['input'];
  position: PositionInput;
};

export type MutationrequestEmailVerificationArgs = {
  input: RequestEmailVerificationInput;
};

export type MutationrequestUserAccountDeletionArgs = {
  input: UserAccountDeletionInput;
};

export type MutationrequestVerificationCodeArgs = {
  input: RequestVerificationCodeInput;
};

export type MutationrerouteShipmentsArgs = {
  input: RerouteShipmentsInput;
};

export type MutationrescueArchiveFosterHomeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationrescueCancelPetAdoptionTransferArgs = {
  input: RescueCancelPetAdoptionTransferInput;
};

export type MutationrescueCancelScheduledHandoffArgs = {
  input: RescueCancelScheduledHandoffInput;
};

export type MutationrescueCreateDeviceOrderArgs = {
  input: RescueCreateDeviceOrderInput;
};

export type MutationrescueCreateFosterHomeArgs = {
  input: RescueCreateFosterHomeInput;
};

export type MutationrescueCreateNanoOrderArgs = {
  input: RescueCreateNanoOrderInput;
};

export type MutationrescueCreatePetAdoptionTransferArgs = {
  input: RescueCreatePetAdoptionTransferInput;
};

export type MutationrescueCreatePetFosterTransferArgs = {
  input: RescueCreatePetFosterTransferInput;
};

export type MutationrescueEnableShelterluvArgs = {
  input: RescueEnableShelterluvInput;
};

export type MutationrescueEnrollGwaArgs = {
  input: EnrollGwaInput;
};

export type MutationrescueMarkAdoptionTransferNotRecoveredArgs = {
  input: RescueMarkAdoptionTransferNotRecoveredInput;
};

export type MutationrescueMarkAdoptionTransferRecoveredArgs = {
  input: RescueMarkAdoptionTransferRecoveredInput;
};

export type MutationrescueMarkAdoptionTransferStalledArgs = {
  input: RescueMarkAdoptionTransferStalledInput;
};

export type MutationrescueRecallPetArgs = {
  input: RescueRecallPetInput;
};

export type MutationrescueRecallPetFosterTransferArgs = {
  input: RescueRecallPetFosterTransferInput;
};

export type MutationrescueRequestGwaPostcardsArgs = {
  input: RescueRequestGwaPostcardsInput;
};

export type MutationrescueRescheduleHandoffArgs = {
  input: RescueRescheduleHandoffInput;
};

export type MutationrescueScheduleHandoffArgs = {
  input: RescueScheduleHandoffInput;
};

export type MutationrescueSendSmsArgs = {
  input: RescueSendSmsInput;
};

export type MutationrescueSetShelterluvEmailUpdateOptInArgs = {
  optIn: Scalars['Boolean']['input'];
};

export type MutationrescueSignExemptionAttestationArgs = {
  input: RescueSignExemptionAttestationInput;
};

export type MutationrescueStartImportArgs = {
  input: RescueStartImportInput;
};

export type MutationrescueStreakArgs = {
  petId: Scalars['ID']['input'];
};

export type MutationrescueSubmit501c3DocumentArgs = {
  input: RescueSubmit501c3DocumentInput;
};

export type MutationrescueSubmitExemptionDocumentArgs = {
  input: RescueSubmitExemptionDocumentInput;
};

export type MutationrescueTransferPetPermanentlyArgs = {
  input: RescueTransferPetPermanentlyInput;
};

export type MutationrescueTransferPetTemporarilyArgs = {
  input: RescueTransferPetTemporarilyInput;
};

export type MutationrescueUpdateFosterHomeContactArgs = {
  input: RescueUpdateFosterHomeContactInput;
};

export type MutationrescueUpdateGwaPromoCodeArgs = {
  input: UpdateGwaPromoCodeInput;
};

export type MutationresolveChipTransferArgs = {
  input: ResolveChipTransferInput;
};

export type MutationresolvePetAdoptionTransferArgs = {
  input: ResolvePetAdoptionTransferInput;
};

export type MutationrestrictUserProcessingArgs = {
  reason: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationresumeMembershipArgs = {
  input: ResumeMembershipInput;
};

export type MutationresyncRMAToDclArgs = {
  id: Scalars['ID']['input'];
};

export type MutationretryFailedInvoiceArgs = {
  input: RetryFailedInvoiceInput;
};

export type MutationrevokeResellerOrganizationApiKeyArgs = {
  id: Scalars['ID']['input'];
};

export type MutationrevokeUserInviteArgs = {
  input: RevokeUserInviteInput;
};

export type MutationsaveBillingInfoAndRetryFailedInvoiceArgs = {
  input: SaveBillingInfoAndRetryFailedInvoiceInput;
};

export type MutationsaveBillingInfoFromSetupIntentArgs = {
  setupIntentId: Scalars['String']['input'];
};

export type MutationsendHealthGptChatMessageArgs = {
  input: SendHealthGptChatMessageInput;
};

export type MutationsendHighFivesArgs = {
  input: SendHighFivesInput;
};

export type MutationsetActivityNoteArgs = {
  activityId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type MutationsetArticleLikedArgs = {
  articleId: Scalars['ID']['input'];
  liked: Scalars['Boolean']['input'];
};

export type MutationsetCommentLikedArgs = {
  commentId: Scalars['ID']['input'];
  liked: Scalars['Boolean']['input'];
};

export type MutationsetContainmentEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  moduleId: Scalars['ID']['input'];
};

export type MutationsetContainmentZonesForSafeZoneArgs = {
  input: SetPlaceContainmentInput;
  placeId: Scalars['ID']['input'];
};

export type MutationsetDefaultBillingInfoArgs = {
  billingInfoId: Scalars['String']['input'];
};

export type MutationsetDeviceActuationPatternArgs = {
  moduleId: Scalars['String']['input'];
  pattern: DeviceActuationType;
};

export type MutationsetDeviceActuationSuccessArgs = {
  actuationId: Scalars['Int']['input'];
  moduleId: Scalars['String']['input'];
};

export type MutationsetDeviceDisabledArgs = {
  disabled: Scalars['Boolean']['input'];
  moduleId: Scalars['String']['input'];
};

export type MutationsetDeviceLedArgs = {
  ledColorCode: Scalars['Int']['input'];
  moduleId: Scalars['String']['input'];
};

export type MutationsetDeviceNoteArgs = {
  imei?: InputMaybe<Scalars['String']['input']>;
  moduleId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type MutationsetDevicePetArgs = {
  imei?: InputMaybe<Scalars['String']['input']>;
  moduleId?: InputMaybe<Scalars['String']['input']>;
  petId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationsetDeviceResponseOverrideArgs = {
  deviceResponseOverride: Scalars['JSON']['input'];
  moduleId: Scalars['String']['input'];
  overrideDurationInMinutes: Scalars['Int']['input'];
};

export type MutationsetDeviceUpdateChannelArgs = {
  channelName: Scalars['String']['input'];
  imei?: InputMaybe<Scalars['String']['input']>;
  moduleId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationsetFiNewsNotificationsEnabledArgs = {
  fiNewsNotificationsEnabled: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationsetMarketingEmailsOptedInArgs = {
  marketingEmailsOptedIn: Scalars['Boolean']['input'];
};

export type MutationsetMuteAllSearchPartiesArgs = {
  muteAllSearchParties: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationsetNearbyUserDetectionArgs = {
  enabled: Scalars['Boolean']['input'];
  petId: Scalars['ID']['input'];
};

export type MutationsetNormalModeReportIntervalArgs = {
  moduleId: Scalars['ID']['input'];
  normalModeReportIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationsetPetBlockedArgs = {
  blocked: Scalars['Boolean']['input'];
  petId: Scalars['ID']['input'];
};

export type MutationsetPetDismissedArgs = {
  dismissed: Scalars['Boolean']['input'];
  petId: Scalars['ID']['input'];
};

export type MutationsetPetFollowedArgs = {
  followed: Scalars['Boolean']['input'];
  petId: Scalars['ID']['input'];
};

export type MutationsetPetOperationParamsModeArgs = {
  input: SetPetOperationParamsModeInput;
};

export type MutationsetPetPrimaryPhotoArgs = {
  input: SetPetPrimaryPhotoInput;
};

export type MutationsetPhotoLikedArgs = {
  actingPetId?: InputMaybe<Scalars['ID']['input']>;
  liked: Scalars['Boolean']['input'];
  photoId: Scalars['ID']['input'];
};

export type MutationsetPrimaryUserEmailArgs = {
  input: SetPrimaryUserEmailInput;
};

export type MutationsetSocialBanUserArgs = {
  banned: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationsetSocialOptedOutArgs = {
  householdId: Scalars['ID']['input'];
  socialOptedOut: Scalars['Boolean']['input'];
};

export type MutationsetStepGoalForPetArgs = {
  input: SetStepGoalForPetInput;
};

export type MutationsetSupplementNextShipDateArgs = {
  input: SetNextShipmentDateInput;
};

export type MutationsetSupplementShippingAddressArgs = {
  input: SetShippingAddressInput;
};

export type MutationsetTermsOfServiceAcceptedArgs = {
  input: SetTermsOfServiceAcceptedInput;
};

export type MutationsetTextPostLikedArgs = {
  liked: Scalars['Boolean']['input'];
  textPostId: Scalars['ID']['input'];
};

export type MutationsetUserLocationArgs = {
  input: LocationReportInput;
};

export type MutationsetUserRoleInHouseholdArgs = {
  input: SetUserRoleInHouseholdInput;
};

export type MutationsetVideoPostLikedArgs = {
  liked: Scalars['Boolean']['input'];
  videoPostId: Scalars['ID']['input'];
};

export type MutationsetWalkLikedArgs = {
  liked: Scalars['Boolean']['input'];
  walkId: Scalars['ID']['input'];
};

export type MutationshipOrderLineItemsArgs = {
  input: ShipOrderLineItemsInput;
};

export type MutationshipOrdersArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type MutationskipSupplementShipmentArgs = {
  input: SkipSupplementShipmentInput;
};

export type MutationsnoozePetArgs = {
  petId: Scalars['ID']['input'];
  ttlSeconds: Scalars['Int']['input'];
};

export type MutationsubmitDeviceInfoArgs = {
  deviceInfo: Scalars['JSON']['input'];
  imei?: InputMaybe<Scalars['String']['input']>;
  moduleId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationsubmitHealthGptChatMessageFeedbackArgs = {
  input: SubmitHealthGptChatMessageFeedbackInput;
};

export type MutationsubmitNotificationFeedbackArgs = {
  input: NotificationReportInput;
};

export type MutationsubmitObservedBehaviorArgs = {
  input: SubmitObservedBehaviorInput;
};

export type MutationsubmitRealtimeBehaviorFeedbackArgs = {
  input: SubmitRealtimeBehaviorFeedbackInput;
};

export type MutationsubmitReportsArgs = {
  activityInput?: InputMaybe<Array<ActivityReportInput>>;
  binaryResponse?: InputMaybe<Scalars['Boolean']['input']>;
  locationInput?: InputMaybe<Array<LocationReportInput>>;
  mobilityInput?: InputMaybe<Array<MobilityReportInput>>;
  moduleId: Scalars['String']['input'];
  moduleRequest?: InputMaybe<Scalars['String']['input']>;
};

export type MutationsyncAmazonReturnToRMAArgs = {
  lpn: Scalars['String']['input'];
};

export type MutationsyncOrdersArgs = {
  input: SyncOrdersInput;
};

export type MutationsyncOrdersForUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationunassignChargingBaseArgs = {
  baseId: Scalars['String']['input'];
};

export type MutationunassignDeviceArgs = {
  moduleId: Scalars['String']['input'];
  petId: Scalars['ID']['input'];
};

export type MutationundeletePetArgs = {
  subjectId: Scalars['ID']['input'];
};

export type MutationunfreezeStreakArgs = {
  petId: Scalars['ID']['input'];
};

export type MutationunregisterHandsetArgs = {
  input: RegisterHandsetInput;
};

export type MutationunregisterHandsetLiveActivityTokenArgs = {
  input: UnregisterHandsetLiveActivityTokenInput;
};

export type MutationunrestrictUserProcessingArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationunsnoozePetArgs = {
  petId: Scalars['ID']['input'];
};

export type MutationupdateBillingAccountArgs = {
  input: BillingAccountInput;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
};

export type MutationupdateChargingBaseArgs = {
  baseId: Scalars['String']['input'];
  input: UpdateChargingBaseInput;
};

export type MutationupdateChipConditionArgs = {
  input: UpdateChipConditionInput;
};

export type MutationupdateChipContactInfoArgs = {
  input: UpdateChipContactInfoInput;
};

export type MutationupdateChipResellerInfoArgs = {
  input: UpdateChipResellerInfoInput;
};

export type MutationupdateDeviceOperationParamsArgs = {
  input: UpdateDeviceOperationParamsInput;
  moduleId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationupdateDynamicEnumMemberArgs = {
  input: UpdateDynamicEnumMemberInput;
};

export type MutationupdateEcommerceImageListArgs = {
  input: UpdateEcommerceImageListInput;
};

export type MutationupdateFiNewsNotificationArgs = {
  input: UpdateFiNewsNotificationInput;
};

export type MutationupdateMobileAppBannerArgs = {
  input: UpdateMobileAppBannerInput;
};

export type MutationupdateMobileAppBlockerScreenArgs = {
  input: UpdateMobileAppBlockerScreenInput;
};

export type MutationupdateMobileAppBottomSheetArgs = {
  input: UpdateMobileAppBottomSheetInput;
};

export type MutationupdateMobileAppClientSplashArgs = {
  input: UpdateMobileAppClientSplashInput;
};

export type MutationupdateMobileAppDiscoverItemArgs = {
  input: UpdateMobileAppDiscoverItemInput;
};

export type MutationupdateMobileAppPermissionBlockerScreenArgs = {
  input: UpdateMobileAppPermissionBlockerScreenInput;
};

export type MutationupdateMobileAppSplashScreenArgs = {
  input: UpdateMobileAppSplashScreenInput;
};

export type MutationupdateOrderShippingAddressArgs = {
  input: UpdateOrderShippingAddressInput;
};

export type MutationupdateOrderShippingOptionArgs = {
  input: UpdateOrderShippingOptionInput;
};

export type MutationupdatePetArgs = {
  input: UpdatePetInput;
};

export type MutationupdatePetAlertPreferencesArgs = {
  input: UpdatePetAlertPreferencesInput;
};

export type MutationupdatePetCityStateArgs = {
  input: UpdatePetCityStateInput;
};

export type MutationupdatePetDocumentArgs = {
  input: UpdatePetDocumentInput;
};

export type MutationupdatePhoneNumberArgs = {
  input: UpdatePhoneNumberInput;
};

export type MutationupdatePhoneNumberAndAutoAcceptInvitesArgs = {
  input: UpdatePhoneNumberInput;
};

export type MutationupdatePlaceArgs = {
  input: UpdatePlaceInput;
};

export type MutationupdateResellerContactInfoArgs = {
  input: UpdateResellerContactInfoInput;
};

export type MutationupdateResellerOrganizationApiKeyRateLimitArgs = {
  id: Scalars['ID']['input'];
  rateLimitReqPerMin: Scalars['Int']['input'];
};

export type MutationupdateResellerRescueVerifiedArgs = {
  input: UpdateResellerRescueVerified;
};

export type MutationupdateShipmentShippingAddressArgs = {
  input: UpdateShipmentShippingAddressInput;
};

export type MutationupdateSupplementSubscriptionArgs = {
  input: UpdateSupplementSubscriptionInput;
};

export type MutationupdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationupdateUserCommunicationPreferencesArgs = {
  input: UpdateUserCommunicationPreferencesInput;
};

export type MutationupdateUserLocalePreferencesArgs = {
  input: UpdateUserLocalePreferencesInput;
};

export type MutationupdateUserNameArgs = {
  input: UpdateUserNameInput;
};

export type MutationupdateWifiNetworkArgs = {
  input: UpdateWifiNetworkInput;
};

export type MutationupgradeDeviceArgs = {
  currentModuleId: Scalars['String']['input'];
  petId: Scalars['ID']['input'];
  upgradeModuleId: Scalars['String']['input'];
};

export type MutationuploadContactsArgs = {
  uploadContactInputs: UploadContactInput;
};

export type MutationuserFeedbackActivityPlayFeedbackSubmitArgs = {
  input: UserFeedbackActivityPlayFeedbackSubmitInput;
};

export type MutationuserFeedbackActivityRestFeedbackSubmitArgs = {
  input: UserFeedbackActivityRestFeedbackSubmitInput;
};

export type MutationuserFeedbackActivityTravelFeedbackSubmitArgs = {
  input: UserFeedbackActivityTravelFeedbackSubmitInput;
};

export type MutationuserFeedbackActivityWalkFeedbackSubmitArgs = {
  input: UserFeedbackActivityWalkFeedbackSubmitInput;
};

export type MutationuserFeedbackEscapeAlertFeedbackSubmitArgs = {
  input: UserFeedbackEscapeAlertFeedbackSubmitInput;
};

export type MutationuserFeedbackLostDogFeedbackSubmitArgs = {
  input: UserFeedbackLostDogFeedbackSubmitInput;
};

export type MutationuserFeedbackLostDogModeDidHelpArgs = {
  input: UserFeedbackLostDogModeDidHelpInput;
};

export type MutationwalkSegmentsGeoJSONZipArgs = {
  input: WalkSegmentsGeoJSONZipInput;
};

export type NanoBatchSummary = {
  __typename?: 'NanoBatchSummary';
  batchId: Scalars['String']['output'];
  claimedAt: Scalars['DateTime']['output'];
  claimedBy: Scalars['String']['output'];
  idCount: Scalars['String']['output'];
};

export type NanoIcarIdRange = {
  __typename?: 'NanoIcarIdRange';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  endIcarId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  startIcarId: Scalars['String']['output'];
};

export type NanoWebId = {
  __typename?: 'NanoWebId';
  batchId?: Maybe<Scalars['String']['output']>;
  claimed: Scalars['Boolean']['output'];
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  claimedBy?: Maybe<Scalars['String']['output']>;
  webId: Scalars['String']['output'];
};

export type NanoWebIdBatchInfo = {
  __typename?: 'NanoWebIdBatchInfo';
  batchId: Scalars['String']['output'];
  claimedAt: Scalars['DateTime']['output'];
  claimedBy: Scalars['String']['output'];
  icarIdCount: Scalars['String']['output'];
  idCount: Scalars['String']['output'];
};

export enum NanoWebIdClaimJobState {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  QUEUED = 'QUEUED',
}

export type NanoWebIdClaimJobStatus = {
  __typename?: 'NanoWebIdClaimJobStatus';
  batchId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
  progress?: Maybe<Scalars['Int']['output']>;
  state: NanoWebIdClaimJobState;
  total?: Maybe<Scalars['Int']['output']>;
};

export type NearbyDogPark = {
  __typename?: 'NearbyDogPark';
  /**
   * Text describing distance to dog park.
   * e.g. "2.5 miles away"
   */
  distanceText: Scalars['String']['output'];
  dogPark: DogPark;
};

export type NearbyDogParkFeed = {
  __typename?: 'NearbyDogParkFeed';
  count: Scalars['Int']['output'];
  nearbyDogParks: Array<NearbyDogPark>;
};

export type NearbyPetItem = {
  __typename?: 'NearbyPetItem';
  approximateDistance: ApproximateDistance;
  pet: StrangerPet;
};

export type NearbyPetsFeed = {
  __typename?: 'NearbyPetsFeed';
  items: Array<NearbyPetItem>;
  totalCount: Scalars['Int']['output'];
};

export type NearbyUsersResult = {
  __typename?: 'NearbyUsersResult';
  /** Convenience flag indicating if there are any nearby users (userCount > 0). */
  hasUsers: Scalars['Boolean']['output'];
  /**
   * Number of nearby users who could be notified about the search party.
   * This count filters by mute preferences and excludes pet owners, but is BEFORE feature flag filtering.
   */
  userCount: Scalars['Int']['output'];
  /** Number of nearby users after feature flag filtering. */
  userCountAfterFeatureFlag: Scalars['Int']['output'];
  /** User IDs before feature flag filtering (after mute preferences and pet owner exclusion). */
  userIds: Array<Scalars['Int']['output']>;
  /** User IDs after feature flag filtering. */
  userIdsAfterFeatureFlag: Array<Scalars['Int']['output']>;
};

/**
 * Represents a state where the current state can't be fully determined due to a lack of reports
 * resulting from the pet either needing a collar or a lack of reports for that pet/collar
 */
export type NeedsReportsState = PetCollarState & {
  __typename?: 'NeedsReportsState';
  /** Whether the pet has a collar assigned */
  needsCollar: Scalars['Boolean']['output'];
  /** Whether the pet has any reports associated with its collar */
  needsReports: Scalars['Boolean']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export enum NeighborCellsScanType {
  COMBINED = 'COMBINED',
  NONE = 'NONE',
  PLMN_INFO = 'PLMN_INFO',
  RX_MEAS = 'RX_MEAS',
}

export type NextSupplementShipmentDetails = {
  __typename?: 'NextSupplementShipmentDetails';
  deliveryExpected?: Maybe<Scalars['DateTime']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  trackingLink?: Maybe<Scalars['String']['output']>;
};

export type NoLTEConnectivityDeviceInfo = {
  __typename?: 'NoLTEConnectivityDeviceInfo';
  modemNoRegistrationCount: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
  uptime: Scalars['Int']['output'];
};

export type NormalModeReportIntervalOption = {
  __typename?: 'NormalModeReportIntervalOption';
  /** 0 = Live (constant tracking); otherwise a fixed report interval in seconds. */
  intervalSeconds: Scalars['Int']['output'];
  /** Display label, e.g. "Live tracking", "30 minutes", "8 hours". */
  name: Scalars['String']['output'];
};

export enum NotificationChannel {
  PUSH = 'PUSH',
  SMS = 'SMS',
}

export type NotificationCountByType = {
  __typename?: 'NotificationCountByType';
  /** Sent (push + SMS) in the window; suppressed sends are counted separately. */
  logDocumentCount: Scalars['Int']['output'];
  notificationType: Scalars['String']['output'];
  suppressedCount: Scalars['Int']['output'];
  userSettingType?: Maybe<Scalars['String']['output']>;
};

export type NotificationDailyCount = {
  __typename?: 'NotificationDailyCount';
  /** UTC calendar day, YYYY-MM-DD. */
  date: Scalars['String']['output'];
  sent: Scalars['Int']['output'];
  suppressed: Scalars['Int']['output'];
};

export type NotificationFeed = {
  __typename?: 'NotificationFeed';
  feedItems: Array<NotificationFeedItem>;
  pageInfo: PageInfo;
  unreadCount: Scalars['Int']['output'];
};

export type NotificationFeedunreadCountArgs = {
  since?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationFeedArticleItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedArticleItem';
  article: Article;
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type NotificationFeedDogParkVisitItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedDogParkVisitItem';
  /** Which dog park was visited */
  dogPark: DogPark;
  id: Scalars['ID']['output'];
  /** The pet that visited the dog park */
  pet: StrangerPet;
  timestamp: Scalars['DateTime']['output'];
};

export type NotificationFeedFiNewsItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedFiNewsItem';
  fiNewsNotification: FiNewsNotification;
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type NotificationFeedFollowedPetPhotoAddedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedFollowedPetPhotoAddedItem';
  followedPet: StrangerPet;
  id: Scalars['ID']['output'];
  photo: Photo;
  timestamp: Scalars['DateTime']['output'];
};

export type NotificationFeedHighFivesReceivedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedHighFivesReceivedItem';
  /** High fives sent that day, summed across every bout. */
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** The pet who was high fived */
  pet: Pet;
  /** The pet who sent them */
  sendingPet: StrangerPet;
  /** The newest bout in the line. Bumps as more high fives arrive the same day. */
  timestamp: Scalars['DateTime']['output'];
};

export type NotificationFeedItem = {
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type NotificationFeedNearbyPetJoinedFiItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedNearbyPetJoinedFiItem';
  id: Scalars['ID']['output'];
  /** Where the new pet is located. */
  locationText: Scalars['String']['output'];
  /** The pet that just joined Fi. */
  pet: StrangerPet;
  timestamp: Scalars['DateTime']['output'];
};

export type NotificationFeedPetFollowedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedPetFollowedItem';
  followedPet: Pet;
  followingPet: StrangerPet;
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type NotificationFeedPhotoCommentItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedPhotoCommentItem';
  comment: Comment;
  /** The pet who commented */
  commentingPet: StrangerPet;
  id: Scalars['ID']['output'];
  /** The pet whose photo was commented on */
  pet: Pet;
  photo: Photo;
  timestamp: Scalars['DateTime']['output'];
};

export type NotificationFeedPhotoCommentLikedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedPhotoCommentLikedItem';
  comment: Comment;
  id: Scalars['ID']['output'];
  /** The pet who liked the comment */
  likingPet: StrangerPet;
  /** The pet whose post was commented on */
  pet: Pet;
  photo: Photo;
  timestamp: Scalars['DateTime']['output'];
};

export type NotificationFeedPhotoLikedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedPhotoLikedItem';
  id: Scalars['ID']['output'];
  /** The pet who is liking the photo */
  likingPet: StrangerPet;
  numPhotosLiked: Scalars['Int']['output'];
  /** The pet whose photo is being liked */
  pet: Pet;
  photo: Photo;
  timestamp: Scalars['DateTime']['output'];
};

export type NotificationFeedTextPostCommentItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedTextPostCommentItem';
  comment: Comment;
  /** The pet who commented */
  commentingPet: StrangerPet;
  id: Scalars['ID']['output'];
  /** The pet whose photo was commented on */
  pet: StrangerPet;
  textPost: TextPost;
  timestamp: Scalars['DateTime']['output'];
};

export type NotificationFeedTextPostCommentLikedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedTextPostCommentLikedItem';
  comment: Comment;
  id: Scalars['ID']['output'];
  /** The pet who liked the comment */
  likingPet: StrangerPet;
  /** The pet whose post was commented on */
  pet: Pet;
  textPost: TextPost;
  timestamp: Scalars['DateTime']['output'];
};

export type NotificationFeedTextPostLikedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedTextPostLikedItem';
  id: Scalars['ID']['output'];
  /** The pet who is liking the post */
  likingPet: StrangerPet;
  numPostsLiked: Scalars['Int']['output'];
  /** The pet whose post is being liked */
  pet: Pet;
  textPost: TextPost;
  timestamp: Scalars['DateTime']['output'];
};

export type NotificationFeedVideoPostCommentItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedVideoPostCommentItem';
  comment: Comment;
  /** The pet who commented */
  commentingPet: StrangerPet;
  id: Scalars['ID']['output'];
  /** The pet whose photo was commented on */
  pet: StrangerPet;
  timestamp: Scalars['DateTime']['output'];
  videoPost: VideoPost;
};

export type NotificationFeedVideoPostCommentLikedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedVideoPostCommentLikedItem';
  comment: Comment;
  id: Scalars['ID']['output'];
  /** The pet who liked the comment */
  likingPet: StrangerPet;
  /** The pet whose post was commented on */
  pet: Pet;
  timestamp: Scalars['DateTime']['output'];
  videoPost: VideoPost;
};

export type NotificationFeedVideoPostLikedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedVideoPostLikedItem';
  id: Scalars['ID']['output'];
  /** The pet who is liking the post */
  likingPet: StrangerPet;
  numPostsLiked: Scalars['Int']['output'];
  /** The pet whose post is being liked */
  pet: Pet;
  timestamp: Scalars['DateTime']['output'];
  videoPost: VideoPost;
};

/** DEPRECATED */
export type NotificationFeedWalkClappedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedWalkClappedItem';
  /** The pet who gave the clap */
  clappingPet: StrangerPet;
  id: Scalars['ID']['output'];
  /** The pet whose walk got a clap */
  pet: Pet;
  timestamp: Scalars['DateTime']['output'];
  walk: StrangerWalk;
};

export type NotificationFeedWalkLikedItem = NotificationFeedItem & {
  __typename?: 'NotificationFeedWalkLikedItem';
  id: Scalars['ID']['output'];
  /** The pet who gave the like */
  likingPet: StrangerPet;
  /** The pet whose walk got a like */
  pet: Pet;
  timestamp: Scalars['DateTime']['output'];
  walk: StrangerWalk;
};

export type NotificationLog = SentPushNotificationLog | SentSMSNotificationLog | SuppressedNotificationLog;

export type NotificationLogDocument = {
  __typename?: 'NotificationLogDocument';
  channel: Scalars['String']['output'];
  msg: Scalars['String']['output'];
  notificationCategory?: Maybe<Scalars['String']['output']>;
  notificationMessage: Scalars['String']['output'];
  notificationType: Scalars['String']['output'];
  petId?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  shouldShowBadge?: Maybe<Scalars['Boolean']['output']>;
  timestamp: Scalars['DateTime']['output'];
  twilio?: Maybe<Scalars['Boolean']['output']>;
  userId: Scalars['Int']['output'];
};

export type NotificationLogsForUserInput = {
  dateRange: DateRangeInput;
  includeSuppressed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notificationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  petIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId: Scalars['Int']['input'];
};

export type NotificationLogsForUserResult = {
  __typename?: 'NotificationLogsForUserResult';
  logs: Array<NotificationLog>;
};

export type NotificationQuietHours = {
  __typename?: 'NotificationQuietHours';
  days: NotificationQuietHoursDays;
  endHour: Scalars['Int']['output'];
  startHour: Scalars['Int']['output'];
};

export enum NotificationQuietHoursDays {
  WEEKDAY = 'WEEKDAY',
  WEEKEND = 'WEEKEND',
}

export type NotificationReportInput = {
  feedback: Scalars['String']['input'];
  notificationId: Scalars['ID']['input'];
  petId?: InputMaybe<Scalars['ID']['input']>;
};

export type NotificationSuppressionCount = {
  __typename?: 'NotificationSuppressionCount';
  count: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

export type NotificationSuppressionDetails = {
  __typename?: 'NotificationSuppressionDetails';
  allowedSpecies: Array<Species>;
  quietHours: Array<NotificationQuietHours>;
  rateLimitMinutes?: Maybe<Scalars['Int']['output']>;
  sendsDuringHouseholdLostDogMode: Scalars['Boolean']['output'];
  sendsDuringLostDogMode: Scalars['Boolean']['output'];
  sendsDuringRest: Scalars['Boolean']['output'];
  sendsDuringSnooze: Scalars['Boolean']['output'];
  sendsDuringWalkOrTravel: Scalars['Boolean']['output'];
  suppressedModels: Array<Scalars['String']['output']>;
};

/**
 * Daily volume and suppression breakdown for a notification type and its runtime aliases (a class
 * such as `DeadBatteryNotification` logs as `dead_battery_d1`, `dead_battery_d2`, ...). Fetched for
 * one type at a time rather than for all of them at once — see `notificationTypeActivity`.
 */
export type NotificationTypeActivity = {
  __typename?: 'NotificationTypeActivity';
  /** One entry per UTC day in the window, oldest first, including days with no activity. */
  dailyCounts: Array<NotificationDailyCount>;
  notificationTypes: Array<Scalars['String']['output']>;
  suppressionsByReason: Array<NotificationSuppressionCount>;
};

/**
 * Why a notification is sent, and the rules that decide whether it survives to delivery.
 * `description` is hand-written prose; every other field is derived from the notification class.
 */
export type NotificationTypeDetails = {
  __typename?: 'NotificationTypeDetails';
  description?: Maybe<Scalars['String']['output']>;
  notificationType: Scalars['String']['output'];
  sendsSms: Scalars['Boolean']['output'];
  showsAppBadge: Scalars['Boolean']['output'];
  suppression?: Maybe<NotificationSuppressionDetails>;
  timeSensitive: Scalars['Boolean']['output'];
  userSettingType?: Maybe<Scalars['String']['output']>;
};

export type NotifyNearbyUsersResult = {
  __typename?: 'NotifyNearbyUsersResult';
  /** Error message if the operation failed, null otherwise. */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * Estimated number of notifications that will be sent.
   * This is an estimate based on user IDs before processing.
   * The actual count may differ due to notification failures or filtering.
   */
  notificationsSent: Scalars['Int']['output'];
  /** Whether the operation was successful. */
  success: Scalars['Boolean']['output'];
};

export type NumberFeatureFlag = FeatureFlag & {
  __typename?: 'NumberFeatureFlag';
  accessedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dynamicSettingName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  numberValue: Scalars['Float']['output'];
  rollout?: Maybe<NumberFeatureFlagRollout>;
  updatedAt: Scalars['DateTime']['output'];
};

export type NumberFeatureFlagRollout = {
  __typename?: 'NumberFeatureFlagRollout';
  percentage: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export type OAuthSetupDetails = {
  __typename?: 'OAuthSetupDetails';
  authorizeUrl: Scalars['String']['output'];
  clientId: Scalars['Int']['output'];
  redirectUrl: Scalars['String']['output'];
  scope: Scalars['String']['output'];
};

export type ObfuscatedCardInfo = {
  __typename?: 'ObfuscatedCardInfo';
  lastFour: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export enum ObfuscatedReason {
  HAS_ACCESS = 'HAS_ACCESS',
  NO_ACCESS = 'NO_ACCESS',
  NO_SUBSCRIPTION = 'NO_SUBSCRIPTION',
}

export type OffgridToken = {
  __typename?: 'OffgridToken';
  expires: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
};

export enum OfflineCollarDuration {
  /** Offline for > 30 minutes. */
  LONG = 'LONG',
  /** Offline for <= 30 minutes. */
  SHORT = 'SHORT',
}

/** Encapsulates any state associated with the collar being offline */
export type OfflineCollarStatus = {
  __typename?: 'OfflineCollarStatus';
  /** Indication of how long the collar has been offline. */
  offlineDuration: OfflineCollarDuration;
  /** Whether the system believes the collar is offline due to being out of power */
  outOfBattery: Scalars['Boolean']['output'];
};

/**
 * An onboarding session is a period of time during which a user is using the app to activate a device. This is for
 * retrieving handset logs for a specific period of time during an onboarding session.
 */
export type OnboardingSession = {
  __typename?: 'OnboardingSession';
  endDate: Scalars['DateTime']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type OngoingActivity = {
  address?: Maybe<Scalars['String']['output']>;
  areaName?: Maybe<Scalars['String']['output']>;
  atDogPark?: Maybe<DogPark>;
  cityState?: Maybe<Scalars['String']['output']>;
  debugMetadata: Scalars['JSON']['output'];
  lastReportTimestamp: Scalars['DateTime']['output'];
  neighborhood?: Maybe<Scalars['String']['output']>;
  obfuscated: Scalars['Boolean']['output'];
  obfuscatedReason: ObfuscatedReason;
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']['output']>;
  shouldShowDuration?: Maybe<Scalars['Boolean']['output']>;
  start: Scalars['DateTime']['output'];
  totalSteps: Scalars['Int']['output'];
  uncertaintyInfo?: Maybe<UncertaintyInfo>;
};

export type OngoingRest = OngoingActivity & {
  __typename?: 'OngoingRest';
  actualSegmentTypeForDebug: Scalars['String']['output'];
  address?: Maybe<Scalars['String']['output']>;
  allPositionsForDebug?: Maybe<Array<Position>>;
  areaName?: Maybe<Scalars['String']['output']>;
  atDogPark?: Maybe<DogPark>;
  cityState?: Maybe<Scalars['String']['output']>;
  debugMetadata: Scalars['JSON']['output'];
  lastReportTimestamp: Scalars['DateTime']['output'];
  location: Location;
  neighborhood?: Maybe<Scalars['String']['output']>;
  obfuscated: Scalars['Boolean']['output'];
  obfuscatedReason: ObfuscatedReason;
  place?: Maybe<Place>;
  /** @deprecated Use location instead */
  position: Position;
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']['output']>;
  shouldShowDuration?: Maybe<Scalars['Boolean']['output']>;
  start: Scalars['DateTime']['output'];
  totalSteps: Scalars['Int']['output'];
  uncertaintyInfo?: Maybe<UncertaintyInfo>;
};

export type OngoingWalk = OngoingActivity & {
  __typename?: 'OngoingWalk';
  address?: Maybe<Scalars['String']['output']>;
  areaName?: Maybe<Scalars['String']['output']>;
  atDogPark?: Maybe<DogPark>;
  cityState?: Maybe<Scalars['String']['output']>;
  debugMetadata: Scalars['JSON']['output'];
  distance: Scalars['Float']['output'];
  /**
   * True when this walk's step count is unreliable — typically because the walk was captured solely
   * by a device that doesn't track steps (e.g. an Ultra) while the step-tracking device was elsewhere.
   * Mobile should suppress the step display when true.
   */
  excludeStepCount: Scalars['Boolean']['output'];
  lastReportTimestamp: Scalars['DateTime']['output'];
  neighborhood?: Maybe<Scalars['String']['output']>;
  obfuscated: Scalars['Boolean']['output'];
  obfuscatedReason: ObfuscatedReason;
  path: Array<Position>;
  positions: Array<Location>;
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']['output']>;
  shouldShowDuration?: Maybe<Scalars['Boolean']['output']>;
  start: Scalars['DateTime']['output'];
  totalSteps: Scalars['Int']['output'];
  uncertaintyInfo?: Maybe<UncertaintyInfo>;
};

/** Encapsulates any state associated with the collar being online */
export type OnlineCollarStatus = {
  __typename?: 'OnlineCollarStatus';
  state: OnlineConnectionState;
};

export type OnlineConnectionState = ConnectedToBase | ConnectedToCellular | ConnectedToUser | ConnectedToWifi;

export type OperationParams = {
  __typename?: 'OperationParams';
  /**
   * Whether the Ultra collar applies containment feedback. Absent leaves the current setting alone;
   * false is meaningful and persists (containment off), it is not the same as unset.
   */
  containmentEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Not used */
  gnssLongTimeout?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Not used */
  gnssMaxAcceptableRadiusM?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Not used */
  gnssMinAcceptableSatellites?: Maybe<Scalars['Int']['output']>;
  /**
   * Unused, delete once clients stop asking for them.
   * @deprecated Not used
   */
  gnssShortTimeout?: Maybe<Scalars['Int']['output']>;
  ledEnabled?: Maybe<Scalars['Boolean']['output']>;
  ledOffAt?: Maybe<Scalars['DateTime']['output']>;
  lpppIntervalS?: Maybe<Scalars['Int']['output']>;
  maxAllowableReportDelayBleS?: Maybe<Scalars['Int']['output']>;
  maxAllowableReportDelayWifiS?: Maybe<Scalars['Int']['output']>;
  mode?: Maybe<OperationParamsMode>;
  neighborCellsScanType?: Maybe<NeighborCellsScanType>;
  /**
   * User-selected report cadence applied while the device is in `normal` mode.
   *   null → "smart" mode (server-computed cadence)
   *   0    → constant tracking ("Live": 10s reports, 1s breadcrumbs, liveTracking=true)
   *   60..480 → fixed cadence in seconds (1..8 minutes)
   */
  normalModeReportIntervalSeconds?: Maybe<Scalars['Int']['output']>;
  /**
   * The PLMN (MCCMNC format, e.g. "310830") the device is forced to camp on. Only set when plmnProfile
   * is a single allowed PLMN; null for any other profile.
   * @deprecated Use plmnProfile
   */
  plmnOverride?: Maybe<Scalars['String']['output']>;
  /**
   * PLMNs the device is told to camp on (ALLOWED) or avoid (DISALLOWED) via BasicResponse.plmn_profile.
   * Persists until cleared.
   */
  plmnProfile?: Maybe<PlmnProfile>;
  reboot?: Maybe<Scalars['Boolean']['output']>;
  remoteLogLevel?: Maybe<RemoteLogLevel>;
  requestLppp?: Maybe<Scalars['Boolean']['output']>;
  requestNeighborCellsScan?: Maybe<Scalars['Boolean']['output']>;
  switchEuiccProfile?: Maybe<Scalars['String']['output']>;
  /**
   * If true, the device's LTE modem is locked to band 25 for TSAT testing. Persists until cleared.
   * Applying or clearing the lock restarts the modem.
   */
  tsatBandLock?: Maybe<Scalars['Boolean']['output']>;
  updateFrequency?: Maybe<Scalars['Int']['output']>;
  updateFrequencyNoActivity?: Maybe<Scalars['Int']['output']>;
  wifiDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum OperationParamsMode {
  DORMANT = 'DORMANT',
  EAGER = 'EAGER',
  LOST_DOG = 'LOST_DOG',
  NORMAL = 'NORMAL',
  POST_ESCAPE_NOTIFICATION = 'POST_ESCAPE_NOTIFICATION',
}

export type Order = {
  __typename?: 'Order';
  bigCommerceOrderId?: Maybe<Scalars['String']['output']>;
  billingInfo?: Maybe<BillingInfo>;
  canBeCanceled: Scalars['Boolean']['output'];
  canBeHeld: Scalars['Boolean']['output'];
  canBeReleasedFromHold: Scalars['Boolean']['output'];
  channel?: Maybe<Scalars['String']['output']>;
  consignmentRecurlyInvoiceId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerOrderNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inPersonEvent?: Maybe<InPersonEvent>;
  internalOrderCreatorEmail?: Maybe<Scalars['String']['output']>;
  internalOrderNotes?: Maybe<Scalars['String']['output']>;
  internalOrderPartnerName?: Maybe<Scalars['String']['output']>;
  internalOrderSubscriptionOverrideMonths?: Maybe<Scalars['Int']['output']>;
  lineItems: Array<OrderLineItem>;
  orderDate: Scalars['DateTime']['output'];
  orderSource: OrderSource;
  orderSourceId: Scalars['String']['output'];
  poNumber?: Maybe<Scalars['String']['output']>;
  shipments: Array<OrderShipment>;
  shippingAddress: ShippingAddress;
  shippingOption: ShippingOption;
  status: OrderStatus;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<StrangerUser>;
};

export enum OrderChannel {
  AMBASSADOR = 'AMBASSADOR',
  CONSIGNMENT_RETAIL = 'CONSIGNMENT_RETAIL',
  COSTCO_ROADSHOW = 'COSTCO_ROADSHOW',
  EMPLOYEE_GIFT = 'EMPLOYEE_GIFT',
  INVENTORY_TO_OFFICE = 'INVENTORY_TO_OFFICE',
  MARKETING_EVENT = 'MARKETING_EVENT',
  OTHER = 'OTHER',
  POLICE_DEPARTMENT = 'POLICE_DEPARTMENT',
  RESCUE = 'RESCUE',
  USER_RESEARCH_INCENTIVE = 'USER_RESEARCH_INCENTIVE',
  VERIZON = 'VERIZON',
  WHOLESALE = 'WHOLESALE',
}

export type OrderHistoryLineItem = {
  __typename?: 'OrderHistoryLineItem';
  description: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  serialNumber?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
};

export type OrderHistoryPackage = {
  __typename?: 'OrderHistoryPackage';
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryStatus?: Maybe<Scalars['String']['output']>;
  estimatedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  shippingCarrierCode: Scalars['String']['output'];
  trackingNumber: Scalars['String']['output'];
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type OrderHistoryResult = {
  __typename?: 'OrderHistoryResult';
  invoiceNumber: Scalars['String']['output'];
  lineItems: Array<OrderHistoryLineItem>;
  orderDate: Scalars['DateTime']['output'];
  packages: Array<OrderHistoryPackage>;
  shippingAddress: ShippingAddress;
  shippingOption: ShippingOption;
  status: OrderHistoryStatus;
};

export enum OrderHistoryStatus {
  AWAITING_SHIPMENT = 'AWAITING_SHIPMENT',
  BACKORDERED = 'BACKORDERED',
  CANCELED = 'CANCELED',
  DELIVERED = 'DELIVERED',
  SHIPPED = 'SHIPPED',
}

export type OrderLineItem = {
  __typename?: 'OrderLineItem';
  createdAt: Scalars['DateTime']['output'];
  /** Whether this hardware-first collar was marked as a gift at checkout. False on every other line item. */
  hardwareFirstGift: Scalars['Boolean']['output'];
  /** Whether the hardware-first stamp on this line item is still armed. False on every non-hardware-first line item. */
  hardwareFirstMembershipPending: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** True when a hardware-first collar was marked as a gift at checkout; null on every other line item. */
  isGift?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Id of the Order that contains this line item. When a shipment consolidates items from
   * multiple orders, comparing this against the page's current order id reveals which line
   * items came from a different order.
   */
  orderId: Scalars['ID']['output'];
  orderSourceLineNumber?: Maybe<Scalars['String']['output']>;
  productDescription?: Maybe<Scalars['String']['output']>;
  /**
   * Short, list-friendly product name without variant detail (color, size, subscription cadence).
   * Use `productDescription` for full detail.
   */
  productName?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  status: OrderLineItemStatus;
  /** True when an ultra was bought as an attachment to an existing membership, false when standalone; null on every other line item. */
  ultraAttachment?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum OrderLineItemStatus {
  BACKORDERED = 'BACKORDERED',
  CANCELED = 'CANCELED',
  PENDING = 'PENDING',
  RELEASED = 'RELEASED',
}

export type OrderShipment = {
  __typename?: 'OrderShipment';
  createdAt: Scalars['DateTime']['output'];
  fulfillmentProviderOrderNumber: Scalars['String']['output'];
  fulfillmentWarehouse: FulfillmentWarehouse;
  id: Scalars['ID']['output'];
  lineItems: Array<OrderShipmentLineItem>;
  packages: Array<OrderShipmentPackage>;
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  shippingAddress: ShippingAddress;
  shippingOption: ShippingOption;
  status: OrderShipmentStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type OrderShipmentLineItem = {
  __typename?: 'OrderShipmentLineItem';
  allSerialsReturned: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  orderLineItem?: Maybe<OrderLineItem>;
  productDescription?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  serialNumbers: Array<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  status: OrderShipmentLineItemStatus;
};

export enum OrderShipmentLineItemStatus {
  AWAITING_SHIPMENT = 'AWAITING_SHIPMENT',
  CANCELED = 'CANCELED',
  SHIPPED = 'SHIPPED',
}

export type OrderShipmentPackage = {
  __typename?: 'OrderShipmentPackage';
  deliveredAt?: Maybe<Scalars['String']['output']>;
  deliveryStatus?: Maybe<Scalars['String']['output']>;
  shippingCarrier?: Maybe<Scalars['String']['output']>;
  shippingMethod?: Maybe<Scalars['String']['output']>;
  trackingNumber: Scalars['String']['output'];
};

export enum OrderShipmentStatus {
  AWAITING_RELEASE = 'AWAITING_RELEASE',
  AWAITING_SHIPMENT = 'AWAITING_SHIPMENT',
  CANCELED = 'CANCELED',
  DELIVERED = 'DELIVERED',
  PENDING = 'PENDING',
  RELEASED = 'RELEASED',
  SHIPPED = 'SHIPPED',
}

export type OrderShippingAddressInput = {
  city: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zipcode: Scalars['String']['input'];
};

export enum OrderSource {
  AMAZON = 'AMAZON',
  AMBASSADOR = 'AMBASSADOR',
  CHEWY = 'CHEWY',
  CHEWY_WHOLESALE = 'CHEWY_WHOLESALE',
  COSTCO = 'COSTCO',
  COSTCO_ROADSHOW = 'COSTCO_ROADSHOW',
  FLIP = 'FLIP',
  HSN = 'HSN',
  INTERNAL = 'INTERNAL',
  MANUAL = 'MANUAL',
  PETSMART = 'PETSMART',
  PETWATCH = 'PETWATCH',
  PET_RESORTS = 'PET_RESORTS',
  RACHIO = 'RACHIO',
  RECURLY = 'RECURLY',
  RESCUE = 'RESCUE',
  RETAIL = 'RETAIL',
  STUNTPUPPY = 'STUNTPUPPY',
}

export enum OrderStatus {
  BACKORDERED = 'BACKORDERED',
  CANCELED = 'CANCELED',
  COMPLETE = 'COMPLETE',
  ON_HOLD = 'ON_HOLD',
  PARTIALLY_RELEASED = 'PARTIALLY_RELEASED',
  PENDING = 'PENDING',
  RELEASED = 'RELEASED',
  REPLACED = 'REPLACED',
}

export type OrdersQueryInput = {
  customerOrderNumber?: InputMaybe<Scalars['String']['input']>;
  endOrderDate?: InputMaybe<Scalars['DateTime']['input']>;
  inPersonEventUuid?: InputMaybe<Scalars['String']['input']>;
  orderSources?: InputMaybe<Array<OrderSource>>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  search?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  shipmentStatuses?: InputMaybe<Array<OrderShipmentStatus>>;
  shippingCountries?: InputMaybe<Array<FiCountry>>;
  skus?: InputMaybe<Array<Scalars['String']['input']>>;
  startOrderDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OvernightRestSummary = {
  date: Scalars['DateTime']['output'];
};

export enum POIType {
  BAR = 'BAR',
  BEACH = 'BEACH',
  BOARDING = 'BOARDING',
  DOG_CLUB = 'DOG_CLUB',
  DOG_PARK = 'DOG_PARK',
  NATURE_RESERVE = 'NATURE_RESERVE',
  OTHER = 'OTHER',
  PARK = 'PARK',
}

export type Pack = BasePack & {
  __typename?: 'Pack';
  actingPetCanJoin: Scalars['Boolean']['output'];
  actingPetCanLeave: Scalars['Boolean']['output'];
  actingPetCannotJoinReason?: Maybe<Scalars['String']['output']>;
  actingPetDidManuallyJoin: Scalars['Boolean']['output'];
  actingPetIsMember: Scalars['Boolean']['output'];
  actingPetMembershipReason: Scalars['String']['output'];
  ageFiltersWithEnoughRankedPets: Array<PackAgeFilter>;
  avatar: PackAvatar;
  category: PackCategory;
  dbId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Packs Phase 1 made fiHandle nullable */
  fiHandle: Scalars['String']['output'];
  /**
   * A 6-digit hex color code, including # sign, and letters lowercase (eg.
   * `#ff00b1`) used to highlight this pack in the app.
   */
  highlightColorHex?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use category instead */
  isAllFiDogsPack: Scalars['Boolean']['output'];
  /** @deprecated Use category instead */
  isLocationPack: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  joinPackUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use packMemberFeed instead */
  members: StrangerPetFeed;
  name: Scalars['String']['output'];
  /** @deprecated Use packMemberFeed instead */
  pendingMembers: StrangerPetFeed;
  petRanking: PackRanking;
  photo?: Maybe<Photo>;
  /** @deprecated Use totalRankedSteps instead */
  totalMonthlySteps: Scalars['Int']['output'];
  totalRankedPets: Scalars['Int']['output'];
  /**
   * A 64-bit integer representing the total steps for all pets in this pack for
   * the latest ranking period returned as a String.
   */
  totalRankedSteps: Scalars['String']['output'];
};

export type PackpetRankingArgs = {
  packAgeFilter?: InputMaybe<PackAgeFilter>;
  petId: Scalars['ID']['input'];
};

export enum PackAgeFilter {
  ADULT = 'ADULT',
  ALL = 'ALL',
  PUPPY = 'PUPPY',
  SENIOR = 'SENIOR',
}

export type PackAvatar = AvatarAbbreviation | AvatarImage;

export enum PackCategory {
  ALL_FI_DOGS = 'ALL_FI_DOGS',
  BREED = 'BREED',
  GEO = 'GEO',
  MY_PACK = 'MY_PACK',
  ORGANIZATION = 'ORGANIZATION',
  OTHER = 'OTHER',
}

export type PackFeed = {
  __typename?: 'PackFeed';
  packs: Array<Pack>;
  pageInfo: PageInfo;
};

export type PackMember = {
  __typename?: 'PackMember';
  /**
   * Only present for members of the "Your Pack" pack.
   * "Your Pack" pack without any members will be empty array.
   */
  ownersContactInfo?: Maybe<Array<PackMemberContactInfo>>;
  pet: StrangerPet;
  /** Empty when pet does not have a ranking */
  ranking?: Maybe<PackRanking>;
};

/** For the "Your Pack" pack, this is the contact info for the pet's owner. */
export type PackMemberContactInfo = {
  __typename?: 'PackMemberContactInfo';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type PackMemberFeed = {
  __typename?: 'PackMemberFeed';
  members: Array<PackMember>;
  pageInfo: PageInfo;
  tokenValidity: TokenValidity;
};

export type PackRanking = {
  __typename?: 'PackRanking';
  isPending: Scalars['Boolean']['output'];
  points: PackRankingPoints;
  rankChange?: Maybe<RankChange>;
  rankNumber: Scalars['Int']['output'];
  /** @deprecated Always 0, and consumed by no client. A real value combined with rankNumber would reveal a pack's size — the platform-wide dog count for the overall pack. Will be removed once iOS and Android stop selecting it. */
  rankPercentile: Scalars['Int']['output'];
  stepCount: Scalars['Int']['output'];
};

export type PackRankingPoints = {
  __typename?: 'PackRankingPoints';
  /** Points before any bonuses are added */
  basePoints: Scalars['Int']['output'];
  /** Total bonus points granted from any source (currently only streaks) */
  totalBonusPoints: Scalars['Int']['output'];
  /** Combination of base points and bonus points */
  totalPoints: Scalars['Int']['output'];
};

/** Padding is in pixels */
export type PaddingInput = {
  bottom: Scalars['Int']['input'];
  left: Scalars['Int']['input'];
  right: Scalars['Int']['input'];
  top: Scalars['Int']['input'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** Pass this as `before` to paginate backwards in time. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Pass this as `after` to paginate forwards in time. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginatedPhotoFeed = {
  __typename?: 'PaginatedPhotoFeed';
  feedItems: Array<Photo>;
  pageInfo: PageInfo;
};

/**
 * The semantics of PagingDirection are ambiguous depending on the context of its
 * use. In time-based paging scenarios, "forward" refers to moving forward in
 * time (more recent) whereas "backwards" is correspondingly backwards in time
 * (less recent). For most "feeds", the implementation has the user scrolling
 * down on the device from the most recent data towards older data ("backwards").
 * When implementing a time-based feed of data, these semantics make sense.
 *
 * However when implementing paging in non-time-based contexts (browsing
 * alphabetically, browsing by rank, etc) this temporal reasoning is abandoned
 * and instead we must think about "BACKWARDS" meaning scrolling down further
 * into the list of items, and "FORWARDS" meaning scrolling up. This is not
 * intuitive but keeps the client logic for scrolling in time-based feeds and
 * other forms of pagination consistent.
 */
export enum PagingDirection {
  /** endCursor on PageInfo + BACKWARD scrolls 'down' */
  BACKWARD = 'BACKWARD',
  /** startCursor on PageInfo + FORWARD scrolls 'up' */
  FORWARD = 'FORWARD',
}

export type PagingInstruction = {
  cursor: Scalars['String']['input'];
  direction: PagingDirection;
};

export type PathProcessingDataForDebug = {
  __typename?: 'PathProcessingDataForDebug';
  errors: Array<Scalars['String']['output']>;
  steps: Array<PathProcessingStepForDebug>;
};

export type PathProcessingStepForDebug = {
  __typename?: 'PathProcessingStepForDebug';
  details?: Maybe<Scalars['JSON']['output']>;
  geoJson: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
};

export type PauseMembershipInput = {
  moduleId: Scalars['String']['input'];
  /** Deprecated: use pauseMonths. */
  numTerms?: InputMaybe<Scalars['Int']['input']>;
  /** Pause length in months, 1-3. Falls back to numTerms when omitted. */
  pauseMonths?: InputMaybe<Scalars['Int']['input']>;
  recurlySubscriptionId: Scalars['String']['input'];
};

export type PauseMembershipResult = {
  __typename?: 'PauseMembershipResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PayPalInfo = {
  __typename?: 'PayPalInfo';
  billingAgreementId?: Maybe<Scalars['String']['output']>;
};

export type PaymentInfo = BankAccountInfo | ObfuscatedCardInfo | PayPalInfo | WalletPaymentInfo;

/** Whether the account's stored payment method can be removed by a CX agent, and if not, why. */
export type PaymentMethodRemovability = {
  __typename?: 'PaymentMethodRemovability';
  canRemove: Scalars['Boolean']['output'];
  /** One sentence for the agent: what blocks removal and how to unblock it. Null when removable. */
  reason?: Maybe<Scalars['String']['output']>;
};

/**
 * Free days a cx agent has promised an account before its hardware-first membership exists.
 * Applied to the membership's term end when it starts; null appliedAt means it is still open.
 */
export type PendingMembershipExtension = {
  __typename?: 'PendingMembershipExtension';
  accountCode: Scalars['String']['output'];
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  appliedSubscriptionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByUserId?: Maybe<Scalars['ID']['output']>;
  days: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

export type PercentageOfUsersBooleanSetting = BooleanSetting & {
  __typename?: 'PercentageOfUsersBooleanSetting';
  percentage: Scalars['Int']['output'];
  platformOverrides: Array<BooleanSettingPlatformOverride>;
};

export type PermissionMobileAppContent = {
  __typename?: 'PermissionMobileAppContent';
  blockerScreen: MobileAppPermissionBlockerScreen;
  permissionType: Scalars['String']['output'];
};

export enum PermissionScope {
  read = 'read',
  write = 'write',
}

export type Pet = BasePet & {
  __typename?: 'Pet';
  activitiesForRange: ActivitiesForRangeResult;
  activity: Activity;
  activityFeed: ActivityFeed;
  /** `after` is exclusive. */
  activityIntensities: Array<ActivityIntensity>;
  /** @deprecated Use pet.stepFeed */
  activitySummaryFeed: ActivitySummaryFeed;
  additionalInfo?: Maybe<Scalars['String']['output']>;
  ageRange: AgeRange;
  /** @deprecated Use notificationSettings */
  alertPreferences: PetAlertPreferences;
  alertsEnabled: Scalars['Boolean']['output'];
  breed?: Maybe<Breed>;
  chip?: Maybe<AssignedChip>;
  color?: Maybe<Scalars['String']['output']>;
  communityAudience: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentActivityIntensity: ActivityIntensity;
  currentActivitySummary: ActivitySummary;
  dayOfBirth?: Maybe<Scalars['Int']['output']>;
  dbId: Scalars['Int']['output'];
  debugActivitiesLastNDays: Scalars['Int']['output'];
  deleted: Scalars['Boolean']['output'];
  device?: Maybe<Device>;
  discoverPostFeed: PetDiscoverFeed;
  fiHandle?: Maybe<Scalars['String']['output']>;
  followers: StrangerPetFeed;
  following: StrangerPetFeed;
  gender: Gender;
  hasSleepData: Scalars['Boolean']['output'];
  /**
   * Fetch heatmap data for a specified date range. Activity types are optional, omitting
   * them will return a heatmap of all types.
   *
   * Start and end dates are full-day inclusive. Any time component is ignored; startDate
   * is treated as midnight and endDate as end of day.
   *
   * If present, resolutionInMeters must be between 0 and 1000. Setting it to 0 disables clustering,
   * returning every distinct point as its own heatmap entry. Not providing a resolution will default to
   * 10 meters.
   */
  heatmap: HeatmapData;
  /** @deprecated Always null. Use homeLocation instead */
  homeCityState?: Maybe<Scalars['String']['output']>;
  homeLocation?: Maybe<PetHomeLocation>;
  household: Household;
  id: Scalars['ID']['output'];
  instagramHandle?: Maybe<Scalars['String']['output']>;
  isAmbassador: Scalars['Boolean']['output'];
  isEligibleForHealthReport: Scalars['Boolean']['output'];
  isIncludedInRanking: Scalars['Boolean']['output'];
  isPurebred: Scalars['Boolean']['output'];
  lastOvernightRestSummary: OvernightRestSummary;
  latestStepActivity?: Maybe<StepActivity>;
  /**
   * The pet's placement on each weekly activity leaderboard it has slice keys
   * for (breed, home city/state, life stage) — the same boards `leaderboard` /
   * `petRanking` serve. Null when the viewer lacks internal rankings access
   * (the mobile:leaderboards:enabled targeted flag); clients fall back to
   * packFeed's legacy pack rankings.
   */
  leaderboardPlacements?: Maybe<Array<LeaderboardPlacement>>;
  lifetimeStats?: Maybe<PetLifetimeStats>;
  /**
   * Fetch timestamped location points for a time-based scrubber. Returns chronologically
   * ordered positions with unix timestamps that can be scrubbed through on the front end.
   *
   * Supports specific timestamps — startDate and endDate are used as-is without snapping
   * to day boundaries.
   *
   * All timestamps are rounded to the nearest minute. REST segments are padded to cover the
   * full requested range and have gaps filled with interpolated positions. WALK and TRAVEL
   * segments only include points from the actual trace data (map-matched when available).
   *
   * Consecutive points at the same position are collapsed to just the first and last of each
   * stationary run — the client can infer the pet was at that location for the entire interval
   * between the two timestamps. This significantly reduces payload size for long REST periods.
   */
  locationScrubber: LocationScrubberData;
  monthOfBirth?: Maybe<Scalars['Int']['output']>;
  /** Pack containing this pet and the owners contacts */
  myPack?: Maybe<VirtualPack>;
  name: Scalars['String']['output'];
  notificationSettings: Array<PetNotificationSetting>;
  /**
   * The caller's credential for fetching this pet's location over SMS while off grid. The text to send
   * is `FI <key>`. Null for a provisional caretaker.
   */
  offgridToken?: Maybe<OffgridToken>;
  ongoingActivity?: Maybe<OngoingActivity>;
  overnightRestSummary: OvernightRestSummary;
  packFeed: PackFeed;
  packs: Array<Pack>;
  /** Returns a chip for which there is an outstanding transfer associated with this Pet. */
  pendingChip?: Maybe<StrangerChip>;
  /** The step count distribution specific to this pet's age and breed */
  personalizedStepCountDistribution?: Maybe<StepCountDistribution>;
  petCollarState: PetCollarState;
  photos: PhotoFeed;
  places: Array<Place>;
  /** Product features that are available for this pet. These may be based on pet species, breed, or other factors. */
  productAvailability: Array<ProductAvailability>;
  publicProfile?: Maybe<PublicProfileSharing>;
  renderDebugActivitySegments: RenderedDebugActivitySegments;
  /**
   * Where this pet sits in the calling rescue's adoption pipeline, counting only adoptions the
   * caller's own rescue or foster households started. NONE for anyone who is not a rescue user, and
   * for a pet whose only adoptions belong to another organization.
   *
   * Pet-centric, unlike the rescueDevices filters callers used to cross-reference against: a
   * chip-only adoption, where no device was ever attached, is reported here and was invisible before.
   * Unlike those filters it applies no completedSince window, so an adoption of any age counts.
   */
  rescueAdoptionState: RescuePetAdoptionState;
  /** Rescue transfer record: only returned for rescue users, one of PetTemporaryTransfer OR PetAdoptionTransfer */
  rescueTransfer?: Maybe<RescueTransfer>;
  restFeed: RestFeed;
  restSegmentsForRange: Array<RestSegment>;
  /** @deprecated Use pet.restFeed */
  restSummaryFeed: RestSummaryFeed;
  secondaryDevice?: Maybe<Device>;
  /** Current snooze status for this pet. */
  snoozeStatus: PetSnoozeStatus;
  species?: Maybe<Species>;
  stepActivityInfo: StepActivityInfo;
  /**
   * Added to support Activity/Rest UI refresh in June 2024.
   * https://docs.google.com/document/d/1T2qpG0_E1QC-k0gq7A0Cp-sfqkKDAyQNuMrB9zTLv2U/edit#heading=h.2rmuizvwm3bv
   */
  stepFeed: StepFeed;
  /** The pet's current daily step goal. */
  stepGoal: Scalars['Int']['output'];
  /** Returns the average strain score for all Fi dogs. */
  strainScoreAverageAllDogs?: Maybe<StrainScoreAverage>;
  /** Returns average strain score over last 60 days. */
  strainScoreAveragePast60Days?: Maybe<StrainScoreAverage>;
  /** Returns the average strain score over all "similar" dogs (same breed + age) */
  strainScoreAverageSimilarDogs?: Maybe<StrainScoreAverage>;
  /**
   * Returns 24 buckets, one per hour, of strain scores (if available) on specified day.
   *
   * The `day` argument should be null to retrieve today's score.
   * To page back into the past, set `day` to be the `nextCursor` string provided in the
   * StrainScoreResult.
   *
   * Returned strain scores are *not* rounded.
   * @deprecated Use pet.strainFeed
   */
  strainScoreHourly?: Maybe<StrainScoreResult>;
  streakHistoryFeed: StreakHistoryFeed;
  tenancy?: Maybe<Scalars['String']['output']>;
  thirdPartyAccess?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
  /** Total number of likes for this pet, across walks, photos, etc. */
  totalLikes: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Story-style "Week In Review" rendered as a sequence of full-screen cards
   * in the mobile apps. The week is Monday–Sunday in the pet's local
   * timezone; any DateTime within the desired week is normalized to that
   * week's Monday server-side. When `weekOf` is omitted, defaults to the
   * most recent Sunday at midday in the pet's timezone — i.e. the
   * just-completed week, rolling forward to the current week at Sunday
   * noon. Returns null when no review is available for the requested week
   * (e.g. insufficient data, future week).
   */
  weekInReview?: Maybe<WeekInReview>;
  weight: Scalars['Float']['output'];
  yearOfBirth: Scalars['Int']['output'];
};

export type PetactivitiesForRangeArgs = {
  after: Scalars['DateTime']['input'];
  before?: InputMaybe<Scalars['DateTime']['input']>;
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PetactivityArgs = {
  id: Scalars['ID']['input'];
  walksVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type PetactivityFeedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  typeFilter?: InputMaybe<Array<ActivityType>>;
  walksVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type PetactivityIntensitiesArgs = {
  after: Scalars['DateTime']['input'];
  before?: InputMaybe<Scalars['DateTime']['input']>;
  stride?: InputMaybe<Scalars['Int']['input']>;
};

export type PetactivitySummaryFeedArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  period: ActivitySummaryPeriod;
};

export type PetcurrentActivityIntensityArgs = {
  stride?: InputMaybe<Scalars['Int']['input']>;
};

export type PetcurrentActivitySummaryArgs = {
  period: ActivitySummaryPeriod;
};

export type PetdiscoverPostFeedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type PetfollowersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type PetfollowingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type PetheatmapArgs = {
  activityTypes?: InputMaybe<Array<HeatmapActivityType>>;
  endDate: Scalars['DateTime']['input'];
  resolutionInMeters?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type PetlocationScrubberArgs = {
  activityTypes?: InputMaybe<Array<ActivityType>>;
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type PetnotificationSettingsArgs = {
  category?: InputMaybe<PetNotificationSettingCategory>;
  forUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type PetongoingActivityArgs = {
  walksVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type PetovernightRestSummaryArgs = {
  date: Scalars['DateTime']['input'];
};

export type PetrenderDebugActivitySegmentsArgs = {
  input: Scalars['JSON']['input'];
};

export type PetrestFeedArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  period: ActivityRestStrainPeriod;
};

export type PetrestSegmentsForRangeArgs = {
  after: Scalars['DateTime']['input'];
  before?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PetrestSummaryFeedArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  period: ActivitySummaryPeriod;
};

export type PetstepFeedArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  period: ActivityRestStrainPeriod;
};

export type PetstrainScoreHourlyArgs = {
  day?: InputMaybe<Scalars['String']['input']>;
};

export type PetstreakHistoryFeedArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
};

export type PetweekInReviewArgs = {
  weekOf?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PetAdoptionTransfer = {
  __typename?: 'PetAdoptionTransfer';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  fromHousehold: Household;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pet: Pet;
  status: PetAdoptionTransferStatus;
  toHousehold: Household;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export enum PetAdoptionTransferStatus {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  NOT_RECOVERED = 'NOT_RECOVERED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  RESCUE_RESOLVED = 'RESCUE_RESOLVED',
}

export type PetAlertPreferences = {
  __typename?: 'PetAlertPreferences';
  notificationMode: PetNotificationMode;
};

export enum PetBehaviorChangeDirection {
  DOWN = 'DOWN',
  NONE = 'NONE',
  UP = 'UP',
}

export type PetBehaviorDetail =
  | PetBehaviorDetailDay
  | PetBehaviorDetailMonth
  | PetBehaviorDetailWeek
  | PetBehaviorDetailYear;

export type PetBehaviorDetailComparison = {
  __typename?: 'PetBehaviorDetailComparison';
  changeAmount: Scalars['String']['output'];
  description: FormatString;
  direction: PetBehaviorChangeDirection;
  graph: PetBehaviorDetailComparisonGraph;
};

export type PetBehaviorDetailComparisonGraph = {
  __typename?: 'PetBehaviorDetailComparisonGraph';
  /**
   * Indicates the end of data.
   * There may be future time indicated by this value being less than `length`
   */
  currentPeriodDataEnd?: Maybe<Scalars['Float']['output']>;
  currentPeriodDataEndText?: Maybe<Scalars['String']['output']>;
  currentPeriodDescription: Scalars['String']['output'];
  currentPeriodIntervals: Array<PetBehaviorDetailComparisonGraphInterval>;
  currentPeriodLabel: Scalars['String']['output'];
  previousPeriodDescription: Scalars['String']['output'];
  previousPeriodIntervals: Array<PetBehaviorDetailComparisonGraphInterval>;
  previousPeriodLabel: Scalars['String']['output'];
  xAxisLabels: Array<Maybe<Scalars['String']['output']>>;
};

/** Values are normalized between 0 and 1 */
export type PetBehaviorDetailComparisonGraphInterval = {
  __typename?: 'PetBehaviorDetailComparisonGraphInterval';
  offset: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type PetBehaviorDetailDay = BasePetBehaviorDetail & {
  __typename?: 'PetBehaviorDetailDay';
  behaviorId: Scalars['String']['output'];
  behaviorLabel: Scalars['String']['output'];
  color: Scalars['HexColorCode']['output'];
  comparison: PetBehaviorDetailComparison;
  cursor: Scalars['String']['output'];
  durationLabel: Scalars['String']['output'];
  durationText: Scalars['String']['output'];
  durationTextColor?: Maybe<Scalars['HexColorCode']['output']>;
  eventCountLabel: Scalars['String']['output'];
  eventCountText: Scalars['String']['output'];
  eventCountTextColor: Scalars['HexColorCode']['output'];
  graph: PetBehaviorDetailGraph;
  help: PetBehaviorDetailHelp;
  icon: Image;
  nextCursor?: Maybe<Scalars['String']['output']>;
  period: PetBehaviorPeriod;
  previousCursor?: Maybe<Scalars['String']['output']>;
  /** A human readable label for this period of time */
  rangeLabel: Scalars['String']['output'];
  segmentedTimeline: PetBehaviorDetailSegmentedTimeline;
};

export type PetBehaviorDetailGraph = {
  __typename?: 'PetBehaviorDetailGraph';
  average: Scalars['Float']['output'];
  intervals: Array<PetBehaviorDetailGraphInterval>;
  maxValueText: Scalars['String']['output'];
  xAxisLabels: Array<Scalars['String']['output']>;
};

export type PetBehaviorDetailGraphInterval = {
  __typename?: 'PetBehaviorDetailGraphInterval';
  inFuture: Scalars['Boolean']['output'];
  /** Will be true if the current interval is incomplete (current day) */
  isIncomplete: Scalars['Boolean']['output'];
  /** Optional overlay value for dual-bar visualization (normalized between 0 and 1) */
  overlayValue?: Maybe<Scalars['Float']['output']>;
  tooltip?: Maybe<PetBehaviorDetailGraphIntervalTooltip>;
  /** Values are normalized between 0 and 1 */
  value: Scalars['Float']['output'];
};

export type PetBehaviorDetailGraphIntervalTooltip = {
  __typename?: 'PetBehaviorDetailGraphIntervalTooltip';
  /**
   * Duration text like "22m 3s" or "1hr 20m"
   * @deprecated Use eventLabelSecondary instead
   */
  duration: Scalars['String']['output'];
  /** Event type label like "Sleep", "Nap", "Active time", "Walk" */
  eventLabel: Scalars['String']['output'];
  /** Event details like "22m 3s", "Walk 1.2mi", "22m • 2.2k steps" */
  eventLabelSecondary: Scalars['String']['output'];
  /** Timestamp like "8:01AM" */
  timestamp: Scalars['String']['output'];
};

export type PetBehaviorDetailHelp = {
  __typename?: 'PetBehaviorDetailHelp';
  buttonText: Scalars['String']['output'];
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Indicates the type of interval in a segmented timeline */
export enum PetBehaviorDetailIntervalType {
  /** An interval where the device was off the pet */
  DEVICE_OFF = 'DEVICE_OFF',
  /** An interval representing detected behavior events (eg barking, sleeping, activity) */
  EVENT = 'EVENT',
  /** An interval with no detected behavior events */
  NOTHING = 'NOTHING',
}

export type PetBehaviorDetailMonth = BasePetBehaviorDetail & {
  __typename?: 'PetBehaviorDetailMonth';
  behaviorId: Scalars['String']['output'];
  behaviorLabel: Scalars['String']['output'];
  color: Scalars['HexColorCode']['output'];
  comparison: PetBehaviorDetailComparison;
  cursor: Scalars['String']['output'];
  durationLabel: Scalars['String']['output'];
  durationText: Scalars['String']['output'];
  durationTextColor?: Maybe<Scalars['HexColorCode']['output']>;
  eventCountLabel: Scalars['String']['output'];
  eventCountText: Scalars['String']['output'];
  eventCountTextColor: Scalars['HexColorCode']['output'];
  graph: PetBehaviorDetailGraph;
  help: PetBehaviorDetailHelp;
  icon: Image;
  nextCursor?: Maybe<Scalars['String']['output']>;
  period: PetBehaviorPeriod;
  previousCursor?: Maybe<Scalars['String']['output']>;
  /** A human readable label for this period of time */
  rangeLabel: Scalars['String']['output'];
};

export type PetBehaviorDetailSegmentedTimeline = {
  __typename?: 'PetBehaviorDetailSegmentedTimeline';
  /**
   * Indicates the end of data.
   * There may be future time indicated by this value being less than `length`
   */
  dataEnd?: Maybe<Scalars['Float']['output']>;
  dataEndText?: Maybe<Scalars['String']['output']>;
  /** Optional data markers to overlay on the timeline (e.g., sun icon at wake-up time, moon icon at bedtime) */
  dataMarkers?: Maybe<Array<PetBehaviorDetailSegmentedTimelineDataMarker>>;
  intervals: Array<PetBehaviorDetailSegmentedTimelineInterval>;
  /** Will be null if there is only one timeline being returned */
  label?: Maybe<Scalars['String']['output']>;
  /** Will be null if time period is complete and there is no future time */
  lastUpdatedText?: Maybe<Scalars['String']['output']>;
  length: Scalars['Float']['output'];
  xAxisLabels: Array<Maybe<Scalars['String']['output']>>;
};

/**
 * A marker that can be overlaid on a segmented timeline to indicate specific events
 * such as wake-up time (sun icon) or bedtime (moon icon)
 */
export type PetBehaviorDetailSegmentedTimelineDataMarker = {
  __typename?: 'PetBehaviorDetailSegmentedTimelineDataMarker';
  /** Icon to display at the marker position */
  labelIcon: Image;
  /** Text label to display next to the marker (e.g., "8:47AM") */
  labelText: Scalars['String']['output'];
  /** Offset in seconds from the start of the timeline where the marker should appear */
  offset: Scalars['Float']['output'];
};

export type PetBehaviorDetailSegmentedTimelineInterval = {
  __typename?: 'PetBehaviorDetailSegmentedTimelineInterval';
  color: Scalars['HexColorCode']['output'];
  /** The type of interval (e.g., activity, rest, device off). */
  intervalType: PetBehaviorDetailIntervalType;
  length: Scalars['Float']['output'];
  offset: Scalars['Float']['output'];
  tooltip?: Maybe<PetBehaviorDetailSegmentedTimelineIntervalTooltip>;
};

export type PetBehaviorDetailSegmentedTimelineIntervalTooltip = {
  __typename?: 'PetBehaviorDetailSegmentedTimelineIntervalTooltip';
  /**
   * Duration text like "22m 3s" or "1hr 20m"
   * @deprecated Use eventLabelSecondary instead
   */
  duration: Scalars['String']['output'];
  /** Event type label like "Sleep", "Nap", "Active time", "Walk" */
  eventLabel: Scalars['String']['output'];
  /** Event details like "22m 3s", "Walk 1.2mi", "22m • 2.2k steps" */
  eventLabelSecondary: Scalars['String']['output'];
  /** Timestamp like "8:01AM" */
  timestamp: Scalars['String']['output'];
};

export type PetBehaviorDetailWeek = BasePetBehaviorDetail & {
  __typename?: 'PetBehaviorDetailWeek';
  behaviorId: Scalars['String']['output'];
  behaviorLabel: Scalars['String']['output'];
  color: Scalars['HexColorCode']['output'];
  comparison: PetBehaviorDetailComparison;
  cursor: Scalars['String']['output'];
  durationLabel: Scalars['String']['output'];
  durationText: Scalars['String']['output'];
  durationTextColor?: Maybe<Scalars['HexColorCode']['output']>;
  eventCountLabel: Scalars['String']['output'];
  eventCountText: Scalars['String']['output'];
  eventCountTextColor: Scalars['HexColorCode']['output'];
  graph: PetBehaviorDetailGraph;
  help: PetBehaviorDetailHelp;
  icon: Image;
  nextCursor?: Maybe<Scalars['String']['output']>;
  period: PetBehaviorPeriod;
  previousCursor?: Maybe<Scalars['String']['output']>;
  /** A human readable label for this period of time */
  rangeLabel: Scalars['String']['output'];
  segmentedTimelines: Array<PetBehaviorDetailSegmentedTimeline>;
};

export type PetBehaviorDetailYear = BasePetBehaviorDetail & {
  __typename?: 'PetBehaviorDetailYear';
  behaviorId: Scalars['String']['output'];
  behaviorLabel: Scalars['String']['output'];
  color: Scalars['HexColorCode']['output'];
  comparison: PetBehaviorDetailComparison;
  cursor: Scalars['String']['output'];
  durationLabel: Scalars['String']['output'];
  durationText: Scalars['String']['output'];
  durationTextColor?: Maybe<Scalars['HexColorCode']['output']>;
  eventCountLabel: Scalars['String']['output'];
  eventCountText: Scalars['String']['output'];
  eventCountTextColor: Scalars['HexColorCode']['output'];
  graph: PetBehaviorDetailGraph;
  help: PetBehaviorDetailHelp;
  icon: Image;
  nextCursor?: Maybe<Scalars['String']['output']>;
  period: PetBehaviorPeriod;
  previousCursor?: Maybe<Scalars['String']['output']>;
  /** A human readable label for this period of time */
  rangeLabel: Scalars['String']['output'];
};

export enum PetBehaviorPeriod {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR',
}

export enum PetChangeType {
  CURRENT_ACTIVITY = 'CURRENT_ACTIVITY',
  LOCATION = 'LOCATION',
  MODULE_INFO = 'MODULE_INFO',
  ONGOING_ACTIVITY = 'ONGOING_ACTIVITY',
  STATUS = 'STATUS',
  TEST = 'TEST',
}

/** Represents a pet/collar combo's synthesized state at a given moment in time */
export type PetCollarState = {
  /** The moment in time the state represents */
  timestamp: Scalars['DateTime']['output'];
};

export type PetDailyGoalStreakBonus = {
  __typename?: 'PetDailyGoalStreakBonus';
  /** The number of bonus points earned for meeting this goal */
  bonusPoints: Scalars['Int']['output'];
  /** The number of days in a row that pet must meat their step goal to qualify for this bonus */
  streakLengthRequirement: Scalars['Int']['output'];
  /** Indicates whether the pet has or has not met this streak goal */
  streakMet: Scalars['Boolean']['output'];
};

export type PetDiscoverFeed = {
  __typename?: 'PetDiscoverFeed';
  feedItems: Array<PetDiscoverFeedItem>;
  pageInfo: PageInfo;
};

export type PetDiscoverFeedItem = DiscoverFeedPhotoItem | DiscoverFeedTextPostItem | DiscoverFeedVideoPostItem;

export type PetDocument = BasePetDocument & {
  __typename?: 'PetDocument';
  date: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  fileSizeBytes: Scalars['Int']['output'];
  fileType: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isUnseen: Scalars['Boolean']['output'];
  labels?: Maybe<Array<Scalars['String']['output']>>;
  markdownFileUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: PetDocumentStatus;
  summary?: Maybe<Scalars['String']['output']>;
  totalCostCents?: Maybe<Scalars['Int']['output']>;
  type: PetDocumentType;
};

export type PetDocumentFeed = {
  __typename?: 'PetDocumentFeed';
  documents: Array<PetDocument>;
  pageInfo: PageInfo;
  unreadCount: Scalars['Int']['output'];
};

export enum PetDocumentStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  READY = 'READY',
}

export enum PetDocumentType {
  DOCUMENT = 'DOCUMENT',
  PHOTO = 'PHOTO',
}

export type PetFeed = {
  __typename?: 'PetFeed';
  pageInfo: PageInfo;
  pets: Array<Pet>;
  totalCount: Scalars['Int']['output'];
};

export enum PetFilter {
  /**
   * Restrict results to pets that have a device assigned (Pet.deviceId IS NOT NULL).
   * This is independent of subscription state — a pet whose device has no active
   * subscription still passes.
   */
  HAS_DEVICE = 'HAS_DEVICE',
}

export type PetHealthInsight = {
  __typename?: 'PetHealthInsight';
  deepLink?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isFullWidth: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type PetHealthTrend = {
  __typename?: 'PetHealthTrend';
  chart: PetHealthTrendChart;
  deepLinkUrl: Scalars['String']['output'];
  /**
   * This is a trend that is not available for the pet's hardware version. This would be false for pets with a S3+ module.
   * A disabled trend will also contain mocked graph/timeline data.
   */
  disabled: Scalars['Boolean']['output'];
  icon: Image;
  id: Scalars['ID']['output'];
  /** Summary of the trend like "4,128 steps/day" or "9hr 55m /day" */
  summaryComponents: PetHealthTrendSummary;
  title: Scalars['String']['output'];
};

export type PetHealthTrendChangeSummary = {
  __typename?: 'PetHealthTrendChangeSummary';
  direction: PetBehaviorChangeDirection;
  icon: Image;
  summary: Scalars['String']['output'];
};

export type PetHealthTrendChart = PetHealthTrendGraph | PetHealthTrendSegmentedTimeline;

export type PetHealthTrendGraph = {
  __typename?: 'PetHealthTrendGraph';
  average: Scalars['Float']['output'];
  color: Scalars['HexColorCode']['output'];
  /** A null value indicates that the value is not available, probably because the time represented by that interval hasn't happened yet */
  intervals: Array<Maybe<Scalars['Float']['output']>>;
  /** The maximum interval value */
  maximum: Scalars['Float']['output'];
  /** The minimum interval value */
  minimum: Scalars['Float']['output'];
  showAverage: Scalars['Boolean']['output'];
};

export enum PetHealthTrendPeriod {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
}

export type PetHealthTrendSegmentedTimeline = {
  __typename?: 'PetHealthTrendSegmentedTimeline';
  /** Indicates the end of data. The timeline may include future time that should be displayed different from time that has passed but has no events */
  dataEnd?: Maybe<Scalars['Int']['output']>;
  intervals: Array<PetHealthTrendSegmentedTimelineInterval>;
  length: Scalars['Int']['output'];
};

export type PetHealthTrendSegmentedTimelineInterval = {
  __typename?: 'PetHealthTrendSegmentedTimelineInterval';
  color: Scalars['HexColorCode']['output'];
  intervalType: PetBehaviorDetailIntervalType;
  length: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type PetHealthTrendSummary = {
  __typename?: 'PetHealthTrendSummary';
  durationChange?: Maybe<PetHealthTrendSummaryChange>;
  /**
   * Summary of any trend in the duration metric
   * @deprecated Use napSummary or sleepSummary for rest trends
   */
  durationSummary?: Maybe<Scalars['String']['output']>;
  eventsChange?: Maybe<PetHealthTrendSummaryChange>;
  /**
   * Summary of any trend in the events metric
   * @deprecated Use napSummary or sleepSummary for rest trends
   */
  eventsSummary?: Maybe<Scalars['String']['output']>;
  /** Summary of nap duration for rest trends */
  napSummary?: Maybe<Scalars['String']['output']>;
  /** Populated when there is no data to display e.g. "Collecting data" */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Summary of sleep duration for rest trends */
  sleepSummary?: Maybe<Scalars['String']['output']>;
};

export type PetHealthTrendSummaryChange = {
  __typename?: 'PetHealthTrendSummaryChange';
  change: Scalars['String']['output'];
  direction: PetBehaviorChangeDirection;
};

export type PetHealthTrendUpgradeBanner = {
  __typename?: 'PetHealthTrendUpgradeBanner';
  body: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  deeplink: Scalars['String']['output'];
  image: Image;
};

export type PetHealthTrends = {
  __typename?: 'PetHealthTrends';
  /** Behavior trends are only available to users with compatible modules providing this data. These are trends like barking, licking, eating, etc. */
  behaviorTrends: Array<PetHealthTrend>;
  /** Generic trends are available to all users based on activity data collected for every module */
  genericTrends: Array<PetHealthTrend>;
  period: PetHealthTrendPeriod;
  /** Banner to show when the user needs to upgrade to unlock behavior data. */
  upgradeBanner?: Maybe<PetHealthTrendUpgradeBanner>;
};

export type PetHomeLocation = {
  __typename?: 'PetHomeLocation';
  city?: Maybe<Scalars['String']['output']>;
  cityState?: Maybe<Scalars['String']['output']>;
  /** ISO 3166-1 alpha-2 country code (e.g. "US", "GB"). */
  country?: Maybe<Scalars['String']['output']>;
  /** The coordinates the home location was geocoded from; null for pets still on the legacy blob. */
  position?: Maybe<Position>;
  state?: Maybe<Scalars['String']['output']>;
};

export type PetInsight = {
  __typename?: 'PetInsight';
  buttonText: Scalars['String']['output'];
  buttonUrl: Scalars['String']['output'];
  description: Scalars['String']['output'];
  graph: PetInsightGraph;
  id: Scalars['ID']['output'];
  leadingImage: InsightLeadingImage;
  title: Scalars['String']['output'];
};

export type PetInsightGraph = {
  __typename?: 'PetInsightGraph';
  currentPeriodLineHexColor: Scalars['HexColorCode']['output'];
  currentPeriodValues: Array<Scalars['Float']['output']>;
  previousPeriodLineHexColor: Scalars['HexColorCode']['output'];
  previousPeriodValues: Array<Scalars['Float']['output']>;
  showDividingLine: Scalars['Boolean']['output'];
};

export type PetInsightWithoutGraph = {
  __typename?: 'PetInsightWithoutGraph';
  buttonText: Scalars['String']['output'];
  buttonUrl: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  leadingImage: InsightLeadingImage;
  title: Scalars['String']['output'];
};

/** A single pet's own placement, from the ClickHouse rankings service. */
export type PetLeaderboardRank = {
  __typename?: 'PetLeaderboardRank';
  events: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
};

/**
 * All `*On` / `*Starting` DateTimes are midnight at the start of the relevant day/week/month in
 * the pet's local timezone. `recordStepsHourAt` and `recordEarliestWalkSeconds` are likewise
 * pet-local.
 */
export type PetLifetimeStats = {
  __typename?: 'PetLifetimeStats';
  asOfDate: Scalars['DateTime']['output'];
  averageActiveMinutesDay?: Maybe<Scalars['Float']['output']>;
  averageActiveMinutesMonth?: Maybe<Scalars['Float']['output']>;
  cumulativeSteps?: Maybe<Scalars['Int']['output']>;
  cumulativeWalkDistanceMeters?: Maybe<Scalars['Int']['output']>;
  currentTier: PetLifetimeStatsTier;
  dailyAverageSteps?: Maybe<Scalars['Float']['output']>;
  /**
   * Average/typical cumulative step curve by hour (24 entries, 00:00→23:00 pet-local), drawn behind
   * the most-active day's cumulative line for comparison. Null when no historic trend is available;
   * individual entries are null for hours with no recorded activity.
   */
  intradayStepTrend?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /**
   * Average/typical per-day step totals across a month (31 entries), drawn behind the most-active
   * month's line for comparison. Null when no historic trend is available; individual entries are
   * null for days with no recorded activity.
   */
  intramonthStepTrend?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  longestDailyStreakDays?: Maybe<Scalars['Int']['output']>;
  longestDailyStreakEnding?: Maybe<Scalars['DateTime']['output']>;
  longestDailyStreakStarting?: Maybe<Scalars['DateTime']['output']>;
  longestWeeklyStreakStarting?: Maybe<Scalars['DateTime']['output']>;
  longestWeeklyStreakWeeks?: Maybe<Scalars['Int']['output']>;
  nextTier?: Maybe<PetLifetimeStatsTier>;
  recordActiveMinutesDay?: Maybe<Scalars['Int']['output']>;
  /**
   * Cumulative running step total by hour (24 entries, 00:00→23:00 pet-local) for the most-active day,
   * the foreground line on the day card. The final entry is the day's total steps, which the card uses
   * as its headline number. Null when that day has no recorded summary. For record days predating the
   * per-hour data (before 2025-02-24) no real breakdown exists, so the intraday shape is synthesized
   * from population-average hourly step distributions and is not measured data; only the final entry,
   * the day's real total, is authoritative.
   */
  recordActiveMinutesDayCumulativeSteps?: Maybe<Array<Scalars['Int']['output']>>;
  /**
   * Per-hour step counts (24 entries, 00:00→23:00 pet-local) for the most-active day. Null when that
   * day has no recorded activity.
   * @deprecated Use recordActiveMinutesDayCumulativeSteps for the day trend graph; this per-hour series required client-side cumulation.
   */
  recordActiveMinutesDayHourlySteps?: Maybe<Array<Scalars['Int']['output']>>;
  recordActiveMinutesDayOn?: Maybe<Scalars['DateTime']['output']>;
  /** Percentage by which the record active-minutes day exceeded the daily average. */
  recordActiveMinutesDayPctAboveAvg?: Maybe<Scalars['Float']['output']>;
  recordActiveMinutesMonth?: Maybe<Scalars['Int']['output']>;
  /**
   * Daily step counts across the record active-minutes month, indexed by day of month. Entries are
   * null for days outside the month or not yet recorded.
   */
  recordActiveMinutesMonthDailySteps?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Percentage by which the record active-minutes month exceeded the monthly average. */
  recordActiveMinutesMonthPctAboveAvg?: Maybe<Scalars['Float']['output']>;
  recordActiveMinutesMonthStarting?: Maybe<Scalars['DateTime']['output']>;
  recordConsistentWeekStarting?: Maybe<Scalars['DateTime']['output']>;
  /** Standard deviation of daily steps within the most-consistent week — lower means more consistent. */
  recordConsistentWeekStepsStddev?: Maybe<Scalars['Int']['output']>;
  recordDaysAboveGoalMonth?: Maybe<Scalars['Int']['output']>;
  recordDaysAboveGoalMonthStarting?: Maybe<Scalars['DateTime']['output']>;
  recordEarliestWalk?: Maybe<Walk>;
  recordEarliestWalkOn?: Maybe<Scalars['DateTime']['output']>;
  /** Seconds since midnight (pet-local) of the earliest walk start. */
  recordEarliestWalkSeconds?: Maybe<Scalars['Int']['output']>;
  recordStepsDay?: Maybe<Scalars['Int']['output']>;
  recordStepsDayOn?: Maybe<Scalars['DateTime']['output']>;
  recordStepsHour?: Maybe<Scalars['Int']['output']>;
  /** Hour-of-day (0-23) in the pet's local timezone. */
  recordStepsHourAt?: Maybe<Scalars['Int']['output']>;
  recordStepsHourOn?: Maybe<Scalars['DateTime']['output']>;
  recordStepsMonth?: Maybe<Scalars['Int']['output']>;
  recordStepsMonthStarting?: Maybe<Scalars['DateTime']['output']>;
  recordStepsWeek?: Maybe<Scalars['Int']['output']>;
  recordStepsWeekStarting?: Maybe<Scalars['DateTime']['output']>;
  recordWalkDistanceMeters?: Maybe<Scalars['Int']['output']>;
  recordWalkDistanceOn?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The walk that set the record. Null when the walk no longer exists or when
   * viewing another user's pet.
   */
  recordWalkDistanceWalk?: Maybe<Walk>;
  recordWalkDurationOn?: Maybe<Scalars['DateTime']['output']>;
  recordWalkDurationSeconds?: Maybe<Scalars['Int']['output']>;
  recordWalkDurationWalk?: Maybe<Walk>;
  recordWalksInDay?: Maybe<Scalars['Int']['output']>;
  recordWalksInDayOn?: Maybe<Scalars['DateTime']['output']>;
  stepsToNextTier?: Maybe<Scalars['Int']['output']>;
};

export type PetLifetimeStatsTier = {
  __typename?: 'PetLifetimeStatsTier';
  /** Ordered color stops. Solid tiers return a single stop; gradient tiers return two or more. */
  colors: Array<Scalars['HexColorCode']['output']>;
  name: PetLifetimeStatsTierName;
  /** Percentage (0–100) of Fi pets that have reached this tier, i.e. logged at least `stepMinimum` steps. */
  percentageOfPets: Scalars['Float']['output'];
  /** Single flat color for surfaces that can't render a gradient, e.g. borders and dividers. */
  solidColor: Scalars['HexColorCode']['output'];
  /**
   * Spline scene for the tier's 3D badge, served from the media CDN, in the native export
   * format read by the iOS and Android runtimes.
   */
  splineSceneUrl: Scalars['String']['output'];
  /** The same scene in Spline's web export format. */
  splineSceneWebUrl: Scalars['String']['output'];
  stepMinimum: Scalars['Int']['output'];
  /** Which text color to lay over `solidColor`/`colors` for legible contrast, e.g. on the tier badge. */
  textColor: PetLifetimeStatsTierTextColor;
  /**
   * Looping animation of the tier's trophy — an 800x800 animated WebP with a transparent
   * background — for surfaces that want motion but can't run the Spline scene.
   */
  trophyAnimationWebpUrl: Scalars['String']['output'];
  /**
   * Static image of the tier's trophy — a 1000x1000 PNG with a transparent background — for
   * surfaces that render the trophy as an image rather than an interactive scene.
   */
  trophyImageUrl: Scalars['String']['output'];
};

export enum PetLifetimeStatsTierName {
  BRONZE = 'BRONZE',
  CLAY = 'CLAY',
  DIAMOND = 'DIAMOND',
  EMERALD = 'EMERALD',
  GALAXY = 'GALAXY',
  GOLD = 'GOLD',
  IRON = 'IRON',
  SAPPHIRE = 'SAPPHIRE',
  SILVER = 'SILVER',
  STONE = 'STONE',
  TITANIUM = 'TITANIUM',
  WOOD = 'WOOD',
}

export enum PetLifetimeStatsTierTextColor {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}

/**
 * Consolidated live state for a pet, resolved across all devices.
 * Backend owns multi-device consolidation logic.
 */
export type PetLiveState = {
  __typename?: 'PetLiveState';
  /** Geocoded fallback (neighborhood / city) when neither a safe zone nor dog park matches. */
  areaName?: Maybe<Scalars['String']['output']>;
  /** Dog park the pet is currently at; null if not at one. Enables dog park navigation and analytics. */
  atDogPark?: Maybe<DogPark>;
  /**
   * Saved place (user-defined safe zone) the pet is currently at; null if not at one.
   * Enables "Edit zone" and other place-specific actions. Distinct from `location.place`, which
   * is the saved place matching the raw location-estimate point — clients wanting the canonical
   * "pet is at this safe zone" signal should use this field.
   */
  atSafeZone?: Maybe<Place>;
  /** How the collar is currently reaching the network. */
  backhaul: BackhaulType;
  cityState?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the pet is currently online — true if any on-dog device is reporting within its
   * expected interval. When all of a pet's devices are off-dog (or off-dog status is unknown),
   * falls back to "any device online" across every device.
   */
  isOnline: Scalars['Boolean']['output'];
  /** Online but the last connection state is older than the staleness threshold. False when offline. */
  isStale: Scalars['Boolean']['output'];
  /**
   * Latest location-report timestamp across the pet's on-dog devices (falls back to all devices
   * when off-dog status is unknown or all are off-dog). Ignored reports are excluded.
   */
  lastReportTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The pet's consolidated location estimate — derived from the currently ongoing activity (for
   * walks: the latest filtered position; for rests: the segment's representative location). Null
   * when no location has been resolved yet. The `location.place` resolver matches the estimate's
   * point against the user's saved places; clients wanting the canonical pet-level saved safe
   * zone (for "Edit zone" etc.) should use `PetLiveState.atSafeZone` instead.
   */
  location?: Maybe<Location>;
  /**
   * Whether the caller is authorized to see this pet's location. Reuses ObfuscatedReason:
   * HAS_ACCESS means location visibility is allowed — but location-related fields may still be
   * null when there is no resolvable activity yet (e.g. freshly activated collar). NO_ACCESS and
   * NO_SUBSCRIPTION both guarantee location-related fields are null.
   */
  locationAccess: ObfuscatedReason;
  /**
   * Backend-resolved display name (priority: atSafeZone > atDogPark > areaName).
   * Convenience for simple-display consumers; use atSafeZone/atDogPark/areaName for typed branching.
   */
  locationName?: Maybe<Scalars['String']['output']>;
  lostMode: CollarLostDogModeState;
  /**
   * Earliest expected next-report deadline across the pet's on-dog devices (same fallback rule
   * as lastReportTimestamp). Clients use this as the offline-detection threshold — if no update
   * arrives by this time plus a grace period, fire a one-shot refresh to discover whether the pet
   * has gone offline. Null when no device has a deadline set yet (e.g. freshly activated collar).
   */
  nextUpdateExpectedBy?: Maybe<Scalars['DateTime']['output']>;
  /** Current ongoing activity (walk or rest). Null when no activity is resolvable. */
  ongoingActivity?: Maybe<PetLiveStateOngoingActivity>;
  /**
   * Consolidated collar online/offline state (see CollarOnlineState), resolved across the pet's
   * devices: the primary, or the secondary when the primary is offline and the secondary is online.
   * Per-device states are on `DeviceSummary.onlineState`.
   */
  onlineState: CollarOnlineState;
  /**
   * Offline with the last known battery at or below the out-of-battery threshold — distinguishes a
   * dead-battery collar from one that may still recover. False when online. Consolidated across the
   * pet's devices, matching `onlineState`.
   */
  outOfBattery: Scalars['Boolean']['output'];
  /** The user currently accompanying the pet (e.g. on a walk). Null when nobody is. */
  presentUser?: Maybe<StrangerUser>;
  /**
   * The pet's primary device. Null only when the caller lacks access (e.g. no subscription)
   * or the pet has no device assigned.
   */
  primaryDevice?: Maybe<DeviceSummary>;
  /** The pet's secondary device, if one is assigned. Null otherwise. */
  secondaryDevice?: Maybe<DeviceSummary>;
  streetAddress?: Maybe<Scalars['String']['output']>;
};

/**
 * Snapshot of the pet's currently ongoing activity (walk or rest). Null when the pet has
 * no resolvable activity yet (e.g. freshly activated collar with no reports).
 */
export type PetLiveStateOngoingActivity = {
  __typename?: 'PetLiveStateOngoingActivity';
  /** Cumulative distance (meters) for the current walk. Zero when resting. */
  distanceMeters: Scalars['Float']['output'];
  /** True when the walk's step count is unreliable and should be suppressed (e.g. an Ultra-only walk). */
  excludeStepCount: Scalars['Boolean']['output'];
  /** True when the pet is on a walk; false when resting. */
  isWalking: Scalars['Boolean']['output'];
  /**
   * False when `start` is not meaningful as an elapsed duration — the pet is travelling, or has
   * left the center of its rest and segmentation hasn't opened the successor segment yet. Clients
   * showing "<place> for <duration>" must hide the duration when this is false; `start` still
   * refers to the segment that is open right now.
   */
  shouldShowDuration: Scalars['Boolean']['output'];
  start: Scalars['DateTime']['output'];
  /** Cumulative step count for the current activity. */
  steps: Scalars['Int']['output'];
  /** Ordered trail of positions for the current walk. Empty when resting. */
  walkTrail: Array<Position>;
};

export enum PetNotificationMode {
  SENSITIVE = 'SENSITIVE',
  SMART = 'SMART',
}

export type PetNotificationSetting = {
  __typename?: 'PetNotificationSetting';
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  id: Scalars['ID']['output'];
  pushEligible: Scalars['Boolean']['output'];
  pushEnabled: Scalars['Boolean']['output'];
  settingType: PetNotificationSettingType;
  smsEligible: Scalars['Boolean']['output'];
  smsEnabled: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export enum PetNotificationSettingCategory {
  COLLAR_ALERTS = 'COLLAR_ALERTS',
  MEMBERSHIP = 'MEMBERSHIP',
  SOCIAL = 'SOCIAL',
}

export type PetNotificationSettingInput = {
  pushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  settingType: PetNotificationSettingType;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PetNotificationSettingType {
  BATTERY = 'BATTERY',
  BIRTHDAY_CARD = 'BIRTHDAY_CARD',
  END_OF_OUTSIDE_TIME = 'END_OF_OUTSIDE_TIME',
  END_OF_WALK = 'END_OF_WALK',
  ESCAPE = 'ESCAPE',
  FOLLOWED = 'FOLLOWED',
  FOLLOWED_PET_PHOTO_ADDED = 'FOLLOWED_PET_PHOTO_ADDED',
  FOLLOWED_PET_TEXT_ADDED = 'FOLLOWED_PET_TEXT_ADDED',
  FOLLOWED_PET_VIDEO_ADDED = 'FOLLOWED_PET_VIDEO_ADDED',
  LIVE_SHARING_REMINDER = 'LIVE_SHARING_REMINDER',
  MODULE_OFFLINE = 'MODULE_OFFLINE',
  NEARBY_PET_JOINED_FI = 'NEARBY_PET_JOINED_FI',
  NEW_PETS_JOINED_PACK = 'NEW_PETS_JOINED_PACK',
  OUTSIDE_TIME_LIKE = 'OUTSIDE_TIME_LIKE',
  PET_DOCUMENTS_UPLOADED = 'PET_DOCUMENTS_UPLOADED',
  PHOTO_COMMENT = 'PHOTO_COMMENT',
  PHOTO_LIKE = 'PHOTO_LIKE',
  PLAN_RESUMED = 'PLAN_RESUMED',
  PLAN_WILL_PAUSE = 'PLAN_WILL_PAUSE',
  RANKING = 'RANKING',
  REALTIME_BEHAVIOR_FEEDBACK = 'REALTIME_BEHAVIOR_FEEDBACK',
  SAFE_ZONE = 'SAFE_ZONE',
  SEARCH_PARTY_NEARBY = 'SEARCH_PARTY_NEARBY',
  SEARCH_PARTY_RECOVERY = 'SEARCH_PARTY_RECOVERY',
  STREAK = 'STREAK',
  TEXT_POST_COMMENT = 'TEXT_POST_COMMENT',
  TEXT_POST_LIKE = 'TEXT_POST_LIKE',
  VIDEO_POST_COMMENT = 'VIDEO_POST_COMMENT',
  VIDEO_POST_LIKE = 'VIDEO_POST_LIKE',
  WALK_LIKE = 'WALK_LIKE',
  WALK_WITH_OWNER = 'WALK_WITH_OWNER',
  WEAR_TIME = 'WEAR_TIME',
  WEEK_IN_REVIEW = 'WEEK_IN_REVIEW',
}

export enum PetRankFilter {
  AGE = 'AGE',
  BREED = 'BREED',
}

export type PetSnoozeStatus = {
  __typename?: 'PetSnoozeStatus';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  status: PetSnoozeStatusType;
};

/**
 * State flow:
 *
 *   DISABLED -> ENABLING -> ENABLED -> DISABLING -> DISABLED
 *                  |                       |
 *                  v                       v
 *            ENABLING_FAILED         DISABLING_FAILED
 *
 * Non-Ultra devices skip ENABLING/DISABLING and go directly to ENABLED/DISABLED.
 */
export enum PetSnoozeStatusType {
  DISABLED = 'DISABLED',
  DISABLING = 'DISABLING',
  DISABLING_FAILED = 'DISABLING_FAILED',
  ENABLED = 'ENABLED',
  ENABLING = 'ENABLING',
  ENABLING_FAILED = 'ENABLING_FAILED',
}

export type PetState = {
  __typename?: 'PetState';
  activityType?: Maybe<ActivityType>;
  atPOI?: Maybe<DogPark>;
  atPlace?: Maybe<Place>;
  connectedUser?: Maybe<User>;
};

export type PetStreakBonusSummary = {
  __typename?: 'PetStreakBonusSummary';
  bonuses: Array<PetDailyGoalStreakBonus>;
  daysUntilNextBonus: Scalars['Int']['output'];
};

export type PetUpdate = {
  __typename?: 'PetUpdate';
  changeType: PetChangeType;
};

export type PhoneConfig = {
  __typename?: 'PhoneConfig';
  /** Countries allowed for phone number entry and display in the picker. */
  allowedCountries: Array<PhoneCountry>;
  /**
   * The country preselected in the phone number picker.
   *
   * Resolution order:
   * 1) Explicit locale setting in user preferences
   * 2) Header-derived country (X-Locale-Region or Accept-Language)
   * 3) Fallback to US
   *
   * Must always be one of `allowedCountries`.
   */
  defaultCountry: PhoneCountry;
};

export type PhoneCountry = {
  __typename?: 'PhoneCountry';
  callingCode: Scalars['String']['output'];
  country: FiCountry;
  countryName: Scalars['String']['output'];
  flagEmoji: Scalars['String']['output'];
};

export type PhoneSupport = {
  __typename?: 'PhoneSupport';
  /** The name of the digital support line in ZenDesk. */
  digitalSupportLineName?: Maybe<Scalars['String']['output']>;
  /** Indicates that user is eligible for phone support. Note that they may still require upgrade. */
  eligibleForSupport: Scalars['Boolean']['output'];
  /**
   * Phone support number.
   *
   * If null, indicates the user has no phone support option.
   */
  phoneSupportNumber?: Maybe<Scalars['String']['output']>;
  /** If true, the client should display the upgrade flow, rather than directly calling. */
  shouldPromptUpgrade: Scalars['Boolean']['output'];
  /** URL to open in webview for upgrade flow if applicable. */
  upgradeWebviewUrl?: Maybe<Scalars['String']['output']>;
};

export type Photo = {
  __typename?: 'Photo';
  aspectRatio: AspectRatio;
  caption?: Maybe<Scalars['String']['output']>;
  comments: CommentFeed;
  date: Scalars['DateTime']['output'];
  /** Admin-only */
  dbId: Scalars['Int']['output'];
  deleted: Scalars['Boolean']['output'];
  externalLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: Image;
  isCommunityPhoto?: Maybe<Scalars['Boolean']['output']>;
  likeCount: Scalars['Int']['output'];
  /** Whether the current user has liked this photo. */
  liked: Scalars['Boolean']['output'];
  likedByPets: Array<StrangerPet>;
  /** Pet associated with this photo, if any. */
  pet?: Maybe<StrangerPet>;
  poster: PhotoPoster;
  publicShareLink?: Maybe<Scalars['String']['output']>;
  source?: Maybe<PhotoSource>;
};

export type PhotoFeed = {
  __typename?: 'PhotoFeed';
  feed: PaginatedPhotoFeed;
  first?: Maybe<Photo>;
  /**
   * items returns an unbounded list. Instead, please use `feed` which implements our standard paginated feed interface
   * @deprecated Use `feed` instead
   */
  items: Array<Photo>;
};

export type PhotoFeedfeedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type PhotoPoster = ExternalUser | StrangerUser;

export enum PhotoSource {
  APP = 'APP',
  IG_HASHTAG = 'IG_HASHTAG',
  IG_PROFILE_TAG = 'IG_PROFILE_TAG',
}

export type PhotoUpdatesInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated */
  isCommunityPhoto?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PiiCategory {
  address = 'address',
  email = 'email',
  name = 'name',
  phone = 'phone',
}

export type Place = {
  __typename?: 'Place';
  address?: Maybe<Scalars['String']['output']>;
  /** Should only be populated for polygon safe-zones. */
  boundary?: Maybe<Scalars['JSON']['output']>;
  cityState?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Array<Position>>;
  /**
   * If null, then this was created via the first-party Fi App.
   * If set, indicates which third party created the Place (e.g. 'verizon').
   */
  createdByThirdParty?: Maybe<Scalars['String']['output']>;
  dbId: Scalars['Int']['output'];
  geocodeAddress?: Maybe<Scalars['String']['output']>;
  householdId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Whether this place is a temporary Quick Zone. */
  isQuickZone: Scalars['Boolean']['output'];
  mapUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  neighborhood?: Maybe<Scalars['String']['output']>;
  position: Position;
  /** Original TTL in seconds for display purposes. Null for regular safe zones. */
  quickZoneDurationSeconds?: Maybe<Scalars['Int']['output']>;
  /** When this Quick Zone expires. Null for regular safe zones. */
  quickZoneExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Circle safe-zones have a real value here.
   * Polygon safe-zones have a hardcoded fake value (clients should ignore).
   */
  radius: Scalars['Float']['output'];
  /** Containment zone for sound feedback. Null if no sound zone is configured. */
  soundZone?: Maybe<ContainmentZone>;
  /** Allows clients to differentiate between circle and polygon safe-zones. */
  type: PlaceType;
  /** Containment zone for vibration feedback. Null if no vibration zone is configured. */
  vibrationZone?: Maybe<ContainmentZone>;
};

export type PlacemapUrlArgs = {
  colorScheme?: InputMaybe<ColorScheme>;
  height: Scalars['Int']['input'];
  minimumPadding?: InputMaybe<PaddingInput>;
  scale?: InputMaybe<Scalars['Int']['input']>;
  style?: InputMaybe<MapStyle>;
  width: Scalars['Int']['input'];
};

export enum PlaceType {
  CIRCLE = 'CIRCLE',
  POLYGON = 'POLYGON',
}

export type PlanMini = {
  __typename?: 'PlanMini';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
};

export type Platform = {
  __typename?: 'Platform';
  archived: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  updateChannels: Array<FirmwareUpdateChannel>;
};

export type Play = Activity & {
  __typename?: 'Play';
  address?: Maybe<Scalars['String']['output']>;
  allPositionsForDebug?: Maybe<Array<Position>>;
  areaName?: Maybe<Scalars['String']['output']>;
  cityState?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use likeCount */
  clapCount: Scalars['Int']['output'];
  dbId: Scalars['Int']['output'];
  debugMetadata: Scalars['JSON']['output'];
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use isLikable */
  isClappable: Scalars['Boolean']['output'];
  isLikable: Scalars['Boolean']['output'];
  likeCount: Scalars['Int']['output'];
  mapUrl: Scalars['String']['output'];
  neighborhood?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  obfuscated: Scalars['Boolean']['output'];
  overallStepsPerMinuteForDebug: Scalars['Float']['output'];
  place?: Maybe<Place>;
  position: Position;
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']['output']>;
  start: Scalars['DateTime']['output'];
  totalSteps: Scalars['Int']['output'];
};

export type PlaymapUrlArgs = {
  colorScheme?: InputMaybe<ColorScheme>;
  height: Scalars['Int']['input'];
  scale?: InputMaybe<Scalars['Int']['input']>;
  style?: InputMaybe<MapStyle>;
  width: Scalars['Int']['input'];
};

export enum PlmnListMode {
  ALLOWED = 'ALLOWED',
  DISALLOWED = 'DISALLOWED',
}

export type PlmnProfile = {
  __typename?: 'PlmnProfile';
  mode: PlmnListMode;
  /** PLMNs in MCCMNC format (5 or 6 digits), at most 10. */
  plmns: Array<Scalars['String']['output']>;
};

export type PlmnProfileInput = {
  mode: PlmnListMode;
  plmns: Array<Scalars['String']['input']>;
};

export enum PlmnProfileSupport {
  /** Either a list of allowed PLMNs or a list of disallowed PLMNs (never both), up to 10 entries. */
  ALLOWED_OR_DISALLOWED_LIST = 'ALLOWED_OR_DISALLOWED_LIST',
  /** Firmware ignores BasicResponse.plmn_profile. */
  NONE = 'NONE',
  /** Only a single allowed PLMN can be set (Ultra). */
  SINGLE_ALLOWED_PLMN = 'SINGLE_ALLOWED_PLMN',
}

export type PointInTimeEvent = {
  time: Scalars['DateTime']['output'];
};

export type PoorLTEConnectivityDeviceInfo = LowLTESignalDeviceInfo | NoLTEConnectivityDeviceInfo;

export type Position = {
  __typename?: 'Position';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

/**
 * Preview of position-based discount for a subscription cart item.
 * Shows the user what discount they'll receive based on their subscription position.
 */
export type PositionDiscountPreview = {
  __typename?: 'PositionDiscountPreview';
  /** Cart item ID this preview applies to */
  cartItemId: Scalars['String']['output'];
  /** Discount percentage (0 for position 1, 10 for position 2, 15 for position 3+) */
  discountPercent: Scalars['Int']['output'];
  /** Whether the user is enrolled in the position discount experiment */
  isEnrolled: Scalars['Boolean']['output'];
  /** 1-indexed position of this subscription (1st collar, 2nd collar, etc.) */
  position: Scalars['Int']['output'];
};

export type PositionInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type PowerStateChangeDeviceEvent = DeviceEventBase & {
  __typename?: 'PowerStateChangeDeviceEvent';
  date: Scalars['DateTime']['output'];
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  moduleId: Scalars['String']['output'];
  new: DevicePowerState;
  old: DevicePowerState;
  platform: Scalars['String']['output'];
};

export enum PreSignedUploadPurpose {
  COMMUNITY_VIDEO_POST = 'COMMUNITY_VIDEO_POST',
  PET_DOCUMENT = 'PET_DOCUMENT',
}

export type PreSignedUploadUrl = {
  __typename?: 'PreSignedUploadUrl';
  expiration: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PreSignedUploadUrlInput = {
  contentType: Scalars['String']['input'];
  purpose: PreSignedUploadPurpose;
};

export type PreviewConsignmentChargeInput = {
  amountInCents: Scalars['Int']['input'];
  consignmentAccountId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  ecomConfigType?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Recurly item code to preview against; must be one of `adminConsignmentChargeSkus`. */
  sku: Scalars['String']['input'];
  taxExempt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PreviewDiscountCredit = {
  __typename?: 'PreviewDiscountCredit';
  cartItemId: Scalars['String']['output'];
  creditAmountInCents: Scalars['Int']['output'];
  creditReason: Scalars['String']['output'];
};

/** Line item from invoice preview */
export type PreviewLineItem = {
  __typename?: 'PreviewLineItem';
  /** Final amount in dollars (after discounts) */
  amountInDollars: Scalars['Float']['output'];
  /** Description of the line item */
  description: Scalars['String']['output'];
  /** Discount applied in dollars */
  discountInDollars: Scalars['Float']['output'];
  /** Quantity */
  quantity: Scalars['Int']['output'];
  /** Line item SKU/product code */
  sku: Scalars['String']['output'];
  /** Subtotal in dollars (before discounts) */
  subtotalInDollars: Scalars['Float']['output'];
  /** Unit amount in dollars */
  unitAmountInDollars: Scalars['Float']['output'];
};

export type PreviewMembershipUpgradeResult = {
  __typename?: 'PreviewMembershipUpgradeResult';
  appliedAccountBalanceInCents: Scalars['Int']['output'];
  appliedDiscountInCents: Scalars['Int']['output'];
  proratedCreditAmountInCents: Scalars['Int']['output'];
  subtotalInCents: Scalars['Int']['output'];
  taxInCents: Scalars['Int']['output'];
  totalInCents: Scalars['Int']['output'];
};

export type PreviewPurchaseResult = {
  __typename?: 'PreviewPurchaseResult';
  activationFeesInCents: Scalars['Int']['output'];
  appliedDiscountInCents: Scalars['Int']['output'];
  shippingInCents: Scalars['Int']['output'];
  subtotalInCents: Scalars['Int']['output'];
  taxInCents: Scalars['Int']['output'];
  totalInCents: Scalars['Int']['output'];
};

export type PreviewRenewAndSaveResult = {
  __typename?: 'PreviewRenewAndSaveResult';
  subtotalInCents: Scalars['Int']['output'];
  taxInCents: Scalars['Int']['output'];
  totalInCents: Scalars['Int']['output'];
};

export type PreviewSubscriptionResult = {
  __typename?: 'PreviewSubscriptionResult';
  activationFeeInCents?: Maybe<Scalars['Int']['output']>;
  couponAmountInCents?: Maybe<Scalars['Int']['output']>;
  /** Positive integer indicating the value of the gift card, if one was applied. */
  giftCardAmountInCents?: Maybe<Scalars['Int']['output']>;
  taxInCents: Scalars['Int']['output'];
  totalInCents: Scalars['Int']['output'];
  /**
   * Recurring charges grouped by the schedule fields on `RecurringCharge` — `interval`,
   * `intervalCount`, and `freeTrialDays`. Consumers may therefore receive multiple entries with the
   * same `interval`. Consumed by Apple Pay's recurringPaymentRequest so the payment sheet can
   * display line items (e.g. "$X every 3 months starting …") and obtain a recurring billing token.
   */
  totalRecurringCharges: Array<RecurringCharge>;
  /**
   * The activation fee amount that was waived, in cents. Present when a lapsed subscription customer
   * reactivates on the month-to-month plan.
   */
  waivedActivationFeesInCents?: Maybe<Scalars['Int']['output']>;
};

export type PreviewUpgradeToSeriesThreePlusModuleResult = {
  __typename?: 'PreviewUpgradeToSeriesThreePlusModuleResult';
  shippingInCents: Scalars['Int']['output'];
  subtotalInCents: Scalars['Int']['output'];
  taxInCents: Scalars['Int']['output'];
  totalInCents: Scalars['Int']['output'];
};

export type PreviewUpgradeToUltraResult = {
  __typename?: 'PreviewUpgradeToUltraResult';
  activationFeesInCents: Scalars['Int']['output'];
  appliedDiscountInCents: Scalars['Int']['output'];
  cartItemCredits: Array<PreviewDiscountCredit>;
  shippingInCents: Scalars['Int']['output'];
  subtotalInCents: Scalars['Int']['output'];
  taxInCents: Scalars['Int']['output'];
  totalInCents: Scalars['Int']['output'];
};

export type PricingByCurrency = {
  __typename?: 'PricingByCurrency';
  CAD?: Maybe<Scalars['Int']['output']>;
  CHF?: Maybe<Scalars['Int']['output']>;
  DKK?: Maybe<Scalars['Int']['output']>;
  EUR?: Maybe<Scalars['Int']['output']>;
  GBP?: Maybe<Scalars['Int']['output']>;
  ISK?: Maybe<Scalars['Int']['output']>;
  NOK?: Maybe<Scalars['Int']['output']>;
  RON?: Maybe<Scalars['Int']['output']>;
  SEK?: Maybe<Scalars['Int']['output']>;
  TRY?: Maybe<Scalars['Int']['output']>;
  USD: Scalars['Int']['output'];
};

export type Principal = {
  __typename?: 'Principal';
  capabilities: Array<PrincipalCapability>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  permissions: Array<AdminPermission>;
  unmaskedPiiCategories: Array<PiiCategory>;
};

export enum PrincipalCapability {
  ADMIN = 'ADMIN',
  CHARGEBACK_DISPUTE_RESOLUTION = 'CHARGEBACK_DISPUTE_RESOLUTION',
  CREATE_ORDERS = 'CREATE_ORDERS',
  CREATE_TEST_DATA = 'CREATE_TEST_DATA',
  CUSTOMER_SUPPORT = 'CUSTOMER_SUPPORT',
  FEATURE_FLAG_READ = 'FEATURE_FLAG_READ',
  FICOMMERCE = 'FICOMMERCE',
  FIRMWARE_PROD = 'FIRMWARE_PROD',
  FIRMWARE_TEST = 'FIRMWARE_TEST',
  FI_MOBILE_SDK_PROD = 'FI_MOBILE_SDK_PROD',
  FI_MOBILE_SDK_TEST = 'FI_MOBILE_SDK_TEST',
  IMPORT_ORDERS = 'IMPORT_ORDERS',
  IN_APP_CONTENT_AUTHORING = 'IN_APP_CONTENT_AUTHORING',
  IN_APP_CONTENT_VIEWER = 'IN_APP_CONTENT_VIEWER',
  NEWS_NOTIFICATION = 'NEWS_NOTIFICATION',
  PUBLIC_PET_PROFILE = 'PUBLIC_PET_PROFILE',
  RMA = 'RMA',
  VERIZON_PROD = 'VERIZON_PROD',
  VERIZON_REPORTING_PROD = 'VERIZON_REPORTING_PROD',
  VERIZON_REPORTING_TEST = 'VERIZON_REPORTING_TEST',
  VERIZON_TEST = 'VERIZON_TEST',
}

export type Product = {
  __typename?: 'Product';
  /** Decompose into component pieces given the input sub item codes. */
  decompose: Array<Product>;
  description: Scalars['String']['output'];
  eligibleForRma: Scalars['Boolean']['output'];
  flagExchangeForProductReturn: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  optionsForRequiredBundledSubscription: Array<SubscriptionOption>;
  /**
   * Every SKU that resolves back to this product — its base SKU plus the kit, international,
   * third-party, and refurb-tier ship SKUs it owns. Mirrors the backend `productsBySku` reverse
   * map so callers can resolve a shipped or order-history SKU to its product.
   */
  ownedSkus: Array<Scalars['String']['output']>;
  priceInCents: Scalars['Int']['output'];
  /**
   * When this is a physical product subscription, product to ship will be the product
   * that is shipped to the customer.
   */
  productToShip?: Maybe<Product>;
  rmaProductCategory?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  subItems: Array<ReturnsTrackerSubItem>;
};

export type ProductdecomposeArgs = {
  rmaInput?: InputMaybe<ProductDecomposeRMAInput>;
  subItemCodes: Array<Scalars['String']['input']>;
};

export type ProductoptionsForRequiredBundledSubscriptionArgs = {
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  onlyAvailable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** These are product features that are available for the given parent entity */
export enum ProductAvailability {
  ACTIVE_TIME = 'ACTIVE_TIME',
  APPLE_WATCH = 'APPLE_WATCH',
  BEHAVIOR_DETECTION = 'BEHAVIOR_DETECTION',
  BEHAVIOR_DETECTION_UPGRADE = 'BEHAVIOR_DETECTION_UPGRADE',
  DOG_PARKS = 'DOG_PARKS',
  HEALTH = 'HEALTH',
  HEALTH_AI = 'HEALTH_AI',
  HEALTH_OVERVIEW = 'HEALTH_OVERVIEW',
  OUTSIDE_TIME = 'OUTSIDE_TIME',
  RANK = 'RANK',
  REST = 'REST',
  STEPS = 'STEPS',
  STRAIN = 'STRAIN',
  SUPPLEMENTS = 'SUPPLEMENTS',
  /**
   * Walk Tracking vs Outside Time Tracking differentiates between a cosmetic treatment applied to "walk" segments where cats
   * will consider such a segment as "outside time" and dogs will consider as "walk".
   */
  WALKS = 'WALKS',
}

export type ProductDecomposeRMAInput = {
  drilldownCode: Scalars['String']['input'];
  processType: RMAProcessType;
  reasonCode: Scalars['String']['input'];
  /**
   * Optional rescue-context signal. When the serial number resolves to a device that is currently
   * with a rescue household, the backend substitutes the refurbished `-RA` SKU for each post-
   * decompose component whenever the refurb is in stock at any active warehouse, falling back to
   * the new-stock SKU on OOS. See `isRescueObtainedDevice` for the detection details.
   */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ProductInventoryLevel = {
  __typename?: 'ProductInventoryLevel';
  /** @deprecated Will no longer be used */
  allowAutoMarkOutOfStock: Scalars['Boolean']['output'];
  /** @deprecated Query inventoryConfigurations instead */
  eligibleForJustInTimeKitting: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Will no longer be used */
  inStock: Scalars['Boolean']['output'];
  inStockAtAnyWarehouse: Scalars['Boolean']['output'];
  /** @deprecated Query inventoryConfigurations instead */
  justInTimeKittingEnabled: Scalars['Boolean']['output'];
  /** @deprecated Will no longer be used */
  manualInventoryAdjustment: Scalars['Int']['output'];
  /** @deprecated Will no longer be used */
  outOfStockThreshold: Scalars['Int']['output'];
  productDescription?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use sources instead */
  quantityAvailable: Scalars['Int']['output'];
  /** @deprecated Use sources instead */
  quantityInStock: Scalars['Int']['output'];
  /** @deprecated Use sources instead */
  quantityPending: Scalars['Int']['output'];
  /** @deprecated Use sources instead */
  quantityReserved: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  sources: Array<WarehouseInventoryLevel>;
};

export type ProductInventoryLevels = {
  __typename?: 'ProductInventoryLevels';
  activeWarehouses: Array<FulfillmentWarehouse>;
  configurations: Array<InventoryConfiguration>;
  dateLastUpdated: Scalars['DateTime']['output'];
  levels: Array<ProductInventoryLevel>;
};

export type ProductTransferPreview = {
  __typename?: 'ProductTransferPreview';
  accountCode: Scalars['String']['output'];
  /** resolved currency for the user's region */
  currency: Currency;
  /** Before waiver */
  hardwareFeeInCents: Scalars['Int']['output'];
  hardwareFeeWaived: Scalars['Boolean']['output'];
  /** totalCharge - totalCredit */
  netChargeInCents: Scalars['Int']['output'];
  /** prepay charge amount (0 if no prepay selected) */
  prepayChargeInCents: Scalars['Int']['output'];
  /** number of months to extend subscription (0 if no prepay) */
  prepayMonths: Scalars['Int']['output'];
  totalChargeInCents: Scalars['Int']['output'];
  totalCreditInCents: Scalars['Int']['output'];
  transfers: Array<TransferPreviewItem>;
};

export type ProductTransferPreviewInput = {
  accountCode: Scalars['String']['input'];
  /** Moves an existing membership onto hardware the customer already holds. No hardware fee, no prepay. */
  hardwareAlreadyDelivered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Overrides default hardware fee */
  hardwareFeeAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  /** Membership prepay option - charges upfront and extends subscription date */
  prepayOption?: InputMaybe<MembershipPrepayOption>;
  transfers: Array<DeviceTransferInput>;
  waiveHardwareFee?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Result of executing a product transfer. */
export type ProductTransferResult = {
  __typename?: 'ProductTransferResult';
  /** Invoice number (hardware fee for SKU-only, membership for prorated upgrades) */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** Order ID for hardware fulfillment (only present when new hardware needs to ship) */
  orderId?: Maybe<Scalars['Int']['output']>;
  /** amount charged for membership prepay (0 if no prepay) */
  prepayChargeInCents: Scalars['Int']['output'];
  /** error message if prepay charge failed after transfer was already committed */
  prepayError?: Maybe<Scalars['String']['output']>;
  /** invoice number for prepay charge (null if no prepay) */
  prepayInvoiceNumber?: Maybe<Scalars['String']['output']>;
  /** True if all transfers succeeded */
  success: Scalars['Boolean']['output'];
  /** Total amount charged in cents */
  totalChargedInCents: Scalars['Int']['output'];
  /** Results for each device transfer */
  transfers: Array<TransferResultItem>;
};

/**
 * Type of product transfer flow.
 * PRORATED_UPGRADE: For S1/S2 → S3+/Mini. Old subscription is terminated with prorated credit.
 * SKU_ONLY: For S3 → S3+ and Mini ↔ S3+. Only the subscription plan code changes.
 */
export enum ProductTransferType {
  PRORATED_UPGRADE = 'PRORATED_UPGRADE',
  SKU_ONLY = 'SKU_ONLY',
}

export type Promotion = {
  __typename?: 'Promotion';
  /** ISO-2 country codes where this promotion applies. Null means all countries. */
  countries?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Hours the promotion keeps running past `end`, showing its extension copy with
   * a countdown reset to the new deadline. 0 means no extension.
   */
  extensionHours: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  internalName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  start?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  variants: Scalars['JSON']['output'];
};

/**
 * Pet that exists in the boarding facility's third-party platform but is not yet tied to a Fi pet because they have not
 * been checked into a boarding facility on the Fi app.
 */
export type ProspectiveBoardingPet = {
  __typename?: 'ProspectiveBoardingPet';
  name: Scalars['String']['output'];
  owner: BoardingFacilityContact;
  profilePicture?: Maybe<Image>;
  thirdPartyAgeFormatted: Scalars['String']['output'];
  /**
   * This breed comes from the third-party platform and may not map to our own breeds so we use a string
   * instead of the Breed type.
   */
  thirdPartyBreedName: Scalars['String']['output'];
  /** The ID of the pet in the boarding facility's third-party platform. */
  thirdPartyPetId: Scalars['ID']['output'];
  /** The next upcoming reservation time for the pet. */
  upcomingReservationTime?: Maybe<Scalars['DateTime']['output']>;
};

export type PublicProfileSharing = {
  __typename?: 'PublicProfileSharing';
  url?: Maybe<Scalars['String']['output']>;
};

export type PurchaseResultInvoice = {
  __typename?: 'PurchaseResultInvoice';
  number: Scalars['String']['output'];
};

export type PurchaseSubscriptionInput = {
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  marketingEmailsOptedIn?: InputMaybe<Scalars['Boolean']['input']>;
  moduleId: Scalars['ID']['input'];
  redeemGiftCard?: InputMaybe<RedeemGiftCardInput>;
  sku: Scalars['ID']['input'];
  threeDSecureActionResultToken?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /**
   * The live shop hardware-first promo for the account's country, for applying to an admin
   * product charge. Null when no such promo is currently running.
   * Requires: Admin or Customer Support role
   */
  activeHardwarePromoForAccount?: Maybe<ActiveHardwarePromo>;
  admin: Admin;
  /**
   * Exemption certificates filed against an Avalara customer code. Used by E2E
   * tests to assert the cert was actually filed in the expected exposure zone. Admin-only.
   */
  adminAvalaraCertsForCustomer: Array<AvalaraCertSummary>;
  adminBoardingFacilities: Array<BoardingFacility>;
  adminBoardingFacility: BoardingFacility;
  /**
   * Admin query: returns all breeds with translations for a given species.
   * If no species is provided, returns all DOG breeds.
   */
  adminBreeds: Array<Breed>;
  /**
   * Live BullMQ queue stats for a Fi worker queue. Used by E2E tests to assert that
   * the Avalara worker is processing jobs (not silently dropping them). Admin-only.
   */
  adminBullMqQueueStats: BullMqQueueStats;
  adminConsignmentAccount?: Maybe<ConsignmentAccount>;
  /** Recurly invoices for a consignment account. Fetches directly from Recurly API. Admin-only. */
  adminConsignmentAccountInvoices: Array<ConsignmentInvoiceEntry>;
  /**
   * Shipment history for a consignment account: orders shipped to this account's locations,
   * with line items summary and tracking per package. One row per package (or one row per order when no packages yet).
   * Admin-only.
   */
  adminConsignmentAccountShipmentHistory: Array<ConsignmentShipmentHistoryEntry>;
  adminConsignmentAccounts: Array<ConsignmentAccount>;
  adminConsignmentAvailableSkus: Array<ConsignmentAvailableSku>;
  /** Charge-tool SKUs available in the admin Create Charge dropdown. Admin-only. */
  adminConsignmentChargeSkus: Array<ConsignmentChargeSku>;
  adminConsignmentLocation?: Maybe<ConsignmentLocation>;
  adminDeviceActuations: AdminDeviceActuationsResult;
  adminDeviceHealthStatistics: AdminDeviceHealthStatisticsResult;
  adminEvalClassificationTaxonomy: Array<EvalClassification>;
  adminEvalGuidelineHistory: Array<EvalGuideline>;
  adminEvalGuidelines: Array<EvalGuideline>;
  adminEvalResultForMessage?: Maybe<EvalResult>;
  /**
   * Fetch GrowthBook experiment enrollments for a pet from Databricks analytics events.
   * Returns experiments the pet has been enrolled in within the specified day window.
   */
  adminExperimentEnrollmentsForPet: Array<ExperimentEnrollment>;
  /**
   * Fetch GrowthBook experiment enrollments for a user from Databricks analytics events.
   * Returns experiments the user has been enrolled in within the specified day window.
   */
  adminExperimentEnrollmentsForUser: Array<ExperimentEnrollment>;
  /** Targeted Feature Flags */
  adminGetAllTargetedFeatureFlags: Array<AdminTargetedFeatureFlag>;
  adminGetAllTranslations: Array<TranslationRecord>;
  /** Change Logs across products */
  adminGetChangeLog: ChangeLog;
  adminGetChangeLogs: ChangeLogs;
  /** Presigned URL to download the consignment account's consignment agreement. Admin-only. Null if no file. */
  adminGetConsignmentAgreementDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** Presigned URL to upload a consignment agreement file for the given account. Admin-only. */
  adminGetConsignmentAgreementUploadUrl: PreSignedUploadUrl;
  /** Full URL for the partner setup page (token included). Admin-only. Use for the partner link. */
  adminGetConsignmentPartnerSetupUrl: Scalars['String']['output'];
  /** Presigned URL to download the consignment account's resale certificate. Admin-only. */
  adminGetConsignmentResaleCertificateUrl?: Maybe<Scalars['String']['output']>;
  adminGetDismissedMobileAppContent: Array<DismissedMobileAppContent>;
  adminGetDogParkCheckinExclusionsByDogPark: Array<AdminDogParkCheckinExclusion>;
  /** Dog park checkin exclusions */
  adminGetDogParkCheckinExclusionsByPet: Array<AdminDogParkCheckinExclusion>;
  adminGetHealthGptConfig: AdminHealthGptConfig;
  /** Get a single HealthGPT message by integer ID, encoded UUID, or raw UUID. */
  adminGetHealthGptMessage: AdminHealthGptMessage;
  adminGetHealthGptThreadMessages: Array<AdminHealthGptMessage>;
  adminGetHealthGptThreadsForUser: Array<AdminHealthGptThread>;
  /** Metadata for the object at `path`, or null if nothing exists there. Use to warn before overwriting. */
  adminGetMediaAsset?: Maybe<AdminMediaAsset>;
  /**
   * Returns the full edit history for a piece of mobile app content, newest first.
   * Each entry is a full snapshot of the content at the time of the change.
   */
  adminGetMobileAppContentAuditTrail: Array<AdminMobileAppContentAuditEntry>;
  adminGetPetDocumentsUploadedByUserId: Array<AdminPetDocument>;
  /**
   * Admin Get a Pre-Signed URL for File Upload
   * This is a global mutation that can be used to get a pre-signed URL for any supported purpose
   */
  adminGetPreSignedUploadUrl: PreSignedUploadUrl;
  /** Saved by Fi — community stories moderation queue. Pass `status` to filter, omit to see all. */
  adminGetRescueStories: RescueStories;
  adminGetRescueStory: RescueStory;
  adminGetTargetedFeatureFlag?: Maybe<AdminTargetedFeatureFlag>;
  adminGetTargetedFeatureFlagAuditTrail: Array<AdminTargetedFeatureFlag>;
  adminGetTargetedFeatureFlagTargetingFacts: Array<MobileAppContentTargetingFact>;
  adminGetTranslationByKey?: Maybe<TranslationRecord>;
  adminGetVipUserLookupCriteria: Array<VipUserLookupCriteria>;
  adminGetVisibleMobileAppContent: MobileAppContent;
  adminGoldenQuestion?: Maybe<GoldenQuestion>;
  adminGoldenQuestionRun?: Maybe<GoldenQuestionRun>;
  adminGoldenQuestionRunComparison: GoldenQuestionRunComparison;
  adminGoldenQuestionRuns: Array<GoldenQuestionRun>;
  adminGoldenQuestions: Array<GoldenQuestion>;
  adminHealthGptGetDocument: AdminHealthGptDocument;
  adminHealthGptGetDocuments: Array<AdminHealthGptDocument>;
  /**
   * Fi Intelligence memories for admin/CX inspection. Filter by pet, by member, or the exact
   * (pet, member) scope; returns all statuses (incl. SUPERSEDED/REJECTED) newest-first. Requires
   * at least one of petId/userId.
   */
  adminHealthGptMemories: Array<AdminHealthGptMemory>;
  adminHealthGptPlaybookDataSources: Array<HealthGptPlaybookDataSource>;
  adminHealthGptPlaybookHistory: Array<HealthGptPlaybook>;
  adminHealthGptPlaybooks: Array<HealthGptPlaybook>;
  adminIsShelterluvIntegrationValid: Scalars['Boolean']['output'];
  /**
   * List all invoices for a billing account (admin/CS only).
   * Returns summary data for each invoice — use recurlyInvoice query for full details.
   */
  adminListAccountInvoices: Array<AccountInvoiceSummary>;
  adminListAppIntegrationsForUser: Array<AppIntegration>;
  /**
   * Lists one folder level of the media bucket. `prefix` is a folder path ending in "/" (omit or pass
   * "" for the bucket root).
   */
  adminListMediaAssets: AdminMediaAssetList;
  /**
   * Requires the admin or customer-support capability (same access as
   * Device.adminTimeline). Query the timelines of several devices (e.g. a pet's
   * primary and secondary collar) as a single consistently-windowed page. Unlike
   * issuing one limit/before query per device — whose pages can span wildly
   * different time ranges when report densities differ — every event from every
   * device within [pageInfo.windowStart, pageInfo.windowEnd] is guaranteed to be
   * included.
   */
  adminMergedTimeline: TimelineMergedQueryResult;
  adminNanoIcarIdOnlyClaimStatus?: Maybe<NanoWebIdClaimJobStatus>;
  adminNanoIcarIdRanges: Array<NanoIcarIdRange>;
  adminNanoIcarIdUnclaimedCount: Scalars['Int']['output'];
  /** @deprecated Use adminNanoWebIdOnlyClaimStatus or adminNanoIcarIdOnlyClaimStatus. */
  adminNanoWebIdClaimStatus?: Maybe<NanoWebIdClaimJobStatus>;
  adminNanoWebIdOnlyClaimStatus?: Maybe<NanoWebIdClaimJobStatus>;
  adminOrderFilterCountries: Array<FiCountry>;
  /**
   * OCR a previously-uploaded resale-cert file from S3 and return the four structured fields (or
   * nulls when OCR can't extract a field). Admin-side equivalent of the unauthenticated
   * POST /parse-cert endpoint used by partner self-serve. Does NOT save; admin reviews the result
   * and submits via adminUpdateConsignmentResaleCertFields. Admin-only.
   */
  adminParseConsignmentTaxCert: TaxCertOcrFields;
  /**
   * Preview a one-time charge for a consignment account without charging.
   * Returns line items, tax, and total from Recurly's preview API.
   * Admin-only.
   */
  adminPreviewConsignmentCharge: ChargePreview;
  /** Preview mobile app content with [[KEY]] tokens resolved for a specific locale. */
  adminPreviewMobileAppContentWithLocale?: Maybe<AdminMobileAppContent>;
  adminPreviewOrder: PreviewPurchaseResult;
  /**
   * List product SKUs from the database with optional filters.
   * Requires: Admin or Customer Support role
   */
  adminProductSkus: Array<AdminProductSku>;
  /** Read-only Recurly account state for E2E assertions. Hits Recurly directly. Admin-only. */
  adminRecurlyAccountDebug: RecurlyAccountDebug;
  adminRenderTestDataTemplate: RenderTestDataTemplateResult;
  adminSearchDogParks: DogParkFeed;
  adminSearchPartyTestingInfo: SearchPartyTestingResult;
  adminSearchResellerModules: Array<ResellerModule>;
  /** Translate a piece of text to the given locale using fi-babel. */
  adminTranslateText: Scalars['String']['output'];
  /** Returns keys from the input list that do NOT exist in the translations table. */
  adminValidateTranslationKeys: Array<Scalars['String']['output']>;
  /**
   * Returns all breeds for a given species.
   * If no species is provided, returns all DOG breeds (for backwards compatibility).
   */
  allBreeds: Array<Breed>;
  allDogParks: DogParkFeed;
  /** @deprecated Use allNanoWebIdBatches or allNanoIcarIdBatches. */
  allNanoBatches: Array<NanoWebIdBatchInfo>;
  allNanoIcarIdBatches: Array<NanoBatchSummary>;
  allNanoWebIdBatches: Array<NanoBatchSummary>;
  allNotificationTypes: Array<Scalars['String']['output']>;
  article?: Maybe<Article>;
  articles: Array<Article>;
  assignedChargingBase?: Maybe<ChargingBase>;
  /**
   * Get list of all non-subscription products available for charging
   * Returns products like bands, charging bases, modules, supplements, etc.
   * Excludes subscriptions (use subscription creation flow for those)
   * Requires: Admin or Customer Support role
   */
  availableChargeableProducts: Array<ChargeableProduct>;
  /** @deprecated Used for legacy in-app subscription purchasing. Use Device.purchasableSubscriptionOptions instead. */
  availableSubscriptionOptions: Array<SubscriptionOption>;
  /**
   * Get available subscription plans for a transfer. S1/S2 upgrades limited to 6m/12m/24m plans.
   * Requires: Admin or Customer Support role
   */
  availableTransferPlans: Array<AvailableTransferPlan>;
  birthdayCardForPet: BirthdayCard;
  /**
   * The pets that exist in the boarding facility third-party platform but may not have been checked into the
   * facility on the Fi app.
   */
  boardingFacilityProspectivePets: BoardingFacilityProspectivePetFeed;
  /** Get a boarding pet by its Fi pet ID */
  boardingPet?: Maybe<BoardingPet>;
  /** Paginates through Packs alphabetically. */
  browsePacks: BrowsePacksResponse;
  browsePopularPacks: BrowsePacksResponse;
  chargingBase?: Maybe<ChargingBase>;
  chargingBaseOfflineDateRanges: Array<DateRange>;
  /** @deprecated Charging bases can always be re-assigned */
  checkChargingBaseAssignable: ChargingBaseAssignable;
  checkDeviceAssignable: DeviceAssignable;
  checkFiHandleValidAndAvailable?: Maybe<CheckFiHandleValidAndAvailableResponse>;
  checkForAppUpdatePrompt?: Maybe<AppUpdatePrompt>;
  /**
   * Check how many nearby users could be notified about an active search party.
   *
   * This query filters by mute preferences - only returns users who have not muted all search parties.
   * The count reflects the actual number of users who would receive notifications.
   *
   * Use this query before showing the "Notify Nearby Users" button to the pet owner.
   * If hasUsers is false, the button should be hidden or disabled.
   */
  checkNearbyUsersForSearchParty: NearbyUsersResult;
  /**
   * Check if a device can be transferred to a target platform type.
   * Returns eligibility status, transfer type, and reason if not eligible.
   * Requires: Admin or Customer Support role
   */
  checkTransferEligibility: TransferEligibility;
  chip?: Maybe<BaseChip>;
  chipContactInfoForVerifiedRescue?: Maybe<ChipContactInfoForVerifiedRescue>;
  chipReseller?: Maybe<ChipReseller>;
  clientUrls: ClientUrls;
  contactsForUser: ContactsForUserResponse;
  currentPrincipal: Principal;
  currentUser: User;
  /** Lookup a device by moduleId or dbId. Exactly one of the arguments should be provided. */
  device?: Maybe<Device>;
  /** Device actuation */
  deviceActuationStatus: DeviceActuation;
  /**
   * Fetches a FW update URL for specified module (if update is available). Does
   * not do any household authorization checks, to allow for fetching FW updates
   * for unassigned devices during onboarding.
   */
  deviceFirmwareUpdate?: Maybe<FirmwareUpdate>;
  dogPark?: Maybe<DogPark>;
  dogParkCheckInsForPet: DogParkCheckinFeed;
  dogParkLeaderboard: DogParkVisitorFeed;
  /** @deprecated Dog park notifications were removed. */
  dogParkNotificationSettings?: Maybe<DogParkNotificationSettings>;
  dogParkRequest?: Maybe<DogParkRequest>;
  dogParkRequests: Array<DogParkRequest>;
  /** @deprecated Dog park SMS notifications were never implemented. */
  dogParkShareableSubscriptionText?: Maybe<DogParkShareableSubscriptionText>;
  dynamicEnum: DynamicEnum;
  /**
   * Look up feature flags (including their targeting configuration) by name.
   * Gated on the `feature_flag_read` capability (admins and customer support also
   * pass). Intended for internal release tooling (e.g. sled) that surfaces
   * newly-added flags and whether they're gated. Names not currently defined are
   * omitted from the result. Unlike `admin { allFeatureFlags }` this does not open
   * the rest of the admin query namespace.
   */
  featureFlagsByName: Array<FeatureFlag>;
  fiNewsNotification: FiNewsNotification;
  fiNewsNotificationFeed: FiNewsNotificationFeed;
  findAdministrativeAreas: Array<AdministrativeArea>;
  forwardGeocode: Array<ForwardGeocodeResult>;
  forwardGeocodeCity: Array<ForwardGeocodeCityResult>;
  getAllInsightsForPet: Array<Insight>;
  getAllMobileAppContent: Array<AdminMobileAppContent>;
  getAvailableS3DowngradeableSubscriptionOptions: AvailableS3DowngradeSubscriptionOptionsResult;
  /**
   * [Partner setup - token auth] Recurly hosted page URL for partner to update payment method.
   * Null if no Recurly account or token invalid. Unauthenticated.
   */
  getConsignmentPartnerRecurlyBillingUrl?: Maybe<Scalars['String']['output']>;
  /**
   * [Partner setup - token auth] Presigned URL to upload a document (resale cert or consignment agreement).
   * Token is from admin-generated partner setup link. Unauthenticated.
   */
  getConsignmentPartnerUploadUrl: PreSignedUploadUrl;
  getHealthGptChatThread: HealthGptChatThread;
  getHealthGptSuggestedQuestions: Array<HealthGptSuggestedQuestion>;
  /** @deprecated Never launched to public */
  getHealthInsightsForPet: Array<PetHealthInsight>;
  /** Decagon In App Chat */
  getInAppDecagonChat?: Maybe<DecagonChatConfiguration>;
  /** @deprecated Use getAllInsightsForPet instead */
  getInsightsForPet: Array<Maybe<PetInsight>>;
  getIntelligenceInsight?: Maybe<IntelligenceInsight>;
  getIntelligenceTeaser?: Maybe<IntelligenceTeaser>;
  getMobileAppContent: MobileAppContent;
  getMobileAppContentById?: Maybe<AdminMobileAppContent>;
  getMobileAppContentSplashScreen?: Maybe<MobileAppSplashScreen>;
  getMobileAppContentTargetingFacts: Array<MobileAppContentTargetingFact>;
  getMultipleSupplementSubscriptionsPricing?: Maybe<GetMultipleSupplementSubscriptionsPricingResult>;
  getOAuthSetupDetails: OAuthSetupDetails;
  getPermissionMobileAppContent: Array<PermissionMobileAppContent>;
  getPetBehaviorDetail: PetBehaviorDetail;
  getPetDocument: PetDocument;
  getPetDocumentFeed: PetDocumentFeed;
  getPetDocumentLabels: Array<Scalars['String']['output']>;
  getPetHealthTrendsForPet: PetHealthTrends;
  /** Get a Pre-Signed URL for File Upload */
  getPreSignedUploadUrl: PreSignedUploadUrl;
  /**
   * Finds a sharing session for a pet.
   * If sessionType is not specified, defaults to Search Party.
   */
  getSharingSession: SharingSession;
  getUserOAuthStatus: Scalars['Boolean']['output'];
  gnssFixFailures: Array<GnssFixFailure>;
  handsetLogs: Array<HandsetLogDocument>;
  household?: Maybe<Household>;
  households: Array<Household>;
  inAppPromotionBanner?: Maybe<InAppPromotionBanner>;
  /**
   * A customer's billing invoices by email, as flat summaries with paid/refundable amounts.
   * Same access and semantics as subscriptionsList.
   */
  invoicesList: Array<InvoiceSummary>;
  /** Dog parks joined by a set of pets, most recently joined first. */
  joinedDogParks: Array<JoinedDogPark>;
  /**
   * ClickHouse-backed activity leaderboard (weekly competition + rolling windows).
   * Internal-only during rollout: gated on the mobile:leaderboards:enabled targeted flag.
   * Ranked pet ids are hydrated into privacy-filtered StrangerPets.
   */
  leaderboard: Leaderboard;
  /**
   * The leaderboards home screen for one of the viewer's pets, in a single request.
   * Internal-only during rollout (gated on the mobile:leaderboards:enabled targeted flag).
   */
  leaderboardsHome: LeaderboardsHome;
  listAppIntegrations: Array<AppIntegration>;
  /**
   * Returns localized asset URLs based on Accept-Language header.
   * Keys are dynamically discovered from S3.
   *
   * TODO: Use the authenticated user's language preference instead of the header.
   *
   * Returns a JSON object where each key is an asset name, and the value is an array
   * of available image variants with their scale (1 or 2) and URL.
   *
   * Example:
   * {
   *   "bluetooth_01": [
   *     { "scale": 1, "url": "https://media.tryfi.com/app-assets/bluetooth_01_en.png" },
   *     { "scale": 2, "url": "https://media.tryfi.com/app-assets/bluetooth_01_en@2x.png" }
   *   ]
   * }
   */
  localizedAssets: Scalars['JSON']['output'];
  /** Lookup a location report by its ID. Admin only. */
  locationReport?: Maybe<LocationReport>;
  missedLocationReports: Array<MissedLocationReport>;
  /**
   * Backend-driven mobile app launch routing: computes which step the client
   * should land on at startup, replacing the client-side decision cascades.
   */
  mobileAppLaunchState: MobileAppLaunchState;
  /**
   * The account's full set of authorized BLE peripherals — all collar module IDs
   * and charging-base IDs across every household the user belongs to — plus the
   * total non-deleted pet count. Lets the app build its BLE allowlist without
   * downloading the full pet roster. Self-scoped to the authed user.
   */
  mobileAuthorizedPeripherals: MobileAuthorizedPeripherals;
  multidogHouseholdPromotionBanner?: Maybe<MultidogHouseholdPromotionBanner>;
  nanoBatch: Array<NanoWebId>;
  nanoBatchIcarIds: Array<Scalars['String']['output']>;
  nearbyDogParks: NearbyDogParkFeed;
  nearbyPets: NearbyPetsFeed;
  /** @deprecated Use notificationLogsForUser instead */
  notificationLogs: Array<NotificationLogDocument>;
  notificationLogsForUser: NotificationLogsForUserResult;
  notificationTypeActivity: NotificationTypeActivity;
  notificationTypeDetails: Array<NotificationTypeDetails>;
  notificationTypeExampleMessages: Array<Scalars['String']['output']>;
  onboardingSessionLogs: Array<HandsetLogDocument>;
  onboardingSessions: Array<OnboardingSession>;
  order: Order;
  orderAuditLogs: Array<AuditLogEvent>;
  /**
   * Deduplicated, sorted list of all known SKUs for the orders filter dropdown.
   * Includes active product SKUs and inventory configuration SKUs.
   * Requires: canReadEcommerceOrders
   */
  orderFilterSkus: Array<Scalars['String']['output']>;
  orders: Array<Order>;
  pack?: Maybe<Pack>;
  packMemberFeed: PackMemberFeed;
  /** The account's open pending free-days extension, or null when it has none (admin/CS only). */
  pendingMembershipExtension?: Maybe<PendingMembershipExtension>;
  pet?: Maybe<Pet>;
  /** Returned in ascending order by `stepMinimum`. */
  petLifetimeStatsTiers: Array<PetLifetimeStatsTier>;
  /** Consolidated live state for a pet, resolved across all devices. */
  petLiveState?: Maybe<PetLiveState>;
  /**
   * A single pet's placement in the ClickHouse-backed rankings for the given window and
   * scope. Scope defaults to global (all Fi dogs); pass breed/location filters to rank the
   * pet within that slice. Null if the pet isn't ranked. Internal-only during rollout
   * (gated on the mobile:leaderboards:enabled targeted flag).
   */
  petRanking?: Maybe<PetLeaderboardRank>;
  /** Returns all pets with active (Recurly) subscriptions for the current user. */
  petsWithActiveSubscription: Array<Pet>;
  phoneConfig: PhoneConfig;
  photo?: Maybe<Photo>;
  place?: Maybe<Place>;
  poorLTEConnectivityDeviceInfo: Array<PoorLTEConnectivityDeviceInfo>;
  previewAddOrderLineItems: PreviewPurchaseResult;
  /**
   * Preview pricing for charging any product to an account (admin/CS only)
   * Works for all product types - subscriptions, bands, charging bases, etc.
   * Uses Recurly invoice preview API
   * Requires: Admin or Customer Support role
   */
  previewChargeAccount: ChargePreview;
  previewMembershipUpgrade: PreviewMembershipUpgradeResult;
  /**
   * Preview a product transfer showing all billing actions.
   * Requires: Admin or Customer Support role
   */
  previewProductTransfer: ProductTransferPreview;
  previewRenewAndSave: PreviewRenewAndSaveResult;
  previewSubscription: PreviewSubscriptionResult;
  /**
   * Preview pricing for a subscription purchase (uses Recurly invoice preview API)
   * Requires: Admin or Customer Support role
   */
  previewSubscriptionPurchase: SubscriptionPurchasePreview;
  /**
   * Preview refund amounts for subscription cancellation options
   * Requires: Admin or Customer Support role
   */
  previewSubscriptionRefund: SubscriptionRefundPreview;
  previewUpgradeToSeriesThreePlusModule: PreviewUpgradeToSeriesThreePlusModuleResult;
  previewUpgradeToUltra: PreviewUpgradeToUltraResult;
  prioritizedBackorders: Array<Order>;
  product: Product;
  products: Array<Product>;
  publicPetProfile?: Maybe<StrangerPet>;
  /**
   * Admin-only gateway to the internal rankings service. Returns a namespace of
   * proxied read-only endpoints; see RankingsAdmin.
   */
  rankingsService: RankingsAdmin;
  /** Image URLs of the most recent community photos, ordered by photo date desc. Bounded by `limit`. */
  recentCommunityPhotoThumbnails: Array<Image>;
  recentDogParkVisitors: DogParkVisitorFeed;
  recentNotificationCountsByType: Array<NotificationCountByType>;
  /** One of `serialNumber` or `invoiceNumber` must be specified */
  recurlyInvoice: RecurlyInvoice;
  /**
   * Get referral copy for a specific context. Returns copy with variables
   * injected based on the user's device type.
   */
  referralCopy: ReferralCopy;
  renewSubscriptionBanner?: Maybe<RenewSubscriptionBanner>;
  /**
   * Batch chip-availability lookup for the rescue portal's CSV import wizard.
   * Classifies each serial from the calling reseller's perspective (in our
   * inventory, claimable, owned by another reseller, or not found). Max
   * 500 serials per call. Read-only / advisory — the import mutation takes
   * its own row lock when actually claiming.
   */
  rescueChipClaimEligibility: Array<RescueChipClaimEligibility>;
  /**
   * Look up the progress of a previously-started rescue CSV import by id. Returns `null` if no such row
   * exists for the caller; clients poll this to track worker progress (QUEUED → RUNNING →
   * SUCCEEDED/FAILED). Verified rescue reseller only; rows owned by another reseller surface as Forbidden.
   */
  rescueCsvImportProgress?: Maybe<RescueCsvImportProgress>;
  /**
   * The calling user's current 501(c)(3) document, or `null` if they have never submitted one.
   * "Current" is the most recent row not superseded by a later upload, so `status` is always PENDING,
   * APPROVED or REJECTED. Scoped to the individual user rather than the rescue org: in a rescue with
   * several portal logins, each user sees only the letters they uploaded themselves.
   */
  rescueCurrent501c3Document?: Maybe<RescueDocument>;
  /** Aggregate counts for each rescue device filter category. */
  rescueDeviceStats: RescueDeviceStats;
  /**
   * List rescue devices with offset/limit pagination and accurate totalCount.
   * Only returns pets with a collar attached.
   */
  rescueDevices: RescueDevicesResult;
  /**
   * Returns the current rescue user's enrollment status in the Fi devices program.
   * Backed by membership in the `RescueAdoptionBetaTester` user group.
   */
  rescueDevicesProgram: RescueDevicesProgram;
  /**
   * What the calling rescue is asked to do to claim a sales-tax exemption, and how far they've got.
   * Resolved from the state on their registered address every read, so a rescue that relocates is
   * served their new jurisdiction's requirement while the signature they already made stays valid for
   * the state it names.
   */
  rescueExemptionStatus: RescueExemptionStatus;
  /**
   * Recommend the single existing foster home the entered contact maps to, or null. Backs the
   * manual-entry path in the create-foster UI and shares the matcher the transfer flow's auto-reuse
   * uses, so the recommendation and an actual reuse can never disagree. At least one of `email` /
   * `phoneNumber` must be provided.
   */
  rescueFosterHomeForContact?: Maybe<RescueFosterHome>;
  /**
   * The calling rescue's known foster homes (non-archived), newest first. Includes homes that
   * currently have a pet placed as well as ones between placements — the only filter is not-archived.
   *
   * Unpaginated, and stays that way: the assign-to-foster picker needs every home. The roster table
   * wants a page, and uses `rescueFosterHomesPaged`.
   */
  rescueFosterHomes: Array<RescueFosterHome>;
  /** The paginated, sortable view of the same homes, for the roster table. */
  rescueFosterHomesPaged: RescueFosterHomesResult;
  /**
   * Issue a short-lived presigned S3 PUT URL the rescue portal can use to upload the caller's own
   * 501(c)(3) determination letter. Returned `key` is scoped to the calling user
   * (`rescue-501c3/{userId}/{uuid}`) and is what `rescueSubmit501c3Document` expects. Any rescue-org
   * user may call this — unlike the CSV import it does not require a verified chip reseller, since the
   * letter is an input to that verification rather than a consequence of it.
   */
  rescueGet501c3UploadUrl: PreSignedUploadUrl;
  /**
   * Issue a short-lived presigned S3 PUT URL the rescue portal can use to upload a CSV directly to
   * the `fi-rescue-import-files` bucket. Returned `key` is scoped to the caller's chip reseller
   * (`rescue-import-files/{resellerId}/{uuid}.csv`); a follow-up PR will wire object-uploaded
   * events from the bucket into worker-side ingestion. Verified rescue reseller only.
   */
  rescueGetImportUploadUrl: PreSignedUploadUrl;
  /**
   * Postcard orders for the current rescue user's GWA program, most recent first. Empty if the user
   * has no GWA enrollment.
   */
  rescueGwaPostcardOrders: Array<RescueGwaPostcardOrder>;
  /**
   * Whether the current rescue user may request printed adoption cards themselves. Backed by membership
   * in the `RescueOrganization` user group. False hides the order UI; requesting anyway is rejected.
   */
  rescueGwaPostcardsEligible: Scalars['Boolean']['output'];
  /** Returns the current user's GWA (Gift with Adoption) program enrollment, or null if not enrolled. */
  rescueGwaProgram?: Maybe<RescueGwaProgram>;
  /**
   * Returns the current rescue user's outstanding nano-chip shipments. Same in-flight semantics as
   * `rescueOrderShipments` — delivered shipments are excluded, one row per shipment, sorted by the
   * most recent contributing order — but limited to shipments containing nano line items.
   */
  rescueNanoShipments: Array<RescueNanoShipment>;
  /**
   * Returns the current rescue user's outstanding shipments. Delivered
   * shipments are excluded so the rescue only sees what is still in transit; orders with both
   * delivered and undelivered shipments will appear once per still-shipping shipment.
   */
  rescueOrderShipments: Array<RescueOrderShipment>;
  /** Get a rescue pet by pet ID - returns pet + rescue transfer */
  rescuePet?: Maybe<RescuePet>;
  /**
   * The Dashboard's pet roster: one page of rows that already carry the status, timestamp, adopter
   * snapshot, and chip the Dashboard used to assemble from five drained queries.
   *
   * Distinct from `rescuePets`, which stays as-is — it is the picker source for several modals and
   * wants the whole household, unpaginated and unsorted.
   */
  rescueRoster: RescueRosterResult;
  rescueScheduledHandoffs: Array<RescueScheduledHandoff>;
  /**
   * ShelterLuv integration status for the current user's rescue organization.
   * Returns null if the user has no reseller or shelterluv is not configured.
   */
  rescueShelterluvStatus?: Maybe<ShelterluvConfiguration>;
  /**
   * Returns delivered devices owned by the current rescue user that have no pet assigned in
   * either position (unactivated, post-recall, or otherwise unattached). Devices on orders whose
   * shipments have not yet reached DELIVERED status are excluded — the rescue should only see
   * devices that have physically arrived. Devices currently attached to a pet (e.g. fostered or
   * adopted-out) are also excluded; use the rescueDevices endpoint to view those.
   */
  rescueUnassignedDeviceInventory: RescueUnassignedInventoryDevicesResult;
  resellerChip?: Maybe<ResellerChip>;
  /**
   * Admin / customer-support only. Lists every API key issued to the given reseller org, addressed by
   * reseller id — the active key first (if any) followed by revoked keys, most-recently-revoked first.
   */
  resellerOrganizationApiKeys: Array<ResellerOrganizationApiKey>;
  returnsTrackerSubItems: Array<ReturnsTrackerSubItem>;
  reverseGeocode?: Maybe<ReverseGeocodeResult>;
  rma: RMA;
  /**
   * Looks up the latest matching order for a serial number AND optional rescue context. Drives
   * the admin Returns app's "I have a serial number" flow:
   *   - Returns the latest order matching the serial number (or null).
   *   - When the device qualifies as rescue-obtained (rescue-channel order matched, OR rescue
   *     device note paired with a rescue/reseller-flagged household), populates `rescueContext`
   *     with the user the RMA should be assigned to, the customer info to autofill, and the
   *     module product SKU to synthesize a line item from when no order exists.
   */
  rmaLookupBySerialNumber: RMALookupResult;
  rmas: RMAFeed;
  searchFiHandle: SearchFiHandleResult;
  searchPacks: SearchPacksResponse;
  searchPets: Array<Pet>;
  /** Search and filter pets with offset pagination + facet counts for filter pills. */
  searchPetsWithFilters: SearchPetsWithFiltersResult;
  searchVets: Array<Veterinary>;
  series3UpgradeOffer?: Maybe<Series3UpgradeOffer>;
  /**
   * Either both `breedId` and `ageRange` should be provided to return the step count
   * distribution for that breed and age range, or both should be null in which case
   * the step count distribution for all Fi pets is returned.
   */
  stepCountDistribution?: Maybe<StepCountDistribution>;
  /**
   * The boards a pet holds a rank on this week, best rank first — the viewer-safe subset of its
   * home screen, for the stranger profile's Groups cards. Gated like the stranger profile itself
   * (community visibility, not ownership) plus the leaderboards rollout flag.
   */
  strangerLeaderboards: Array<LeaderboardHomeBoard>;
  strangerPet?: Maybe<StrangerPet>;
  subscription: BillingSubscription;
  /**
   * A customer's billing subscriptions by email, as flat summaries. Requires billing:read
   * (satisfied by admin, customer_support, and the ficommerce capability). Unlike
   * BillingSubscription, every field resolves for capability/service principals. Includes
   * deactivated (churned) accounts; an unknown email returns an empty list.
   */
  subscriptionsList: Array<SubscriptionSummary>;
  /**
   * Suggest equivalent plan by renewal months. Returns null if no subscription or match.
   * Requires: Admin or Customer Support role
   */
  suggestEquivalentPlan?: Maybe<AvailableTransferPlan>;
  suggestedPacks: SuggestedPacksResult;
  /** Pets to display in Discover tab Search. */
  suggestedPets: SuggestedPetResult;
  /** Pets to display in Discover tab carousel. */
  suggestedPetsToFollow: SuggestedPetResult;
  /** Pets in user's contacts ordered by creation date. */
  suggestedPetsToFollowFromContacts: SuggestedPetResult;
  /**
   * Returns the list of supported FiLanguage values for the current user.
   * Gated by feature flag — unlaunched languages are only visible to internal testers.
   */
  supportedLanguages: Array<FiLanguage>;
  textPost?: Maybe<TextPost>;
  textPostStyles: Array<TextPostStyle>;
  /** Returns all orders the current user has placed that contains collars that have not yet been assigned to a pet. */
  unactivatedOrders: Array<OrderHistoryResult>;
  user?: Maybe<AdminBaseUserProfile>;
  userPetsAtDogPark: DogParkVisitorFeed;
  validateAddress: ValidateAddressResponse;
  videoPost?: Maybe<VideoPost>;
  wifiNetwork?: Maybe<WifiNetwork>;
};

export type QueryactiveHardwarePromoForAccountArgs = {
  accountId: Scalars['ID']['input'];
};

export type QueryadminAvalaraCertsForCustomerArgs = {
  customerCode: Scalars['String']['input'];
};

export type QueryadminBoardingFacilityArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminBreedsArgs = {
  species?: InputMaybe<Species>;
};

export type QueryadminBullMqQueueStatsArgs = {
  queueName: Scalars['String']['input'];
};

export type QueryadminConsignmentAccountArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminConsignmentAccountInvoicesArgs = {
  consignmentAccountId: Scalars['ID']['input'];
};

export type QueryadminConsignmentAccountShipmentHistoryArgs = {
  consignmentAccountId: Scalars['ID']['input'];
};

export type QueryadminConsignmentLocationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminDeviceActuationsArgs = {
  input: AdminDeviceActuationsInput;
};

export type QueryadminDeviceHealthStatisticsArgs = {
  input: AdminDeviceHealthStatisticsInput;
};

export type QueryadminEvalGuidelineHistoryArgs = {
  key: Scalars['String']['input'];
};

export type QueryadminEvalGuidelinesArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminEvalResultForMessageArgs = {
  messageId: Scalars['Int']['input'];
};

export type QueryadminExperimentEnrollmentsForPetArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  petId: Scalars['ID']['input'];
};

export type QueryadminExperimentEnrollmentsForUserArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};

export type QueryadminGetAllTranslationsArgs = {
  namespace: TranslationNamespace;
};

export type QueryadminGetChangeLogArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminGetChangeLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminGetConsignmentAgreementDownloadUrlArgs = {
  consignmentAccountId: Scalars['ID']['input'];
};

export type QueryadminGetConsignmentAgreementUploadUrlArgs = {
  consignmentAccountId: Scalars['ID']['input'];
  contentType: Scalars['String']['input'];
};

export type QueryadminGetConsignmentPartnerSetupUrlArgs = {
  consignmentAccountId: Scalars['ID']['input'];
};

export type QueryadminGetConsignmentResaleCertificateUrlArgs = {
  consignmentAccountId: Scalars['ID']['input'];
};

export type QueryadminGetDismissedMobileAppContentArgs = {
  userId: Scalars['ID']['input'];
};

export type QueryadminGetDogParkCheckinExclusionsByDogParkArgs = {
  dogParkId: Scalars['ID']['input'];
};

export type QueryadminGetDogParkCheckinExclusionsByPetArgs = {
  petId: Scalars['ID']['input'];
};

export type QueryadminGetHealthGptMessageArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminGetHealthGptThreadMessagesArgs = {
  threadId: Scalars['ID']['input'];
};

export type QueryadminGetHealthGptThreadsForUserArgs = {
  userId: Scalars['ID']['input'];
};

export type QueryadminGetMediaAssetArgs = {
  path: Scalars['String']['input'];
};

export type QueryadminGetMobileAppContentAuditTrailArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminGetPetDocumentsUploadedByUserIdArgs = {
  userId: Scalars['ID']['input'];
};

export type QueryadminGetPreSignedUploadUrlArgs = {
  input: AdminPreSignedUploadUrlInput;
};

export type QueryadminGetRescueStoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<RescueStoryStatus>;
};

export type QueryadminGetRescueStoryArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminGetTargetedFeatureFlagArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminGetTargetedFeatureFlagAuditTrailArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminGetTranslationByKeyArgs = {
  key: Scalars['String']['input'];
  namespace: TranslationNamespace;
};

export type QueryadminGetVisibleMobileAppContentArgs = {
  androidAppVersion?: InputMaybe<Scalars['String']['input']>;
  iosAppVersion?: InputMaybe<Scalars['String']['input']>;
  petId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryadminGoldenQuestionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminGoldenQuestionRunArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminGoldenQuestionRunComparisonArgs = {
  runIdA: Scalars['ID']['input'];
  runIdB: Scalars['ID']['input'];
};

export type QueryadminGoldenQuestionRunsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminGoldenQuestionsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminHealthGptGetDocumentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminHealthGptMemoriesArgs = {
  petId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryadminHealthGptPlaybookHistoryArgs = {
  key: Scalars['String']['input'];
};

export type QueryadminHealthGptPlaybooksArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminIsShelterluvIntegrationValidArgs = {
  chipResellerId: Scalars['String']['input'];
};

export type QueryadminListAccountInvoicesArgs = {
  accountCode: Scalars['ID']['input'];
};

export type QueryadminListAppIntegrationsForUserArgs = {
  userId: Scalars['ID']['input'];
};

export type QueryadminListMediaAssetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
};

export type QueryadminMergedTimelineArgs = {
  input: TimelineQueryInput;
  moduleIds: Array<Scalars['String']['input']>;
};

export type QueryadminParseConsignmentTaxCertArgs = {
  consignmentAccountId: Scalars['ID']['input'];
  uploadedFileKey: Scalars['String']['input'];
};

export type QueryadminPreviewConsignmentChargeArgs = {
  input: PreviewConsignmentChargeInput;
};

export type QueryadminPreviewMobileAppContentWithLocaleArgs = {
  id: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
};

export type QueryadminPreviewOrderArgs = {
  input: AdminPreviewOrderInput;
};

export type QueryadminProductSkusArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type QueryadminRecurlyAccountDebugArgs = {
  recurlyAccountCode: Scalars['String']['input'];
};

export type QueryadminRenderTestDataTemplateArgs = {
  input: RenderTestDataTemplateInput;
};

export type QueryadminSearchDogParksArgs = {
  input: AdminSearchDogParksInput;
};

export type QueryadminSearchPartyTestingInfoArgs = {
  petId: Scalars['ID']['input'];
};

export type QueryadminSearchResellerModulesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<ResellerModuleQueryInput>;
};

export type QueryadminTranslateTextArgs = {
  locale: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type QueryadminValidateTranslationKeysArgs = {
  keys: Array<Scalars['String']['input']>;
  namespace: TranslationNamespace;
};

export type QueryallBreedsArgs = {
  species?: InputMaybe<Species>;
};

export type QueryarticleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryarticlesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryassignedChargingBaseArgs = {
  baseId: Scalars['String']['input'];
};

export type QueryavailableChargeableProductsArgs = {
  currency?: Scalars['String']['input'];
};

export type QueryavailableSubscriptionOptionsArgs = {
  currency?: InputMaybe<Currency>;
  moduleId?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  showAllSkus?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryavailableTransferPlansArgs = {
  sourceModuleId: Scalars['String']['input'];
  targetPlatformType: Scalars['String']['input'];
};

export type QuerybirthdayCardForPetArgs = {
  petId: Scalars['ID']['input'];
};

export type QueryboardingFacilityProspectivePetsArgs = {
  input: BoardingFacilityProspectivePetsInput;
};

export type QueryboardingPetArgs = {
  fiPetId: Scalars['ID']['input'];
};

export type QuerybrowsePacksArgs = {
  limit: Scalars['Int']['input'];
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type QuerybrowsePopularPacksArgs = {
  category?: InputMaybe<PackCategory>;
  limit: Scalars['Int']['input'];
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type QuerychargingBaseArgs = {
  baseId: Scalars['String']['input'];
};

export type QuerychargingBaseOfflineDateRangesArgs = {
  chargingBaseId: Scalars['ID']['input'];
  dateRange: DateRangeInput;
};

export type QuerycheckChargingBaseAssignableArgs = {
  baseId: Scalars['String']['input'];
};

export type QuerycheckDeviceAssignableArgs = {
  imei?: InputMaybe<Scalars['String']['input']>;
  moduleId?: InputMaybe<Scalars['String']['input']>;
};

export type QuerycheckFiHandleValidAndAvailableArgs = {
  proposedHandle: Scalars['String']['input'];
};

export type QuerycheckNearbyUsersForSearchPartyArgs = {
  petId: Scalars['ID']['input'];
};

export type QuerycheckTransferEligibilityArgs = {
  sourceModuleId: Scalars['String']['input'];
  targetPlatformType: Scalars['String']['input'];
};

export type QuerychipArgs = {
  id: Scalars['ID']['input'];
};

export type QuerychipContactInfoForVerifiedRescueArgs = {
  dbId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerychipResellerArgs = {
  id: Scalars['ID']['input'];
};

export type QuerycontactsForUserArgs = {
  input: ContactsForUserInput;
};

export type QuerydeviceArgs = {
  dbId?: InputMaybe<Scalars['Int']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  moduleId?: InputMaybe<Scalars['String']['input']>;
};

export type QuerydeviceActuationStatusArgs = {
  id: Scalars['ID']['input'];
};

export type QuerydeviceFirmwareUpdateArgs = {
  currentVersion: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
};

export type QuerydogParkArgs = {
  id: Scalars['ID']['input'];
};

export type QuerydogParkCheckInsForPetArgs = {
  input: DogParkCheckinsForPetInput;
};

export type QuerydogParkLeaderboardArgs = {
  dogParkId: Scalars['ID']['input'];
};

export type QuerydogParkNotificationSettingsArgs = {
  dogParkId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerydogParkRequestArgs = {
  id: Scalars['ID']['input'];
};

export type QuerydogParkRequestsArgs = {
  status?: InputMaybe<DogParkRequestStatus>;
};

export type QuerydogParkShareableSubscriptionTextArgs = {
  dogParkId: Scalars['ID']['input'];
};

export type QuerydynamicEnumArgs = {
  kind: DynamicEnumKind;
};

export type QueryfeatureFlagsByNameArgs = {
  names: Array<Scalars['String']['input']>;
};

export type QueryfiNewsNotificationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryfindAdministrativeAreasArgs = {
  level: AdminLevel;
  position: PositionInput;
};

export type QueryforwardGeocodeArgs = {
  partialAddress: Scalars['String']['input'];
  proximity?: InputMaybe<PositionInput>;
};

export type QueryforwardGeocodeCityArgs = {
  proximity?: InputMaybe<PositionInput>;
  query: Scalars['String']['input'];
};

export type QuerygetAllInsightsForPetArgs = {
  petId: Scalars['ID']['input'];
};

export type QuerygetAvailableS3DowngradeableSubscriptionOptionsArgs = {
  input: AvailableS3DowngradeSubscriptionOptionsInput;
};

export type QuerygetConsignmentPartnerRecurlyBillingUrlArgs = {
  token: Scalars['String']['input'];
};

export type QuerygetConsignmentPartnerUploadUrlArgs = {
  contentType: Scalars['String']['input'];
  documentType: ConsignmentPartnerDocumentType;
  token: Scalars['String']['input'];
};

export type QuerygetHealthGptChatThreadArgs = {
  input: GetHealthGptChatThreadInput;
};

export type QuerygetHealthGptSuggestedQuestionsArgs = {
  petId: Scalars['ID']['input'];
};

export type QuerygetHealthInsightsForPetArgs = {
  petId: Scalars['ID']['input'];
};

export type QuerygetInsightsForPetArgs = {
  petId: Scalars['ID']['input'];
};

export type QuerygetIntelligenceInsightArgs = {
  petId: Scalars['ID']['input'];
};

export type QuerygetIntelligenceTeaserArgs = {
  petId: Scalars['ID']['input'];
};

export type QuerygetMobileAppContentArgs = {
  clientTargetingFacts?: InputMaybe<MobileAppContentClientTargetingFactsInput>;
  petId: Scalars['ID']['input'];
};

export type QuerygetMobileAppContentByIdArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetMobileAppContentSplashScreenArgs = {
  clientTargetingFacts?: InputMaybe<MobileAppContentClientTargetingFactsInput>;
  petId: Scalars['ID']['input'];
  splashScreenId: Scalars['ID']['input'];
};

export type QuerygetMultipleSupplementSubscriptionsPricingArgs = {
  input: GetMultipleSupplementSubscriptionsPricingInput;
};

export type QuerygetOAuthSetupDetailsArgs = {
  app: Scalars['String']['input'];
};

export type QuerygetPermissionMobileAppContentArgs = {
  input: GetPermissionMobileAppContentInput;
};

export type QuerygetPetBehaviorDetailArgs = {
  input: GetPetBehaviorDetailInput;
};

export type QuerygetPetDocumentArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetPetDocumentFeedArgs = {
  input: GetPetDocumentsInput;
};

export type QuerygetPetHealthTrendsForPetArgs = {
  period: PetHealthTrendPeriod;
  petId: Scalars['ID']['input'];
};

export type QuerygetPreSignedUploadUrlArgs = {
  input: PreSignedUploadUrlInput;
};

export type QuerygetSharingSessionArgs = {
  petId: Scalars['ID']['input'];
  sessionType?: InputMaybe<SharingSessionType>;
};

export type QuerygetUserOAuthStatusArgs = {
  app: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type QuerygnssFixFailuresArgs = {
  dateRange: DateRangeInput;
  moduleId: Scalars['ID']['input'];
};

export type QueryhandsetLogsArgs = {
  dateRange: DateRangeInput;
  logTypes?: InputMaybe<Array<HandsetLogType>>;
  userId: Scalars['ID']['input'];
};

export type QueryhouseholdArgs = {
  id: Scalars['ID']['input'];
};

export type QueryhouseholdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryinAppPromotionBannerArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryinvoicesListArgs = {
  email: Scalars['String']['input'];
};

export type QueryjoinedDogParksArgs = {
  input: JoinedDogParksInput;
};

export type QueryleaderboardArgs = {
  breedId?: InputMaybe<Scalars['ID']['input']>;
  lifeStage?: InputMaybe<AgeRange>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LeaderboardLocation>;
  metric?: RankingMetric;
  offset?: InputMaybe<Scalars['Int']['input']>;
  packId?: InputMaybe<Scalars['ID']['input']>;
  weekOffset?: InputMaybe<Scalars['Int']['input']>;
  window: RankingWindow;
};

export type QueryleaderboardsHomeArgs = {
  petId: Scalars['ID']['input'];
};

export type QuerylocationReportArgs = {
  id: Scalars['ID']['input'];
};

export type QuerymissedLocationReportsArgs = {
  dateRange: DateRangeInput;
  moduleId: Scalars['ID']['input'];
};

export type QuerymobileAppLaunchStateArgs = {
  input: MobileAppLaunchStateInput;
};

export type QuerynanoBatchArgs = {
  input: AdminQueryNanoBatchInput;
};

export type QuerynanoBatchIcarIdsArgs = {
  input: AdminQueryNanoBatchInput;
};

export type QuerynearbyDogParksArgs = {
  position: PositionInput;
};

export type QuerynearbyPetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  radiusInMeters?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerynotificationLogsArgs = {
  dateRange: DateRangeInput;
  userId: Scalars['ID']['input'];
};

export type QuerynotificationLogsForUserArgs = {
  input: NotificationLogsForUserInput;
};

export type QuerynotificationTypeActivityArgs = {
  notificationTypes: Array<Scalars['String']['input']>;
};

export type QuerynotificationTypeExampleMessagesArgs = {
  notificationType: Scalars['String']['input'];
};

export type QueryonboardingSessionLogsArgs = {
  dateRange: DateRangeInput;
  userId: Scalars['ID']['input'];
};

export type QueryonboardingSessionsArgs = {
  userId: Scalars['ID']['input'];
};

export type QueryorderArgs = {
  id: Scalars['ID']['input'];
};

export type QueryorderAuditLogsArgs = {
  id: Scalars['ID']['input'];
};

export type QueryordersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<OrdersQueryInput>;
};

export type QuerypackArgs = {
  id: Scalars['ID']['input'];
};

export type QuerypackMemberFeedArgs = {
  adjacentPetId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  packAgeFilter?: InputMaybe<PackAgeFilter>;
  packId: Scalars['ID']['input'];
  pagingInstruction?: InputMaybe<PagingInstruction>;
  validityToken?: InputMaybe<Scalars['String']['input']>;
};

export type QuerypendingMembershipExtensionArgs = {
  accountId: Scalars['ID']['input'];
};

export type QuerypetArgs = {
  id: Scalars['ID']['input'];
};

export type QuerypetLiveStateArgs = {
  petId: Scalars['ID']['input'];
};

export type QuerypetRankingArgs = {
  breedId?: InputMaybe<Scalars['ID']['input']>;
  lifeStage?: InputMaybe<AgeRange>;
  location?: InputMaybe<LeaderboardLocation>;
  metric?: RankingMetric;
  packId?: InputMaybe<Scalars['ID']['input']>;
  petId: Scalars['ID']['input'];
  weekOffset?: InputMaybe<Scalars['Int']['input']>;
  window: RankingWindow;
};

export type QueryphotoArgs = {
  id: Scalars['ID']['input'];
};

export type QueryplaceArgs = {
  id: Scalars['ID']['input'];
};

export type QuerypoorLTEConnectivityDeviceInfoArgs = {
  dateRange: DateRangeInput;
  moduleId: Scalars['ID']['input'];
};

export type QuerypreviewAddOrderLineItemsArgs = {
  input: AddOrderLineItemsInput;
};

export type QuerypreviewChargeAccountArgs = {
  accountCode: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  currency?: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
  unitAmountInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerypreviewMembershipUpgradeArgs = {
  input: UpgradeMembershipInput;
};

export type QuerypreviewProductTransferArgs = {
  input: ProductTransferPreviewInput;
};

export type QuerypreviewRenewAndSaveArgs = {
  input: RenewAndSaveInput;
};

export type QuerypreviewSubscriptionArgs = {
  input: PurchaseSubscriptionInput;
};

export type QuerypreviewSubscriptionPurchaseArgs = {
  accountCode: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  overridePriceInCents?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  waiveActivationFee?: InputMaybe<Scalars['Boolean']['input']>;
  waiveTrial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerypreviewSubscriptionRefundArgs = {
  subscriptionId: Scalars['String']['input'];
};

export type QuerypreviewUpgradeToSeriesThreePlusModuleArgs = {
  input: UpgradeToSeriesThreePlusModuleInput;
};

export type QuerypreviewUpgradeToUltraArgs = {
  input: UpgradeToUltraInput;
};

export type QueryproductArgs = {
  sku: Scalars['String']['input'];
};

export type QueryproductsArgs = {
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  includeRefurbs?: InputMaybe<Scalars['Boolean']['input']>;
  noDiscontinued?: InputMaybe<Scalars['Boolean']['input']>;
  noNoLongerManufactured?: InputMaybe<Scalars['Boolean']['input']>;
  onlyAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPhysical?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerypublicPetProfileArgs = {
  handle: Scalars['String']['input'];
};

export type QueryrecentCommunityPhotoThumbnailsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryrecentDogParkVisitorsArgs = {
  dogParkId: Scalars['ID']['input'];
};

export type QueryrecurlyInvoiceArgs = {
  ecomConfigType?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QueryreferralCopyArgs = {
  context: ReferralCopyContext;
};

export type QueryrescueChipClaimEligibilityArgs = {
  serialNumbers: Array<Scalars['String']['input']>;
};

export type QueryrescueCsvImportProgressArgs = {
  id: Scalars['ID']['input'];
};

export type QueryrescueDeviceStatsArgs = {
  completedSince?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryrescueDevicesArgs = {
  input: RescueDevicesInput;
};

export type QueryrescueFosterHomeForContactArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QueryrescueFosterHomesPagedArgs = {
  input: RescueFosterHomesInput;
};

export type QueryrescueGet501c3UploadUrlArgs = {
  input: RescueGet501c3UploadUrlInput;
};

export type QueryrescueGetImportUploadUrlArgs = {
  input: RescueGetImportUploadUrlInput;
};

export type QueryrescuePetArgs = {
  petId: Scalars['ID']['input'];
};

export type QueryrescueRosterArgs = {
  input: RescueRosterInput;
};

export type QueryrescueUnassignedDeviceInventoryArgs = {
  input: RescueUnassignedInventoryDevicesInput;
};

export type QueryresellerChipArgs = {
  dbId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryresellerOrganizationApiKeysArgs = {
  resellerId: Scalars['ID']['input'];
};

export type QueryreverseGeocodeArgs = {
  position: PositionInput;
};

export type QueryrmaArgs = {
  id: Scalars['ID']['input'];
};

export type QueryrmaLookupBySerialNumberArgs = {
  serialNumber: Scalars['String']['input'];
};

export type QueryrmasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<RMAQueryInput>;
};

export type QuerysearchFiHandleArgs = {
  position?: InputMaybe<PositionInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerysearchPacksArgs = {
  category?: InputMaybe<PackCategory>;
  query: Scalars['String']['input'];
};

export type QuerysearchPetsArgs = {
  position?: InputMaybe<PositionInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerysearchPetsWithFiltersArgs = {
  input: SearchPetsWithFiltersInput;
};

export type QuerysearchVetsArgs = {
  proximity?: InputMaybe<PositionInput>;
  query: Scalars['String']['input'];
};

export type Queryseries3UpgradeOfferArgs = {
  petId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerystepCountDistributionArgs = {
  ageRange?: InputMaybe<AgeRange>;
  breedId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerystrangerLeaderboardsArgs = {
  petId: Scalars['ID']['input'];
};

export type QuerystrangerPetArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type QuerysubscriptionArgs = {
  id: Scalars['String']['input'];
};

export type QuerysubscriptionsListArgs = {
  email: Scalars['String']['input'];
};

export type QuerysuggestEquivalentPlanArgs = {
  sourceModuleId: Scalars['String']['input'];
  targetPlatformType: Scalars['String']['input'];
};

export type QuerysuggestedPetsArgs = {
  categoryTypes?: InputMaybe<Array<SuggestedPetCategoryType>>;
};

export type QuerytextPostArgs = {
  id: Scalars['ID']['input'];
};

export type QueryuserArgs = {
  id: Scalars['ID']['input'];
};

export type QueryuserPetsAtDogParkArgs = {
  dogParkId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryvalidateAddressArgs = {
  address: AddressInput;
};

export type QueryvideoPostArgs = {
  id: Scalars['ID']['input'];
};

export type QuerywifiNetworkArgs = {
  householdId: Scalars['ID']['input'];
  ssid: Scalars['String']['input'];
};

export enum QuickReportModeState {
  NO_CHANGE = 'NO_CHANGE',
  TURN_OFF = 'TURN_OFF',
  TURN_ON = 'TURN_ON',
}

export type RMA = {
  __typename?: 'RMA';
  amazonLpn?: Maybe<Scalars['String']['output']>;
  checkedInAt?: Maybe<Scalars['DateTime']['output']>;
  checkedInBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerEmail: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  drilldown?: Maybe<DynamicEnumMember>;
  exchangeOrder?: Maybe<Order>;
  exchangeRecurlyInvoiceNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoiceSource?: Maybe<InvoiceSource>;
  items: Array<RMAItem>;
  notes: Array<RMANote>;
  processType: RMAProcessType;
  purchaseProvenance?: Maybe<DynamicEnumMember>;
  reason: DynamicEnumMember;
  refundStatus?: Maybe<RefundStatus>;
  returnShipmentStatusCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  returnShipmentStatusCode?: Maybe<Scalars['String']['output']>;
  returnShipmentStatusDescription?: Maybe<Scalars['String']['output']>;
  shippingLabelUrl?: Maybe<Scalars['String']['output']>;
  status: RMAStatus;
  syncedToDcl: Scalars['Boolean']['output'];
  tags: Array<RMATag>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Note: this is a StrangerUser not a User since RMAs can be accessed by
   * less privileged users. Don't want to introduce a privilege escalation.
   */
  user?: Maybe<StrangerUser>;
  wasUpgrade: Scalars['Boolean']['output'];
  zendeskNumber?: Maybe<Scalars['String']['output']>;
};

export type RMAFeed = {
  __typename?: 'RMAFeed';
  items: Array<RMA>;
  /** Total count of all RMAs, doesn't take into account your query. */
  totalCount: Scalars['Int']['output'];
};

export type RMAItem = {
  __typename?: 'RMAItem';
  checkInCondition?: Maybe<RMAItemCondition>;
  /**
   * Resolved display name for this item. Applies the Mini-specific sub-item override so 'A'
   * renders as "Silicone Attachment" for Minis and "USB Adapter" for collars. For items without
   * a subItem, falls back to a best-effort sku-based description; may still be null for unknown
   * SKUs or items with no sku set.
   */
  displayName?: Maybe<Scalars['String']['output']>;
  hardwareDefects: Array<HardwareDefect>;
  id: Scalars['ID']['output'];
  lineItemId?: Maybe<Scalars['String']['output']>;
  ordinal?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<Product>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  stockpileAssignmentDescription?: Maybe<Scalars['String']['output']>;
  stockpileAssignmentName?: Maybe<Scalars['String']['output']>;
  subItem?: Maybe<ReturnsTrackerSubItem>;
};

export enum RMAItemCondition {
  HEAVILY_USED = 'HEAVILY_USED',
  LIGHTLY_USED = 'LIGHTLY_USED',
  MISSING = 'MISSING',
  NEW = 'NEW',
  UNACCEPTABLE = 'UNACCEPTABLE',
}

export type RMAItemInput = {
  hardwareDefectCodes: Array<Scalars['String']['input']>;
  lineItemId?: InputMaybe<Scalars['String']['input']>;
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  subItemCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Result of `rmaLookupBySerialNumber` — combines the existing serial-number order lookup with
 * optional rescue context. Admin Returns app uses this to drive the unknown-return + rescue
 * RMA flow.
 */
export type RMALookupResult = {
  __typename?: 'RMALookupResult';
  /**
   * Latest matching order for the serial number, or null when no order exists (orderless
   * rescue case).
   */
  order?: Maybe<Order>;
  /**
   * Populated when the device qualifies as rescue-obtained — drives admin's orderless rescue
   * branch and surfaces the user the RMA should be assigned to (which can differ from the
   * matched order's user for stale-household cases).
   */
  rescueContext?: Maybe<RescueRMAContext>;
};

export type RMANote = {
  __typename?: 'RMANote';
  attributes: Scalars['JSON']['output'];
  body: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  initiatedBy?: Maybe<Scalars['String']['output']>;
  noteType: Scalars['String']['output'];
};

export type RMAPolicyResult = {
  __typename?: 'RMAPolicyResult';
  message: Scalars['String']['output'];
  requiresException: Scalars['Boolean']['output'];
  triggersNotification: Scalars['Boolean']['output'];
  type: RMAPolicyResultType;
};

export enum RMAPolicyResultType {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN',
}

export enum RMAProcessType {
  RETURN = 'RETURN',
  SHIPPING_ERROR = 'SHIPPING_ERROR',
  UNKNOWN_RETURN = 'UNKNOWN_RETURN',
  WARRANTY_EXCHANGE = 'WARRANTY_EXCHANGE',
}

export type RMAQueryInput = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export enum RMAStatus {
  AWAITING_RETURN = 'AWAITING_RETURN',
  CANCELLED = 'CANCELLED',
  COMPLETE = 'COMPLETE',
  LOST_PACKAGE = 'LOST_PACKAGE',
}

export enum RMATag {
  CUSTOMER_DISCARD = 'CUSTOMER_DISCARD',
  INSPECT_ON_ARRIVAL = 'INSPECT_ON_ARRIVAL',
}

export type RandomPercentageBooleanSetting = BooleanSetting & {
  __typename?: 'RandomPercentageBooleanSetting';
  floatPercentage: Scalars['Float']['output'];
  platformOverrides: Array<BooleanSettingPlatformOverride>;
};

export type RankChange = {
  __typename?: 'RankChange';
  /** e.g. 4, -5, 0 */
  amount: Scalars['Int']['output'];
};

export type RankedPetsResponse = {
  __typename?: 'RankedPetsResponse';
  pageInfo: PageInfo;
  pets: Array<BasePet>;
  tokenValidity: TokenValidity;
};

/** What a ranking is computed on. Only steps today; new measures are added here. */
export enum RankingMetric {
  STEPS = 'STEPS',
}

/** Time window for the ClickHouse-backed activity leaderboard. */
export enum RankingWindow {
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_90_DAYS = 'LAST_90_DAYS',
  TODAY = 'TODAY',
  WEEKLY = 'WEEKLY',
  YESTERDAY = 'YESTERDAY',
}

/**
 * Admin-only gateway to the internal rankings service (a read-only REST API for
 * pet activity rankings). Each field proxies a GET request to the service and
 * returns the HTTP status plus the JSON response body, so non-2xx responses (e.g.
 * 404 for an unknown pet, 400 for bad params) surface as data rather than GraphQL
 * errors.
 */
export type RankingsAdmin = {
  __typename?: 'RankingsAdmin';
  /** GET /v1/discovery — available metrics, windows, and filter values. */
  discovery: RankingsResponse;
  /** GET /health — service health check (no auth required upstream). */
  health: RankingsResponse;
  /** GET /v1/rankings/pets/:petId — an individual pet's rank and score. */
  petRank: RankingsResponse;
  /** GET /v1/rankings/presets/:id — rankings for a preset. */
  preset: RankingsResponse;
  /** GET /v1/rankings/presets/:id/pets/:petId — a pet's rank within a preset. */
  presetPetRank: RankingsResponse;
  /** GET /v1/rankings/presets — the list of preset rankings. */
  presets: RankingsResponse;
  /** GET /v1/status — data freshness and ingestion worker stats. */
  status: RankingsResponse;
  /** GET /v1/rankings/top — top pets by metric and window. */
  top: RankingsResponse;
};

/**
 * Admin-only gateway to the internal rankings service (a read-only REST API for
 * pet activity rankings). Each field proxies a GET request to the service and
 * returns the HTTP status plus the JSON response body, so non-2xx responses (e.g.
 * 404 for an unknown pet, 400 for bad params) surface as data rather than GraphQL
 * errors.
 */
export type RankingsAdminpetRankArgs = {
  input: RankingsTopInput;
  petId: Scalars['String']['input'];
};

/**
 * Admin-only gateway to the internal rankings service (a read-only REST API for
 * pet activity rankings). Each field proxies a GET request to the service and
 * returns the HTTP status plus the JSON response body, so non-2xx responses (e.g.
 * 404 for an unknown pet, 400 for bad params) surface as data rather than GraphQL
 * errors.
 */
export type RankingsAdminpresetArgs = {
  id: Scalars['String']['input'];
  input?: InputMaybe<RankingsPresetInput>;
};

/**
 * Admin-only gateway to the internal rankings service (a read-only REST API for
 * pet activity rankings). Each field proxies a GET request to the service and
 * returns the HTTP status plus the JSON response body, so non-2xx responses (e.g.
 * 404 for an unknown pet, 400 for bad params) surface as data rather than GraphQL
 * errors.
 */
export type RankingsAdminpresetPetRankArgs = {
  id: Scalars['String']['input'];
  petId: Scalars['String']['input'];
  weekOffset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Admin-only gateway to the internal rankings service (a read-only REST API for
 * pet activity rankings). Each field proxies a GET request to the service and
 * returns the HTTP status plus the JSON response body, so non-2xx responses (e.g.
 * 404 for an unknown pet, 400 for bad params) surface as data rather than GraphQL
 * errors.
 */
export type RankingsAdmintopArgs = {
  input: RankingsTopInput;
};

export type RankingsPresetInput = {
  breedId?: InputMaybe<Scalars['String']['input']>;
  lifeStage?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** For weekly presets only: 0 = current week, 1 = last week, etc. */
  weekOffset?: InputMaybe<Scalars['Int']['input']>;
};

/** The result of a proxied rankings-service request. */
export type RankingsResponse = {
  __typename?: 'RankingsResponse';
  /** Parsed JSON response body. */
  body?: Maybe<Scalars['JSON']['output']>;
  /** True when the rankings service returned a 2xx status. */
  ok: Scalars['Boolean']['output'];
  /** The path (with query string) that was requested. */
  path: Scalars['String']['output'];
  /** HTTP status code returned by the rankings service. */
  status: Scalars['Int']['output'];
};

export type RankingsTopInput = {
  breedId?: InputMaybe<Scalars['String']['input']>;
  lifeStage?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  locationState?: InputMaybe<Scalars['String']['input']>;
  /** Metric to rank by, e.g. "steps". */
  metric: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** For window=weekly only: 0 = current week, 1 = last week, etc. Ignored for other windows. */
  weekOffset?: InputMaybe<Scalars['Int']['input']>;
  /** Time window: today, yesterday, 7d, 30d, 90d, weekly. */
  window: Scalars['String']['input'];
};

export type ReactivateSubscriptionInput = {
  subscriptionId: Scalars['String']['input'];
};

export enum RealtimeBehaviorFeedback {
  ALTERNATIVE_BEHAVIOR = 'ALTERNATIVE_BEHAVIOR',
  CORRECT_BEHAVIOR = 'CORRECT_BEHAVIOR',
  NOTHING = 'NOTHING',
  OTHER = 'OTHER',
  UNSURE = 'UNSURE',
}

export enum ReasonForPackInsertFailure {
  ALREADY_IN_PACK = 'ALREADY_IN_PACK',
  DELETED_PET = 'DELETED_PET',
  DEVICE_NOT_FOUND = 'DEVICE_NOT_FOUND',
  NO_ACTIVE_SUBSCRIPTION = 'NO_ACTIVE_SUBSCRIPTION',
  PET_NOT_FOUND = 'PET_NOT_FOUND',
}

export type ReassignChipToResellerInput = {
  /**
   * If true, clears the pet and latest contact history entry from the chip.
   * Defaults to false (keeps existing owner info).
   */
  clearOwnerInfo?: InputMaybe<Scalars['Boolean']['input']>;
  serialNumber: Scalars['String']['input'];
};

export type RebootDeviceEvent = DeviceEventBase & {
  __typename?: 'RebootDeviceEvent';
  date: Scalars['DateTime']['output'];
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  moduleId: Scalars['String']['output'];
  oldUptime: Scalars['Float']['output'];
  platform: Scalars['String']['output'];
};

export type RecallChipInput = {
  chipId: Scalars['ID']['input'];
};

export type RecentlyPurchasedItemsResponse = {
  __typename?: 'RecentlyPurchasedItemsResponse';
  lineItems: Array<LineItem>;
};

export type RecentlySeenBaseInput = {
  baseId: Scalars['String']['input'];
  rssi?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordAppInstallForUserInput = {
  app: AppIntegrationId;
  isInstalled: Scalars['Boolean']['input'];
  /** For admin/CX use */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type RecordAppInstallForUserResult = {
  __typename?: 'RecordAppInstallForUserResult';
  /** Populated when success is false */
  reason?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/**
 * Read-only snapshot of a Recurly account for E2E assertions. Sourced directly
 * from Recurly's `accounts/{code}` endpoint at query time — not cached.
 */
export type RecurlyAccountDebug = {
  __typename?: 'RecurlyAccountDebug';
  billingAddressCountry?: Maybe<Scalars['String']['output']>;
  /**
   * USPS state code of the Recurly billing address (e.g. "FL", "CT"). This is the
   * state Avalara uses for tax destination — NOT the Fi-stored partner location's
   * state. Mismatch between this and the filed cert's exposure zone is the
   * canonical Zen Canine bug class.
   */
  billingAddressState?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  /**
   * Recurly's tax-engine entity-use code. For consignment, "G" (Resale) is the
   * expected value when the partner is tax-exempt.
   */
  entityUseCode?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  taxExempt: Scalars['Boolean']['output'];
};

export type RecurlyInvoice = {
  __typename?: 'RecurlyInvoice';
  account: BillingAccount;
  /** Amount of account credits applied to this invoice (from creditPayments) */
  appliedCreditAmount: Scalars['Float']['output'];
  /** Outstanding balance remaining (0 if fully paid) */
  balance: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  /**
   * The date that the package associated with the shipment associated with this invoice
   * was delivered. If null, it means that either the package hasn't been delivered yet,
   * or we could not find/determine the shipment.
   */
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Total discounts/coupons applied to this invoice */
  discount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  lineItems: Array<LineItem>;
  number: Scalars['String']['output'];
  /** Amount actually paid/charged (after account credits applied) */
  paid: Scalars['Float']['output'];
  /** Are the items in this invoice within the 14-day return window? */
  returnEligibility: RMAPolicyResult;
  subtotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  /** Are the items in this invoice under warranty? */
  warrantyStatus: RMAPolicyResult;
};

export type RecurlyInvoicereturnEligibilityArgs = {
  drilldownCode: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
};

export type RecurlyInvoicewarrantyStatusArgs = {
  drilldownCode: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RecurringCharge = {
  __typename?: 'RecurringCharge';
  amountInCents: Scalars['Int']['output'];
  freeTrialDays?: Maybe<Scalars['Int']['output']>;
  interval: BillingCadence;
  intervalCount: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type RedeemGiftCardInput = {
  redemptionCode: Scalars['String']['input'];
};

export type ReferralCopy = {
  __typename?: 'ReferralCopy';
  /** The context this copy is for */
  context: ReferralCopyContext;
  /** Variables that were injected into the copy (for debugging/analytics) */
  injectedVariables: Array<ReferralCopyVariable>;
  /** The copy text with variables already injected */
  text: Scalars['String']['output'];
};

export enum ReferralCopyContext {
  ONBOARDING = 'ONBOARDING',
  SHARE_SHEET = 'SHARE_SHEET',
}

export type ReferralCopyVariable = {
  __typename?: 'ReferralCopyVariable';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ReferralInput = {
  referralCode: Scalars['String']['input'];
};

export type ReferralMenuBannerSettings = {
  __typename?: 'ReferralMenuBannerSettings';
  isEnabled: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum ReferralProgramName {
  Give1MonthGet1DollarPerMonthNoLimit = 'Give1MonthGet1DollarPerMonthNoLimit',
  Give1MonthGet1DollarPerMonthWithLimit = 'Give1MonthGet1DollarPerMonthWithLimit',
  Give1MonthGet1Month = 'Give1MonthGet1Month',
}

export enum ReferralRewardType {
  DOLLAR_CREDIT = 'DOLLAR_CREDIT',
  FIRST_FREE_BAND = 'FIRST_FREE_BAND',
  ONE_MONTH_EXTENSION = 'ONE_MONTH_EXTENSION',
  ONE_YEAR_EXTENSION = 'ONE_YEAR_EXTENSION',
  SECOND_FREE_BAND = 'SECOND_FREE_BAND',
  THREE_YEAR_EXTENSION = 'THREE_YEAR_EXTENSION',
  TWO_YEAR_EXTENSION = 'TWO_YEAR_EXTENSION',
}

export enum ReferralSource {
  DirectLink = 'DirectLink',
  Onboarding = 'Onboarding',
  ReferralsTab = 'ReferralsTab',
}

export type Referrals = {
  __typename?: 'Referrals';
  codeFraudulent: Scalars['Boolean']['output'];
  codeSuspended: Scalars['Boolean']['output'];
  give1MonthGet1DollarPerMonthDetails?: Maybe<Give1MonthGet1DollarPerMonthDetails>;
  invitedReferees: Array<StrangerUser>;
  numConfirmedReferrals: Scalars['Int']['output'];
  numPendingReferrals: Scalars['Int']['output'];
  /**
   * Number of users that have been referred so far.
   * DEPRECATED: This is associated with the V1 legacy referrals system; we're
   * keeping the resolver so that admin can use it.
   */
  numReferred: Scalars['Int']['output'];
  pendingReferrees: Array<AdminBaseUserProfile>;
  pendingReferrerToReward?: Maybe<AdminBaseUserProfile>;
  referralCode: Scalars['String']['output'];
  /** Message that the client should pre-populate the SMS message with. */
  referralMessage: Scalars['String']['output'];
  referralProgramName: Scalars['String']['output'];
  referralProgramTitle: Scalars['String']['output'];
  unlockedRewardTypes: Array<ReferralRewardType>;
};

export enum RefundStatus {
  NOT_REFUNDED = 'NOT_REFUNDED',
  NO_REFUND_NECESSARY = 'NO_REFUND_NECESSARY',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  REFUNDED = 'REFUNDED',
}

export enum RefundType {
  custom = 'custom',
  full = 'full',
  prorate = 'prorate',
}

export type RegisterChipResellerInput = {
  contactInfo: ChipContactInfoInput;
  name: Scalars['String']['input'];
  petInterest: ResellerPetInterest;
  type: ResellerType;
};

export type RegisterChipResellerInputV2 = {
  contactInfo: ChipContactInfoInput;
  isRescue?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  petInterestTypes: Array<InputMaybe<ResellerPetInterest>>;
  programInterest?: InputMaybe<Array<ResellerProgramInterest>>;
  shippingAddress: AddressInput;
  taxExemptType?: InputMaybe<ResellerTaxExemptType>;
  types: Array<InputMaybe<ResellerType>>;
};

export type RegisterConsignmentAgreementInput = {
  consignmentAccountId: Scalars['ID']['input'];
  uploadedFileKey: Scalars['String']['input'];
};

export type RegisterConsignmentResaleCertificateInput = {
  consignmentAccountId: Scalars['ID']['input'];
  resaleCertBusinessType?: InputMaybe<Scalars['String']['input']>;
  resaleCertExemptionReason?: InputMaybe<ConsignmentExemptionReason>;
  resaleCertExpirationDate?: InputMaybe<Scalars['String']['input']>;
  resaleCertNumber?: InputMaybe<Scalars['String']['input']>;
  resaleCertStateOfIssue?: InputMaybe<Scalars['String']['input']>;
  uploadedFileKey: Scalars['String']['input'];
};

export type RegisterHandsetInput = {
  deviceToken: Scalars['String']['input'];
};

export type RegisterHandsetLiveActivityTokenInput = {
  deviceToken: Scalars['String']['input'];
  liveActivityToken: Scalars['String']['input'];
};

export enum RemoteLogLevel {
  CRITICAL = 'CRITICAL',
  DEBUG = 'DEBUG',
  ERROR = 'ERROR',
  INFO = 'INFO',
  OFF = 'OFF',
  WARNING = 'WARNING',
}

export type RemoveChipFromPetInput = {
  chipId: Scalars['ID']['input'];
};

export type RemoveCouponFromAccountInput = {
  /** The account code (user external ID) */
  accountCode: Scalars['ID']['input'];
  /** The coupon code to remove */
  couponCode: Scalars['String']['input'];
};

export type RemoveUserEmailInput = {
  email: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type RemoveUserFromHouseholdInput = {
  householdId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type RemoveUserFromHouseholdResult = {
  __typename?: 'RemoveUserFromHouseholdResult';
  household: Household;
  petRecalled?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveWifiCredentialInput = {
  householdId: Scalars['ID']['input'];
  ssid: Scalars['String']['input'];
};

export type RenderTestDataTemplateInput = {
  text: Scalars['String']['input'];
};

export type RenderTestDataTemplateResult = {
  __typename?: 'RenderTestDataTemplateResult';
  renderedText: Scalars['String']['output'];
};

export type RenderedDebugActivitySegments = {
  __typename?: 'RenderedDebugActivitySegments';
  activities: Array<SimpleDebugActivity>;
};

export type RenewAndSaveInput = {
  marketingEmailsOptedIn?: InputMaybe<Scalars['Boolean']['input']>;
  moduleId: Scalars['ID']['input'];
};

export type RenewSubscriptionBanner = InAppPromotionBanner & {
  __typename?: 'RenewSubscriptionBanner';
  ctaUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  line1Text: FormatString;
  line2Text: FormatString;
};

export type RenewSubscriptionInput = {
  moduleId?: InputMaybe<Scalars['String']['input']>;
};

export type RenewSubscriptionResult = {
  __typename?: 'RenewSubscriptionResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Aggregated membership renewal terms for a single Apple Pay recurring-payment disclosure. */
export type RenewalTerms = {
  __typename?: 'RenewalTerms';
  amountInCents: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  renewalMonths: Scalars['Int']['output'];
};

export type ReplacementProductAudit = {
  previousQuantity?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
  type: ReplacementProductAuditType;
};

export enum ReplacementProductAuditType {
  ITEM_ADDED = 'ITEM_ADDED',
  ITEM_REMOVED = 'ITEM_REMOVED',
  QUANTITY_CHANGED = 'QUANTITY_CHANGED',
}

export type ReplacementProductInput = {
  id: Scalars['ID']['input'];
  priceOverrideInCents?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
};

export enum ReportBackhaul {
  BASE = 'BASE',
  LTE = 'LTE',
  MOBILE = 'MOBILE',
  SIDEWALK = 'SIDEWALK',
  WEARABLE = 'WEARABLE',
  WIFI = 'WIFI',
}

export type ReportSubmissionInput = {
  activityInput?: InputMaybe<Array<ActivityReportInput>>;
  binaryResponse?: InputMaybe<Scalars['Boolean']['input']>;
  locationInput?: InputMaybe<Array<LocationReportInput>>;
  mobilityInput?: InputMaybe<Array<MobilityReportInput>>;
  moduleRequest?: InputMaybe<Scalars['String']['input']>;
};

export enum ReportType {
  ACTIVITY = 'ACTIVITY',
  LOCATION = 'LOCATION',
  MOBILITY = 'MOBILITY',
}

export type ReportTypeFilterParams = {
  reportType: ReportType;
  sourceBlacklist?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceWhitelist?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RequestEmailVerificationInput = {
  email: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type RequestVerificationCodeInput = {
  phoneNumber: Scalars['String']['input'];
};

export type RerouteShipmentsInput = {
  shipmentIds: Array<Scalars['Int']['input']>;
  warehouseId: Scalars['Int']['input'];
};

/**
 * File format a rescue user may upload for their 501(c)(3) determination letter. PDF only — the
 * portal's upload control accepts nothing else, and a single format keeps what admins review
 * predictable. (The underlying RESCUE_501C3 upload purpose also permits JPEG/PNG for the admin path.)
 */
export enum Rescue501c3ContentType {
  APPLICATION_PDF = 'APPLICATION_PDF',
  IMAGE_JPEG = 'IMAGE_JPEG',
  IMAGE_PNG = 'IMAGE_PNG',
}

export type RescueAdoptionTransfersFilter = {
  status?: InputMaybe<PetAdoptionTransferStatus>;
};

export type RescueCancelPetAdoptionTransferInput = {
  petId: Scalars['ID']['input'];
};

export type RescueCancelPetAdoptionTransferResult = {
  __typename?: 'RescueCancelPetAdoptionTransferResult';
  transfer: RescueTransfer;
};

export type RescueCancelScheduledHandoffInput = {
  id: Scalars['ID']['input'];
};

export type RescueChipClaimEligibility = {
  __typename?: 'RescueChipClaimEligibility';
  /** Serial as supplied by the caller, normalized to uppercase. */
  serialNumber: Scalars['String']['output'];
  status: RescueChipClaimStatus;
};

export enum RescueChipClaimStatus {
  /** Chip exists with no reseller; can be claimed during import. */
  CLAIMABLE = 'CLAIMABLE',
  /** Chip is in the calling reseller's inventory. */
  IN_MY_INVENTORY = 'IN_MY_INVENTORY',
  /** Chip is already linked to a pet; cannot be claimed. */
  LINKED_TO_PET = 'LINKED_TO_PET',
  /** No chip exists with this serial number. */
  NOT_FOUND = 'NOT_FOUND',
  /** Chip exists but is not in working condition (e.g. damaged, deceased pet, missing); cannot be claimed. */
  NOT_USABLE = 'NOT_USABLE',
  /** Chip is owned by a different reseller; cannot be claimed. */
  OTHER_RESELLER = 'OTHER_RESELLER',
}

export type RescueCreateDeviceOrderInput = {
  /**
   * Must be true when `attestationVersion` is supplied — there is no path that files an order with a
   * declined attestation.
   */
  attestationAgreed?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The `version` served by `RescueDevicesProgram.deviceOrderAttestation`, echoed back to prove which
   * wording was agreed to. Rejected if it isn't the version currently in force, so a tab left open
   * across a terms change can't submit against superseded terms.
   *
   * Nullable only to keep clients that predate the attestation working; submissions that omit it are
   * accepted as before and record no attestation. Becomes required once the portal ships.
   */
  attestationVersion?: InputMaybe<Scalars['String']['input']>;
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  deviceQuantity: Scalars['Int']['input'];
  includeHardCases: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  shippingAddress: AddressInput;
};

export type RescueCreateDeviceOrderResult = {
  __typename?: 'RescueCreateDeviceOrderResult';
  ok: Scalars['Boolean']['output'];
  /**
   * Identifier of the persisted Order row (the DB-assigned numeric id, returned as a string).
   * Clients can retain this id and quote it in support flows; ops can use it directly to look
   * up the order in admin tools.
   */
  orderId: Scalars['ID']['output'];
};

export type RescueCreateFosterHomeInput = {
  contactEmail: Scalars['String']['input'];
  contactFirstName: Scalars['String']['input'];
  contactLastName?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber: Scalars['String']['input'];
};

export type RescueCreateNanoOrderInput = {
  /**
   * Number of nano-chip boxes to ship. Each box contains 20 chips (Fi Nano `F1-N-20` SKU). Singles
   * are not orderable through this flow — ops fulfills strictly in box increments.
   */
  boxQuantity: Scalars['Int']['input'];
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  shippingAddress: AddressInput;
};

export type RescueCreateNanoOrderResult = {
  __typename?: 'RescueCreateNanoOrderResult';
  ok: Scalars['Boolean']['output'];
  /**
   * Identifier of the persisted Order row (the DB-assigned numeric id, returned as a string).
   * Clients can retain this id and quote it in support flows; ops can use it directly to look
   * up the order in admin tools.
   */
  orderId: Scalars['ID']['output'];
};

export type RescueCreatePetAdoptionTransferInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  petId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type RescueCreatePetAdoptionTransferResult = {
  __typename?: 'RescueCreatePetAdoptionTransferResult';
  household: Household;
  inviteMessage?: Maybe<Scalars['String']['output']>;
  inviteUrl?: Maybe<Scalars['String']['output']>;
  transfer: RescueTransfer;
};

export type RescueCreatePetFosterTransferInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  petId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
  /**
   * Keep this foster home on the roster after the placement ends. Defaults to true; false writes no
   * record, so recall tears the household down and the home never reaches `rescueFosterHomes`.
   * Ignored when the contact already has an active home.
   */
  saveToRoster?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RescueCreatePetFosterTransferResult = {
  __typename?: 'RescueCreatePetFosterTransferResult';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Phase of an in-flight rescue CSV import, surfaced from the live BullMQ job progress. */
export enum RescueCsvImportPhase {
  APPLYING = 'APPLYING',
  FINALIZING = 'FINALIZING',
  PARSING = 'PARSING',
}

export type RescueCsvImportProgress = {
  __typename?: 'RescueCsvImportProgress';
  /** When the worker reached a terminal state, regardless of outcome. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * Row-level error messages, newest first. Every error from the run is kept on the job for its
   * lifetime (not capped); empty when there is no live job.
   */
  errors: Array<Scalars['String']['output']>;
  /** Rows the worker considered failed during apply. Null until the apply phase finishes. */
  finalFailed?: Maybe<Scalars['Int']['output']>;
  /**
   * Rows the worker successfully turned into a created/updated pet record. Null until the apply
   * phase finishes — for builds without apply logic, stays null through SUCCEEDED.
   */
  finalProcessed?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Live phase while the job is running, read from the BullMQ job rather than Postgres. Null once
   * the job is terminal and has aged out of the queue.
   */
  phase?: Maybe<RescueCsvImportPhase>;
  /** Rows failed so far this run (live, from the job). Distinct from the durable `finalFailed`. */
  rowsFailed?: Maybe<Scalars['Int']['output']>;
  /** Rows applied so far this run (live, from the job). Distinct from the durable `finalProcessed`. */
  rowsProcessed?: Maybe<Scalars['Int']['output']>;
  /**
   * Rows seen so far this run (live, from the job). Distinct from `totalRows`, which is the durable
   * final parse count. Null when there is no live job to read.
   */
  rowsSeen?: Maybe<Scalars['Int']['output']>;
  /** When the worker picked the job up. Null until the worker transitions QUEUED → RUNNING. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: RescueCsvImportStatus;
  /** Human-readable failure reason, populated only when status is FAILED. */
  terminalError?: Maybe<Scalars['String']['output']>;
  /**
   * Total number of data rows the worker parsed out of the CSV (excludes the header). Populated
   * once parsing completes; null while the worker is still in the parsing phase.
   */
  totalRows?: Maybe<Scalars['Int']['output']>;
};

/**
 * Lifecycle of a rescue CSV import. The Postgres row holds only these state transitions plus the
 * terminal counts; per-batch row counters and recent error samples live on the BullMQ job progress
 * while the job is RUNNING.
 */
export enum RescueCsvImportStatus {
  /** Worker errored out; `terminalError` populated. */
  FAILED = 'FAILED',
  /** Row created, BullMQ job enqueued, worker not yet picked it up. */
  QUEUED = 'QUEUED',
  /** Worker has picked up the job and is downloading / parsing / applying. */
  RUNNING = 'RUNNING',
  /** Worker finished successfully; `totalRows` and the `final*` counters are populated. */
  SUCCEEDED = 'SUCCEEDED',
}

export enum RescueDeviceFilter {
  COMPLETED_ADOPTIONS = 'COMPLETED_ADOPTIONS',
  IN_FOSTER = 'IN_FOSTER',
  IN_RESCUE = 'IN_RESCUE',
  PENDING_ADOPTIONS = 'PENDING_ADOPTIONS',
}

export type RescueDeviceItem = {
  __typename?: 'RescueDeviceItem';
  /** Current battery percentage (0-100). Null if unavailable. */
  batteryPercent?: Maybe<Scalars['Int']['output']>;
  /** Whether the pet's household has at least one safe zone configured. */
  hasSafeZone: Scalars['Boolean']['output'];
  /** Whether the pet's household has at least one wifi network configured. */
  hasWifiSetup: Scalars['Boolean']['output'];
  /** Whether the device is currently online (reporting as expected). */
  isOnline: Scalars['Boolean']['output'];
  pet: Pet;
  /** A transfer or adoption booked for a future time, if the pet has one. */
  scheduledHandoff?: Maybe<RescueScheduledHandoff>;
  /** Present for IN_FOSTER, PENDING_ADOPTIONS, and COMPLETED_ADOPTIONS. Null for IN_RESCUE. */
  transfer?: Maybe<RescueTransfer>;
};

/**
 * The commitment terms a rescue's next device order requires, and the id they are recorded under.
 *
 * Everything inside the agreement is served here — what the rescue verifies, what they acknowledge, and
 * the statement the checkbox attaches consent to — so a client cannot display one wording while
 * recording another. Surrounding chrome (modal title, "read and sign" instruction) belongs to the
 * client.
 *
 * Two conventions apply to every string below:
 *
 * - `{rescue}` is a placeholder for the organisation's own name. Substitute the name you already
 *   display; this API deliberately doesn't resolve it, since that would duplicate the portal's
 *   org-name lookup purely to interpolate a string.
 * - `**phrase**` marks a phrase the design sets in bold. Render it as emphasis, never as literal
 *   asterisks. Emphasis is presentation only, so it never changes `version`.
 */
export type RescueDeviceOrderAttestation = {
  __typename?: 'RescueDeviceOrderAttestation';
  /** The statement the agreement checkbox attaches consent to. */
  agreementLabel: Scalars['String']['output'];
  /** Qualifier shown under the heading; null when the terms apply to every order. */
  scopeNote?: Maybe<Scalars['String']['output']>;
  understandBullets: Array<Scalars['String']['output']>;
  understandHeading: Scalars['String']['output'];
  variant: RescueDeviceOrderAttestationVariant;
  verifyBullets: Array<Scalars['String']['output']>;
  verifyHeading: Scalars['String']['output'];
  /**
   * Opaque id naming this exact wording, recorded against the order when the rescue agrees. Clients echo
   * it back in `RescueCreateDeviceOrderInput` and must not assume a value — a submission carrying a
   * stale id is rejected, which is what stops a tab left open across a terms change from agreeing to
   * superseded terms.
   */
  version: Scalars['String']['output'];
};

export enum RescueDeviceOrderAttestationVariant {
  /** Every order after the first: rescue-chosen quantity, 7-day activation commitment. */
  STANDING = 'STANDING',
  /**
   * A rescue's first device order: fixed batch of 10 with hard cases, held for the point of adoption.
   * Selected until the rescue has placed one device order through the portal — a rescue with
   * pre-portal device history still starts here.
   */
  STARTER_BATCH = 'STARTER_BATCH',
}

export enum RescueDeviceSortKey {
  /** Adopter name on the pending transfer. PENDING_ADOPTIONS only. */
  ADOPTER = 'ADOPTER',
  DEVICE = 'DEVICE',
  /**
   * Foster household name. Null for rows with no active foster placement, which collate as the
   * lowest value in either direction.
   */
  HOLDER = 'HOLDER',
  PET = 'PET',
  /**
   * When the pet was placed with its current foster. Null outside IN_FOSTER, and collates as the
   * lowest value in either direction.
   */
  PLACED_ON = 'PLACED_ON',
  /** Age since the transfer was filed, so ascending runs freshest-first. PENDING_ADOPTIONS only. */
  STALLED = 'STALLED',
  /** When the adoption transfer was filed. PENDING_ADOPTIONS only. */
  TRANSFERRED = 'TRANSFERRED',
}

export type RescueDeviceStats = {
  __typename?: 'RescueDeviceStats';
  completedAdoptionsCount: Scalars['Int']['output'];
  inFosterCount: Scalars['Int']['output'];
  inRescueCount: Scalars['Int']['output'];
  pendingAdoptionsCount: Scalars['Int']['output'];
  scheduledHandoffsCount: Scalars['Int']['output'];
  /**
   * How long a pending adoption may sit before it counts as stalled without the rescue flagging it.
   * Drives both the `stalled` filter on rescueDevices and the Devices page's section copy.
   */
  stalledTransferThresholdDays: Scalars['Int']['output'];
  /** inRescueCount + inFosterCount (devices actively in the rescue's inventory). */
  totalActiveDevices: Scalars['Int']['output'];
};

export type RescueDevicesInput = {
  /** Only return completed adoptions after this date. Defaults to all time if omitted. */
  completedSince?: InputMaybe<Scalars['DateTime']['input']>;
  filter: RescueDeviceFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Search across pet name, module ID, and holder name (case-insensitive partial match).
   * For IN_FOSTER the holder name is the one the row's transfer reports — the foster person —
   * as well as the foster household's own name.
   */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to ASC when sortKey is given. */
  sortDirection?: InputMaybe<SortDirection>;
  /**
   * Omit for the default ordering (pet name ascending). Only honoured by the IN_RESCUE and
   * IN_FOSTER filters; the adoption filters keep their fixed ordering.
   */
  sortKey?: InputMaybe<RescueDeviceSortKey>;
  /**
   * Narrows PENDING_ADOPTIONS to stalled (true) or fresh (false) transfers. A transfer is stalled
   * once the rescue flags it or it ages past stalledTransferThresholdDays, whichever comes first.
   * Omit for the union, which is what rescueDeviceStats counts.
   */
  stalled?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Represents the current rescue user's enrollment in the Fi devices program.
 * Persistence is via membership in the `RescueAdoptionBetaTester` user group.
 */
export type RescueDevicesProgram = {
  __typename?: 'RescueDevicesProgram';
  /** The attestation the rescue's *next* device order will require. */
  deviceOrderAttestation: RescueDeviceOrderAttestation;
  enrolled: Scalars['Boolean']['output'];
  /**
   * The rescue's device order awaiting Fi review, or null when they have none outstanding.
   *
   * Non-null means `rescueCreateDeviceOrder` will reject a new order with a 409 — one outstanding
   * request at a time — so clients should present the pending order in place of the order form
   * rather than letting a rescue fill one out that cannot be filed.
   */
  pendingDeviceOrder?: Maybe<RescuePendingDeviceOrder>;
};

export type RescueDevicesResult = {
  __typename?: 'RescueDevicesResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<RescueDeviceItem>;
  totalCount: Scalars['Int']['output'];
};

export type RescueDocument = {
  __typename?: 'RescueDocument';
  documentType: RescueDocumentType;
  /** Time-limited signed URL for downloading the document. Generated fresh on each query (~60s TTL). */
  downloadUrl: Scalars['String']['output'];
  /**
   * Date-only, `YYYY-MM-DD`. When the document stops being good, set by a reviewer. Null means it
   * carries no expiry, which is the common case — most jurisdictions issue blanket certificates that
   * don't lapse.
   */
  expirationDate?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the document is approved and past its expiry date. Derived from `expirationDate` on read
   * rather than stored, so it can't be stale.
   */
  expired: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  originalFileName: Scalars['String']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  /**
   * The jurisdiction whose rules asked for this document, recorded at submission. Null for documents
   * filed before the exemption flow existed, and for uploads made where no requirement could be stated.
   */
  requestedForState?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  sizeBytes: Scalars['Int']['output'];
  status: RescueDocumentStatus;
  uploadedAt: Scalars['DateTime']['output'];
};

export enum RescueDocumentStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  SUPERSEDED = 'SUPERSEDED',
}

export enum RescueDocumentType {
  /**
   * The IRS 501(c)(3) determination letter, collected for identity. The signed attestation carries the
   * exemption, not this document.
   */
  DETERMINATION_LETTER = 'DETERMINATION_LETTER',
  /**
   * The pre-existing upload, collected for marketing compliance before the exemption flow existed.
   * Distinct from `DETERMINATION_LETTER`, which is the same kind of letter requested by the exemption
   * flow against a particular state's rules.
   */
  FORM_501C3 = 'FORM_501C3',
  /**
   * Proof that a shelter is a department of a city, county or state. Stands in for the determination
   * letter where the organisation is a government entity.
   */
  GOV_STATUS_PROOF = 'GOV_STATUS_PROOF',
  /**
   * A purchaser-completed exemption form the jurisdiction also accepts, filed instead of the document
   * we asked for. Set by a reviewer, never by the portal.
   */
  PURCHASER_FORM = 'PURCHASER_FORM',
  /** The exemption certificate a rescue's state issued them, in the three states that issue one. */
  STATE_CERT = 'STATE_CERT',
}

export type RescueEnableShelterluvInput = {
  apiKey: Scalars['String']['input'];
  thirdPartyChipBackfillEnabled: Scalars['Boolean']['input'];
  thirdPartyChipIncrementalEnabled: Scalars['Boolean']['input'];
};

/**
 * A signature a rescue made. Write-once: certifying again files a new record rather than amending this
 * one, because an audit record that can be amended isn't one.
 */
export type RescueExemptionAttestationRecord = {
  __typename?: 'RescueExemptionAttestationRecord';
  agreedAt: Scalars['DateTime']['output'];
  exemptionNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Federal EIN as the officer entered it, and the number on a state-issued certificate where the
   * jurisdiction assigns one. Only the three certificate jurisdictions do, so `exemptionNumber` is null
   * elsewhere — never asked rather than none issued.
   */
  fein: Scalars['String']['output'];
  /** Who certified, and in what capacity. A state exemption requires an officer of the organisation. */
  officerName: Scalars['String']['output'];
  officerTitle: Scalars['String']['output'];
  /**
   * The purchaser form this certification stood in for, recorded at signing rather than re-derived:
   * Finance can change which form a jurisdiction names, and a filed copy has to keep saying what was
   * signed.
   */
  purchaserFormShown?: Maybe<Scalars['String']['output']>;
  /**
   * The jurisdiction whose rules the signature was made under, recorded at signing rather than
   * re-derived — a rescue can relocate, and this names the rules that applied.
   */
  state: Scalars['String']['output'];
  text: RescueExemptionAttestationText;
  /** The heading the signer actually saw, stored because one wording carries two titles. */
  titleShown: Scalars['String']['output'];
  /**
   * The version of the wording that was signed. Resolving it back to sentences is a server-side lookup
   * against an append-only map, not something clients can reconstruct.
   */
  version: Scalars['String']['output'];
};

/**
 * The wording to present, paired with the version that identifies it. A submission carrying a stale
 * `version` is rejected, so a tab left open across a wording change can't certify against sentences its
 * signer never read.
 */
export type RescueExemptionAttestationTerms = {
  __typename?: 'RescueExemptionAttestationTerms';
  /**
   * The purchaser form the statement says it replaces, or null where the jurisdiction names none.
   * Echoed back on submission and stored with the signature.
   */
  purchaserForm?: Maybe<Scalars['String']['output']>;
  /**
   * The whole of what the rescue certifies, as one sentence. `**phrase**` marks phrases the design sets
   * in bold, and `{rescue}` is replaced with the organisation name the portal already displays. The
   * jurisdiction is already named, so a filed copy renders the sentence the signer read.
   */
  statement: Scalars['String']['output'];
  text: RescueExemptionAttestationText;
  /**
   * The heading to show. Not derivable from `text` alone: the exemption wording is titled differently
   * depending on whether the jurisdiction also issues a certificate.
   */
  title: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum RescueExemptionAttestationText {
  /**
   * Claims a sales-tax exemption. Used wherever one is granted, whatever kind of organisation the
   * rescue is — the claim is the same either way.
   */
  EXEMPTION = 'EXEMPTION',
  /** Confirms 501(c)(3) status and nothing more, where the jurisdiction grants no exemption. */
  FEDERAL = 'FEDERAL',
  /** Confirms government-entity status and nothing more. A government body has no 501(c)(3) to cite. */
  GOVERNMENT = 'GOVERNMENT',
}

/**
 * An advisory for the portal. Pairs what's wrong with what the rescue can do about it, so the same
 * message can point at the account page or at support without the client deciding which.
 */
export type RescueExemptionNotice = {
  __typename?: 'RescueExemptionNotice';
  kind: RescueExemptionNoticeKind;
  remedy: RescueExemptionNoticeRemedy;
};

export enum RescueExemptionNoticeKind {
  /** No registered address, so we can't say which document to ask for. */
  ADDRESS_REQUIRED = 'ADDRESS_REQUIRED',
  /** We hold no position for this jurisdiction. Puerto Rico is the live case. */
  JURISDICTION_UNSUPPORTED = 'JURISDICTION_UNSUPPORTED',
  /**
   * We don't know what kind of organisation this is, and a government body needs a different document
   * from a 501(c)(3).
   */
  MAY_BE_GOVERNMENT_ENTITY = 'MAY_BE_GOVERNMENT_ENTITY',
}

export enum RescueExemptionNoticeRemedy {
  /** There is nothing for the rescue to edit, so the only route is support. */
  CONTACT_SUPPORT = 'CONTACT_SUPPORT',
  /**
   * The rescue can fix this themselves on the account page, because they have a reseller record whose
   * address and organisation type are editable there.
   */
  SELF_SERVE_ACCOUNT_PAGE = 'SELF_SERVE_ACCOUNT_PAGE',
}

export enum RescueExemptionRequirement {
  /** Nothing state-issued exists to upload, so the signature is the exemption certificate. */
  ATTESTATION = 'ATTESTATION',
  /**
   * No registered address, so no requirement can be stated. Ask for the address rather than presenting
   * an outcome.
   */
  NO_STATE_ON_FILE = 'NO_STATE_ON_FILE',
  /** The jurisdiction issues the rescue a certificate, which they upload. */
  STATE_CERTIFICATE = 'STATE_CERTIFICATE',
  /**
   * We hold no position for this jurisdiction — US territories, which levy their own taxes rather than
   * a state sales tax. No exemption is offered and none is refused.
   */
  UNMAPPED_JURISDICTION = 'UNMAPPED_JURISDICTION',
  /**
   * No sales-tax exemption is claimed. Either the jurisdiction levies no sales tax, or the exemption it
   * offers doesn't reach non-profits. The document collected verifies the organisation instead.
   */
  VERIFY_ONLY = 'VERIFY_ONLY',
}

/**
 * What a rescue must do to claim a sales-tax exemption. Every jurisdiction we hold a position for asks
 * for exactly one document and one signature; what differs is which document, and what the signature
 * represents. Two further outcomes state no requirement at all, and the portal should ask for an
 * address rather than present an outcome.
 */
export type RescueExemptionStatus = {
  __typename?: 'RescueExemptionStatus';
  /**
   * The wording to present and the version a submission must echo back. Null only where no requirement
   * can be stated.
   */
  attestation?: Maybe<RescueExemptionAttestationTerms>;
  /**
   * Whether `signedAttestation` was made against the wording currently in force. False means the terms
   * have been revised and the rescue is asked to certify again.
   */
  attestationIsCurrent: Scalars['Boolean']['output'];
  /**
   * Nothing is outstanding: an approved, unexpired document is on file and the signature is current.
   * True in a `VERIFY_ONLY` jurisdiction once both are done — so this is not the same as holding an
   * exemption. Read `requirement` for that.
   */
  complete: Scalars['Boolean']['output'];
  /**
   * The document on file, of `requiredDocumentType`. Null until one is uploaded; check `status` and
   * `expired` before treating it as accepted.
   */
  document?: Maybe<RescueDocument>;
  /**
   * Advisories to surface. Derived server-side, so the portal renders them without needing to know
   * which record a missing address or organisation type actually lives on.
   */
  notices: Array<RescueExemptionNotice>;
  /**
   * A purchaser-completed form the jurisdiction names, offered as an alternative route. Advisory — the
   * signature satisfies the jurisdiction either way. Null both where no form can be named and where
   * Finance hasn't yet supplied the number; in both cases no pointer renders.
   */
  purchaserForm?: Maybe<Scalars['String']['output']>;
  /** Which document to ask for. Null only where no requirement can be stated. */
  requiredDocumentType?: Maybe<RescueDocumentType>;
  requirement: RescueExemptionRequirement;
  /**
   * The signature already on file, or null if the rescue has never certified. Retained after the
   * wording changes rather than discarded — it stays a valid record of what was certified and when.
   */
  signedAttestation?: Maybe<RescueExemptionAttestationRecord>;
  /**
   * The jurisdiction whose rules apply, as a two-letter code. Null only when `requirement` is
   * `NO_STATE_ON_FILE`.
   */
  state?: Maybe<Scalars['String']['output']>;
  /**
   * The certificate the jurisdiction issues, which the rescue uploads. Set only when `requirement` is
   * `STATE_CERTIFICATE`.
   */
  stateIssuedForm?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the rescue can act on this card. False where no requirement can be stated, which is the
   * portal's cue to disable the uploader and show the notice instead.
   */
  uploadEnabled: Scalars['Boolean']['output'];
};

export type RescueFosterHome = {
  __typename?: 'RescueFosterHome';
  /**
   * Placements currently open — the home's occupancy right now, as opposed to placementCount's
   * lifetime total.
   */
  activePlacementCount: Scalars['Int']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFirstName: Scalars['String']['output'];
  contactLastName?: Maybe<Scalars['String']['output']>;
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fosterHousehold: Household;
  /** Whether the foster household has any safe zone (Place) configured. */
  hasSafeZone: Scalars['Boolean']['output'];
  /** Whether the foster household has any wifi network configured. */
  hasWifiSetup: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Pets this rescue has placed into the home over its lifetime, not its current occupancy — a recall
   * leaves the count where it is. Exactly `placements.length`: prefer `placements` when you need the
   * detail, and this when you only need the total.
   *
   * 0 for a home set up but never used, and for a home whose placements all predate the ledger this
   * counts — it does not include placements made before individual placements were recorded.
   */
  placementCount: Scalars['Int']['output'];
  /**
   * Every placement this rescue has made into the home, newest first, including the one in progress.
   * Empty for a home set up but never used, and for a home whose placements all predate this ledger.
   */
  placements: Array<RescueFosterPlacement>;
};

export enum RescueFosterHomeSortKey {
  /** Contact display name. */
  FOSTER = 'FOSTER',
  /** Lifetime placement count. */
  PLACEMENTS = 'PLACEMENTS',
  /** Number of placements currently open — what the roster's Status column shows. */
  STATUS = 'STATUS',
}

export type RescueFosterHomesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Case-insensitive partial match against contact name, email, and phone number. */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to ASC when sortKey is given. */
  sortDirection?: InputMaybe<SortDirection>;
  /** Omit to keep the default newest-first ordering. */
  sortKey?: InputMaybe<RescueFosterHomeSortKey>;
};

export type RescueFosterHomesResult = {
  __typename?: 'RescueFosterHomesResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<RescueFosterHome>;
  totalCount: Scalars['Int']['output'];
};

/** One pet's stay in one foster home. Open — the pet is there now — while `recalledAt` is null. */
export type RescueFosterPlacement = {
  __typename?: 'RescueFosterPlacement';
  endedReason?: Maybe<RescueFosterPlacementEndedReason>;
  fosteredAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The pet's name when it was placed, which is not necessarily its name today. */
  petName: Scalars['String']['output'];
  recalledAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum RescueFosterPlacementEndedReason {
  ADOPTED = 'ADOPTED',
  RECALLED = 'RECALLED',
  /**
   * The pet left by a route that doesn't record placements — an admin household move, a boarding
   * transfer — and the ledger only noticed when the pet turned up somewhere else. `recalledAt` is when
   * we noticed, not when the pet actually left.
   */
  UNKNOWN = 'UNKNOWN',
}

export type RescueGet501c3UploadUrlInput = {
  /**
   * File format the client will upload. The `Content-Type` header sent on the PUT to the returned URL
   * must match the MIME type this enum resolves to (`APPLICATION_PDF` → `application/pdf`); S3 rejects
   * a header that doesn't match the signed URL.
   */
  contentType: Rescue501c3ContentType;
};

export type RescueGetImportUploadUrlInput = {
  /**
   * File format the client will upload. The Content-Type header sent on the PUT to the returned
   * URL must match the MIME type this enum resolves to (e.g. `TEXT_CSV` → `text/csv`); S3 rejects
   * mismatched headers against the signed URL.
   */
  contentType: RescueImportContentType;
};

/**
 * A request to print a batch of identical GWA postcards for a rescue and ship them in one parcel to
 * the rescue. `status` is one of: pending_approval, queued, submitted, in_production, shipped,
 * delivered, failed, cancelled. Self-service orders start in pending_approval and move to queued when
 * ops approves (Slack button or admin mutation); admin-placed orders start in queued.
 */
export type RescueGwaPostcardOrder = {
  __typename?: 'RescueGwaPostcardOrder';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Who approved the order: `slack:<name>` for Slack-button approvals, `admin:<email>` for
   * admin-placed or admin-approved orders. Null while pending approval or after rejection.
   */
  approvedBy?: Maybe<Scalars['String']['output']>;
  /** Carrier as the vendor names it — `USPS` for Click2Mail, the shipment-method name for Gelato. */
  carrier?: Maybe<Scalars['String']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /**
   * Diagnostic detail for a failed or rejected order. Admin-only: it carries raw vendor and internal
   * error text, so it resolves to null for a rescue reading its own order — `status` is what tells them
   * the outcome.
   */
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  providerJobId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  /** `self_service` or `admin`. */
  requestSource: Scalars['String']['output'];
  /**
   * Where the batch ships, from the snapshot captured at request time. Null when no snapshot was
   * captured.
   */
  shipTo?: Maybe<RescueGwaPostcardOrderShipTo>;
  /** When the batch was first seen as shipped, not when the vendor shipped it. */
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  /**
   * Tracking number for the parcel carrying the whole batch. Null until the vendor reports one, which
   * can lag `shipped` by a poll cycle or two.
   */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RescueGwaPostcardOrderShipTo = {
  __typename?: 'RescueGwaPostcardOrderShipTo';
  city: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  /** Recipient name from the snapshot (the order's contact person). Null when the snapshot has none. */
  name?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type RescueGwaProgram = {
  __typename?: 'RescueGwaProgram';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** How the rescue was enrolled: `self_service`, `shelterluv_auto_enroll`, `fi_nano_auto_enroll`, or null for legacy enrollments. */
  enrollmentType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Last-30-day redemption counts grouped by source; sums to `monthRedemptions`. */
  last30DaysRedemptionSourceCounts: Array<GwaRedemptionSourceCount>;
  monthRedemptions: Scalars['Int']['output'];
  pdpUrl: Scalars['String']['output'];
  promoCodeAlias: Scalars['String']['output'];
  recentRedemptions: Array<GwaRedemption>;
  /** All-time redemption counts grouped by source; sums to `totalRedemptions`. */
  redemptionSourceCounts: Array<GwaRedemptionSourceCount>;
  slug: Scalars['String']['output'];
  totalRedemptions: Scalars['Int']['output'];
  user: User;
};

export enum RescueImportContentType {
  TEXT_CSV = 'TEXT_CSV',
}

export type RescueMarkAdoptionTransferNotRecoveredInput = {
  petId: Scalars['ID']['input'];
};

export type RescueMarkAdoptionTransferNotRecoveredResult = {
  __typename?: 'RescueMarkAdoptionTransferNotRecoveredResult';
  transfer: RescueTransfer;
};

export type RescueMarkAdoptionTransferRecoveredInput = {
  petId: Scalars['ID']['input'];
};

export type RescueMarkAdoptionTransferRecoveredResult = {
  __typename?: 'RescueMarkAdoptionTransferRecoveredResult';
  transfer: RescueTransfer;
};

export type RescueMarkAdoptionTransferStalledInput = {
  petId: Scalars['ID']['input'];
};

export type RescueMarkAdoptionTransferStalledResult = {
  __typename?: 'RescueMarkAdoptionTransferStalledResult';
  transfer: RescueTransfer;
};

/**
 * A single shipment that contains Fi nano line items for one of the rescue user's orders.
 * Returned by `rescueNanoShipments`. Same semantics as `RescueOrderShipment` (delivered shipments
 * are included alongside in-flight ones; use `shipmentStatus` to distinguish them), but limited to
 * shipments containing a nano SKU so the rescue can track microchip deliveries separately from
 * collar / hard-case orders.
 */
export type RescueNanoShipment = {
  __typename?: 'RescueNanoShipment';
  /**
   * Total number of chips contained in this shipment across its nano line items. A box-shipped
   * line item (`F1-N-20`) contributes 20 chips per quantity; single-chip line items (`F1-N-1`)
   * contribute one chip per quantity. Non-nano line items on the same shipment are not counted.
   */
  chipCount: Scalars['Int']['output'];
  /** Date of the most recent contributing order (matches the sort key used by `rescueNanoShipments`). */
  orderDate: Scalars['DateTime']['output'];
  /**
   * Fi order IDs (the internal `Order.id` primary key, rendered as a string) of every order that
   * contributed nano line items to this shipment. The source-system `orderSourceId` is not used
   * here because rescue orders carry a randomly-generated source ID that is not meaningful to
   * operators.
   */
  orderNumbers: Array<Scalars['String']['output']>;
  /** Where the shipment is in its progression, including DELIVERED for completed shipments. */
  shipmentStatus: RescueOrderShipmentStatus;
  /** Tracking number from the first package on the shipment, or null if no carrier handoff has occurred yet. */
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * A single Fi-device shipment for one of the rescue user's orders. Returned by
 * `rescueOrderShipments`. Limited to shipments that contain at least one Fi tracker line item so
 * the rescue portal does not surface pure-accessory (hard-case-only) or pure-nano shipments here —
 * those are tracked through `rescueNanoShipments`. Orders that produce multiple shipments appear
 * once per shipment so partial deliveries can be tracked independently. Delivered shipments are
 * included alongside in-flight ones; use `shipmentStatus` to distinguish them.
 */
export type RescueOrderShipment = {
  __typename?: 'RescueOrderShipment';
  /** Total number of Fi device units in this shipment (sum of quantities over Fi-device line items only — accessories on the same shipment are not counted). */
  deviceCount: Scalars['Int']['output'];
  /** Date of the most recent contributing order (matches the sort key used by `rescueOrderShipments`). */
  orderDate: Scalars['DateTime']['output'];
  /**
   * Fi order IDs (the internal `Order.id` primary key, rendered as a string) of every order that
   * contributed line items to this shipment. Most shipments have a single entry; consolidated
   * multi-order shipments include every contributing order. The source-system `orderSourceId` is
   * not used here because rescue orders carry a randomly-generated source ID that is not meaningful
   * to operators.
   */
  orderNumbers: Array<Scalars['String']['output']>;
  /** Where the shipment is in its progression, including DELIVERED for completed shipments. */
  shipmentStatus: RescueOrderShipmentStatus;
  /** Tracking number from the first package on the shipment, or null if no carrier handoff has occurred yet. */
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * Customer-facing shipment progression for `rescueOrderShipments`. We collapse the underlying
 * OrderShipmentStatus into the few states a rescue user actually cares about; delivered
 * shipments are filtered out by the resolver and so are not represented here.
 */
export enum RescueOrderShipmentStatus {
  /** The shipment was canceled before delivery. */
  CANCELED = 'CANCELED',
  /** The shipment has been delivered to the recipient. */
  DELIVERED = 'DELIVERED',
  /** The shipment has been placed but not yet handed to the carrier. */
  ORDERED = 'ORDERED',
  /** The shipment has been handed to the carrier and is in transit. */
  SHIPPED = 'SHIPPED',
}

/**
 * A filed device order that Fi has not yet approved or rejected. It clears when ops acts on it; there
 * is no timeout that releases it on its own, so a client has no wait to quote.
 */
export type RescuePendingDeviceOrder = {
  __typename?: 'RescuePendingDeviceOrder';
  /**
   * Fi Minis requested. Excludes the hard-case packs that ship alongside them, and any line the Fi
   * team has since canceled.
   */
  deviceQuantity: Scalars['Int']['output'];
  /**
   * Ready-to-render copy for the blocked state — the same sentence `rescueCreateDeviceOrder` returns
   * with its 409. Served so the portal doesn't keep a second copy of this wording that can drift from
   * what a rescue sees if they submit anyway.
   */
  message: Scalars['String']['output'];
  /**
   * Identifier of the pending Order row, in the same form `RescueCreateDeviceOrderResult.orderId`
   * returns — so a rescue can match it against the confirmation they were shown.
   */
  orderId: Scalars['ID']['output'];
  submittedAt: Scalars['DateTime']['output'];
};

export type RescuePet = {
  __typename?: 'RescuePet';
  pet: Pet;
  scheduledHandoff?: Maybe<RescueScheduledHandoff>;
  transfer?: Maybe<RescueTransfer>;
};

export enum RescuePetAdoptionState {
  COMPLETED = 'COMPLETED',
  NONE = 'NONE',
  PENDING = 'PENDING',
}

/**
 * Context for creating an RMA when the lookup matched a rescue-obtained device. Populated by
 * `rmaLookupBySerialNumber` when the device qualifies through `OrderChannel.RESCUE` on a
 * matched order, or the rescue-device note paired with the pet's current household being
 * rescue-flagged (type RESCUE, or has a Rescue-typed chip reseller).
 */
export type RescueRMAContext = {
  __typename?: 'RescueRMAContext';
  /** Email of the resolved user, for autofilling the customer info form. */
  customerEmail: Scalars['String']['output'];
  /** First name + last name of the resolved user, for autofilling the customer info form. */
  customerName: Scalars['String']['output'];
  /**
   * Module product SKU derived from the device's collar product. Frontend uses this to
   * synthesize a line item when no order was found, so the replacement order step of RMA
   * creation has something to decompose.
   */
  moduleProductSku: Scalars['String']['output'];
  /**
   * User the RMA should be assigned to (current pet owner). For stale-household rescue cases
   * (pet adopted out from a rescue household), this is the new owner — not the rescue org user
   * that placed the original order. Admin forwards this through `CreateRMAInput.userId`.
   */
  userId: Scalars['ID']['output'];
};

export type RescueRecallPetFosterTransferInput = {
  petId: Scalars['ID']['input'];
  /**
   * Keep this foster home on the roster instead of tearing it down. Defaults to false: recall of an
   * unsaved home behaves as before. Ignored for a home already on the roster, which recall preserves
   * either way. Best-effort — a home whose foster contact can't be resolved is torn down and logged.
   */
  saveToRoster?: InputMaybe<Scalars['Boolean']['input']>;
  unassignBaseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RescueRecallPetFosterTransferResult = {
  __typename?: 'RescueRecallPetFosterTransferResult';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RescueRecallPetInput = {
  petId: Scalars['ID']['input'];
  unassignBaseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RescueRecallPetResult = {
  __typename?: 'RescueRecallPetResult';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RescueRequestGwaPostcardsInput = {
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  shippingAddress: AddressInput;
};

export type RescueRescheduleHandoffInput = {
  id: Scalars['ID']['input'];
  scheduledFor: Scalars['DateTime']['input'];
  scheduledForTimezone: Scalars['String']['input'];
};

/**
 * A user found by `Admin.rescueOrResellerSearch` with the rescue/reseller
 * classifications attached. Built so future categories (foster, vet, etc.) can
 * be added as additional booleans without breaking callers.
 */
export type RescueResellerSearchResult = {
  __typename?: 'RescueResellerSearchResult';
  /**
   * The user's current (non-superseded) 501(c)(3) document, if one has been
   * uploaded. Null for users with no document on file or non-rescue users.
   */
  current501c3Document?: Maybe<RescueDocument>;
  /**
   * The current document filed against the exemption flow — a state certificate, determination letter,
   * proof of government status, or the purchaser form a reviewer re-typed. Distinct from
   * `current501c3Document`, which is the pre-exemption marketing upload: a rescue can have either,
   * both, or neither.
   */
  currentExemptionDocument?: Maybe<RescueDocument>;
  /**
   * The signature on file, or null if the rescue has never certified. A document without one is only
   * half of what the jurisdiction asks for.
   */
  exemptionAttestation?: Maybe<RescueExemptionAttestationRecord>;
  /**
   * Time-limited URL for the filed PDF of that signature. Null when no signature exists. Generated
   * fresh on each read (~5m TTL).
   */
  exemptionAttestationPdfUrl?: Maybe<Scalars['String']['output']>;
  /**
   * True when the user has a chip-reseller record of type RESCUE. The search
   * excludes non-rescue chip-reseller types entirely, so this can only ever be
   * true for the RESCUE type.
   */
  isChipReseller: Scalars['Boolean']['output'];
  isRescueUser: Scalars['Boolean']['output'];
  /**
   * The user's RESCUE-typed household, when they have one. Null for non-rescue
   * users or rescue users who haven't been assigned to a household yet.
   */
  rescueHousehold?: Maybe<Household>;
  user: User;
};

export type RescueRosterInput = {
  /**
   * Narrows to pets with (true) or without (false) a device. Orthogonal to `status` rather than a
   * fourth value of it.
   */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Case-insensitive partial match against pet name and breed name. */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to DESC for STATUS and ASC otherwise. */
  sortDirection?: InputMaybe<SortDirection>;
  /** Defaults to STATUS. */
  sortKey?: InputMaybe<RescueRosterSortKey>;
  status?: InputMaybe<RescueRosterStatusFilter>;
};

export type RescueRosterResult = {
  __typename?: 'RescueRosterResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<RescueRosterRow>;
  totalCount: Scalars['Int']['output'];
};

export type RescueRosterRow = {
  __typename?: 'RescueRosterRow';
  /**
   * Matched by pet rather than through `Pet.chip`, which goes null for pending and adopted pets once
   * the rescue's household membership lapses even though the rescue still owns the chip.
   */
  chip?: Maybe<AssignedChip>;
  /** The adopter snapshot for a PENDING_ADOPTION row; null for every other status. */
  pendingAdoption?: Maybe<RescueTransfer>;
  pet: Pet;
  status: RescueRosterStatus;
  /**
   * The timestamp the Status column reads: the transfer's for a foster or adoption, the pet's own
   * otherwise. Null only when the underlying record has none.
   */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum RescueRosterSortKey {
  CHIP = 'CHIP',
  DEVICE = 'DEVICE',
  NAME = 'NAME',
  /**
   * The Status column, which orders on the row's `updatedAt` rather than the status itself. Undated
   * rows sort last in both directions.
   */
  STATUS = 'STATUS',
}

/**
 * A rescue's durable record of a foster home — the mapping to a volunteer's household plus the
 * contact snapshot. Persists across placements; drops out of `rescueFosterHomes` once archived.
 */
export enum RescueRosterStatus {
  ADOPTED = 'ADOPTED',
  FOSTER = 'FOSTER',
  PENDING_ADOPTION = 'PENDING_ADOPTION',
  RESCUE = 'RESCUE',
}

/**
 * The roster's status chips. ADOPTED covers both pending and completed adoptions, matching how the
 * Dashboard presents them.
 */
export enum RescueRosterStatusFilter {
  ADOPTED = 'ADOPTED',
  FOSTER = 'FOSTER',
  RESCUE = 'RESCUE',
}

export type RescueScheduleHandoffInput = {
  /** Chip serial number or short id, when the pet's chip should move with the adoption. */
  chipId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Omitted for ADOPTION_FROM_FOSTER, where the current foster is the adopter. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  kind: RescueScheduledHandoffKind;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  petId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * Take the pet back from its current foster first — moving a fostered pet
   * straight to a different foster or to an adopter. Always on for ADOPTION_FROM_FOSTER.
   */
  recallFirst?: InputMaybe<Scalars['Boolean']['input']>;
  saveToRoster?: InputMaybe<Scalars['Boolean']['input']>;
  /** The absolute instant to run at, resolved by the client from the picked wall-clock time. */
  scheduledFor: Scalars['DateTime']['input'];
  /** IANA zone that wall-clock time was picked in (e.g. \"America/Los_Angeles\"). */
  scheduledForTimezone: Scalars['String']['input'];
};

/**
 * A transfer or adoption the rescue has booked for a future time. Nothing about the pet, its collar, or its
 * household changes until `scheduledFor`, when the server runs the same action the immediate
 * mutations run.
 */
export type RescueScheduledHandoff = {
  __typename?: 'RescueScheduledHandoff';
  /**
   * The adoption ran but the microchip could not be moved to the adopter. Status stays COMPLETED --
   * the transfer is already pending and re-running it would duplicate.
   */
  chipFailureReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Why it could not run at its scheduled time. Set only when status is FAILED. */
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: RescueScheduledHandoffKind;
  notes?: Maybe<Scalars['String']['output']>;
  pet: Pet;
  /** Whether the pet is taken back from its current foster before this runs. */
  recallFirst: Scalars['Boolean']['output'];
  scheduledFor: Scalars['DateTime']['output'];
  /** IANA zone the time was picked in, so it can be redisplayed as the rescue chose it. */
  scheduledForTimezone: Scalars['String']['output'];
  status: RescueScheduledHandoffStatus;
  toEmail?: Maybe<Scalars['String']['output']>;
  toFirstName: Scalars['String']['output'];
  toLastName?: Maybe<Scalars['String']['output']>;
  toPhone?: Maybe<Scalars['String']['output']>;
};

export enum RescueScheduledHandoffKind {
  ADOPTION = 'ADOPTION',
  ADOPTION_FROM_FOSTER = 'ADOPTION_FROM_FOSTER',
  FOSTER = 'FOSTER',
}

export type RescueScheduledHandoffResult = {
  __typename?: 'RescueScheduledHandoffResult';
  handoff: RescueScheduledHandoff;
};

export enum RescueScheduledHandoffStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  EXECUTING = 'EXECUTING',
  FAILED = 'FAILED',
  SCHEDULED = 'SCHEDULED',
}

export type RescueSendSmsInput = {
  message: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type RescueSendSmsResult = {
  __typename?: 'RescueSendSmsResult';
  ok: Scalars['Boolean']['output'];
};

export type RescueSignExemptionAttestationInput = {
  /**
   * The number on the certificate being filed. Accepted only where the jurisdiction issues one, and
   * rejected elsewhere rather than stored as a number the rescue invented.
   */
  exemptionNumber?: InputMaybe<Scalars['String']['input']>;
  /** Federal EIN, nine digits with or without the hyphen. */
  fein: Scalars['String']['input'];
  officerName: Scalars['String']['input'];
  officerTitle: Scalars['String']['input'];
  /**
   * The `version` served by `RescueExemptionStatus.attestation`, echoed back to prove which wording was
   * certified against. Rejected if it isn't the version currently in force.
   */
  version: Scalars['String']['input'];
};

export type RescueStartImportInput = {
  /**
   * S3 key the rescue portal received from `rescueGetImportUploadUrl` and just PUT the CSV to.
   * Must start with `rescue-import-files/{callerResellerId}/`; otherwise the call is rejected.
   * Calling twice with the same key is idempotent — the existing row is returned, no second job is
   * enqueued.
   */
  uploadedFileKey: Scalars['String']['input'];
};

/**
 * Which of the three shapes a jurisdiction takes. Each has exactly one legal field combination, so a
 * row cannot sit half-way between two buckets.
 */
export enum RescueStateExemptionBucket {
  /** Nothing state-issued exists to upload, so the signed attestation is the exemption certificate. */
  ATTESTATION_IS_CERTIFICATE = 'ATTESTATION_IS_CERTIFICATE',
  /** The jurisdiction issues the rescue a certificate, which they upload. */
  STATE_CERTIFICATE = 'STATE_CERTIFICATE',
  /** No sales-tax exemption is claimed. The document collected verifies the organisation instead. */
  VERIFY_ONLY = 'VERIFY_ONLY',
}

/**
 * One jurisdiction's rule for what a rescue registered there is asked to do. Lives in the database
 * rather than in code because Finance owns these positions and corrects them without a deploy.
 */
export type RescueStateExemptionRule = {
  __typename?: 'RescueStateExemptionRule';
  bucket: RescueStateExemptionBucket;
  id: Scalars['ID']['output'];
  /**
   * A purchaser-completed form the jurisdiction names, offered to the rescue as an alternative route.
   * Advisory — the signed attestation satisfies the jurisdiction either way. Null both where no form
   * can be named and where Finance has not yet supplied the number; in both cases no pointer renders.
   */
  purchaserForm?: Maybe<Scalars['String']['output']>;
  /** Two-letter jurisdiction code, uppercase. */
  state: Scalars['String']['output'];
  /**
   * The certificate the jurisdiction issues, which the rescue uploads. Set only on
   * `STATE_CERTIFICATE` rows, where it is required.
   */
  stateIssuedForm?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Why no exemption is claimed. Required on `VERIFY_ONLY` rows and forbidden elsewhere. For internal
   * review only — never served to a rescue.
   */
  verifyOnlyReason?: Maybe<Scalars['String']['output']>;
};

export type RescueStories = {
  __typename?: 'RescueStories';
  hasNext: Scalars['Boolean']['output'];
  stories: Array<RescueStory>;
};

export type RescueStory = {
  __typename?: 'RescueStory';
  body: Scalars['String']['output'];
  collar: RescueStoryCollar;
  createdAt: Scalars['DateTime']['output'];
  /** When the rescue/reunion happened. Typically rendered with month precision. */
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isFiUser: Scalars['Boolean']['output'];
  /**
   * Stable public URL for the user-submitted photo; null when no photo was submitted. Serves via
   * CloudFront (`media.tryfi.com`) in prod, direct S3 elsewhere. Safe to cache long-term — the URL
   * is content-addressed by S3 key and does not expire.
   */
  photoUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Raw S3 key of the admin-curated poster. Exposed for form-state tracking in the admin UI; the
   * marketing site should use `posterUrl` instead.
   */
  posterS3Key?: Maybe<Scalars['String']['output']>;
  /**
   * Stable public URL for the admin-curated poster shown as the thumbnail on the list card.
   * Separate from the user-submitted photo. Same CloudFront / direct-S3 split as `photoUrl`.
   */
  posterUrl?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  source: RescueStorySource;
  status: RescueStoryStatus;
  /**
   * Editorial title. Null for raw public submissions until a marketer authors one during moderation.
   * Required before publishing.
   */
  title?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export enum RescueStoryCollar {
  FI_MINI = 'FI_MINI',
  FI_MINI_FOR_CATS = 'FI_MINI_FOR_CATS',
  FI_SERIES_3_PLUS = 'FI_SERIES_3_PLUS',
}

export type RescueStoryPosterUploadResult = {
  __typename?: 'RescueStoryPosterUploadResult';
  s3Key: Scalars['String']['output'];
};

export enum RescueStorySource {
  CUSTOMER_CHAT = 'CUSTOMER_CHAT',
  CUSTOMER_EMAIL = 'CUSTOMER_EMAIL',
  REDDIT_POST = 'REDDIT_POST',
}

export enum RescueStoryStatus {
  PENDING = 'PENDING',
  PUBLISHED = 'PUBLISHED',
  REJECTED = 'REJECTED',
}

export type RescueSubmit501c3DocumentInput = {
  /** Original file name from the uploader's filesystem (for display only). */
  fileName: Scalars['String']['input'];
  /**
   * S3 key returned by `rescueGet501c3UploadUrl` and just PUT to. Must start with
   * `rescue-501c3/{callerUserId}/`; keys belonging to another user are rejected.
   */
  uploadedFileKey: Scalars['String']['input'];
};

export type RescueSubmitExemptionDocumentInput = {
  /** The file's original name, retained for the admin review queue. */
  fileName: Scalars['String']['input'];
  /**
   * S3 key from `rescueGet501c3UploadUrl`. Must sit inside the caller's own `rescue-501c3/{userId}/`
   * prefix.
   */
  uploadedFileKey: Scalars['String']['input'];
};

export type RescueTransfer = {
  __typename?: 'RescueTransfer';
  /** Adoption transfer completion timestamp. Null for foster transfers and pending adoptions. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fromHousehold?: Maybe<Household>;
  id: Scalars['ID']['output'];
  /**
   * When a rescue flagged this pending adoption as stalled, before it aged past the 7-day window.
   * Null for foster transfers and unflagged adoptions.
   */
  stalledAt?: Maybe<Scalars['DateTime']['output']>;
  status: RescueTransferStatus;
  toEmail?: Maybe<Scalars['String']['output']>;
  toFullName?: Maybe<Scalars['String']['output']>;
  toHousehold?: Maybe<Household>;
  toName?: Maybe<Scalars['String']['output']>;
  toPhone?: Maybe<Scalars['String']['output']>;
  type: RescueTransferType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RescueTransferPetPermanentlyInput = {
  billingAccountInput?: InputMaybe<BillingAccountInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  giftCardRedemptionCode: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  petId: Scalars['ID']['input'];
};

export type RescueTransferPetPermanentlyResult = {
  __typename?: 'RescueTransferPetPermanentlyResult';
  accountCreated: Scalars['Boolean']['output'];
  billingAccount?: Maybe<BillingAccount>;
  newAccountTemporaryPassword?: Maybe<Scalars['String']['output']>;
};

export type RescueTransferPetTemporarilyInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  petId: Scalars['ID']['input'];
};

export type RescueTransferPetTemporarilyResult = {
  __typename?: 'RescueTransferPetTemporarilyResult';
  accountCreated: Scalars['Boolean']['output'];
  newAccountTemporaryPassword?: Maybe<Scalars['String']['output']>;
};

export enum RescueTransferStatus {
  ACCEPTED = 'ACCEPTED',
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  NOT_RECOVERED = 'NOT_RECOVERED',
  PENDING = 'PENDING',
  RECALLED = 'RECALLED',
  REJECTED = 'REJECTED',
  RESCUE_RESOLVED = 'RESCUE_RESOLVED',
}

export enum RescueTransferType {
  ADOPTION = 'ADOPTION',
  FOSTER = 'FOSTER',
}

export type RescueUnassignedInventoryDeviceItem = {
  __typename?: 'RescueUnassignedInventoryDeviceItem';
  /** Current battery percentage (0-100). Null if unavailable. */
  batteryPercent?: Maybe<Scalars['Int']['output']>;
  /**
   * Date the device's shipment was delivered. Always set for items returned by
   * `rescueUnassignedDeviceInventory` (which only surfaces delivered devices), unless the underlying
   * shipment has no package delivery timestamp.
   */
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the device is currently online (reporting as expected). */
  isOnline: Scalars['Boolean']['output'];
  /**
   * Date of the device's most recent connection (cellular, wifi, base, or user). Falls back to the
   * device's createdAt when no reports exist or the caller is unauthorized to inspect the device.
   */
  lastConnectionDate: Scalars['DateTime']['output'];
  moduleId: Scalars['String']['output'];
  /** Date the order containing this device was placed. Null when no shipment is found. */
  orderedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date the device's shipment was shipped from the warehouse. Null until shipped. */
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Tracking number from the first package on the shipment that contains this device. When a
   * shipment splits into multiple boxes only one tracking number is surfaced (rescue UI shows a
   * single tracking link). Null when no tracking number has been assigned by the carrier yet.
   */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  /** Customer-facing device type (e.g. "Series 3"). Null for non-module platforms. */
  type?: Maybe<Scalars['String']['output']>;
};

export type RescueUnassignedInventoryDevicesInput = {
  /** Page size. Defaults to 50, clamped to a server-defined maximum. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Zero-based offset into the result set. Defaults to 0; clamped to [0, server-defined maximum]. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Case-insensitive substring match against moduleId. */
  query?: InputMaybe<Scalars['String']['input']>;
};

export type RescueUnassignedInventoryDevicesResult = {
  __typename?: 'RescueUnassignedInventoryDevicesResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<RescueUnassignedInventoryDeviceItem>;
  totalCount: Scalars['Int']['output'];
};

export type RescueUpdateFosterHomeContactInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactFirstName: Scalars['String']['input'];
  contactLastName?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** A chip with information relevant to a ChipReseller. */
export type ResellerChip = {
  __typename?: 'ResellerChip';
  boxId?: Maybe<Scalars['String']['output']>;
  cartonId?: Maybe<Scalars['String']['output']>;
  chipCondition: ChipCondition;
  /** Admin only */
  contactHistory: Array<ChipContactHistoryEntry>;
  createdAt: Scalars['DateTime']['output'];
  dbId: Scalars['Int']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isFiChip: Scalars['Boolean']['output'];
  latestContactHistoryEntry?: Maybe<ChipContactHistoryEntry>;
  /** @deprecated Use `latestContactHistoryEntry.contactInfo` instead */
  latestContactInfo?: Maybe<ChipContactInfo>;
  manufacturedAt?: Maybe<Scalars['DateTime']['output']>;
  pet?: Maybe<StrangerPet>;
  primaryPetOwner?: Maybe<StrangerUser>;
  reseller?: Maybe<ChipReseller>;
  serialNumber: Scalars['String']['output'];
  /** Admin only */
  shipmentData?: Maybe<DeviceShipment>;
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  shortId: Scalars['String']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  status: ChipStatusType;
  transfer?: Maybe<ChipTransfer>;
  /** Admin only */
  transfers: Array<ChipTransfer>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ResellerChipFeed = {
  __typename?: 'ResellerChipFeed';
  chips: Array<ResellerChip>;
  metadata?: Maybe<ResellerChipFeedMetadata>;
};

export type ResellerChipFeedMetadata = {
  __typename?: 'ResellerChipFeedMetadata';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalChipCount: Scalars['Int']['output'];
};

export type ResellerModule = {
  __typename?: 'ResellerModule';
  activatedSubscriptionId?: Maybe<Scalars['String']['output']>;
  consignmentLocation?: Maybe<ConsignmentLocation>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  moduleId: Scalars['String']['output'];
  orderSource: OrderSource;
  renewalMonths: Scalars['Int']['output'];
  shipDate: Scalars['DateTime']['output'];
  shipmentId?: Maybe<Scalars['String']['output']>;
};

export type ResellerModuleQueryInput = {
  moduleId?: InputMaybe<Scalars['String']['input']>;
  orderSource?: InputMaybe<OrderSource>;
};

/**
 * Bearer-key credential for a reseller org's programmatic integrations, issued by an admin or
 * customer-support agent, keyed on the reseller org (`resellerId`). One active key per reseller. The
 * plaintext token has the form `fi_rescue_<base62>` and is hashed (SHA-256) before storage; only
 * `keySuffix` (last 4 chars) is kept for display. Plaintext is returned exactly once at create time.
 */
export type ResellerOrganizationApiKey = {
  __typename?: 'ResellerOrganizationApiKey';
  createdAt: Scalars['DateTime']['output'];
  /** Email of the admin or customer-support agent who issued the key, snapshotted at create time. */
  createdByEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Last 4 base62 chars of the plaintext body — for display alongside the masked prefix. */
  keySuffix: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  rateLimitReqPerMin: Scalars['Int']['output'];
  resellerId: Scalars['ID']['output'];
  /** Set when the key is revoked. Null on active keys. */
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Email of the admin or customer-support agent who revoked the key, snapshotted at revoke time. Null on active keys. */
  revokedByEmail?: Maybe<Scalars['String']['output']>;
  scopes: Array<Scalars['String']['output']>;
};

export enum ResellerPetInterest {
  CATS = 'CATS',
  DOGS = 'DOGS',
  DOGS_AND_CATS = 'DOGS_AND_CATS',
  OTHER = 'OTHER',
}

export enum ResellerProgramInterest {
  FREE_MICROCHIPS = 'FREE_MICROCHIPS',
  RESCUE_COLLAR_PROGRAM = 'RESCUE_COLLAR_PROGRAM',
}

export enum ResellerStatus {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

export enum ResellerTaxExemptType {
  GOVERNMENT_ENTITY = 'GOVERNMENT_ENTITY',
  REGISTERED_501C3 = 'REGISTERED_501C3',
}

export enum ResellerType {
  BREEDER = 'BREEDER',
  RESCUE = 'RESCUE',
  VET = 'VET',
}

export type ResolveChipTransferInput = {
  chipTransferId: Scalars['ID']['input'];
  /**
   * If status == ACCEPTED and this is set, the transfer will be accepted
   * and also the chip will be associated with the specified pet.
   */
  petId?: InputMaybe<Scalars['ID']['input']>;
  status: ChipTransferStatus;
};

export type ResolvePetAdoptionTransferInput = {
  billingAccountInput?: InputMaybe<BillingAccountInput>;
  giftCardRedemptionCode?: InputMaybe<Scalars['String']['input']>;
  petId: Scalars['ID']['input'];
  resolution: AdoptionTransferResolution;
};

export type ResolvePetAdoptionTransferResult = {
  __typename?: 'ResolvePetAdoptionTransferResult';
  redirectUrl: Scalars['String']['output'];
  transfer: PetAdoptionTransfer;
};

export type Rest = Activity & {
  __typename?: 'Rest';
  address?: Maybe<Scalars['String']['output']>;
  allPositionsForDebug?: Maybe<Array<Position>>;
  areaName?: Maybe<Scalars['String']['output']>;
  cityState?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use likeCount */
  clapCount: Scalars['Int']['output'];
  dbId: Scalars['Int']['output'];
  debugMetadata: Scalars['JSON']['output'];
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use isLikable */
  isClappable: Scalars['Boolean']['output'];
  isLikable: Scalars['Boolean']['output'];
  likeCount: Scalars['Int']['output'];
  mapUrl: Scalars['String']['output'];
  neighborhood?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  obfuscated: Scalars['Boolean']['output'];
  overallStepsPerMinuteForDebug: Scalars['Float']['output'];
  place?: Maybe<Place>;
  position: Position;
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']['output']>;
  start: Scalars['DateTime']['output'];
  totalSteps: Scalars['Int']['output'];
};

export type RestmapUrlArgs = {
  colorScheme?: InputMaybe<ColorScheme>;
  height: Scalars['Int']['input'];
  scale?: InputMaybe<Scalars['Int']['input']>;
  style?: InputMaybe<MapStyle>;
  width: Scalars['Int']['input'];
};

export type RestFeed = {
  __typename?: 'RestFeed';
  cursor: Scalars['String']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  period: ActivityRestStrainPeriod;
  prevCursor?: Maybe<Scalars['String']['output']>;
  restSummary: RestFeedSummary;
};

/**
 * Describes rests (naps + sleep) and associated metadata (total time, etc.)
 * across the specified Period.
 */
export type RestFeedSummary = {
  __typename?: 'RestFeedSummary';
  /** Maximum rest (sleep + nap) seconds over the period (e.g. maximum rest/month for YEAR). */
  maxRestSeconds: Scalars['Int']['output'];
  /**
   * Average per day over the period (only counting days we have data for).
   *
   * For the DAY period this will be the same as the Total field above.
   * For WEEK/MONTH/YEAR this will be the average per day that we have data for.
   */
  napSecondsAverage?: Maybe<Scalars['Int']['output']>;
  /** Summed over the entire period */
  napSecondsTotal: Scalars['Int']['output'];
  /** Only populated for DAY period */
  overnightRestSummary?: Maybe<OvernightRestSummary>;
  period: ActivityRestStrainPeriod;
  /**
   * One value for each sub-period:
   * * Day: 24 values, one per hour
   * * Week: 7 values, one per day
   * * Month: 28-31 values, one per day
   * * Year: 12 values, one per month
   */
  restData: Array<RestFeedSummaryData>;
  /**
   * Graph visualization for rest data (available for month/year periods only)
   * Returns null for day/week periods where aggregated charting is not meaningful
   */
  restGraph?: Maybe<PetBehaviorDetailGraph>;
  restSecondsAverage?: Maybe<Scalars['Int']['output']>;
  restSecondsTotal: Scalars['Int']['output'];
  /** Rest time comparison between current and previous period */
  restTimeComparison: PetBehaviorDetailComparison;
  /**
   * Segmented timeline for rests showing hourly sleep time blocks
   * Always available as an array, providing detailed time-based data for all periods
   */
  restTimelines: Array<PetBehaviorDetailSegmentedTimeline>;
  sleepSecondsAverage?: Maybe<Scalars['Int']['output']>;
  sleepSecondsTotal: Scalars['Int']['output'];
  /** Midnight at the beginning of the period */
  start: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  /** Labels to display on the x-axis of graphs in the app. */
  xAxisLabels: Array<Scalars['String']['output']>;
};

export type RestFeedSummaryData = {
  __typename?: 'RestFeedSummaryData';
  availability: ActivityRestStrainPeriodDataAvailability;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  napSeconds?: Maybe<Scalars['Int']['output']>;
  /** Sum of nap and sleep seconds. */
  restSeconds?: Maybe<Scalars['Int']['output']>;
  sleepSeconds?: Maybe<Scalars['Int']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
};

/** Not exposed outside of admin. */
export type RestSegment = {
  __typename?: 'RestSegment';
  end?: Maybe<Scalars['DateTime']['output']>;
  start: Scalars['DateTime']['output'];
  type: RestSegmentType;
};

export enum RestSegmentType {
  ACTIVE = 'ACTIVE',
  OFFLINE = 'OFFLINE',
  OFF_DOG = 'OFF_DOG',
  RESTING = 'RESTING',
}

export type RestSummary = {
  __typename?: 'RestSummary';
  dailyRests: Array<DailyRestSummary>;
  data: RestSummaryData;
  end: Scalars['DateTime']['output'];
  period: ActivitySummaryPeriod;
  start: Scalars['DateTime']['output'];
};

export type RestSummaryData = ConcreteRestSummaryData | UnavailableRestSummaryData;

export type RestSummaryFeed = {
  __typename?: 'RestSummaryFeed';
  nextCursor?: Maybe<Scalars['String']['output']>;
  restSummaries: Array<RestSummary>;
};

export type ResumeMembershipInput = {
  moduleId?: InputMaybe<Scalars['String']['input']>;
  recurlySubscriptionId: Scalars['String']['input'];
};

export type ResumeMembershipResult = {
  __typename?: 'ResumeMembershipResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RetryFailedInvoiceInput = {
  /**
   * The past-due invoice to retry, identified by its Recurly invoice id as surfaced
   * by BillingSubscription.dunningInfo.invoiceId (not the human-readable number).
   */
  invoiceId: Scalars['ID']['input'];
};

export type RetryFailedInvoiceResult = {
  __typename?: 'RetryFailedInvoiceResult';
  amountInCents?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  /** Populated when status is FAILED: the gateway decline code and a customer-facing message. */
  declineCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  invoiceNumber: Scalars['String']['output'];
  status: InvoiceRetryStatus;
};

export type ReturnsTrackerSubItem = {
  __typename?: 'ReturnsTrackerSubItem';
  code: Scalars['String']['output'];
  friendlyName: Scalars['String']['output'];
  hasSerialNumber: Scalars['Boolean']['output'];
  miniFriendlyName?: Maybe<Scalars['String']['output']>;
  miniName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  requiredForRefund: Scalars['Boolean']['output'];
};

export type ReverseGeocodeResult = {
  __typename?: 'ReverseGeocodeResult';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityState?: Maybe<Scalars['String']['output']>;
  /** ISO 3166-1 alpha-2 country code, uppercased (e.g. "US"). */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** BCP-47 language tag the names are in; null when the provider doesn't report it. */
  language?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** ISO 3166-2 subdivision code (e.g. "US-NY"). */
  subdivisionCode?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type RevokeUserInviteInput = {
  inviteCode: Scalars['String']['input'];
};

export type RevokeUserInviteResult = {
  __typename?: 'RevokeUserInviteResult';
  household?: Maybe<Household>;
  petRecalled?: Maybe<Scalars['Boolean']['output']>;
};

export type S3UpgradePromotionBanner = InAppPromotionBanner & {
  __typename?: 'S3UpgradePromotionBanner';
  backgroundColorHex: Scalars['String']['output'];
  ctaUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  line1Text: FormatString;
  line1TextColorHex: Scalars['String']['output'];
  line2Text: FormatString;
  line2TextColorHex: Scalars['String']['output'];
};

export type SaveBillingInfoAndRetryFailedInvoiceInput = {
  /**
   * The past-due invoice to retry, identified by its Recurly invoice id as surfaced
   * by BillingSubscription.dunningInfo.invoiceId (not the human-readable number).
   */
  invoiceId: Scalars['ID']['input'];
  /** The completed Stripe SetupIntent whose payment method should be stored before retrying. */
  setupIntentId: Scalars['String']['input'];
};

export type SaveBillingInfoResult = {
  __typename?: 'SaveBillingInfoResult';
  success: Scalars['Boolean']['output'];
};

export type SearchFiHandleResult = {
  __typename?: 'SearchFiHandleResult';
  /** @deprecated Always empty */
  packs: Array<Pack>;
  pets: Array<StrangerPet>;
};

export type SearchPacksResponse = {
  __typename?: 'SearchPacksResponse';
  packFeed: PackFeed;
};

export type SearchPartyFlagValues = {
  __typename?: 'SearchPartyFlagValues';
  enableNearbyUserDetection: Scalars['Boolean']['output'];
  internalSearchPartyNotificationTesterConfigured: Scalars['Boolean']['output'];
  maxOfflineHours: Scalars['Int']['output'];
  maxSessionAgeDays: Scalars['Int']['output'];
  maxUsersPerSession: Scalars['Int']['output'];
  nearbyUserDetectionOverrideAdditionsConfigured: Scalars['Boolean']['output'];
};

export type SearchPartyNotificationCandidate = {
  __typename?: 'SearchPartyNotificationCandidate';
  email?: Maybe<Scalars['String']['output']>;
  filterReason?: Maybe<Scalars['String']['output']>;
  isInternalTester: Scalars['Boolean']['output'];
  isOverrideAddition: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  userId: Scalars['Int']['output'];
  wouldBeNotified: Scalars['Boolean']['output'];
};

export type SearchPartyTestingResult = {
  __typename?: 'SearchPartyTestingResult';
  candidates: Array<SearchPartyNotificationCandidate>;
  featureEnabled: Scalars['Boolean']['output'];
  finalUserIds: Array<Scalars['Int']['output']>;
  flagValues: SearchPartyFlagValues;
  isInternalTestMode: Scalars['Boolean']['output'];
  nearbyUserIds: Array<Scalars['Int']['output']>;
  overrideUserIds: Array<Scalars['Int']['output']>;
  petLatitude?: Maybe<Scalars['Float']['output']>;
  petLongitude?: Maybe<Scalars['Float']['output']>;
  userIdsAfterBaseFiltering: Array<Scalars['Int']['output']>;
  userIdsAfterFeatureFlag: Array<Scalars['Int']['output']>;
};

/**
 * The set of filter chips the UI supports.
 * Multiple can be active at once (OR semantics).
 */
export enum SearchPetsFilter {
  IN_FOSTER = 'IN_FOSTER',
  IN_RESCUE = 'IN_RESCUE',
  MY_PETS = 'MY_PETS',
  PENDING_ADOPTIONS = 'PENDING_ADOPTIONS',
}

/** Facet count for a single filter. */
export type SearchPetsWithFiltersFacet = {
  __typename?: 'SearchPetsWithFiltersFacet';
  filter: SearchPetsFilter;
  totalCount: Scalars['Int']['output'];
};

/** Input for pet search with filters and pagination. */
export type SearchPetsWithFiltersInput = {
  /**
   * Multi-select filters (OR semantics).
   * If omitted or empty, no filter constraint is applied.
   */
  filters?: InputMaybe<Array<SearchPetsFilter>>;
  /**
   * When false (the default), exclude pets that have a chip (Fi nano) but no device.
   * Set to true to include nano-only pets in the results, facets, and totalCount.
   */
  includeNanoPets?: InputMaybe<Scalars['Boolean']['input']>;
  /** Max results to return in this page. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Pagination info */
  pagingInstruction?: InputMaybe<PagingInstruction>;
  /** Simple text query applied to pet name. */
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Pagination and request metadata for pet search with filters. */
export type SearchPetsWithFiltersMetadata = {
  __typename?: 'SearchPetsWithFiltersMetadata';
  /** Echo back the filters actually applied (empty means none). */
  filtersApplied: Array<SearchPetsFilter>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  /** Echo back normalized query string if provided. */
  query?: Maybe<Scalars['String']['output']>;
  /**
   * Total number of pets matching the current query + selected filters.
   * Used for pagination / "All (X)".
   */
  totalCount: Scalars['Int']['output'];
};

/** Result of pet search with filters. */
export type SearchPetsWithFiltersResult = {
  __typename?: 'SearchPetsWithFiltersResult';
  /** Counts per filter option (for pills/tabs). */
  facets: Array<SearchPetsWithFiltersFacet>;
  /** Pagination info */
  pageInfo: PageInfo;
  /** Flat list in display order (single list UI). */
  pets: Array<Pet>;
  totalCount: Scalars['Int']['output'];
};

export type SeekParameters = {
  before: Scalars['DateTime']['input'];
};

export type SendBackgroundNotificationInput = {
  userId: Scalars['ID']['input'];
};

export type SendHealthGptChatMessageInput = {
  message: Scalars['String']['input'];
  petId: Scalars['ID']['input'];
};

export type SendHighFivesInput = {
  /** Taps in this bout. The sending pet is the acting pet. */
  count: Scalars['Int']['input'];
  recipientPetId: Scalars['ID']['input'];
};

export type SendNotificationInput = {
  channelId: PetNotificationSettingCategory;
  deepLink?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  timeSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};

export type SendSMSInput = {
  message: Scalars['String']['input'];
  /** One of `userId` or `phoneNumber` must be set. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** One of `userId` or `phoneNumber` must be set. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SentPushNotificationLog = {
  __typename?: 'SentPushNotificationLog';
  notificationCategory?: Maybe<Scalars['String']['output']>;
  notificationMessage: Scalars['String']['output'];
  notificationType: Scalars['String']['output'];
  pet?: Maybe<Pet>;
  shouldShowBadge?: Maybe<Scalars['Boolean']['output']>;
  timestamp: Scalars['DateTime']['output'];
  user: User;
};

export type SentSMSNotificationLog = {
  __typename?: 'SentSMSNotificationLog';
  /** Null when no Twilio status callback could be matched to this send. */
  deliveryReceipt?: Maybe<SmsDeliveryReceipt>;
  notificationMessage: Scalars['String']['output'];
  notificationType: Scalars['String']['output'];
  pet?: Maybe<Pet>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  twilio?: Maybe<Scalars['Boolean']['output']>;
  user: User;
};

export type Series3UpgradeCartInput = {
  cartItems: Array<ForModuleBundleCartItemInput>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  isUpgradeV2?: InputMaybe<Scalars['Boolean']['input']>;
  marketingEmailsOptedIn?: InputMaybe<Scalars['Boolean']['input']>;
  shippingCode?: InputMaybe<Scalars['String']['input']>;
  threeDSecureActionResultToken?: InputMaybe<Scalars['String']['input']>;
};

export type Series3UpgradeDeviceOffer = {
  __typename?: 'Series3UpgradeDeviceOffer';
  amountDueTodayInCents: Scalars['Int']['output'];
  currentCollarModel: Scalars['String']['output'];
  device: Device;
  pet: Pet;
  promoDiscounts: Array<Series3UpgradePromoDiscount>;
  proratedCreditAmountInCents: Scalars['Int']['output'];
};

export type Series3UpgradeOffer = {
  __typename?: 'Series3UpgradeOffer';
  deviceOffers: Array<Series3UpgradeDeviceOffer>;
  nextBillDate: Scalars['DateTime']['output'];
  planCode: Scalars['String']['output'];
};

export type Series3UpgradePromoDiscount = {
  __typename?: 'Series3UpgradePromoDiscount';
  discountAmountInCents: Scalars['Int']['output'];
  planCode: Scalars['String']['output'];
};

export type SetCommunityFeedModifiersInput = {
  differentLanguageMultiplier?: InputMaybe<Scalars['Float']['input']>;
  engagementCountOffset?: InputMaybe<Scalars['Float']['input']>;
  followerCountOffset?: InputMaybe<Scalars['Float']['input']>;
  sameRegionMultiplier?: InputMaybe<Scalars['Float']['input']>;
  videoPostScoreMultiplier?: InputMaybe<Scalars['Float']['input']>;
};

export type SetCommunityFeedPostBoostInput = {
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  multiplier: Scalars['Float']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type SetCommunityFeedTrendingMetaInput = {
  applyVideoMultiplier?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum SetFeatureFlagType {
  BOOLEAN = 'BOOLEAN',
  NUMBER = 'NUMBER',
  STRING = 'STRING',
}

/**
 * GraphQL doesn't support union types for inputs, so this takes a lassez-faire
 * approach to type safety with all optional fields.
 */
export type SetFeatureFlagValue = {
  booleanFloatPercentage?: InputMaybe<Scalars['Float']['input']>;
  booleanGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  booleanPercentage?: InputMaybe<Scalars['Int']['input']>;
  booleanPlatformOverrides?: InputMaybe<Array<BooleanSettingPlatformOverrideInput>>;
  booleanType?: InputMaybe<BooleanSettingType>;
  booleanUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  number?: InputMaybe<Scalars['Float']['input']>;
  numberRolloutPercentage?: InputMaybe<Scalars['Int']['input']>;
  numberRolloutValue?: InputMaybe<Scalars['Float']['input']>;
  setDynamicSettingName?: InputMaybe<Scalars['String']['input']>;
  string?: InputMaybe<Scalars['String']['input']>;
  unsetDynamicSettingName?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetFeedDecayCurveConfigInput = {
  decayCurve: Array<DecayCurvePointInput>;
  feedType: FeedDecayCurveType;
};

export type SetFirmwareRolloutResult = {
  __typename?: 'SetFirmwareRolloutResult';
  /** The number of records that were updated. */
  numUpdated: Scalars['Int']['output'];
};

export type SetNextShipmentDateInput = {
  nextShipDate: Scalars['DateTime']['input'];
  recurlySubscriptionId: Scalars['ID']['input'];
};

export type SetNextShipmentDateResult = {
  __typename?: 'SetNextShipmentDateResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SetPetOperationParamsModeInput = {
  mode: OperationParamsMode;
  petId: Scalars['ID']['input'];
};

export type SetPetPrimaryPhotoInput = {
  petId: Scalars['ID']['input'];
  photoId: Scalars['ID']['input'];
};

/**
 * Input for setting containment zones on a safe zone (Place).
 * Each zone field is optional - omit to not create that zone type, or set to null to remove an existing zone.
 */
export type SetPlaceContainmentInput = {
  /** Containment zone for sound feedback. */
  soundZone?: InputMaybe<CreateContainmentZoneInput>;
  /** Containment zone for vibration feedback. */
  vibrationZone?: InputMaybe<CreateContainmentZoneInput>;
};

export type SetPrimaryUserEmailInput = {
  email: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type SetRemoteLoggingForFirmwareChannelInput = {
  channelName: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  platform: Scalars['String']['input'];
};

export type SetShippingAddressInput = {
  applyToAll: Scalars['Boolean']['input'];
  recurlySubscriptionId: Scalars['ID']['input'];
  shippingAddress: AddressInput;
};

export type SetShippingAddressResult = {
  __typename?: 'SetShippingAddressResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SetStepGoalForPetInput = {
  dailyStepGoal: Scalars['Int']['input'];
  petId: Scalars['ID']['input'];
};

export type SetStepGoalForPetResult = {
  __typename?: 'SetStepGoalForPetResult';
  pet: Pet;
};

export type SetTermsOfServiceAcceptedInput = {
  /** The user that is accepting the terms of service. */
  userId: Scalars['ID']['input'];
};

export type SetTermsOfServiceAcceptedResult = {
  __typename?: 'SetTermsOfServiceAcceptedResult';
  success: Scalars['Boolean']['output'];
};

export type SetUserPasswordToRandomStringResult = {
  __typename?: 'SetUserPasswordToRandomStringResult';
  newPassword: Scalars['String']['output'];
};

export type SetUserRoleInHouseholdInput = {
  householdId: Scalars['ID']['input'];
  role: UserHouseholdRole;
  userId: Scalars['ID']['input'];
};

export type SetUserRoleInHouseholdResult = {
  __typename?: 'SetUserRoleInHouseholdResult';
  userHousehold: UserHousehold;
};

export type SharingSession = {
  __typename?: 'SharingSession';
  session?: Maybe<SharingSessionDetails>;
};

export type SharingSessionDetails = {
  __typename?: 'SharingSessionDetails';
  /**
   * Whether nearby user detection is enabled for this search party session.
   * When enabled, the system will periodically check for new nearby users and notify them.
   */
  enableNearbyUserDetection: Scalars['Boolean']['output'];
  sharingUrl: Scalars['String']['output'];
  /** Total number of visitors to the sharing session */
  visitorCount: Scalars['Int']['output'];
};

export enum SharingSessionType {
  LOCATION_SHARING = 'LOCATION_SHARING',
  SEARCH_PARTY = 'SEARCH_PARTY',
}

export type ShelterluvConfiguration = {
  __typename?: 'ShelterluvConfiguration';
  apiKeyEndsWith: Scalars['String']['output'];
  /**
   * Whether the reseller receives email updates for registrations imported from
   * ShelterLuv. Defaults to true when never set.
   */
  emailUpdateOptIn: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  fiNanoBackfillCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  lastImportAt?: Maybe<Scalars['DateTime']['output']>;
  thirdPartyChipBackfillCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  thirdPartyChipBackfillEnabled: Scalars['Boolean']['output'];
  thirdPartyChipIncrementalEnabled: Scalars['Boolean']['output'];
};

export type ShelterluvConfigurationInput = {
  apiKey: Scalars['String']['input'];
  thirdPartyChipBackfillEnabled: Scalars['Boolean']['input'];
  thirdPartyChipIncrementalEnabled: Scalars['Boolean']['input'];
};

export type ShipOrderLineItemsInput = {
  id: Scalars['ID']['input'];
  lineItemIds: Array<Scalars['ID']['input']>;
};

export type ShippingAddress = {
  __typename?: 'ShippingAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  residential?: Maybe<Scalars['Boolean']['output']>;
  state: Scalars['String']['output'];
  street1: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  zipcode: Scalars['String']['output'];
};

export enum ShippingOption {
  DHL_PARCEL_EXPEDITED_MAX = 'DHL_PARCEL_EXPEDITED_MAX',
  /** The shipping options below are only available for internal orders. */
  DHL_PARCEL_GROUND = 'DHL_PARCEL_GROUND',
  FLAT_RATE = 'FLAT_RATE',
  FREE_TRIAL = 'FREE_TRIAL',
  GROUND = 'GROUND',
  IN_PERSON = 'IN_PERSON',
  LANDMARK_INTERNATIONAL_STANDARD = 'LANDMARK_INTERNATIONAL_STANDARD',
  OVERNIGHT = 'OVERNIGHT',
  PRIORITY_MAIL = 'PRIORITY_MAIL',
  TWO_DAY = 'TWO_DAY',
  UPS_2ND_DAY_AIR = 'UPS_2ND_DAY_AIR',
  UPS_GROUND = 'UPS_GROUND',
  UPS_NEXT_DAY_AIR = 'UPS_NEXT_DAY_AIR',
  UPS_NEXT_DAY_AIR_SATURDAY = 'UPS_NEXT_DAY_AIR_SATURDAY',
}

export type ShippingOptionInput = {
  code: Scalars['String']['input'];
};

export type SimpleDebugActivity = {
  __typename?: 'SimpleDebugActivity';
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  positions: Array<Position>;
  start: Scalars['DateTime']['output'];
  typeString?: Maybe<Scalars['String']['output']>;
};

export type SimpleHealthMetric = {
  __typename?: 'SimpleHealthMetric';
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  values: HealthRollupValues;
};

export enum SizeOption {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
  XLARGE = 'XLARGE',
  XSMALL = 'XSMALL',
}

export type SkipSupplementShipmentInput = {
  recurlySubscriptionId: Scalars['ID']['input'];
};

export type SkipSupplementShipmentResult = {
  __typename?: 'SkipSupplementShipmentResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SleepAmount = {
  __typename?: 'SleepAmount';
  /** Total duration in seconds */
  duration: Scalars['Int']['output'];
  type: SleepType;
};

export type SleepInterruptionSpan = {
  __typename?: 'SleepInterruptionSpan';
  end: Scalars['DateTime']['output'];
  /** Between 0-1: where to place end this bar between `sleepStart` and `sleepEnd`. */
  endCoordinate: Scalars['Float']['output'];
  start: Scalars['DateTime']['output'];
  /** Between 0-1: where to place end this bar between `sleepStart` and `sleepEnd`. */
  startCoordinate: Scalars['Float']['output'];
};

export enum SleepType {
  NAP = 'NAP',
  SLEEP = 'SLEEP',
}

export type SmsDeliveryReceipt = {
  __typename?: 'SmsDeliveryReceipt';
  /** Twilio error code, set on undelivered/failed. See https://www.twilio.com/docs/api/errors */
  errorCode?: Maybe<Scalars['String']['output']>;
  messageSid: Scalars['String']['output'];
  /** The Messaging Service pool number the recipient actually saw. Sticky per recipient. */
  senderNumber?: Maybe<Scalars['String']['output']>;
  /** Latest Twilio status: queued, sent, delivered, undelivered, failed. */
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** One of inputs should be specified */
export type SocialContentInput = {
  commentId?: InputMaybe<Scalars['ID']['input']>;
  photoId?: InputMaybe<Scalars['ID']['input']>;
  textPostId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Sort order for a paginated query that accepts a sort key. General-purpose — not scoped to any
 * one feature.
 */
export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type Span = {
  __typename?: 'Span';
  color?: Maybe<Scalars['HexColorCode']['output']>;
  length: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  style: FontStyle;
};

export enum Species {
  CAT = 'CAT',
  DOG = 'DOG',
  OTHER = 'OTHER',
}

export type StatChanged = {
  __typename?: 'StatChanged';
  newValue: Scalars['Int']['output'];
  oldValue: Scalars['Int']['output'];
  stat: DeviceStat;
};

export type StatDeltaDeviceEvent = DeviceEventBase & {
  __typename?: 'StatDeltaDeviceEvent';
  date: Scalars['DateTime']['output'];
  deltaValue: Scalars['Float']['output'];
  duration: Scalars['Float']['output'];
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  moduleId: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  statName: Scalars['String']['output'];
};

export type Statistics = {
  __typename?: 'Statistics';
  last24HrsTotalActivityReports: Scalars['Int']['output'];
  last24HrsTotalLocationReports: Scalars['Int']['output'];
  totalActivatedDevices: Scalars['Int']['output'];
  totalActivatedUsers: Scalars['Int']['output'];
  totalDevices: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  uptime: Scalars['Float']['output'];
};

export type StepActivity = {
  __typename?: 'StepActivity';
  date: Scalars['DateTime']['output'];
  stepCount: Scalars['Int']['output'];
};

export type StepActivityInfo = {
  __typename?: 'StepActivityInfo';
  currentStepGoalStreak: Scalars['Int']['output'];
  currentStreakText: Scalars['String']['output'];
  /** @deprecated No client renders this. Always returns 0. */
  longestStepGoalStreak: Scalars['Int']['output'];
  streakBonusSummary: PetStreakBonusSummary;
};

export type StepCountDistribution = {
  __typename?: 'StepCountDistribution';
  averageStepCount: Scalars['Int']['output'];
  /** The size (in steps) of an individual bucket */
  bucketSize: Scalars['Int']['output'];
  buckets: Array<StepCountDistributionBucket>;
};

export type StepCountDistributionBucket = {
  __typename?: 'StepCountDistributionBucket';
  /** A single value (in steps) somewhere in the middle of this bucket. */
  midpointSteps: Scalars['Int']['output'];
  /** The percentage of dogs in this bucket (0-1). */
  percentage: Scalars['Float']['output'];
  /** The percentile as an integer between 1-100 (e.g. 95 = top 95th percentile). */
  percentile: Scalars['Int']['output'];
  /** The lower bound of steps contained in this bucket. */
  steps: Scalars['Int']['output'];
};

export type StepFeed = {
  __typename?: 'StepFeed';
  /** Cursors are base64 encoded ISO date strings. */
  cursor: Scalars['String']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  period: ActivityRestStrainPeriod;
  prevCursor?: Maybe<Scalars['String']['output']>;
  stepSummary: StepSummary;
};

/**
 * Describes steps and associated metadata (streak counts, walks, etc.) across
 * the specified ActivityRestStrainPeriod.
 */
export type StepSummary = {
  __typename?: 'StepSummary';
  /** Active time comparison between current and previous period */
  activeTimeComparison: PetBehaviorDetailComparison;
  /**
   * Graph visualization for active time data (available for month/year periods only)
   * Returns null for day/week periods where aggregated charting is not meaningful
   */
  activeTimeGraph?: Maybe<PetBehaviorDetailGraph>;
  /**
   * Average active minutes per day for this period. For DAY period, this equals totalActiveMinutes.
   * For WEEK/MONTH/YEAR periods, this is totalActiveMinutes divided by the number of days with data.
   */
  activeTimePerDay: Scalars['Int']['output'];
  /** Segmented timeline for walks showing hourly active time blocks */
  activityTimelines: Array<PetBehaviorDetailSegmentedTimeline>;
  comparisonActiveTimeLegend?: Maybe<Scalars['String']['output']>;
  comparisonStepsLegend?: Maybe<Scalars['String']['output']>;
  /** Comparison graph labels. */
  comparisonTitleCurrent?: Maybe<Scalars['String']['output']>;
  comparisonTitlePrevious?: Maybe<Scalars['String']['output']>;
  /** Maximum steps over the period (e.g. maximum steps/month for YEAR). */
  maxSteps: Scalars['Int']['output'];
  metStepGoal?: Maybe<Scalars['Boolean']['output']>;
  period: ActivityRestStrainPeriod;
  /** Midnight at the beginning of the period */
  start: Scalars['DateTime']['output'];
  /**
   * One value for each sub-period:
   * * Day: 24 values, one per hour
   * * Week: 7 values, one per day
   * * Month: 28-31 values, one per day
   * * Year: 12 values, one per month
   */
  stepData: Array<StepSummaryData>;
  /** Only applicable (and only populated) for DAY period. */
  stepGoal?: Maybe<Scalars['Int']['output']>;
  /** Steps comparison between current and previous period */
  stepsComparison: PetBehaviorDetailComparison;
  /**
   * Graph visualization for step data (available for month/year periods only)
   * Returns null for day/week periods where aggregated charting is not meaningful
   */
  stepsGraph?: Maybe<PetBehaviorDetailGraph>;
  /**
   * Average steps per day for this period. For DAY period, this equals totalSteps.
   * For WEEK/MONTH/YEAR periods, this is totalSteps divided by the number of days with data.
   */
  stepsPerDay: Scalars['Int']['output'];
  strainLevel?: Maybe<StrainLevel>;
  /** Strain score for the specified period. */
  strainScore?: Maybe<Scalars['Float']['output']>;
  streakDays?: Maybe<Scalars['Int']['output']>;
  streakExtended?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  totalActiveMinutes: Scalars['Int']['output'];
  totalNumberOfWalks: Scalars['Int']['output'];
  /** Summed over the entire period */
  totalSteps: Scalars['Int']['output'];
  totalWalkDistanceMeters: Scalars['Float']['output'];
  /** Labels to display on the x-axis of graphs in the app. */
  xAxisLabels: Array<Scalars['String']['output']>;
};

export type StepSummaryData = {
  __typename?: 'StepSummaryData';
  activeMinutes?: Maybe<Scalars['Int']['output']>;
  availability: ActivityRestStrainPeriodDataAvailability;
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  metStepGoal?: Maybe<Scalars['Boolean']['output']>;
  previousActiveMinutes?: Maybe<Scalars['Int']['output']>;
  /**
   * Comparison graph data.
   * Previous refers to the data from the corresponding sub-period in the previous period.
   * For example, if this StepSummaryData refers to Wednesday in the WEEK view,
   * then previous will refer to the Wednesday in the previous week.
   */
  previousSteps?: Maybe<Scalars['Int']['output']>;
  steps?: Maybe<Scalars['Int']['output']>;
  strainLevel?: Maybe<StrainLevel>;
  strainScore?: Maybe<Scalars['Float']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type StoreCartItemInput = {
  addonLineItems?: InputMaybe<Array<CartLineItemInput>>;
  cartItemId: Scalars['String']['input'];
  giftCardDelivery?: InputMaybe<GiftCardDeliveryInput>;
  /**
   * Whether this cart item is a gift. It will be used to determine if we should gift wrap the item and treat the
   * bundled subscription so it will not be created under the purchaser's account.
   */
  isGift?: InputMaybe<Scalars['Boolean']['input']>;
  lineItem: CartLineItemInput;
  quantity: Scalars['Int']['input'];
  subscriptionLineItem?: InputMaybe<CartLineItemInput>;
  /**
   * Ultra hardware only: true when the shopper is adding the tracker to a membership they already pay
   * for, false when it starts a new one. Ignored on every other product.
   */
  ultraAttachment?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Strain scores are a range from 0 to 30.
 * Descriptive levels are defined as:
 * LOW       [0 - 7.5)    (0-25%)
 * MODERATE  [7.5 - 22.5) (25-75%)
 * HIGH      [22.5 - 30]  (75-100%)
 */
export enum StrainLevel {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MODERATE = 'MODERATE',
  /** If the score cannot be calculated for given period (e.g. due to lack of data). */
  UNAVAILABLE = 'UNAVAILABLE',
}

export type StrainScore = {
  __typename?: 'StrainScore';
  date?: Maybe<Scalars['DateTime']['output']>;
  level?: Maybe<StrainScoreLevel>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type StrainScoreAverage = {
  __typename?: 'StrainScoreAverage';
  level?: Maybe<StrainScoreLevel>;
  score?: Maybe<Scalars['Float']['output']>;
};

/**
 * Strain scores: https://docs.google.com/document/d/16RiGCt9MSLb6lrpeBMFORZP4qsj5pQeEDswpZ-QHcNY/edit
 * Bucket values:
 * Light       1-10
 * Moderate   11-16
 * Strenuous  17-22
 * All Out    23-30+
 *
 * *** DEPRECATED: Use StrainLevel instead ***
 */
export enum StrainScoreLevel {
  ALL_OUT = 'ALL_OUT',
  LIGHT = 'LIGHT',
  MODERATE = 'MODERATE',
  STRENUOUS = 'STRENUOUS',
  /** If the score cannot be calculated for given period (e.g. due to lack of data). */
  UNAVAILABLE = 'UNAVAILABLE',
}

export enum StrainScorePeriod {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
}

export type StrainScoreResult = {
  __typename?: 'StrainScoreResult';
  nextCursor?: Maybe<Scalars['String']['output']>;
  scores: Array<StrainScore>;
};

/**
 * A chip that may be unassigned or may be assigned to someone else.
 * The user is able to request a transfer.
 */
export type StrangerChip = BaseChip & {
  __typename?: 'StrangerChip';
  /**
   * Whether this chip has owner contact information (latestContactHistoryEntry).
   * This allows us to determine if we should show the clear/keep owner info option
   * when reassigning a chip without exposing the actual owner data.
   */
  hasOwner: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isFiChip: Scalars['Boolean']['output'];
  serialNumber: Scalars['String']['output'];
  shortId: Scalars['String']['output'];
  /**
   * An outstanding transfer related to the chip. This will only be returned if either
   * 1) The transfer is to the current user (canResolve will be true)
   * 2) The transfer was requested by the current user (canResolve will be false)
   */
  transfer?: Maybe<ChipTransfer>;
};

export type StrangerPet = BasePet & {
  __typename?: 'StrangerPet';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  ageRange: AgeRange;
  breed?: Maybe<Breed>;
  color?: Maybe<Scalars['String']['output']>;
  communityAudience: Scalars['String']['output'];
  dayOfBirth?: Maybe<Scalars['Int']['output']>;
  discoverPostFeed: PetDiscoverFeed;
  /** Sum of comments and likes made by this pet. */
  engagementScore: Scalars['Int']['output'];
  fiHandle?: Maybe<Scalars['String']['output']>;
  followStatus: FollowStatus;
  followers: StrangerPetFeed;
  following: StrangerPetFeed;
  gender: Gender;
  /** @deprecated Always null. Use homeLocation instead */
  homeCityState?: Maybe<Scalars['String']['output']>;
  homeLocation?: Maybe<PetHomeLocation>;
  id: Scalars['ID']['output'];
  instagramHandle?: Maybe<Scalars['String']['output']>;
  isAmbassador: Scalars['Boolean']['output'];
  isIncludedInRanking: Scalars['Boolean']['output'];
  isPurebred: Scalars['Boolean']['output'];
  /**
   * The pet's placement on each weekly activity leaderboard it has slice keys
   * for (breed, home city/state, life stage) — the same boards `leaderboard` /
   * `petRanking` serve. Null when the viewer lacks internal rankings access
   * (the mobile:leaderboards:enabled targeted flag); clients fall back to
   * packFeed's legacy pack rankings.
   */
  leaderboardPlacements?: Maybe<Array<LeaderboardPlacement>>;
  lifetimeStats?: Maybe<StrangerPetLifetimeStats>;
  monthOfBirth?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** True if the pet joined Fi within the last two weeks. */
  newToFi?: Maybe<Scalars['Boolean']['output']>;
  /** Whether outside time feature is available for this pet in their product availability */
  outsideTimeAvailable: Scalars['Boolean']['output'];
  packFeed: PackFeed;
  petRanking?: Maybe<PackRanking>;
  photos: PhotoFeed;
  /** Whether ranking feature is available for this pet in their product availability */
  rankAvailable: Scalars['Boolean']['output'];
  /** @deprecated Use pet.restFeed */
  restSummaryFeed: RestSummaryFeed;
  species?: Maybe<Species>;
  stepActivityInfo: StepActivityInfo;
  /** Whether steps feature is available for this pet in their product availability */
  stepsAvailable: Scalars['Boolean']['output'];
  /** Total number of likes for this pet, across walks, photos, etc. */
  totalLikes: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weight: Scalars['Float']['output'];
  yearOfBirth: Scalars['Int']['output'];
};

export type StrangerPetdiscoverPostFeedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type StrangerPetfollowersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type StrangerPetfollowingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type StrangerPetpetRankingArgs = {
  limitBy: Array<PetRankFilter>;
};

export type StrangerPetrestSummaryFeedArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  period: ActivitySummaryPeriod;
};

export type StrangerPetFeed = {
  __typename?: 'StrangerPetFeed';
  pageInfo: PageInfo;
  strangerPets: Array<StrangerPet>;
  totalCount: Scalars['Int']['output'];
};

/**
 * The subset of PetLifetimeStats shown on public/stranger pet profiles
 * (total lifetime steps, average daily steps, streak). Kept separate from
 * PetLifetimeStats so owner-only data — notably record Walks, which carry
 * location traces — is never reachable through StrangerPet.
 */
export type StrangerPetLifetimeStats = {
  __typename?: 'StrangerPetLifetimeStats';
  cumulativeSteps?: Maybe<Scalars['Int']['output']>;
  dailyAverageSteps?: Maybe<Scalars['Float']['output']>;
  longestDailyStreakDays?: Maybe<Scalars['Int']['output']>;
};

export type StrangerUser = {
  __typename?: 'StrangerUser';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Currently just the profile picture from their first pet. */
  profilePicture?: Maybe<Image>;
};

export type StrangerWalk = {
  __typename?: 'StrangerWalk';
  /** @deprecated Use likeCount */
  clapCount: Scalars['Int']['output'];
  /** @deprecated Use liked */
  clapped: Scalars['Boolean']['output'];
  distance: Scalars['Float']['output'];
  end: Scalars['DateTime']['output'];
  /**
   * True when this walk's step count is unreliable — typically because the walk was captured solely
   * by a device that doesn't track steps (e.g. an Ultra) while the step-tracking device was elsewhere.
   * Mobile should suppress the step display when true.
   */
  excludeStepCount: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  likeCount: Scalars['Int']['output'];
  liked: Scalars['Boolean']['output'];
  start: Scalars['DateTime']['output'];
  stepCount: Scalars['Int']['output'];
};

export type StreakDetail = {
  __typename?: 'StreakDetail';
  availability: ActivityRestStrainPeriodDataAvailability;
  date: Scalars['DateTime']['output'];
  metStepGoal?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Set when a streak freeze or rescue covers this day. The day neither extended
   * nor broke the streak. Null for ordinary days.
   */
  protection?: Maybe<StreakProtectionType>;
  /**
   * Cursor that can be passed into pet.stepFeed to get get step data for this
   * day, i.e. "jump to date" functionality
   */
  stepFeedCursor: Scalars['String']['output'];
  stepGoal?: Maybe<Scalars['Int']['output']>;
  steps?: Maybe<Scalars['Int']['output']>;
  streakExtended?: Maybe<Scalars['Boolean']['output']>;
  /** Server-generated day label (e.g., "16") */
  title: Scalars['String']['output'];
};

export type StreakHistoryFeed = {
  __typename?: 'StreakHistoryFeed';
  /** cursor is a base64 encoded ISO date string for symmetry with prevCursor */
  cursor: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  /**
   * prevCursor is a base64 encoded ISO date string.
   *
   * There is no nextCursor as this feed will always start 'now'
   * and only supports swiping back through time.
   */
  prevCursor?: Maybe<Scalars['String']['output']>;
  /** The first and last (inclusive) days that are available in streakDetails. */
  startDate: Scalars['DateTime']['output'];
  /**
   * Index (0-6) indicating where day 1 should appear in the calendar grid.
   * Monday=0, Tuesday=1, ..., Sunday=6
   */
  startPosition: Scalars['Int']['output'];
  /** Streak history for each day of the month. */
  streakDetails: Array<StreakDetail>;
  /** Server-generated month header (e.g., "May 2025") */
  title: Scalars['String']['output'];
};

export enum StreakProtectionType {
  FREEZE = 'FREEZE',
  RESCUE = 'RESCUE',
}

export type StringFeatureFlag = FeatureFlag & {
  __typename?: 'StringFeatureFlag';
  accessedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dynamicSettingName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  stringValue: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SubmitHealthGptChatMessageFeedbackInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
  wasHelpful: Scalars['Boolean']['input'];
};

export type SubmitObservedBehaviorInput = {
  behavior: Scalars['String']['input'];
  eventTs: Scalars['DateTime']['input'];
  petId: Scalars['ID']['input'];
};

export type SubmitObservedBehaviorResponse = {
  __typename?: 'SubmitObservedBehaviorResponse';
  /** Placeholder for future expansion */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SubmitRealtimeBehaviorFeedbackInput = {
  eventId: Scalars['ID']['input'];
  feedback: RealtimeBehaviorFeedback;
  feedbackTs: Scalars['DateTime']['input'];
};

export type SubmitRealtimeBehaviorFeedbackResponse = {
  __typename?: 'SubmitRealtimeBehaviorFeedbackResponse';
  /** Placeholder for future expansion */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SubmitReportsResult = {
  __typename?: 'SubmitReportsResult';
  /** @deprecated Always HIGH */
  desiredLocationAccuracy: ClientLocationAccuracy;
  moduleResponse?: Maybe<Scalars['String']['output']>;
  quickReportMode: QuickReportModeState;
  /** @deprecated Use `quickReportMode` instead */
  quickReportModeEnabled: Scalars['Boolean']['output'];
  shouldDisconnectFromModule: Scalars['Boolean']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Subscribe to changes in actuation state for a specific device.
   * Returns updates when actuation status changes or when a new actuation is created.
   */
  deviceActuationUpdates: DeviceActuation;
  /** Subscribe to ICAR-id-only claim job progress updates. */
  nanoIcarIdOnlyClaimProgress: NanoWebIdClaimJobStatus;
  /**
   * Subscribe to NanoWebId claim job progress updates.
   * @deprecated Use nanoWebIdOnlyClaimProgress or nanoIcarIdOnlyClaimProgress.
   */
  nanoWebIdClaimProgress: NanoWebIdClaimJobStatus;
  /** Subscribe to web-id-only claim job progress updates. */
  nanoWebIdOnlyClaimProgress: NanoWebIdClaimJobStatus;
  /** Subscribe to all new location reports */
  newLocationReport?: Maybe<LocationReport>;
  /**
   * Subscribe to consolidated live state updates for a pet.
   * Fires on every pet state change (location, activity, status, module info).
   */
  petLiveState: PetLiveState;
  /** Subscribe to snooze status changes for a specific pet. */
  petSnoozeStatusUpdates: PetSnoozeStatus;
  petUpdates: Array<PetUpdate>;
};

export type SubscriptiondeviceActuationUpdatesArgs = {
  moduleId: Scalars['String']['input'];
};

export type SubscriptionnewLocationReportArgs = {
  imei?: InputMaybe<Scalars['String']['input']>;
  moduleId?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionpetLiveStateArgs = {
  petId: Scalars['ID']['input'];
};

export type SubscriptionpetSnoozeStatusUpdatesArgs = {
  petId: Scalars['ID']['input'];
};

export type SubscriptionpetUpdatesArgs = {
  changeTypes: Array<PetChangeType>;
  petId: Scalars['ID']['input'];
};

export enum SubscriptionAccessType {
  /** Payment has failed to renew the subscription beyond the grace period, payment update is required */
  FAILED_PAYMENT = 'FAILED_PAYMENT',
  /** Indicates that a device has an active subscription and should have access to everything */
  FULL_ACCESS = 'FULL_ACCESS',
  /** An S3 module that has no active subscription and should not have access to any features */
  NO_ACCESS = 'NO_ACCESS',
  /** An S1 or S2 module that has no active subscription and should not have access to GPS or historical data */
  NO_GPS_ACCESS = 'NO_GPS_ACCESS',
}

export type SubscriptionChange = {
  __typename?: 'SubscriptionChange';
  activateAt?: Maybe<Scalars['DateTime']['output']>;
  activated?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<PlanMini>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  unitAmount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SubscriptionOption = {
  __typename?: 'SubscriptionOption';
  /** @deprecated Use activationFeePricingInCents instead */
  activationFeeInCents?: Maybe<Scalars['Int']['output']>;
  activationFeePricingInCents?: Maybe<PricingByCurrency>;
  attemptUpsellToPlanCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use renewalMonths instead */
  billingCadence: BillingCadence;
  billingPeriodsPerTerm: Scalars['Int']['output'];
  buyItMembership: Scalars['Boolean']['output'];
  couponExtensionMonths?: Maybe<Scalars['Int']['output']>;
  daysBetweenShipments?: Maybe<Scalars['Int']['output']>;
  displayedRate: Scalars['String']['output'];
  displayedRateUnit: Scalars['String']['output'];
  featured: Scalars['Boolean']['output'];
  freeTrialDays?: Maybe<Scalars['Int']['output']>;
  /**
   * Deprecated fields
   * @deprecated Use pricingDescription instead
   */
  fullRate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use pricingDescription instead */
  fullRateUnit?: Maybe<Scalars['String']['output']>;
  inAppManagementName: Scalars['String']['output'];
  /**
   * Discounted first-term price in cents of a hardware-first membership: on purchasable options before
   * activation and inside the 7-day switch window (a plan change then bills this now), and on a
   * subscription's current plan for its whole discounted first term, after which it renews at the
   * standard price. Null when the standard price applies.
   */
  introPriceInCents?: Maybe<Scalars['Int']['output']>;
  isPlusPlan: Scalars['Boolean']['output'];
  monthlyUpgradeSavings?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Used by clients in subscription management e.g., "Monthly membership", "6 month membership" */
  planDescription: Scalars['String']['output'];
  planSwitchAmountChargedInCents?: Maybe<Scalars['Int']['output']>;
  planSwitchCreditAppliedInCents?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use pricingInCents instead */
  priceInCents: Scalars['Int']['output'];
  /** Used by clients in subscription management e.g., "$19 / month", "$99 / 6 months" */
  pricingDescription: Scalars['String']['output'];
  pricingInCents: PricingByCurrency;
  recommendedForDogSize?: Maybe<SizeOption>;
  recommendedForDogWeightRangePounds?: Maybe<WeightRange>;
  renewalMonths: Scalars['Int']['output'];
  /** @deprecated Use renewalMonths instead */
  renewalYears?: Maybe<Scalars['Int']['output']>;
  savings?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  supportPlus: Scalars['Boolean']['output'];
  unavailableForTenders: Array<TenderType>;
  upsellOnly: Scalars['Boolean']['output'];
  valueLabel?: Maybe<Scalars['String']['output']>;
  weeksBetweenShipments?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionPendingChange = {
  __typename?: 'SubscriptionPendingChange';
  subscriptionChange?: Maybe<SubscriptionChange>;
  subscriptionOption?: Maybe<SubscriptionOption>;
};

/** Preview of subscription purchase pricing (from Recurly invoice preview API) */
export type SubscriptionPurchasePreview = {
  __typename?: 'SubscriptionPurchasePreview';
  /** Account balance credit applied in cents (reduces total) */
  appliedAccountBalanceInCents: Scalars['Int']['output'];
  /** Base price in cents */
  basePriceInCents: Scalars['Int']['output'];
  /** Line items from Recurly invoice preview */
  lineItems: Array<PreviewLineItem>;
  /** Override price in cents (if set) */
  overridePriceInCents?: Maybe<Scalars['Int']['output']>;
  /** SKU being previewed */
  sku: Scalars['String']['output'];
  /** Tax amount in cents */
  taxInCents: Scalars['Int']['output'];
  /** Total amount to charge in cents (after account balance applied) */
  totalInCents: Scalars['Int']['output'];
};

/** Preview of subscription refund amounts for different refund options */
export type SubscriptionRefundPreview = {
  __typename?: 'SubscriptionRefundPreview';
  /** Currency of the subscription (USD or CAD) */
  currency: Scalars['String']['output'];
  /** Amount refunded for full refund in cents */
  fullRefundAmount: Scalars['Int']['output'];
  /** Most recent invoice number for this subscription */
  mostRecentInvoiceNumber?: Maybe<Scalars['String']['output']>;
  /** Amount refunded for no refund option (always 0) */
  noRefundAmount: Scalars['Int']['output'];
  /** Amount refunded for prorated refund in cents */
  proratedRefundAmount: Scalars['Int']['output'];
  /** Subscription ID */
  subscriptionId: Scalars['String']['output'];
};

/** Refund type options for subscription cancellation */
export enum SubscriptionRefundType {
  /** Immediate cancellation with full refund */
  FULL_REFUND = 'FULL_REFUND',
  /** Cancel at end of current term, no refund */
  NO_REFUND = 'NO_REFUND',
  /** Immediate cancellation with prorated refund */
  PRORATED_REFUND = 'PRORATED_REFUND',
}

export type SubscriptionRenewalPreview = {
  __typename?: 'SubscriptionRenewalPreview';
  appliedDiscountInCents: Scalars['Int']['output'];
  subtotalInCents: Scalars['Int']['output'];
  taxInCents: Scalars['Int']['output'];
  totalInCents: Scalars['Int']['output'];
};

export type SubscriptionRenewalStatus = {
  __typename?: 'SubscriptionRenewalStatus';
  reason?: Maybe<Scalars['String']['output']>;
  shouldOfferSubscriptionRenewal: Scalars['Boolean']['output'];
};

/**
 * Flat, principal-independent subscription summary for the email-keyed subscriptionsList
 * query. Deliberately not BillingSubscription: several of its subfields require a user
 * principal and reject capability/service callers.
 */
export type SubscriptionSummary = {
  __typename?: 'SubscriptionSummary';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Recurly v3 subscription ID, matching InvoiceSummary.subscriptionIds; distinct from the membership UUID in id. */
  billingId?: Maybe<Scalars['ID']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currentTermEndsAt?: Maybe<Scalars['DateTime']['output']>;
  currentTermStartedAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  pausedAt?: Maybe<Scalars['DateTime']['output']>;
  planCode: Scalars['String']['output'];
  planName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  remainingBillingCycles: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
  trialStartedAt?: Maybe<Scalars['DateTime']['output']>;
  unitAmountInCents: Scalars['Int']['output'];
};

export type SuggestedPacksResult = {
  __typename?: 'SuggestedPacksResult';
  packs: Array<Pack>;
};

export type SuggestedPet = {
  __typename?: 'SuggestedPet';
  strangerPet: StrangerPet;
  suggestionContextString?: Maybe<Scalars['String']['output']>;
  /** Used in Carousel suggestions. */
  suggestionFormatString?: Maybe<FormatString>;
};

export enum SuggestedPetCategoryType {
  CONTACTS = 'CONTACTS',
  ENGAGED_WITH = 'ENGAGED_WITH',
  FOLLOWS_YOU = 'FOLLOWS_YOU',
  NEARBY_HOME = 'NEARBY_HOME',
  NEARBY_PET = 'NEARBY_PET',
  SAME_AGE = 'SAME_AGE',
}

export type SuggestedPetFeed = {
  __typename?: 'SuggestedPetFeed';
  suggestedPets: Array<SuggestedPet>;
  type: SuggestedPetCategoryType;
};

export type SuggestedPetResult = {
  __typename?: 'SuggestedPetResult';
  suggestionCategories: Array<SuggestedPetFeed>;
};

export type SupplementShipmentDates = {
  __typename?: 'SupplementShipmentDates';
  displayDate: Scalars['DateTime']['output'];
  latestSkipDate: Scalars['DateTime']['output'];
  nextShipmentDate: Scalars['DateTime']['output'];
  previewResumingShipmentDate: Scalars['DateTime']['output'];
  previewSkippingShipmentDate: Scalars['DateTime']['output'];
  previewUpdate: Array<SupplementUpdatePreview>;
};

export type SupplementUpdatePreview = {
  __typename?: 'SupplementUpdatePreview';
  nextShipDate: Scalars['DateTime']['output'];
  sku: Scalars['String']['output'];
};

export type SuppressedNotificationLog = {
  __typename?: 'SuppressedNotificationLog';
  debugMetadata: Scalars['JSON']['output'];
  notificationMessage: Scalars['String']['output'];
  notificationType: Scalars['String']['output'];
  pet?: Maybe<Pet>;
  suppressionType: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  user: User;
};

export type SyncOrdersInput = {
  externalOrderIds: Array<Scalars['ID']['input']>;
  orderSource: OrderSource;
};

export type SyncOrdersResults = {
  __typename?: 'SyncOrdersResults';
  created: Scalars['Int']['output'];
  errors: Scalars['Int']['output'];
  filtered: Scalars['Int']['output'];
  new: Scalars['Int']['output'];
};

export type TActivityReportEvent = TEvent & {
  __typename?: 'TActivityReportEvent';
  activityReport: ActivityReport;
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type TAppLaunchEvent = TEvent & {
  __typename?: 'TAppLaunchEvent';
  applicationState?: Maybe<ApplicationState>;
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  user: User;
};

export type TCollapsedEvents = TEvent & {
  __typename?: 'TCollapsedEvents';
  allEvents: Array<TEvent>;
  count: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** Expose first/last event separately so you don't need to select all of `allEvents`. */
  firstEvent: TEvent;
  id: Scalars['ID']['output'];
  /** Expose first/last event separately so you don't need to select all of `allEvents`. */
  lastEvent: TEvent;
};

export type TConnectionHistoryEvent = TEvent & {
  __typename?: 'TConnectionHistoryEvent';
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  state: ConnectionState;
};

export type TDeviceInfoEvent = TEvent & {
  __typename?: 'TDeviceInfoEvent';
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  deviceInfo: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
};

export type TDeviceRestartEvent = TEvent & {
  __typename?: 'TDeviceRestartEvent';
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  newUptime: Scalars['Int']['output'];
  oldDate: Scalars['DateTime']['output'];
  oldUptime: Scalars['Int']['output'];
};

export type TEscapeEvent = TEvent & {
  __typename?: 'TEscapeEvent';
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['JSON']['output'];
  pet: Pet;
};

export type TEvent = {
  date: Scalars['DateTime']['output'];
  /** A simple string description of the event, useful for ad-hoc querying. */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum TEventType {
  ACTIVITY_REPORT = 'ACTIVITY_REPORT',
  APP_LAUNCH = 'APP_LAUNCH',
  CONNECTION_HISTORY = 'CONNECTION_HISTORY',
  /**
   * Includes some handy events derived from device-info, like device restarts
   * based on uptime.
   */
  DEVICE_EVENTS = 'DEVICE_EVENTS',
  DEVICE_INFO = 'DEVICE_INFO',
  DEVICE_RESPONSE = 'DEVICE_RESPONSE',
  ESCAPE_EVENT = 'ESCAPE_EVENT',
  FIRMWARE_UPDATE = 'FIRMWARE_UPDATE',
  LED_EVENT = 'LED_EVENT',
  LOCATION_REPORT = 'LOCATION_REPORT',
  LOST_DOG_MODE_TOGGLE = 'LOST_DOG_MODE_TOGGLE',
  LOW_POWER_MODE_TOGGLE = 'LOW_POWER_MODE_TOGGLE',
  MOBILITY_REPORT = 'MOBILITY_REPORT',
  MODULE_LOG = 'MODULE_LOG',
  NOTIFICATION_SEND = 'NOTIFICATION_SEND',
  OPERATION_PARAMS_CHANGE = 'OPERATION_PARAMS_CHANGE',
  PET_STATE = 'PET_STATE',
  SERVER_PUSH = 'SERVER_PUSH',
  STATS_CHANGED = 'STATS_CHANGED',
  SUPPRESSED_ESCAPE = 'SUPPRESSED_ESCAPE',
  SUPPRESSED_NOTIFICATION = 'SUPPRESSED_NOTIFICATION',
  WARNING = 'WARNING',
  WEBSOCKET_EVENTS = 'WEBSOCKET_EVENTS',
}

export type TFirmwareUpdateEvent = TEvent & {
  __typename?: 'TFirmwareUpdateEvent';
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  newVersion: Scalars['String']['output'];
  oldVersion?: Maybe<Scalars['String']['output']>;
};

export type TGenericLogEvent = TEvent & {
  __typename?: 'TGenericLogEvent';
  attributes?: Maybe<Scalars['JSON']['output']>;
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  level: LogLevel;
  message: Scalars['String']['output'];
};

export type TLedEvent = TEvent & {
  __typename?: 'TLedEvent';
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ledOn: Scalars['Boolean']['output'];
};

export type TLocationReportEvent = TEvent & {
  __typename?: 'TLocationReportEvent';
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locationReport: LocationReport;
};

export type TLostDogModeToggleEvent = TEvent & {
  __typename?: 'TLostDogModeToggleEvent';
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ldmOn: Scalars['Boolean']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
};

/**
 * A toggle of the Ultra "low power" mode (the `setDeviceDisabled` mutation), derived from
 * `operationParams.lowPower` transitions just as lost dog mode is derived from `mode`.
 */
export type TLowPowerModeToggleEvent = TEvent & {
  __typename?: 'TLowPowerModeToggleEvent';
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lowPowerOn: Scalars['Boolean']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
};

export type TMobilityReportEvent = TEvent & {
  __typename?: 'TMobilityReportEvent';
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mobilityReport: MobilityReport;
};

export type TModemRegistrationFailuresEvent = TEvent & {
  __typename?: 'TModemRegistrationFailuresEvent';
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  numFailures: Scalars['Int']['output'];
};

export type TModuleLogEvent = TEvent & {
  __typename?: 'TModuleLogEvent';
  attributes: Scalars['JSON']['output'];
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  hsmTransitionDetails?: Maybe<ModuleHSMTransitionDetails>;
  id: Scalars['ID']['output'];
  logType: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TNotificationSendEvent = TEvent & {
  __typename?: 'TNotificationSendEvent';
  channel: NotificationChannel;
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  user: User;
};

export type TOperationParamsChangeEvent = TEvent & {
  __typename?: 'TOperationParamsChangeEvent';
  /** @deprecated Use reason */
  controlEntry?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  newMode?: Maybe<Scalars['String']['output']>;
  newParams: Scalars['JSON']['output'];
  oldMode?: Maybe<Scalars['String']['output']>;
  oldParams: Scalars['JSON']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type TPetStateChangeEvent = TEvent & {
  __typename?: 'TPetStateChangeEvent';
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  newState: PetState;
  oldState: PetState;
};

export type TStatsChangedEvent = TEvent & {
  __typename?: 'TStatsChangedEvent';
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  newDeviceInfo: Scalars['JSON']['output'];
  oldDeviceInfo: Scalars['JSON']['output'];
  statsChanged: Array<StatChanged>;
};

export type TSuppressedEscapeEvent = TEvent & {
  __typename?: 'TSuppressedEscapeEvent';
  date: Scalars['DateTime']['output'];
  debugMetadata: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pet: Pet;
  statePlaceId?: Maybe<Scalars['Int']['output']>;
  suppressionReason: Scalars['String']['output'];
  /** @deprecated Use debugMetadata.totalReportsOutsidePlace */
  totalReportsOutsidePlace?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use debugMetadata.weightedAverageSteps */
  weightedAverageSteps?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use debugMetadata.weightedStepThreshold */
  weightedStepThreshold?: Maybe<Scalars['Float']['output']>;
};

export type TSuppressedNotificationEvent = TEvent & {
  __typename?: 'TSuppressedNotificationEvent';
  date: Scalars['DateTime']['output'];
  debugMetadata: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  suppressionType: Scalars['String']['output'];
  user: User;
};

export type TWebsocketEvent = TEvent & {
  __typename?: 'TWebsocketEvent';
  backhaul?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  protocol?: Maybe<Scalars['String']['output']>;
  session: Scalars['JSON']['output'];
  sessionId: Scalars['String']['output'];
};

export type TargetedFeatureFlag = {
  __typename?: 'TargetedFeatureFlag';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

/**
 * Result of OCR'ing a resale-cert image/PDF. Fields are nullable because OCR may not extract every
 * field from every cert (e.g. CA seller's permits print no expiration; some scans are too low-res
 * for a cert# read).
 */
export type TaxCertOcrFields = {
  __typename?: 'TaxCertOcrFields';
  certificateNumber?: Maybe<Scalars['String']['output']>;
  exemptionReason?: Maybe<ConsignmentExemptionReason>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  stateOfIssue?: Maybe<Scalars['String']['output']>;
};

export type TaxExemptAvalaraCert = {
  __typename?: 'TaxExemptAvalaraCert';
  expirationDate?: Maybe<Scalars['String']['output']>;
  exposureZoneName: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type TaxExemptAvalaraState = {
  __typename?: 'TaxExemptAvalaraState';
  certificates: Array<TaxExemptAvalaraCert>;
};

export type TaxExemptFiState = {
  __typename?: 'TaxExemptFiState';
  resaleCertExpirationDate?: Maybe<Scalars['String']['output']>;
  resaleCertStateOfIssue?: Maybe<Scalars['String']['output']>;
  taxExemptStatus: TaxExemptStatus;
};

/**
 * Live 3-source comparison of a consignment partner's tax-exempt state:
 * - Fi: stored milestones in our DB (the source of `taxExemptStatus`).
 * - Recurly: the account-level `tax_exempt` flag and `entity_use_code` (read at request time).
 * - Avalara: certificates currently on file (read at request time).
 *
 * `mismatches` are produced only when Fi says EXEMPT. When Fi says NOT_EXEMPT or
 * PENDING the partial/missing upstream state is expected (cert not yet filed, or
 * filed but Avalara hasn't confirmed yet), so the implementation short-circuits and
 * `mismatches` is always empty in those states.
 */
export type TaxExemptLiveCheck = {
  __typename?: 'TaxExemptLiveCheck';
  avalara?: Maybe<TaxExemptAvalaraState>;
  fi: TaxExemptFiState;
  mismatches: Array<TaxExemptMismatch>;
  recurly?: Maybe<TaxExemptRecurlyState>;
};

/**
 * A single disagreement between the three tax-exempt sources, with a human-readable
 * hint admin can act on. `kind` drives the click-through target in the admin UI
 * (Recurly account edit, in-page cert-fields accordion, or Avalara dashboard).
 */
export type TaxExemptMismatch = {
  __typename?: 'TaxExemptMismatch';
  kind: TaxExemptMismatchKind;
  message: Scalars['String']['output'];
  remediationHint: Scalars['String']['output'];
};

export enum TaxExemptMismatchKind {
  AVALARA_CERT_EXPIRED = 'AVALARA_CERT_EXPIRED',
  AVALARA_NO_CERTIFICATES = 'AVALARA_NO_CERTIFICATES',
  AVALARA_NO_CERT_FOR_RECURLY_ADDRESS_STATE = 'AVALARA_NO_CERT_FOR_RECURLY_ADDRESS_STATE',
  RECURLY_ENTITY_USE_CODE_MISSING = 'RECURLY_ENTITY_USE_CODE_MISSING',
  RECURLY_TAX_EXEMPT_FALSE = 'RECURLY_TAX_EXEMPT_FALSE',
}

export type TaxExemptRecurlyState = {
  __typename?: 'TaxExemptRecurlyState';
  accountTaxExempt: Scalars['Boolean']['output'];
  billingAddressState?: Maybe<Scalars['String']['output']>;
  entityUseCode?: Maybe<Scalars['String']['output']>;
};

/**
 * Reflects whether a consignment partner is exempt from sales tax in Recurly.
 *
 * - NOT_EXEMPT: No Avalara submission on record, or exemption was revoked.
 * - PENDING: Avalara submission recorded but Recurly has not yet been updated.
 * - EXEMPT: Avalara confirmed and Recurly flagged tax-exempt.
 */
export enum TaxExemptStatus {
  EXEMPT = 'EXEMPT',
  NOT_EXEMPT = 'NOT_EXEMPT',
  PENDING = 'PENDING',
}

/** The result of a tenancy update operation. The included entities are those that had their tenancy changed. */
export type TenancyUpdateResult = {
  __typename?: 'TenancyUpdateResult';
  chargingBases: Array<ChargingBase>;
  devices: Array<Device>;
  households: Array<Household>;
  pets: Array<Pet>;
  tenancy: Scalars['String']['output'];
};

export enum TenderType {
  CREDIT_CARD = 'CREDIT_CARD',
  PAYPAL = 'PAYPAL',
}

export type TextPost = {
  __typename?: 'TextPost';
  comments: CommentFeed;
  date: Scalars['DateTime']['output'];
  /** Admin-only */
  dbId: Scalars['Int']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  likeCount: Scalars['Int']['output'];
  /** If the current user has liked this post. */
  liked: Scalars['Boolean']['output'];
  likedByPets: Array<StrangerPet>;
  /** Pet associated with this post, if any. */
  pet: StrangerPet;
  poster: StrangerUser;
  publicShareLink?: Maybe<Scalars['String']['output']>;
  style: TextPostStyle;
  text: Scalars['String']['output'];
};

export type TextPostStyle = {
  __typename?: 'TextPostStyle';
  backgroundColorHex: Scalars['String']['output'];
  backgroundEndColorHex: Scalars['String']['output'];
  /** @deprecated Android is querying this field, but it is not used. */
  backgroundPhoto?: Maybe<Photo>;
  id: Scalars['ID']['output'];
  textColorHex: Scalars['String']['output'];
};

export type ThirdPartyChipInput = {
  serialNumber: Scalars['String']['input'];
};

export type ThirdPartyData = {
  __typename?: 'ThirdPartyData';
  data: AirvetDataItem;
  thirdPartyId: ThirdPartyId;
};

export enum ThirdPartyId {
  AIRVET = 'AIRVET',
  COSTCO_COM = 'COSTCO_COM',
  VERIZON = 'VERIZON',
}

export type TimeBoundStepCount = {
  __typename?: 'TimeBoundStepCount';
  end: Scalars['DateTime']['output'];
  /** Activity level in percent (0-1). */
  percentActive: Scalars['Float']['output'];
  start: Scalars['DateTime']['output'];
  steps: Scalars['Int']['output'];
};

export type TimeRangeEvent = {
  end?: Maybe<Scalars['DateTime']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

export enum TimelineAggregation {
  COLLAPSE_SIMILAR = 'COLLAPSE_SIMILAR',
}

/**
 * Rudimentary filters that will be applied where applicable.
 * These are purposely not very generic -- we're not implementing a full-fledged
 * query language.
 */
export type TimelineFieldFilter = {
  reportBackhaulsIn?: InputMaybe<Array<Scalars['String']['input']>>;
  reportSourcesIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TimelineIntervalPagination = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
};

export type TimelineLimitBeforePagination = {
  /**
   * Optional lower bound (inclusive, >= comparison). When set, paging stops at this
   * floor: results are restricted to [after, before] and `limit` still caps the page
   * size, so the existing "load older" cursor walks down to `after` and then exhausts.
   */
  after?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * This before date is used with a LessThan comparison so that the last element of the previous page can be passed directly here
   * and not return duplicate records
   */
  before?: InputMaybe<Scalars['DateTime']['input']>;
  limit: Scalars['Int']['input'];
};

export type TimelineMergedDeviceEvents = {
  __typename?: 'TimelineMergedDeviceEvents';
  events: Array<TEvent>;
  moduleId: Scalars['String']['output'];
};

export type TimelineMergedPageInfo = {
  __typename?: 'TimelineMergedPageInfo';
  /**
   * True when older matching data may exist before windowStart: a device filled its
   * location report limit, or the merged page was truncated to the server page cap.
   */
  hasMore: Scalars['Boolean']['output'];
  windowEnd: Scalars['DateTime']['output'];
  /**
   * Lower bound of the window this page fully covers: every matching event from every
   * requested device in [windowStart, windowEnd] is included. Pass this as the next
   * page's `before` cursor to continue paging older (deduplicate the boundary events by
   * id — bounds are inclusive). Null when no device has any matching location reports.
   */
  windowStart?: Maybe<Scalars['DateTime']['output']>;
};

export type TimelineMergedQueryResult = {
  __typename?: 'TimelineMergedQueryResult';
  deviceEvents: Array<TimelineMergedDeviceEvents>;
  pageInfo: TimelineMergedPageInfo;
};

/** Exactly one of the members must be set. */
export type TimelinePagination = {
  interval?: InputMaybe<TimelineIntervalPagination>;
  limitBefore?: InputMaybe<TimelineLimitBeforePagination>;
};

export type TimelineQueryClause = {
  /** BETA! Still trying to figure out the best level to apply aggregation on. */
  aggregation?: InputMaybe<TimelineAggregation>;
  fieldFilter?: InputMaybe<TimelineFieldFilter>;
  /** Event types we are interested in */
  types: Array<TEventType>;
};

export type TimelineQueryInput = {
  /** Return results matching ANY of these clauses. */
  clauses: Array<TimelineQueryClause>;
  /** Causes some data nodes to emit example events */
  debugEvents?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: TimelinePagination;
};

export type TimelineQueryResult = {
  __typename?: 'TimelineQueryResult';
  events: Array<TEvent>;
};

export type TokenValidity = InvalidToken | ValidToken;

/** Result of checking transfer eligibility for a device. */
export type TransferEligibility = {
  __typename?: 'TransferEligibility';
  /** Whether the transfer is allowed */
  eligible: Scalars['Boolean']['output'];
  /** Human-readable reason if transfer is not eligible */
  reason?: Maybe<Scalars['String']['output']>;
  /** Whether the transfer requires shipping new hardware */
  requiresNewHardware: Scalars['Boolean']['output'];
  /** Whether the transfer involves prorated credit from old subscription */
  requiresProration: Scalars['Boolean']['output'];
  /** Module ID of the source device */
  sourceModuleId: Scalars['String']['output'];
  /** Target platform type (e.g., FC3B, M1) */
  targetPlatformType: Scalars['String']['output'];
  /** Type of transfer flow to use (null if not eligible) */
  transferType?: Maybe<ProductTransferType>;
};

export type TransferPreviewItem = {
  __typename?: 'TransferPreviewItem';
  /** Only for PRORATED_UPGRADE */
  membershipChargeInCents: Scalars['Int']['output'];
  /** Only for PRORATED_UPGRADE */
  proratedCreditInCents: Scalars['Int']['output'];
  /** 'unchanged' for SKU_ONLY, 'reset' for PRORATED_UPGRADE */
  renewalDateChange: Scalars['String']['output'];
  sourceModuleId: Scalars['String']['output'];
  sourcePlanCode?: Maybe<Scalars['String']['output']>;
  targetModuleId?: Maybe<Scalars['String']['output']>;
  targetPlanCode: Scalars['String']['output'];
  transferType: ProductTransferType;
  /** Subscription id of a duplicate hardware-first membership an in-hand transfer would expire for $0, or null */
  willExpireDuplicateSubscriptionId?: Maybe<Scalars['String']['output']>;
};

/** Result of a single device transfer. */
export type TransferResultItem = {
  __typename?: 'TransferResultItem';
  /** Error message if success is false */
  error?: Maybe<Scalars['String']['output']>;
  /** Informational note about the outcome when success is true (e.g. the membership stayed on the source device) */
  note?: Maybe<Scalars['String']['output']>;
  sourceModuleId: Scalars['String']['output'];
  /** Subscription ID (same as source for SKU_ONLY, new for PRORATED_UPGRADE) */
  subscriptionId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  targetModuleId: Scalars['String']['output'];
  transferType: ProductTransferType;
};

export type TranslatedEntry = {
  __typename?: 'TranslatedEntry';
  key: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TranslationEntry = {
  __typename?: 'TranslationEntry';
  locale: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TranslationEntryInput = {
  locale: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum TranslationNamespace {
  MOBILE_COMMS = 'MOBILE_COMMS',
}

export type TranslationRecord = {
  __typename?: 'TranslationRecord';
  key: Scalars['String']['output'];
  namespace: TranslationNamespace;
  translations: Array<TranslationEntry>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type Travel = Activity & {
  __typename?: 'Travel';
  address?: Maybe<Scalars['String']['output']>;
  areaName?: Maybe<Scalars['String']['output']>;
  cityState?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use likeCount */
  clapCount: Scalars['Int']['output'];
  dbId: Scalars['Int']['output'];
  debugMetadata: Scalars['JSON']['output'];
  /** Distance in meters traveled */
  distance: Scalars['Float']['output'];
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use isLikable */
  isClappable: Scalars['Boolean']['output'];
  isLikable: Scalars['Boolean']['output'];
  likeCount: Scalars['Int']['output'];
  mapUrl: Scalars['String']['output'];
  neighborhood?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  obfuscated: Scalars['Boolean']['output'];
  positions: Array<Position>;
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']['output']>;
  start: Scalars['DateTime']['output'];
  totalSteps: Scalars['Int']['output'];
};

export type TravelmapUrlArgs = {
  colorScheme?: InputMaybe<ColorScheme>;
  height: Scalars['Int']['input'];
  minimumPadding?: InputMaybe<PaddingInput>;
  scale?: InputMaybe<Scalars['Int']['input']>;
  style?: InputMaybe<MapStyle>;
  width: Scalars['Int']['input'];
};

export type TrendingFeed = {
  __typename?: 'TrendingFeed';
  feedItems: Array<DiscoverFeedItem>;
};

export type TrueBooleanSetting = BooleanSetting & {
  __typename?: 'TrueBooleanSetting';
  /**
   * DO NOT USE: This is required since GraphQL doesn't support empty types.
   * Use the __typename to determine the flag's boolean value.
   */
  emptyType?: Maybe<Scalars['Boolean']['output']>;
  platformOverrides: Array<BooleanSettingPlatformOverride>;
};

export enum TsatBandLockStatus {
  APPLIED = 'APPLIED',
  PENDING = 'PENDING',
}

export type TwoLinePromotionBanner = InAppPromotionBanner & {
  __typename?: 'TwoLinePromotionBanner';
  backgroundColorHex: Scalars['String']['output'];
  ctaUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  line1Text: FormatString;
  line1TextColorHex: Scalars['String']['output'];
  line2Text: FormatString;
  line2TextColorHex: Scalars['String']['output'];
};

export type UnavailableDailyRestSummary = DailyRestSummary & {
  __typename?: 'UnavailableDailyRestSummary';
  date: Scalars['DateTime']['output'];
};

export type UnavailableOvernightRestSummary = OvernightRestSummary & {
  __typename?: 'UnavailableOvernightRestSummary';
  date: Scalars['DateTime']['output'];
  inProgress: Scalars['Boolean']['output'];
};

export type UnavailableRestSummaryData = {
  __typename?: 'UnavailableRestSummaryData';
  /** This field is always null, it's added because GraphQL doesn't support empty types. */
  unavailable?: Maybe<Scalars['Boolean']['output']>;
};

export type UncertaintyInfo = {
  __typename?: 'UncertaintyInfo';
  areaName?: Maybe<Scalars['String']['output']>;
  circle: Circle;
  updatedAt: Scalars['DateTime']['output'];
};

export type UnknownConnectivity = ConnectionState & {
  __typename?: 'UnknownConnectivity';
  date: Scalars['DateTime']['output'];
  isStale: Scalars['Boolean']['output'];
  /** Always null, added so that fragments can have something to select. */
  unknownConnectivity?: Maybe<Scalars['Boolean']['output']>;
};

export type UnmatchedPath = {
  __typename?: 'UnmatchedPath';
  locations: Array<Location>;
};

export type UnregisterHandsetLiveActivityTokenInput = {
  deviceToken: Scalars['String']['input'];
};

export type UpdateChangeLogInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  type?: InputMaybe<ChangeLogType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChargingBaseInput = {
  bleTxPowerLevel?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<PositionInput>;
  tenancy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChipConditionInput = {
  chipCondition: ChipCondition;
  chipId: Scalars['ID']['input'];
};

export type UpdateChipContactInfoInput = {
  chipId: Scalars['ID']['input'];
  contactInfo: ChipContactInfoInput;
  petId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateChipContactInfoResult = {
  __typename?: 'UpdateChipContactInfoResult';
  contactInfoResponse: ChipContactInfoResponse;
  /**
   * True if the pet ownership was transferred as part of this operation. The current
   * user may no longer own the pet associated with the chip.
   */
  petOwnershipWasTransferred: Scalars['Boolean']['output'];
};

export type UpdateChipResellerInfoInput = {
  contactInfo?: InputMaybe<ChipResellerContactInfoInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<ChipResellerShippingAddressInput>;
  taxExemptType?: InputMaybe<ResellerTaxExemptType>;
};

export type UpdateConsignmentAccountInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  fiSalesRepEmail?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Link an existing Recurly account by providing its account code. */
  recurlyAccountCode?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConsignmentLocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConsignmentRecurlyShippingAddressInput = {
  address: AddressInput;
  consignmentAccountId: Scalars['ID']['input'];
  ecomConfigType?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Update structured resale-cert fields without re-uploading the cert file. All fields are optional;
 * omitted fields are unchanged. Null `resaleCertExpirationDate` is synthesized to today+5y at the
 * server (same policy as registration, for permits that print no expiration).
 */
export type UpdateConsignmentResaleCertFieldsInput = {
  consignmentAccountId: Scalars['ID']['input'];
  resaleCertExemptionReason?: InputMaybe<ConsignmentExemptionReason>;
  resaleCertExpirationDate?: InputMaybe<Scalars['String']['input']>;
  resaleCertNumber?: InputMaybe<Scalars['String']['input']>;
  resaleCertStateOfIssue?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeviceOperationParamsInput = {
  /**
   * Admin-only, Ultra-only. True turns on containment feedback, false turns it off. Absent leaves
   * the current setting alone (a no-op, not a reset) — false is meaningful and must persist.
   */
  containmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Not used */
  gnssLongTimeout?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Not used */
  gnssMaxAcceptableRadiusM?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Not used */
  gnssMinAcceptableSatellites?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Deprecated. Delete once clients stop sending them.
   * @deprecated Not used
   */
  gnssShortTimeout?: InputMaybe<Scalars['Int']['input']>;
  ledEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lpppIntervalS?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<OperationParamsMode>;
  moduleId?: InputMaybe<Scalars['ID']['input']>;
  neighborCellsScanType?: InputMaybe<NeighborCellsScanType>;
  /**
   * Admin-only. Single PLMN (MCCMNC format, e.g. "310830") the device is forced to camp on. Empty string
   * clears it. Stored as an ALLOWED plmnProfile with one entry. Cannot be combined with plmnProfile.
   * @deprecated Use plmnProfile
   */
  plmnOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Admin-only. Either the PLMNs the device may camp on or the ones it must avoid, per the device's
   * plmnProfileSupport. Explicit null clears the profile; omit to leave it unchanged.
   */
  plmnProfile?: InputMaybe<PlmnProfileInput>;
  reboot?: InputMaybe<Scalars['Boolean']['input']>;
  remoteLogLevel?: InputMaybe<RemoteLogLevel>;
  requestLppp?: InputMaybe<Scalars['Boolean']['input']>;
  requestNeighborCellsScan?: InputMaybe<Scalars['Boolean']['input']>;
  switchEuiccProfile?: InputMaybe<Scalars['String']['input']>;
  /**
   * Admin-only. True locks the device's LTE modem to band 25 for TSAT testing; false clears the
   * lock. Applying or clearing the lock restarts the modem.
   */
  tsatBandLock?: InputMaybe<Scalars['Boolean']['input']>;
  wifiDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDynamicEnumMemberInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateEcommerceImageListInput = {
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  id: Scalars['ID']['input'];
  /** If images are being updated, all images must be provided */
  images?: InputMaybe<Array<EcommerceImageInput>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFiNewsNotificationInput = {
  featureImageUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFirmwareChannelInput = {
  channelName: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  releaseClass?: InputMaybe<FirmwareReleaseClass>;
  type?: InputMaybe<FirmwareUpdateType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFirmwareInput = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  releaseClass?: InputMaybe<FirmwareReleaseClass>;
};

export type UpdateGingrBoardingFacilityInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiSubdomain?: InputMaybe<Scalars['String']['input']>;
  boardingFacilityId: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The timezone for the boarding facility (e.g., "America/New_York"). */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGwaPromoCodeInput = {
  promoCodeAlias: Scalars['String']['input'];
};

export type UpdateGwaPromoCodeResult = {
  __typename?: 'UpdateGwaPromoCodeResult';
  enrollment: RescueGwaProgram;
};

export type UpdateInPersonEventInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  location: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type UpdateInPersonEventInventoryInput = {
  id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type UpdateMobileAppBannerInput = {
  backgroundColorHex?: InputMaybe<Scalars['HexColorCode']['input']>;
  borderGradient?: InputMaybe<MobileAppBannerBorderGradientInput>;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  darkModeBackgroundColorHex?: InputMaybe<Scalars['HexColorCode']['input']>;
  darkModeForegroundColorHex?: InputMaybe<Scalars['HexColorCode']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  destinationUrl?: InputMaybe<Scalars['String']['input']>;
  dismissOnTap?: InputMaybe<Scalars['Boolean']['input']>;
  dismissible?: InputMaybe<Scalars['Boolean']['input']>;
  dismissibleAfterSeconds?: InputMaybe<Scalars['Int']['input']>;
  foregroundColorHex?: InputMaybe<Scalars['HexColorCode']['input']>;
  id: Scalars['ID']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
  leadingImage?: InputMaybe<MobileAppBannerImageInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMobileAppBlockerScreenInput = {
  bottomSheet?: InputMaybe<CreateMobileAppBlockerScreenBottomSheetInput>;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  id: Scalars['ID']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
  /** If pages are being updated, all pages must be provided, updating individual pages is not supported */
  pages?: InputMaybe<Array<CreateMobileAppBlockerScreenPageInput>>;
};

export type UpdateMobileAppBottomSheetInput = {
  /**
   * The sheet's content, in the order a reader pages through it. All cards must be provided;
   * updating individual cards is not supported. Leave it out to change only the targeting.
   */
  cards?: InputMaybe<Array<CreateMobileAppBottomSheetCardInput>>;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  id: Scalars['ID']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMobileAppClientSplashInput = {
  clientSplashKey?: InputMaybe<ClientSplashKey>;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  id: Scalars['ID']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMobileAppDiscoverItemInput = {
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  destinationUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMobileAppPermissionBlockerScreenInput = {
  bottomSheet?: InputMaybe<CreateMobileAppBlockerScreenBottomSheetInput>;
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  dismissable?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
  /** If pages are being updated, all pages must be provided, updating individual pages is not supported */
  pages?: InputMaybe<Array<CreateMobileAppBlockerScreenPageInput>>;
  permissionType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMobileAppSplashScreenInput = {
  contentTargeting?: InputMaybe<MobileAppContentTargetingInput>;
  id: Scalars['ID']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
  /** If pages are being updated, all pages must be provided, updating individual pages is not supported */
  pages?: InputMaybe<Array<CreateMobileAppSplashScreenPageInput>>;
};

export type UpdateOrderShippingAddressInput = {
  id: Scalars['ID']['input'];
  shippingAddress: OrderShippingAddressInput;
};

export type UpdateOrderShippingOptionInput = {
  id: Scalars['ID']['input'];
  shippingOption: ShippingOption;
};

export type UpdatePetAlertPreferencesInput = {
  alertsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  changeSettings?: InputMaybe<Array<PetNotificationSettingInput>>;
  /**
   * Update preferences for the specified user instead of the currently logged-in
   * user (admin only).
   */
  forUserId?: InputMaybe<Scalars['ID']['input']>;
  notificationMode?: InputMaybe<PetNotificationMode>;
  petId: Scalars['ID']['input'];
};

export type UpdatePetCityStateInput = {
  city: Scalars['String']['input'];
  /**
   * The selected place's resolved fields, from the client's forward-geocode result. Each is optional;
   * the server uses what's provided and reverse-geocodes the position to fill any gaps. `countryCode`
   * (ISO 3166-1 alpha-2) and `subdivisionCode` (ISO 3166-2) are normalized server-side. `namesLanguage`
   * is the BCP-47 tag the names are in.
   */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  localityName?: InputMaybe<Scalars['String']['input']>;
  namesLanguage?: InputMaybe<Scalars['String']['input']>;
  /**
   * The selected place's coordinates. When provided, used directly as the home_location override
   * position; when omitted, the server forward-geocodes city/state to derive it.
   */
  position?: InputMaybe<PositionInput>;
  state: Scalars['String']['input'];
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
  subdivisionName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePetDocumentInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalCostCents?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePetInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  breedId?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  /**
   * Admin only. 'public' or 'internal' — internal-audience pets are hidden from all community
   * surfaces except for viewers in the InternalTester group.
   */
  communityAudience?: InputMaybe<Scalars['String']['input']>;
  dayOfBirth?: InputMaybe<Scalars['Int']['input']>;
  fiHandle?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['ID']['input'];
  /** Admin only. */
  isAmbassador?: InputMaybe<Scalars['Boolean']['input']>;
  isIncludedInRanking?: InputMaybe<Scalars['Boolean']['input']>;
  isPurebred?: InputMaybe<Scalars['Boolean']['input']>;
  monthOfBirth?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Species>;
  tenancy?: InputMaybe<Scalars['String']['input']>;
  thirdPartyAccess?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePhoneNumberAndAutoAcceptInvitesResult = {
  __typename?: 'UpdatePhoneNumberAndAutoAcceptInvitesResult';
  acceptedUserHouseholds: Array<UserHousehold>;
  acceptedUserInvites: Array<UserInvite>;
  user: User;
};

export type UpdatePhoneNumberInput = {
  phoneNumber: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type UpdatePlaceInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  /** Should only be set for polygon safe zones. */
  boundary?: InputMaybe<Scalars['JSON']['input']>;
  coordinates?: InputMaybe<Array<PositionInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<PositionInput>;
  /** If provided on a Quick Zone, resets the expiration. */
  quickZone?: InputMaybe<UpdateQuickZoneInput>;
  /** Should only be set for circle safe zones. */
  radius?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Optional containment zone for sound feedback. Set to create/update, omit to leave unchanged.
   * To remove an existing sound zone, use removeContainmentZonesForSafeZone mutation.
   */
  soundZone?: InputMaybe<CreateContainmentZoneInput>;
  subjectId: Scalars['ID']['input'];
  /** Circle or polygon safe zone. */
  type?: InputMaybe<PlaceType>;
  /**
   * Optional containment zone for vibration feedback. Set to create/update, omit to leave unchanged.
   * To remove an existing vibration zone, use removeContainmentZonesForSafeZone mutation.
   */
  vibrationZone?: InputMaybe<CreateContainmentZoneInput>;
};

export type UpdatePromotionInput = {
  /** ISO-2 country codes where this promotion applies. Null means all countries. */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Hours the promotion keeps running past `end`. 0 (the default) disables the
   * extension period.
   */
  extensionHours?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  variants?: InputMaybe<Scalars['JSON']['input']>;
};

/** Quick Zone options for updatePlace. When provided on a Quick Zone, resets the expiration. */
export type UpdateQuickZoneInput = {
  /** New time-to-live in seconds (resets expiration from now). */
  ttlSeconds: Scalars['Int']['input'];
};

/**
 * Moderator edit to the story content. Status transitions go through publish/reject — not this.
 * Photo replacement is not supported. All fields except `id` are optional: omit to leave unchanged.
 */
export type UpdateRescueStoryInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  collar?: InputMaybe<RescueStoryCollar>;
  eventDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  isFiUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** S3 key returned by `adminUploadRescueStoryPoster`. Pass null to clear; omit to leave unchanged. */
  posterS3Key?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<RescueStorySource>;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResellerContactInfoInput = {
  contactInfo: ChipContactInfoInput;
  resellerId: Scalars['ID']['input'];
  shippingAddress?: InputMaybe<AddressInput>;
};

export type UpdateResellerRescueVerified = {
  subjectId: Scalars['ID']['input'];
  verified: Scalars['Boolean']['input'];
};

export type UpdateShelterluvConfigInput = {
  chipResellerId: Scalars['ID']['input'];
  shelterluvConfiguration: ShelterluvConfigurationInput;
};

export type UpdateShipmentShippingAddressInput = {
  id: Scalars['ID']['input'];
  shippingAddress: OrderShippingAddressInput;
};

export type UpdateSupplementSubscriptionInput = {
  newSku: Scalars['String']['input'];
  recurlySubscriptionId: Scalars['ID']['input'];
};

export type UpdateSupplementSubscriptionResult = {
  __typename?: 'UpdateSupplementSubscriptionResult';
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserCommunicationPreferencesInput = {
  pushEnabled: Scalars['Boolean']['input'];
  smsEnabled: Scalars['Boolean']['input'];
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  subjectId: Scalars['ID']['input'];
  tenancy?: InputMaybe<Scalars['String']['input']>;
  thirdPartyAccess?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserLocalePreferencesInput = {
  distanceUnit?: InputMaybe<DistanceUnit>;
  language?: InputMaybe<FiLanguage>;
  region?: InputMaybe<FiCountry>;
  weightUnit?: InputMaybe<WeightUnit>;
};

export type UpdateUserNameInput = {
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  subjectId: Scalars['ID']['input'];
};

export type UpdateWifiNetworkInput = {
  householdId: Scalars['ID']['input'];
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  newPsk?: InputMaybe<Scalars['String']['input']>;
  newSsid?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<PositionInput>;
  ssid: Scalars['String']['input'];
};

export type UpgradeMembershipInput = {
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  couponCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  currency?: InputMaybe<Currency>;
  marketingEmailsOptedIn?: InputMaybe<Scalars['Boolean']['input']>;
  moduleId: Scalars['ID']['input'];
  sku: Scalars['ID']['input'];
  threeDSecureActionResultToken?: InputMaybe<Scalars['String']['input']>;
};

export type UpgradeToSeriesThreePlusModuleInput = {
  marketingEmailsOptedIn?: InputMaybe<Scalars['Boolean']['input']>;
  moduleId: Scalars['ID']['input'];
};

export type UpgradeToUltraInput = {
  marketingEmailsOptedIn?: InputMaybe<Scalars['Boolean']['input']>;
  membershipTermMonths?: InputMaybe<Scalars['Int']['input']>;
  moduleId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Set on a retry after the client completes a 3-D Secure challenge. The initial purchase attempt
   * throws a `three_d_secure` error carrying the action token; the client runs the challenge and
   * re-submits with the resulting token so Recurly can finalize the charge.
   */
  threeDSecureActionResultToken?: InputMaybe<Scalars['String']['input']>;
};

export type UploadContactInput = {
  contacts: Array<ContactInfo>;
};

export type UpsertTranslationInput = {
  key: Scalars['String']['input'];
  translations: Array<TranslationEntryInput>;
};

export type User = {
  __typename?: 'User';
  automaticallyActivateDevices: Scalars['Boolean']['output'];
  billingAccount?: Maybe<BillingAccount>;
  /**
   * In-app subscription management (aka in-app cancellation)
   * @deprecated No longer needed
   */
  canManageSupplementSubscriptions?: Maybe<Scalars['Boolean']['output']>;
  /** Chip reseller associated with this user, if any. */
  chipReseller?: Maybe<ChipReseller>;
  /** @deprecated Use chips instead */
  chipTransfersToUser: Array<ChipTransfer>;
  chips: Array<BaseChip>;
  /**
   * User's consent history for GDPR compliance.
   * Returns all consent records in reverse chronological order.
   */
  consentHistory: Array<ConsentRecord>;
  /** Current consent statuses for all consent types. */
  consentStatuses: Array<ConsentStatus>;
  dbId: Scalars['Int']['output'];
  deactivated: Scalars['Boolean']['output'];
  decagonWidgetAuth?: Maybe<DecagonWidgetAuth>;
  discoverFeed: DiscoverFeed;
  distanceUnit?: Maybe<DistanceUnit>;
  /**
   * A URL that users can use to update their payment information. This calls the
   * recurly API so only request when needed.
   */
  editBillingInfoUrl?: Maybe<Scalars['String']['output']>;
  /** Refers to user's primary email */
  email: Scalars['String']['output'];
  emails: Array<UserEmail>;
  fiFeed: FiFeed;
  fiNewsNotificationsEnabled: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  /**
   * Access is restricted to admins. To alter client behavior based on
   * a user's groups, create a new feature flag.
   */
  groups: Array<UserGroup>;
  handsets: Array<Handset>;
  /** Returns true if the user has the multidog discount coupon applied in Recurly. */
  hasMultidogDiscount: Scalars['Boolean']['output'];
  hasPurchasedSupplementSubscription?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use userHouseholds instead */
  households: Array<Household>;
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isRescuePartner: Scalars['Boolean']['output'];
  isVerizonCustomer: Scalars['Boolean']['output'];
  language?: Maybe<FiLanguage>;
  lastName?: Maybe<Scalars['String']['output']>;
  latestLocation?: Maybe<Location>;
  /**
   * Whether the user has opted in to marketing emails (Product Updates & Promotions topic in CIO).
   * Read from Customer.io subscription preferences. Defaults to true for users who haven't been asked.
   */
  marketingEmailsOptedIn: Scalars['Boolean']['output'];
  muteAllSearchParties: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  notificationFeed: NotificationFeed;
  /**
   * Pending deletion request in grace period for this user, if any.
   * Returns null if no PENDING request exists (does not include PROCESSING, COMPLETED, etc.).
   */
  pendingDeletionRequest?: Maybe<AdminUserDeletionRequest>;
  /**
   * Pets across every household this user belongs to. Optionally paginate
   * with `limit`/`pagingInstruction`, narrow by `householdType`, or apply
   * pet-level `filters` (e.g. HAS_DEVICE). Self-readable; admin
   * and customer support can read any user's pets.
   */
  petsFeed: PetFeed;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Returns phone support details for this user. */
  phoneSupport: PhoneSupport;
  /**
   * Returns all collar kit product IDs that the user has previously purchased (excluding canceled orders).
   * Used by the frontend to prevent showing free trial options for products the user already owns.
   */
  previouslyPurchasedCollarProductIds: Array<Scalars['String']['output']>;
  /**
   * Whether the user's data processing is restricted under GDPR Art. 18. When true, non-essential
   * processing (marketing, analytics, social) is halted while essential/transactional processing continues.
   */
  processingRestricted: Scalars['Boolean']['output'];
  /** When the user's processing was restricted, or null if not restricted. */
  processingRestrictedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Admin/CS-only note describing why processing was restricted. Null if not restricted. */
  processingRestrictedReason?: Maybe<Scalars['String']['output']>;
  /** Returns all pets that can be recalled by this user. */
  recallableTransferredPets: Array<Pet>;
  referrals: Referrals;
  /**
   * Where the account is homed for commerce and regulatory purposes (currency, plan
   * availability, referral eligibility, collar wifi country code). Derived from signup
   * geoIP and the device's point of sale — not a client-settable preference.
   */
  region?: Maybe<FiCountry>;
  settings: UserSettings;
  socialBanned: Scalars['Boolean']['output'];
  /** Returns all feature flag values by default, but can optionally provide an array of feature flag names to return */
  targetedFeatureFlags: Array<TargetedFeatureFlag>;
  tenancy?: Maybe<Scalars['String']['output']>;
  thirdPartyAccess?: Maybe<Scalars['String']['output']>;
  thirdPartyData: Array<Maybe<ThirdPartyData>>;
  /** @deprecated All subscription data will be in thirdPartyData */
  thirdPartySubscriptions?: Maybe<Array<Maybe<BillingSubscription>>>;
  timezone: Scalars['String']['output'];
  /** Returns all pets that can be temporarily transferred by this user. */
  transferablePets: Array<Pet>;
  trendingPosts: TrendingFeed;
  userHouseholds: Array<UserHousehold>;
  weightUnit?: Maybe<WeightUnit>;
};

export type UserchipTransfersToUserArgs = {
  query?: InputMaybe<ChipTransferQueryInput>;
};

export type UserdiscoverFeedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
  pulledToRefresh?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserfiFeedArgs = {
  filter?: InputMaybe<FiFeedFilter>;
  includeTravel?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
  seekParameters?: InputMaybe<SeekParameters>;
};

export type UsergroupsArgs = {
  excludePseudo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserhandsetsArgs = {
  status?: InputMaybe<Array<HandsetStatus>>;
};

export type UsernotificationFeedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type UserpetsFeedArgs = {
  filters?: InputMaybe<Array<PetFilter>>;
  householdType?: InputMaybe<HouseholdType>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagingInstruction?: InputMaybe<PagingInstruction>;
};

export type UsertargetedFeatureFlagsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserthirdPartyDataArgs = {
  id?: InputMaybe<ThirdPartyId>;
};

export type UseruserHouseholdsArgs = {
  householdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UserAccountDeletionInput = {
  userId: Scalars['ID']['input'];
};

/** Info for a user's contacts uploaded from their phone. */
export type UserContactInfo = {
  __typename?: 'UserContactInfo';
  emails?: Maybe<Array<Scalars['String']['output']>>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<Scalars['String']['output']>>;
};

export enum UserDevice {
  PHONE = 'PHONE',
  WEARABLE = 'WEARABLE',
}

export type UserEmail = {
  __typename?: 'UserEmail';
  email: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
};

export type UserFeedbackActivityPlayFeedbackSubmitInput = {
  feedback: Scalars['String']['input'];
  playEventId: Scalars['ID']['input'];
};

export type UserFeedbackActivityRestFeedbackSubmitInput = {
  feedback: Scalars['String']['input'];
  restEventId: Scalars['ID']['input'];
};

export type UserFeedbackActivityTravelFeedbackSubmitInput = {
  feedback: Scalars['String']['input'];
  travelEventId: Scalars['ID']['input'];
};

export type UserFeedbackActivityWalkFeedbackSubmitInput = {
  feedback: Scalars['String']['input'];
  walkEventId: Scalars['ID']['input'];
};

export type UserFeedbackEscapeAlertFeedbackSubmitInput = {
  escapeAlertNotificationId: Scalars['ID']['input'];
  feedback: Scalars['String']['input'];
  isNotificationAccurate?: InputMaybe<Scalars['Boolean']['input']>;
  petId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserFeedbackLostDogFeedbackSubmitInput = {
  feedback: Scalars['String']['input'];
  petId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserFeedbackLostDogModeDidHelpInput = {
  didHelp: Scalars['Boolean']['input'];
  petId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Similar to household but augmented with user specific data */
export type UserHousehold = {
  __typename?: 'UserHousehold';
  /** Whether this is the first user household that was created for this user. */
  firstCreated: Scalars['Boolean']['output'];
  household: Household;
  householdRole: UserHouseholdRole;
};

export enum UserHouseholdRole {
  CARETAKER = 'CARETAKER',
  OWNER = 'OWNER',
  PROVISIONAL_CARETAKER = 'PROVISIONAL_CARETAKER',
}

export type UserIdsBooleanSetting = BooleanSetting & {
  __typename?: 'UserIdsBooleanSetting';
  platformOverrides: Array<BooleanSettingPlatformOverride>;
  userIds: Array<Scalars['Int']['output']>;
};

export type UserInvite = {
  __typename?: 'UserInvite';
  acceptedDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * This is admin-only for now because we don't expose the User type for other users,
   * and invites can be accessed at a household level where you may receive another user's
   * invite.
   */
  adminInviter: User;
  createdAt: Scalars['DateTime']['output'];
  dbId: Scalars['Int']['output'];
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  householdInvite?: Maybe<HouseholdInvite>;
  /** The invite code. */
  id: Scalars['String']['output'];
  inviteCode: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  revokedDate?: Maybe<Scalars['DateTime']['output']>;
  state: InviteState;
};

export type UserNotificationSettings = {
  __typename?: 'UserNotificationSettings';
  maxNumMinutesForOfflineNotification: Scalars['Int']['output'];
  minNumMinutesForOfflineNotification: Scalars['Int']['output'];
};

export type UserSearchPartySettings = {
  __typename?: 'UserSearchPartySettings';
  muteAllSearchParties: Scalars['Boolean']['output'];
};

export type UserSettings = {
  __typename?: 'UserSettings';
  autoSetBaseLocationEnabled: Scalars['Boolean']['output'];
  /** @deprecated Use User.distanceUnit */
  distanceUnit?: Maybe<DistanceUnit>;
  dynamicSettings: Scalars['JSON']['output'];
  helpCenterEnabled: Scalars['Boolean']['output'];
  /** @deprecated Use User.language */
  language?: Maybe<FiLanguage>;
  locationReportThrottleDuration: Scalars['Float']['output'];
  lostDogPhoneLineEnabled: Scalars['Boolean']['output'];
  minimumLogLevel: LogLevel;
  minimumTimeIntervalBetweenLocationReports: Scalars['Float']['output'];
  moduleActivationRequiresModuleBePowered: Scalars['Boolean']['output'];
  notificationSettings: UserNotificationSettings;
  referralMenuBannerSettings: ReferralMenuBannerSettings;
  referralsEnabled: Scalars['Boolean']['output'];
  rescueOrganizationAccess: Scalars['Boolean']['output'];
  searchPartySettings: UserSearchPartySettings;
  series2UpsellString: FormatString;
  shouldAlwaysScanForBases: Scalars['Boolean']['output'];
  shouldBatchLocationReports: Scalars['Boolean']['output'];
  shouldPromptAppReview: Scalars['Boolean']['output'];
  showDebugMenu: Scalars['Boolean']['output'];
  showSeries2Upsell: Scalars['Boolean']['output'];
  /** @deprecated No longer used. Always returns false. */
  systemMetricLoggingEnabled: Scalars['Boolean']['output'];
  useFiBleProxy: Scalars['Boolean']['output'];
  userImpersonationEnabled: Scalars['Boolean']['output'];
  walkSharingEnabled: Scalars['Boolean']['output'];
  /** @deprecated Use User.weightUnit */
  weightUnit?: Maybe<WeightUnit>;
};

export type ValidToken = {
  __typename?: 'ValidToken';
  token: Scalars['String']['output'];
};

export type ValidateAddressResponse = {
  __typename?: 'ValidateAddressResponse';
  matchedAddress?: Maybe<Address>;
  status?: Maybe<ValidateAddressResponseStatus>;
};

export enum ValidateAddressResponseStatus {
  CORRECTED = 'CORRECTED',
  NOT_VERIFIED = 'NOT_VERIFIED',
  VERIFIED = 'VERIFIED',
}

export type Veterinary = {
  __typename?: 'Veterinary';
  address?: Maybe<VeterinaryAddress>;
  dbId: Scalars['Int']['output'];
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type VeterinaryAddress = {
  __typename?: 'VeterinaryAddress';
  city: Scalars['String']['output'];
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type VideoLink = {
  __typename?: 'VideoLink';
  aspectRatio: AspectRatio;
  type: VideoType;
  url: Scalars['String']['output'];
};

export enum VideoOrientation {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT',
}

export type VideoPost = {
  __typename?: 'VideoPost';
  aspectRatio: AspectRatio;
  caption?: Maybe<Scalars['String']['output']>;
  comments: CommentFeed;
  date: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  /** When true, the post is hidden from other users but still visible to the poster. */
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  includesAudio: Scalars['Boolean']['output'];
  likeCount: Scalars['Int']['output'];
  /** If the current user has liked this post. */
  liked: Scalars['Boolean']['output'];
  likedByPets: Array<StrangerPet>;
  /** Pet associated with this post */
  pet: StrangerPet;
  poster: StrangerUser;
  /** Returns the requested playback format, may return null if the format is not available due to video processing not being complete. */
  preferredPlaybackLink?: Maybe<VideoLink>;
  /** A link to a web page containing this post that can be shared publicly if item is publicly shareable */
  publicShareLink?: Maybe<Scalars['String']['output']>;
  status: VideoPostStatus;
  thumbnailImage?: Maybe<Image>;
};

export type VideoPostpreferredPlaybackLinkArgs = {
  format: VideoType;
};

export enum VideoPostStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  READY = 'READY',
}

export enum VideoType {
  DASH = 'DASH',
  HLS = 'HLS',
  MP4 = 'MP4',
}

export type VipUserLookupCriteria = {
  __typename?: 'VipUserLookupCriteria';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailDomain?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<VipUserLookupCriteriaName>;
};

export type VipUserLookupCriteriaName = {
  __typename?: 'VipUserLookupCriteriaName';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type VirtualPack = BasePack & {
  __typename?: 'VirtualPack';
  actingPetCanJoin: Scalars['Boolean']['output'];
  actingPetCanLeave: Scalars['Boolean']['output'];
  actingPetCannotJoinReason?: Maybe<Scalars['String']['output']>;
  actingPetDidManuallyJoin: Scalars['Boolean']['output'];
  actingPetIsMember: Scalars['Boolean']['output'];
  actingPetMembershipReason: Scalars['String']['output'];
  ageFiltersWithEnoughRankedPets: Array<PackAgeFilter>;
  avatar: PackAvatar;
  category: PackCategory;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * A 6-digit hex color code, including # sign, and letters lowercase (eg.
   * `#ff00b1`) used to highlight this pack in the app.
   */
  highlightColorHex?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  joinPackUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  petRanking: PackRanking;
  photo?: Maybe<Photo>;
  totalRankedPets: Scalars['Int']['output'];
  /**
   * A 64-bit integer representing the total steps for all pets in this pack for
   * the latest ranking period returned as a String.
   */
  totalRankedSteps: Scalars['String']['output'];
};

export type VirtualPackpetRankingArgs = {
  packAgeFilter?: InputMaybe<PackAgeFilter>;
  petId: Scalars['ID']['input'];
};

export type Walk = Activity & {
  __typename?: 'Walk';
  address?: Maybe<Scalars['String']['output']>;
  animatedShareableUrl: AnimatedShareableUrls;
  areaName?: Maybe<Scalars['String']['output']>;
  cityState?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use likeCount */
  clapCount: Scalars['Int']['output'];
  dbId: Scalars['Int']['output'];
  debugMetadata: Scalars['JSON']['output'];
  /** Distance in meters traveled */
  distance: Scalars['Float']['output'];
  end: Scalars['DateTime']['output'];
  /**
   * True when this walk's step count is unreliable — typically because the walk was captured solely
   * by a device that doesn't track steps (e.g. an Ultra) while the step-tracking device was elsewhere.
   * Mobile should suppress the step display when true.
   */
  excludeStepCount: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use isLikable */
  isClappable: Scalars['Boolean']['output'];
  isLikable: Scalars['Boolean']['output'];
  likeCount: Scalars['Int']['output'];
  mapPath: MapPath;
  mapUrl: Scalars['String']['output'];
  neighborhood?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  obfuscated: Scalars['Boolean']['output'];
  /** Stored path positions */
  path: Array<Position>;
  pathProcessingDataForDebug: PathProcessingDataForDebug;
  /** raw positions */
  positions: Array<Location>;
  presentUser?: Maybe<User>;
  presentUserString?: Maybe<Scalars['String']['output']>;
  routeMatcherName?: Maybe<Scalars['String']['output']>;
  sharedToExternalApps: Array<Maybe<AppIntegrationId>>;
  start: Scalars['DateTime']['output'];
  totalSteps: Scalars['Int']['output'];
};

export type WalkanimatedShareableUrlArgs = {
  format: AnimationFormat;
};

export type WalkmapUrlArgs = {
  colorScheme?: InputMaybe<ColorScheme>;
  height: Scalars['Int']['input'];
  minimumPadding?: InputMaybe<PaddingInput>;
  scale?: InputMaybe<Scalars['Int']['input']>;
  style?: InputMaybe<MapStyle>;
  width: Scalars['Int']['input'];
};

export type WalkSegmentsGeoJSONZipInput = {
  /** Must be a walk activity. */
  activityId: Scalars['ID']['input'];
  /** To be included in downloaded file. */
  description?: InputMaybe<Scalars['String']['input']>;
};

export type WalletPaymentInfo = {
  __typename?: 'WalletPaymentInfo';
  type: Scalars['String']['output'];
};

export type WarehouseInventoryLevel = {
  __typename?: 'WarehouseInventoryLevel';
  allowFulfillment: Scalars['Boolean']['output'];
  fulfillmentWarehouse: FulfillmentWarehouse;
  manualAdjustment: Scalars['Int']['output'];
  outOfStockThreshold: Scalars['Int']['output'];
  quantityInStock: Scalars['Int']['output'];
  quantityPending: Scalars['Int']['output'];
  quantityReserved: Scalars['Int']['output'];
};

export type WeekInReview = {
  __typename?: 'WeekInReview';
  /**
   * Cards to render, in canonical order: steps → streak → strain → walk → rank → tier.
   * Cards with insufficient data are omitted; relative order is preserved.
   */
  cards: Array<WeekInReviewCard>;
  /**
   * Human-readable date range label for the top-level card, e.g.
   * "April 2 - April 8". Formatted server-side in the pet's local timezone
   * so clients don't have to reproduce the timezone-aware date math.
   */
  dateRangeLabel: Scalars['String']['output'];
  /** Human-readable date range label for the share card. */
  shareCardDateRangeLabel: Scalars['String']['output'];
  /** End of day Sunday of the review week, in the pet's local timezone. */
  weekEnd: Scalars['DateTime']['output'];
  /** Monday 00:00 of the review week, in the pet's local timezone. */
  weekStart: Scalars['DateTime']['output'];
};

export type WeekInReviewCard =
  | WeekInReviewRankCard
  | WeekInReviewStepsCard
  | WeekInReviewStrainCard
  | WeekInReviewStreakCard
  | WeekInReviewTierGraduationCard
  | WeekInReviewTierProgressCard
  | WeekInReviewWalkCard;

export type WeekInReviewDaySteps = {
  __typename?: 'WeekInReviewDaySteps';
  date: Scalars['DateTime']['output'];
  stepCount: Scalars['Int']['output'];
};

export type WeekInReviewRankCard = {
  __typename?: 'WeekInReviewRankCard';
  /**
   * Average rank movement across this pet's groups. Positive = improved
   * (rank number decreased); negative = dropped; 0 = unchanged. Null when
   * there is no comparable prior week.
   */
  averageRankChange?: Maybe<Scalars['Int']['output']>;
  /** Backend-curated, ordered most-specific to least-specific for display. */
  groups: Array<WeekInReviewRankGroup>;
};

export type WeekInReviewRankGroup = {
  __typename?: 'WeekInReviewRankGroup';
  /** Display label, e.g. 'German Shepherds', 'Brooklyn Dogs', 'All Fi Dogs'. */
  label: Scalars['String']['output'];
  /** 1-indexed rank within this group. */
  rank: Scalars['Int']['output'];
  /**
   * Movement vs prior week. Positive = improved (rank number decreased);
   * negative = dropped; 0 = unchanged; null = not comparable.
   */
  rankChange?: Maybe<Scalars['Int']['output']>;
  /** Optional secondary label, e.g. '4,268 dogs' or 'Top 1,000 dogs'. */
  subLabel?: Maybe<Scalars['String']['output']>;
};

export type WeekInReviewStepsCard = {
  __typename?: 'WeekInReviewStepsCard';
  averageDailySteps: Scalars['Int']['output'];
  /**
   * Each day of the review week, ordered Mon → Sun. Always 7 entries; days with no
   * recorded steps report stepCount = 0.
   */
  dailySteps: Array<WeekInReviewDaySteps>;
  /** Total steps across the review week (sum of all days). */
  totalSteps: Scalars['Int']['output'];
  /** Percent change vs prior week (e.g. 28 for "+28%"). Null if no comparable prior week. */
  weekOverWeekPercentChange?: Maybe<Scalars['Float']['output']>;
};

export type WeekInReviewStrainCard = {
  __typename?: 'WeekInReviewStrainCard';
  /** Average daily strain across the review week. */
  averageStrain: Scalars['Float']['output'];
  /**
   * Daily strain for the sparkline, ordered Mon → Sun. Always 7 entries;
   * score is null on days with no strain data so the client can render gaps.
   */
  dailyStrain: Array<WeekInReviewStrainDay>;
  /**
   * Percent change vs prior week. Null if no comparable prior week.
   * @deprecated The simplified strain card renders only averageStrain and the dailyStrain sparkline.
   */
  weekOverWeekPercentChange?: Maybe<Scalars['Float']['output']>;
};

export type WeekInReviewStrainDay = {
  __typename?: 'WeekInReviewStrainDay';
  date: Scalars['DateTime']['output'];
  /** Null when no strain data was recorded for this day. */
  score?: Maybe<Scalars['Float']['output']>;
};

export type WeekInReviewStreakCard = {
  __typename?: 'WeekInReviewStreakCard';
  /** Best day of the week by goalPercent. */
  bestDay: WeekInReviewStreakDay;
  /**
   * Each day, ordered Mon → Sun. Always 7 entries. goalPercent is uncapped —
   * UI shows values >100 (e.g. 145%).
   */
  dailyGoals: Array<WeekInReviewStreakDay>;
};

export type WeekInReviewStreakDay = {
  __typename?: 'WeekInReviewStreakDay';
  date: Scalars['DateTime']['output'];
  goalPercent: Scalars['Float']['output'];
};

/**
 * The pet crossed into a new lifetime-step tier during the review week. Mutually
 * exclusive with WeekInReviewTierProgressCard — a week yields at most one of the two.
 */
export type WeekInReviewTierGraduationCard = {
  __typename?: 'WeekInReviewTierGraduationCard';
  /** Lifetime steps as of the end of the review week. */
  cumulativeSteps: Scalars['Int']['output'];
  tier: PetLifetimeStatsTier;
};

/**
 * Progress toward the next lifetime-step tier, shown on weeks with no graduation.
 * Omitted for pets already at the top tier, which have nothing to progress toward.
 */
export type WeekInReviewTierProgressCard = {
  __typename?: 'WeekInReviewTierProgressCard';
  /** Lifetime steps as of the end of the review week. */
  cumulativeSteps: Scalars['Int']['output'];
  currentTier: PetLifetimeStatsTier;
  nextTier: PetLifetimeStatsTier;
  /** 0–100 progress from `currentTier.stepMinimum` toward `nextTier.stepMinimum`. */
  progressPercent: Scalars['Float']['output'];
  /** Steps recorded during the review week, i.e. how much closer this week got the pet. */
  stepsThisWeek: Scalars['Int']['output'];
  stepsToNextTier: Scalars['Int']['output'];
};

export type WeekInReviewWalkCard = {
  __typename?: 'WeekInReviewWalkCard';
  /**
   * Optional human-readable comparison string the backend may surface
   * alongside the walk (e.g. "Longer than the Brooklyn Bridge").
   */
  comparisonFact?: Maybe<Scalars['String']['output']>;
  /**
   * Longest walk that both started and ended within the review week, with
   * distance > 0.5 miles. The card is omitted if no walk qualifies.
   */
  walk: Walk;
};

export type WeightRange = {
  __typename?: 'WeightRange';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export enum WeightUnit {
  KG = 'KG',
  LB = 'LB',
}

export type WifiCredentialInput = {
  isHidden: Scalars['Boolean']['input'];
  psk?: InputMaybe<Scalars['String']['input']>;
  ssid: Scalars['String']['input'];
};

export type WifiNetwork = {
  __typename?: 'WifiNetwork';
  addressLabel?: Maybe<Scalars['String']['output']>;
  /** May be false if the system has reason to believe the network's stored position is no longer accurate */
  hasAccuratePosition: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  isInSafeZone: Scalars['Boolean']['output'];
  position: Position;
  ssid: Scalars['String']['output'];
  state?: Maybe<WifiNetworkStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum WifiNetworkStatus {
  ACTIVE = 'ACTIVE',
  CONNECTION_ERROR = 'CONNECTION_ERROR',
  PENDING = 'PENDING',
}

export type WifiNetworks = {
  __typename?: 'WifiNetworks';
  credentialPackHash?: Maybe<Scalars['String']['output']>;
  maximumNetworkCount: Scalars['Int']['output'];
  networks: Array<WifiNetwork>;
};

export type WifiScanResult = {
  __typename?: 'WifiScanResult';
  authMode?: Maybe<Scalars['String']['output']>;
  rssi?: Maybe<Scalars['Int']['output']>;
  ssid?: Maybe<Scalars['String']['output']>;
};

export enum supplementCancellationReason {
  DOG_DOES_NOT_LIKE_IT = 'DOG_DOES_NOT_LIKE_IT',
  OTHER = 'OTHER',
  SUBSCRIBED_BY_ACCIDENT = 'SUBSCRIBED_BY_ACCIDENT',
  TOO_EXPENSIVE = 'TOO_EXPENSIVE',
}

export enum zendeskCancellationReason {
  BATTERY_DRAINS_TOO_QUICKLY = 'BATTERY_DRAINS_TOO_QUICKLY',
  BILLING_ERROR = 'BILLING_ERROR',
  CAT_PASSED_AWAY = 'CAT_PASSED_AWAY',
  CAT_WILL_NOT_WEAR_COLLAR = 'CAT_WILL_NOT_WEAR_COLLAR',
  COLLAR_DOES_NOT_WORK_PROPERLY = 'COLLAR_DOES_NOT_WORK_PROPERLY',
  COLLAR_IS_LOST = 'COLLAR_IS_LOST',
  COLLAR_IS_PHYSICALLY_BROKEN = 'COLLAR_IS_PHYSICALLY_BROKEN',
  DOG_DOES_NOT_RUN_AWAY = 'DOG_DOES_NOT_RUN_AWAY',
  DOG_PASSED_AWAY = 'DOG_PASSED_AWAY',
  DOG_WILL_NOT_WEAR_COLLAR = 'DOG_WILL_NOT_WEAR_COLLAR',
  LOCATION_REPORTS_INCORRECT = 'LOCATION_REPORTS_INCORRECT',
  OTHER = 'OTHER',
  PLAN_TO_REACTIVATE = 'PLAN_TO_REACTIVATE',
  REPLACING_DEVICE = 'REPLACING_DEVICE',
  TOOK_TOO_LONG_TO_NOTIFY = 'TOOK_TOO_LONG_TO_NOTIFY',
  TOO_EXPENSIVE = 'TOO_EXPENSIVE',
}

export type billingAccountVariables = Exact<{ [key: string]: never }>;

export type billingAccount = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName?: string | null;
    isRescuePartner: boolean;
    isVerizonCustomer: boolean;
    decagonWidgetAuth?: { __typename?: 'DecagonWidgetAuth'; signature: string; epoch: number } | null;
    billingAccount?: {
      __typename?: 'BillingAccount';
      firstName?: string | null;
      lastName?: string | null;
      canUpdatePaymentInfo: boolean;
      billingInfo?: {
        __typename?: 'BillingInfo';
        firstName: string;
        lastName: string;
        address: {
          __typename?: 'Address';
          line1: string;
          line2?: string | null;
          city: string;
          state: string;
          zip: string;
          country: string;
        };
        paymentInfo:
          | { __typename: 'BankAccountInfo'; bankName: string; last4: string; accountType: string }
          | { __typename: 'ObfuscatedCardInfo'; lastFour: number; type: string; month: number; year: number }
          | { __typename: 'PayPalInfo' }
          | { __typename: 'WalletPaymentInfo'; type: string };
      } | null;
      address?: {
        __typename?: 'Address';
        line1: string;
        line2?: string | null;
        city: string;
        state: string;
        zip: string;
        country: string;
        phone?: string | null;
      } | null;
    } | null;
  };
};

export type updateBillingInfoVariables = Exact<{
  input: BillingAccountInput;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type updateBillingInfo = {
  __typename?: 'Mutation';
  updateBillingAccount: {
    __typename?: 'BillingAccount';
    billingInfo?: {
      __typename?: 'BillingInfo';
      firstName: string;
      lastName: string;
      address: {
        __typename?: 'Address';
        line1: string;
        line2?: string | null;
        city: string;
        state: string;
        zip: string;
        country: string;
      };
      paymentInfo:
        | { __typename: 'BankAccountInfo' }
        | { __typename: 'ObfuscatedCardInfo'; lastFour: number; type: string; month: number; year: number }
        | { __typename: 'PayPalInfo' }
        | { __typename: 'WalletPaymentInfo' };
    } | null;
  };
};

export type ECOMMERCE_createUserBillingAccountVariables = Exact<{ [key: string]: never }>;

export type ECOMMERCE_createUserBillingAccount = {
  __typename?: 'Mutation';
  createBillingAccount: { __typename?: 'BillingAccount'; code: string };
};

export type activeBillingSubscriptionsVariables = Exact<{ [key: string]: never }>;

export type activeBillingSubscriptions = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName?: string | null;
    billingAccount?: {
      __typename?: 'BillingAccount';
      subscriptions: Array<{ __typename?: 'BillingSubscription'; id: string }>;
    } | null;
  };
};

export type ECOMMERCE_activeBillingSubscriptionsDetailsVariables = Exact<{ [key: string]: never }>;

export type ECOMMERCE_activeBillingSubscriptionsDetails = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    billingAccount?: {
      __typename?: 'BillingAccount';
      subscriptions: Array<{
        __typename?: 'BillingSubscription';
        id: string;
        currentTermEndsAt: any;
        lastPaymentFailed?: boolean | null;
        isCanceled?: boolean | null;
        expiresAt?: any | null;
        subscriptionOption?: { __typename?: 'SubscriptionOption'; name: string; renewalMonths: number } | null;
      }>;
    } | null;
  };
};

export type ECOMMERCE_getSupplementSubscriptionsQueryVariables = Exact<{ [key: string]: never }>;

export type ECOMMERCE_getSupplementSubscriptionsQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    id: string;
    hasPurchasedSupplementSubscription?: boolean | null;
    billingAccount?: {
      __typename?: 'BillingAccount';
      billingInfo?: {
        __typename?: 'BillingInfo';
        paymentInfo:
          | { __typename: 'BankAccountInfo' }
          | { __typename: 'ObfuscatedCardInfo'; lastFour: number; type: string; month: number; year: number }
          | { __typename: 'PayPalInfo'; billingAgreementId?: string | null }
          | { __typename: 'WalletPaymentInfo' };
      } | null;
      subscriptions: Array<{
        __typename?: 'BillingSubscription';
        id: string;
        state: BillingSubscriptionState;
        currentTermEndsAt: any;
        address?: {
          __typename?: 'ShippingAddress';
          street1: string;
          street2?: string | null;
          city: string;
          state: string;
          country: string;
          zipcode: string;
        } | null;
        supplementShipmentDates?: {
          __typename?: 'SupplementShipmentDates';
          latestSkipDate: any;
          nextShipmentDate: any;
          displayDate: any;
          previewResumingShipmentDate: any;
          previewSkippingShipmentDate: any;
          previewUpdate: Array<{ __typename?: 'SupplementUpdatePreview'; sku: string; nextShipDate: any }>;
        } | null;
        nextSupplementShipmentDetails?: {
          __typename?: 'NextSupplementShipmentDetails';
          status: string;
          deliveryExpected?: any | null;
          trackingLink?: string | null;
          discount?: number | null;
        } | null;
        pendingChanges?: {
          __typename?: 'SubscriptionPendingChange';
          subscriptionOption?: {
            __typename?: 'SubscriptionOption';
            weeksBetweenShipments?: number | null;
            sku: string;
          } | null;
        } | null;
        subscriptionOption?: {
          __typename?: 'SubscriptionOption';
          sku: string;
          priceInCents: number;
          displayedRateUnit: string;
          billingPeriodsPerTerm: number;
          inAppManagementName: string;
          freeTrialDays?: number | null;
          weeksBetweenShipments?: number | null;
          recommendedForDogWeightRangePounds?: {
            __typename?: 'WeightRange';
            min?: number | null;
            max?: number | null;
          } | null;
        } | null;
      }>;
    } | null;
  };
};

export type ECOMMERCE_billingInfoFromBillingAccountVariables = Exact<{ [key: string]: never }>;

export type ECOMMERCE_billingInfoFromBillingAccount = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    editBillingInfoUrl?: string | null;
    billingAccount?: {
      __typename?: 'BillingAccount';
      address?: {
        __typename?: 'Address';
        line1: string;
        line2?: string | null;
        city: string;
        state: string;
        zip: string;
        country: string;
      } | null;
      billingInfo?: {
        __typename?: 'BillingInfo';
        firstName: string;
        lastName: string;
        address: {
          __typename?: 'Address';
          line1: string;
          line2?: string | null;
          city: string;
          state: string;
          zip: string;
          country: string;
        };
        paymentInfo:
          | { __typename: 'BankAccountInfo' }
          | { __typename: 'ObfuscatedCardInfo'; lastFour: number; type: string; month: number; year: number }
          | { __typename: 'PayPalInfo' }
          | { __typename: 'WalletPaymentInfo' };
      } | null;
    } | null;
  };
};

export type marketingEmailsOptedInVariables = Exact<{ [key: string]: never }>;

export type marketingEmailsOptedIn = {
  __typename?: 'Query';
  currentUser: { __typename?: 'User'; id: string; marketingEmailsOptedIn: boolean };
};

export type ECOMMERCE_setMarketingEmailsOptedInVariables = Exact<{
  marketingEmailsOptedIn: Scalars['Boolean']['input'];
}>;

export type ECOMMERCE_setMarketingEmailsOptedIn = {
  __typename?: 'Mutation';
  setMarketingEmailsOptedIn: { __typename?: 'User'; id: string; marketingEmailsOptedIn: boolean };
};

export type ECOMMERCE_previewMembershipUpgradeVariables = Exact<{
  input: UpgradeMembershipInput;
}>;

export type ECOMMERCE_previewMembershipUpgrade = {
  __typename?: 'Query';
  previewMembershipUpgrade: {
    __typename?: 'PreviewMembershipUpgradeResult';
    appliedAccountBalanceInCents: number;
    appliedDiscountInCents: number;
    proratedCreditAmountInCents: number;
    subtotalInCents: number;
    taxInCents: number;
    totalInCents: number;
  };
};

export type ECOMMERCE_purchaseMembershipUpgradeVariables = Exact<{
  input: UpgradeMembershipInput;
}>;

export type ECOMMERCE_purchaseMembershipUpgrade = {
  __typename?: 'Mutation';
  purchaseMembershipUpgrade: {
    __typename?: 'CartPurchaseResult';
    isGWP: boolean;
    isReturningCustomer: boolean;
    chargeInvoice?: { __typename?: 'PurchaseResultInvoice'; number: string } | null;
    giftCardInvoices: Array<{ __typename?: 'PurchaseResultInvoice'; number: string }>;
  };
};

export type ECOMMERCE_purchaseMonthlyUpgradeVariables = Exact<{
  input: UpgradeMembershipInput;
}>;

export type ECOMMERCE_purchaseMonthlyUpgrade = {
  __typename?: 'Mutation';
  purchaseMonthlyUpgradePromotion: {
    __typename?: 'CartPurchaseResult';
    isGWP: boolean;
    isReturningCustomer: boolean;
    chargeInvoice?: { __typename?: 'PurchaseResultInvoice'; number: string } | null;
    giftCardInvoices: Array<{ __typename?: 'PurchaseResultInvoice'; number: string }>;
  };
};

export type ECOMMERCE_packVariables = Exact<{
  packId: Scalars['ID']['input'];
}>;

export type ECOMMERCE_pack = { __typename?: 'Query'; pack?: { __typename?: 'Pack'; id: string; name: string } | null };

export type ECOMMERCE_joinPackVariables = Exact<{
  petId: Scalars['ID']['input'];
  packId: Scalars['ID']['input'];
}>;

export type ECOMMERCE_joinPack = { __typename?: 'Mutation'; joinPack?: { __typename?: 'Pack'; id: string } | null };

export type ECOMMERCE_resolvePetAdoptionTransferVariables = Exact<{
  input: ResolvePetAdoptionTransferInput;
}>;

export type ECOMMERCE_resolvePetAdoptionTransfer = {
  __typename?: 'Mutation';
  resolvePetAdoptionTransfer: {
    __typename?: 'ResolvePetAdoptionTransferResult';
    redirectUrl: string;
    transfer: { __typename?: 'PetAdoptionTransfer'; id: string; status: PetAdoptionTransferStatus };
  };
};

export type ECOMMERCE_purchaseConsumerStoreCartVariables = Exact<{
  input: ConsumerStoreCartInput;
}>;

export type ECOMMERCE_purchaseConsumerStoreCart = {
  __typename?: 'Mutation';
  purchaseConsumerStoreCart: {
    __typename?: 'CartPurchaseResult';
    isGWP: boolean;
    isReturningCustomer: boolean;
    chargeInvoice?: { __typename?: 'PurchaseResultInvoice'; number: string } | null;
    giftCardInvoices: Array<{ __typename?: 'PurchaseResultInvoice'; number: string }>;
  };
};

export type ECOMMERCE_purchaseSeries3UpgradeCartVariables = Exact<{
  input: Series3UpgradeCartInput;
}>;

export type ECOMMERCE_purchaseSeries3UpgradeCart = {
  __typename?: 'Mutation';
  purchaseSeries3UpgradeCart: {
    __typename?: 'CartPurchaseResult';
    isGWP: boolean;
    isReturningCustomer: boolean;
    chargeInvoice?: { __typename?: 'PurchaseResultInvoice'; number: string } | null;
    giftCardInvoices: Array<{ __typename?: 'PurchaseResultInvoice'; number: string }>;
  };
};

export type ECOMMERCE_previewSubscriptionVariables = Exact<{
  input: PurchaseSubscriptionInput;
}>;

export type ECOMMERCE_previewSubscription = {
  __typename?: 'Query';
  previewSubscription: {
    __typename?: 'PreviewSubscriptionResult';
    activationFeeInCents?: number | null;
    waivedActivationFeesInCents?: number | null;
    taxInCents: number;
    totalInCents: number;
    giftCardAmountInCents?: number | null;
    couponAmountInCents?: number | null;
    totalRecurringCharges: Array<{
      __typename?: 'RecurringCharge';
      amountInCents: number;
      interval: BillingCadence;
      intervalCount: number;
      quantity: number;
      freeTrialDays?: number | null;
    }>;
  };
};

export type ECOMMERCE_purchaseSubscriptionVariables = Exact<{
  input: PurchaseSubscriptionInput;
}>;

export type ECOMMERCE_purchaseSubscription = {
  __typename?: 'Mutation';
  purchaseSubscription: {
    __typename?: 'CartPurchaseResult';
    isGWP: boolean;
    isReturningCustomer: boolean;
    chargeInvoice?: { __typename?: 'PurchaseResultInvoice'; number: string } | null;
    giftCardInvoices: Array<{ __typename?: 'PurchaseResultInvoice'; number: string }>;
  };
};

export type ECOMMERCE_deviceSubscriptionVariables = Exact<{
  moduleId: Scalars['String']['input'];
}>;

export type ECOMMERCE_deviceSubscription = {
  __typename?: 'Query';
  device?: {
    __typename?: 'Device';
    subscription?: { __typename?: 'BillingSubscription'; currentTermEndsAt: any } | null;
  } | null;
};

export type ECOMMERCE_purchaseSubscriptionDeviceVariables = Exact<{
  moduleId: Scalars['String']['input'];
  inAppFlow?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
}>;

export type ECOMMERCE_purchaseSubscriptionDevice = {
  __typename?: 'Query';
  device?: {
    __typename?: 'Device';
    id: string;
    moduleId: string;
    currentCollarModel?: string | null;
    healthTrackingStartedAt?: any | null;
    preselectedPlanCodeForNewSubscription?: string | null;
    subscriptionAccessType: SubscriptionAccessType;
    hasSubscriptionOverride: boolean;
    shouldOfferFreeMonthDuringCancellation?: boolean | null;
    shouldOfferPauseMonthDuringCancellation?: boolean | null;
    shouldOfferDowngradeDuringCancellation?: boolean | null;
    shouldOfferDiscountDuringClickToCancel?: boolean | null;
    shouldOfferFreeTrialCancelDeterrent?: boolean | null;
    canCancel: boolean;
    canCancelDate?: any | null;
    upgradeRedeemed?: DeviceUpgrade | null;
    purchasableSubscriptionOptions: Array<{
      __typename?: 'SubscriptionOption';
      sku: string;
      name: string;
      priceInCents: number;
      billingCadence: BillingCadence;
      displayedRate: string;
      displayedRateUnit: string;
      fullRate?: string | null;
      fullRateUnit?: string | null;
      savings?: string | null;
      monthlyUpgradeSavings?: string | null;
      featured: boolean;
      renewalYears?: number | null;
      activationFeeInCents?: number | null;
      introPriceInCents?: number | null;
      renewalMonths: number;
      billingPeriodsPerTerm: number;
      upsellOnly: boolean;
      buyItMembership: boolean;
      valueLabel?: string | null;
      supportPlus: boolean;
      couponExtensionMonths?: number | null;
      planSwitchCreditAppliedInCents?: number | null;
      planSwitchAmountChargedInCents?: number | null;
      isPlusPlan: boolean;
      pricingInCents: {
        __typename?: 'PricingByCurrency';
        USD: number;
        CAD?: number | null;
        EUR?: number | null;
        GBP?: number | null;
        RON?: number | null;
        SEK?: number | null;
        DKK?: number | null;
        NOK?: number | null;
        CHF?: number | null;
        ISK?: number | null;
        TRY?: number | null;
      };
    }>;
    prepaidSubscription?: {
      __typename?: 'DevicePrepaidSubscription';
      planCode: string;
      orderSource: OrderSource;
      renewalPlanCode?: string | null;
      freeMonths?: number | null;
      resellerPriceInCents?: number | null;
    } | null;
    pet?: {
      __typename?: 'Pet';
      id: string;
      name: string;
      gender: Gender;
      species?: Species | null;
      photos: {
        __typename?: 'PhotoFeed';
        first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
      };
      household: {
        __typename?: 'Household';
        pets: Array<{
          __typename?: 'Pet';
          id: string;
          name: string;
          device?: { __typename?: 'Device'; subscriptionAccessType: SubscriptionAccessType } | null;
          photos: {
            __typename?: 'PhotoFeed';
            first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
          };
        }>;
      };
    } | null;
    subscription?: {
      __typename?: 'BillingSubscription';
      id: string;
      code: string;
      billingEmail?: string | null;
      currentTermEndsAt: any;
      expiresAt?: any | null;
      pausedAt?: any | null;
      isPaused?: boolean | null;
      pausesAt?: any | null;
      pauseResumesAt?: any | null;
      isCanceled?: boolean | null;
      hasFreeTrialPlan?: boolean | null;
      isInTrialPeriod?: boolean | null;
      hardwareFirstChangeBillsNow?: boolean | null;
      activatedAt?: any | null;
      currency?: string | null;
      subscriptionOption?: {
        __typename?: 'SubscriptionOption';
        name: string;
        priceInCents: number;
        activationFeeInCents?: number | null;
        billingCadence: BillingCadence;
        displayedRate: string;
        displayedRateUnit: string;
        renewalYears?: number | null;
        renewalMonths: number;
        billingPeriodsPerTerm: number;
        sku: string;
        buyItMembership: boolean;
        introPriceInCents?: number | null;
        pricingInCents: {
          __typename?: 'PricingByCurrency';
          USD: number;
          CAD?: number | null;
          EUR?: number | null;
          GBP?: number | null;
          RON?: number | null;
          SEK?: number | null;
          DKK?: number | null;
          NOK?: number | null;
          CHF?: number | null;
          ISK?: number | null;
          TRY?: number | null;
        };
        activationFeePricingInCents?: {
          __typename?: 'PricingByCurrency';
          USD: number;
          CAD?: number | null;
          EUR?: number | null;
          GBP?: number | null;
          RON?: number | null;
          SEK?: number | null;
          DKK?: number | null;
          NOK?: number | null;
          CHF?: number | null;
          ISK?: number | null;
          TRY?: number | null;
        } | null;
      } | null;
      pendingChanges?: {
        __typename?: 'SubscriptionPendingChange';
        subscriptionOption?: {
          __typename?: 'SubscriptionOption';
          priceInCents: number;
          renewalMonths: number;
          pricingInCents: {
            __typename?: 'PricingByCurrency';
            USD: number;
            CAD?: number | null;
            EUR?: number | null;
            GBP?: number | null;
            RON?: number | null;
            SEK?: number | null;
            DKK?: number | null;
            NOK?: number | null;
            CHF?: number | null;
            ISK?: number | null;
            TRY?: number | null;
          };
        } | null;
      } | null;
    } | null;
    subscriptionRenewalStatus?: {
      __typename?: 'SubscriptionRenewalStatus';
      shouldOfferSubscriptionRenewal: boolean;
    } | null;
  } | null;
};

export type allCurrencies = {
  __typename?: 'PricingByCurrency';
  USD: number;
  CAD?: number | null;
  EUR?: number | null;
  GBP?: number | null;
  RON?: number | null;
  SEK?: number | null;
  DKK?: number | null;
  NOK?: number | null;
  CHF?: number | null;
  ISK?: number | null;
  TRY?: number | null;
};

export type purchaseSubscriptionDeviceDetails = {
  __typename?: 'Device';
  id: string;
  moduleId: string;
  currentCollarModel?: string | null;
  healthTrackingStartedAt?: any | null;
  preselectedPlanCodeForNewSubscription?: string | null;
  subscriptionAccessType: SubscriptionAccessType;
  hasSubscriptionOverride: boolean;
  shouldOfferFreeMonthDuringCancellation?: boolean | null;
  shouldOfferPauseMonthDuringCancellation?: boolean | null;
  shouldOfferDowngradeDuringCancellation?: boolean | null;
  shouldOfferDiscountDuringClickToCancel?: boolean | null;
  shouldOfferFreeTrialCancelDeterrent?: boolean | null;
  canCancel: boolean;
  canCancelDate?: any | null;
  upgradeRedeemed?: DeviceUpgrade | null;
  purchasableSubscriptionOptions: Array<{
    __typename?: 'SubscriptionOption';
    sku: string;
    name: string;
    priceInCents: number;
    billingCadence: BillingCadence;
    displayedRate: string;
    displayedRateUnit: string;
    fullRate?: string | null;
    fullRateUnit?: string | null;
    savings?: string | null;
    monthlyUpgradeSavings?: string | null;
    featured: boolean;
    renewalYears?: number | null;
    activationFeeInCents?: number | null;
    introPriceInCents?: number | null;
    renewalMonths: number;
    billingPeriodsPerTerm: number;
    upsellOnly: boolean;
    buyItMembership: boolean;
    valueLabel?: string | null;
    supportPlus: boolean;
    couponExtensionMonths?: number | null;
    planSwitchCreditAppliedInCents?: number | null;
    planSwitchAmountChargedInCents?: number | null;
    isPlusPlan: boolean;
    pricingInCents: {
      __typename?: 'PricingByCurrency';
      USD: number;
      CAD?: number | null;
      EUR?: number | null;
      GBP?: number | null;
      RON?: number | null;
      SEK?: number | null;
      DKK?: number | null;
      NOK?: number | null;
      CHF?: number | null;
      ISK?: number | null;
      TRY?: number | null;
    };
  }>;
  prepaidSubscription?: {
    __typename?: 'DevicePrepaidSubscription';
    planCode: string;
    orderSource: OrderSource;
    renewalPlanCode?: string | null;
    freeMonths?: number | null;
    resellerPriceInCents?: number | null;
  } | null;
  pet?: {
    __typename?: 'Pet';
    id: string;
    name: string;
    gender: Gender;
    species?: Species | null;
    photos: {
      __typename?: 'PhotoFeed';
      first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
    };
    household: {
      __typename?: 'Household';
      pets: Array<{
        __typename?: 'Pet';
        id: string;
        name: string;
        device?: { __typename?: 'Device'; subscriptionAccessType: SubscriptionAccessType } | null;
        photos: {
          __typename?: 'PhotoFeed';
          first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
        };
      }>;
    };
  } | null;
  subscription?: {
    __typename?: 'BillingSubscription';
    id: string;
    code: string;
    billingEmail?: string | null;
    currentTermEndsAt: any;
    expiresAt?: any | null;
    pausedAt?: any | null;
    isPaused?: boolean | null;
    pausesAt?: any | null;
    pauseResumesAt?: any | null;
    isCanceled?: boolean | null;
    hasFreeTrialPlan?: boolean | null;
    isInTrialPeriod?: boolean | null;
    hardwareFirstChangeBillsNow?: boolean | null;
    activatedAt?: any | null;
    currency?: string | null;
    subscriptionOption?: {
      __typename?: 'SubscriptionOption';
      name: string;
      priceInCents: number;
      activationFeeInCents?: number | null;
      billingCadence: BillingCadence;
      displayedRate: string;
      displayedRateUnit: string;
      renewalYears?: number | null;
      renewalMonths: number;
      billingPeriodsPerTerm: number;
      sku: string;
      buyItMembership: boolean;
      introPriceInCents?: number | null;
      pricingInCents: {
        __typename?: 'PricingByCurrency';
        USD: number;
        CAD?: number | null;
        EUR?: number | null;
        GBP?: number | null;
        RON?: number | null;
        SEK?: number | null;
        DKK?: number | null;
        NOK?: number | null;
        CHF?: number | null;
        ISK?: number | null;
        TRY?: number | null;
      };
      activationFeePricingInCents?: {
        __typename?: 'PricingByCurrency';
        USD: number;
        CAD?: number | null;
        EUR?: number | null;
        GBP?: number | null;
        RON?: number | null;
        SEK?: number | null;
        DKK?: number | null;
        NOK?: number | null;
        CHF?: number | null;
        ISK?: number | null;
        TRY?: number | null;
      } | null;
    } | null;
    pendingChanges?: {
      __typename?: 'SubscriptionPendingChange';
      subscriptionOption?: {
        __typename?: 'SubscriptionOption';
        priceInCents: number;
        renewalMonths: number;
        pricingInCents: {
          __typename?: 'PricingByCurrency';
          USD: number;
          CAD?: number | null;
          EUR?: number | null;
          GBP?: number | null;
          RON?: number | null;
          SEK?: number | null;
          DKK?: number | null;
          NOK?: number | null;
          CHF?: number | null;
          ISK?: number | null;
          TRY?: number | null;
        };
      } | null;
    } | null;
  } | null;
  subscriptionRenewalStatus?: {
    __typename?: 'SubscriptionRenewalStatus';
    shouldOfferSubscriptionRenewal: boolean;
  } | null;
};

export type purchaseSubscriptionPetDetails = {
  __typename?: 'Pet';
  id: string;
  name: string;
  gender: Gender;
  species?: Species | null;
  photos: {
    __typename?: 'PhotoFeed';
    first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
  };
  household: {
    __typename?: 'Household';
    pets: Array<{
      __typename?: 'Pet';
      id: string;
      name: string;
      device?: { __typename?: 'Device'; subscriptionAccessType: SubscriptionAccessType } | null;
      photos: {
        __typename?: 'PhotoFeed';
        first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
      };
    }>;
  };
};

export type subscriptionOption = {
  __typename?: 'SubscriptionOption';
  sku: string;
  name: string;
  priceInCents: number;
  billingCadence: BillingCadence;
  displayedRate: string;
  displayedRateUnit: string;
  fullRate?: string | null;
  fullRateUnit?: string | null;
  savings?: string | null;
  monthlyUpgradeSavings?: string | null;
  featured: boolean;
  renewalYears?: number | null;
  activationFeeInCents?: number | null;
  introPriceInCents?: number | null;
  renewalMonths: number;
  billingPeriodsPerTerm: number;
  upsellOnly: boolean;
  buyItMembership: boolean;
  valueLabel?: string | null;
  supportPlus: boolean;
  couponExtensionMonths?: number | null;
  planSwitchCreditAppliedInCents?: number | null;
  planSwitchAmountChargedInCents?: number | null;
  isPlusPlan: boolean;
  pricingInCents: {
    __typename?: 'PricingByCurrency';
    USD: number;
    CAD?: number | null;
    EUR?: number | null;
    GBP?: number | null;
    RON?: number | null;
    SEK?: number | null;
    DKK?: number | null;
    NOK?: number | null;
    CHF?: number | null;
    ISK?: number | null;
    TRY?: number | null;
  };
};

export type ECOMMERCE_referralsVariables = Exact<{ [key: string]: never }>;

export type ECOMMERCE_referrals = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    id: string;
    referrals: {
      __typename?: 'Referrals';
      referralProgramName: string;
      referralCode: string;
      numConfirmedReferrals: number;
      numPendingReferrals: number;
      unlockedRewardTypes: Array<ReferralRewardType>;
      codeSuspended: boolean;
      referralMessage: string;
      referralProgramTitle: string;
      invitedReferees: Array<{
        __typename?: 'StrangerUser';
        firstName: string;
        profilePicture?: { __typename?: 'Image'; nearestResized: string } | null;
      }>;
      give1MonthGet1DollarPerMonthDetails?: {
        __typename?: 'Give1MonthGet1DollarPerMonthDetails';
        totalDollarsEarned: number;
        numActiveReferrals: number;
      } | null;
    };
  };
};

export type referralsFragment = {
  __typename?: 'User';
  referrals: {
    __typename?: 'Referrals';
    referralProgramName: string;
    referralCode: string;
    numConfirmedReferrals: number;
    numPendingReferrals: number;
    unlockedRewardTypes: Array<ReferralRewardType>;
    codeSuspended: boolean;
    referralMessage: string;
    referralProgramTitle: string;
    invitedReferees: Array<{
      __typename?: 'StrangerUser';
      firstName: string;
      profilePicture?: { __typename?: 'Image'; nearestResized: string } | null;
    }>;
    give1MonthGet1DollarPerMonthDetails?: {
      __typename?: 'Give1MonthGet1DollarPerMonthDetails';
      totalDollarsEarned: number;
      numActiveReferrals: number;
    } | null;
  };
};

export type ECOMMERCE_previewRenewAndSaveVariables = Exact<{
  input: RenewAndSaveInput;
}>;

export type ECOMMERCE_previewRenewAndSave = {
  __typename?: 'Query';
  previewRenewAndSave: {
    __typename?: 'PreviewRenewAndSaveResult';
    subtotalInCents: number;
    taxInCents: number;
    totalInCents: number;
  };
};

export type ECOMMERCE_purchaseRenewAndSaveVariables = Exact<{
  input: RenewAndSaveInput;
}>;

export type ECOMMERCE_purchaseRenewAndSave = {
  __typename?: 'Mutation';
  purchaseRenewAndSave: {
    __typename?: 'CartPurchaseResult';
    isGWP: boolean;
    isReturningCustomer: boolean;
    chargeInvoice?: { __typename?: 'PurchaseResultInvoice'; number: string } | null;
    giftCardInvoices: Array<{ __typename?: 'PurchaseResultInvoice'; number: string }>;
  };
};

export type ECOMMERCE_rescueRecallPetVariables = Exact<{
  input: RescueRecallPetInput;
}>;

export type ECOMMERCE_rescueRecallPet = {
  __typename?: 'Mutation';
  rescueRecallPet?: { __typename?: 'RescueRecallPetResult'; ok?: boolean | null } | null;
};

export type fullAddress = {
  __typename?: 'Address';
  line1: string;
  line2?: string | null;
  city: string;
  state: string;
  zip: string;
  country: string;
  phone?: string | null;
};

export type updateShippingAddressVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  address: AddressInput;
  billingInfo?: InputMaybe<BillingInfoInput>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type updateShippingAddress = {
  __typename?: 'Mutation';
  updateBillingAccount: {
    __typename?: 'BillingAccount';
    firstName?: string | null;
    lastName?: string | null;
    address?: {
      __typename?: 'Address';
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      zip: string;
      country: string;
      phone?: string | null;
    } | null;
  };
};

export type validateAddressVariables = Exact<{
  address: AddressInput;
}>;

export type validateAddress = {
  __typename?: 'Query';
  validateAddress: {
    __typename?: 'ValidateAddressResponse';
    status?: ValidateAddressResponseStatus | null;
    matchedAddress?: {
      __typename?: 'Address';
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      zip: string;
      country: string;
      phone?: string | null;
    } | null;
  };
};

export type ECOMMERCE_currentUserEditBillingInfoUrlVariables = Exact<{ [key: string]: never }>;

export type ECOMMERCE_currentUserEditBillingInfoUrl = {
  __typename?: 'Query';
  currentUser: { __typename?: 'User'; id: string; editBillingInfoUrl?: string | null };
};

export type ECOMMERCE_createZendeskCancellationTicketVariables = Exact<{
  input: CreateZendeskCancellationTicketInput;
}>;

export type ECOMMERCE_createZendeskCancellationTicket = {
  __typename?: 'Mutation';
  createZendeskCancellationTicket?: { __typename?: 'CreateZendeskTicketResult'; ticketCreated?: boolean | null } | null;
};

export type ECOMMERCE_createZendeskReplacementTicketVariables = Exact<{
  input: CreateZendeskReplacementTicketInput;
}>;

export type ECOMMERCE_createZendeskReplacementTicket = {
  __typename?: 'Mutation';
  createZendeskReplacementTicket?: { __typename?: 'CreateZendeskTicketResult'; ticketCreated?: boolean | null } | null;
};

export type ECOMMERCE_createZendeskTroubleshootingTicketVariables = Exact<{
  input: CreateZendeskTroubleshootingTicketInput;
}>;

export type ECOMMERCE_createZendeskTroubleshootingTicket = {
  __typename?: 'Mutation';
  createZendeskTroubleshootingTicket?: {
    __typename?: 'CreateZendeskTicketResult';
    ticketCreated?: boolean | null;
  } | null;
};

export type ECOMMERCE_petsWithActiveSubscriptionVariables = Exact<{ [key: string]: never }>;

export type ECOMMERCE_petsWithActiveSubscription = {
  __typename?: 'Query';
  petsWithActiveSubscription: Array<{
    __typename?: 'Pet';
    id: string;
    name: string;
    photos: {
      __typename?: 'PhotoFeed';
      first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
    };
    device?: {
      __typename?: 'Device';
      id: string;
      moduleId: string;
      currentCollarModel?: string | null;
      subscriptionAccessType: SubscriptionAccessType;
      hasSubscriptionOverride: boolean;
      subscription?: {
        __typename?: 'BillingSubscription';
        id: string;
        currentTermEndsAt: any;
        subscriptionOption?: {
          __typename?: 'SubscriptionOption';
          name: string;
          priceInCents: number;
          billingCadence: BillingCadence;
          displayedRate: string;
          displayedRateUnit: string;
          renewalYears?: number | null;
          renewalMonths: number;
          billingPeriodsPerTerm: number;
          sku: string;
        } | null;
      } | null;
    } | null;
  }>;
};

export type ECOMMERCE_applyMultidogDiscountVariables = Exact<{ [key: string]: never }>;

export type ECOMMERCE_applyMultidogDiscount = {
  __typename?: 'Mutation';
  applyMultidogDiscount?: { __typename?: 'ApplyMultidogDiscountResult'; success?: boolean | null } | null;
};

export type ECOMMERCE_hasMultidogDiscountVariables = Exact<{ [key: string]: never }>;

export type ECOMMERCE_hasMultidogDiscount = {
  __typename?: 'Query';
  currentUser: { __typename?: 'User'; id: string; hasMultidogDiscount: boolean };
};

export type ECOMMERCE_claimFreeMonthVariables = Exact<{
  input: ClaimFreeMonthInput;
}>;

export type ECOMMERCE_claimFreeMonth = {
  __typename?: 'Mutation';
  claimFreeMonth?: { __typename?: 'ClaimFreeMonthResult'; success?: boolean | null } | null;
};

export type ECOMMERCE_claimClickToCancelDiscountVariables = Exact<{
  input: ClaimClickToCancelDiscountInput;
}>;

export type ECOMMERCE_claimClickToCancelDiscount = {
  __typename?: 'Mutation';
  claimClickToCancelDiscount?: {
    __typename?: 'ClaimClickToCancelDiscountResult';
    success: boolean;
    reasonForFailure?: string | null;
  } | null;
};

export type ECOMMERCE_claimFreeTrialCancelDeterrentVariables = Exact<{
  input: ClaimFreeTrialCancelDeterrentInput;
}>;

export type ECOMMERCE_claimFreeTrialCancelDeterrent = {
  __typename?: 'Mutation';
  claimFreeTrialCancelDeterrent?: {
    __typename?: 'ClaimFreeTrialCancelDeterrentResult';
    success: boolean;
    reasonForFailure?: string | null;
  } | null;
};

export type ECOMMERCE_downgradeS2Variables = Exact<{
  input: DowngradeSeries2Input;
}>;

export type ECOMMERCE_downgradeS2 = {
  __typename?: 'Mutation';
  downgradeSeries2?: { __typename?: 'DowngradeSeries2Result'; success?: boolean | null } | null;
};

export type ECOMMERCE_getAvailableS3DowngradeableSubscriptionOptionsVariables = Exact<{
  input: AvailableS3DowngradeSubscriptionOptionsInput;
}>;

export type ECOMMERCE_getAvailableS3DowngradeableSubscriptionOptions = {
  __typename?: 'Query';
  getAvailableS3DowngradeableSubscriptionOptions: {
    __typename?: 'AvailableS3DowngradeSubscriptionOptionsResult';
    subscriptionOptions: Array<{
      __typename?: 'SubscriptionOption';
      sku: string;
      name: string;
      priceInCents: number;
      displayedRate: string;
      displayedRateUnit: string;
      billingCadence: BillingCadence;
      renewalMonths: number;
      billingPeriodsPerTerm: number;
      supportPlus: boolean;
      valueLabel?: string | null;
      savings?: string | null;
      fullRate?: string | null;
      fullRateUnit?: string | null;
      featured: boolean;
      renewalYears?: number | null;
      activationFeeInCents?: number | null;
      upsellOnly: boolean;
      buyItMembership: boolean;
      pricingInCents: {
        __typename?: 'PricingByCurrency';
        USD: number;
        CAD?: number | null;
        EUR?: number | null;
        GBP?: number | null;
        RON?: number | null;
        SEK?: number | null;
        DKK?: number | null;
        NOK?: number | null;
        CHF?: number | null;
        ISK?: number | null;
        TRY?: number | null;
      };
      activationFeePricingInCents?: {
        __typename?: 'PricingByCurrency';
        USD: number;
        CAD?: number | null;
        EUR?: number | null;
        GBP?: number | null;
        RON?: number | null;
        SEK?: number | null;
        DKK?: number | null;
        NOK?: number | null;
        CHF?: number | null;
        ISK?: number | null;
        TRY?: number | null;
      } | null;
    }>;
  };
};

export type ECOMMERCE_downgradeS3Variables = Exact<{
  input: DowngradeSeries3Input;
}>;

export type ECOMMERCE_downgradeS3 = {
  __typename?: 'Mutation';
  downgradeSeries3?: { __typename?: 'DowngradeSeries3Result'; success?: boolean | null } | null;
};

export type ECOMMERCE_renewSubscriptionVariables = Exact<{
  input: RenewSubscriptionInput;
}>;

export type ECOMMERCE_renewSubscription = {
  __typename?: 'Mutation';
  renewSubscription?: { __typename?: 'RenewSubscriptionResult'; success?: boolean | null } | null;
};

export type ECOMMERCE_cancelSupplementSubscriptionVariables = Exact<{
  input: CancelSupplementSubscriptionInput;
}>;

export type ECOMMERCE_cancelSupplementSubscription = {
  __typename?: 'Mutation';
  cancelSupplementSubscription?: {
    __typename?: 'CancelSupplementSubscriptionResult';
    success: boolean;
    reasonForFailure?: string | null;
  } | null;
};

export type ECOMMERCE_updateSupplementSubscriptionVariables = Exact<{
  input: UpdateSupplementSubscriptionInput;
}>;

export type ECOMMERCE_updateSupplementSubscription = {
  __typename?: 'Mutation';
  updateSupplementSubscription?: {
    __typename?: 'UpdateSupplementSubscriptionResult';
    success: boolean;
    reasonForFailure?: string | null;
  } | null;
};

export type ECOMMERCE_getMultipleSupplementSubscriptionsPricingVariables = Exact<{
  input: GetMultipleSupplementSubscriptionsPricingInput;
}>;

export type ECOMMERCE_getMultipleSupplementSubscriptionsPricing = {
  __typename?: 'Query';
  getMultipleSupplementSubscriptionsPricing?: {
    __typename?: 'GetMultipleSupplementSubscriptionsPricingResult';
    subtotalInCents: number;
    taxInCents: number;
    totalInCents: number;
  } | null;
};

export type ECOMMERCE_addMultipleSupplementSubscriptionsVariables = Exact<{
  input: AddMultipleSupplementSubscriptionsInput;
}>;

export type ECOMMERCE_addMultipleSupplementSubscriptions = {
  __typename?: 'Mutation';
  addMultipleSupplementSubscriptions?: {
    __typename?: 'AddMultipleSupplementSubscriptionsResult';
    success: boolean;
    reasonForFailure?: string | null;
  } | null;
};

export type ECOMMERCE_setSupplementNextShipDateVariables = Exact<{
  input: SetNextShipmentDateInput;
}>;

export type ECOMMERCE_setSupplementNextShipDate = {
  __typename?: 'Mutation';
  setSupplementNextShipDate?: {
    __typename?: 'SetNextShipmentDateResult';
    success: boolean;
    reasonForFailure?: string | null;
  } | null;
};

export type ECOMMERCE_setSupplementShippingAddressVariables = Exact<{
  input: SetShippingAddressInput;
}>;

export type ECOMMERCE_setSupplementShippingAddress = {
  __typename?: 'Mutation';
  setSupplementShippingAddress?: {
    __typename?: 'SetShippingAddressResult';
    success: boolean;
    reasonForFailure?: string | null;
  } | null;
};

export type ECOMMERCE_claimSupplementDiscountVariables = Exact<{
  input: ClaimSupplementDiscountInput;
}>;

export type ECOMMERCE_claimSupplementDiscount = {
  __typename?: 'Mutation';
  claimSupplementDiscount?: {
    __typename?: 'ClaimSupplementDiscountResult';
    success: boolean;
    reasonForFailure?: string | null;
  } | null;
};

export type ECOMMERCE_claimTwoMonthsHalfOffDiscountVariables = Exact<{
  input: ClaimTwoMonthsHalfOffInput;
}>;

export type ECOMMERCE_claimTwoMonthsHalfOffDiscount = {
  __typename?: 'Mutation';
  claimTwoMonthsHalfOff?: {
    __typename?: 'ClaimTwoMonthsHalfOffResult';
    success: boolean;
    reasonForFailure?: string | null;
  } | null;
};

export type ECOMMERCE_pauseMembershipVariables = Exact<{
  input: PauseMembershipInput;
}>;

export type ECOMMERCE_pauseMembership = {
  __typename?: 'Mutation';
  pauseMembership?: { __typename?: 'PauseMembershipResult'; success: boolean; reasonForFailure?: string | null } | null;
};

export type ECOMMERCE_resumeMembershipVariables = Exact<{
  input: ResumeMembershipInput;
}>;

export type ECOMMERCE_resumeMembership = {
  __typename?: 'Mutation';
  resumeMembership?: {
    __typename?: 'ResumeMembershipResult';
    success: boolean;
    reasonForFailure?: string | null;
  } | null;
};

export type ECOMMERCE_cancelMembershipVariables = Exact<{
  input: CancelMembershipInput;
}>;

export type ECOMMERCE_cancelMembership = {
  __typename?: 'Mutation';
  cancelMembership?: {
    __typename?: 'CancelMembershipResult';
    success: boolean;
    reasonForFailure?: string | null;
  } | null;
};

export type ECOMMERCE_cancelThirdPartyMembershipVariables = Exact<{
  input: CancelThirdPartySubscriptionInput;
}>;

export type ECOMMERCE_cancelThirdPartyMembership = {
  __typename?: 'Mutation';
  cancelThirdPartySubscription: {
    __typename?: 'CancelThirdPartySubscriptionResult';
    success: boolean;
    reasonForFailure?: string | null;
  };
};

export type ECOMMERCE_allSubscriptionsForCurrentUserVariables = Exact<{ [key: string]: never }>;

export type ECOMMERCE_allSubscriptionsForCurrentUser = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    email: string;
    editBillingInfoUrl?: string | null;
    userHouseholds: Array<{
      __typename?: 'UserHousehold';
      householdRole: UserHouseholdRole;
      household: {
        __typename?: 'Household';
        pets: Array<{
          __typename?: 'Pet';
          id: string;
          name: string;
          species?: Species | null;
          photos: {
            __typename?: 'PhotoFeed';
            first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
          };
          device?: {
            __typename?: 'Device';
            moduleId: string;
            subscriptionId?: string | null;
            currentCollarModelLongName?: string | null;
            subscription?: {
              __typename?: 'BillingSubscription';
              name: string;
              code: string;
              billingEmail?: string | null;
              isCanceled?: boolean | null;
              isPaused?: boolean | null;
              hasFreeTrialPlan?: boolean | null;
              isInTrialPeriod?: boolean | null;
              currentTermEndsAt: any;
              expiresAt?: any | null;
              pausedAt?: any | null;
              pausesAt?: any | null;
              pauseResumesAt?: any | null;
              currency?: string | null;
              unitAmountInCents: number;
              lastPaymentFailed?: boolean | null;
              subscriptionOption?: {
                __typename?: 'SubscriptionOption';
                sku: string;
                priceInCents: number;
                renewalMonths: number;
                activationFeeInCents?: number | null;
                introPriceInCents?: number | null;
              } | null;
              nextRenewalPreview?: { __typename?: 'SubscriptionRenewalPreview'; totalInCents: number } | null;
              appliedFreeMonth?: {
                __typename?: 'AppliedFreeMonth';
                status: AppliedFreeMonthStatus;
                startsAt?: any | null;
              } | null;
              pendingChanges?: {
                __typename?: 'SubscriptionPendingChange';
                subscriptionOption?: {
                  __typename?: 'SubscriptionOption';
                  priceInCents: number;
                  renewalMonths: number;
                  pricingInCents: {
                    __typename?: 'PricingByCurrency';
                    USD: number;
                    CAD?: number | null;
                    EUR?: number | null;
                    GBP?: number | null;
                    RON?: number | null;
                    SEK?: number | null;
                    DKK?: number | null;
                    NOK?: number | null;
                    CHF?: number | null;
                    ISK?: number | null;
                    TRY?: number | null;
                  };
                } | null;
              } | null;
              dunningInfo?: {
                __typename?: 'DunningInfo';
                declineCode?: string | null;
                customerMessage?: string | null;
                failureDate?: any | null;
                paymentMethodType?: string | null;
                cardType?: string | null;
                lastFour?: string | null;
                invoiceId?: string | null;
                amountInCents?: number | null;
                currency?: string | null;
              } | null;
            } | null;
            cxPendingAction?: { __typename?: 'CxPendingAction'; category: string } | null;
          } | null;
        }>;
      };
    }>;
    billingAccount?: { __typename?: 'BillingAccount'; recurlyHostedBillingInfoUrl?: string | null } | null;
  };
};

export type ECOMMERCE_changeMembershipPlanEndOfTermVariables = Exact<{
  input: ChangeMembershipPlanEndOfTermInput;
}>;

export type ECOMMERCE_changeMembershipPlanEndOfTerm = {
  __typename?: 'Mutation';
  changeMembershipPlanEndOfTerm?: {
    __typename?: 'ChangeMembershipPlanEndOfTermResult';
    success: boolean;
    reasonForFailure?: string | null;
  } | null;
};

export type ECOMMERCE_convertFreeTrialVariables = Exact<{
  input: ConvertFreeTrialInput;
}>;

export type ECOMMERCE_convertFreeTrial = {
  __typename?: 'Mutation';
  convertFreeTrial?: {
    __typename?: 'ConvertFreeTrialResult';
    success: boolean;
    reasonForFailure?: string | null;
  } | null;
};

export type ECOMMERCE_series3UpgradeOfferVariables = Exact<{
  petId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ECOMMERCE_series3UpgradeOffer = {
  __typename?: 'Query';
  series3UpgradeOffer?: {
    __typename?: 'Series3UpgradeOffer';
    planCode: string;
    deviceOffers: Array<{
      __typename?: 'Series3UpgradeDeviceOffer';
      proratedCreditAmountInCents: number;
      promoDiscounts: Array<{
        __typename?: 'Series3UpgradePromoDiscount';
        discountAmountInCents: number;
        planCode: string;
      }>;
      device: { __typename?: 'Device'; moduleId: string; series3UpgradeV2Eligible: boolean };
      pet: {
        __typename?: 'Pet';
        id: string;
        name: string;
        photos: {
          __typename?: 'PhotoFeed';
          first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
        };
      };
    }>;
  } | null;
};

export type series3UpgradeDeviceOffer = {
  __typename?: 'Series3UpgradeDeviceOffer';
  proratedCreditAmountInCents: number;
  promoDiscounts: Array<{
    __typename?: 'Series3UpgradePromoDiscount';
    discountAmountInCents: number;
    planCode: string;
  }>;
  device: { __typename?: 'Device'; moduleId: string; series3UpgradeV2Eligible: boolean };
  pet: {
    __typename?: 'Pet';
    id: string;
    name: string;
    photos: {
      __typename?: 'PhotoFeed';
      first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
    };
  };
};

export type ECOMMERCE_previewUpgradeToSeriesThreePlusModuleVariables = Exact<{
  input: UpgradeToSeriesThreePlusModuleInput;
}>;

export type ECOMMERCE_previewUpgradeToSeriesThreePlusModule = {
  __typename?: 'Query';
  previewUpgradeToSeriesThreePlusModule: {
    __typename?: 'PreviewUpgradeToSeriesThreePlusModuleResult';
    subtotalInCents: number;
    shippingInCents: number;
    taxInCents: number;
    totalInCents: number;
  };
};

export type ECOMMERCE_purchaseUpgradeToSeriesThreePlusModuleVariables = Exact<{
  input: UpgradeToSeriesThreePlusModuleInput;
}>;

export type ECOMMERCE_purchaseUpgradeToSeriesThreePlusModule = {
  __typename?: 'Mutation';
  purchaseUpgradeToSeriesThreePlusModule: {
    __typename?: 'CartPurchaseResult';
    isGWP: boolean;
    isReturningCustomer: boolean;
    chargeInvoice?: { __typename?: 'PurchaseResultInvoice'; number: string } | null;
    giftCardInvoices: Array<{ __typename?: 'PurchaseResultInvoice'; number: string }>;
  };
};

export type ECOMMERCE_previewUpgradeToUltraVariables = Exact<{
  input: UpgradeToUltraInput;
}>;

export type ECOMMERCE_previewUpgradeToUltra = {
  __typename?: 'Query';
  previewUpgradeToUltra: {
    __typename?: 'PreviewUpgradeToUltraResult';
    subtotalInCents: number;
    shippingInCents: number;
    taxInCents: number;
    totalInCents: number;
    activationFeesInCents: number;
    appliedDiscountInCents: number;
    cartItemCredits: Array<{
      __typename?: 'PreviewDiscountCredit';
      cartItemId: string;
      creditReason: string;
      creditAmountInCents: number;
    }>;
  };
};

export type ECOMMERCE_purchaseUpgradeToUltraVariables = Exact<{
  input: UpgradeToUltraInput;
}>;

export type ECOMMERCE_purchaseUpgradeToUltra = {
  __typename?: 'Mutation';
  purchaseUpgradeToUltra: {
    __typename?: 'CartPurchaseResult';
    isReturningCustomer: boolean;
    chargeInvoice?: { __typename?: 'PurchaseResultInvoice'; number: string } | null;
  };
};

export type userIdentityVariables = Exact<{ [key: string]: never }>;

export type userIdentity = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName?: string | null;
    email: string;
    isAdmin: boolean;
    isRescuePartner: boolean;
    isVerizonCustomer: boolean;
    hasPurchasedSupplementSubscription?: boolean | null;
    previouslyPurchasedCollarProductIds: Array<string>;
    decagonWidgetAuth?: { __typename?: 'DecagonWidgetAuth'; signature: string; epoch: number } | null;
    billingAccount?: {
      __typename?: 'BillingAccount';
      billingInfo?: {
        __typename?: 'BillingInfo';
        firstName: string;
        lastName: string;
        address: {
          __typename?: 'Address';
          line1: string;
          line2?: string | null;
          city: string;
          state: string;
          zip: string;
          country: string;
        };
      } | null;
      address?: {
        __typename?: 'Address';
        line1: string;
        line2?: string | null;
        city: string;
        state: string;
        zip: string;
        country: string;
        phone?: string | null;
      } | null;
    } | null;
  };
};

export type userFreeTrialStatusVariables = Exact<{ [key: string]: never }>;

export type userFreeTrialStatus = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    id: string;
    userHouseholds: Array<{
      __typename?: 'UserHousehold';
      household: {
        __typename?: 'Household';
        pets: Array<{
          __typename?: 'Pet';
          device?: {
            __typename?: 'Device';
            hasActiveSubscription: boolean;
            subscription?: { __typename?: 'BillingSubscription'; hasFreeTrialPlan?: boolean | null } | null;
          } | null;
        }>;
      };
    }>;
  };
};

export type userPetsVariables = Exact<{ [key: string]: never }>;

export type userPets = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    id: string;
    userHouseholds: Array<{
      __typename?: 'UserHousehold';
      household: {
        __typename?: 'Household';
        pets: Array<{
          __typename?: 'Pet';
          id: string;
          name: string;
          weight: number;
          photos: {
            __typename?: 'PhotoFeed';
            first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
          };
          device?: {
            __typename?: 'Device';
            moduleId: string;
            subscription?: { __typename?: 'BillingSubscription'; id: string; unitAmountInCents: number } | null;
          } | null;
        }>;
      };
    }>;
  };
};

export type ultraEligiblePetsVariables = Exact<{ [key: string]: never }>;

export type ultraEligiblePets = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    id: string;
    userHouseholds: Array<{
      __typename?: 'UserHousehold';
      householdRole: UserHouseholdRole;
      household: {
        __typename?: 'Household';
        pets: Array<{
          __typename?: 'Pet';
          id: string;
          name: string;
          photos: {
            __typename?: 'PhotoFeed';
            first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
          };
          device?: {
            __typename?: 'Device';
            moduleId: string;
            currentCollarModel?: string | null;
            subscriptionAccessType: SubscriptionAccessType;
          } | null;
        }>;
      };
    }>;
  };
};

export type userPetsIdVariables = Exact<{ [key: string]: never }>;

export type userPetsId = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    userHouseholds: Array<{
      __typename?: 'UserHousehold';
      household: { __typename?: 'Household'; pets: Array<{ __typename?: 'Pet'; id: string }> };
    }>;
  };
};

export type userPetsWeightVariables = Exact<{ [key: string]: never }>;

export type userPetsWeight = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    id: string;
    userHouseholds: Array<{
      __typename?: 'UserHousehold';
      household: { __typename?: 'Household'; pets: Array<{ __typename?: 'Pet'; weight: number }> };
    }>;
  };
};

export type userThirdPartiesVariables = Exact<{ [key: string]: never }>;

export type userThirdParties = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    id: string;
    email: string;
    thirdPartyData: Array<{
      __typename?: 'ThirdPartyData';
      thirdPartyId: ThirdPartyId;
      data: { __typename?: 'AirvetDataItem'; nextBillDate?: any | null; subscriptionId?: string | null };
    } | null>;
  };
};

export type ECOMMERCE_rescueTransferPetPermanentlyVariables = Exact<{
  input: RescueTransferPetPermanentlyInput;
}>;

export type ECOMMERCE_rescueTransferPetPermanently = {
  __typename?: 'Mutation';
  rescueTransferPetPermanently?: {
    __typename?: 'RescueTransferPetPermanentlyResult';
    accountCreated: boolean;
    newAccountTemporaryPassword?: string | null;
    billingAccount?: {
      __typename?: 'BillingAccount';
      billingInfo?: {
        __typename?: 'BillingInfo';
        firstName: string;
        lastName: string;
        address: {
          __typename?: 'Address';
          line1: string;
          line2?: string | null;
          city: string;
          state: string;
          zip: string;
          country: string;
        };
        paymentInfo:
          | { __typename: 'BankAccountInfo' }
          | { __typename: 'ObfuscatedCardInfo'; lastFour: number; type: string; month: number; year: number }
          | { __typename: 'PayPalInfo' }
          | { __typename: 'WalletPaymentInfo' };
      } | null;
    } | null;
  } | null;
};

export type ECOMMERCE_rescueTransferPetTemporarilyVariables = Exact<{
  input: RescueTransferPetTemporarilyInput;
}>;

export type ECOMMERCE_rescueTransferPetTemporarily = {
  __typename?: 'Mutation';
  rescueTransferPetTemporarily?: {
    __typename?: 'RescueTransferPetTemporarilyResult';
    accountCreated: boolean;
    newAccountTemporaryPassword?: string | null;
  } | null;
};

export type ECOMMERCE_rescuePlacementMainVariables = Exact<{ [key: string]: never }>;

export type ECOMMERCE_rescuePlacementMain = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    id: string;
    transferablePets: Array<{
      __typename?: 'Pet';
      id: string;
      name: string;
      photos: {
        __typename?: 'PhotoFeed';
        first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
      };
      household: {
        __typename?: 'Household';
        id: string;
        users: Array<{
          __typename?: 'HouseholdUser';
          id: string;
          firstName: string;
          lastName?: string | null;
          email: string;
        }>;
      };
      device?: { __typename?: 'Device'; id: string; moduleId: string; currentCollarModel?: string | null } | null;
    }>;
    recallableTransferredPets: Array<{
      __typename?: 'Pet';
      id: string;
      name: string;
      photos: {
        __typename?: 'PhotoFeed';
        first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
      };
      household: {
        __typename?: 'Household';
        id: string;
        users: Array<{
          __typename?: 'HouseholdUser';
          id: string;
          firstName: string;
          lastName?: string | null;
          email: string;
        }>;
      };
      device?: { __typename?: 'Device'; id: string; moduleId: string; currentCollarModel?: string | null } | null;
    }>;
    userHouseholds: Array<{
      __typename?: 'UserHousehold';
      firstCreated: boolean;
      household: {
        __typename?: 'Household';
        id: string;
        pets: Array<{
          __typename?: 'Pet';
          id: string;
          name: string;
          photos: {
            __typename?: 'PhotoFeed';
            first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
          };
          household: {
            __typename?: 'Household';
            id: string;
            users: Array<{
              __typename?: 'HouseholdUser';
              id: string;
              firstName: string;
              lastName?: string | null;
              email: string;
            }>;
          };
          device?: { __typename?: 'Device'; id: string; moduleId: string; currentCollarModel?: string | null } | null;
        }>;
        bases: Array<{ __typename?: 'ChargingBase'; id: string; baseId: string; name: string }>;
      };
    }>;
  };
};

export type baseDetails = { __typename?: 'ChargingBase'; id: string; baseId: string; name: string };

export type petDetails = {
  __typename?: 'Pet';
  id: string;
  name: string;
  photos: {
    __typename?: 'PhotoFeed';
    first?: { __typename?: 'Photo'; image: { __typename?: 'Image'; fullSize?: string | null } } | null;
  };
  household: {
    __typename?: 'Household';
    id: string;
    users: Array<{
      __typename?: 'HouseholdUser';
      id: string;
      firstName: string;
      lastName?: string | null;
      email: string;
    }>;
  };
  device?: { __typename?: 'Device'; id: string; moduleId: string; currentCollarModel?: string | null } | null;
};
